webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyles = exports.css = undefined;

var _ThemedStyleSheet = __webpack_require__(497);

var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);

var _aphroditeInterfaceGlobal = __webpack_require__(1108);

var _aphroditeInterfaceGlobal2 = _interopRequireDefault(_aphroditeInterfaceGlobal);

var _reactWithStyles = __webpack_require__(496);

var _utils = __webpack_require__(12);

var _pos = __webpack_require__(1111);

var _pos2 = _interopRequireDefault(_pos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const { partnership, convention } = getPartnershipAndConventionFromUrl(location)

/* if (partnership && partnership.toLowerCase().startsWith('pos')) {
  ThemedStyleSheet.registerTheme(PosTheme)
} else if (partnership === 'HYPE' && convention === 'YOOX') {
  ThemedStyleSheet.registerTheme(YooxTheme)
} else if (partnership === 'HYPE4TIM') {
  ThemedStyleSheet.registerTheme(TimTheme)
} else {
  ThemedStyleSheet.registerTheme(HypeTheme)
}
 */
_ThemedStyleSheet2.default.registerTheme(_pos2.default);

/* import HypeTheme from './themes/hype'
import YooxTheme from './themes/yoox'
import TimTheme from './themes/tim' */


_ThemedStyleSheet2.default.registerInterface(_aphroditeInterfaceGlobal2.default);

exports.css = _reactWithStyles.css;
exports.withStyles = _reactWithStyles.withStyles;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToFirstInvalidComponent = exports.getLinkFoglioInformativo = exports.getHelpdeskMail = exports.getPartnershipAndConventionFromUrl = exports.getPartnershipAndConventionFromRawValue = exports.getFlowRawValue = exports.cleanupString = exports.removeDiacritics = exports.getValidationsResult = exports.arraysEqual = exports.resizeImage = exports.ios11Instructions = exports.isBrowserTooOld = exports.getBrowser = exports.padNum = exports.cfBelongsToAdult = exports.cfBelongsToEligibleUser = exports.isNoRadioSelected = exports.b64toBlob = exports.compressWidgets = exports.initWidgets = exports.extendModel = exports.camelize = exports.arrayObjectIndexOf = exports.filterObject = exports.isEntityInvalid = exports.getUnderageQueryString = exports.getFloodLightActivity = exports.getFloodLightGroup = exports.getActorSlug = exports.getProductCode = exports.getStepSlug = exports.isValidStep = exports.pushRoute = exports.MAX_IMAGE_UPLOAD_SIZE = exports.CONTEXT_ROOT = exports.getEnv = exports.fileTypes = exports.posProducts = undefined;

var _promise = __webpack_require__(511);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(261);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = __webpack_require__(111);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(263);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

var _stateExtension = __webpack_require__(95);

var Model = _interopRequireWildcard(_stateExtension);

var _widgetsActions = __webpack_require__(136);

var _componentsActions = __webpack_require__(19);

var _lodash = __webpack_require__(96);

var _reactRouter = __webpack_require__(133);

var _qs = __webpack_require__(124);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import { addTitolareUser } from './state/actions/stepActions'

/**
 * Utility functions that help with common tasks. Functions like extending widgets,
 * or filtering an object properties
 *
 * @module  Utils
 */
var posProducts = exports.posProducts = {
  prodPersonaFisica: 'POS_PERSONA_FISICA_EASYNOLO',
  prodDittaInd: 'POS_DITTA_IND_EASYNOLO',
  prodAzienda: 'POS_AZIENDA_EASYNOLO'
};
var fileTypes = exports.fileTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/pjpeg', 'image/x-png', 'application/pdf']; //'image/bmp'
var getContextRoot = function getContextRoot() {
  var HAS_CONTEXT_ROOT = "production" === 'production';
  var contextRoot = '';

  if (HAS_CONTEXT_ROOT) {
    contextRoot = window.location.href.replace(window.location.origin + '/', '');
    contextRoot = '/' + contextRoot.substr(0, contextRoot.indexOf('/'));
  }

  return contextRoot;
};

var getEnv = exports.getEnv = function getEnv() {
  var onbApiRoot = "https://www.sella.it/onboarding".replace('/onboarding', '') || location.origin;

  var env = onbApiRoot.replace(/www\.(\w\w)-hype\.it/, '$1').replace(/trust\.telecomitalia\.it/, 'pp').replace(/hype\.localdomain/, 'pp').replace('te', 'tst').replace('pp', 'pre').replace(/www\.hype\.it/, 'pro').replace(/https?:\/\//, '');

  return env;
};

var CONTEXT_ROOT = exports.CONTEXT_ROOT = getContextRoot();
var MAX_IMAGE_UPLOAD_SIZE = exports.MAX_IMAGE_UPLOAD_SIZE = 1024;

var pushRoute = exports.pushRoute = function pushRoute(route, mergeWithOldQs) {
  var ignoreKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var routeChunks = route.split('?');

  var routePath = routeChunks[0];

  var newParams = _qs2.default.parse(routeChunks[1] || '');

  var oldParams = mergeWithOldQs ? _qs2.default.parse(window.location.search, { ignoreQueryPrefix: true }) : {};

  var filteredOldParams = ignoreKeys.reduce(function (res, ik) {
    return (0, _extends4.default)({}, res, (0, _defineProperty3.default)({}, ik, undefined));
  }, oldParams);

  var queryObj = (0, _extends4.default)({}, filteredOldParams, newParams);

  (0, _keys2.default)(queryObj).forEach(function (k) {
    if (queryObj[k] === '0') {
      delete queryObj[k];
    }
  });

  var queryString = !!queryObj ? '?' + _qs2.default.stringify(queryObj) : '';

  _reactRouter.browserHistory.push('' + CONTEXT_ROOT + routePath + queryString);
};

var POS_EASYNOLO = {
  POS_PERSONA_FISICA_EASYNOLO: {
    s1: 'contact-info',
    s2: 'address-info',
    s3: 'legal-info',
    s4: 'pos',
    s5: 'identification',
    s6: 'contract',
    s7: 'thanks'
  },
  POS_DITTA_IND_EASYNOLO: {
    s1: 'contact-info',
    s2: 'address-info',
    s3: 'company-info',
    s4: 'legal-info',
    s5: 'pos',
    s6: 'identification',
    s7: 'contract',
    s8: 'thanks'
  },
  POS_AZIENDA_EASYNOLO: {
    s1: 'contact-info',
    s2: 'address-info',
    s3: 'company-info',
    s4: 'legal-info',
    s5: 'identification',
    s6: 'pos',
    s7: 'contract',
    s8: 'thanks'
  }
};

var isValidStep = exports.isValidStep = function isValidStep(step, product) {
  var productCode = product.prodCode;
  return POS_EASYNOLO[productCode] && step < (0, _keys2.default)(POS_EASYNOLO[productCode]).length;
};

var getStepSlug = exports.getStepSlug = function getStepSlug(step, product, state) {
  var sCode = '';
  var isDirectThankPage = step.number === 1 && step.name === 'thanks';
  var productCode = isDirectThankPage ? state && state.routing.partnership : product.prodCode;
  if (productCode && POS_EASYNOLO[productCode]) {
    if (isDirectThankPage) {
      var stepValues = (0, _values2.default)(POS_EASYNOLO[productCode]);
      sCode = stepValues[stepValues.length - 1];
    } else {
      sCode = POS_EASYNOLO[productCode]['s' + step.number];
    }
  }
  return sCode;
};

var getProductCode = exports.getProductCode = function getProductCode(step, product, state) {
  var pCode = product.prodCode;
  var isDirectThankPage = step.number === 1 && step.name === 'thanks';
  pCode = isDirectThankPage ? state && state.routing.partnership : pCode && POS_EASYNOLO[pCode] && pCode || '';
  return pCode;
};

var getActorSlug = exports.getActorSlug = function getActorSlug(step) {
  if (!!step.isUnderage) return '-underage';

  if (!!step.isParent) return '-parent';

  return '';
};

var getFloodLightGroup = exports.getFloodLightGroup = function getFloodLightGroup(step) {
  var map = {
    s1: 'sella0',
    s2: 'banca0',
    s3: 'banca00',
    s4: 'step40',
    s5: 'step40',
    s6: 'typ_m0',
    s1u: 'sella0',
    s2u: 'step20',
    s3u: 'step30',
    s4u: 'step400',
    s5u: 'step50',
    s6u: 'typ_m00'
  };

  return map['s' + step.number + (step.isUnderage ? 'u' : '')] || '';
};

var getFloodLightActivity = exports.getFloodLightActivity = function getFloodLightActivity(step) {
  var map = {
    s1: 'banca0',
    s2: 'banca0',
    s3: 'banca0',
    s4: 'banca0',
    s5: 'banca00',
    s6: 'banca0',
    s1u: 'banca0',
    s2u: 'banca0',
    s3u: 'banca0',
    s4u: 'banca0',
    s5u: 'banca0',
    s6u: 'banca0'
  };

  return map['s' + step.number + (step.isUnderage ? 'u' : '')] || '';
};

var getUnderageQueryString = exports.getUnderageQueryString = function getUnderageQueryString(step) {
  return '?u=' + (!!step.isUnderage ? '1' : '0') + '&p=' + (!!step.isParent ? '1' : '0');
};

/**
 * Checks if an entity is valid for the client
 * @param  {string} key         The entity key
 * @param  {Object} entities    The entities to check
 * @param  {Boolean} validate   Determines if the predicate should be used for error rendering
 * @return {string}             The component id
 */
var isEntityInvalid = exports.isEntityInvalid = function isEntityInvalid(key, entities) {
  var res = entities[key].status.indexOf('hidden') < 0 && entities[key].status.indexOf('error') > -1;

  if (!entities[key].components && !!entities.validations && !!entities.validations.rules && entities.validations.rules.length > 0) {
    res = res && entities[key].type !== 'hidden' && !entities[key].isDisabled;
    if (entities[key].type === 'radio') {
      res = res && !(0, _keys2.default)(entities).find(function (k) {
        return k.indexOf(key.split('-')[0] + '-') > -1 && entities[k].type === 'radio' && entities[k].status.indexOf('error') < 0;
      });
    }
  }

  return res;
};

/**
 * Filters an object's properties
 * @public
 *
 * @param  {Object} obj           The source object
 * @param  {Function} predicate   The filter criteria
 * @return {Object}               The filtered object
 */
var filterObject = exports.filterObject = function filterObject(obj, predicate) {
  var result = {};
  var key = void 0;

  for (key in obj) {
    if (obj.hasOwnProperty(key) && predicate(obj[key])) {
      result[key] = obj[key];
    }
  }

  return result;
};

/**
 * Gets the index of an object in an array
 * @param  {Array} myArray    The array to scan
 * @param  {string} searchTerm The search term
 * @param  {string} property   The property
 * @return {Number}            The resultant index
 */
var arrayObjectIndexOf = exports.arrayObjectIndexOf = function arrayObjectIndexOf(myArray, searchTerm, property) {
  for (var i = 0, len = myArray.length; i < len; i++) {
    if (myArray[i][property] === searchTerm) return i;
  }
  return -1;
};

/**
 * Camelizes a string
 * @public
 *
 * @param  {string} str           The string you need to camelize
 * @param  {Boolean} onlyFirst    If we should set only the first character to uppercase
 * @param  {Boolean} avoidJoin    If we should join the string
 * @return {string}               The camelized string
 */
var camelize = exports.camelize = function camelize(str, onlyFirst, avoidJoin) {
  if (typeof str !== 'string') return;
  var pattern = /[\s_](.)/g;
  if (onlyFirst) {
    pattern = /(.)/;
  }

  var ret = str.toLowerCase().replace(pattern, function ($1) {
    return $1.toUpperCase();
  });

  if (!avoidJoin) {
    ret = ret.replace(/\s/g, '');
  }

  return ret;
};

/**
 * Returns the missing components for the passed widget seeking them into the stateExtension
 * @private
 *
 * @param {Object} widgets          The source widgets
 * @param {string} wk               The current widget key
 * @return {Array}                  The extended widget's components keys
 */
var getMissingWidgetComponentKeys = function getMissingWidgetComponentKeys(widgets, wk) {
  return (0, _keys2.default)(Model.COMPONENTS).filter(function (ck) {
    return !!widgets.NOME_COGNOME //@hack to avoid that legacy JOLLY_INPUT on step 1 gets populated with JOLLY_RADIO value
    ? ck.indexOf(widgets[wk].name + '-') > -1 && (!!Model.COMPONENTS[ck].extra && !ck.startsWith('JOLLY-') || ck.startsWith('JOLLY-') && !Model.COMPONENTS[ck].extra) : ck.indexOf(widgets[wk].name + '-') > -1 && !!Model.COMPONENTS[ck].extra;
  });
};

/**
 * Integrates widget's missing metadata
 * @public
 * @todo   We can probably make it more concise
 *
 * @param  {Object} model                 The model to extend and persist
 * @param  {Object} oldModel              The old model
 * @param  {Object} config                The config for the extend model
 * @return {Object}                       The extended model
 */
var extendModel = exports.extendModel = function extendModel(model, oldModel, config) {
  if (!model) return;
  var WIDGETS = 'WIDGETS';
  var COMPONENTS = 'COMPONENTS';
  var modelType = model[(0, _keys2.default)(model)[0]].code ? WIDGETS : COMPONENTS;
  var extendedModel = model;
  var tito = ['CODICE_FISCALE-DATADINASCITA', 'CODICE_FISCALE-SESSO', 'CODICE_FISCALE-PROVINCIADINASCITA', 'CODICE_FISCALE-LUOGODINASCITA'];

  var TYPES = {
    cf: 'codiceFiscale',
    nome: 'nome',
    cognome: 'cognome',
    datadinascita: 'dataDiNascita',
    sesso: 'sesso',
    luogodinascita: 'luogoDiNascita',
    provinciadinascita: 'provinciaDiNascita'

    // @hack for the signaler
    /*if (modelType === WIDGETS && !!extendedModel.NOME_COGNOME) {
      if (!extendedModel.WHAT_YOU_NEED) {
        extendedModel.WHAT_YOU_NEED = {
          ...Model[modelType].WHAT_YOU_NEED
        }
      }
      if (!extendedModel.SIGNALER) {
        extendedModel.SIGNALER = { ...Model[modelType].SIGNALER }
      }
    }*/

    // @hack for the extra email verification
  };if (modelType === WIDGETS && !!extendedModel.TIPOLOGIA_CARTA) {
    if (!extendedModel.VERIFICA_EMAIL_EXTRA) {
      extendedModel.VERIFICA_EMAIL_EXTRA = (0, _extends4.default)({}, Model[modelType].VERIFICA_EMAIL_EXTRA);
    }
  }

  var genericIndex = modelType === COMPONENTS ? [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)((0, _keys2.default)(extendedModel)), (0, _toConsumableArray3.default)(!!(0, _keys2.default)(extendedModel).find(function (k //@hack to avoid that legacy JOLLY_INPUT on step 1 gets populated with JOLLY_RADIO value
  ) {
    return k.startsWith('NOME_COGNOME-');
  }) ? (0, _keys2.default)(Model[modelType]).filter(function (k) {
    return !k.startsWith('JOLLY-') || k.startsWith('JOLLY-') && !Model[modelType][k].extra;
  }) : (0, _keys2.default)(Model[modelType])))))) : (0, _keys2.default)(extendedModel);
  var widgetsIndex = modelType === COMPONENTS ? [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)((0, _keys2.default)(extendedModel).map(function (s) {
    return s.split('-')[0];
  })), (0, _toConsumableArray3.default)((0, _keys2.default)(extendedModel).indexOf('TIPOLOGIA_CARTA-CARTA_VIRTUALE') > -1 ? ['VERIFICA_EMAIL_EXTRA'] : []))))) : genericIndex;
  genericIndex.forEach(function (k) {
    if (!!extendedModel[k]) {
      if (!!oldModel && oldModel[k] && (modelType === WIDGETS || oldModel[k].id && oldModel[k].id.indexOf('FLOW_BAR') < 0)) {
        extendedModel[k].status = [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(extendedModel[k].status), (0, _toConsumableArray3.default)(oldModel[k].status)))));
        extendedModel[k].errorMessage = [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(extendedModel[k].errorMessage), (0, _toConsumableArray3.default)(oldModel[k].errorMessage)))));
      }

      if (modelType === WIDGETS) {
        extendedModel[k].components = [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(extendedModel[k].components), (0, _toConsumableArray3.default)(getMissingWidgetComponentKeys(extendedModel, k))))));
      }

      if (modelType === COMPONENTS && widgetsIndex.some(function (s) {
        return s.indexOf(k.split('-')[0]) > -1;
      })) {
        extendedModel[k] = (0, _extends4.default)({}, extendedModel[k], Model[modelType][k], {
          status: [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(extendedModel[k].status), [!extendedModel[k].active && 'hidden'])))).filter(function (e) {
            return !!e;
          })
        });
      }
    } else {
      if (modelType === COMPONENTS && widgetsIndex.some(function (s) {
        return s.indexOf(k.split('-')[0]) > -1;
      }) && !!Model[modelType][k].extra) {
        extendedModel[k] = (0, _extends4.default)({}, extendedModel[k], Model[modelType][k]);
      }
    }

    if (modelType === COMPONENTS && !!extendedModel[k] && (!extendedModel[k].validations || extendedModel[k].validations.constructor.toString().indexOf('Array') > -1)) {
      extendedModel[k].validations = {};
    }
  });

  // @hack for parent's radiobutton
  if (modelType === COMPONENTS && !!extendedModel['JOLLY-JOLLY_INPUT'] && !!extendedModel['JOLLY-JOLLY_RADIO_' + extendedModel['JOLLY-JOLLY_INPUT'].value]) {
    extendedModel['JOLLY-JOLLY_RADIO_' + extendedModel['JOLLY-JOLLY_INPUT'].value].status = ['selected'];
  }

  // @hack for residency permit
  if (modelType === COMPONENTS && !!extendedModel['DOCUMENTO_2-PERMESSO_SOGGIORNO'] && !!extendedModel['DOCUMENTO_2-PERMESSO_SOGGIORNO'].active) {
    extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options = !!extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options ? extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options : {};

    extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options.url = 'wgt/utils/tipologiaPermessoDiSoggiorno';

    extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options.mapping = {
      label: 'label',
      value: 'value',
      enteEmissione: 'enteEmissione'

      // if (config.name === 'Identificati') {
    };extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].position = 1;
    extendedModel['DOCUMENTO_2-ENTE_RILASCIO'].position = 2;
    // }
  }

  if (modelType === WIDGETS && !!config.isWebCamEnabled && !!extendedModel['MOD_IDENTIFICAZIONE']) {
    extendedModel['MOD_IDENTIFICAZIONE'].status = [];
  }
  if (modelType === COMPONENTS && !!config.isWebCamEnabled && !!extendedModel['MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO']) {
    extendedModel['MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO'].status = [];
    extendedModel['MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO'].type = 'radio';
  }

  if (modelType === COMPONENTS && !!extendedModel['DOCUMENTO_2-DATA_SCADENZA'] && !!oldModel && !!oldModel['DOCUMENTO_2-DATA_SCADENZA']) {
    extendedModel['DOCUMENTO_2-DATA_SCADENZA'].validations.isRequired = oldModel['DOCUMENTO_2-DATA_SCADENZA'].validations.isRequired;
    extendedModel['DOCUMENTO_2-DATA_SCADENZA'].isDisabled = oldModel['DOCUMENTO_2-DATA_SCADENZA'].isDisabled;
  }

  if (modelType === COMPONENTS) {
    var SETTORE_ATTIVITA_AZIENDA = ['SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA', 'SETTORE_ATTIVITA_AZIENDA-SETTORE', 'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA', 'PROFESSIONE_ATTIVITA-PROFESSIONE', 'PROFESSIONE_ATTIVITA-SETTORE', 'PROFESSIONE_ATTIVITA-ATTIVITA'];
    SETTORE_ATTIVITA_AZIENDA.map(function (k) {
      if (!!extendedModel[k] && !!oldModel && !!oldModel[k]) {
        // if (!extendedModel[k].value && oldModel[k].value) {
        //   extendedModel[k].value = oldModel[k].value
        // }
        // if (oldModel[k].value) {
        //   extendedModel[k].value = oldModel[k].value
        // }
        extendedModel[k].value = oldModel[k].value;
        extendedModel[k].values = oldModel[k].values;
      }
    });

    var SETTORE = extendedModel['SETTORE_ATTIVITA_AZIENDA-SETTORE'];
    if (SETTORE && SETTORE.value) {
      var DETTAGLIO_ATTIVITA_ECONOMICA = extendedModel['SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA'];
      if (DETTAGLIO_ATTIVITA_ECONOMICA && DETTAGLIO_ATTIVITA_ECONOMICA.options) {
        DETTAGLIO_ATTIVITA_ECONOMICA.options.init = true;
      }
    }

    // const cell_component = extendedModel['CELLULARE-NUM_CELLULARE']
    // if (!!cell_component && config.product !== posProducts.prodPersonaFisica) {
    //   const validations = {}
    //   validations.isRequired = cell_component.validations.isRequired
    //   validations.default = cell_component.validations.default
    //   extendedModel['CELLULARE-NUM_CELLULARE'].validations = validations
    // }

    var tipoRoles = extendedModel['AZIENDA_ROLES-TIPO_ROLES_LINK_AZIENDA'];
    if (!!tipoRoles && tipoRoles.rawValue && tipoRoles.rawValue.length) {
      var rawValue = tipoRoles.rawValue.filter(function (v) {
        return v.value !== -1;
      });
      tipoRoles.values = rawValue.map(function (v) {
        return {
          value: v.value,
          label: v.description
        };
      });
    }
  }

  /*  if (modelType === COMPONENTS && !!extendedModel['TITOLARE_ESERCITA-ADD']) {
    extendedModel['TITOLARE_ESERCITA-ADD'].action = addTitolareUser
  }
  */
  /** TODO: Have to fix this based on widget.radioGroup impl */
  // The following statement selects the first radio by default if none from it's widget is set
  /*if (modelType === COMPONENTS) {
    const radios = filterObject(extendedModel, obj => obj.type === 'radio')
    if (Object.keys(radios).length > 0) {
      const groupedRadios = Object.keys(radios)
        .filter(k => radios[k].status.indexOf('hidden') < 0)
        .reduce((obj, k) => {
          const groupKey = k.substr(0, k.indexOf('-'))
          if (!obj[groupKey]) {
            obj[groupKey] = {}
          }
          obj[groupKey][k] = radios[k]
          return obj
        }, {})
        Object.keys(groupedRadios).forEach(k => {
        if (
          Object.keys(groupedRadios[k]).every(
            k2 =>
              !groupedRadios[k][k2].value &&
              groupedRadios[k][k2].status.indexOf('selected') < 0
          )
        ) {
          const firstRadioId = Object.keys(groupedRadios[k]).reduce(
            (prev, curr) =>
              groupedRadios[k][curr].position < groupedRadios[k][prev].position
                ? groupedRadios[k][curr].id
                : groupedRadios[k][prev].id
          )
          extendedModel[firstRadioId].value = 'selected'
        } else {
          Object.keys(groupedRadios[k]).forEach(k2 => {
            if (
              !groupedRadios[k][k2].value &&
              groupedRadios[k][k2].status.indexOf('selected') > -1
            ) {
              groupedRadios[k][k2].value = 'selected'
            }
          })
        }
      })
    }
  }*/
  if (config && config.name && !config.name.startsWith('I titolari')) {
    if (modelType === WIDGETS) {
      var cf = extendedModel.CODICE_FISCALE;
      if (!!cf && cf.components) {
        cf.components = cf.components.filter(function (k) {
          return tito.every(function (n) {
            return n !== k;
          });
        });
      }
    }
    if (modelType === COMPONENTS) {
      if (!!extendedModel) {
        var extendedModel_ = {};
        (0, _keys2.default)(extendedModel).forEach(function (k) {
          if (tito.every(function (n) {
            return n !== k;
          })) {
            extendedModel_[k] = extendedModel[k];
          }
        });
        extendedModel = extendedModel_;
      }
    }
  }

  if (modelType === COMPONENTS && config && config.dispatch) {
    var entitiesWidgets = config.widgets;
    var dispatch = config.dispatch;
    (0, _keys2.default)(extendedModel).map(function (k) {
      var o = extendedModel[k];
      var options = o.toggleVisibility;
      if ((o.linkId || o.widgetName) && options && o.hasOwnProperty('toggleVisibility')) {
        var visibility_ = true;
        var isExist = !o.widgetName && (0, _componentsActions.isLinkExist)(o.linkId, extendedModel);
        if (isExist) {
          visibility_ = true;
        } else if ((o.type === 'selectbox' || o.type === 'text') && o.value !== null) {
          if (o.linkValues) {
            visibility_ = o.linkValues.some(function (v) {
              return v === o.value;
            });
          } else {
            visibility_ = o.linkValue && o.linkValue === o.value;
          }
        } else if (o.type === 'radio' || o.type === 'checkbox') {
          visibility_ = o.value === 'selected';
        }
        if (options) {
          (0, _keys2.default)(options).forEach(function (visibility) {
            var isVisible = null;
            var fields = options[visibility] && options[visibility].fields;
            if (fields && fields.length > 0) {
              fields.forEach(function (field) {
                var isComponent = field.indexOf('-') > -1;
                var extendedModel_ = isComponent ? extendedModel[field] : entitiesWidgets[field];
                if (extendedModel_.status) {
                  if (field === 'SZ0025') {
                    isVisible = 'true';
                  } else {
                    if (isComponent || config && config.step && !config.name.startsWith('Personalizza')) {
                      isVisible = visibility === 'show' ? visibility_ : !visibility_;
                      //isVisible = visibility === 'show' && visibility_
                    } else {
                      var widget = entitiesWidgets[field];
                      if (widget) {
                        if (visibility === 'show') {
                          if (visibility_) {
                            isVisible = widget.active || fields.some(function (f) {
                              return f.startsWith(field + '-');
                            });
                          } else {
                            isVisible = widget.active && (0, _componentsActions.isWidgetsActive)(widget, fields);
                          }
                        } else {
                          if (visibility_) {
                            isVisible = widget.active && (0, _componentsActions.isWidgetsActive)(widget, fields);
                          } else {
                            isVisible = widget.active || fields.some(function (f) {
                              return f.startsWith(field + '-');
                            });
                          }
                        }
                      }
                    }
                  }
                  var updateBody = {};
                  if (isVisible) {
                    updateBody.status = extendedModel_.status.filter(function (e) {
                      return e !== 'hidden';
                    });
                    updateBody.active = true;
                  } else if (!isVisible) {
                    updateBody.status = (0, _lodash.union)(extendedModel_.status, ['hidden']);
                    updateBody.active = false;

                    if (extendedModel_.type === 'radio' || extendedModel_.type === 'checkbox') {
                      updateBody.value = extendedModel_.status.indexOf('selected') > -1 ? 'selected' : '';
                    }
                  }
                  if (isComponent) {
                    extendedModel[field] = (0, _extends4.default)({}, extendedModel_, updateBody);
                  } else {
                    dispatch((0, _widgetsActions.updateWidget)(field, updateBody, { collateral: true }));
                  }
                }
              });
            }
          });
        }
      }
    });
  }

  // if (config && !!config.name.startsWith('I titolari')) {
  //   let dpdKey = null
  //   if (!!extendedModel['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA']) {
  //     //cehckinf for the componets which contains all the values and extracting the same
  //     const titoComp =
  //       extendedModel['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA']
  //     if (
  //       titoComp &&
  //       titoComp.rawValue &&
  //       titoComp.rawValue.titolare_effettivo[0]
  //     ) {
  //       const titoValue = titoComp.rawValue.titolare_effettivo[0]

  //       //Iterating the Components and Assigning the value
  //       Object.keys(extendedModel).forEach(k => {
  //         const comp = extendedModel[k]
  //         if (comp.id.startsWith('RESIDENZA-')) {
  //           dpdKey =
  //             comp.name === 'residenzaFiscale'
  //               ? 'residenzaFiscale'
  //               : comp.name.toLowerCase()
  //           comp.value = titoValue.residenza[dpdKey]
  //         }
  //         if (
  //           comp.id.startsWith('DOCUMENTO-') &&
  //           comp.name !== 'DOCR_UPLOAD' &&
  //           comp.name !== 'DOCF_UPLOAD'
  //         ) {
  //           comp.value = titoValue.documento[comp.name.toLowerCase()]
  //         }

  //         if (
  //           comp.id.startsWith('NOME_COGNOME-') ||
  //           comp.id.startsWith('CODICE_FISCALE-')
  //         ) {
  //           const dpdKey =
  //             comp.name === 'meseAnno' ? 'meseAnno' : comp.name.toLowerCase()
  //           const rezKey = TYPES[dpdKey]
  //           comp.value = titoValue.datiContatto[rezKey]
  //         }
  //         if (
  //           comp.refDataTeJsObj &&
  //           comp.refDataTeJsObj === 'indirectPepDetail'
  //         ) {
  //           dpdKey =
  //             comp.refDataTeJs === 'tipolegame'
  //               ? 'tipoLegame'
  //               : comp.refDataTeJs
  //           comp.value = titoValue.indirectPepDetail[dpdKey]
  //         }
  //         if (
  //           comp.refDataTeJsObj &&
  //           comp.refDataTeJsObj === 'directPepDetail'
  //         ) {
  //           dpdKey = comp.refDataTeJs
  //           comp.value = titoValue.directPepDetail[dpdKey]
  //         }
  //       })

  //       extendedModel['TITOLARE_DATA-EFFETTIVO_SI'].value =
  //         titoValue.legale_repre === 'SI' ? 'selected' : ''
  //       extendedModel['TITOLARE_DATA-EFFETTIVO_NO'].value =
  //         titoValue.legale_repre === 'SI' ? '' : 'selected'

  //       extendedModel['SZ0025-SS0052_DM0097_RI0022'].value =
  //         titoValue.directPep === 'SI' ? 'selected' : ''
  //       extendedModel['SZ0025-SS0052_DM0097_RI0023'].value =
  //         titoValue.directPep === 'SI' ? '' : 'selected'

  //       extendedModel['SZ0025-SS0163_DM0503_RI0568'].value =
  //         titoValue.indirectPep === 'SI' ? 'selected' : ''
  //       extendedModel['SZ0025-SS0163_DM0503_RI0569'].value =
  //         titoValue.indirectPep === 'SI' ? '' : 'selected'

  //       if (titoValue.directPepDetail.inCorso) {
  //         extendedModel['SZ0025-SS0162_DM0501_RI0565'].value =
  //           titoValue.directPepDetail.inCorso === 'SI' ? 'selected' : ''
  //         extendedModel['SZ0025-SS0162_DM0501_RI0566'].value =
  //           titoValue.directPepDetail.inCorso === 'SI' ? '' : 'selected'
  //       }
  //       if (titoValue.indirectPepDetail.inCorso) {
  //         extendedModel['SZ0025-SS0163_DM0507_RI0573'].value =
  //           titoValue.indirectPepDetail.inCorso === 'SI' ? 'selected' : ''
  //         extendedModel['SZ0025-SS0163_DM0507_RI0574'].value =
  //           titoValue.indirectPepDetail.inCorso === 'SI' ? '' : 'selected'
  //       }
  //     }
  //   }
  // }

  return extendedModel;
};

/**
 * Integrates same step widget's missing metadata
 * avoiding data loss for previously asyncronously loaded select options or
 * checkboxes selection
 * @public
 *
 * @param  {Array} oldWidgets          The old widgets array
 * @param  {Array} freshWidgets        The new widgets array
 * @param  {Number} oldStepNumber      The old step number
 * @param  {Number} freshStepNumber    The new step number
 * @return {Array}                     The extended widget array
 */
var initWidgets = exports.initWidgets = function initWidgets(oldWidgets, freshWidgets, oldStepNumber, freshStepNumber) {
  if (oldStepNumber === freshStepNumber) {
    var _loop = function _loop(w) {
      var _loop2 = function _loop2(c) {
        if (c.type === 'selectbox') {
          c.values = oldWidgets.find(function (ow) {
            return ow.name === w.name;
          }).components.find(function (oc) {
            return oc.name === c.name;
          }).values;
        } else if (c.type === 'checkbox') {
          c.value = oldWidgets.find(function (ow) {
            return ow.name === w.name;
          }).components.find(function (oc) {
            return oc.name === c.name;
          }).value;
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(w.components), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var c = _step2.value;

          _loop2(c);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(freshWidgets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var w = _step.value;

        _loop(w);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return freshWidgets;
};

/**
 * Removes widget's additional metadata
 * @public
 *
 * @param  {Array} widgets      The widgets array
 * @param  {Array} components   The components array
 * @return {Array}              The compressed widget array without the flowbar
 */
var compressWidgets = exports.compressWidgets = function compressWidgets(widgets, components) {
  return (0, _lodash.toArray)(filterObject(widgets, function (w) {
    return Number(w.code) > 0 && !w.extra && w.name !== 'PROMO';
  })).map(function (w) {
    return {
      code: w.code,
      name: w.name.replace('_' + w.code, ''),
      components: w.components.filter(function (k) {
        return !!components[k] && !components[k].extra;
      }).map(function (c) {
        return { //solving undefined error  - by Fahim
          name: components[c].name,
          value: components[c].value
        };
      })
    };
  });
};

/**
 * Converts a base64 string into a blob
 *
 * @param  {string} b64Data     The base64 string
 * @param  {string} contentType The file content type
 * @param  {Number} sliceSize   The slice size
 * @return {Byte[]}             The converted bytes array
 */
var b64toBlob = exports.b64toBlob = function b64toBlob(b64Data) {
  var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

/**
 * Checks if none of the radios relative to the passed componentId is selected
 *
 * @param  {Object}  components  The components
 * @param  {string}  componentId The component id
 * @param  {Object}  widget      The widget
 * @return {Boolean}             The result
 */
var isNoRadioSelected = exports.isNoRadioSelected = function isNoRadioSelected(components, componentId, widget) {
  var component = components[componentId];
  var radioGroup = null;
  if (widget && widget.radioGroup) {
    var parentId = widget.radioGroup[component.id_];
    radioGroup = (0, _keys2.default)(widget.radioGroup).filter(function (k) {
      return widget.radioGroup[k] === parentId;
    });
  }
  var keys = (0, _keys2.default)(components).filter(function (k) {
    return components[k].type === 'radio';
  });
  if (widget && radioGroup) {
    keys = keys.filter(function (k) {
      return radioGroup.some(function (id_) {
        return id_ === components[k].id_;
      });
    });
  } else {
    keys = keys.filter(function (k) {
      return k.indexOf(componentId.split('-')[0]) > -1;
    });
  }
  var noneSelected = true;

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)(keys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var k = _step3.value;

      noneSelected = noneSelected && components[k].value === '';
      if (!noneSelected) {
        return noneSelected;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return noneSelected;
};

/**
 * Checks if the provided cf belongs to an eligible user
 *
 * @param  {string} cf         The CF
 * @param  {Number} userAge    The user's age
 * @return {Boolean}           The result
 */
var cfBelongsToEligibleUser = exports.cfBelongsToEligibleUser = function cfBelongsToEligibleUser(cf, userAge) {
  userAge = userAge || 18;
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();

  var birthYear = Number(cf.replace(/\w\w\w\w\w\w(\d\d)\w\d\d\w\d\d\d\w/, '$1'));

  var century = parseInt(currentYear / 100) * 100;

  if (birthYear > currentYear.toString().substr(2, 4)) {
    century = century - 100;
  }

  birthYear = century + birthYear;

  var age = currentYear - birthYear;

  var isEligible = false;

  if (age >= userAge) {
    if (age === userAge) {
      // checks month and day
      var monthsMap = {
        A: '01',
        B: '02',
        C: '03',
        D: '04',
        E: '05',
        H: '06',
        L: '07',
        M: '08',
        P: '09',
        R: '10',
        S: '11',
        T: '12'
      };

      var month = monthsMap[cf.replace(/\w\w\w\w\w\w\d\d(\w)\d\d\w\d\d\d\w/, '$1')];

      var day = Number(cf.replace(/\w\w\w\w\w\w\d\d\w(\d\d)\w\d\d\d\w/, '$1'));

      day = day > 40 ? day - 40 : day;

      var birthDate = new Date(birthYear + '-' + month + '-' + day);

      var checkTimestamp = birthDate.setFullYear(birthDate.getUTCFullYear() + userAge);

      isEligible = checkTimestamp < currentDate.getTime();
    } else {
      isEligible = true;
    }
  }

  return isEligible;
};

/**
 * Checks if the provided cf belongs to an adult
 *
 * @param  {string} cf    The CF
 * @return {Boolean}      The result
 */
var cfBelongsToAdult = exports.cfBelongsToAdult = function cfBelongsToAdult(cf) {
  return cfBelongsToEligibleUser(cf);
};

var padNum = exports.padNum = function padNum(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

var getBrowser = exports.getBrowser = function getBrowser() {
  var str = function () {
    var ua = navigator.userAgent;
    var tem = void 0;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'MSIE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== null) {
        return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
      M.splice(1, 1, tem[1]);
    }
    return M.join(' ');
  }();
  return {
    name: str.match(/\w+/)[0],
    version: str.match(/\d+/)[0]
  };
};

var isBrowserTooOld = exports.isBrowserTooOld = function isBrowserTooOld() {
  var browser = getBrowser();
  try {
    switch (browser.name.toLowerCase()) {
      case 'chrome':
        return Number(browser.version) < 41;
      case 'firefox':
        return Number(browser.version) < 38;
      case 'msie':
        return Number(browser.version) < 9;
      case 'edge':
        return Number(browser.version) < 25;
      case 'safari':
        return Number(browser.version) < 7;
      case 'opera':
        return Number(browser.version) < 15;
      default:
        return true;
    }
  } catch (ex) {
    return true;
  }
};
var ios11Instructions = exports.ios11Instructions = function ios11Instructions() {
  var browser = getBrowser();
  var instructions = '';
  if (browser.name.toLowerCase() === 'safari') {
    instructions = '<div style="font-weight:bold;text-align: left;margin-left: 30px;margin-top: 15px;">Gentile Cliente, la preghiamo di riprovare dopo aver disabilitato l’opzione "Blocca tracciamento cross-site" nel modo seguente <div style="margin-left: 20px;"><p>1 Entrare in Impostazioni</p><p>2 Cliccare sull’icona Safari</p><p>3 Entrare nel tab Privacy e Sicurezza</p><p>4 Disabilitare l’opzione "Blocca tracciamento cross-site"</p></div></div>';
  }
  return instructions;
};
var resizeImage = exports.resizeImage = function resizeImage(dataUri, maxSize) {
  if (!dataUri) throw 'error: resizeImage requires dataUri argument';
  if (!maxSize) throw 'error: resizeImage requires maxSize argument';

  return new _promise2.default(function (resolve, reject) {
    var canvas = document.createElement('canvas');

    var image = new Image();
    image.src = dataUri;

    image.onload = function () {
      var maxWidth = maxSize; // Max width for the image
      var maxHeight = maxSize; // Max height for the image
      var ratio = 0; // Used for aspect ratio
      var width = image.width; // Current image width
      var height = image.height; // Current image height

      canvas.width = width;
      canvas.height = height;

      // Check if the current width is larger than the max
      if (width > maxWidth) {
        ratio = maxWidth / width; // get ratio for scaling image
        canvas.width = maxWidth; // Set new width
        canvas.height = height * ratio; // Scale height based on ratio
        height = height * ratio; // Reset height to match scaled image
        width = width * ratio; // Reset width to match scaled image
      }

      // Check if current height is larger than max
      if (height > maxHeight) {
        ratio = maxHeight / height; // get ratio for scaling image
        canvas.height = maxHeight; // Set new height
        canvas.width = width * ratio; // Scale width based on ratio
        width = width * ratio; // Reset width to match scaled image
        height = height * ratio; // Reset height to match scaled image
      }

      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);

      resolve(canvas.toDataURL('image/jpeg'));
    };
    image.onerror = function (e) {
      reject(e);
    };
  });
};

var arraysEqual = exports.arraysEqual = function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  for (var i = arr1.length; i--;) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};

var getValidationsResult = exports.getValidationsResult = function getValidationsResult(_ref) {
  var component = _ref.component,
      passTrough = _ref.passTrough,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'default' : _ref$type;

  var initialResult = { result: true, failedRule: null, errorMessage: null };

  if (!!component.validations && !!component.validations[type]) {
    var rules = passTrough ? [] : component.validations[type];
    var finalResult = rules.reduce(function (res, rule) {
      res.result = res.result && rule.validate && rule.validate(component);
      if (!res.result && !res.failedRule) {
        res.failedRule = rule;
      }
      return res;
    }, { result: true, failedRule: null });

    if (!finalResult.result) {
      if (!finalResult.failedRule.getErrorMessage) {
        finalResult.errorMessage = component.cleanName.toLowerCase() + ' non \xE8 valido';
      } else {
        finalResult.errorMessage = finalResult.failedRule.getErrorMessage(component);
      }
    }

    return finalResult;
  } else {
    return initialResult;
  }
};

/**
 * Removes diacritics from the provided string
 * @param  {string} str input string
 * @return {string}     output string
 */
var removeDiacritics = exports.removeDiacritics = function removeDiacritics(str) {
  var defaultDiacriticsRemovalMap = [{
    base: 'A',
    letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
  }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, {
    base: 'B',
    letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
  }, {
    base: 'C',
    letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
  }, {
    base: 'D',
    letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
  }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, {
    base: 'E',
    letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
  }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, {
    base: 'G',
    letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
  }, {
    base: 'H',
    letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
  }, {
    base: 'I',
    letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
  }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, {
    base: 'K',
    letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
  }, {
    base: 'L',
    letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
  }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, {
    base: 'M',
    letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
  }, {
    base: 'N',
    letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
  }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, {
    base: 'O',
    letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
  }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, {
    base: 'P',
    letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
  }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, {
    base: 'R',
    letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
  }, {
    base: 'S',
    letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
  }, {
    base: 'T',
    letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
  }, { base: 'TZ', letters: /[\uA728]/g }, {
    base: 'U',
    letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
  }, {
    base: 'V',
    letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
  }, { base: 'VY', letters: /[\uA760]/g }, {
    base: 'W',
    letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
  }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, {
    base: 'Y',
    letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
  }, {
    base: 'Z',
    letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
  }, {
    base: 'a',
    letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
  }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, {
    base: 'b',
    letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
  }, {
    base: 'c',
    letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
  }, {
    base: 'd',
    letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
  }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, {
    base: 'e',
    letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
  }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, {
    base: 'g',
    letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
  }, {
    base: 'h',
    letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
  }, { base: 'hv', letters: /[\u0195]/g }, {
    base: 'i',
    letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
  }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, {
    base: 'k',
    letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
  }, {
    base: 'l',
    letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
  }, { base: 'lj', letters: /[\u01C9]/g }, {
    base: 'm',
    letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
  }, {
    base: 'n',
    letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
  }, { base: 'nj', letters: /[\u01CC]/g }, {
    base: 'o',
    letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
  }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, {
    base: 'p',
    letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
  }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, {
    base: 'r',
    letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
  }, {
    base: 's',
    letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
  }, {
    base: 't',
    letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
  }, { base: 'tz', letters: /[\uA729]/g }, {
    base: 'u',
    letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
  }, {
    base: 'v',
    letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
  }, { base: 'vy', letters: /[\uA761]/g }, {
    base: 'w',
    letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
  }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, {
    base: 'y',
    letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
  }, {
    base: 'z',
    letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
  }];

  str = str.replace(/([À-ž]$|([À-ž](?=\s)))/g, "$1'");

  for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
  }

  return str;
};

/**
 * Removes extra whitespaces and diacritics from the provided string
 * @param  {string} str input string
 * @return {string}     output string
 */
var cleanupString = exports.cleanupString = function cleanupString(str) {
  var res = str && str.replace('€ ', '').trim().replace(/\s\s+/g, ' ').replace(/\s*\-\s*/, '-');
  if (/\s$/.test(res) || /^\s/.test(res) || /[À-ž]/.test(res)) {
    return removeDiacritics(res);
  }
  return res;
};

var getFlowRawValue = exports.getFlowRawValue = function getFlowRawValue(partnership, convention) {
  return '' + partnership.toLowerCase() + (!!convention && convention !== 'ND' ? '-' + convention : '').toLowerCase();
};

var getPartnershipAndConventionFromRawValue = exports.getPartnershipAndConventionFromRawValue = function getPartnershipAndConventionFromRawValue(rawValue) {
  rawValue = rawValue.toUpperCase();

  var regex = /([^\/\-]+)\-?([^\/]*).*/i;

  var defaultPartnership = 'POS_AZIENDA_EASYNOLO';
  var defaultConvention = 'ND';

  var partnership = defaultPartnership;
  var convention = defaultConvention;

  if (!!rawValue) {
    partnership = rawValue.replace(regex, '$1');
    convention = rawValue.replace(regex, '$2') || defaultConvention;

    /*if (
      rawValue === 'POS_PERSONA_FISICA_EASYNOLO' ||
      rawValue === 'POS_DITTA_IND_EASYNOLO' ||
      rawValue === 'POS_AZIENDA_EASYNOLO'
    ) {
      partnership = defaultPartnership
    }*/

    /*if (rawValue === 'HYPEYOOX') {
      convention = 'YOOX'
    }
      if (rawValue === 'ADECCO') {
      convention = 'ADECCO'
    }*/
  }

  return { partnership: partnership, convention: convention };
};

var getPartnershipAndConventionFromUrl = exports.getPartnershipAndConventionFromUrl = function getPartnershipAndConventionFromUrl(payload) {
  var regex = new RegExp(CONTEXT_ROOT.replace('/', '\\/') + '\\/[^\\/]+\\/([^\\/]+).*', 'i');

  var defaultPartnership = 'POS_AZIENDA_EASYNOLO';
  var defaultConvention = 'ND';

  var partnership = defaultPartnership;
  var convention = defaultConvention;

  if (regex.test(payload.pathname)) {
    return getPartnershipAndConventionFromRawValue(payload.pathname.replace(regex, '$1'));
  }

  return { partnership: partnership, convention: convention };
};

var getHelpdeskMail = exports.getHelpdeskMail = function getHelpdeskMail(_ref2) {
  var partnership = _ref2.partnership,
      convention = _ref2.convention;

  if (partnership === 'HYPE4TIM') return 'timpersonal@hype.it';

  if (partnership === 'HYPE' && convention === 'YOOX') return 'yooxcard@hype.it';

  return 'hello@hype.it';
};

var getLinkFoglioInformativo = exports.getLinkFoglioInformativo = function getLinkFoglioInformativo(_ref3) {
  var partnership = _ref3.partnership,
      convention = _ref3.convention;

  if (partnership === 'HYPE4TIM') return 'https://www.hype.it/SSRDocumentDisplayer?dtdPG=B26_BSE&dtdPE=1';

  if (partnership === 'HYPE' && convention === 'YOOX') return 'https://www.hype.it/SSRDocumentDisplayer?dtdPG=FI_HYPE_YOOX&dtdPE=1';

  return 'https://www.hype.it/SSRDocumentDisplayer?dtdPG=FI_HYPE_START&dtdPE=1';
};

var compareDomNodePosition = function compareDomNodePosition(a, b) {
  if (a === b) return 0;
  if (!a.compareDocumentPosition) {
    // support for IE8 and below
    return a.sourceIndex - b.sourceIndex;
  }
  if (a.compareDocumentPosition(b) & 2) {
    // b comes before a
    return 1;
  }
  return -1;
};

var getDomNodeDistances = function getDomNodeDistances(element) {
  var xPosition = 0;
  var yPosition = 0;

  while (element) {
    xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
    yPosition += element.offsetTop - element.scrollTop + element.clientTop;
    element = element.offsetParent;
  }

  return { x: xPosition, y: yPosition };
};

var scrollToFirstInvalidComponent = exports.scrollToFirstInvalidComponent = function scrollToFirstInvalidComponent(components) {
  // if (!!document.activeElement && document.activeElement.id === 'bt-next') {
  var invalidComponentKeys = (0, _keys2.default)(components).filter(function (k) {
    return isEntityInvalid(k, components);
  }).sort(function (a, b) {
    return (components[a].position || 0) - (components[b].position || 0);
  });

  var nodes = (invalidComponentKeys || []).map(function (k) {
    return document.querySelectorAll('[name="' + k + '"]')[0];
  });

  if (nodes.length === 0) {
    nodes = (invalidComponentKeys || []).map(function (k) {
      return document.querySelectorAll('[name^="' + k + '"]')[0];
    });
  }

  if (nodes.length > 0) {
    nodes = nodes.sort(compareDomNodePosition);

    window.scrollTo(0, getDomNodeDistances(nodes[0]).y - 50);
  }
  //}
};

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tweakAgreement = exports.sendSmsOtp = exports.sendEmailOtp = exports.uploadFile = exports.updateFilePreview = exports.updateComponent = exports.autoFillDependantComponents = exports.getSelectOptions = exports.notifyComponents = exports.triggerGroupConditions = exports.triggerDependantComponents = exports.invokeMethod = exports.fetchData = exports.activateSign = exports.updateComponentCustom = exports.isLinkExist = exports.parseQuestionarioWidgets = exports.sendOTP = exports.sendRequest = exports.parsePersonalizzaWidgets = exports.hidesectionsforsoftpos = exports.hidesectionslist = exports.validateComponent = exports.updateAllComponents = exports.toggleVisibility = exports.isWidgetsActive = exports.AUTOFILL_COMPONENT_DISCARDED = exports.AUTOFILL_COMPONENT_FAILED = exports.AUTOFILL_COMPONENT_DONE = exports.AUTOFILL_COMPONENT_START = exports.SERVER_VALIDATE_COMPONENT_FAILED = exports.SERVER_VALIDATE_COMPONENT_SUCCESS = exports.SIDE_VALIDATE_COMPONENT_FAILED = exports.SIDE_VALIDATE_COMPONENT_SUCCESS = exports.VALIDATE_COMPONENT_FAILED = exports.VALIDATE_COMPONENT_SUCCESS = exports.SIDE_UPDATE_COMPONENT = exports.QUESTIONARIO_COMPONENT = exports.UPDATE_COMPONENT = exports.UPDATE_ALL_COMPONENTS = undefined;

var _assign = __webpack_require__(227);

var _assign2 = _interopRequireDefault(_assign);

var _map = __webpack_require__(1085);

var _map2 = _interopRequireDefault(_map);

var _values = __webpack_require__(263);

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = __webpack_require__(261);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(264);

var _stringify2 = _interopRequireDefault(_stringify);

var _set = __webpack_require__(111);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _api = __webpack_require__(45);

var _utils = __webpack_require__(12);

var _widgetsActions = __webpack_require__(136);

var _addressStatic = __webpack_require__(525);

var _promoCodeStatic = __webpack_require__(526);

var _stepActions = __webpack_require__(28);

var _lodash = __webpack_require__(96);

var _uuid = __webpack_require__(170);

var _uuid2 = _interopRequireDefault(_uuid);

var _stateExtension = __webpack_require__(95);

var Model = _interopRequireWildcard(_stateExtension);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import qs from 'qs'

/**
 * Actions you can make on components
 * @module  {Actions} componentActions
 */
var UPDATE_ALL_COMPONENTS = exports.UPDATE_ALL_COMPONENTS = '@@components/UPDATE_ALL';
var UPDATE_COMPONENT = exports.UPDATE_COMPONENT = '@@components/UPDATE';
var QUESTIONARIO_COMPONENT = exports.QUESTIONARIO_COMPONENT = '@@components/QUESTIONARIO';
var SIDE_UPDATE_COMPONENT = exports.SIDE_UPDATE_COMPONENT = '@@components/SIDE_UPDATE';
var VALIDATE_COMPONENT_SUCCESS = exports.VALIDATE_COMPONENT_SUCCESS = '@@components/VALIDATION_SUCCESS';
var VALIDATE_COMPONENT_FAILED = exports.VALIDATE_COMPONENT_FAILED = '@@components/VALIDATION_FAILED';
var SIDE_VALIDATE_COMPONENT_SUCCESS = exports.SIDE_VALIDATE_COMPONENT_SUCCESS = '@@components/SIDE_VALIDATION_SUCCESS';
var SIDE_VALIDATE_COMPONENT_FAILED = exports.SIDE_VALIDATE_COMPONENT_FAILED = '@@components/SIDE_VALIDATION_FAILED';
var SERVER_VALIDATE_COMPONENT_SUCCESS = exports.SERVER_VALIDATE_COMPONENT_SUCCESS = '@@components/SERVER_VALIDATION_SUCCESS';
var SERVER_VALIDATE_COMPONENT_FAILED = exports.SERVER_VALIDATE_COMPONENT_FAILED = '@@components/SERVER_VALIDATION_FAILED';
var AUTOFILL_COMPONENT_START = exports.AUTOFILL_COMPONENT_START = '@@components/AUTOFILL_START';
var AUTOFILL_COMPONENT_DONE = exports.AUTOFILL_COMPONENT_DONE = '@@components/AUTOFILL_DONE';
var AUTOFILL_COMPONENT_FAILED = exports.AUTOFILL_COMPONENT_FAILED = '@@components/AUTOFILL_FAILED';
var AUTOFILL_COMPONENT_DISCARDED = exports.AUTOFILL_COMPONENT_DISCARDED = '@@components/AUTOFILL_DISCARDED';

/**
 * Given the object toggleVisibility options and an array of widgets
 * or components return the update body required to update the component/widget visibility.
 * @private
 *
 * @param  {bool} isVisible     If the related component or widget must be visible or not
 * @param  {Array} array        The whole array of widgets or components
 * @param  {string} field       The related component or widget id
 * @return {Object}             The update body
 */
var getVisibilityUpdatedBody = function getVisibilityUpdatedBody(isVisible, array, field) {
  var updateBody = {};
  if (isVisible) {
    updateBody.status = array[field].status.filter(function (e) {
      return e !== 'hidden';
    });
    updateBody.active = true;
  } else if (!isVisible) {
    updateBody.status = (0, _lodash.union)(array[field].status, ['hidden']);
    updateBody.active = false;

    if (array[field].type === 'radio') {
      updateBody.value = array[field].status.indexOf('selected') > -1 ? 'selected' : '';
    }
    // if(array[field].status.indexOf(''))
  } /*else {
    if (array[field].status.indexOf('hidden') >= 0) {
      updateBody.status = array[field].status.filter(e => e !== 'hidden')
      updateBody.active = true
    } else {
      updateBody.status = union(array[field].status, ['hidden'])
      updateBody.active = false
        if (array[field].type === 'radio') {
        updateBody.value =
          array[field].status.indexOf('selected') > -1 ? 'selected' : ''
      }
    }
    }*/
  return updateBody;
};

var isWidgetsActive = exports.isWidgetsActive = function isWidgetsActive(widget, fields) {
  return widget.components.some(function (n) {
    //const cName = `${widget.name}-${c.name}`
    var c = Model.COMPONENTS[n];
    return fields.every(function (f) {
      return f !== n;
    }) && c && c.active;
  });
};

/**
 * Notify components that they need to validate again
 *
 * @param  {type} options     Validation options
 * @param  {type} components  The full state components
 * @return {Function}         Calls the validateComponent function
 */
var toggleVisibility = exports.toggleVisibility = function toggleVisibility(options, component) {
  return function (dispatch, getState) {
    var _getState = getState(),
        components = _getState.components,
        widgets = _getState.widgets,
        step = _getState.step,
        product = _getState.product;

    var visibility_ = true;
    if (component.linkId || component.widgetName) {
      var isExist = !component.widgetName && isLinkExist(component.linkId, components);
      if (isExist) {
        visibility_ = true;
      } else if (component.type === 'selectbox' || component.type === 'text') {
        if (component.linkValues) {
          visibility_ = component.linkValues.some(function (v) {
            return v === component.value;
          });
        } else {
          visibility_ = component.linkValue && component.linkValue === component.value;
        }
      } else if (component.type === 'radio' || component.type === 'checkbox') {
        visibility_ = component.value === 'selected';
      }
    }
    (0, _keys2.default)(options).forEach(function (visibility) {
      var isVisible = false;
      var fields = options[visibility] && options[visibility].fields;
      if (fields && fields.length > 0) {
        fields.forEach(function (field) {
          var isComponent = field.indexOf('-') > -1;
          if (field === 'SZ0025') {
            isVisible = 'true';
          } else {
            if (isComponent || step.number && !step.name.startsWith('Personalizza')) {
              isVisible = visibility === 'show' ? visibility_ : !visibility_;
              //isVisible = visibility === 'show' && visibility_
            } else {
              var widget = widgets[field];
              if (widget) {
                if (visibility === 'show') {
                  if (visibility_) {
                    isVisible = widget.active || fields.some(function (f) {
                      return f.startsWith(field + '-');
                    });
                  } else {
                    isVisible = widget.active && isWidgetsActive(widgets[field], fields);
                  }
                } else {
                  if (visibility_) {
                    isVisible = widget.active && isWidgetsActive(widgets[field], fields);
                  } else {
                    isVisible = widget.active || fields.some(function (f) {
                      return f.startsWith(field + '-');
                    });
                  }
                }
              }
            }
          }
          if (!!components[field]) {
            var updateBody = getVisibilityUpdatedBody(isVisible, components, field);
            dispatch(updateComponent(field, updateBody, {
              collateral: true,
              avoidAutofill: true
            }));
          } else if (!!widgets[field]) {
            var _updateBody = getVisibilityUpdatedBody(isVisible, widgets, field);
            dispatch((0, _widgetsActions.updateWidget)(field, _updateBody, { collateral: true }));

            //Rewamp of whole digital contracts in last step (All flows)	
            if (field === 'DOCUMENTO_2' || field === 'SELFIE') {
              (0, _keys2.default)(components).filter(function (c) {
                return components[c].id.startsWith(field + '-') && c !== 'DOCUMENTO_2-PERMESSO_SOGGIORNO' && c !== 'DOCUMENTO_2-SECONDDOCUMENTRULE1' && c !== 'DOCUMENTO_2-SECONDDOCUMENTRULE2' && c !== 'DOCUMENTO_2-SECONDDOCUMENTRULE3' && c !== 'DOCUMENTO_2-TIPO_DOCUMENTO';
              }).forEach(function (k) {
                isVisible ? dispatch(updateComponent(k, { status: [] }, { collateral: true, avoidAutofill: true })) : dispatch(updateComponent(k, { status: ['hidden'] }, { collateral: true, avoidAutofill: true }));
              });
            }
          }
        });
      }
    });
  };
};

/**
 * Updates all the components
 *
 * @param {Object} components      The updated components
 * @return {Function}              Dispatches an UPDATE_ALL_COMPONENTS action
 */
var updateAllComponents = exports.updateAllComponents = function updateAllComponents(components) {
  return {
    type: UPDATE_ALL_COMPONENTS,
    components: components
  };
};

/**
 * Validates a component by calling an API endpoint
 *
 * @param  {Object} component     The component to validate
 * @param  {string} components    The component new value
 * @return {Promise}              Dispatches an UPDATE_WIDGETS action
 */
var serverValidateComponent = function serverValidateComponent(component) {
  return function (dispatch, getState) {
    if (!component.validations.hasOwnProperty('url') || component.value === '') return;

    var _getState2 = getState(),
        components = _getState2.components;

    var token = new _stepActions.ActionToken(component.id + '.serverValidateComponent', true);

    var body = {};
    var needValidation = false;
    if (component.validations.fields.length) {
      component.validations.fields.forEach(function (input) {
        if (!!components[input]) {
          if (!!component.validations.mapping && !!component.validations.mapping[input]) {
            body[component.validations.mapping[input]] = components[input].value;
          } else {
            body[components[input].name.toLowerCase()] = components[input].value;
            if (components[input].value !== components[input].validValue) needValidation = true;
            if (components[input].id === 'PROMO-PromoCode') needValidation = true;
          }
        }
      });
    } else {
      var fields = component.validations.fields;
      (0, _keys2.default)(fields).forEach(function (key) {
        if (fields[key].fieldName && components[key]) {
          body[fields[key].fieldName] = components[key].value;
          if (components[key].value !== components[key].validValue) needValidation = true;
          if (components[key].id === 'PROMO-PromoCode') needValidation = true;
        }
      });
    }

    // if (
    //   !component.validations.results ||
    //   !component.validations.results[qs.stringify(body)]
    // ) {
    if (needValidation) {
      dispatch((0, _stepActions.dealActionToken)(token));
      (0, _api.getServerValidation)(component, body).then(function (delta) {
        if (delta.status.indexOf('success') > -1) {
          if (component.id === 'CELLULARE-NUM_CELLULARE') {
            dispatch(updateComponent('CELLULARE-CODICE_CELLULARE', {
              isDisabled: false
            }, { avoidValidation: true }));
          }
          if (component.validations.fields.length) {
            component.validations.fields.forEach(function (input) {
              if (!!components[input]) {
                if (!!component.validations.mapping && !!component.validations.mapping[input]) {
                  // components[input].validValue = components[input].value
                } else {
                  components[input].validValue = components[input].value;
                }
              }
            });
          } else {
            var _fields = component.validations.fields;
            (0, _keys2.default)(_fields).forEach(function (key) {
              if (_fields[key].fieldName && components[key]) {
                components[key].validValue = components[key].value;
              }
            });
          }
        }
        if (component.id === 'CELLULARE-CODICE_CELLULARE' && delta.status.indexOf('error') > -1) {
          var updateBody = { otpbtnDisabled: false };
          dispatch(updateComponent('CELLULARE-NUM_CELLULARE', {
            otpbtnDisabled: false
          }, { avoidValidation: true }));
          // dispatch({type:UPDATE_COMPONENT,component:{...updateBody,id: 'CELLULARE-NUM_CELLULARE'}, avoidValidation: true })
        }
        dispatch({
          type: delta.status.indexOf('error') > -1 ? SERVER_VALIDATE_COMPONENT_FAILED : SERVER_VALIDATE_COMPONENT_SUCCESS,
          component: (0, _extends3.default)({}, delta, {
            status: [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(component.status.filter(function (s) {
              return s !== 'error';
            })), (0, _toConsumableArray3.default)(delta.status))))),
            id: component.id
            // validations: {
            //   ...component.validations,
            //   results: {
            //     ...(component.validations.results || {}),
            //     [qs.stringify(body)]: delta
            //   }
            // }
          })
        });
        dispatch((0, _stepActions.dealActionToken)((0, _extends3.default)({}, token, { dispose: true })));
      });
    }
    // } else {
    //   const delta = component.validations.results[qs.stringify(body)]
    //   dispatch({
    //     type:
    //       delta.status.indexOf('error') > -1
    //         ? SERVER_VALIDATE_COMPONENT_FAILED
    //         : SERVER_VALIDATE_COMPONENT_SUCCESS,
    //     component: {
    //       ...delta,
    //       id: component.id
    //     }
    //   })
    // }
  };
};

/**
 * Validates a component pattern
 *
 * @param {Object} componentId      The component to validate
 * @param {Object} options          The component to validate
 * @param {Boolean} options.passTrough      Allows to bypass the validation
 * @param {Boolean} options.evalBlanks      Force validation for blank inputs
 * @param {Boolean} options.collateral      Collateral validation flag
 * @return {Object}                 The validated component
 */
var validateComponent = exports.validateComponent = function validateComponent(componentId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      passTrough = _ref.passTrough,
      evalBlanks = _ref.evalBlanks,
      collateral = _ref.collateral,
      execLazy = _ref.execLazy;

  return function (dispatch, getState) {
    var _getState3 = getState(),
        widgets = _getState3.widgets,
        components = _getState3.components,
        step = _getState3.step;

    if (step.name.startsWith('Personalizza') && componentId && componentId.startsWith('CODICE_FISCALE')) {
      return;
    }
    if (componentId === "undefined") {
      return;
    }
    var component = components[componentId];
    if (componentId === 'PROFESSIONE_ATTIVITA-ATTIVITA' || componentId === 'PROFESSIONE_ATTIVITA-SETTORE') {
      if (!!component.values && component.values.length === 0) {
        evalBlanks = false;
      }
    }
    passTrough = !!passTrough;
    passTrough = passTrough || component.validations && (!component.validations.isRequired || !component.validations.hasOwnProperty('default'));
    passTrough = passTrough || component.type === 'hidden' || component.status.indexOf('hidden') > -1;

    if (component.type === 'radio' && component.status.indexOf('hidden') < 0) {
      var widget = widgets['' + componentId.split('-')[0]];
      if (widget && widget.status.indexOf('hidden') < 0) {
        passTrough = (passTrough || !!evalBlanks) && !(0, _utils.isNoRadioSelected)(components, componentId, widget);
      } else {
        passTrough = true;
      }
    } else {
      var firstCheckBox = 'SZ0024-SS0049_DM0094_RI0504';
      var secondCheckBox = 'SZ0024-SS0049_DM0094_RI0505';

      /* Titolare Effecttivo checkboxes validations*/
      var Titolare_Effettivo_CheckBoxes = ['SZ0024-SS0049_DM0094_RI0500', 'SZ0024-SS0049_DM0094_RI0501', 'SZ0024-SS0049_DM0534_RI0502', 'SZ0024-SS0049_DM0534_RI0503', 'SZ0024-SS0049_DM0525_RI0576', 'SZ0024-SS0049_DM0525_RI0577'];
      var checkboxGroup1 = ['SZ0024-SS0049_DM0094_RI0500', 'SZ0024-SS0049_DM0094_RI0501'];
      var checkboxGroup2 = ['SZ0024-SS0049_DM0534_RI0502', 'SZ0024-SS0049_DM0534_RI0503'];
      var checkboxGroup3 = ['SZ0024-SS0049_DM0525_RI0576', 'SZ0024-SS0049_DM0525_RI0577'];

      //Fix for Informazioni-compagine questionnaire checkbox validation
      var checkbox1_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI0121';
      var checkbox2_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1058';
      var checkbox3_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1059';
      var checkbox4_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1060';
      var checkbox5_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1061';
      var checkbox6_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI1056';
      var checkbox7_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI0126';
      var checkbox8_SS0048_DM0089 = 'SZ0023-SS0048_DM0089_RI0381';

      var Informazioni_compagine_checkboxes = ['SZ0023-SS0048_DM0089_RI0121', 'SZ0023-SS0048_DM0089_RI1058', 'SZ0023-SS0048_DM0089_RI1059', 'SZ0023-SS0048_DM0089_RI1060', 'SZ0023-SS0048_DM0089_RI1061', 'SZ0023-SS0048_DM0089_RI1056', 'SZ0023-SS0048_DM0089_RI0126', 'SZ0023-SS0048_DM0089_RI0381'];
      var Ulteriori_info_CheckBoxes = ['SZ0022-SS0208_DM0849_RI0947', 'SZ0022-SS0208_DM0849_RI0948', 'SZ0022-SS0208_DM0849_RI0949'];
      var Altre_informazioni_Checkboxes = ['SZ0011-SS0230_DM0886_RI0989', 'SZ0011-SS0230_DM0886_RI0990', 'SZ0011-SS0230_DM0886_RI0991'];
      // const Patrimonio_CheckBoxes=[
      //   'SZ0010-SS0221_DM0864_RI0059',
      //   'SZ0010-SS0221_DM0864_RI0060', 
      //   'SZ0010-SS0221_DM0864_RI0061', 
      //   'SZ0010-SS0221_DM0864_RI0062', 
      //   'SZ0010-SS0221_DM0864_RI0063',
      //   'SZ0010-SS0221_DM0864_RI0064', 
      //   'SZ0010-SS0221_DM0864_RI0065']
      var checkbox1_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0059';
      var checkbox2_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0060';
      var checkbox3_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0061';
      var checkbox4_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0062';
      var checkbox5_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0063';
      var checkbox6_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0064';
      var checkbox7_SZ0010_SS0221 = 'SZ0010-SS0221_DM0864_RI0065';
      var checkbox1_SZ0011_SS0230 = 'SZ0011-SS0230_DM0886_RI0989';
      var checkbox2_SZ0011_SS0230 = 'SZ0011-SS0230_DM0886_RI0990';
      var checkbox3_SZ0011_SS0230 = 'SZ0011-SS0230_DM0886_RI0991';
      var checkbox1_SZ0022_SS0208 = 'SZ0022-SS0208_DM0849_RI0947';
      var checkbox2_SZ0022_SS0208 = 'SZ0022-SS0208_DM0849_RI0948';
      var checkbox3_SZ0022_SS0208 = 'SZ0022-SS0208_DM0849_RI0949';
      var dropProvincia = 'SZ0016-SS0011_DM0030_RI0103';
      var dropArea = 'SZ0016-SS0011_DM0031_RI0104';
      var dropPerProvincia = 'SZ0007-SS0007_DM0030_RI0026';
      var dropPerArea = 'SZ0007-SS0007_DM0031_RI0027';
      var drpNazioneFiduciaria = 'SZ0023-SS0027_DM0536_RI0609';
      var drpNazioneTrust = 'SZ0023-SS0027_DM0537_RI0610';
      var drpNazioneSociet = 'SZ0023-SS0027_DM0538_RI0611';
      var drpNazionecapogruppo = 'SZ0023-SS0027_DM0092_RI0102';
      var drpNazioneFondazione = 'SZ0023-SS0027_DM0535_RI0608';
      //const drpprodotto="SZ0144-SS0237_DM0959_RI0791";
      if (component.type === 'checkbox' && (component.id === firstCheckBox || component.id === secondCheckBox)) {
        var otherCheckBox = component.id === firstCheckBox ? secondCheckBox : firstCheckBox;
        passTrough = passTrough || component.value === 'selected' || components[otherCheckBox].active && components[otherCheckBox].value === 'selected';
      }
      //Fix for Informazioni-compagine questionnaire checkbox validation
      else if (component.type === 'checkbox' && (component.id === checkbox1_SS0048_DM0089 || component.id === checkbox2_SS0048_DM0089 || component.id === checkbox3_SS0048_DM0089 || component.id === checkbox4_SS0048_DM0089 || component.id === checkbox5_SS0048_DM0089 || component.id === checkbox6_SS0048_DM0089 || component.id === checkbox7_SS0048_DM0089 || component.id === checkbox8_SS0048_DM0089)) {

          //debugger;
          var isInfoCampgneChecked = false;
          Informazioni_compagine_checkboxes.forEach(function (chbox) {
            isInfoCampgneChecked = isInfoCampgneChecked || !!components[chbox] && components[chbox].active && components[chbox].value === 'selected';
          });
          passTrough = passTrough || component.value === 'selected' || isInfoCampgneChecked;
        } else if (component.type === 'checkbox' && (component.id === checkbox1_SZ0022_SS0208 || component.id === checkbox2_SZ0022_SS0208 || component.id === checkbox3_SZ0022_SS0208)) {
          var isUlterioriInfoCheckBoxes = false;
          Ulteriori_info_CheckBoxes.forEach(function (chbox) {
            isUlterioriInfoCheckBoxes = isUlterioriInfoCheckBoxes || components[chbox].active && components[chbox].value === 'selected';
          });
          passTrough = passTrough || component.value === 'selected' || isUlterioriInfoCheckBoxes;
        } else if (component.type === 'checkbox' && (component.id === checkbox1_SZ0011_SS0230 || component.id === checkbox2_SZ0011_SS0230 || component.id === checkbox3_SZ0011_SS0230)) {
          var altreInformazioniCheckboxes = false;
          Altre_informazioni_Checkboxes.forEach(function (chbox) {
            altreInformazioniCheckboxes = altreInformazioniCheckboxes || components[chbox].active && components[chbox].value === 'selected';
          });
          passTrough = passTrough || component.value === 'selected' || altreInformazioniCheckboxes;
        } else if (component.type === 'checkbox' && _stepActions.Patrimonio_CheckBoxes.indexOf(component.id) > -1) {
          var patrimonioCheckBoxes = false;
          _stepActions.Patrimonio_RadioButtons.forEach(function (radiobtn) {
            if (components[radiobtn].value === 'selected') {
              if (radiobtn === 'SZ0010-SS0212_DM0855_RI0937') {
                _stepActions.Patrimonio_CheckBoxes_RBG1.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0938') {
                _stepActions.Patrimonio_CheckBoxes_RBG2.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0939') {
                _stepActions.Patrimonio_CheckBoxes_RBG3.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0940') {
                _stepActions.Patrimonio_CheckBoxes_RBG4.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0941') {
                _stepActions.Patrimonio_CheckBoxes_RBG5.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0942') {
                _stepActions.Patrimonio_CheckBoxes_RBG6.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0943') {
                _stepActions.Patrimonio_CheckBoxes_RBG7.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0944') {
                _stepActions.Patrimonio_CheckBoxes_RBG8.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0945') {
                _stepActions.Patrimonio_CheckBoxes_RBG9.forEach(function (chbox) {
                  patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                });
              }
              // else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0946') {
              //   Patrimonio_CheckBoxes_RBG10.forEach(chbox => {
              //     patrimonioCheckBoxes = patrimonioCheckBoxes || (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
              //   })
              // }
            }
          });
          passTrough = component.value === 'selected' || patrimonioCheckBoxes;
        }
      if (component.type === 'checkbox' && Titolare_Effettivo_CheckBoxes.indexOf(component.id) > -1) {
        var isTitolareCheckBoxChecked = false;
        if (component.id === 'SZ0024-SS0049_DM0094_RI0500' || component.id === 'SZ0024-SS0049_DM0094_RI0501') {
          var isTitolareCheckBoxCheckedGR1 = false;
          checkboxGroup1.forEach(function (chbox) {
            isTitolareCheckBoxCheckedGR1 = isTitolareCheckBoxCheckedGR1 || components[chbox].active && components[chbox].value === 'selected';
          });
          isTitolareCheckBoxChecked = isTitolareCheckBoxCheckedGR1;
        } else if (component.id === 'SZ0024-SS0049_DM0534_RI0502' || component.id === 'SZ0024-SS0049_DM0534_RI0503') {
          var isTitolareCheckBoxCheckedGR2 = false;
          checkboxGroup2.forEach(function (chbox) {
            isTitolareCheckBoxCheckedGR2 = isTitolareCheckBoxCheckedGR2 || components[chbox].active && components[chbox].value === 'selected';
          });
          isTitolareCheckBoxChecked = isTitolareCheckBoxCheckedGR2;
        } else if (component.id === 'SZ0024-SS0049_DM0525_RI0576' || component.id === 'SZ0024-SS0049_DM0525_RI0577') {
          var isTitolareCheckBoxCheckedGR3 = false;
          checkboxGroup3.forEach(function (chbox) {
            isTitolareCheckBoxCheckedGR3 = isTitolareCheckBoxCheckedGR3 || components[chbox].active && components[chbox].value === 'selected';
          });
          isTitolareCheckBoxChecked = isTitolareCheckBoxCheckedGR3;
        }
        passTrough = passTrough || component.value === 'selected' || isTitolareCheckBoxChecked;
      } else if (component.type === 'selectbox' && (component.id === dropProvincia || component.id === dropArea)) {
        var otherDropBox = component.id === dropProvincia ? dropArea : dropProvincia;
        passTrough = passTrough || component.value !== 'Seleziona' && component.value !== '' || components[otherDropBox].active && components[otherDropBox].value !== 'Seleziona' && components[otherDropBox].value !== '';
      } else if (component.type === 'selectbox' && (component.id === drpNazioneFiduciaria || component.id === drpNazioneTrust || component.id === drpNazioneSociet || component.id === drpNazionecapogruppo || component.id === drpNazioneFondazione)) {
        passTrough = passTrough || component.value !== 'Seleziona' && component.value !== '';
      } else if (component.type === 'selectbox' && (component.id === dropPerProvincia || component.id === dropPerArea)) {
        var _otherDropBox = component.id === dropPerProvincia ? dropPerArea : dropPerProvincia;
        passTrough = passTrough || component.value !== 'Seleziona' && component.value !== '' || components[_otherDropBox].active && components[_otherDropBox].value !== 'Seleziona' && components[_otherDropBox].value !== '';
      } else {
        var _widget = widgets['' + componentId.split('-')[0]];
        if (!!_widget && _widget.status.indexOf('hidden') < 0) {
          if (!evalBlanks) {
            passTrough = passTrough || component.value === '';
          }
        } else {
          passTrough = true;
        }
      }
    }

    var updateBody = {};

    var validationResult = (0, _utils.getValidationsResult)({ component: component, passTrough: passTrough });

    if (passTrough || validationResult.result) {
      updateBody.status = component.status.filter(function (e) {
        return e !== 'error';
      });
      updateBody.errorMessage = [];
      dispatch({
        type: !!collateral ? SIDE_VALIDATE_COMPONENT_SUCCESS : VALIDATE_COMPONENT_SUCCESS,
        component: (0, _extends3.default)({}, updateBody, { id: component.id })
      });
      if (component.status.indexOf('hidden') < 0 && (component.validations.skipLazy && !execLazy || !component.validations.skipLazy && (!component.validations.lazy || !!execLazy))) {
        dispatch(serverValidateComponent(component));
      } else if (component.id === 'CELLULARE-CODICE_CELLULARE') {
        dispatch(serverValidateComponent(component));
      }
    } else {
      updateBody.status = (0, _lodash.union)(component.status, ['error']);
      updateBody.errorMessage = [validationResult.errorMessage];

      dispatch({
        type: !!collateral ? SIDE_VALIDATE_COMPONENT_FAILED : VALIDATE_COMPONENT_FAILED,
        component: (0, _extends3.default)({}, updateBody, { id: component.id })
      });
    }
  };
};

var getSectionCode = function getSectionCode(id) {
  return id && id.match(/([a-z])+(\d)+/gi);
};
var FIELD_TYPES = {
  COMBO: 'selectbox',
  RADIO: 'radio',
  LABEL: 'label',
  TEXTBOX: 'text',
  TEXTAREA: 'textarea',
  NUMBER: 'text',
  EMAIL: 'text',
  PHONE: 'text',
  CURRENCY: 'text',
  CHECKBOX: 'checkbox',
  UPLOAD: 'file'
};
var PERSONALIZZA_WIDGETS = ['FLOW_BAR'];

var createSpacerComponent = function createSpacerComponent(f, idx, widget) {
  return {
    iid: widget.name + '-' + f.id + '_' + idx,
    name: f.id + '_' + idx,
    type: 'spacer',
    position: idx,
    value: '',
    active: !!(f.properties && !f.properties.hide),
    status: [],
    errorMessage: [],
    extra: true
  };
};

var AddressComponentList = {
  S1S2: ['S1-CAP', 'S1-CITTA', 'S1-INDIRIZZO', 'S1-NAZIONE', 'S1-PROVINCIA'],
  S3S3: ['S3-CAP', 'S3-CITTA', 'S3-INDIRIZZO', 'S3-NAZIONE', 'S3-PROVINCIA'],
  S13S1: ['S13-CAP', 'S13-CITTA', 'S13-INDIRIZZO', 'S13-NAZIONE', 'S13-PROVINCIA']
};
var updateLinkValueMap = function updateLinkValueMap(f, c) {
  var linkValues = [];
  var e = f.events;
  if (e && e.onChange && e.onChange.length && e.onChange.length === 1) {
    e.onChange.map(function (o) {
      var l = o.valueToCheck.length;
      if (l === 1) {
        c.linkValue = o.valueToCheck[0];
      } else if (l) {
        c.linkValues = o.valueToCheck;
      }
      if (l && (c.linkValue || c.linkValues)) {
        c.toggleVisibility = {};
        if (o.show.length) {
          c.toggleVisibility.show = {
            fields: o.show
          };
        }
        if (o.hide.length) {
          c.toggleVisibility.hide = {
            fields: o.hide
          };
        }
      }
    });
  }
  return linkValues;
};
var updateWidgetToggles = function updateWidgetToggles(widgets) {
  var cKeys = (0, _keys2.default)(Model.COMPONENTS);
  var widgetsKeys = (0, _keys2.default)(widgets);
  widgetsKeys.map(function (wk) {
    var w = widgets[wk];
    w.components.map(function (c) {
      var cName = w.name + '-' + c.name;
      var sc = Model.COMPONENTS[cName];
      if (sc) {
        if (c.toggleVisibility) {
          var toggleKeys = (0, _keys2.default)(c.toggleVisibility);
          toggleKeys.forEach(function (key) {
            if (c.toggleVisibility[key] && c.toggleVisibility[key].fields && c.toggleVisibility[key].fields.length) {
              sc.toggleVisibility = c.toggleVisibility;
              var fields = c.toggleVisibility[key].fields;
              var tv = [];
              fields.map(function (k) {
                //const name = `${c.widgetName}-${k}`
                cKeys.map(function (cName) {
                  /* if (cName.startsWith(name)) {
                    tv.push(cName)
                  } */
                  var cName_ = cName.split('-');
                  if (cName_[1] && cName_[1].startsWith(k)) {
                    tv.push(cName);
                  }
                  if (tv.length > 0) {
                    if (tv.indexOf(cName) !== -1 && tv.indexOf(cName_[0]) === -1) {
                      tv.push(cName_[0]);
                    }
                  }
                });
                if (k === 'S1S2' || k === 'S3S3' || k === 'S13S1') {
                  tv = tv.concat(AddressComponentList[k]);
                }
              });
              if (sc.fieldId === 'S8S2D1' && sc.description === 'Manual entry (MOTO)') {
                tv.push('S12-DOCUMENTRULES');
              }
              sc.toggleVisibility[key].fields = tv;
            }
          });
        }
        if (sc.name === 'S6S1D1') {
          c.isDisabled = true;
          sc.isDisabled = true;
        }
      }
    });
  });
  //updateWidgetToggles_(widgets, wKeys, cKeys)
};

var constructValidations = function constructValidations(c, f) {
  var prop = f.properties || {};
  var validations = {};
  if (prop.mandatory /*  && f.id === 'S4S1D1' */) {
      validations.isRequired = true;
      var validate = void 0;
      switch (c.type) {
        case 'radio':
        case 'checkbox':
          validate = Model.VALIDATION_METHODS.bool;
          break;
        default:
          validate = Model.VALIDATION_METHODS.filled;
      }
      validations.default = [{
        validate: validate,
        getErrorMessage: Model.VALIDATION_ERRORS.filled
      }];
    }
  c.validations = validations;
};

var cleanValue = function cleanValue(o) {
  return o === undefined || o === null || o === NaN ? '' : o;
};

var createComponent = function createComponent(s, f, idx, widget) {
  var prop = f.properties || {};
  var isActive = f.id === 'S1S4D7' ? true : !(s.hide || prop.hide);
  idx = f.id === 'S1S4D7' ? 60 : idx;
  var c = {
    cleanName: f.title,
    position: idx,
    active: isActive,
    status: isActive ? [] : ['hidden'],
    value: cleanValue(f.value[0]),
    name: f.id,
    fieldId: f.id,
    sectionId: s.id,
    /* sectionTitle: s.title, */
    /* validations: validations, */
    type: FIELD_TYPES[f.type],
    values: [],
    /* isDisabled: prop.disabled, */
    description: f.description || '',
    errorMessage: [],
    widgetName: widget.name
  };
  if (f.type === 'LABEL' && f.id === 'S16S1D2') {
    c.fetchPromoCode = {
      url: 'OnboardRequestDetails/FetchPromoCode',
      body: {
        GUID: f.guid
      },
      mappingEvent: 'FetchPromoCode'
    };
  }
  if (f.id === 'idPOSPlan') {
    c.fetchPosPlan = {
      url: 'OnboardRequestDetails/FetchPOSPlan',
      body: {
        GUID: f.guid
      },
      mappingEvent: 'FetchPromoCode'
    };
  }
  if (f.id === 'S9S8D1' || f.id === 'S9S8D2' || f.id === 'S2S8D1') {
    c.fullWidth = true;
  }
  constructValidations(c, f);
  return c;
};
var hidesectionslist = exports.hidesectionslist = ["S2S10", "S11S2", "S11S0"]; //,"S2S9","S2S1"]//"S1S4"(dashboardsection),
//export const sectiontitlelist=["S1S4"]
var hidesectionsforsoftpos = exports.hidesectionsforsoftpos = function hidesectionsforsoftpos(section) {
  //hiding the sections
  if (hidesectionslist.indexOf(section.id) > -1) {
    section.hide = true;
  }
  //Set the section title 
  //  if(section.id==='S1S4')
  //  {
  //   section.title="Contatti utente amministratore Dashboard"
  //  }
};
/**
 * Construct widgets from raw value data of response
 *
 * @param {Object} data             The data object to parse as widgets
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
var parsePersonalizzaWidgets = exports.parsePersonalizzaWidgets = function parsePersonalizzaWidgets(data) {
  return function (dispatch, getState) {
    if (!(data && data.sections)) return;
    var validateComponents = null;
    if (!!getState().components["PRODUCT_PLUGIN-PLUGIN_VALIDATION_ERROR"]) {
      validateComponents = getState().components["PRODUCT_PLUGIN-PLUGIN_VALIDATION_ERROR"].rawValue.ErrorMessage;
    }
    var posPlanUrl = 'OnboardRequestDetails/FetchPOSPlan';
    var posPlanBody = { GUID: getState().step.guid };
    var posPlan = "";
    (0, _api.FetchPOSPlan)(posPlanUrl, posPlanBody).then(function (posPlanJson) {
      var dbplan = posPlanJson && posPlanJson.payLoad && posPlanJson.payLoad.Plan && posPlanJson.payLoad.Plan.toUpperCase();
      var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
      posPlan = planMap[dbplan] || 'flat';

      var widgets = {};
      var sections = data.sections;
      if (sections && sections.length > 0) {
        var idx = 0;
        var addComponents = function addComponents(widget, components) {
          components.map(function (c) {
            Model.COMPONENTS[widget.name + '-' + c.name] = c;
          });
        };
        var getComponent = function getComponent(components, s, f, widget) {
          if (f.id === 'S8S2D2') {
            return;
          }
          var typeValues = f.typeValues;
          typeValues.map(function (field) {
            var c = createComponent(s, f, ++idx, widget);
            c.name = f.id + field.code;
            c._code = field.code;
            c.description = field.description;
            if (f.title && c.description === 'Do il consenso') {
              c._description = c.description;
              c.description = f.title;
            }
            c.value = f.value[0] === field.code ? 'selected' : '';
            var e = f.events;
            if (e && e.onChange && e.onChange.length && e.onChange.length === 1) {
              /**e.onChange.length === 1 is a hack to make it work for single link */
              e.onChange.map(function (o) {
                if (o.valueToCheck.length) {
                  var isLinked = o.valueToCheck.some(function (v) {
                    return v === field.code;
                  });
                  if (isLinked) {
                    c.toggleVisibility = {};
                    if (o.show.length) {
                      c.toggleVisibility.show = {
                        fields: o.show
                      };
                    }
                    if (o.hide.length) {
                      c.toggleVisibility.hide = {
                        fields: o.hide
                      };
                    }
                  }
                }
              });
            }
            components.push(c);
          });
        };
        var updateComponentProp = function updateComponentProp(components, s, f) {
          components.map(function (c) {
            if (c.widgetName === 'S11' || c.widgetName === 'S18') {
              c.value = f.value;
              c.validations = f.validations;
              c.cleanName = f.cleanName;
            }
            c.position = ++idx;
            c.active = !(s.hide || f.properties.hide);
          });
          //return c
        };
        var GeneratedStateComponents = [];
        var chkSelectedCount = 0;
        /*Promo Code */
        /*const promoCodeStaticComp = JSON.parse(
        JSON.stringify(getPromoCodeComponent())
         )       
        promoCodeStaticComp.widgets[0].components[0].fetchPromoCode= {
            url: 'https://172.17.4.63/abu_ws/OnboardRequestDetails/FetchPromoCode',
            body: {
              GUID: getState().step.guid
            },
            mappingEvent: 'FetchPromoCode'
        }
        // widget.components = [...widget.components, ...components]
        addComponents(promoCodeStaticComp.widgets[0], promoCodeStaticComp.widgets[0].components)
        widgets['PROMO'] = promoCodeStaticComp.widgets[0]
        Model.WIDGETS['PROMO'] =promoCodeStaticComp.widgets[0]
        Model.COMPONENTS = { ...Model.COMPONENTS, ...Model.WIDGETS['PROMO'].components[0]}*/
        /*PromoCOde Changes*/

        sections.map(function (s) {
          if (s.title === 'CONVENZIONE' && !!s.fields) {
            s.fields.unshift((0, _promoCodeStatic.getPromotionalComponent)());
            s.fields[0].guid = getState().step.guid;
          }
        });

        for (var i = 0; i < sections.length; i++) {
          /* Sections as Widgets */
          var s = sections[i];
          var sectionCode = getSectionCode(s.id);
          if (!sectionCode) continue;
          var widgetCode = sectionCode[0];
          var widget = widgets[widgetCode];
          /*if (s.title !== null) {
          }*/
          if (s.id === "S18S1" && !!posPlan && (posPlan.toLowerCase() === 'flat' || posPlan.toLowerCase() === 'flex' || posPlan.toLowerCase() === 'flexmini')) {
            s.hide = true;
          }
          hidesectionsforsoftpos(s);
          if (!widget) {
            widget = {
              name: widgetCode,
              code: widgetCode,
              group: widgetCode,
              groupTitle: s.title || '',
              errorMessage: [],
              errorMessage_: s.errorMessage || [],
              position: i,
              active: !s.hide,
              status: s.hide ? ['hidden'] : [],
              components: []
            };
          }
          widget.active = widget.active || !s.hide;
          if (widget.active && widget.status.indexOf('hidden') > -1) {
            widget.status = widget.status.filter(function (e) {
              return e !== 'hidden';
            });
          }
          if ((widget.code === 'S3' || widget.code === 'S6') && getState().product.prodCode !== _utils.posProducts.prodPersonaFisica) {
            widget.status = ['hidden'];
            widget.active = false;
          }
          var fields = s.fields;
          var components = [];

          var _loop = function _loop(j) {
            var f = fields[j];
            var type = FIELD_TYPES[f.type];
            if (type && (type === FIELD_TYPES.RADIO || type === FIELD_TYPES.CHECKBOX) && f.typeValues && f.typeValues.length) {
              if (f.id === 'S1S0D1') {
                components.push(createSpacerComponent(f, ++idx, widget));
              }
              getComponent(components, s, f, widget);
              if (f.id === 'S1S0D1') {
                components.push(createSpacerComponent(f, ++idx, widget));
              }
              //if(f.id==='S11S0D1')
              if (widget.code === 'S11' && chkSelectedCount === 0) {
                f.value = 'selected';
                f.isRequired = true;
                var validations = {};
                validations.isRequired = true;
                var validate = Model.VALIDATION_METHODS.bool;
                validations.default = [{
                  validate: validate,
                  getErrorMessage: Model.VALIDATION_ERRORS.filled
                }];
                f.validations = validations;
                f.cleanName = 'Il consenso'; //'Presa visione',
                updateComponentProp(components, s, f);
                chkSelectedCount = 1;
              }
              if (widget.code === 'S18' && chkSelectedCount === 0) {
                f.isRequired = true;
                var _validations = {};
                _validations.isRequired = true;
                var _validate = Model.VALIDATION_METHODS.bool;
                _validations.default = [{
                  validate: _validate,
                  getErrorMessage: Model.VALIDATION_ERRORS.filled
                }];
                f.validations = _validations;
                //f.cleanName='Il consenso' //'Presa visione',
                updateComponentProp(components, s, f);
                chkSelectedCount = 1;
              }
            } else {
              if (f.type === 'ADDRESS') {
                /** generating Components for State */
                var addressStateComponents = Model.getAddressStateComponents(widgetCode, f.id);
                GeneratedStateComponents.push(addressStateComponents);
                /** generating Components for widget config */
                var addressWidget = JSON.parse((0, _stringify2.default)((0, _addressStatic.getAddressComponents)()));
                updateComponentProp(addressWidget.components, s, f);
                components = components.concat(addressWidget.components);
              } else {
                if (f.type === 'PHONE') {
                  components.push(createSpacerComponent(f, ++idx, widget));
                  var idx2 = 0;
                  if (!f.value.length) {
                    f.value = ['', ''];
                  }
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = (0, _getIterator3.default)(f.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var v = _step.value;

                      var c = createComponent(s, f, ++idx, widget);
                      if (idx2 === 0) {
                        c.cleanName = 'Prefisso Telefono';
                        c.description = 'PREFISSO';
                        c.type = 'selectbox';
                        c.options = {
                          url: 'wgt/utils/prefissi',
                          mapping: { label: 'description', value: 'value' }
                        };
                        c.value = v || '+39';
                        c.label = 'Italia (+39)';
                      } else {
                        c.value = v;
                        c.description = 'NUMERO';
                      }
                      c.name = f.id + idx2++;
                      c.value = cleanValue(c.value || v);
                      components.push(c);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                } else {
                  var _c = createComponent(s, f, ++idx, widget);
                  switch (f.type) {
                    case 'COMBO':
                      _c.initialValue = f.value[0];
                      if (_c.name === 'S6S1D1') {
                        _c.value = '0';
                      }
                      if (_c.name === 'S1S6D1' && _c.value === '') {
                        _c.value = '00';
                        // if(getState().product.prodCode !==posProducts.prodPersonaFisica)
                        // {
                        //   //c.active=false
                        //   c.isDisabled=true
                        // }
                      }
                      if (f.typeValues && f.typeValues.length) {
                        _c.values = f.typeValues.map(function (v) {
                          return {
                            value: v.code,
                            label: v.description
                          };
                        });
                      }
                      if (_c.name === 'S2S1D2' && _c.cleanName === 'Tipologia POS' && !!posPlan && (posPlan.toLowerCase() === 'flat' || posPlan.toLowerCase() == 'flatcrs')) {
                        // const telcoProduct = c.values.find(v => v.label === 'POS GPRS')
                        // const easyProduct = c.values.find(v => v.label === 'POS PAX A920')
                        var product = !!_c && _c.values.find(function (v) {
                          return v.label === 'ANDROID' || v.label === 'ANDROID 920';
                        });
                        _c.value = cleanValue(!!product && product.value);
                        //c.isDisabled = true
                        _c.status.push('readonly');
                      } else if (_c.name === 'S2S1D3' && _c.cleanName === 'Tipologia POS' && !!posPlan && posPlan.toLowerCase() === 'flexmini') {
                        var _product = !!_c && _c.values.find(function (v) {
                          return v.label === 'ANDROIDA50';
                        });
                        _c.value = cleanValue(!!_product && _product.value);
                        _c.status.push('readonly');
                      } else if (_c.name === 'S2S1D6' && _c.cleanName === 'Tipologia POS' && !!posPlan && (posPlan.toLowerCase() === 'flex' || posPlan.toLowerCase() == 'flexcrs')) {
                        var _product2 = !!_c && _c.values.find(function (v) {
                          return v.label === 'Android A99';
                        });
                        _c.value = cleanValue(!!_product2 && _product2.value);
                        _c.status.push('readonly');
                      } else if (_c.name === 'S16S1D1' || widget.groupTitle === 'CONVENZIONE') {
                        //c.values.push({ value: '203', label: 'EN Canone Flex' }); //TODO: Remove this
                        _c.values = _c.values.filter(function (v) {
                          return v.label === 'EN Canone Flat 1' || v.label === 'EN Canone Flat 2' || v.label === 'Canone Flexi' || v.label === 'Telco 4' || v.label === 'Telco 5' || v.label === 'Canone Flexi 80 euro';
                        }); // || v.label==='Canone Flat 3');
                        _c.values = _c.values.map(function (v) {
                          if (v.label === 'EN Canone Flat 1' || v.label === 'Telco 4') {
                            v.label = '17€ + IVA / mese, se con il tuo POS incassi meno di 10.000 euro all’anno';
                            v.currency = '17€';
                            v.vat = '+ IVA';
                            v.perMonth = 'al mese';
                            v.desc = 'Se con il tuo POS incassi meno di 10.000 euro all’anno.';
                          } else if (v.label === 'EN Canone Flat 2' || v.label === 'Telco 5') {
                            v.label = '22€ + IVA / mese, se con il tuo POS incassi tra 10.000 e 30.000 euro all’anno';
                            v.currency = '22€';
                            v.vat = '+ IVA';
                            v.perMonth = 'al mese';
                            v.desc = 'Se con il tuo POS incassi tra 10.000 e 30.000 euro all’anno';
                          } else if (v.label === 'Canone Flexi') {
                            v.label = '1% / transazione, nessun canone mensile per il tuo POS';
                            v.currency = '1%';
                            v.vat = '+ IVA';
                            v.perMonth = 'per transazione';
                            v.desc = 'Nessun canone mensile per il tuo POS';
                          }
                          return v;
                        });
                        //widget.groupTitle = 'SCEGLI IL CANONE'
                      }
                    case 'NUMBER':
                      if (_c.name === 'S2S1D1' || _c.cleanName === 'Numero Terminali POS da Installare'
                      //   &&
                      // (getState().product.prodCode ===
                      //   posProducts.prodPersonaFisica ||
                      //   getState().product.prodCode === posProducts.prodDittaInd)
                      ) {
                          //c.value = 1
                          //c.status.push('readonly')
                          _c.maxLength = '2';
                          var _validations2 = {};
                          _validations2.isRequired = true;
                          var _validate2 = Model.VALIDATION_METHODS.number;
                          _validations2.default = [{
                            validate: _validate2,
                            getErrorMessage: Model.VALIDATION_ERRORS.filled
                          }];
                          _c.validations = _validations2;
                        }
                      if (_c.name === 'S2S9D1') {
                        _c.status = ['hidden'];
                      }
                      if (_c.name === 'S18S2D1' || _c.name === 'S18S2D2') {
                        _c.maxLength = !!f.properties && f.properties.maxlength;
                        var _validations3 = {};
                        _validations3.isRequired = true;
                        var _validate3 = Model.VALIDATION_METHODS.number;
                        _validations3.default = [{
                          validate: _validate3,
                          getErrorMessage: Model.VALIDATION_ERRORS.filled
                        }];
                        _c.validations = _validations3;
                      }
                      updateLinkValueMap(f, _c);
                  }
                  if (!!validateComponents) {
                    validateComponents.map(function (component) {
                      if (component.field === f.id) {
                        _c.errorMessage[0] = component.message;
                      }
                    });
                  }
                  components.push(_c);
                }
              }
            }
            //prop.readOnly
          };

          for (var j = 0; j < fields.length; j++) {
            _loop(j);
          }
          if (widget.code === 'S15' || widget.code === 'S12') {
            var DocumentoStepWidget = JSON.parse((0, _stringify2.default)((0, _addressStatic.getDocumentoRulesComponent)()));
            DocumentoStepWidget.widgets[0].components[0].fieldId = widget.code + '-' + DocumentoStepWidget.widgets[0].components[0].name;
            components[0].fullWidth = true;
            components = [].concat((0, _toConsumableArray3.default)(components), (0, _toConsumableArray3.default)(DocumentoStepWidget.widgets[0].components));
          }
          widget.components = [].concat((0, _toConsumableArray3.default)(widget.components), (0, _toConsumableArray3.default)(components));
          addComponents(widget, components);
          widgets[widgetCode] = widget;
          Model.WIDGETS[widgetCode] = widget;
        }
        GeneratedStateComponents.map(function (stateComponent) {
          Model.COMPONENTS = (0, _extends3.default)({}, Model.COMPONENTS, stateComponent);
        });
        updateWidgetToggles(widgets);
      }
      /* Constructing */
      var customJson = {
        message: 'The request is successfully served.',
        status: 'success'
      };
      customJson.step = (0, _extends3.default)({}, getState().step);

      var widgetsTemp = [];
      if (customJson.step.widgets_ && customJson.step.widgets_.length) {
        PERSONALIZZA_WIDGETS.map(function (k) {
          var widgets_ = customJson.step.widgets_.find(function (w) {
            return w && k === w.name;
          });
          if (widgets_) {
            widgetsTemp.push(widgets_);
          }
        });
      }
      // if(widget.code==='S8' && components[0].fieldId==='S8S2D1' &&
      // components[0].toggleVisibility && 
      // components[0].toggleVisibility.show && 
      // components[0].toggleVisibility.show.fields)
      // {
      // components[0].toggleVisibility.show.fields.concat('S12-DOCUMENTRULES')
      // }
      //const finalWidgets = ob widgets
      customJson.step.widgets = widgetsTemp.concat((0, _values2.default)(widgets));
      var token = new _stepActions.ActionToken('step.parsePersonalizzaWidgets');
      var oldWidgets = getState().widgets;
      var oldComponents = getState().components;
      dispatch((0, _stepActions.stepCallback)(token, customJson, oldWidgets, oldComponents));
    });
  };
};
/**
 * Fetch data through API
 *
 * @param {Object} key          The object of a request api to fetch (optional)
 * @param {Object} component        The component to change
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 * @param {param} skipFields          The object of a request api to fetch (optional)
 */
var sendRequest = exports.sendRequest = function sendRequest(key, component, skipFields) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        components = _getState4.components;

    var request = component.fetch[key];
    if (request && request.isDisabled !== false && request.hasOwnProperty('url')) {
      var token = new _stepActions.ActionToken('step.sendRequest');
      var body = void 0;
      if (request.hasOwnProperty('body')) {
        body = request.body;
      }

      if (component.id === 'DIFARMA_0-FIRMA' || component.id === 'DIFARMA_1-FIRMA' || component.id === 'DIFARMA_2-FIRMA' || component.id === 'DIFARMA_3-FIRMA' || component.id === 'DIFARMA_4-FIRMA' || component.id === 'DIFARMA_5-FIRMA') {
        body = component.body;
      }
      if (component.id === 'PROFESSIONE_ATTIVITA-PROFESSIONE' || component.id === 'PROFESSIONE_ATTIVITA-SETTORE' || component.id === 'PROFESSIONE_ATTIVITA-ATTIVITA') {
        if (component.value !== '') skipFields = false;
      }
      if (request.hasOwnProperty('fields') && !skipFields) {
        body = body || {};
        request.fields.forEach(function (field) {
          return (0, _keys2.default)(field).forEach(function (key) {
            return body[field[key].fieldName] = components[key].value;
          });
        });
      }
      if (request.mappingEvent === 'titolareEffettivo' && !body.cf) {
        return;
      }
      var filterDupes = function filterDupes(arr) {
        request.mapping ? (0, _lodash.uniqBy)(arr.map(function (o) {
          var res = o;
          for (var k in request.mapping) {
            res[k] = o[request.mapping[k]];
          }
          return res;
        }), 'value') : arr;
      };
      dispatch((0, _stepActions.dealActionToken)(token));
      (0, _api.fetchAPIData)(request.url, body).then(function () {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        dispatch((0, _stepActions.hideLoading)());
        dispatch((0, _stepActions.dealActionToken)((0, _extends3.default)({}, token, { dispose: true })));
        if (request.mappingEvent) {
          dispatch(updateComponentCustom(request, component, json));
        } else {
          var action = {};
          action.type = UPDATE_COMPONENT;
          action.component = {
            id: component.id,
            value: component.value,
            values: filterDupes(json.data)
          };
          dispatch(action);
        }
      });
    }
  };
};

var isNull = function isNull(v) {
  return v === null;
};
//const isNoRefId = id => id === null

//Fix for Informazioni-compagine questionnaire checkbox validation
var constructValidationsQuest = function constructValidationsQuest(o /* , qo */) {
  if (o.id === 'SZ0024SS0049DM0094RI0504' || o.id === 'SZ0024SS0049DM0094RI0505' || o.type === 'text' || o.id === 'SZ0023SS0048DM0089RI0121' || o.id === 'SZ0023SS0048DM0089RI1058' || o.id === 'SZ0023SS0048DM0089RI1059' || o.id === 'SZ0023SS0048DM0089RI1060' || o.id === 'SZ0023SS0048DM0089RI1061' || o.id === 'SZ0023SS0048DM0089RI1056' || o.id === 'SZ0023SS0048DM0089RI0126' || o.id === 'SZ0023SS0048DM0089RI0381' || o.id === 'SZ0024SS0049DM0094RI0500' || o.id === 'SZ0024SS0049DM0094RI0501' || o.id === 'SZ0024SS0049DM0534RI0502' || o.id === 'SZ0024SS0049DM0534RI0503' || o.id === 'SZ0024SS0049DM0525RI0576' || o.id === 'SZ0024SS0049DM0525RI0577' || o.id === 'SZ0024SS0049DM0094RI0507' || o.id === 'SZ0024SS0049DM0526RI0578' || o.id === 'SZ0016SS0011DM0030RI0103' || o.id === 'SZ0016SS0011DM0031RI0104' || o.id === 'SZ0007SS0007DM0030RI0026' || o.id === 'SZ0007SS0007DM0031RI0027' || o.id === 'SZ0023SS0027DM0535RI0608' || o.id === 'SZ0023SS0027DM0536RI0609' || o.id === 'SZ0023SS0027DM0537RI0610' || o.id === 'SZ0023SS0027DM0538RI0611' || o.id === 'SZ0023SS0027DM0092RI0102' || o.id === 'SZ0022SS0208DM0849RI0947' || o.id === 'SZ0022SS0208DM0849RI0948' || o.id === 'SZ0022SS0208DM0849RI0949' || o.id === 'SZ0022SS0209DM0850RI0950' || o.id === 'SZ0022SS0209DM0850RI0951' || o.id === 'SZ0011SS0230DM0886RI0989' || o.id === 'SZ0011SS0230DM0886RI0990' || o.id === 'SZ0011SS0230DM0886RI0991' || o.id === 'SZ0011SS0231DM0887RI0992' || o.id === 'SZ0011SS0231DM0887RI0993' || _stepActions.PatrimonioCheckBoxesIds.indexOf(o.id) > -1
  // o.id==='SZ0010SS0221DM0864RI0059' ||
  // o.id==='SZ0010SS0221DM0864RI0060' ||
  // o.id==='SZ0010SS0221DM0864RI0061' ||
  // o.id==='SZ0010SS0221DM0864RI0062' ||
  // o.id==='SZ0010SS0221DM0864RI0063' ||
  // o.id==='SZ0010SS0221DM0864RI0064' ||
  // o.id==='SZ0010SS0221DM0864RI0065'

  //|| o.id==='SZ0144SS0237DM0959RI0791'
  ) {
      var validations = {};
      validations.isRequired = true;
      var validate = void 0;
      switch (o.type) {
        case 'radio':
        case 'checkbox':
        case 'selectbox':
          //case 'dropdownbox':
          validate = Model.VALIDATION_METHODS.bool;
          break;
        default:
          validate = Model.VALIDATION_METHODS.filled;
      }
      validations.default = [{
        validate: validate,
        getErrorMessage: Model.VALIDATION_ERRORS.filled
      }];
      o.validations = validations;
    }
};

/**
 *Send OTP through API
 * 
 */

var sendOTP = exports.sendOTP = function sendOTP(api, body) {
  return function (dispatch, getState) {
    (0, _api.fetchAPIData)(api, body).then(function () {
      var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    });
    var updateBody = { otpbtnDisabled: true };
    dispatch({
      type: UPDATE_COMPONENT,
      component: (0, _extends3.default)({}, updateBody, {
        id: 'CELLULARE-NUM_CELLULARE'
      })
    });
    dispatch(updateComponent('CELLULARE-CODICE_CELLULARE', {
      isDisabled: false
    }, { avoidValidation: true }));
    setTimeout(function () {
      var updateBody = { otpbtnDisabled: false };
      var updatedComponent = getState().components['CELLULARE-NUM_CELLULARE'];
      if (updatedComponent.status.indexOf('error') <= -1) {
        dispatch({ type: UPDATE_COMPONENT, component: (0, _extends3.default)({}, updateBody, { id: 'CELLULARE-NUM_CELLULARE' }) });
      }
    }, 10000);
  };
};
/**
 * Fetch data through API
 *
 * @param {Object} response         The response object contains widgets and components
 * @param {Object} config           The data fetched for the request to parse
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
var parseQuestionarioWidgets = exports.parseQuestionarioWidgets = function parseQuestionarioWidgets(response, config, prevProvincia) {
  return function (dispatch, getState) {
    var TYPES = {
      DropdownBox: 'selectbox',
      Radio: 'radio',
      ListBox: 'selectbox',
      Label: 'label',
      TextBox: 'text',
      CheckBox: 'checkbox',
      TextArea: 'TextArea',
      DatePicker: 'date',
      Others: 'Others'
    };
    var QUESTIONARIO_WIDGETS = ['FLOW_BAR', 'SETTORE_ATTIVITA_AZIENDA', 'AZIENDA_ANTIRICICLAGGIO', 'PROFESSIONE_ATTIVITA', 'ANTIRICICLAGGIO', 'DATI_SENSIBILI', 'CRONISTORIA', 'PROMOZIONE', 'PROMOZIONE_TERZI', 'PROFILAZIONE'];
    var isTitolare = config.method === 'Titolare_Effettivo';
    //try {
    /* Hack for the AZIENDA_ANTIRICICLAGGIO step */
    var section = config.data.sections.section;
    var listBoxData = config.data.listBoxData;
    if (config.isSavePG) {
      var jsonPG = JSON.parse((0, _stringify2.default)(response));
      Model.savePG = jsonPG;
    }
    if (section && section.length > 0) {
      Model.RefIdMap = {};
      var widgets = [];
      var widget = {};

      var _loop2 = function _loop2(s) {
        /* Sections as Widgets */
        widget = {
          name: s.sectionCode,
          code: s.sectionCode,
          group: s.sectionCode,
          groupTitle: s.description.value,
          errorMessage: [],
          errorMessage_: s.errorMessage,
          position: s.sequence,
          active: isNull(s.refId),
          status: isNull(s.refId) && s.isHidden !== true && s.description.visible === true ? [] : ['hidden']
        };
        var components = [];
        var config = {
          sectionCode: s.sectionCode,
          position: 0
        };

        if (!(s.subSections && s.subSections.subSection && s.subSections.subSection.length)) {
          return 'continue';
        }

        //let isAnyActive = false
        var subSection = s.subSections.subSection;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(subSection), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var ss = _step3.value;

            /* SubSections as Component */
            var sso = {
              name: ss.subSectionCode,
              cleanName: ss.description.value,
              isSubSection: true,
              active: widget.active,
              groupConditions: {}
            };
            config.subSectionCode = ss.subSectionCode;
            sso.value = ss.description.value;
            updateObject(ss, sso, config);
            sso.name_ = s.sectionCode + '-' + sso.name;

            var question = ss.questions.question;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = (0, _getIterator3.default)(question), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var q = _step4.value;

                /* Questions as Component */
                var qo = {
                  cleanName: q.description.value,
                  /*type: TYPES.Label,*/
                  position: q.sequence,
                  isQuestion: true,
                  qCode: q.code,
                  active: sso.active,
                  groupCondition: q.groupCondition
                };

                updateObject(q, qo, config);
                qo.name = ss.subSectionCode + '_' + q.code;
                qo.validations = { isRequired: q.isRequired };

                var ans = q.answers && q.answers.answer && q.answers.answer[0];
                if (ans && ans.field && (ans.field.type === 'Radio' || ans.field.type === 'Label' || ans.field.type == 'Others')) {
                  qo.value = q.description.value;
                }

                qo.name_ = s.sectionCode + '-' + qo.name;
                var radioBtnValue = '';
                var questionID = '';
                var answer = q.answers.answer;

                var _loop3 = function _loop3(a) {
                  /* Answer as Component */
                  var o = (0, _extends3.default)({}, a);
                  if (!!q.description && q.description.value === 'Nazione' && !o.field.value) {
                    o.field.value = 'ITALIA';
                  }
                  if (!!q.description && q.description.value === 'una Provincia' && !o.field.value) {
                    o.field.value = !!prevProvincia ? prevProvincia : o.field.value;
                  }
                  delete o.code;
                  o.active = qo.active;
                  o.isAnswer = true;
                  updateObject(o, o, config);
                  o.name = ss.subSectionCode + '_' + q.code + '_' + a.code;
                  o.type = TYPES[a.field.type];
                  if (o.type === TYPES.ListBox || o.type === TYPES.TextBox || o.type === TYPES.TextArea || o.type === TYPES.DatePicker) {
                    o.cleanName = qo.cleanName;
                  } else if (a.description) {
                    a.cleanName = a.description;
                  }
                  o.aCode = a.code;
                  o.qCode = q.code;
                  o.values = [];
                  if (a.field.refId && o.type === TYPES.ListBox && listBoxData && listBoxData.list) {
                    var values = listBoxData.list.filter(function (v) {
                      return v.refId === a.field.refId;
                    });
                    o.values = values && values[0] && values[0].data;
                  }
                  config.position += q.sequence;
                  a.position = config.position;

                  if (o.type === TYPES.CheckBox || o.type === TYPES.Radio) {
                    if (o.type === TYPES.Radio) {
                      if (!widget.radioGroup) {
                        widget.radioGroup = {};
                      }
                      widget.radioGroup[o.id_] = qo.id_;
                    }
                    //o.value=
                    if (radioBtnValue === '' && a.description === 'NO') {
                      o.value = 'selected';
                    } else {
                      o.value = a.field && a.field.selected ? 'selected' : '';
                      radioBtnValue = o.value;
                    }
                    if (o.type === TYPES.Radio) {
                      if (questionID !== qo.id_ && a.description !== 'SI') {
                        o.value = 'selected';
                      }
                      questionID = qo.id_;
                    }
                    if (o.id === 'SZ0023SS0048DM0089RI1056') {
                      if (!!o.description && o.description.indexOf("vedi l'elenco dei Paesi") > -1) {
                        var link = {
                          placeholder: '§link§',
                          text: "vedi l'elenco dei Paesi",
                          url: 'https://finance.ec.europa.eu/financial-crime/high-risk-third-countries-and-international-context-content-anti-money-laundering-and-countering_en',
                          target: '_blank'
                        };
                        o.description = "Nella compagine societaria del Cliente è presente un'entità giuridica avente sede in Paesi terzi ad alto rischio (§link§) : se si seleziona questa opzione occorre indicare la/le Nazione/i della sede dell'entità giuridica";
                        o.link = link;
                      }
                    }
                  } else if (o.type === TYPES.Label || o.type === TYPES.TextBox || o.type === TYPES.TextArea || o.type === TYPES.DatePicker || o.type === TYPES.ListBox) {
                    o.value = a.field && (a.field.value ? a.field.value : "");
                  }
                  o.linkValue = a.field && a.field.linkValue;
                  o.name_ = s.sectionCode + '-' + o.name;
                  constructValidationsQuest(o, qo);
                  updateRefIdMap([{ refId: o.refId, name: o.name_, type: 'answer' }, { refId: qo.refId, name: o.name_, type: 'answer' }, { refId: sso.refId, name: o.name_, type: 'answer' }, { refId: s.refId, name: o.name_, type: 'answer' }, { refId: qo.refId, name: qo.name_, type: 'question' }, { refId: sso.refId, name: qo.name_, type: 'question' }, { refId: s.refId, name: qo.name_, type: 'question' }, { refId: sso.refId, name: sso.name_, type: 'subSection' }, { refId: s.refId, name: sso.name_, type: 'subSection' }, { refId: s.refId, name: widget.name, type: 'section' }, { refId: 'OB0001', name: 'SZ0023-SS0027', type: 'subSection' }, { refId: 'OB0002', name: 'SZ0023-SS0027', type: 'subSection' }]);
                  updateLinkIdMap(o);

                  if (qo.groupCondition === 'OR' || qo.groupCondition === 'or') {
                    sso.groupConditions[o.name] = qo.name;
                    o.isGrouped = true;
                  }
                  Model.COMPONENTS[o.name_] = o;
                  components.push(o);
                };

                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                  for (var _iterator5 = (0, _getIterator3.default)(answer), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var a = _step5.value;

                    _loop3(a);
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }

                Model.COMPONENTS[qo.name_] = qo;
                components.push(qo);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            Model.COMPONENTS[sso.name_] = sso;
            components.push(sso);
          }
          // if(widget.code==='SZ0016')
          // {
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var provincia = components.filter(function (c) {
          return c.cleanName === 'una Provincia' && !!c.field;
        });
        var area = components.filter(function (c) {
          return c.cleanName === 'una Regione/Area' && !!c.field;
        });
        var disComponentID = void 0;
        if (!!provincia[0] && provincia[0].value && provincia[0].value !== 'Seleziona') {
          //area.isDisabled=true
          disComponentID = area[0].id;
        }
        if (!!area[0] && area[0].value && area[0].value !== 'Seleziona') {
          disComponentID = provincia[0].id;
        }
        if (disComponentID) {
          components.map(function (c) {
            if (c.id === disComponentID) {
              c.isDisabled = true;
            }
          });
        }
        //}
        Model.WIDGETS[widget.name] = (0, _extends3.default)({}, widget);
        widget.components = components;
        widgets.push(widget);
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(section), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var s = _step2.value;

          var _ret2 = _loop2(s);

          if (_ret2 === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      widgets.map(function (w) {
        /* toggle visibility  */
        createLinkRefMap(w);
      });

      /* Constructing */
      if (isTitolare) {
        return widgets;
      } else {
        var customJson = {
          status: response.status,
          message: response.message
        };
        customJson.step = (0, _extends3.default)({}, getState().step);

        var widgets_temp = [];
        if (customJson.step.widgets_ && customJson.step.widgets_.length) {
          QUESTIONARIO_WIDGETS.map(function (k) {
            var w = customJson.step.widgets_.find(function (w) {
              return w && k === w.name;
            });
            if (!!w) {
              widgets_temp.push(w);
            }
          });
        }
        customJson.step.widgets = widgets_temp.concat(widgets);
        var token = new _stepActions.ActionToken('step.questionarioComponents');
        var oldWidgets = getState().widgets;
        var oldComponents = getState().components;
        dispatch((0, _stepActions.stepCallback)(token, customJson, oldWidgets, oldComponents));
      }
    }
  };
};

var updateObject = function updateObject(src, dec, config) {
  if (config) {
    dec.position = ++config.position;
    dec.sectionCode = config.sectionCode;
    dec.subSectionCode = config.subSectionCode;
  }
  dec.errorMessage = [];
  dec.id_ = src.id;
  dec.refId = src.refId;
  dec.linkId = src.linkId;

  dec.active = dec.active && isNull(src.refId);
  dec.status = dec.active ? [] : ['hidden'];
  if (dec.sectionCode === 'SZ0130' && (dec.subSectionCode === 'SS0033' || dec.subSectionCode === 'SS0034' || dec.subSectionCode === 'SS0035') || dec.sectionCode === 'SZ0018' && (dec.subSectionCode === 'SS0029' || dec.subSectionCode === 'SS0003' || dec.subSectionCode === 'SS0030') || dec.sectionCode === 'SZ0023' && dec.subSectionCode === 'SS0027') {
    dec.status = false;
    dec.status = ['hidden'];
  }

  if (dec.isQuestion || dec.isSubSection) {
    if (src.description === null || src.description.visible === false) {
      dec.status = ['hidden'];
    } else if (dec.isSubSection) {
      dec.value = src.description.value;
    }
    dec.type = 'label';
  }

  dec.errorMessage_ = src.errorMessage;
};

var createLinkRefMap = function createLinkRefMap(widget) {
  var components = widget.components;
  if (components && components.length) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = (0, _getIterator3.default)(components), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var c = _step6.value;

        if (c.linkId) {
          var linkIdMap = Model.RefIdMap[c.linkId];
          if (linkIdMap) {
            linkIdMap = (0, _keys2.default)(linkIdMap);
            c.toggleVisibility = {
              show: {
                fields: [].concat((0, _toConsumableArray3.default)(linkIdMap))
              }
            };
          }
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    widget.components = components;
  }
};

var isLinkExist = exports.isLinkExist = function isLinkExist(linkId, components) {
  var isLinkExist_ = false;
  if (linkId) {
    var linkIdMap = Model.LinkIdMap[linkId];
    if (linkIdMap) {
      var linkIdMapKey = (0, _keys2.default)(linkIdMap);
      if (linkIdMapKey.length) {
        isLinkExist_ = linkIdMapKey.some(function (k) {
          var isLinked = false;
          var c = components[k];
          if (c && c.type && c.value) {
            if (c.type === 'selectbox' || c.type === 'text') {
              isLinked = c.linkValue && c.linkValue === c.value;
            } else if (c.type === 'radio' || c.type === 'checkbox') {
              isLinked = c.value === 'selected';
            }
          }
          return isLinked;
        });
      }
    }
  }
  return isLinkExist_;
};

var updateRefIdMap = function updateRefIdMap(refIdMap) {
  var linkRefIdMap = Model.RefIdMap || {};
  refIdMap.map(function (o) {
    if (!isNull(o.refId)) {
      if (!linkRefIdMap[o.refId]) {
        linkRefIdMap[o.refId] = {};
      }
      linkRefIdMap[o.refId][o.name] = o.type;
    }
  });
  Model.RefIdMap = linkRefIdMap;
};

var updateLinkIdMap = function updateLinkIdMap(o) {
  var linkIdMap = Model.LinkIdMap || {};
  if (!isNull(o.linkId)) {
    if (!linkIdMap[o.linkId]) {
      linkIdMap[o.linkId] = {};
    }
    linkIdMap[o.linkId][o.name_] = o.type;
  }
  Model.LinkIdMap = linkIdMap;
};
/**
 * Fetch data through API
 *
 * @param {Object} request          The object of a request api to fetch (optional)
 * @param {Object} component        The component to change
 * @param {Object} response             The data fetched for the request
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
var updateComponentCustom = exports.updateComponentCustom = function updateComponentCustom(request, component, response) {
  return function (dispatch, getState) {
    //const action = {}
    var _getState5 = getState(),
        step = _getState5.step,
        product = _getState5.product;

    var isQuestionario = request.mappingEvent === 'questionario';
    if (isQuestionario && response && response.data && response.data.acolQuestionnaire) {
      //action.type = QUESTIONARIO_COMPONENT
      //const customJson = {}
      //customJson.step = { ...getState().step }

      var config = {
        data: response.data.acolQuestionnaire,
        isSavePG: true
      };
      (0, _api.FetchPOSOnboardDetails)('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID: step.guid }).then(function () {
        var provinciaJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var prevProvincia = !!provinciaJson && !!provinciaJson.payLoad && !!provinciaJson.payLoad.Provincia ? provinciaJson.payLoad.Provincia.split('-')[1] : '';
        //console.log(provinciaJson.payLoad.Provincia)
        dispatch(parseQuestionarioWidgets(response, config, prevProvincia));
      });

      /* TODO: copy existing widgets and create components with json */
      //const token = new ActionToken('step.questionarioComponents')
      //dispatch(stepCallback(token, customJson))
      //action.components = customJson
    } else if (request.mappingEvent === 'titolareEffettivo' && step.number === 5 && product.partnership === _utils.posProducts.prodAzienda) {
      if (response.data) {
        var codiceMap = new _map2.default();
        codiceMap.set('CODICE_FISCALE-DATADINASCITA', response.data.dataDiNascita);
        codiceMap.set('CODICE_FISCALE-SESSO', response.data.sesso);
        codiceMap.set('CODICE_FISCALE-DATADINASCITA', response.data.dataDiNascita);
        codiceMap.set('CODICE_FISCALE-SESSO', response.data.sesso);
        codiceMap.set('CODICE_FISCALE-PROVINCIADINASCITA', response.data.provinciaDiNascita);
        codiceMap.set('CODICE_FISCALE-LUOGODINASCITA', !!response.data.luogoDiNascita ? response.data.luogoDiNascita : response.data.statoDiNascita);

        codiceMap.forEach(function (value, key) {
          //const value = codiceMap.get(key)
          if (key) {
            dispatch(updateComponent(key, {
              value: value
            }));
          }
        });
      }
    } else if (request.mappingEvent === 'IframeSrcSetter' && step.last) {
      if (response.data !== null) {
        var _response$data = response.data,
            esito = _response$data.esito,
            activationUrl = _response$data.activationUrl,
            message = _response$data.message;
        //var alertMessage=message.replace('<br><br>','<br/>')

        var srcUrl = activationUrl;
        var callCount = 0;
        if (esito.toUpperCase() === 'OK') {
          dispatch(updateComponent(component.updateComponentId, { value: srcUrl }));
          dispatch((0, _stepActions.showAlert)({
            id: 'ATTIVA_REVOCA_FIRMA-MODAL',
            value: message,
            title: 'Messaggio'
          }));
          dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-LABEL', { status: ['hidden'] }));
          setTimeout(dispatch(iterativeCheckCall(callCount)), timer);
        }
      }
    }
    //Digital Contract for last step
    else if (request.mappingEvent === 'DigiSignature' && step.last) {
        var action = {};
        if (response && response.status !== null && response.status === 'success') {
          action.type = UPDATE_COMPONENT;
          action.component = {
            id: component.id,
            value: component.value,
            disabled: true
          };
          dispatch((0, _stepActions.updateDiFarmaComponent)({}, { step: { widgets: [] } }));
        } else {

          action.type = UPDATE_COMPONENT;
          action.component = {
            id: component.id,
            value: 'Firma',
            disabled: false
          };
          dispatch(action);
        }
      } else if (request.mappingEvent === 'DiFarmaIframeSrcSetter' && step.last) {
        if (response.data !== null) {
          var _response$data2 = response.data,
              _esito = _response$data2.esito,
              url = _response$data2.url;

          var _srcUrl = url;
          var _callCount = 0;
          if (_esito.toUpperCase() === 'OK') {
            dispatch(updateComponent(component.updateComponentId, { value: _srcUrl }));
            setTimeout(dispatch(iterativeGetContractCall(component, _callCount)), timer);
          }
        }
      }
  };
};

var activateSign = exports.activateSign = function activateSign(sign) {
  return function (dispatch) {
    if (sign.toLowerCase() === 'true') {
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-VISIONE', {
        value: 'selected',
        status: ['hidden'],
        Position: 2
      }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-LINK_ADDENDUM', {
        status: ['hidden']
      }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-LINK_MANUALE', {
        value: 'La firma digitale \xE8 un servizio gratuito che ti consente di firmare i documenti comodamente online, senza stampare.',
        Position: 1
      }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-FIRMA', {
        value: 'Attivata',
        type: 'active',
        disabled: true,
        Position: 2
      }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-LINK_ISTRUZIONI', {
        value: 'Per firmare i documenti usa la firma digitale SellaDigit gi\xE0 in tuo possesso.\n        Per ulteriori informazioni su SellaDigit puoi contattare l\'Assistenza al numero 800.142.142 disponibile dal luned\xEC al venerd\xEC dalle 8 alle 21 (Da estero e cellulare: +39-015.2434617)',
        Position: 3
      }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-LABEL', { status: ['hidden'] }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-IFRAME', { status: ['hidden'] }));
      dispatch(updateComponent('ATTIVA_REVOCA_FIRMA-LABEL', { status: ['hidden'] }));
    }
  };
};

var callMaxCount = 400;
var timer = 5000;
var iterativeCheckCall = function iterativeCheckCall(callCount) {
  return function (dispatch, getState) {
    (0, _stepActions.digitalSignCheckCall)().then(function (_ref2) {
      var digitalsign = _ref2.digitalsign;

      if (digitalsign.toLowerCase() === 'true') {
        dispatch(activateSign(digitalsign));

        var _getState6 = getState(),
            _components = _getState6.components,
            widgets = _getState6.widgets;

        var widget = widgets.DIFARMA_0;
        var component = _components[widget.name + '-FIRMA'];
        if (component !== null && widget !== null) dispatch(updateComponent(component.id, {
          disabled: false,
          type: 'sella',
          action: (0, _assign2.default)({}, {
            value: 'Attivata',
            type: 'inverse',
            disabled: true,
            fetch: {
              attivata: {
                url: 'wgt/sign/url',
                body: {
                  docId: component.barcode,
                  smsContent: component.tipo
                },
                mappingEvent: 'DiFarmaIframeSrcSetter'
              }
            },
            updateComponentId: widget.name + '-IFRAME',
            toggleVisibility: {
              show: {
                fields: [widget.name + '-IFRAME']
              }
            }
          })
        }));
        dispatch(updateComponent("ATTIVA_REVOCA_FIRMA-IFRAME", { otpMessage: false }));
      } else {
        callCount++;
        if (callCount <= callMaxCount) setTimeout(dispatch(iterativeCheckCall(callCount)), timer);else dispatch((0, _stepActions.showAlert)({
          id: 'ATTIVA_REVOCA_FIRMA-MODAL',
          value: 'Errore di timeout Ricarica la pagina',
          title: 'Messaggio'
        }));
      }
    });
  };
};

var iterativeGetContractCall = function iterativeGetContractCall(component, callCount) {
  return function (dispatch, getState) {
    var updateFirma = null;
    (0, _stepActions.getContractList)().then(function (response) {
      if (response.status.toLowerCase() === 'success') {
        var _response$data3 = response.data,
            contracts = _response$data3.contracts,
            holderInfo = _response$data3.holderInfo;

        var contractList = contracts.filter(function (_ref3) {
          var sign = _ref3.sign;
          return sign !== '' && sign !== 'never_uploaded';
        });
        var signedContractList = contractList.filter(function (_ref4) {
          var sign = _ref4.sign;
          return sign === 'true';
        });
        var openContract = contractList.filter(function (_ref5) {
          var barCode = _ref5.barCode;
          return barCode === component.barcode;
        });
        if (!!openContract && openContract[0].sign === 'true') {
          dispatch(updateComponent(component.id, {
            type: 'active',
            disabled: true,
            value: 'FIRMATO',
            action: {},
            fetch: {}
          }));
          dispatch(updateComponent(component.updateComponentId, { status: ['hidden'] }));

          var _getState7 = getState(),
              step = _getState7.step;

          if (contractList.length === signedContractList.length) {
            dispatch((0, _stepActions.enableBtn)(step));
          }
          var contractFirmaActive = true;
          var updateContractsComponents = contractList.map(function (contract, index) {
            if (holderInfo.digitalsign && contract.sign === 'false' && contractFirmaActive) {
              updateFirma = {
                id: 'DIFARMA_' + index + '-' + contract.azioni,
                update: {
                  disabled: false,
                  type: 'sella',
                  action: (0, _assign2.default)({}, {
                    value: 'Attivata',
                    type: 'inverse',
                    disabled: true,
                    barcode: contract.barCode,
                    fetch: {
                      attivata: {
                        url: 'wgt/sign/url',
                        body: {
                          docId: contract.barCode,
                          smsContent: contract.tipo
                        },
                        mappingEvent: 'DiFarmaIframeSrcSetter'
                      }
                    },
                    updateComponentId: 'DIFARMA_' + index + '-IFRAME',
                    toggleVisibility: {
                      show: {
                        fields: ['DIFARMA_' + index + '-IFRAME']
                      }
                    }
                  })
                }
              };
              contractFirmaActive = false;
            }
          });

          if (updateFirma !== null) {
            dispatch(updateComponent(updateFirma.id, updateFirma.update));
          }
        } else {
          callCount++;
          if (callCount <= callMaxCount) setTimeout(dispatch(iterativeGetContractCall(component, callCount)), timer);else dispatch((0, _stepActions.showAlert)({
            id: 'ATTIVA_REVOCA_FIRMA-MODAL',
            value: 'Errore di timeout Ricarica la pagina',
            title: 'Messaggio'
          }));
        }
      }
    });
  };
};
/**
 * Fetch data through API
 *
 * @param {String} componentId      The component that updates other components
 * @param {String} api              The name of the api to fetch (optional)
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 * @param {boolean} skipFields     Skip the fields for first call
 */
var fetchData = exports.fetchData = function fetchData(componentId, api, skipFields) {
  return function (dispatch, getState) {
    var _getState8 = getState(),
        components = _getState8.components,
        step = _getState8.step,
        product = _getState8.product;

    var component = components[componentId];
    if (component.hasOwnProperty('fetch') && component.status.indexOf('error') < 0) {
      if (step.number === 1 && component.id === 'CODICE_FISCALE-CF') {
        return;
      }
      // if (
      //   step.number === 3 &&
      //   product.prodCode === posProducts.prodPersonaFisica &&
      //   (!components['PROFESSIONE_ATTIVITA-SETTORE'].value ||
      //     !components['PROFESSIONE_ATTIVITA-PROFESSIONE'].value ||
      //     !components['PROFESSIONE_ATTIVITA-ATTIVITA'].value)
      // ) {
      //   return
      // }
      if (step.number === 5 && product.prodCode === _utils.posProducts.prodAzienda && componentId === 'SETTORE_ATTIVITA_AZIENDA-SETTORE') {
        return;
      }
      if (api) {
        dispatch(sendRequest(api, component, skipFields));
      } else {
        //for (const request of component.fetch) {
        (0, _keys2.default)(component.fetch).forEach(function (key) {
          /* we can add logic here to skip any API call based on prop */
          dispatch(sendRequest(key, component, skipFields));
        });
      }
    }
  };
};

/**
 * Invoke a callback method
 *
 * @param {Object} config      The config to invoke a methods
 * @param {Object} component   The component to change
 * @return {Function}          Dispatches an UPDATE_COMPONENT action
 */
var invokeMethod = exports.invokeMethod = function invokeMethod(config, component) {
  return function (dispatch) {
    var params = config.params || [];
    params = params.map(function (p) {
      return component[p.name];
    });
    dispatch(config.fn.apply(config, (0, _toConsumableArray3.default)(params)));
  };
};

/**
 * Triggers all the dependent component to get updated values
 *
 * @param {Object} componentId      The component that updates other components
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
var triggerDependantComponents = exports.triggerDependantComponents = function triggerDependantComponents(componentId) {
  return function (dispatch, getState) {
    var _getState9 = getState(),
        components = _getState9.components;

    var triggerComponent = components[componentId];
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = (0, _getIterator3.default)(triggerComponent.trigger), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var comp = _step7.value;

        if ((0, _keys2.default)(components).indexOf(triggerComponent.id) > -1) {
          if ((0, _keys2.default)(components).indexOf(comp.componentId) > -1) {
            if (comp.type === 'fetchOption' && components[comp.componentId].type === 'selectbox') {
              var component = getState().components[comp.componentId];
              if (triggerComponent.id === 'PROFESSIONE_ATTIVITA-SETTORE' && triggerComponent.value) {
                var addOption = {
                  'PROFESSIONE_ATTIVITA-SETTORE': { fieldName: 'value' }
                };
                component.options.fields.push(addOption);
              }
              //component.value = comp.value || component.value
              dispatch(getSelectOptions(component));
            } else if (comp.type === 'fetch') {
              dispatch(fetchData(comp.componentId, comp.api));
            } else if (comp.type === 'copy') {
              if (triggerComponent.type !== 'radio' || triggerComponent.value === 'selected') {
                var value = comp.hasOwnProperty('value') ? comp.value : triggerComponent.value;
                dispatch(updateComponent(comp.componentId, {
                  value: value
                }));
              }
            }
          }
          if (comp.type === 'call' && comp.fn) {
            dispatch(invokeMethod(comp, triggerComponent));
          }
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }
  };
};

var triggerGroupConditions = exports.triggerGroupConditions = function triggerGroupConditions(componentId) {
  return function (dispatch, getState) {
    var _getState10 = getState(),
        components = _getState10.components;

    var c = components[componentId];
    if (c.isGroupUpdate) return;
    var ssoId = c.sectionCode + '-' + c.subSectionCode;
    var sso = components[ssoId];
    //const cid = `${c.sectionCode}-${c.name}`
    var disableGroup = false;
    //let iAmInside = false
    //let anotherIsNotNull = false

    if (sso && sso.groupConditions && sso.groupConditions[c.name]) {
      var isValueSelected = c.value !== null && c.value !== undefined && c.value.length > 0 && c.value !== 'Seleziona';
      var grpConditons = sso.groupConditions;
      (0, _keys2.default)(grpConditons).forEach(function (key) {
        var gc = components[c.sectionCode + '-' + key];

        disableGroup = gc.id !== c.id && isValueSelected;
        var isGroupUpdate = disableGroup;
        if (gc.isDisabled !== disableGroup) {
          dispatch(updateComponent(gc.id, {
            isDisabled: disableGroup,
            isGroupUpdate: isGroupUpdate
          }));
        }
      });
    }
  };
};

/**
 * Notify components that they need to validate again
 *
 * @param  {type} options     Validation options
 * @return {Function}         Calls the validateComponent function
 */
var notifyComponents = exports.notifyComponents = function notifyComponents(options) {
  return function (dispatch) {
    if (!!options && options.validate) {
      options.validate.forEach(function (k) {
        return dispatch(validateComponent(k, { collateral: true }));
      });
    }
  };
};

/**
 * Fills all the selects with their options
 *
 * @param {Object} component    the component to change
 * @return {Array}              all the widgets with the updated select inside
 */
var getSelectOptions = exports.getSelectOptions = function getSelectOptions(component) {
  return function (dispatch, getState) {
    var options = component.options;
    if (options.init === false || !options.hasOwnProperty('url')) return;

    var _getState11 = getState(),
        components = _getState11.components,
        product = _getState11.product;

    if (product.prodCode === _utils.posProducts.prodAzienda && component.id === 'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA') {
      options.isDisabled = true;
    }
    var filterDupes = function filterDupes(arr) {
      return (0, _lodash.uniqBy)(arr.map(function (o) {
        var res = o;

        for (var k in options.mapping) {
          res[k] = o[options.mapping[k]];
        }

        // @hack for residency permit
        if (options.url === 'wgt/utils/tipologiaPermessoDiSoggiorno') {
          res.enteEmissione = 'QUESTURA';
        }

        return res;
      }), 'value');
    };

    var body = void 0;
    if (options.hasOwnProperty('fields')) {
      body = {};
      options.fields.forEach(function (field) {
        return (0, _keys2.default)(field).forEach(function (key) {
          return components[key] && (body[field[key].fieldName] = components[key].value);
        });
      });
    }
    (0, _api.fetchSelectOptions)(options.url, body).then(function (json) {
      // component.fetchInProgress = false
      // if (component.showLoading) {
      //   dispatch({ type: HIDE_LOADING })
      // }
      if (component.id === 'DOCUMENTO_2-TIPO_DOCUMENTO') {
        var jsonPropertyChange = json.map(function (i) {
          return { label: i.value, value: i.code };
        });
        json = jsonPropertyChange;
      }

      var dataArray = json ? filterDupes(json) : [];
      if (!((component.values || []).length === 0 && dataArray && dataArray.length === 0)) {
        if (component.value && component.value !== '') {
          if (component && component.id && (component.id.toUpperCase() === 'SETTORE_ATTIVITA_AZIENDA-SETTORE' || component.id.toUpperCase() === 'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA')) {
            component.value = !!dataArray.find(function (ow) {
              return ow.value.split("##")[0] === component.value.split("##")[0];
            }) ? dataArray.find(function (ow) {
              return ow.value.split("##")[0] === component.value.split("##")[0];
            }).value : '';
          }
        }
        dispatch({
          type: UPDATE_COMPONENT,
          component: {
            id: component.id,
            value: component.value,
            /* isDisabled: options.init ? component.isDisabled : options.isDisabled, */
            isLoading: false,
            values: json ? filterDupes(json) : [],
            fetchInProgress: false
          }
        });
      } else {
        if (component.id === 'PROFESSIONE_ATTIVITA-PROFESSIONE' || component.id === 'PROFESSIONE_ATTIVITA-ATTIVITA' || component.id === 'PROFESSIONE_ATTIVITA-SETTORE') {
          dispatch({
            type: UPDATE_COMPONENT,
            component: {
              id: component.id,
              value: '',
              /* isDisabled: options.init ? component.isDisabled : options.isDisabled, */
              isLoading: false,
              values: json ? filterDupes(json) : [],
              fetchInProgress: true
            }
          });
        }
      }
    });
  };
};

/**
 * Fills all the address fields guessing their values from the provided zip code
 *
 * @param {Object} componentId      The component that updates other components
 * @return {Function}               Dispatches an UPDATE_COMPONENT action
 */
var autoFillDependantComponents = exports.autoFillDependantComponents = function autoFillDependantComponents(componentId) {
  return function (dispatch, getState) {
    var _getState12 = getState(),
        components = _getState12.components;

    var autofillerComponent = components[componentId];

    if (autofillerComponent.status.indexOf('error') < 0 && !!autofillerComponent.value) {
      if (!!autofillerComponent.autofill.url) {
        var body = {};

        dispatch(updateComponent(autofillerComponent.id, {
          autofill: (0, _extends3.default)({}, autofillerComponent.autofill, { lastRequestId: (0, _uuid2.default)() })
        }, {
          avoidAutofill: true,
          avoidValidation: true
        }));

        autofillerComponent.autofill.mapping.forEach(function (field) {
          if (!field.excludeFromPayload) {
            body[field.key] = components[field.componentId].value;
          }

          dispatch({
            type: AUTOFILL_COMPONENT_START,
            component: {
              id: field.componentId,
              status: (0, _lodash.union)(getState().components[field.componentId].status, ['loading'])
            }
          });
        });

        (0, _api.getAutofillValues)(autofillerComponent.autofill.url, body, autofillerComponent.autofill.lastRequestId).then(function (json) {
          if (json.requestId === autofillerComponent.autofill.lastRequestId) {
            if (json.data && json.data[0]) {
              for (var key in json.data[0]) {
                var _loop4 = function _loop4(field) {
                  if (field.key === key) {
                    var delta = {
                      id: field.componentId,
                      value: json.data[0][key],
                      status: getState().components[field.componentId].status.filter(function (v) {
                        return v !== 'error' && v !== 'loading';
                      }),
                      errorMessage: []
                    };

                    if (key === 'localita') {
                      delta.values = (0, _lodash.uniqBy)(json.data.map(function (o) {
                        return (0, _extends3.default)({}, o, {
                          label: o.localita,
                          value: o.localita
                        });
                      }), 'value');

                      if (delta.values.length > 0) {
                        delta.isDisabled = undefined;
                      }

                      if (delta.values.length > 1) {
                        if (!!delta.values.find(function (v) {
                          return v.value === components[field.componentId].value;
                        })) {
                          delta.value = components[field.componentId].value;
                        } else {
                          delta.value = '';
                        }
                      }
                    }

                    dispatch({
                      type: AUTOFILL_COMPONENT_DONE,
                      component: delta
                    });

                    if (components[field.componentId].hasOwnProperty('notifyComponents') && (0, _keys2.default)(components).map(function (ck) {
                      return getState().components[ck];
                    }).filter(function (c) {
                      return !!c.notifyComponents && c.status.indexOf('loading') > -1;
                    }).length === 0) {
                      dispatch(notifyComponents(components[field.componentId].notifyComponents));
                    }

                    return 'break';
                  }
                };

                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                  for (var _iterator8 = (0, _getIterator3.default)(autofillerComponent.autofill.mapping), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var field = _step8.value;

                    var _ret4 = _loop4(field);

                    if (_ret4 === 'break') break;
                  }
                } catch (err) {
                  _didIteratorError8 = true;
                  _iteratorError8 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                      _iterator8.return();
                    }
                  } finally {
                    if (_didIteratorError8) {
                      throw _iteratorError8;
                    }
                  }
                }
              }
            } else {
              autofillerComponent.autofill.mapping.forEach(function (field) {
                var delta = void 0;

                if (autofillerComponent.id === field.componentId) {
                  delta = {
                    id: field.componentId,
                    status: [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(getState().components[field.componentId].status.filter(function (v) {
                      return v !== 'loading';
                    })), ['error'])))),
                    errorMessage: [autofillerComponent.name + ' non valido']
                  };
                } else {
                  delta = {
                    id: field.componentId,
                    status: getState().components[field.componentId].status.filter(function (v) {
                      return v !== 'loading';
                    })
                  };
                }

                // @hack the value set to null is wanted to avoid typos in cap insertion
                dispatch({
                  type: AUTOFILL_COMPONENT_FAILED,
                  component: delta
                });
              });
            }
          } else {
            dispatch({
              type: AUTOFILL_COMPONENT_DISCARDED,
              component: autofillerComponent
            });
          }
        });
      } else {
        var _loop5 = function _loop5(field) {
          if ((0, _keys2.default)(components).indexOf(field.componentId) > -1 && (0, _keys2.default)(components).indexOf(autofillerComponent.id) > -1) {
            var autofillerOption = autofillerComponent.values.find(function (o) {
              return o[!!field.key ? field.key : 'value'] === autofillerComponent.value;
            });

            if (!!autofillerOption) {
              dispatch({
                type: AUTOFILL_COMPONENT_DONE,
                component: {
                  id: field.componentId,
                  value: autofillerOption[!!field.resKey ? field.resKey : 'value'],
                  status: getState().components[field.componentId].status.filter(function (v) {
                    return v !== 'error' && v !== 'loading';
                  }),
                  errorMessage: []
                }
              });
            }
          }
        };

        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = (0, _getIterator3.default)(autofillerComponent.autofill.mapping), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var field = _step9.value;

            _loop5(field);
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }
    }
  };
};

/**
 * Modifies the component with the updated values
 *
 * @param {string} componentId            The name of the component to update
 * @param {Object} updateBody             An object containing the properties and values to assign to the widget
 * @param {Object} options                Update options
 * @param {Boolean} options.bypassValidation      Allows to bypass the validation process (for view init purposes)
 * @return {Function}                     Dispatches an update widget action
 */
var updateComponent = exports.updateComponent = function updateComponent(componentId, updateBody) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      bypassValidation = _ref6.bypassValidation,
      avoidValidation = _ref6.avoidValidation,
      avoidAutofill = _ref6.avoidAutofill,
      collateral = _ref6.collateral;

  return function (dispatch, getState) {
    if (!getState().components[componentId]) {
      return;
    }
    dispatch({
      type: !collateral ? UPDATE_COMPONENT : SIDE_UPDATE_COMPONENT,
      component: (0, _extends3.default)({}, updateBody, {
        id: componentId,
        dirty: !collateral && getState().components[componentId].value !== updateBody.value && !updateBody.isLoading
      })
    });
    var updatedComponent = getState().components[componentId];

    if (updatedComponent.hasOwnProperty('validations') && !avoidValidation) {
      dispatch(validateComponent(componentId, {
        passTrough: bypassValidation,
        evalBlanks: !!updatedComponent.dirty
      }));
      if (getState().step.number === 5 && getState().product.prodCode === _utils.posProducts.prodAzienda) {
        dispatch((0, _stepActions.updateUserComponent)());
      }
    }

    updatedComponent = getState().components[componentId];

    dispatch(triggerGroupConditions(componentId));

    if (updatedComponent.hasOwnProperty('trigger')) {
      dispatch(triggerDependantComponents(componentId));
      if (getState().step.number === 5 && getState().product.prodCode === _utils.posProducts.prodAzienda) {
        dispatch((0, _stepActions.updateUserComponent)());
      }
    }

    dispatch(fetchData(componentId));

    if (updatedComponent.hasOwnProperty('autofill') && !avoidAutofill) {
      dispatch(autoFillDependantComponents(componentId));
      if (getState().step.number === 5 && getState().product.prodCode === _utils.posProducts.prodAzienda) {
        dispatch((0, _stepActions.updateUserComponent)());
      }
    }

    if (updatedComponent.hasOwnProperty('notifyComponents')) {
      dispatch(notifyComponents(updatedComponent.notifyComponents));
      if (getState().step.number === 5 && getState().product.prodCode === _utils.posProducts.prodAzienda) {
        dispatch((0, _stepActions.updateUserComponent)());
      }
    }

    if (updatedComponent.hasOwnProperty('toggleVisibility') && updatedComponent.value !== undefined && updatedComponent.value !== null && updatedComponent.value !== '') {
      dispatch(toggleVisibility(updatedComponent.toggleVisibility, updatedComponent));

      var _getState13 = getState(),
          widgets = _getState13.widgets,
          _components2 = _getState13.components;

      if (!!_components2['SZ0022-SS0209']) {
        _components2['SZ0022-SS0209'].status[0] = 'hidden';
        dispatch((0, _stepActions.updateUserComponent)());
      }
      if (!!_components2['SZ0011-SS0231']) {
        _components2['SZ0011-SS0231'].status[0] = 'hidden';
        dispatch((0, _stepActions.updateUserComponent)());
      }
      if (getState().step.number === 5 && getState().product.prodCode === _utils.posProducts.prodAzienda) {

        if (!!widgets["TITOLARE_EFFETTIVO"] && !!widgets["TITOLARE_EFFETTIVO"].status && widgets["TITOLARE_EFFETTIVO"].status[0] === 'ignoreValidation' && (!!_components2["TITOLARE_DATA-EFFETTIVO_SI"] && _components2["TITOLARE_DATA-EFFETTIVO_SI"].value !== '' || !!_components2["TITOLARE_DATA-EFFETTIVO_NO"] && _components2["TITOLARE_DATA-EFFETTIVO_NO"].value !== '') && !!_components2 && !!_components2['SZ0025-SS0052_DM0097_RI0022'] && !!_components2['SZ0025-SS0052_DM0097_RI0023'] && !!_components2['SZ0025-SS0163_DM0503_RI0568'] && !!_components2['SZ0025-SS0163_DM0503_RI0569'] && !!_components2['TITOLARE_OWNER-EFFETTIVO_SI'] && !!_components2['TITOLARE_OWNER-EFFETTIVO_NO'] && !!_components2['TITOLARE_OWNER-LABEL'] && !!_components2['SZ0025-SS0163'] && !!_components2['SZ0025-SS0052']) {
          _components2['SZ0025-SS0052_DM0097_RI0022'].status[0] = '';
          _components2['SZ0025-SS0052_DM0097_RI0023'].status[0] = '';
          _components2['SZ0025-SS0163_DM0503_RI0568'].status[0] = '';
          _components2['SZ0025-SS0163_DM0503_RI0569'].status[0] = '';
          _components2['TITOLARE_OWNER-EFFETTIVO_NO'].status[0] = '';
          _components2['TITOLARE_OWNER-EFFETTIVO_NO'].value = 'selected';
          _components2['TITOLARE_OWNER-EFFETTIVO_SI'].status[0] = '';
          _components2['TITOLARE_OWNER-EFFETTIVO_SI'].value = '';
          _components2['TITOLARE_OWNER-LABEL'].status[0] = '';
          _components2['SZ0025-SS0163'].status[0] = '';
          _components2['SZ0025-SS0052'].status[0] = '';
        }
        dispatch((0, _stepActions.updateUserComponent)());
      }
    } else if (updatedComponent.hasOwnProperty('toggleVisibility') && (updatedComponent.linkId || updatedComponent.widgetName || updatedComponent.value === '' && (0, _utils.isNoRadioSelected)(getState().components, componentId) && !updatedComponent.toggleVisibility.show)) {
      dispatch(toggleVisibility(updatedComponent.toggleVisibility, updatedComponent));
      if (getState().step.number === 5 && getState().product.prodCode === _utils.posProducts.prodAzienda) {
        dispatch((0, _stepActions.updateUserComponent)());
      }
    }
    if (updatedComponent.id === 'CELLULARE-NUM_CELLULARE') {
      if (updatedComponent.value === '') {
        updatedComponent.otpbtnDisabled = true;
      } else {
        updatedComponent.otpbtnDisabled = updatedComponent.status.indexOf('error') > -1;
      }
    }
    if (updatedComponent.id === 'SETTORE_ATTIVITA_AZIENDA-SETTORE') {
      // const isNotSelected = !updatedComponent.value
      var componentIdToDisable = 'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA';
      dispatch(updateComponent(componentIdToDisable, {
        // isDisabled: isNotSelected,
        options: (0, _extends3.default)({}, getState().components[componentIdToDisable].options, {
          init: true
        })
      }, { bypassValidation: true }));
    }
    //@hack for residency permit
    if (updatedComponent.id === 'DOCUMENTO_2-TIPO_DOCUMENTO') {
      var isUnlimited = updatedComponent.value === 'CS'; //|| updatedComponent.value === 'RRPS'
      var _componentIdToDisable = 'DOCUMENTO_2-DATA_SCADENZA';
      dispatch(updateComponent(_componentIdToDisable, {
        value: isUnlimited ? '' : getState().components[_componentIdToDisable].value,
        isDisabled: isUnlimited,
        // status: isUnlimited ? ['hidden'] : [],
        statusStyle: isUnlimited ? 'hidden' : '',
        validations: (0, _extends3.default)({}, getState().components[_componentIdToDisable].validations, {
          isRequired: !isUnlimited
        })
      }, { bypassValidation: true }));
    }

    if (updatedComponent.id_ === 'SZ0023SS0048DM0089RI0121' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI1058' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI1059' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI1060' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI1061' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI1056' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI0126' || updatedComponent.id_ === 'SZ0023SS0048DM0089RI0381') {
      var csInfoArr = ['SZ0023-SS0048_DM0089_RI0121',
      //'SZ0023-SS0048_DM0089_RI0122', //Remove component RI0122 begin - end
      'SZ0023-SS0048_DM0089_RI1058', 'SZ0023-SS0048_DM0089_RI1059', 'SZ0023-SS0048_DM0089_RI1060', 'SZ0023-SS0048_DM0089_RI1061', 'SZ0023-SS0048_DM0089_RI1056', 'SZ0023-SS0048_DM0089_RI0126'];

      /*@Hack for Info Legali Step*/
      // if (updatedComponent.id_ === 'SZ0023SS0048DM0089RI0381') {
      //   var isSelected = updatedComponent.value === 'selected'

      //   var csInfoArrBody = {
      //     //validations : {isRequired: true}, //{isRequired: !isSelected},
      //     value: '',
      //     isDisabled: isSelected
      //   }

      //     csInfoArr.forEach(cid => {
      //       dispatch(
      //         updateComponent(
      //           cid,
      //           csInfoArrBody,
      //           { bypassValidation: true }
      //         )
      //       )
      //     })
      //   }  
    }

    /* Informazioni_compagine_societaria */
    var Informazioni_compagine = ['SZ0023-SS0048_DM0089_RI0121', 'SZ0023-SS0048_DM0089_RI1058', 'SZ0023-SS0048_DM0089_RI1059', 'SZ0023-SS0048_DM0089_RI1060', 'SZ0023-SS0048_DM0089_RI1061', 'SZ0023-SS0048_DM0089_RI1056', 'SZ0023-SS0048_DM0089_RI0126', 'SZ0023-SS0048_DM0089_RI0381'];
    var TITOLARE_EFFETTIVO = ['SZ0024-SS0049_DM0094_RI0504', 'SZ0024-SS0049_DM0094_RI0505'];
    if (Informazioni_compagine.indexOf(updatedComponent.id) > -1) {
      var _components3 = getState().components;
      var iCArr = Informazioni_compagine;
      var c1 = _components3[iCArr[0]];
      var c2 = _components3[iCArr[1]];
      //const c3 = components[iCArr[2]] //Remove component RI0122 begin - end
      var csGroup1 = {};
      csGroup1[TITOLARE_EFFETTIVO[0]] = c1.value === 'selected';
      csGroup1[TITOLARE_EFFETTIVO[1]] = !!c1 && !!c1.value && c1.value === 'selected' && !!c2 && !!c2.value && c2.value === 'selected'; //Remove component RI0122 begin - end
      if (csGroup1) {
        var isTitolareEffettivoVisible = (0, _keys2.default)(csGroup1).every(function (k) {
          return csGroup1[k];
        });
        csGroup1['SZ0024-SS0049'] = isTitolareEffettivoVisible;
        csGroup1['SZ0024-SS0049_DM0094'] = isTitolareEffettivoVisible;
        if (isTitolareEffettivoVisible) {
          dispatch((0, _widgetsActions.updateWidget)('SZ0024', { active: false, status: ['hidden'] }));
        } else {
          dispatch((0, _widgetsActions.updateWidget)('SZ0024', { active: true, status: [] }));
        }
      }
      (0, _keys2.default)(csGroup1).forEach(function (k) {
        var isSelected_ = csGroup1[k];
        var status = !!_components3[k] && !!_components3[k].status && _components3[k].status.filter(function (v) {
          return v !== 'hidden';
        });
        dispatch(updateComponent(k, {
          active: !isSelected_,
          status: isSelected_ ? [].concat((0, _toConsumableArray3.default)(status), ['hidden']) : status
        }, { bypassValidation: true }));
      });
    }
    /*  if (updatedComponent.id === 'TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA') {
    }*/
    var TIPO_DOCUMENTO_OPTION = {
      "Carta d'identita": 'DOCUMENTO_2-CARTA_IDENTITA',
      Passaporto: 'DOCUMENTO_2-PASSAPORTO',
      'Patente di guida': 'DOCUMENTO_2-PATENTE'
    };
    if (updatedComponent.id === 'DOCUMENTO-TIPO_DOCUMENTO' && getState().components['DOCUMENTO_2-CARTA_IDENTITA']) {
      var _components4 = getState().components;
      var uC = updatedComponent;
      var isSelected = uC && uC.value;
      var doc2ComponentId = isSelected && TIPO_DOCUMENTO_OPTION[uC.value];
      (0, _values2.default)(TIPO_DOCUMENTO_OPTION).forEach(function (v) {
        var doc2Component = _components4[v];
        if (doc2Component) {
          var isUpdate = false;
          var isDisabled = true;
          if (doc2ComponentId && v === doc2ComponentId) {
            isUpdate = true;
            isDisabled = true;
          } else if (doc2Component.status.indexOf('readonly') > -1) {
            isUpdate = true;
            isDisabled = false;
          }

          if (isUpdate && v) {
            var status = doc2Component.status ? doc2Component.status.filter(function (e) {
              return e !== 'readonly';
            }) : [];
            dispatch(updateComponent(v, {
              value: '',
              status: isDisabled ? [].concat((0, _toConsumableArray3.default)(status), ['readonly']) : status
            }, { bypassValidation: true }));
          }
        }
      });
    }
  };
};

var updateFilePreview = exports.updateFilePreview = function updateFilePreview(component) {
  return function (dispatch, getState) {
    var _getState14 = getState(),
        step = _getState14.step,
        product = _getState14.product,
        components = _getState14.components;

    var token = new _stepActions.ActionToken(component.id + '.updateFilePreview', true);
    // const extraBody = {
    //   type: '',
    //   docRefId: '',
    //   widgetId: '',
    //   docType: ''
    // }
    var extraBody = {};
    if (step.number === 5 && product.partnership === _utils.posProducts.prodAzienda) {
      extraBody = {
        type: '',
        docRefId: '',
        widgetId: '',
        docType: ''
      };
      if (step.widgets_ && step.widgets_.length) {
        var widgets_ = step.widgets_.find(function (w) {
          return w && w.name === 'TITOLARE_EFFETTIVO';
        });
        if (widgets_) {
          extraBody.widgetId = widgets_.code;
        }
      }
      var comp = components['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA'];
      if (comp && comp.rawValue && comp.rawValue.titolare_effettivo[0].documento && comp.rawValue.titolare_effettivo[0].documento.doc_ref_id) {
        extraBody.docRefId = comp.rawValue.titolare_effettivo[0].documento.doc_ref_id;
        extraBody.docType = comp.rawValue.titolare_effettivo[0].documento.doc_type;
        extraBody.type = component.uploadType.startsWith('FRONT') ? 'FRONT' : 'BACK';
      }
    } else if (step.number === 6 && product.partnership === _utils.posProducts.prodAzienda || step.number === 4 && product.partnership === _utils.posProducts.prodPersonaFisica || step.number === 5 && product.partnership === _utils.posProducts.prodDittaInd) {
      extraBody = {
        type: '',
        docRefId: '',
        widgetId: '',
        docType: ''
      };

      var PRODUCT_PLUGIN = step.config && step.config.widget && step.config.widget.PRODUCT_PLUGIN;
      if (PRODUCT_PLUGIN) {
        extraBody.widgetId = PRODUCT_PLUGIN.code;
      }
      extraBody.type = 'FRONT';
    }
    dispatch((0, _stepActions.dealActionToken)(token));
    (0, _api.getFilePreview)(component, extraBody).then(function (url) {
      dispatch(updateComponent(component.id, { value: url }));
      dispatch((0, _stepActions.dealActionToken)((0, _extends3.default)({}, token, { dispose: true })));
    });
  };
};

/**
 * Uploads a file
 * @public
 *
 * @param {Object} component     The uploader component
 * @return {Promise}             promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
var uploadFile = exports.uploadFile = function uploadFile(component, file) {
  return function (dispatch, getState) {
    file = file || {};
    var token = new _stepActions.ActionToken('step.uploadFile', true);
    var extraBody = {};

    var _getState15 = getState(),
        step = _getState15.step,
        product = _getState15.product,
        components = _getState15.components;

    dispatch((0, _stepActions.dealActionToken)(token));
    dispatch(updateComponent(component.id, { isLoading: true }));

    if (step.number === 5 && product.partnership === _utils.posProducts.prodAzienda) {
      extraBody = {
        type: '',
        docRefId: '',
        widgetId: '',
        docType: 'TEDOC'
      };
      extraBody.type = component.uploadType.startsWith('FRONT') ? 'FRONT' : 'BACK';
      var compName = component.name === 'DOCF_UPLOAD' ? 'DOCF_UPLOAD' : 'DOCR_UPLOAD';
      if (compName) {
        var uComp = step.titolareList.filter(function (o) {
          return o.open;
        });
        extraBody.titoComp = uComp;
        var compId = 'DOCUMENTO-' + compName;
        //const compId = 'DOCUMENTO-DOCF_UPLOAD'
        extraBody.compId = compId;
        var ref_id = compId ? //? uComp[0].userComponents['DOCUMENTO-DOCF_UPLOAD'].docRefId
        uComp[0].dcRfId : null;
        extraBody.docRefId = ref_id ? ref_id : '' + Math.floor(Math.random() * 100000000 + 1);
      }

      if (step.widgets_ && step.widgets_.length) {
        var widgets_ = step.widgets_.find(function (w) {
          return w && w.name === 'TITOLARE_EFFETTIVO';
        });
        if (widgets_) {
          extraBody.widgetId = widgets_.code;
        }
      }
    }
    if (step.number === 6 && product.partnership === _utils.posProducts.prodAzienda || step.number === 4 && product.partnership === _utils.posProducts.prodPersonaFisica || step.number === 5 && product.partnership === _utils.posProducts.prodDittaInd) {
      extraBody = {
        type: 'FRONT',
        widgetId: '',
        docType: 'POS_EN'
      };
      extraBody.docRefId = component.sectionId + '##' + component.fieldId;
      var PRODUCT_PLUGIN = step.config && step.config.widget && step.config.widget.PRODUCT_PLUGIN;
      if (PRODUCT_PLUGIN) {
        extraBody.widgetId = PRODUCT_PLUGIN.code;
      }
    }
    //Changes for loading new widget
    if (step.number === 6 && product.partnership === _utils.posProducts.prodDittaInd && component.id === 'DOCUMENTO_GENERICO-DOC_UPLOAD') {
      extraBody = {
        type: 'FRONT_DOC_',
        widgetId: ''
      };
      if (step.widgets_ && step.widgets_.length) {
        var _widgets_ = step.widgets_.find(function (w) {
          return w && w.name === 'DOCUMENTO_GENERICO';
        });
        if (_widgets_) {
          extraBody.widgetId = _widgets_.code;
        }
      }
    }
    return (0, _api.uploadFile)(file, component.value, component.uploadType, component.guid, // only present in re-upload
    component.barCode, // only present in re-upload
    extraBody //only present for titolare_effective step
    ).then(function (json) {
      if (json.status === 'success') {
        if (!!component.guid && !!component.barCode) {
          dispatch(updateComponent(component.id, {
            value: component.value,
            isLoading: false
          }));
          dispatch((0, _stepActions.dealActionToken)((0, _extends3.default)({}, token, { dispose: true })));
        } else {
          (0, _api.getFilePreview)(component, extraBody).then(function (url) {
            if (step.number === 5 && product.partnership === _utils.posProducts.prodAzienda && !!extraBody.compId) {
              step.titolareList.map(function (u) {
                if (u.id === extraBody.titoComp[0].id) {
                  u.userComponents[extraBody.compId].value = component.value || url;
                  u.userComponents[extraBody.compId].isLoading = false;
                  u.userComponents[extraBody.compId].docRefId = extraBody.docRefId;
                  u.userComponents[extraBody.compId].fileName = file.name;
                  u.dcRfId = extraBody.docRefId;
                }
                step.titolareList[u.id] = u;
              });
              dispatch((0, _stepActions.updateTitolareList)(step.titolareList));
              dispatch(updateComponent(component.id, {
                value: file.type === 'application/pdf' ? _utils.CONTEXT_ROOT + '/assets/images/upload_pdf_doc.png' : component.value || url,
                isLoading: false,
                docRefId: extraBody.docRefId,
                fileName: file.name
              }));
            } else {
              dispatch(updateComponent(component.id, {
                value: file.type === 'application/pdf' ? _utils.CONTEXT_ROOT + '/assets/images/upload_pdf_doc.png' : component.value || url,
                isLoading: false,
                docRefId: extraBody.docRefId,
                fileName: file.name
              }));
            }

            dispatch((0, _stepActions.dealActionToken)((0, _extends3.default)({}, token, { dispose: true })));
          });
        }
      } else throw json;
    }).catch(function (json) {
      dispatch(updateComponent(component.id, {
        value: '',
        errorMessage: json.message,
        status: (0, _lodash.union)(component.status, [json.status]),
        isLoading: false
      }, { avoidValidation: true }));
      dispatch((0, _stepActions.dealActionToken)((0, _extends3.default)({}, token, { dispose: true })));
      // dispatch(handleServerErrors(json))
    });
  };
};
/**
 * Sends an OTP to the provided email
 * @public
 * @param  {Object} component    the component containing the email to verify
 * @return {Promise}             otp delivery promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
var sendEmailOtp = exports.sendEmailOtp = function sendEmailOtp(component) {
  return function () /*dispatch*/{
    return sendOtp('EMAIL', component.value);
  };
};

/**
 * Sends an OTP to the provided mobile
 * @public
 * @param  {Object} component    the component containing the mobile to verify
 * @return {Promise}             otp delivery promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
var sendSmsOtp = exports.sendSmsOtp = function sendSmsOtp(component) {
  return function () /*dispatch*/{
    return sendOtp('MOBILE', component.value);
  };
};

var tweakAgreement = exports.tweakAgreement = function tweakAgreement(_ref7) {
  var widget = _ref7.widget,
      force = _ref7.force,
      hide = _ref7.hide,
      _ref7$forceValue = _ref7.forceValue,
      forceValue = _ref7$forceValue === undefined ? 'selected' : _ref7$forceValue,
      description = _ref7.description;
  return function (dispatch, getState) {
    var _getState16 = getState(),
        components = _getState16.components;

    if (!!hide) {
      dispatch((0, _widgetsActions.updateWidget)(widget.name, { status: ['hidden'] }));
    }
    var ck = widget.name + '-VISIONE';
    if (components[ck].status.indexOf('selected') > -1 || !!force) {
      dispatch(updateComponent(ck, {
        value: !!force ? forceValue : 'selected',
        description: !!description ? description : components[ck].description
      }, { bypassValidation: true }));
    }
  };
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxWidth = undefined;

var _breakpoints = __webpack_require__(1120);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (breakpoint) {
  return "@media screen and (min-width: " + _breakpoints2.default[breakpoint] + ")";
};

var maxWidth = exports.maxWidth = function maxWidth(breakpoint) {
  return "@media (max-width: " + _breakpoints.maxWidthBreakpoint[breakpoint] + ")";
};

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _parsers = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var inputWidth = {
    default: '' + (0, _parsers.number)(spacings.default) * 42 + (0, _parsers.unit)(spacings.default),
    x2: '' + (0, _parsers.number)(spacings.default) * 42 * 2 + (0, _parsers.unit)(spacings.default)
  };

  var keyframes = {
    blink: {
      to: {
        borderBottom: '2px solid ' + colors.input.border.default
      }
    }
  };

  var styles = {
    component: (0, _defineProperty3.default)({
      position: 'relative',
      display: 'inline-block',
      width: '100%',
      padding: spacings.x2 + ' ' + spacings.default + ' ' + spacings.default,
      margin: spacings.x2 + ' 0 ' + spacings.x2 + ' 0',

      ':nth-child(odd)': {
        marginLeft: '0'
      },

      ':nth-child(even)': {
        marginRight: '0'
      }

    }, (0, _breakTo2.default)('small'), {
      width: inputWidth.default,
      //margin: `${spacings.x4} ${spacings.x2} ${spacings.x4} 0`,

      ':nth-child(even) + :last-child': {
        width: '100%',
        maxWidth: '' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) + (0, _parsers.unit)(inputWidth.default),
        marginRight: '0'
      },

      ':only-child': {
        width: '100%',
        maxWidth: '' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) + (0, _parsers.unit)(inputWidth.default),
        marginRight: '0'
      }
    }),

    'component--block': {
      maxWidth: (0, _parsers.important)('' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) + (0, _parsers.unit)(inputWidth.default)),
      width: (0, _parsers.important)('100%'),
      marginRight: (0, _parsers.important)('0')
    },

    'component--third': (0, _defineProperty3.default)({
      maxWidth: '' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) + (0, _parsers.unit)(inputWidth.default),
      width: '100%',
      marginRight: '0'

    }, (0, _breakTo2.default)('small'), {
      width: '' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) / 3 + (0, _parsers.unit)(inputWidth.default),
      marginRight: '0'
    }),

    'component--hidden': {
      display: 'none'
    },

    'component--bare': {
      margin: '0',
      padding: '0',

      ':nth-child(odd)': {
        marginRight: spacings.x2
      }
    },

    label: {
      fontSize: '1.125rem',
      fontWeight: fontWeights.label.default,

      position: 'absolute',

      display: 'none',
      visibility: 'hidden',

      color: colors.label.default
    },

    'label--active': {
      fontSize: '.75rem',

      top: '0',

      display: 'block',
      visibility: 'visible'
    },

    'label--required': {
      color: colors.common.utility.error.default
    },

    'label--error': {
      color: colors.common.utility.error.default
    },

    'label--neutral': {
      color: (0, _parsers.important)(colors.common.body.bg.default)
    },

    option: {
      color: colors.input.text.default
    },

    input: {
      fontFamily: fontFamilies.default,
      fontWeight: fontWeights.input.default,
      fontSize: fontSizes.input.default,
      textIndent: fontSizes.input.textIndent,
      lineHeight: fontSizes.input.lineHeight,

      boxSizing: 'border-box',
      width: '100%',
      paddingTop: spacings.input.padding.top.default,
      paddingLeft: '.3rem',
      paddingBottom: '.5rem',
      backgroundColor: colors.input.bg.default,
      borderRadius: '0',
      borderTop: '0',
      borderRight: '0',
      borderBottom: '2px solid ' + colors.input.border.default,
      borderLeft: '0',
      borderImageSource: 'initial',
      borderImageSlice: 'initial',
      borderImageWidth: 'initial',
      borderImageOutset: 'initial',
      borderImageRepeat: 'initial',

      color: colors.input.text.default,

      ':disabled': {
        color: colors.input.text.disabled,
        backgroundColor: colors.input.bg.default,
        // borderBottom: `2px solid ${colors.input.border.default}`,
        // paddingLeft: 0,
        backgroundImage: 'none',
        cursor: 'not-allowed'
      },

      ':disabled + span': {
        color: colors.label.disabled
      },

      '::input-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },

      '::-webkit-input-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },
      '::-moz-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },
      /* firefox 19+ */
      ':-ms-input-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },
      /* ie */
      ':-moz-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },

      ':active': {
        borderBottom: '2px solid ' + colors.input.border.active,
        outline: 'none'
      },

      ':focus': {
        borderBottom: '2px solid ' + colors.input.border.active,
        outline: 'none'
      }
    },

    'input--focused': {
      borderBottom: '2px solid ' + colors.input.border.active
    },

    'input--invalid': {
      borderBottom: '2px solid ' + colors.common.utility.error.default,

      ':not(:active) ~ span': {
        color: colors.common.utility.error.default
      },

      ':active ~ span': {
        color: colors.label.default
      },

      ':active ~ small': {
        display: 'none'
      },

      ':focus ~ span': {
        color: colors.label.default
      },
      ':focus ~ small': {
        display: 'none'
      }
    },

    'input--select': {
      background: images.selectTriangle
    },

    'input--unset': {
      color: (0, _parsers.important)(colors.input.placeholder.default)
    },

    'input--blink': {
      animationName: keyframes.blink,
      animationDuration: '1s',
      animationTimingFunction: 'steps(5, start)',
      animationIterationCount: 'infinite',

      borderBottom: '2px solid ' + colors.input.border.blink,
      outline: 'none'
    },

    'error-msg': {
      position: 'absolute',

      display: 'block',

      marginTop: spacings.default,

      fontSize: '.75rem',
      fontWeight: fontWeights.input.error,

      color: colors.common.utility.error.default
    },
    hint: {
      position: 'absolute',

      display: 'block',

      marginTop: spacings.default,

      fontSize: '.75rem',
      fontWeight: fontWeights.input.error,

      color: (0, _parsers.important)(colors.common.body.text.default)
    },
    singleField: {
      width: '100%!important',
      maxWidth: '' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) + (0, _parsers.unit)(inputWidth.default),
      marginRight: '0'
    },
    divPrefix: {
      width: '20%!important',
      maxWidth: '' + ((0, _parsers.number)(inputWidth.x2) + (0, _parsers.number)(spacings.x2)) + (0, _parsers.unit)(inputWidth.default),
      marginRight: '0',
      verticalAlign: 'top',
      marginTop: '58px'
    }
  };

  return styles;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = exports.PatrimonioCheckBoxesIds = exports.Patrimonio_CheckBoxes = exports.Patrimonio_RadioButtons = exports.Patrimonio_CheckBoxes_RBG10 = exports.Patrimonio_CheckBoxes_RBG9 = exports.Patrimonio_CheckBoxes_RBG8 = exports.Patrimonio_CheckBoxes_RBG7 = exports.Patrimonio_CheckBoxes_RBG6 = exports.Patrimonio_CheckBoxes_RBG5 = exports.Patrimonio_CheckBoxes_RBG4 = exports.Patrimonio_CheckBoxes_RBG3 = exports.Patrimonio_CheckBoxes_RBG2 = exports.Patrimonio_CheckBoxes_RBG1 = exports.showAlert = exports.hideAlert = exports.updateTitolareList = exports.showAPIAlertModel = exports.disableBtn = exports.enableBtn = exports.hideLoading = exports.showLoading = exports.hideWebcamModal = exports.showAddressModal = exports.hideAddressModal = exports.showWebcamModal = exports.deleteTitolareUser = exports.updateDiFarmaComponent = exports.getPdfAnchorTag = exports.downloadPdf = exports.getContractList = exports.digitalSignCheckCall = exports.updateUserComponent = exports.addTitolareUser = exports.getPrevTitolareUser = exports.addTitolareUserToObject = exports.buildTitolareRequest = exports.buildPersonalizzaPOSRequest = exports.modifyPrivacyFabrick = exports.buildSavePg = exports.acknowledgeContract = exports.thanks = exports.hideModal = exports.getPrevStep = exports.getNextStep = exports.removeFabrickPrivacy = exports.urlParam = exports.GetPOSPlan = exports.validateResumeOtp = exports.completeReupload = exports.initReuploadProcess = exports.resumeContactProcess = exports.resumeProcess = exports.initResumeProcess = exports.initRecoveryProcess = exports.getContracts = exports.requireResumeOtpSms = exports.getUserRequests = exports.startProcess = exports.stepCallback = exports.stepCallbackSteps = exports.sendResumeOtpSms = exports.logout = exports.authStep = exports.updateAuthStep = exports.unauthenticated = exports.authenticated = exports.toggleLoginForm = exports.dealActionToken = exports.ActionToken = exports.SHOW_API_ALERT_MODAL = exports.UPDATE_COMPONENT = exports.SET_TITOLARE_LIST = exports.DISABLE_BUTTON = exports.ENABLE_BUTTON = exports.USER_COUNTER = exports.HIDE_LOADING = exports.SHOW_LOADING = exports.PUSH_ANALYTICS = exports.SET_CONTRACT_LIST = exports.SET_REQUEST_LIST = exports.SET_CONTACT_INFO = exports.SET_IS_PARENT = exports.SET_IS_UNDERAGE = exports.ACCEPTED_INVITATION = exports.HIDE_WEBCAM_MODAL = exports.SHOW_WEBCAM_MODAL = exports.HIDE_ADDRESS_MODAL = exports.SHOW_ADDRESS_MODAL = exports.UPDATE_STEP = exports.UPDATE_AUTH_STEP = exports.TOGGLE_LOGIN_FORM = exports.HANDLE_SERVER_ERRORS = exports.DEAL_ACTION_TOKEN = undefined;

var _values = __webpack_require__(263);

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(261);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(264);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(511);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _create = __webpack_require__(468);

var _create2 = _interopRequireDefault(_create);

var _assign = __webpack_require__(227);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(4);

var _extends5 = _interopRequireDefault(_extends4);

var _store = __webpack_require__(506);

var _store2 = _interopRequireDefault(_store);

var _api = __webpack_require__(45);

var API = _interopRequireWildcard(_api);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _qs = __webpack_require__(124);

var _qs2 = _interopRequireDefault(_qs);

var _utils = __webpack_require__(12);

var _normalizr = __webpack_require__(224);

var _lodash = __webpack_require__(96);

var _uuid = __webpack_require__(170);

var _uuid2 = _interopRequireDefault(_uuid);

var _schema = __webpack_require__(1092);

var _productActions = __webpack_require__(510);

var _widgetsActions = __webpack_require__(136);

var _addressStatic = __webpack_require__(525);

var _promoCodeStatic = __webpack_require__(526);

var _posPlanStatic = __webpack_require__(1093);

var _privacyfabrick = __webpack_require__(1094);

var _componentsActions = __webpack_require__(19);

var _stateExtension = __webpack_require__(95);

var Model = _interopRequireWildcard(_stateExtension);

var _titolareStatic = __webpack_require__(527);

var TitolareStatic = _interopRequireWildcard(_titolareStatic);

var _firmeStatic = __webpack_require__(1095);

var FirmeStatic = _interopRequireWildcard(_firmeStatic);

var _api2 = __webpack_require__(45);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = new _mobileDetect2.default(window.navigator.userAgent);

/**
 * Actions you can make on steps
 * @module  {Actions} stepActions
 */
var DEAL_ACTION_TOKEN = exports.DEAL_ACTION_TOKEN = '@@step/DEAL_ACTION_TOKEN';
var HANDLE_SERVER_ERRORS = exports.HANDLE_SERVER_ERRORS = '@@step/HANDLE_SERVER_ERRORS';
var TOGGLE_LOGIN_FORM = exports.TOGGLE_LOGIN_FORM = '@@step/TOGGLE_LOGIN_FORM';
var UPDATE_AUTH_STEP = exports.UPDATE_AUTH_STEP = '@@step/UPDATE_AUTH_STEP';
var UPDATE_STEP = exports.UPDATE_STEP = '@@step/UPDATE';
var SHOW_ADDRESS_MODAL = exports.SHOW_ADDRESS_MODAL = '@@step/SHOW_ADDRESS_MODAL';
var HIDE_ADDRESS_MODAL = exports.HIDE_ADDRESS_MODAL = '@@step/HIDE_ADDRESS_MODAL';
var SHOW_WEBCAM_MODAL = exports.SHOW_WEBCAM_MODAL = '@@step/SHOW_WEBCAM_MODAL';
var HIDE_WEBCAM_MODAL = exports.HIDE_WEBCAM_MODAL = '@@step/HIDE_WEBCAM_MODAL';
var ACCEPTED_INVITATION = exports.ACCEPTED_INVITATION = '@@step/ACCEPTED_INVITATION';
var SET_IS_UNDERAGE = exports.SET_IS_UNDERAGE = '@@step/SET_IS_UNDERAGE';
var SET_IS_PARENT = exports.SET_IS_PARENT = '@@step/SET_IS_PARENT';
var SET_CONTACT_INFO = exports.SET_CONTACT_INFO = '@@step/SET_CONTACT_INFO';
var SET_REQUEST_LIST = exports.SET_REQUEST_LIST = '@@step/SET_REQUEST_LIST';
var SET_CONTRACT_LIST = exports.SET_CONTRACT_LIST = '@@step/SET_CONTRACT_LIST';
var PUSH_ANALYTICS = exports.PUSH_ANALYTICS = '@@step/PUSH_ANALYTICS';
var SHOW_LOADING = exports.SHOW_LOADING = '@@components/SHOW_LOADING';
var HIDE_LOADING = exports.HIDE_LOADING = '@@components/HIDE_LOADING';
var USER_COUNTER = exports.USER_COUNTER = '@@components/USER_COUNTER';
var ENABLE_BUTTON = exports.ENABLE_BUTTON = '@@step/ENABLE_BUTTON';
var DISABLE_BUTTON = exports.DISABLE_BUTTON = '@@step/DISABLE_BUTTON';
var SET_TITOLARE_LIST = exports.SET_TITOLARE_LIST = '@@step/SET_TITOLARE_LIST';
var UPDATE_COMPONENT = exports.UPDATE_COMPONENT = '@@components/UPDATE';
var SHOW_API_ALERT_MODAL = exports.SHOW_API_ALERT_MODAL = '@@step/SHOW_API_ALERT_MODAL';

/**
 * The API root
 * @private
 */
var API_ROOT = "https://www.sella.it/onboarding";

var getStoredState = function getStoredState() {
  var proto = {
    setAuth: function setAuth(authenticated) {
      if (authenticated === undefined) throw new Error('missing required argument: authenticated');

      _store2.default.set('hype-signup', (0, _extends5.default)({}, this, { authenticated: authenticated }));
    },
    updateSession: function updateSession(contactId, stepNumber, isParent) {
      var reachedStepKey = !!isParent ? 'parentReachedStep' : 'reachedStep';

      if (!!contactId && (!this.sessions[contactId] || (this.sessions[contactId][reachedStepKey] || 0) < stepNumber)) {
        _store2.default.set('hype-signup', (0, _extends5.default)({}, this, {
          sessions: (0, _extends5.default)({}, this.sessions, (0, _defineProperty3.default)({}, contactId, (0, _extends5.default)({}, this.sessions[contactId] || {}, (0, _defineProperty3.default)({}, reachedStepKey, stepNumber))))
        }));
      }
    },
    getSessionStep: function getSessionStep(contactId, isParent) {
      var reachedStepKey = !!isParent ? 'parentReachedStep' : 'reachedStep';
      return this.sessions[contactId] && this.sessions[contactId][reachedStepKey] || 0;
    }
  };

  var storedState = _store2.default.get('hype-signup') || {
    authenticated: false,
    sessions: {}
  };

  return (0, _assign2.default)((0, _create2.default)(proto), storedState);
};

var rewriteRoute = function rewriteRoute(baseQs) {
  return function (dispatch, getState) {
    var _getState = getState(),
        step = _getState.step,
        routing = _getState.routing,
        product = _getState.product,
        components = _getState.components;

    if (!!product && !!product.partnership) {
      //@remarks necessary while changing flow in-step (eg: ADECCO promo code)
      routing.flow = product.flow;
      routing.partnership = product.partnership;
      routing.convention = product.convention;
    }

    if (!routing.partnership) return;

    var routePath = '/' + routing.container + '/' + routing.flow + (routing.argument ? '/' + routing.argument : '');

    var underageQs = '?';

    if (!!step.number) {
      if ((0, _utils.isValidStep)(step.number, product)) {
        routePath = '/request/' + routing.flow + '/' + (0, _utils.getStepSlug)(step, product);
        underageQs = (0, _utils.getUnderageQueryString)(step);
      } else {
        if (!!components['THANKS-RESUME_INTEST_2'] && !!components['THANKS-RESUME_INTEST_2'].value) {
          routePath = '/thanks/' + routing.flow + '/' + components['THANKS-RESUME_INTEST_2'].value;
        } else {
          routePath = '/thanks/' + routing.flow;
        }
      }
    } else {
      return;
    }

    var newQs = _qs2.default.stringify((0, _extends5.default)({}, _qs2.default.parse(baseQs || '', { ignoreQueryPrefix: true }), _qs2.default.parse(underageQs, { ignoreQueryPrefix: true })), { addQueryPrefix: true });

    if (routing.locationBeforeTransitions.pathname !== routePath || routing.locationBeforeTransitions.search.indexOf(newQs.replace('?', '')) < 0) {
      (0, _utils.pushRoute)(routePath + newQs, true, routing.partnership === 'HYPE4TIM' ? ['code', 'state'] : []);
    }
  };
};

var pushAnalytics = function pushAnalytics() {
  return function (dispatch) {
    dispatch({ type: PUSH_ANALYTICS });
  };
};

var updateStep = function updateStep(step) {
  return function (dispatch /*, getState*/) {
    dispatch({
      type: UPDATE_STEP,
      step: step
    });
  };
};

/*#Removed4POS*/
/*const setContactInfo = contact => (dispatch) => {
  dispatch({
    type: SET_CONTACT_INFO,
    contact
  })
}
*/
var ActionToken = exports.ActionToken = function ActionToken(actionName, notBlocking) {
  return { id: (0, _uuid2.default)(), actionName: actionName, blocking: !notBlocking };
};

/**
 * Toggles a step loader tracing the caller
 * @param  {Object}     token            The token containing the action initiator and the disposable flag
 * @return {Function}                    unknown
 */
var dealActionToken = exports.dealActionToken = function dealActionToken(token) {
  return function (dispatch /*, getState*/) {
    dispatch({ type: DEAL_ACTION_TOKEN, token: token });
  };
};

/**
 * Handle errors generated by API calls
 *
 * @param  {Object} json      The response json
 * @return {Function}         Dispatches an HANDLE_SERVER_ERRORS action
 */
var handleServerErrors = function handleServerErrors(json) {
  return function (dispatch) {
    if (json && json.status !== 'success') {
      var errorsMap = {
        'Unable to find required metadata: abi, template, code': 'Per proseguire è necessario inserire il codice OTP',
        'Item not found!': 'La pratica richiesta non è stata trovata.',
        'Invalid OTP': 'Il codice OTP inserito non è valido.',
        'Non sono state trovate pratiche associate ai dati inseriti.': 'Non sono state trovate pratiche associate ai dati inseriti.',
        "Attenzione, le credenziali inserite non si riferiscono all'intestatario della richiesta. Non e' possibile proseguire.": "Le credenziali inserite non si riferiscono all'intestatario della richiesta.<br>Non è possibile proseguire.",
        "The parameters 'cf', 'mail', 'prefCell' and 'numCell' are mandatory.": 'I campi "Codice Fiscale", "Email" e "Numero Cellulare" sono obbligatori',
        'tim-unauthorized': '\n        <div>\n          Autenticazione scaduta o non valida.<br/>\n          <a href="' + json.redirectUri + '" >Torna a TIM MobileConnect</a> per riprovare.\n        </div>\n        ',
        'OTP exhausted': '<div>\n          Numero consentito di OTP erogabili per la pratica superato.<br/>\n          Creare una nuova pratica.\n        </div>',
        'OTP expired': '<div>\n            Codice OTP scaduto.<br/>\n            Richiedi un nuovo codice cliccando sul pulsante Reinvia OTP o ricaricando la pagina.\n          </div>'
      };

      var message = errorsMap[json.message];

      if (json.status === 'error' || json.status === 'bad_request') {
        message = message || 'Si è verificato un errore imprevisto. Riprova più tardi.';
      } else if (json.status === 'unauthorized' || json.status === 'invalid_login') {
        message = message || 'Operazione non permessa.';
      } else if (json.status === 'not_found') {
        message = message || 'La risorsa richiesta non esiste.';
      } else {
        message = message || 'Si è verificato un errore imprevisto. Riprova più tardi.';
      }

      dispatch({
        type: HANDLE_SERVER_ERRORS,
        hasServerErrors: true,
        serverErrorStatus: json.status,
        serverErrorMessage: message
      });
    }
  };
};

/**
 * Shows the login form
 * @public
 *
 * @param {Boolean} visibility  The visibility flag
 * @return {Function}           Dispatches an HANDLE_SERVER_ERRORS action
 */
var toggleLoginForm = exports.toggleLoginForm = function toggleLoginForm(visibility) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        widgets = _getState2.widgets,
        step = _getState2.step,
        product = _getState2.product;

    if (!!widgets.LOGIN_SE_CLIENTE && !visibility) {
      dispatch((0, _widgetsActions.updateWidget)('LOGIN_SE_CLIENTE', { status: ['hidden'] }));
    }

    dispatch({ type: TOGGLE_LOGIN_FORM, loginFormVisible: !!visibility });
    (0, _utils.pushRoute)('/request/' + product.flow + '/' + (!!visibility ? 'auth' : (0, _utils.getStepSlug)(step, product)), true);
  };
};

/**
 * Hides the login form and
 * @public
 *
 * @return {Function}           Dispatches an HANDLE_SERVER_ERRORS action
 */
var authenticated = exports.authenticated = function authenticated() {
  return function (dispatch) {
    getStoredState().setAuth(true);
    dispatch(toggleLoginForm(false));
  };
};

var unauthenticated = exports.unauthenticated = function unauthenticated(token) {
  return function (dispatch) {
    getStoredState().setAuth(false);
    dispatch(updateAuthStep());
    if (!!token) {
      dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
    }
  };
};

var updateAuthStep = exports.updateAuthStep = function updateAuthStep(auth) {
  return function (dispatch) {
    dispatch({ type: UPDATE_AUTH_STEP, auth: auth });
  };
};

var authStep = exports.authStep = function authStep(body) {
  return function (dispatch) {
    var token = new ActionToken('step.authStep');

    dispatch(dealActionToken(token));

    if (!!body.callbacks) {
      var userNameCallback = body.callbacks.find(function (c) {
        return c.type === 'NameCallback' && c.output[0].value === 'USER_CODE';
      });
      if (!!userNameCallback) {
        userNameCallback.input[0].value = (0, _utils.padNum)(userNameCallback.input[0].value, 8);
      }
    }

    API.auth(body).then(function (json) {
      dispatch(updateAuthStep(json));
      dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
    }).catch(function (json) {
      dispatch(updateAuthStep(json));
      dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
    });
  };
};

var logout = exports.logout = function logout() {
  return function (dispatch) {
    var token = new ActionToken('step.logout');

    dispatch(dealActionToken(token));

    API.unauth().then(function () /*json*/{
      dispatch(unauthenticated(token));
    }).catch(function () /*json*/{
      //@remarks this will always fail even if the response is 200
      //because it won't return any json
      dispatch(unauthenticated(token));
    });
  };
};

/**
 * Updates the state specifying if the contractor is underage
 *
 * @param  {string} codiceFiscale    The Codice Fiscale
 * @return {Function}                Dispatches a SET_IS_UNDERAGE action
 */
/*#Removed4POS*/
/*const setIsUnderage = codiceFiscale => (dispatch) => {
  dispatch({
    type: SET_IS_UNDERAGE,
    isUnderage: !cfBelongsToAdult(codiceFiscale)
  })
}
*/
var setIsParent = function setIsParent() {
  return function (dispatch, getState) {
    if (!!getState().step.isUnderage) {
      dispatch({ type: SET_IS_UNDERAGE, isUnderage: false });
    }

    dispatch({ type: SET_IS_PARENT, isParent: true });

    getStoredState().updateSession(getState().step.contactId, getState().step.number, true);
  };
};

/**
 * Invitation Callback
 * @param  {Object} token The ActionToken
 * @param  {Object} json  The invitation object
 * @return {null}         nothing
 */
/*#Removed4POS*/
/*const invitationCallback = (token, json) => (dispatch, getState) => {
  if (json.status === 'success') {
    const { step } = getState()

    dispatch(
      setContactInfo({
        codiceFiscale: json.data.codiceFiscale,
        email: json.data.email,
        phoneNumber: json.data.phoneNumber
      })
    )

    if (step.isUnderage === null && !!json.data.codiceFiscale) {
      dispatch(setIsUnderage(json.data.codiceFiscale))
    }

    return API.getInvitations(step.contactId).then(jsonArrWrapper => {
      if (
        uniqBy(jsonArrWrapper.data, 'codiceFiscale').length >= 2 &&
        !step.isParent
      ) {
        dispatch(setIsParent())
      }
      dispatch(dealActionToken({ ...token, dispose: true }))
      return { ...jsonArrWrapper, lastData: json.data }
    })
  }
}*/

/**
 * Decrypts third party data using the hype key
 * @param {Object} proof           The encrypted third party data container
 * @return {Promise}               Promise
 */
/*#Removed4POS*/
/*const decryptHypeProof = proof => (dispatch, getState) => {
  const { components } = getState()

  if (
    !!components['SIGNALER-REFERRER'] &&
    !components['SIGNALER-REFERRER'].value
  ) {
    dispatch(updateComponent('SIGNALER-REFERRER', { value: proof.value }))
  }
}*/

/**
 * Populates the SIGNALER-CAMPAIGN_URL component with the campaign querystring
 *
 * @param {string} campaignQs           The campaign querystring
 * @return {undefined}                    undefined
 */
/*#Removed4POS*/
/*const updateCampaignUrl = campaignQs => (dispatch, getState) => {
  const { components } = getState()

  if (
    !!components['SIGNALER-CAMPAIGN_URL'] &&
    !components['SIGNALER-CAMPAIGN_URL'].value
  ) {
    dispatch(updateComponent('SIGNALER-CAMPAIGN_URL', { value: campaignQs }))
  }
}*/

/**
 * Populates the SIGNALER-PROMO_CODE component with the promoCode querystring value
 *
 * @param {string} promoCode              The promo code
 * @param {boolean} locked                 The readonly flag
 * @return {undefined}                    undefined
 */
/*#Removed4POS*/
/*const updatePromoCode = (promoCode, locked) => (dispatch, getState) => {
  const { components } = getState()

  if (
    !!components['SIGNALER-PROMO_CODE'] &&
    !components['SIGNALER-PROMO_CODE'].value
  ) {
    dispatch(updateComponent('SIGNALER-HAS_PROMO_CODE_NO', { value: '' }))
    dispatch(
      updateComponent('SIGNALER-HAS_PROMO_CODE_YES', { value: 'selected' })
    )
    dispatch(
      updateComponent('SIGNALER-PROMO_CODE', {
        value: promoCode,
        status: !!locked
          ? [
              ...new Set([
                ...components['SIGNALER-PROMO_CODE'].status,
                'readonly'
              ])
            ]
          : components['SIGNALER-PROMO_CODE'].status.filter(
              s => s !== 'readonly'
            )
      })
    )
  }
}*/

/**
 * Decrypts third party data using the yoox key
 * @param {Object} proof           The encrypted third party data container
 * @return {Promise}               Promise
 */
/*#Removed4POS*/
/*const decryptYooxProof = proof => (dispatch, getState) => {
  const token = new ActionToken('step.decryptYooxProof')

  const { step, components } = getState()

  dispatch(dealActionToken(token))

  return API.decryptYooxProof(proof).then(json => {
    switch (step.number) {
      case 1:
        if (
          !!components['JOLLY-JOLLY_INPUT'] &&
          !components['JOLLY-JOLLY_INPUT'].value
        ) {
          dispatch(
            updateComponent('JOLLY-JOLLY_INPUT', { value: json.data.idyoox })
          )
        }

        if (
          !!components['NOME_COGNOME-NOME'] &&
          !components['NOME_COGNOME-NOME'].value
        ) {
          dispatch(
            updateComponent('NOME_COGNOME-NOME', { value: json.data.name })
          )
        }

        if (
          !!components['NOME_COGNOME-COGNOME'] &&
          !components['NOME_COGNOME-COGNOME'].value
        ) {
          dispatch(
            updateComponent('NOME_COGNOME-COGNOME', {
              value: json.data.surname
            })
          )
        }

        if (
          !!components['CODICE_FISCALE-CF'] &&
          !components['CODICE_FISCALE-CF'].value
        ) {
          dispatch(
            updateComponent('CODICE_FISCALE-CF', { value: json.data.cf })
          )
        }

        if (
          !!components['CELLULARE-NUM_CELLULARE'] &&
          !components['CELLULARE-NUM_CELLULARE'].value
        ) {
          dispatch(
            updateComponent('CELLULARE-NUM_CELLULARE', {
              value: json.data.mobile
            })
          )
        }

        if (
          !!components['CELLULARE-CONFERMA_NUM_CELLULARE'] &&
          !components['CELLULARE-CONFERMA_NUM_CELLULARE'].value
        ) {
          dispatch(
            updateComponent('CELLULARE-CONFERMA_NUM_CELLULARE', {
              value: json.data.mobile
            })
          )
        }

        if (!!components['EMAIL-EMAIL'] && !components['EMAIL-EMAIL'].value) {
          dispatch(updateComponent('EMAIL-EMAIL', { value: json.data.mail }))
        }

        if (
          !!components['EMAIL-CONFERMA_EMAIL'] &&
          !components['EMAIL-CONFERMA_EMAIL'].value
        ) {
          dispatch(
            updateComponent('EMAIL-CONFERMA_EMAIL', { value: json.data.mail })
          )
        }

        break
      case 2:
        if (
          !!components['RESIDENZA-PROVINCIA'] &&
          !components['RESIDENZA-PROVINCIA'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-PROVINCIA', {
              value: json.data.address.provice.toUpperCase()
            })
          )
        }

        if (
          !!components['RESIDENZA-CITTA'] &&
          !components['RESIDENZA-CITTA'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-CITTA', {
              value: json.data.address.city
            })
          )
        }

        if (
          !!components['RESIDENZA-INDIRIZZO'] &&
          !components['RESIDENZA-INDIRIZZO'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-INDIRIZZO', {
              value: json.data.address.address
            })
          )
        }

        if (
          !!components['RESIDENZA-CAP'] &&
          !components['RESIDENZA-CAP'].value
        ) {
          dispatch(
            updateComponent('RESIDENZA-CAP', { value: json.data.address.cap })
          )
        }

        break
    }

    dispatch(dealActionToken({ ...token, dispose: true }))
  })
}*/

/**
 * Gets invitation data for the actual contactId
 *
 * @return {Function}             Dispatches many UPDATE_COMPONENT actions
 */
/*#Removed4POS*/
/*const getInvitation = () => (dispatch, getState) => {
  const token = new ActionToken('step.getInvitation')

  const { step } = getState()

  const isReturnedToFirstStep = step.number === 1 && !!step.contactId

  if (
    !!step.contactId &&
    (isReturnedToFirstStep || (step.number > 1 && step.isUnderage === null))
  ) {
    dispatch(dealActionToken(token))

    return API.getInvitation(step.contactId).then(json => {
      return dispatch(invitationCallback(token, json))
    })
  }

  return Promise.resolve({})
}*/

/**
 * Reports the invitations to the signaler service
 *
 * @param  {Object} oldWidgets      The old widgets
 * @param  {Object} oldComponents   The old components
 * @param  {string} contactId       The actual contactId
 * @return {Function}               Dispatches a ACCEPTED_INVITATION action
 */
/*#Removed4POS*/
/*const acceptInvitation = (oldWidgets, oldComponents, contactId) => dispatch => {
  if (!!oldWidgets.SIGNALER) {
    const token = new ActionToken('step.acceptInvitation')

    dispatch(dealActionToken(token))

    const invitation = {
      contactId: contactId,
      codiceFiscale: oldComponents['CODICE_FISCALE-CF'].value,
      email: oldComponents['EMAIL-EMAIL'].value,
      phoneNumber: `${oldComponents['CELLULARE-PREF_CELLULARE'].value}${
        oldComponents['CELLULARE-NUM_CELLULARE'].value
      }`,
      promoCode:
        oldComponents['SIGNALER-PROMO_CODE'].status.indexOf('hidden') < 0
          ? oldComponents['SIGNALER-PROMO_CODE'].value
          : '',
      encryptedReporterId: oldComponents['SIGNALER-REFERRER'].value,
      campaignUrl: oldComponents['SIGNALER-CAMPAIGN_URL'].value
    }

    return API.acceptInvitation(invitation).then(json => {
      dispatch({
        type: ACCEPTED_INVITATION,
        widget: oldWidgets.SIGNALER
      })

      return dispatch(invitationCallback(token, json))
    })
  } else {
    return dispatch(getInvitation())
  }
}*/

/**
 * Components client-side validation
 * @return {Undefined}   nothing
 */
var validateStep = function validateStep() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        components = _getState3.components;

    (0, _keys2.default)(components).forEach(function (k) {
      dispatch((0, _componentsActions.validateComponent)(k, {
        passTrough: false,
        evalBlanks: true,
        execLazy: true
      }));
    });
  };
};

/**
 * Resumes an onboarding process
 * @public
 *
 * @param {Boolean} forClosedContract     Specifies if the otp has to be sent for an open or closed contract
 * @return {null}                         nothing
 */
var sendResumeOtpSms = exports.sendResumeOtpSms = function sendResumeOtpSms(forClosedContract) {
  return function (dispatch, getState) {
    var token = new ActionToken('step.sendResumeOtpSms');

    dispatch(dealActionToken(token));
    API.sendResumeOtpSms(forClosedContract).then(function (json) {
      dispatch(handleServerErrors(json));

      var _getState4 = getState(),
          step = _getState4.step;

      if (!step.hasServerErrors) {
        dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
      }
    });
  };
};

// 'stepCallbackSteps' for Selfie Implementation
var stepCallbackSteps = exports.stepCallbackSteps = function stepCallbackSteps(entities, json, product, oldWidgets, oldComponents) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
        oldStep = _getState5.step;

    var invitationPromise = _promise2.default.resolve({ data: {} });

    // added for making the contract list call aftetr the 7th step is loaded
    // if (
    //   getState().step.number === 7 &&
    //   product.prodCode === posProducts.prodAzienda
    // ) {
    //   API.request({
    //     endpoint: 'wgt/sign/contractlist'
    //   }).then(sBoxJson => {
    //     if (sBoxJson.status === 'success') {
    //       const contract = sBoxJson.data.contracts.filter(
    //         c => c.azioni === 'FIRMA'
    //       )[0]

    //       contract.url = `${process.env.API_ROOT}/wgt/utils/stampa/contract/${
    //         contract.stampeId
    //       }/${contract.barCode}.pdf`
    //       return { ...pJson, contract }
    //     }
    //   })
    // }

    /*#Removed4POS*/
    /*if (
      !!oldWidgets &&
      !!oldComponents &&
      oldStep.number !== getState().step.number
    ) {
      invitationPromise = invitationPromise.then(pJson => {
        return dispatch(
          acceptInvitation(
            oldWidgets,
            oldComponents,
            getState().step.contactId
          )
        ).then(nJson => {
          return { ...pJson, ...nJson }
        })
      })
    } else {
      invitationPromise = invitationPromise.then(pJson => {
        return dispatch(getInvitation()).then(nJson => {
          return { ...pJson, ...nJson }
        })
      })
    }*/
    if (!!entities.widgets["TITOLARE_EFFETTIVO"] && !!entities.widgets["TITOLARE_EFFETTIVO"].status && entities.widgets["TITOLARE_EFFETTIVO"].status[0] === 'ignoreValidation' && !!entities.components["TITOLARE_DATA-EFFETTIVO_SI"] && entities.components["TITOLARE_DATA-EFFETTIVO_SI"].value === '' && !!entities.components["TITOLARE_DATA-EFFETTIVO_NO"] && entities.components["TITOLARE_DATA-EFFETTIVO_NO"].value === '' && !!entities.components && !!entities.components['SZ0025-SS0052_DM0097_RI0022'] && !!entities.components['SZ0025-SS0052_DM0097_RI0023'] && !!entities.components['SZ0025-SS0163_DM0503_RI0568'] && !!entities.components['SZ0025-SS0163_DM0503_RI0569'] && !!entities.components['TITOLARE_OWNER-EFFETTIVO_SI'] && !!entities.components['TITOLARE_OWNER-EFFETTIVO_NO'] && !!entities.components['TITOLARE_OWNER-LABEL'] && !!entities.components['SZ0025-SS0163'] && !!entities.components['SZ0025-SS0052']) {
      entities.components['SZ0025-SS0052_DM0097_RI0022'].status[0] = 'hidden';
      entities.components['SZ0025-SS0052_DM0097_RI0023'].status[0] = 'hidden';
      entities.components['SZ0025-SS0163_DM0503_RI0568'].status[0] = 'hidden';
      entities.components['SZ0025-SS0163_DM0503_RI0569'].status[0] = 'hidden';
      entities.components['TITOLARE_OWNER-EFFETTIVO_NO'].status[0] = 'hidden';
      entities.components['TITOLARE_OWNER-EFFETTIVO_SI'].status[0] = 'hidden';
      entities.components['TITOLARE_OWNER-LABEL'].status[0] = 'hidden';
      entities.components['SZ0025-SS0163'].status[0] = 'hidden';
      entities.components['SZ0025-SS0052'].status[0] = 'hidden';
    }
    if (!!entities.components && !!entities.components["SZ0010-SS0212_DM0855_RI0937"] && !!entities.components["SZ0010-SS0212_DM0855_RI0937"].field && !entities.components["SZ0010-SS0212_DM0855_RI0937"].field.selected) {
      var radibtnSelected = false;
      Patrimonio_RadioButtons.forEach(function (k) {
        if (!radibtnSelected && k !== 'SZ0010-SS0212_DM0855_RI0937') {
          radibtnSelected = entities.components[k].field.selected && entities.components[k].value === 'selected' ? true : false;
        }
      });
      if (radibtnSelected) {
        entities.components["SZ0010-SS0212_DM0855_RI0937"].value = '';
      }
    }
    invitationPromise = invitationPromise.then(function (invitationJson) {
      dispatch((0, _widgetsActions.updateAllWidgets)((0, _utils.extendModel)(entities.widgets, oldWidgets, {
        dispatch: dispatch,
        step: json.step.number,
        product: product.prodCode,
        name: json.step.name,
        isWebCamEnabled: json.step.isWebCamEnabled
      })));
      dispatch((0, _componentsActions.updateAllComponents)((0, _utils.extendModel)(entities.components, oldComponents, {
        dispatch: dispatch,
        widgets: entities.widgets,
        step: json.step.number,
        product: product.prodCode,
        name: json.step.name,
        isWebCamEnabled: json.step.isWebCamEnabled
      })));

      //dispatch(updateStep(json.step))

      var _getState6 = getState(),
          widgets = _getState6.widgets,
          components = _getState6.components,
          step = _getState6.step;

      if (json.step && json.step.number === 5 && product.prodCode === _utils.posProducts.prodAzienda && step.userCounter === 0) {
        json.step.titoWidgets = JSON.parse((0, _stringify2.default)(widgets));
        json.step.titoComponents = JSON.parse((0, _stringify2.default)(components));

        (0, _keys2.default)(json.step.titoWidgets).forEach(function (k) {
          if (k && k === 'TITOLARE_DATA') {
            delete json.step.titoWidgets[k];
          }
          if (k === 'SZ0025' || k === 'CODICE_FISCALE' || k === 'DOCUMENTO' || k === 'NOME_COGNOME' || k === 'RESIDENZA') {
            json.step.titoWidgets[k].status = json.step.titoWidgets[k].status.filter(function (s) {
              return s !== 'hidden';
            });
          }
        });
        (0, _keys2.default)(json.step.titoComponents).forEach(function (k) {
          if (k && k.startsWith('TITOLARE_DATA')) {
            delete json.step.titoComponents[k];
          } else {
            if (json.step.titoComponents[k].status[0] === 'hidden' && k !== 'CODICE_FISCALE-SESSO' && k !== 'CODICE_FISCALE-PROVINCIADINASCITA' && k !== 'CODICE_FISCALE-PROVINCIADINASCITA' && (k.startsWith('CODICE_FISCALE') || k.startsWith('DOCUMENTO') || k.startsWith('NOME_COGNOME') || k.startsWith('RESIDENZA'))) {
              json.step.titoComponents[k].status = json.step.titoComponents[k].status.filter(function (s) {
                return s !== 'hidden';
              });
            }
            // if(json.step.titoComponents[k].active === 'false' && k !== 'CODICE_FISCALE-SESSO' && k !== 'CODICE_FISCALE-PROVINCIADINASCITA' && (k.startsWith('CODICE_FISCALE')|| k.startsWith('DOCUMENTO')||k.startsWith('NOME_COGNOME')|| k.startsWith('RESIDENZA')))
            // {
            //   json.step.titoComponents[k].active = true
            // }
            json.step.titoComponents[k].validations = components[k].validations;
          }
        });
        // if(!!json.step.titoWidgets["TITOLARE_EFFETTIVO"] 
        // && !!json.step.titoWidgets["TITOLARE_EFFETTIVO"].status && 
        // json.step.titoWidgets["TITOLARE_EFFETTIVO"].status[0]==='ignoreValidation' &&
        // !!json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_SI"] && 
        // json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_SI"].value==='' && 
        // !!json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_NO"] && 
        // json.step.titoComponents["TITOLARE_DATA-EFFETTIVO_NO"].value==='' && 
        // !!json.step.titoComponents && !!json.step.titoComponents['SZ0025-SS0052_DM0097_RI0022'] && 
        // !!json.step.titoComponents['SZ0025-SS0052_DM0097_RI0023'] &&
        // !!json.step.titoComponents['SZ0025-SS0163_DM0503_RI0568'] &&
        // !!json.step.titoComponents['SZ0025-SS0163_DM0503_RI0569'] &&
        // !!json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_SI'] &&
        // !!json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_NO'] &&
        // !!json.step.titoComponents['TITOLARE_OWNER-LABEL']  && 
        // !!json.step.titoComponents['SZ0025-SS0163'] &&
        // !!json.step.titoComponents['SZ0025-SS0052'])
        // {
        // json.step.titoComponents['SZ0025-SS0052_DM0097_RI0022'].status[0]='hidden';
        // json.step.titoComponents['SZ0025-SS0052_DM0097_RI0023'].status[0]='hidden';
        // json.step.titoComponents['SZ0025-SS0163_DM0503_RI0568'].status[0]='hidden';
        // json.step.titoComponents['SZ0025-SS0163_DM0503_RI0569'].status[0]='hidden';
        // json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_NO'].status[0]='hidden';
        // json.step.titoComponents['TITOLARE_OWNER-EFFETTIVO_SI'].status[0]='hidden'; 
        // json.step.titoComponents['TITOLARE_OWNER-LABEL'].status[0]='hidden'; 
        // json.step.titoComponents['SZ0025-SS0163'].status[0]='hidden'; 
        // json.step.titoComponents['SZ0025-SS0052'].status[0]='hidden'; 
        // }
        dispatch(updateStep(json.step));

        //MOVED THE CODE TO ELSE STATEMENT
        var TED = components['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA'];
        var nomeObj = TED && TED.values.find(function (w) {
          return w.description === "NOME";
        });
        var cognomeObj = TED && TED.values.find(function (w) {
          return w.description === "COGNOME";
        });
        var nome = nomeObj && nomeObj.value ? nomeObj.value : '';
        var cognome = cognomeObj && cognomeObj.value ? cognomeObj.value : '';
        var titoRawValue = TED && TED.rawValue;
        var titoValue = titoRawValue && titoRawValue.titolare_effettivo;
        if (titoValue && titoValue.length) {
          var userDetails = {
            id: step.userCounter,
            userWidgets: JSON.parse((0, _stringify2.default)(widgets)),
            userComponents: JSON.parse((0, _stringify2.default)(components)),
            NOME: nome,
            COGNOME: cognome
          };
          var titoUserValue = titoValue[userDetails.id];
          dispatch(getPrevTitolareUser(userDetails, titoUserValue));
          dispatch(addTitolareUserToObject(userDetails, step.userCounter));

          for (var i = 1; i < titoValue.length; i++) {
            //dispatch(addTitolareUser())
            step.userCounter = step.userCounter + 1;
            var userD = {
              id: step.userCounter,
              userWidgets: JSON.parse((0, _stringify2.default)(json.step.titoWidgets)),
              userComponents: JSON.parse((0, _stringify2.default)(json.step.titoComponents))
            };
            var _titoUserValue = titoValue[userD.id];
            dispatch(getPrevTitolareUser(userD, _titoUserValue));
            dispatch(addTitolareUserToObject(userD, step.userCounter));
          }
          //dispatch({ type: USER_COUNTER })
        }
        //for retricting the user to get updated while coming back
        else {
            var _userDetails = {
              id: step.userCounter,
              userWidgets: JSON.parse((0, _stringify2.default)(widgets)),
              userComponents: JSON.parse((0, _stringify2.default)(components)),
              NOME: nome,
              COGNOME: cognome
            };
            dispatch(addTitolareUserToObject(_userDetails, step.userCounter));
          }
      }

      if (!!json.isOtpCallback) {
        dispatch(sendResumeOtpSms(!!json.isContractClosed));
      }

      // step 1

      // @todo remove this statement and use the new initialization methods instead
      /*#Removed4POS*/
      /*if (!!json.proof) {
        switch (json.proof.type) {
          case 'hype':
            if (getState().step.number === 1) {
              dispatch(decryptHypeProof(json.proof))
            }
            break
          case 'yoox':
            if (getState().step.number < 3 && product.flow === 'hypeyoox') {
              // @remarks product.flow check is necessary to trigger the decryption only on legacy init
              dispatch(decryptYooxProof(json.proof))
            }
            break
        }
      }
        if (
        !routing.locationBeforeTransitions.query.proof &&
        !routing.locationBeforeTransitions.query.proofType &&
        getState().step.number === 1
      ) {
        dispatch(updateCampaignUrl(routing.locationBeforeTransitions.search))
      }
        if (
        !!routing.locationBeforeTransitions.query.promoCode &&
        getState().step.number === 1
      ) {
        dispatch(
          updatePromoCode(
            routing.locationBeforeTransitions.query.promoCode,
            true
          )
        )
      }*/

      if (!!widgets.EMAIL) {
        if (widgets.EMAIL.status.indexOf('readonly') > -1) {
          var emailConfirmComponent = components['EMAIL-CONFERMA_EMAIL'];
          var mobileConfirmComponent = components['CELLULARE-CONFERMA_NUM_CELLULARE'];
          var signaler = widgets.SIGNALER;
          var mobileWidget = widgets.CELLULARE;

          signaler.status = (0, _lodash.union)(signaler.status, ['hidden']);
          dispatch((0, _widgetsActions.updateWidget)(signaler.name, signaler));
          emailConfirmComponent.status = (0, _lodash.union)(emailConfirmComponent.status, ['hidden']);
          dispatch((0, _componentsActions.updateComponent)(emailConfirmComponent.id, emailConfirmComponent));
          mobileConfirmComponent.status = (0, _lodash.union)(mobileConfirmComponent.status, ['hidden']);
          dispatch((0, _componentsActions.updateComponent)(mobileConfirmComponent.id, mobileConfirmComponent));
          mobileWidget.status = (0, _lodash.union)(mobileWidget.status, ['readonly']);
          dispatch((0, _widgetsActions.updateWidget)(mobileWidget.name, mobileWidget));

          if ((!getState().step.auth || !getState().step.auth.tokenId) && !getState().step.isParent) {
            dispatch(setIsParent());
          }
        }
      }

      /*#Removed4POS*/
      /*if (!!widgets.SIGNALER) {
        if (!!getState().step.contactId) {
          // gone back to first step
          if (invitationJson.lastData.campaignUrl) {
            dispatch(
              updateComponent('SIGNALER-CAMPAIGN_URL', {
                value: invitationJson.lastData.campaignUrl
              })
            )
          }
            if (invitationJson.lastData.encryptedReporterId) {
            dispatch(
              updateComponent('SIGNALER-REFERRER', {
                value: invitationJson.lastData.encryptedReporterId
              })
            )
          }
            if (invitationJson.lastData.promoCode) {
            dispatch(
              updateComponent('SIGNALER-PROMO_CODE', {
                value: invitationJson.lastData.promoCode
              })
            )
          }
            if (
            !!getState().components['SIGNALER-PROMO_CODE'].value &&
            widgets.SIGNALER.status.indexOf('hidden') < 0
          ) {
            // @hack the correct instructions should be the one commented below but for some reason doesn't work as expected
            document.getElementById('SIGNALER-HAS_PROMO_CODE_YES').click()
              // dispatch(updateComponent('SIGNALER-HAS_PROMO_CODE_YES', { value: !!getState().components['SIGNALER-PROMO_CODE'].value ? 'selected' : components['SIGNALER-HAS_PROMO_CODE_YES'].value }))
            // dispatch(updateComponent('SIGNALER-HAS_PROMO_CODE_NO', { value: !getState().components['SIGNALER-PROMO_CODE'].value ? 'selected' : components['SIGNALER-HAS_PROMO_CODE_NO'].value }))
          }
        }
          if (product.partnership === 'HYPE' && product.convention === 'YOOX') {
          dispatch(
            updateWidget('SIGNALER', {
              status: union(widgets.SIGNALER.status, ['hidden'])
            })
          )
        }
          if (
          product.partnership === 'HYPE' &&
          product.convention === 'ADECCO'
        ) {
          dispatch(
            updateWidget('SIGNALER', {
              status: union(widgets.SIGNALER.status, ['hidden'])
            })
          )
          if (!!widgets.JOLLY) {
            dispatch(
              updateComponent('JOLLY-JOLLY_INPUT', {
                value: product.convention
              })
            )
          }
        }
      }
        if (!!widgets.CELLULARE) {
        if (
          product.partnership === 'HYPE4TIM' &&
          !!components['CELLULARE-CONFERMA_NUM_CELLULARE']
        ) {
          dispatch(
            updateComponent('CELLULARE-CONFERMA_NUM_CELLULARE', {
              status: [
                ...new Set([
                  ...components['CELLULARE-CONFERMA_NUM_CELLULARE'].status,
                  'hidden'
                ])
              ]
            })
          )
        }
      }*/

      // step 2

      if (!!widgets.VERIFICA_DATI_DA_CF) {
        if (!!components['VERIFICA_DATI_DA_CF-PROVINCIA'] && components['VERIFICA_DATI_DA_CF-PROVINCIA'].value !== 'EE' && !!components['CITTADINANZA-CITTADINANZA']) {
          components['CITTADINANZA-CITTADINANZA'].initialValue = 'ITALIA';
        }
        // else {
        //   components['CITTADINANZA-CITTADINANZA'].initialValue =
        //     components['VERIFICA_DATI_DA_CF-CITTA'].value
        // }
      }

      // step 3

      if (!!widgets.TIPOLOGIA_CARTA) {
        if (!!getState().step.isParent) {
          dispatch((0, _componentsActions.updateComponent)('TIPOLOGIA_CARTA-CARTA_VIRTUALE', {
            value: 'selected'
          }));
          dispatch((0, _componentsActions.updateComponent)('TIPOLOGIA_CARTA-CARTA_FISICA', { value: '' }));
        }
        /*#Removed4POS*/
        /*if (product.partnership === 'HYPE' && product.convention === 'YOOX') {
          dispatch(
            updateWidget('TIPOLOGIA_CARTA', {
              status: union(widgets.TIPOLOGIA_CARTA.status, ['hidden'])
            })
          )
        }
          if (product.partnership === 'HYPE4TIM') {
          if (!getState().step.isParent) {
            dispatch(
              updateWidget('TIPOLOGIA_CARTA', {
                groupTitle: 'Carta virtuale TIMpersonal'
              })
            )
              dispatch(
              updateWidget('VERIFICA_EMAIL_EXTRA', {
                status: widgets.VERIFICA_EMAIL_EXTRA.status.filter(
                  s => s !== 'hidden'
                )
              })
            )
            dispatch(
              updateComponent('VERIFICA_EMAIL_EXTRA-TYPE_VALUE', {
                value: getState().step.email
              })
            )
          }
            dispatch(
            updateComponent('TIPOLOGIA_CARTA-CARTA_VIRTUALE', {
              status: union(
                components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
                ['readonly', 'reallyreadonly']
              ),
              cleanName: '',
              description:
                'La carta virtuale TIMpersonal ti consente di effettuare acquisti online e nei negozi abilitati in totale sicurezza, scambiare denaro tra amici, ricevere bonifici e tanto altro. Una volta attivata, potrai poi richiedere anche la carta fisica se lo desideri.'
            })
          )
          dispatch(
            updateComponent('TIPOLOGIA_CARTA-CARTA_FISICA', {
              status: union(
                components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
                ['hidden']
              )
            })
          )
        }
          if (product.convenzione === 'HERBALIFE') {
          if (!getState().step.isParent) {
            dispatch(
              updateWidget('TIPOLOGIA_CARTA', {
                groupTitle: 'Carta virtuale Herbalife'
              })
            )
          }
            dispatch(
            updateComponent('TIPOLOGIA_CARTA-CARTA_VIRTUALE', {
              status: union(
                components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
                ['readonly', 'reallyreadonly']
              ),
              cleanName: '',
              description:
                'La carta virtuale Herbalife ti consente di effettuare acquisti online e nei negozi abilitati in totale sicurezza, scambiare denaro tra amici, ricevere bonifici e tanto altro. Una volta attivata, potrai poi richiedere anche la carta fisica se lo desideri.'
            })
          )
          dispatch(
            updateComponent('TIPOLOGIA_CARTA-CARTA_FISICA', {
              status: union(
                components['TIPOLOGIA_CARTA-CARTA_FISICA'].status,
                ['hidden']
              )
            })
          )
        }*/
      }

      /*if (!!widgets.RIF_SPEDIZIONE_CARTA) {
        if (
          product.partnership === 'HYPE4TIM' ||
          !!getState().step.isParent
        ) {
          dispatch(
            updateWidget('RIF_SPEDIZIONE_CARTA', {
              status: [
                ...new Set([...widgets.RIF_SPEDIZIONE_CARTA.status, 'hidden'])
              ]
            })
          )
        }
      }*/

      getStoredState().updateSession(getState().step.contactId, getState().step.number, !!getState().step.isParent);

      var reachedStep = getStoredState().getSessionStep(getState().step.contactId, !!getState().step.isParent);

      if (!!widgets.DOCUMENTAZIONE) {
        dispatch((0, _componentsActions.tweakAgreement)({
          widget: widgets.DOCUMENTAZIONE,
          force: reachedStep <= 3,
          hide: true
        }));
      }

      // if (!!widgets.CRONISTORIA) {
      //   dispatch(
      //     tweakAgreement({
      //       widget: widgets.CRONISTORIA,
      //       // force: reachedStep <= 3,
      //       hide: false
      //     })
      //   )
      // }

      // if (!!widgets.DATI_SENSIBILI) {
      //   dispatch(
      //     tweakAgreement({
      //       widget: widgets.DATI_SENSIBILI,
      //       force: reachedStep <= 3,
      //       hide: !!getState().step.isUnderage,
      //       forceValue: !!getState().step.isUnderage ? 'selected' : '',
      //       description:
      //         !!getState().step.isParent &&
      //         'Ti chiediamo il consenso al trattamento dei dati sensibili sia per te che per il minore. IMPORTANTE: non richiediamo e non trattiamo di nostra iniziativa i “dati sensibili” se non per dare esecuzione alla disposizione delle operazioni. Ci teniamo a precisare che NON UTILIZZEREMO QUESTI DATI IN ALTRO MODO.'
      //     })
      //   )
      // }

      // if (!!widgets.PROFILAZIONE) {
      //   dispatch(
      //     tweakAgreement({
      //       widget: widgets.PROFILAZIONE,
      //       force: reachedStep <= 3,
      //       hide: false
      //     })
      //   )
      // }

      // if (!!widgets.PROMOZIONE) {
      //   dispatch(
      //     tweakAgreement({
      //       widget: widgets.PROMOZIONE,
      //       force: reachedStep <= 3,
      //       hide: !!getState().step.isUnderage,
      //       forceValue: !!getState().step.isUnderage ? 'selected' : '',
      //       description:
      //         !!getState().step.isParent &&
      //         'Ti chiediamo il consenso per il trattamento dei tuoi dati e di quelli del minore da parte di Axerve S.p.A., da parte di una Società del Gruppo Sella oppure da parte di società terze nominate responsabili esterne del trattamento per l’offerta di prodotti finanziari del Gruppo Sella e prodotti e servizi di terzi, per la gestione o/e il monitoraggio dei movimenti, anche ai fini antifrode, o per la realizzazione e l’invio di promozioni ed offerte create “su misura” per te, sia direttamente che tramite società terze.'
      //     })
      //   )
      // }

      // if (!!widgets.PROMOZIONE_TERZI) {
      //   dispatch(
      //     tweakAgreement({
      //       widget: widgets.PROMOZIONE_TERZI,
      //       force: reachedStep <= 3,
      //       hide: false
      //     })
      //   )
      // }

      if (!!widgets.DOCUMENTO_2 && !!(components['DOCUMENTO_2-BOLLETTA'].active && components['DOCUMENTO_2-BUSTA_PAGA'].active && components['DOCUMENTO_2-CARTA_IDENTITA'].active && components['DOCUMENTO_2-ESTRATTO_CONTO'].active)) {
        dispatch((0, _componentsActions.updateComponent)('DOCUMENTO_2-DOCR_UPLOAD', {
          active: false,
          status: ['hidden']
        }));
        var wdoc2UpdatedBody = {
          status: []
        };
        dispatch((0, _widgetsActions.updateWidget)('DOCUMENTO_2', wdoc2UpdatedBody));
      }

      // step 4

      if (!!widgets.MOD_IDENTIFICAZIONE) {
        if (!!getState().step.isUnderage || !!md.mobile()) {
          widgets.MOD_IDENTIFICAZIONE.components.forEach(function (k) {
            if (components[k].type === 'radio') dispatch((0, _componentsActions.updateComponent)(k, { type: 'hidden' }));
          });
        }
      }

      if (!!widgets.DOCUMENTO_2 && !!components['DOCUMENTO_2-TIPO_DOCUMENTO'].active) {
        var _wdoc2UpdatedBody = {
          status: widgets.DOCUMENTO_2.status.filter(function (s) {
            return s !== 'hidden';
          })
        };

        if (!!components['DOCUMENTO_2-PERMESSO_SOGGIORNO'] && !!components['DOCUMENTO_2-PERMESSO_SOGGIORNO'].active) {
          _wdoc2UpdatedBody.groupTitle = 'Permesso di soggiorno';

          dispatch((0, _componentsActions.updateComponent)('DOCUMENTO_2-PERMESSO_SOGGIORNO', {
            value: 'selected'
          }));
        }

        dispatch((0, _widgetsActions.updateWidget)('DOCUMENTO_2', _wdoc2UpdatedBody));
      }
      /*  if (!!widgets.TERMINA_PROCEDURA) {
           dispatch(
             updateComponent(
               'TERMINA_PROCEDURA-CONTRATTO',
               {
                 link: {
                   ...components['TERMINA_PROCEDURA-CONTRATTO'].link
                   // stampeId: invitationJson.contract.stampeId,
                   // barCode: invitationJson.contract.barCode,
                   // url: invitationJson.contract.url
                 }
               },
               { bypassValidation: true }
             )
           )
             if (!!getState().step.isParent) {
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-LABEL',
                 { value: 'Per completare la richiesta manca pochissimo!' },
                 { bypassValidation: true }
               )
             )
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-CONTRATTO',
                 {
                   value:
                     'Proseguendo dichiaro di aver letto e accettato il §link§ del minorenne ed attesto che sia fiscalmente residente esclusivamente in Italia (*)'
                 },
                 { bypassValidation: true }
               )
             )
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-MODULO',
                 { status: ['hidden'] },
                 { bypassValidation: true }
               )
             )
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-RESIDENZA_ITA',
                 {
                   value:
                     'Nel caso il minorenne abbia altre residenze fiscali oltre a quella italiana scrivici §link§' //contattaci telefonicamente allo §phone§ oppure
                 },
                 { bypassValidation: true }
               )
             )
           }
             if (!!getState().step.isUnderage) {
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-CONTRATTO',
                 {
                   value:
                     'Qui trovi la copia del §link§, clicca su continua per concludere.'
                 },
                 { bypassValidation: true }
               )
             )
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-MODULO',
                 { status: ['hidden'] },
                 { bypassValidation: true }
               )
             )
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-RESIDENZA_ITA',
                 { status: ['hidden'] },
                 { bypassValidation: true }
               )
             )
             dispatch(
               updateComponent(
                 'TERMINA_PROCEDURA-RESIDENZA_ITA_SPEC',
                 { status: ['hidden'] },
                 { bypassValidation: true }
               )
             )
           }
         } */

      // if (!oldWidgets || !oldComponents) {
      (0, _keys2.default)(getState().components).forEach(function (k) {
        var component = getState().components[k];
        if (component.hasOwnProperty('autofill')) {
          dispatch((0, _componentsActions.autoFillDependantComponents)(k));
        }
        if (component.hasOwnProperty('trigger')) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(component.trigger), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var comp = _step.value;

              if (comp.type === 'call' && comp.fn) {
                dispatch((0, _componentsActions.invokeMethod)(comp, component));
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
      // }

      // scrolls to top on step change or to the firs invalid component
      if (oldStep.number !== getState().step.number) {
        window.scrollTo(0, 0);
      } else {
        (0, _utils.scrollToFirstInvalidComponent)(components);
      }

      dispatch(rewriteRoute(!!invitationJson.lastData ? invitationJson.lastData.campaignUrl : null));
    });
  };
};

/**
 * Handles a step change callback
 * @param  {Object} token                 The ActionToken
 * @param  {Object} json                  The step data
 * @param  {Object} oldWidgets            The optional old step's widgets
 * @param  {Object} oldComponents         The optional old step's components
 * @return {null}                         nothing
 */
var stepCallback = exports.stepCallback = function stepCallback(token, json, oldWidgets, oldComponents) {
  return function (dispatch, getState) {
    var _getState7 = getState(),
        oldStep = _getState7.step,
        product = _getState7.product;

    var invitationPromise = _promise2.default.resolve({ data: {} });

    dispatch(handleServerErrors(json));
    var stepWidgets = json.step && json.step.widgets ? json.step.widgets : [];
    var widgets_ = JSON.parse((0, _stringify2.default)(stepWidgets));
    var staticWidgets = [];
    var staticOwnerWidgets = [];
    var staticPosPlanWidgets = [];
    var staticprivacyfabrick = [];
    /* TODO: add product code check along with step number */

    //Enable OTP Text Box for all the product flows
    if (stepWidgets.length && json.step && json.step.number === 1) //&& product.prodCode !== posProducts.prodPersonaFisica)
      {
        stepWidgets.find(function (w) {
          return w.name === 'CELLULARE';
        }).components.map(function (c) {
          if (c.name === 'CODICE_CELLULARE') {
            c.active = true;
          }
        });
      }
    //Move component from 1st to 3rd Step Ditta individuale flow (Test-Env)
    if (product.prodCode === _utils.posProducts.prodDittaInd && json.step && json.step.number === 3) {
      stepWidgets.find(function (w) {
        return w.name === 'DENOMINAZIONE_AZIENDA';
      }).components.map(function (c) {
        if (c.name === 'DENOMINAZIONE') {
          c.staticDescFlag = true;
        }
      });
    }

    //POS Status based 'VAT IDENTIFICATION CERTIFICATE' widget action - March16-2020 
    if (product.prodCode === _utils.posProducts.prodDittaInd && json.step && json.step.number === 6) {
      var genericoWidget = stepWidgets.find(function (w) {
        return w.name === 'DOCUMENTO_GENERICO';
      });
      if (genericoWidget.status.length > 0 && genericoWidget.status[0] === "hidden") {
        genericoWidget.components = [];
      }
    }

    if (product.prodCode !== _utils.posProducts.prodPersonaFisica && json.step && json.step.number === 3) {
      stepWidgets.find(function (w) {
        return w.name === 'TELEFONO_FISSO';
      }).components.map(function (c) {
        if (c.name === 'NUMERO') {
          c.status = [];
        }
      });
    }

    if (stepWidgets.length && json.step && json.step.number === 5 && product.prodCode === _utils.posProducts.prodAzienda) {

      var titolareEffectivoData = stepWidgets.find(function (w) {
        return w.name === 'TITOLARE_EFFETTIVO';
      }).components.find(function (x) {
        return x.name === 'TITOLARE_EFFETTIVO_DATA';
      });
      if (!!titolareEffectivoData.rawValue) {
        stepWidgets.find(function (w) {
          return w.name === 'TITOLARE_EFFETTIVO';
        }).components.find(function (x) {
          return x.name === 'TITOLARE_EFFETTIVO_DATA';
        }).rawValue.titolare_effettivo.map(function (m) {
          if (!!m.residenza) m.residenza.nazione = !!m.residenza.nazione || m.residenza.nazione === '' ? 'ITALIA' : m.residenza.nazione;

          if (!m.residenza) {
            // delete m.residenza
            m.residenza = { nazione: 'ITALIA' };
          }
        });
      }
    }

    //Remove Pre Compiled Code in Step 2
    if (json.step && json.step.number === 2) {
      // stepWidgets.find(w=>w.name==='VERIFICA_DATI_DA_CF').components.map(c=>{
      // })
      stepWidgets.map(function (w) {
        if (w.name === 'VERIFICA_DATI_DA_CF') {
          w.status = ['hidden'];
        }
      });
    }
    //Add Document Rules Component
    var DocumentoStepWidget = JSON.parse((0, _stringify2.default)((0, _addressStatic.getDocumentoRulesComponent)()));
    if (stepWidgets.filter(function (w) {
      return w.name === "DOCUMENTO";
    }).length > 0) {
      var DocumentoWidget = stepWidgets.filter(function (w) {
        return w.name === 'DOCUMENTO';
      });
      DocumentoWidget[0].components = [].concat((0, _toConsumableArray3.default)(DocumentoWidget[0].components), (0, _toConsumableArray3.default)(DocumentoStepWidget.widgets[0].components));
    }

    if (stepWidgets.filter(function (w) {
      return w.name === "DOCUMENTO_2";
    }).length > 0) {
      var SecondDocumentoWidget = stepWidgets.filter(function (w) {
        return w.name === 'DOCUMENTO_2';
      });
      SecondDocumentoWidget[0].components = [].concat((0, _toConsumableArray3.default)(SecondDocumentoWidget[0].components), (0, _toConsumableArray3.default)(DocumentoStepWidget.widgets[1].components));
    }

    //End Document Rules
    /// For Ditta individuale Flow
    if (product.prodCode === _utils.posProducts.prodDittaInd && json.step && json.step.number === 4) {
      if (stepWidgets.filter(function (w) {
        return w.name === "SETTORE_ATTIVITA_AZIENDA";
      }).length > 0) {
        var _DocumentoWidget = stepWidgets.filter(function (w) {
          return w.name === 'SETTORE_ATTIVITA_AZIENDA';
        });
        _DocumentoWidget[0].components = [].concat((0, _toConsumableArray3.default)(_DocumentoWidget[0].components), (0, _toConsumableArray3.default)(Model.WIDGETS.SETTORE_ATTIVITA_AZIENDA_COMP.components));
      }
    }

    //Selfie Issue not showing selfie image – Azienda  /  Camera setting issue - Ditta flow (step 6)
    if (json.step && (product.prodCode === _utils.posProducts.prodAzienda && json.step.number === 2 || product.prodCode === _utils.posProducts.prodDittaInd && json.step.number === 6 || product.prodCode === _utils.posProducts.prodPersonaFisica && json.step.number === 5)) {
      if (!!stepWidgets.find(function (w) {
        return w.name === 'MOD_IDENTIFICAZIONE';
      }).components && !!stepWidgets.find(function (w) {
        return w.name === 'MOD_IDENTIFICAZIONE';
      }).components.find(function (w) {
        return w.name === 'SELFIE_1_DOCUMENTO';
      }) && !!stepWidgets.find(function (w) {
        return w.name === 'MOD_IDENTIFICAZIONE';
      }).components.find(function (w) {
        return w.name === 'SELFIE_1_DOCUMENTO';
      }).status && stepWidgets.find(function (w) {
        return w.name === 'MOD_IDENTIFICAZIONE';
      }).components.find(function (w) {
        return w.name === 'SELFIE_1_DOCUMENTO';
      }).status[0] === 'selected'
      //&& !!document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO")
      ) {
          stepWidgets.find(function (w) {
            return w.name === 'MOD_IDENTIFICAZIONE';
          }).components.map(function (c) {
            if (c.name === 'SELFIE_1_DOCUMENTO') {
              c.value = 'selected';
            }
          });

          //setTimeout(() => { document.getElementById('MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO').click() }, 500);      
        } else {
        stepWidgets.find(function (w) {
          return w.name === 'MOD_IDENTIFICAZIONE';
        }).components.map(function (c) {
          if (c.name === '2_DOCUMENTI') {
            c.value = 'selected';
          }
        });
      }
    }

    if (json.step && json.step.number === 3 && (json.step.name.toUpperCase() === "I DATI DELL'AZIENDA" || json.step.name.toUpperCase() === "LA TUA AZIENDA")) {
      var PECAddressWidget = JSON.parse((0, _stringify2.default)((0, _addressStatic.getPECAddressComponent)()));
      var PECStepwidget = stepWidgets.filter(function (w) {
        return w.name === 'PEC';
      });
      PECStepwidget[0].components = [].concat((0, _toConsumableArray3.default)(PECStepwidget[0].components), (0, _toConsumableArray3.default)(PECAddressWidget.widgets[0].components));
    }
    // if(json.step && json.step.number!==1)
    // {
    //    staticPosPlanWidgets = JSON.parse(
    //     JSON.stringify(getPosPlanComponent())
    //   )
    //   staticPosPlanWidgets.widgets[0].components[0].fetchPosPlan = {
    //     url:'OnboardRequestDetails/FetchPOSPlan', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
    //     body: {
    //       GUID: json.step.guid
    //     },
    //     mappingEvent: 'FetchPOSPlan'
    //   }
    //   stepWidgets = [
    //     ...stepWidgets,...staticPosPlanWidgets.widgets]
    // }


    if (stepWidgets.length && json.step && json.step.number === 5 && product.prodCode === _utils.posProducts.prodAzienda) {
      staticWidgets = TitolareStatic.getTitolareEffettivoComponent();
      staticOwnerWidgets = TitolareStatic.getTitolareStaticComponent();
      var filteredwidgets = stepWidgets.filter(function (tw) {
        return tw.name === 'TITOLARE_EFFETTIVO';
      });
      if (filteredwidgets && filteredwidgets[0] && filteredwidgets[0].components) {
        var titolareEffettivoDataComponent = filteredwidgets[0].components.find(function (c) {
          return c.name === 'TITOLARE_EFFETTIVO_DATA';
        });
        if (titolareEffettivoDataComponent && titolareEffettivoDataComponent.values) {
          var titolareJson = titolareEffettivoDataComponent.values.filter(function (tc) {
            return tc.description === 'QUESTIONARIO_PEP';
          });
          if (titolareJson) {
            var config = {
              data: titolareJson[0].jsonString,
              isSavePG: false,
              method: 'Titolare_Effettivo'
            };
            var _DocumentoStepWidget = JSON.parse((0, _stringify2.default)((0, _addressStatic.getDocumentoRulesComponent)()));
            if (staticWidgets.widgets.filter(function (w) {
              return w.name === "DOCUMENTO";
            }).length > 0) {
              var _DocumentoWidget2 = staticWidgets.widgets.filter(function (w) {
                return w.name === 'DOCUMENTO';
              });
              _DocumentoWidget2[0].components = [].concat((0, _toConsumableArray3.default)(_DocumentoWidget2[0].components), (0, _toConsumableArray3.default)(_DocumentoStepWidget.widgets[0].components));
            }
            var parsedWidgets = dispatch((0, _componentsActions.parseQuestionarioWidgets)(null, config));
            stepWidgets = [].concat((0, _toConsumableArray3.default)(stepWidgets), (0, _toConsumableArray3.default)(staticWidgets.widgets), (0, _toConsumableArray3.default)(parsedWidgets), (0, _toConsumableArray3.default)(staticOwnerWidgets.widgets));
          }
        }
      }
    }
    if (!!json.step && !!json.step.number && json.step.number === 1) {
      staticprivacyfabrick = JSON.parse((0, _stringify2.default)((0, _privacyfabrick.getprivacyfabrick)()));
      stepWidgets = [].concat((0, _toConsumableArray3.default)(stepWidgets), (0, _toConsumableArray3.default)(staticprivacyfabrick.widgets));
    }
    if (json.step) {
      staticPosPlanWidgets = JSON.parse((0, _stringify2.default)((0, _posPlanStatic.getPosPlanComponent)()));
      staticPosPlanWidgets.widgets[0].components[0].fetchPosPlan = {
        url: 'OnboardRequestDetails/FetchPOSPlan', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
        body: {
          GUID: json.step.guid
        },
        mappingEvent: 'FetchPOSPlan'
      };
      stepWidgets = [].concat((0, _toConsumableArray3.default)(stepWidgets), (0, _toConsumableArray3.default)(staticPosPlanWidgets.widgets));
      //stepWidgets.components=[...stepWidgets.components,...staticPosPlanWidgets.widgets.components[0]]
    }
    if (stepWidgets.length && json.step.last) {
      json.step.disableButton = true;

      var widgetCode = stepWidgets.filter(function (w) {
        return w.name === 'ATTIVA_REVOCA_FIRMA';
      } /*  || w.name == 'TERMINA_PROCEDURA' */
      ).map(function (w) {
        return w.code;
      });
      var _filteredwidgets = stepWidgets.filter(function (w) {
        return w.name === 'FLOW_BAR';
      } /*  || w.name == 'TERMINA_PROCEDURA' */
      );
      var filteredwidgets_ = widgets_.filter(function (w) {
        return w.name === 'FLOW_BAR';
      } /*  || w.name == 'TERMINA_PROCEDURA' */
      );

      stepWidgets = [].concat((0, _toConsumableArray3.default)(_filteredwidgets));
      dispatch(updateDiFarmaComponent(filteredwidgets_, json));
      // widgets = filteredwidgets
    }

    //widget_.components = [].concat(widgets.components)
    if (!getState().step.hasServerErrors) {
      var _normalize = (0, _normalizr.normalize)(stepWidgets, _schema.widgetListSchema),
          entities = _normalize.entities;

      if (!!getStoredState().authenticated) {
        json.step.auth = { tokenId: '-' };
      }

      json.step.widgets_ = widgets_;
      var PRODUCT_PLUGIN = widgets_.find(function (w) {
        return w.name === 'PRODUCT_PLUGIN';
      });
      if (PRODUCT_PLUGIN && PRODUCT_PLUGIN.code) {
        json.step.config = json.step.config || {};
        json.step.config.widget = json.step.config.widget || {};
        json.step.config.widget.PRODUCT_PLUGIN = {
          code: PRODUCT_PLUGIN.code,
          components: JSON.parse((0, _stringify2.default)(PRODUCT_PLUGIN.components))
        };
      }

      // let invitationPromise = Promise.resolve({ data: {} })
      dispatch(updateStep(json.step));

      //Changes In Selfie Implementation
      if (json.step && (!!json.step.number || !!json.step.name)) {

        //To check the system has webcam or not
        if ((product.prodCode === _utils.posProducts.prodPersonaFisica || product.prodCode === _utils.posProducts.prodDittaInd) && json.step.name === 'Identificati' || product.prodCode === _utils.posProducts.prodAzienda && json.step.name === 'Completa i tuoi dati') {

          navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

          if (navigator.getUserMedia) {
            navigator.getUserMedia({ video: true }, function (stream) {
              //when webcam is enabled in browser
              json.step.isWebCamEnabled = true;
              dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents));
            }, function (e) {
              //when webcam in disabled in browser
              json.step.isWebCamEnabled = false;
              dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents));
            });
          } else {
            //If webcam not available
            dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents));
          }
        } else {
          //Normal flow dont need to check the webcam
          dispatch(stepCallbackSteps(entities, json, product, oldWidgets, oldComponents));
        }
      }

      return invitationPromise.then(function () {
        dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
        if (oldStep.number !== getState().step.number) {
          dispatch(pushAnalytics());
        }

        //Selfie Issue not showing selfie image – Azienda 
        else if (!!oldStep && !!getState() && !!getState().step && !!getState().step.widgets_ && oldStep.number === 2 && product.partnership === _utils.posProducts.prodAzienda && (!!getState().step.widgets_.find(function (w) {
            return w.name === 'CRIF';
          }).errorMessage.length > 0 || !!oldStep.widgets_ && !!oldStep.widgets_.find(function (w) {
            return w.name === 'SELFIE';
          }) && !!oldStep.widgets_.find(function (w) {
            return w.name === 'SELFIE';
          }).components && !!oldStep.widgets_.find(function (w) {
            return w.name === 'SELFIE';
          }).components.find(function (c) {
            return c.name === "CHECK_OCR";
          }) && !!document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO") && !!document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO").value && document.getElementsByName('SELFIE-SELFIE_UPLOAD').length > 0)) {
            setTimeout(function () {
              document.getElementById("MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO").click();
            }, 1000);

            var CrifComponent = getState().step.widgets_.find(function (w) {
              return w.name === 'CRIF';
            });
            if (!!CrifComponent.errorMessage.length > 0) {
              var errMessage = CrifComponent.errorMessage[0];
              alert(errMessage);
            }
          }
      });
    }
  };
};

/**
 * Prepares the start payload before calling the startProcess api
 * @param  {string} partnership     partnership code
 * @param  {string} convention      convention code
 * @param  {string} proof           an initi
 * @return {Promise}                Promise
 */
var startProcessWorker = function startProcessWorker(partnership, convention, proof, location) {
  return function (dispatch, getState) {
    var startJson = void 0;

    var _getState8 = getState(),
        initQuery = _getState8.routing.locationBeforeTransitions.query;

    var federationPromise = partnership === 'HYPE4TIM' && !!(0, _keys2.default)(initQuery).indexOf('code') > -1 ? API.getTimUserInfo(initQuery) : _promise2.default.resolve(!!proof ? proof.value : undefined);

    // @mock
    // const federationPromise =
    //   partnership === 'HYPE4TIM' && !!Object.keys(initQuery).indexOf('code') > -1
    //     ? Promise.resolve({
    //         responseCode: '000',
    //         responseDescr: 'Operation Successfully Completed',
    //         data: {
    //           userInfo: {
    //             sub:
    //               'acr:WNFVtapqjPhduvRTPSIkv3jD5KhRFTQMtXjOGQ9UAMMx7SofUIuiYqTUuF47rqDFegm3+kR5Xx+KW6N2MCaih/MqfWvtFV8DzdGNJH54AX7Pd6Yx3Q7J2igbRUE8DHHpI5fNMrpc+0UrnZRbHz+L3atiljnqF4I6n6pV/Dljxg6Q9gf6dy4tVNnHKi1uL9TdJpnBR6gNqPBAdhF3MgONfVOVU7ZbWIudg7Py3SEctKsc7BlSlXQ8n8Cx+v9xmUmNyPbHcH/M0uYe15ibGZ7k4l7bXPwuGLpA1FQqEOzbnaMbAZRwDemzgnbi7XXYlHNYG9XxNmU0OI1VrIV5dcG+mQ==;type=STAT;ncc=22201',
    //             name: 'Mario Rossi',
    //             given_name: 'Mario',
    //             family_name: 'Rossi',
    //             x_fiscal_code_tim: 'RSSMRA89A01E472I',
    //             phone_number: '3333333333'
    //           }
    //         }
    //       })
    //     : Promise.resolve(undefined)

    return federationPromise.then(function (thirdPartyData) {
      var userInfo = void 0;

      if (partnership === 'HYPE4TIM') {
        if (!!thirdPartyData) {
          if (thirdPartyData.responseCode === '000') {
            userInfo = (0, _stringify2.default)(thirdPartyData.data.userInfo);
          } else {
            return _promise2.default.reject((0, _extends5.default)({}, thirdPartyData, { type: 'tim-unauthorized' }));
          }
        } else {
          return _promise2.default.reject({ type: 'tim-unauthorized' });
        }
      } else {
        userInfo = thirdPartyData;
      }

      return API.startOnboarding(partnership, convention, userInfo).then(function (json) {
        startJson = json;
        if (!!startJson && !!startJson.step && startJson.step.number === 1) {
          var requestbody = {};
          requestbody.Guid = startJson.step.guid;
          requestbody.plan = location.query && location.query.plan;
          // API.insertGUID(requestbody).then(json => {
          //   console.log(json)
          // })
        }
        return API.getProductInfo();
      }).then(function (jsonPc2) {
        dispatch(handleServerErrors(jsonPc2));

        var _getState9 = getState(),
            step = _getState9.step;

        if (!step.hasServerErrors) {
          dispatch((0, _productActions.updateProduct)(jsonPc2.data));
        }
        return startJson;
      });
    });
  };
};

/**
 * Starts the onboarding process
 * @public
 * @param  {string} partnership     partnership code
 * @param  {string} convention      convention code
 * @param  {Object} proof           The encrypted third party data container
 * @param  {boolean} reboot           reboot
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
var startProcess = exports.startProcess = function startProcess(_ref) {
  var partnership = _ref.partnership,
      convention = _ref.convention,
      proof = _ref.proof,
      reboot = _ref.reboot,
      location = _ref.location;
  return function (dispatch, getState) {
    var token = new ActionToken('step.startProcess');

    var _getState10 = getState(),
        initQuery = _getState10.routing.locationBeforeTransitions.query;

    /**
     * @remarks
     * no need to dispatch a dealActionToken action here because this is the initialization action.
     * DON'T DO IT otherwisethe App container will be rendered before the props are provided,
     * the result will be an awful error.
     */

    return API.getProductInfo().then(function (jsonPc) {
      if (jsonPc.status !== 'bad_request' && jsonPc.data.prodCode === partnership // @remarks keep this condition to avoid breaking changes on legacy flows
      /*(|| jsonPc.data.properties[jsonPc.data.prodCode].partnership ===
          partnership) &&
      jsonPc.data.properties[jsonPc.data.prodCode].convenzione ===
        convention &&
      !(partnership === 'HYPE4TIM' && !!initQuery.code)*/
      ) {
          dispatch((0, _productActions.updateProduct)(jsonPc.data));
          return API.getNextStep().then(function (json) {
            if (json.status === 'success' && !!json.step) {
              return json;
            } else throw json;
          }).catch(function (json) {
            if (json.status === 'error' && json.message.indexOf('invoke start api') > -1 || json.status === 'success' && !json.step) {
              return dispatch(startProcessWorker(partnership, convention, proof, location));
            } else {
              return json;
            }
          });
        } else {
        return dispatch(startProcessWorker(partnership, convention, proof, location));
      }
    }).then(function (json) {
      if (!!proof) {
        json.proof = proof;
      }

      var _getState11 = getState(),
          components = _getState11.components;

      dispatch(stepCallback(token, json)).then(function () {
        if (!!reboot) {
          (0, _keys2.default)(components).forEach(function (k) {
            var updatedBody = {
              value: components[k].value
            };

            if (k === 'SIGNALER-PROMO_CODE') {
              updatedBody.value = '';
              updatedBody.redirectRequired = false;
            }

            dispatch((0, _componentsActions.updateComponent)(k, updatedBody));
          });

          dispatch(getNextStep(proof));
        }
      });
    }).catch(function (err) {
      if (err.type === 'tim-unauthorized') {
        var _getState12 = getState(),
            routing = _getState12.routing;

        var mobileConnectUri = ((0, _utils.getEnv)() === 'pro' ? 'https://mobileconnect.mp.tim.it' : 'https://autenticazione.collaudo.telecomitalia.it') + '/OAUTHServer/OauthAuthorization';

        var redirectUri = void 0;

        if (routing.locationBeforeTransitions.query.redirect_uri) {
          redirectUri = '' + mobileConnectUri + routing.locationBeforeTransitions.search;
        } else {
          var appRoot = '' + location.origin + "/OnboardingPOS"; //'https://www.pp-hype.it/signup'

          redirectUri = mobileConnectUri + '?scope=' + encodeURIComponent('openid phone profile') + '&redirect_uri=' + encodeURIComponent(appRoot + ('/oauth-request/hype4tim/' + (!!initQuery.embedded ? 'embedded' : 'standalone'))) + '&response_type=code&client_id=HYPE&state=NOTREGISTERED&nonce=nonce_value&prompt=login&acr_values=' + encodeURIComponent('http://autenticazione.telecomitalia.it/SAM/assurance/Loa2&max_age=3600&login_hint=');
        }

        if (!!err.responseCode) {
          dispatch(handleServerErrors({
            status: 'error',
            message: err.type,
            redirectUri: redirectUri
          }));
        } else {
          location.href = redirectUri;
        }
      }
    });
  };
};

/**
 * Gets the user's contracts list
 * @public
 *
 * @param {string}      guid        The session guid
 * @return {Function}               Dispatches a SET_REQUEST_LIST action
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
var getUserRequests = exports.getUserRequests = function getUserRequests() {
  return function (dispatch, getState) {
    var token = new ActionToken('step.getUserRequests');

    dispatch(dealActionToken(token));
    return API.getUserRequests().then(function (json) {
      dispatch(handleServerErrors(json));

      var _getState13 = getState(),
          step = _getState13.step;

      if (!step.hasServerErrors) {
        dispatch((0, _widgetsActions.updateAllWidgets)({}));
        dispatch((0, _componentsActions.updateAllComponents)({}));
        dispatch({ type: SET_REQUEST_LIST, requestList: json.data });
      }
      dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
      return json;
    });
  };
};

/**
 * Opens the OTP sms prompt to recover an onboarding process
 * @public
 *
 * @param {string}      guid      The session guid
 * @return {Function}             Dispatches a REQUIRE_STEP_TO_RESUME_BY_VERIFICATION action
 */
var requireResumeOtpSms = exports.requireResumeOtpSms = function requireResumeOtpSms(guid) {
  return function (dispatch, getState) {
    dispatch(validateStep());

    var _getState14 = getState(),
        components = _getState14.components;

    if (!(0, _keys2.default)(components).find(function (k) {
      return (0, _utils.isEntityInvalid)(k, components);
    })) {
      var token = new ActionToken('step.requireResumeOtpSms');

      dispatch(dealActionToken(token));
      // const { components } = getState()
      var body = {
        cf: components['CODICE_FISCALE-CF'].value,
        mail: components['EMAIL-EMAIL'].value,
        numCell: components['CELLULARE-NUM_CELLULARE'].value,
        prefCell: components['CELLULARE-PREF_CELLULARE'].value
      };

      API.requireResumeOtpSms(body, guid).then(function (json) {
        if (!!json && json !== null) {
          dispatch(stepCallback(token, json));
        } else {
          //dispatch(hideLoading());
          dispatch(showAPIAlertModel());
          //return json
        }
      });
    }
  };
};

/**
 * Gets the user's contract list
 * @public
 *
 * @param {Array}      guids        The sessions guid
 * @return {Promise}                Dispatches a SET_CONTRACT_LIST action
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
var getContracts = exports.getContracts = function getContracts(guids) {
  return function (dispatch, getState) {
    var token = new ActionToken('step.getContracts');

    dispatch(dealActionToken(token));

    var contractsCallback = function contractsCallback(guid) {
      return API.getContracts(guid).then(function (json) {
        dispatch(handleServerErrors(json));
        return json.data.map(function (c) {
          c.guid = guid;
          return c;
        });
      });
    };

    return _promise2.default.all(guids.map(function (guid) {
      return contractsCallback(guid);
    })).then(function (json) {
      var _getState15 = getState(),
          step = _getState15.step;

      if (!step.hasServerErrors) {
        var _ref2;

        dispatch({ type: SET_CONTRACT_LIST, contractList: (_ref2 = []).concat.apply(_ref2, (0, _toConsumableArray3.default)(json)) });
      }
      dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
    });
  };
};

/**
 * Gets the user's contract list
 * @public
 *
 * @param {string}      guid          The session guid
 * @param {string}      flow          The flow code (partnership-convention)
 * @return {Function}                 Dispatches a UPDATE_STEP action
 */
var initRecoveryProcess = exports.initRecoveryProcess = function initRecoveryProcess(guid, flow) {
  return function (dispatch /*, getState*/
  ) {
    var token = new ActionToken('step.initRecoveryProcess');

    dispatch(dealActionToken(token));
    return API.initRecoveryProcess(guid).then(function (json) {
      if (json.step.name === 'list') {
        (0, _utils.pushRoute)('/status' + (!!flow ? '/' + flow : ''));
        //@remarks don't dispatch the stepCallback here
        //otherwise the components reducer or the extendModel method will fail
        dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
      } else if (json.step.name === 'validate') {
        json.step.widgets.find(function (_ref3) {
          var name = _ref3.name;
          return name === 'CELLULARE';
        }).components.find(function (_ref4) {
          var name = _ref4.name;
          return name === 'CODICE_CELLULARE';
        }).active = false;
        (0, _utils.pushRoute)('/resume' + (!!flow ? '/' + flow : ''));
        dispatch(stepCallback(token, json));
      }
    });
  };
};

/**
 * Resumes an onboarding process
 * @public
 *
 * @param {string}      guid          The session guid
 * @param {string}      flow          The flow code (partnership-convention)
 * @return {Promise}                  Dispatches a UPDATE_STEP action
 */
var initResumeProcess = exports.initResumeProcess = function initResumeProcess(guid, flow) {
  return function (dispatch, getState) {
    var token = new ActionToken('step.initResumeProcess');

    dispatch(dealActionToken(token));

    if (!!guid) {
      if (!!getState().step && !!getState().step.isUnderage) {
        dispatch({ type: SET_IS_UNDERAGE, isUnderage: null });
      }

      return API.initResumeProcess(guid).catch(function (ex) {
        return { status: 'error', message: ex };
      }).then(function (json) {
        if (json.status === 'redirect') {
          dispatch(initRecoveryProcess(guid, flow));
          dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
        } else {
          dispatch(stepCallback(token, json));
        }
      });
    } else {
      dispatch(initRecoveryProcess(guid, flow));
      dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
    }
  };
};

/**
 * Recovers an onboarding session after a successful OTP validation
 * @public
 *
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
var resumeProcess = exports.resumeProcess = function resumeProcess() {
  return function (dispatch, getState) {
    var token = new ActionToken('step.resumeProcess');

    var startJson = void 0;

    dispatch(dealActionToken(token));
    API.resumeProcess().then(function (json) {
      startJson = json;
      return API.getProductInfo();
    }).then(function (jsonPc) {
      dispatch(handleServerErrors(jsonPc));

      var _getState16 = getState(),
          step = _getState16.step;

      if (!step.hasServerErrors) {
        dispatch((0, _productActions.updateProduct)(jsonPc.data));
      }
      return startJson;
    }).then(function (json) {
      return dispatch(stepCallback(token, json));
    });
  };
};

/**
 * Recovers an onboarding session from the dossier list
 * @public
 *
 * @param  {string}     guid              The session guid
 * @return {Function}                     Dispatches a UPDATE_STEP action
 */
var resumeContactProcess = exports.resumeContactProcess = function resumeContactProcess(guid) {
  return function (dispatch, getState) {
    var token = new ActionToken('step.resumeContactProcess');

    dispatch(dealActionToken(token));

    var startJson = void 0;

    API.resumeContactProcess(guid).then(function (json) {
      startJson = json;
      return API.getProductInfo();
    }).then(function (jsonPc) {
      dispatch(handleServerErrors(jsonPc));

      var _getState17 = getState(),
          step = _getState17.step;

      if (!step.hasServerErrors) {
        dispatch((0, _productActions.updateProduct)(jsonPc.data));
      }
      return startJson;
    }).then(function (json) {
      return dispatch(stepCallback(token, json));
    });
  };
};

/**
 * Resumes reupload of document in  onboarding process
 * @public
 *
 * @param  {string}      guid         The session guid
 * @param  {string}      barCode      The document barCode
 * @param  {string}      docType      The document type
 * @param  {Boolean}     showSelfie   Establishes if the selfie widget should be added to the mock
 * @return {Promise}                  Dispatches a UPDATE_STEP action
 */
var initReuploadProcess = exports.initReuploadProcess = function initReuploadProcess(guid, barCode, docType, showSelfie) {
  return function (dispatch /*, getState*/
  ) {
    var token = new ActionToken('step.initReuploadProcess');

    dispatch(dealActionToken(token));
    var json = API.initReuploadProcess(guid, barCode, docType, showSelfie);
    dispatch(stepCallback(token, json));
  };
};

/**
 * Complete contract to reupload and redirect to final step
 * @public
 * @param  {string}      guid         The session guid
 * @param  {string}      barCode1     The document barcode1
 * @param  {string}      barCode2     The document barcode2
 * @return {Function}                 Dispatches a UPDATE_STEP action
 */
var completeReupload = exports.completeReupload = function completeReupload(guid, barCode1, barCode2) {
  return function (dispatch, getState) {
    var token = new ActionToken('step.completeReupload');

    dispatch(dealActionToken(token));
    API.completeReupload(guid, barCode1, barCode2).then(function (json) {
      dispatch(handleServerErrors(json));

      var _getState18 = getState(),
          step = _getState18.step;

      if (!step.hasServerErrors) {
        dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
        (0, _utils.pushRoute)('/status');
      }
    });
  };
};

/**
 * Validates a resume OTP
 * @public
 *
 * @param  {Object}   component     The component that contains the OTP
 * @return {Function}               Dispatches a UPDATE_STEP action
 */
var validateResumeOtp = exports.validateResumeOtp = function validateResumeOtp(component, flow) {
  return function (dispatch, getState) {
    dispatch(validateStep());

    var _getState19 = getState(),
        componentsToCheck = _getState19.components;

    if (!(0, _keys2.default)(componentsToCheck).find(function (k) {
      return (0, _utils.isEntityInvalid)(k, componentsToCheck);
    })) {
      var token = new ActionToken('step.validateResumeOtp');

      dispatch(dealActionToken(token));

      var _getState20 = getState(),
          initialComponents = _getState20.components;

      API.validateResumeOtp(component.value, !initialComponents['RESUME_BY_CELL-GUID_PROCESSO'].value).then(function (json) {
        dispatch(handleServerErrors(json));

        var _getState21 = getState(),
            step = _getState21.step,
            components = _getState21.components;

        if (!step.hasServerErrors) {
          if (!!components['RESUME_BY_CELL-GUID_PROCESSO'].value) {
            dispatch(resumeProcess());
          } else {
            dispatch(initRecoveryProcess(components['RESUME_BY_CELL-GUID_PROCESSO'].value, flow));
          }
        }
        dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
      });
    }
  };
};
var GetPOSPlan = exports.GetPOSPlan = function GetPOSPlan(stepNumber, productcode, guid) {
  var url = 'OnboardRequestDetails/FetchPOSPlan';
  var body = { GUID: guid };
  (0, _api2.FetchPOSPlan)(url, body).then(function (json) {
    var dbplan = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toUpperCase();
    var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
    json.payLoad.plan = planMap[dbplan] || 'flat';
  });
};
var urlParam = exports.urlParam = function urlParam(name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
};
var removeFabrickPrivacy = exports.removeFabrickPrivacy = function removeFabrickPrivacy(widgets, components) {
  if (!!widgets["POSPLAN"]) {
    delete widgets["POSPLAN"];
  }
  if (!!widgets["PRIVACY_FABRICK"]) {
    delete widgets["PRIVACY_FABRICK"];
  }
  if (!!components['POSPLAN-PLAN']) {
    delete components['POSPLAN-PLAN'];
  } else if (!!components["PRIVACY_FABRICK-FABCHECKBOX"]) {
    delete components["PRIVACY_FABRICK-FABCHECKBOX"];
  }
};
/**
 * Gets the next step in the onboarding process
 * @public
 * @param {Object} proof           The encrypted third party data container
 * @return {Function}               Dispatches a NEXT_STEP action
 */
var getNextStep = exports.getNextStep = function getNextStep(proof) {
  return function (dispatch, getState) {
    dispatch(validateStep());

    var token = new ActionToken('step.getNextStep');

    dispatch(dealActionToken(token));

    var checkPendingActions = function checkPendingActions() {
      var _getState22 = getState(),
          widgets = _getState22.widgets,
          components = _getState22.components,
          step = _getState22.step,
          product = _getState22.product;

      if (!!widgets["POSPLAN"]) {
        delete widgets["POSPLAN"];
      }
      if (!!components['POSPLAN-PLAN']) {
        delete components['POSPLAN-PLAN'];
      }
      //removeFabrickPrivacy(widgets,components)
      //acolQuestionnaire widget issue - begin
      if (!!components['SEDE_LEGALE-NAZIONE'] && !!components['SEDE_LEGALE-NAZIONE'].value) {
        components['SEDE_LEGALE-NAZIONE'].value = components['SEDE_LEGALE-NAZIONE'].value.toUpperCase();
      }
      //acolQuestionnaire widget issue - end
      if (!!components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'] && !!components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value && components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value.indexOf('-') === -1 && components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value.indexOf('+') === -1) {
        components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value = "+" + components['CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO'].value;
      }

      if (step.pendingActions.filter(function (a) {
        return !a.blocking;
      }).length > 0) {
        window.setTimeout(checkPendingActions, 100);
      } else {
        if (step.number === 5 && product.partnership === _utils.posProducts.prodAzienda && !!widgets["TITOLARE_EFFETTIVO"] && !!widgets["TITOLARE_EFFETTIVO"].status && widgets["TITOLARE_EFFETTIVO"].status[0] === 'ignoreValidation' && !!components["TITOLARE_DATA-EFFETTIVO_SI"] && components["TITOLARE_DATA-EFFETTIVO_SI"].value === '' && !!components["TITOLARE_DATA-EFFETTIVO_NO"] && components["TITOLARE_DATA-EFFETTIVO_NO"].value === '') {
          var tocomponents = Model.Titolare_Effectivo_EmptyJSONResponse;
          API.saveTitolare(tocomponents, step.number, widgets).then(function (json) {
            if (json.status === 'success') {
              if (!!proof) {
                json.proof = proof;
              }
              //GetPOSPlan(step.number,product.partnership,step.guid)
              dispatch(stepCallback(token, json, widgets, components));
            }
          });
        } else {
          if (!(0, _keys2.default)(components).find(function (k) {
            return (0, _utils.isEntityInvalid)(k, components);
          })) {
            if (!!components['SIGNALER-PROMO_CODE'] && !!components['SIGNALER-PROMO_CODE'].redirectRequired) {
              dispatch(startProcess({
                partnership: product.partnership,
                convention: components['SIGNALER-PROMO_CODE'].value.toUpperCase(),
                proof: proof,
                reboot: true
              })).then(function () {
                dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
              });
            } else {
              //save Pg call
              if (Model.savePG && step.number === 4 && !!components['AZIENDA_ANTIRICICLAGGIO-QUESTIONARIO'] || Model.savePG && step.number === 3 && !!components['ANTIRICICLAGGIO-QUESTIONARIO']) {

                //acolQuestionnaire widget issue - begin
                if (Model.savePG && !!Model.savePG.data && !!Model.savePG.data.acolQuestionnaire) {
                  buildSavePg(Model.savePG, components);
                }
                //acolQuestionnaire widget issue - end
                API.savePg(Model.savePG, step.number).then(function (jsonPg) {
                  if (jsonPg.status === 'success') {
                    API.getNextStep(widgets, components, step.number).then(function (json) {
                      if (!!proof) {
                        json.proof = proof;
                      }
                      //(step.number,product.partnership,step.guid)
                      dispatch(stepCallback(token, json, widgets, components));
                    });
                  } else {
                    dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
                    dispatch(handleServerErrors(jsonPg));
                  }
                });
              } else if (step.number === 5 && product.partnership === _utils.posProducts.prodAzienda) {
                var _tocomponents = buildTitolareRequest(step.titolareList);
                API.saveTitolare(_tocomponents, step.number, widgets).then(function (json) {
                  if (json.status === 'success') {
                    if (!!proof) {
                      json.proof = proof;
                    }
                    //GetPOSPlan(step.number,product.partnership,step.guid)
                    dispatch(stepCallback(token, json, widgets, components));
                  }
                });
              } else if (step.number === 6 && product.partnership === _utils.posProducts.prodAzienda || step.number === 4 && product.partnership === _utils.posProducts.prodPersonaFisica || step.number === 5 && product.partnership === _utils.posProducts.prodDittaInd) {
                API.FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID: step.guid }).then(function (json) {

                  var privacyfabrick = !!json && !!json.payLoad && json.payLoad.PrivacyFK;
                  modifyPrivacyFabrick(privacyfabrick, step, components, product, _utils.posProducts);
                  var toWidgets = buildPersonalizzaPOSRequest(widgets, components, step);
                  API.savePersonalizzaPOS(toWidgets, step.number).then(function (json) {
                    if (json.status === 'success') {
                      if (!!proof) {
                        json.proof = proof;
                      }
                      //GetPOSPlan(step.number,product.partnership,step.guid)
                      dispatch(stepCallback(token, json, widgets, components));
                    }
                  });
                });
              } else {
                var promoCodeComp = {};
                promoCodeComp.PRIVACYFK = !!components["PRIVACY_FABRICK-FABCHECKBOX"] && components["PRIVACY_FABRICK-FABCHECKBOX"].value === "selected" ? "1" : "0";
                removeFabrickPrivacy(widgets, components);
                if (step.number === 1) {
                  var queryParam = urlParam('plan');
                  var queryrefParam = urlParam('ref');
                  promoCodeComp.ContactId = !!step.contactId ? step.contactId : '';
                  promoCodeComp.Guid = step.guid;
                  promoCodeComp.CodiceFiscale = components["CODICE_FISCALE-CF"].value;
                  promoCodeComp.MerchantName = '';
                  promoCodeComp.VatNumber = !!components["PARTITA_IVA-NUM_PARTITA_IVA"] && components["PARTITA_IVA-NUM_PARTITA_IVA"].value ? components["PARTITA_IVA-NUM_PARTITA_IVA"].value : "";
                  promoCodeComp.PromoCode = queryrefParam; //!!components["PROMO-PromoCode"] && components["PROMO-PromoCode"].value ? components["PROMO-PromoCode"].value : ""
                  promoCodeComp.SalesManID = !!components["PROMO-PromoCode"] && components["PROMO-PromoCode"].salesManId ? components["PROMO-PromoCode"].salesManId : "";
                  promoCodeComp.CreationDate = '';
                  promoCodeComp.ModifiedDate = '';
                  promoCodeComp.Nome = !!components["NOME_COGNOME-NOME"] && components["NOME_COGNOME-NOME"].value ? components["NOME_COGNOME-NOME"].value : "";
                  promoCodeComp.Email = !!components["EMAIL-EMAIL"] && components["EMAIL-EMAIL"].value ? components["EMAIL-EMAIL"].value : "";
                  var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
                  promoCodeComp.PLAN = planMap[queryParam && queryParam.toUpperCase()] || 'flat';
                  if (product.prodCode === 'POS_AZIENDA_EASYNOLO' || product.prodCode === 'POS_DITTA_IND_EASYNOLO') {
                    promoCodeComp.RagioneSociale = !!components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"] && components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value ? components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value : "";
                  }
                }

                setTimeout(function () {
                  API.getNextStep(widgets, components, step.number).then(function (json) {
                    if (!!proof) {
                      json.proof = proof;
                    }

                    if (!!json.step && json.step.number === 2) {
                      promoCodeComp.ContactId = !!json.step.contactId ? json.step.contactId : '';
                      API.fetchIPAddress().then(function (data) {
                        promoCodeComp.ClientIP = !!data && !!data.ip ? data.ip : '';
                        var metadatabody = {
                          guid: json.step.guid,
                          metaKey: "LAST_EXT_CLIENT_IP",
                          metaValue: promoCodeComp.ClientIP
                        };
                        API.insertPromoCode(promoCodeComp).then(function (json) {
                          Metadata(metadatabody).then(function (response) {});
                          console.log("Inserted details in step 1", json);
                        });
                      }).catch(function (err) {
                        API.insertPromoCode(promoCodeComp).then(function (json) {
                          console.log("Inserted details in step 1", json);
                        });
                      });
                    }
                    dispatch(stepCallback(token, json, widgets, components));
                  });
                }, 1000);
              }
              if (product.prodCode === 'POS_AZIENDA_EASYNOLO' && ( /*step.number === 1 ||*/step.number === 3 || step.number === 6 || step.number === 2) || product.prodCode === 'POS_DITTA_IND_EASYNOLO' && ( /*step.number === 1 ||*/step.number === 3 || step.number === 5 || step.number === 4) || product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && (step.number === 2 || step.number === 3 || step.number === 4)) {
                var body = null;

                if (product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 3 || product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 3) {
                  var provincia = components["SEDE_LEGALE-PROVINCIA"].values.find(function (el) {
                    return el.value === components["SEDE_LEGALE-PROVINCIA"].value;
                  });
                  body = {
                    Guid: step.guid,
                    INDIRIZZO: !!components["SEDE_LEGALE-INDIRIZZO"] && components["SEDE_LEGALE-INDIRIZZO"].value ? components["SEDE_LEGALE-INDIRIZZO"].value : "",
                    CITTA: !!components["SEDE_LEGALE-CITTA"] && components["SEDE_LEGALE-CITTA"].value ? components["SEDE_LEGALE-CITTA"].value : "",
                    //PROVINCIA: !!components["SEDE_LEGALE-PROVINCIA"] && components["SEDE_LEGALE-PROVINCIA"].value ? components["SEDE_LEGALE-PROVINCIA"].value : ""
                    PROVINCIA: !!components["SEDE_LEGALE-PROVINCIA"] && components["SEDE_LEGALE-PROVINCIA"].value ? components["SEDE_LEGALE-PROVINCIA"].value + "-" + provincia["description"] : ""
                  };
                } else if (product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && step.number === 2) {
                  var _provincia = components["RESIDENZA-PROVINCIA"].values.find(function (el) {
                    return el.value === components["RESIDENZA-PROVINCIA"].value;
                  });
                  body = {
                    Guid: step.guid,
                    INDIRIZZO: !!components["RESIDENZA-INDIRIZZO"] && components["RESIDENZA-INDIRIZZO"].value ? components["RESIDENZA-INDIRIZZO"].value : "",
                    CITTA: !!components["RESIDENZA-CITTA"] && components["RESIDENZA-CITTA"].value ? components["RESIDENZA-CITTA"].value : "",
                    //PROVINCIA: !!components["RESIDENZA-PROVINCIA"] && components["RESIDENZA-PROVINCIA"].value ? components["RESIDENZA-PROVINCIA"].value : ""
                    PROVINCIA: !!components["RESIDENZA-PROVINCIA"] && components["RESIDENZA-PROVINCIA"].value ? components["RESIDENZA-PROVINCIA"].value + "-" + _provincia["description"] : ""
                  };
                } else if (product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 6 || product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 5 || product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && step.number === 4) {
                  body = {
                    Guid: step.guid,
                    INSEGNA: !!components["S1-S1S1D1"] && components["S1-S1S1D1"].value ? components["S1-S1S1D1"].value : "",
                    DATAPROCESSINGVISIONE: !!components["S11-S11S0D11"] && components["S11-S11S0D11"].value === "selected" ? "1" : "0",
                    PRESERVEDOCUMENTATIONVISIONE: !!components["S11-S11S1D11"] && components["S11-S11S1D11"].value === "selected" ? "1" : "0",
                    DETECTIONVISIONE: !!components["S11-S11S2D11"] && components["S11-S11S2D11"].value === "selected" ? "1" : "0",
                    DATACOMMUNICATIONVISIONE: !!components["S11-S11S3D11"] && components["S11-S11S3D11"].value === "selected" ? "1" : "0",
                    PROFILINGVISIONE: !!components["S11-S11S4D11"] && components["S11-S11S4D11"].value === "selected" ? "1" : "0"
                  };
                  if (!!components["S1-S1S0D10"] && components["S1-S1S0D10"].value === 'selected') {
                    body.INDIRIZZO = !!components["S1-INDIRIZZO"] && components["S1-INDIRIZZO"].value ? components["S1-INDIRIZZO"].value : "";
                    body.CITTA = !!components["S1-CITTA"] && components["S1-CITTA"].value ? components["S1-CITTA"].value : "";
                    body.PROVINCIA = !!components["S1-PROVINCIA"] && components["S1-PROVINCIA"].value ? components["S1-PROVINCIA"].value : "";
                  }
                }
                // else if ((product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 1) ||
                //   (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 1)) {
                //   body = {
                //     Guid: step.guid,
                //     RAGIONESOCIALE: !!components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"] && components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value ? components["DENOMINAZIONE_AZIENDA-DENOMINAZIONE"].value : ""
                //   }
                // }
                else if (product.prodCode === 'POS_PERSONA_FISICA_EASYNOLO' && step.number === 3) {
                    body = {
                      Guid: step.guid,
                      RAGIONESOCIALE: !!components["SZ0009-SS0010_DM0024_RI0019"] && components["SZ0009-SS0010_DM0024_RI0019"].value ? components["SZ0009-SS0010_DM0024_RI0019"].value : "",
                      DATISENSIBILIVISIONE: !!components["DATI_SENSIBILI-VISIONE"] && components["DATI_SENSIBILI-VISIONE"].value === "selected" ? "1" : "0",
                      CRONISTORIAVISIONE: !!components["CRONISTORIA-VISIONE"] && components["CRONISTORIA-VISIONE"].value === "selected" ? "1" : "0",
                      PROMOZIONEVISIONE: !!components["PROMOZIONE-VISIONE"] && components["PROMOZIONE-VISIONE"].value === "selected" ? "1" : "0",
                      PROMOZIONETERZIVISIONE: !!components["PROMOZIONE_TERZI-VISIONE"] && components["PROMOZIONE_TERZI-VISIONE"].value === "selected" ? "1" : "0",
                      PROFILAZIONEVISIONE: !!components["PROFILAZIONE-VISIONE"] && components["PROFILAZIONE-VISIONE"].value === "selected" ? "1" : "0"
                    };
                  } else if (product.prodCode === 'POS_AZIENDA_EASYNOLO' && step.number === 2) {
                    body = {
                      Guid: step.guid,
                      DATISENSIBILIVISIONE: !!components["DATI_SENSIBILI-VISIONE"] && components["DATI_SENSIBILI-VISIONE"].value === "selected" ? "1" : "0",
                      CRONISTORIAVISIONE: !!components["CRONISTORIA-VISIONE"] && components["CRONISTORIA-VISIONE"].value === "selected" ? "1" : "0",
                      PROMOZIONEVISIONE: !!components["PROMOZIONE-VISIONE"] && components["PROMOZIONE-VISIONE"].value === "selected" ? "1" : "0",
                      PROMOZIONETERZIVISIONE: !!components["PROMOZIONE_TERZI-VISIONE"] && components["PROMOZIONE_TERZI-VISIONE"].value === "selected" ? "1" : "0",
                      PROFILAZIONEVISIONE: !!components["PROFILAZIONE-VISIONE"] && components["PROFILAZIONE-VISIONE"].value === "selected" ? "1" : "0"
                    };
                  } else if (product.prodCode === 'POS_DITTA_IND_EASYNOLO' && step.number === 4) {
                    body = {
                      Guid: step.guid,
                      DATISENSIBILIVISIONE: !!components["DATI_SENSIBILI-VISIONE"] && components["DATI_SENSIBILI-VISIONE"].value === "selected" ? "1" : "0",
                      CRONISTORIAVISIONE: !!components["CRONISTORIA-VISIONE"] && components["CRONISTORIA-VISIONE"].value === "selected" ? "1" : "0",
                      PROMOZIONEVISIONE: !!components["PROMOZIONE-VISIONE"] && components["PROMOZIONE-VISIONE"].value === "selected" ? "1" : "0",
                      PROMOZIONETERZIVISIONE: !!components["PROMOZIONE_TERZI-VISIONE"] && components["PROMOZIONE_TERZI-VISIONE"].value === "selected" ? "1" : "0",
                      PROFILAZIONEVISIONE: !!components["PROFILAZIONE-VISIONE"] && components["PROFILAZIONE-VISIONE"].value === "selected" ? "1" : "0"
                    };
                  }

                API.updateOnboardingDetails(body);
              }
            }
          } else {
            var invalidAddressComponentKey = (0, _keys2.default)(components).find(function (k) {
              return components[k].status.indexOf('error') > -1 && components[k].name === 'INDIRIZZO' && components[k].values.length > 0;
            });

            if (!!invalidAddressComponentKey) {
              dispatch(showAddressModal(components[invalidAddressComponentKey]));
            }

            (0, _utils.scrollToFirstInvalidComponent)(components);
            dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
          }
        }
      }
    };

    checkPendingActions();
  };
};

/**
 * Gets the previous step in the onboarding process
 * @public
 * @param  {Object} proof proof
 *
 * @return {Function}  dispatches a PREV_STEP action
 */
var getPrevStep = exports.getPrevStep = function getPrevStep(proof) {
  return function (dispatch, getState) {
    var token = new ActionToken('step.getPrevStep');

    dispatch(dealActionToken(token));

    var _getState23 = getState(),
        widgets = _getState23.widgets,
        components = _getState23.components;

    dispatch({ type: USER_COUNTER, userCounter: 0 });
    dispatch({
      type: SET_TITOLARE_LIST,
      titolareList: []
    });
    return API.getPrevStep().then(function (json) {
      return dispatch(stepCallback(token, (0, _extends5.default)({}, json, { proof: proof }), widgets, components));
    });
  };
};

/**
 * Hides a modal if there are server errors
 * @public
 *
 * @return {Function}   Dispatches an HANDLE_SERVER_ERRORS action
 */
var hideModal = exports.hideModal = function hideModal() {
  return {
    type: HANDLE_SERVER_ERRORS,
    hasServerErrors: false,
    serverErrorMessage: ''
  };
};

var thanks = exports.thanks = function thanks(parentGuid) {
  return function (dispatch, getState) {
    var _getState24 = getState(),
        step = _getState24.step;

    var token = new ActionToken('step.thanks');

    if (!!step.contactId) {
      getStoredState().updateSession(step.contactId, step.guid, step.number, !!step.isParent);
    }

    var thanksJSON = API.initThankYouPage(step.contactId, parentGuid);
    thanksJSON.step.guid = step.guid;
    thanksJSON.step.number = step.number + 1;
    thanksJSON.step.last = false;
    dispatch(stepCallback(token, thanksJSON));
  };
};

var acknowledgeContract = exports.acknowledgeContract = function acknowledgeContract() {
  return function (dispatch, getState) {
    var _getState25 = getState(),
        step = _getState25.step,
        components = _getState25.components,
        widgets = _getState25.widgets;

    var token = new ActionToken('step.acknowledgeContract');

    // Coupon start
    var posPlanInQueryString = urlParam('plan');
    var promoCodeComp = {};
    promoCodeComp.PromoCode = components["PROMO-PromoCode"] && components["PROMO-PromoCode"].value ? components["PROMO-PromoCode"].value : "";
    promoCodeComp.Guid = step.guid;
    if (promoCodeComp.PromoCode) {
      var userReqBody = {};
      var sendMailPromoCode = {};
      var promoCodeValue = components["PROMO-PromoCode"].value;
      API.FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID: step.guid }).then(function (json) {
        if (json && json.payLoad) {
          //CheckUserExists API data
          userReqBody.PromoCode = components["PROMO-PromoCode"].value, userReqBody.CodiceFiscale = json.payLoad.CodiceFisicale, userReqBody.VatNumber = json.payLoad.Vatnumber;
          //SendMail API Data
          sendMailPromoCode.Guid = step.guid, sendMailPromoCode.ContactId = step.contactId, sendMailPromoCode.FirstName = json.payLoad.FirstName, sendMailPromoCode.Email = json.payLoad.Email,
          //sendMailPromoCode.PromoCode=promoCodeComp.PromoCode,
          sendMailPromoCode.Plan = posPlanInQueryString;
        }
        API.ValidatePromoCode('PromoCodeManagement/ValidatePromoCode', { promocode: promoCodeValue, plan: posPlanInQueryString, PivaORCodicefisicale: !!userReqBody ? userReqBody.CodiceFiscale : '' }).then(function (res) {
          var couponValidation = res.error && res.error.description ? [res.error.description] : "";
          if (couponValidation) {
            var component = components["PROMO-PromoCode"];
            var updateBody = {};
            updateBody.status = (0, _lodash.union)(components["PROMO-PromoCode"].status, ['error']);
            updateBody.errorMessage = couponValidation;

            dispatch({
              type: UPDATE_COMPONENT,
              component: (0, _extends5.default)({}, updateBody, { id: component.id })
            });
            dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
          } else {
            promoCodeComp.SalesManID = res.payLoad.SalesManId;
            API.ValidateUser('OnboardRequestDetails/CheckUserExists', userReqBody).then(function (response) {
              var userValidation = !!response.error && !!response.error.description ? [response.error.description] : "";
              if (userValidation) {
                var _component = components["PROMO-PromoCode"];
                var _updateBody = {};
                //updateBody.status = union(components["PROMO-PromoCode"].status, ['error'])
                _updateBody.errorMessage = userValidation;

                dispatch({
                  type: UPDATE_COMPONENT,
                  component: (0, _extends5.default)({}, _updateBody, { id: _component.id })
                });
                dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
              } else {
                promoCodeComp.promoCode = res.payLoad.PromoCode;
                API.updateOnboardingDetails(promoCodeComp).then(function (json) {
                  sendMailPromoCode.IsReferalCode = res.payLoad.IsReferalCode;
                  sendMailPromoCode.PromoCode = res.payLoad.PromoCode;
                  API.SendMailWithPromoCode(sendMailPromoCode).then(function (json) {
                    console.log("Mail sent successfully");
                  });
                  acknowledgeContractFinal(dispatch, getState);
                });
              }
            });
          }
        });
      });
      // Coupon end
    } else {
      API.FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', { GUID: step.guid }).then(function (json) {
        if (json && json.payLoad) {
          var _sendMailPromoCode = {
            Guid: step.guid,
            ContactId: step.contactId,
            FirstName: json.payLoad.FirstName,
            Email: json.payLoad.Email,
            PromoCode: promoCodeComp.PromoCode,
            Plan: posPlanInQueryString,
            IsReferalCode: false
          };
          var ReferalCodeComp = {
            PromoCode: "",
            Guid: step.guid
          };
          API.UpdateReferalCode(ReferalCodeComp).then(function (json) {
            API.SendMailWithPromoCode(_sendMailPromoCode).then(function (json) {
              console.log("Mail sent successfully");
            });
          });
          acknowledgeContractFinal(dispatch, getState);
        }
      });
    }
  };
};

var getCurrentDate = function getCurrentDate() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  return dd + '/' + mm + '/' + yyyy;
};

var acknowledgeContractFinal = function acknowledgeContractFinal(dispatch, getState) {
  var _getState26 = getState(),
      step = _getState26.step,
      components = _getState26.components,
      widgets = _getState26.widgets;

  var token = new ActionToken('step.acknowledgeContract');

  dispatch(dealActionToken(token));
  API.acknowledgePOSContract({ step: step, components: components, widgets: widgets }).then(function (stepJson) {
    dispatch(handleServerErrors(stepJson));

    var _getState27 = getState(),
        newStep = _getState27.step;

    if (!newStep.hasServerErrors) {
      if (!!step.auth && !!step.auth.tokenId) {
        dispatch(logout());
      }

      var date = new Date();
      var body = {
        Guid: step.guid,
        // OnBoardCompletionDt: (date.getUTCDate() + '/' + date.getUTCMonth()+1 + '/' + date.getUTCFullYear())
        OnBoardCompletionDt: getCurrentDate()
      };
      API.updateOnboardingDetails(body);

      dispatch(thanks(!!components['TERMINA_PROCEDURA-RESUME_INTEST_2'] && components['TERMINA_PROCEDURA-RESUME_INTEST_2'].value));
    }
    dispatch(dealActionToken((0, _extends5.default)({}, token, { dispose: true })));
  });
};

/**
 * Create a Pg save request and dispatch the request
 * @public
 * @param  {Object} savePG        The savePG
 * @param  {Object} components     The component
 */
var buildSavePg = exports.buildSavePg = function buildSavePg(savePG, components) {
  //const section = savePG.data.acolQuestionnaire.sections.section
  var currEnabled = {
    subSections: [],
    questions: [],
    answers: []
  };
  (0, _keys2.default)(components).forEach(function (key) {
    var currentComponents = components[key];
    if (currentComponents.isSubSection && currentComponents.refId && currentComponents.id_) {
      currEnabled.subSections.push(currentComponents.id_);
    } else if (currentComponents.isQuestion && currentComponents.refId && currentComponents.id_) {
      currEnabled.questions.push(currentComponents.id_);
    } else if (currentComponents.isAnswer && currentComponents.id_) {
      currEnabled.answers.push(currentComponents.id_);
      // if (
      //   currentComponents.linkId !== null &&
      //   currentComponents.field !== undefined &&
      //   currentComponents.field.linkValue !== null
      // ) {
      //   updateSavePg(savePG, currentComponents)
      // }
      updateSavePg(savePG, currentComponents);
    }
  });
  savePG.data.acolQuestionnaire.currentEnabled = currEnabled;
  Model.savePG = savePG;
};

var PersonalizzaPOSRequestType = {
  TEXTBOX: 'text',
  TEXTAREA: 'text',
  RADIO: 'radio',
  COMBO: 'combo',
  selectbox: 'combo',
  PHONE: 'phone',
  CHECKBOX: 'checkbox',
  NUMBER: 'text',
  ADDRESS: 'address',
  UPLOAD: 'upload'
};
var modifyPrivacyFabrick = exports.modifyPrivacyFabrick = function modifyPrivacyFabrick(privacyfabrick, step, components, product, posProducts) {
  if (step.number === 6 && product.partnership === posProducts.prodAzienda && !!components["S11-S11S2D11"]) {
    components["S11-S11S2D11"].value = privacyfabrick === "1" ? "1" : "0";
  } else if (step.number === 4 && product.partnership === posProducts.prodPersonaFisica && !!components["S11-S11S2D11"]) {
    components["S11-S11S2D11"].value = privacyfabrick === "1" ? "1" : "0";
  } else if (step.number === 5 && product.partnership === posProducts.prodDittaInd && !!components["S11-S11S2D11"]) {
    components["S11-S11S2D11"].value = privacyfabrick === "1" ? "1" : "0";
  }
};
var buildPersonalizzaPOSRequest = exports.buildPersonalizzaPOSRequest = function buildPersonalizzaPOSRequest(widgets, components, step) {
  var toWidgets = [];
  var widget = {};
  var PRODUCT_PLUGIN = null;
  try {
    PRODUCT_PLUGIN = step.config.widget.PRODUCT_PLUGIN;
    widget.code = PRODUCT_PLUGIN.code;
  } catch (e) {
    widget.code = '';
  }
  widget.components = [];
  var component = {};
  component.name = 'PLUGIN_USER_INPUT';
  component.rawValue = {};
  component.rawValue.section = [];

  if (PRODUCT_PLUGIN && PRODUCT_PLUGIN.components) {
    var PLUGIN_TEMPLATE = PRODUCT_PLUGIN.components.find(function (c) {
      return c.name === 'PLUGIN_TEMPLATE';
    });
    var cList_ = (0, _values2.default)(components).filter(function (c) {
      return c.id === 'S11-S11S2D11' || c.id === 'S11-S11S0D11' || c.active === true && c.type !== 'spacer' && (c.type !== 'radio' || c.type === 'radio' && c.value === 'selected') && (c.type !== 'checkbox' || c.type === 'checkbox' && c.value === 'selected');
    });
    var sections = PLUGIN_TEMPLATE.rawValue.sections;
    var fields = [];
    var field = null;
    if (sections) {
      sections.forEach(function (s) {
        var section = null;
        fields = [];
        s.fields.forEach(function (f) {
          var cList = (0, _values2.default)(cList_).filter(function (c) {
            return c.name.startsWith(f.id) || c.addressId && c.addressId === f.id;
          });
          field = null;
          if (cList && cList.length) {
            cList.forEach(function (c) {
              /*    field =
                   field ||
                   (fields.length
                     ? fields.find(
                         f_ =>
                           f_.fieldId === c.fieldId ||
                           (c.addressId && c.addressId === f_.fieldId)
                       )
                     : null) */
              field = field || {
                fieldId: f.id,
                fieldDescription: !c.addressId && c.cleanName || '',
                fieldType: PersonalizzaPOSRequestType[f.type] || PersonalizzaPOSRequestType[c.type] || c.type
              };
              if (f.type === 'ADDRESS' && c.addressId && c.addressId === f.id || (f.type === 'PHONE' || f.type === 'UPLOAD') && c.fieldId && c.fieldId === f.id) {
                field.fieldValue = field.fieldValue || [];
                if (f.type === 'UPLOAD') {
                  field.fieldValue.push({
                    description: 'FILE_NAME',
                    value: c.fileName
                  });
                  field.fieldValue.push({
                    description: 'DOC_REF_ID',
                    value: s.id + '##' + f.id
                  });
                } else {
                  field.fieldValue.push({
                    description: f.type === 'PHONE' ? c.description : c.name,
                    value: c.value
                  });
                }
              } else {
                field.fieldValue = /* field.fieldValue || */[];
                field.fieldValue.push({
                  description: c.type === 'text' && c.cleanName || c._description || c.description || c.cleanName,
                  value: c.type === 'radio' || c.type === 'checkbox' && c.id !== "S11-S11S2D11" ? c._code : c.value
                });
                if (f.type === 'COMBO' && c.values && c.values.length) {
                  var valueObj = c.values.find(function (v) {
                    return v.value === field.fieldValue[0].value;
                  });
                  if (valueObj && valueObj.label) {
                    field.fieldValue[0].description = valueObj.label;
                  }
                }
              }
            });
          }
          if (field) {
            if (fields.length) {
              fields = fields.map(function (field_) {
                return field_.fieldId === field.fieldId ? field : field_;
              });
            }
            if (fields.indexOf(field) === -1) {
              fields.push(JSON.parse((0, _stringify2.default)(field)));
            }
          }
        });
        if (fields.length) {
          section = {
            hidden: false,
            sectionId: s.id,
            sectionTitle: s.title || '',
            field: JSON.parse((0, _stringify2.default)(fields))
          };
          component.rawValue.section.push(section);
        }
      });
    }
  }

  widget.components.push(component);

  toWidgets.push(widget);
  return toWidgets;
};

var buildTitolareRequest = exports.buildTitolareRequest = function buildTitolareRequest(titolareList) {
  var resComponents = [];
  if (!!titolareList && titolareList.length >= 1) {
    var dpdKey = null;
    var toComponents = [{
      name: 'TITOLARE_EFFETTIVO_DATA',
      rawValue: {
        titolare_effettivo: []
      }
    }];

    var TYPES = {
      cf: 'codiceFiscale',
      nome: 'nome',
      cognome: 'cognome',
      datadinascita: 'dataDiNascita',
      sesso: 'sesso',
      luogodinascita: 'luogoDiNascita',
      provinciadinascita: 'provinciaDiNascita',
      meseAnno: 'meseAnno'
    };
    titolareList.map(function (user) {
      var tempUser = {
        id: '',
        legale_repre: '',
        directPep: '',
        indirectPep: '',
        criterioApplicato: '',
        datiContatto: {},
        residenza: {},
        documento: {
          doc_type: 'TEDOC',
          doc_ref_id: '',
          docr_upload: '',
          docf_upload: ''
        },
        directPepDetail: {},
        indirectPepDetail: {}
      };

      tempUser.id = user.id + 1;
      if (user.userComponents['TITOLARE_DATA-EFFETTIVO_SI']) {
        tempUser.legale_repre = user.userComponents['TITOLARE_DATA-EFFETTIVO_SI'].value === 'selected' ? 'SI' : 'NO';
      }

      tempUser.directPep = user.userComponents['SZ0025-SS0052_DM0097_RI0022'].value === 'selected' ? 'SI' : 'NO';

      tempUser.indirectPep = user.userComponents['SZ0025-SS0163_DM0503_RI0568'].value === 'selected' ? 'SI' : 'NO';
      if (!!user.userComponents['SZ0025-SS0211_DM0854_RI0954'] && user.userComponents['SZ0025-SS0211_DM0854_RI0954'].value === 'selected') {
        tempUser.criterioApplicato = user.userComponents['SZ0025-SS0211_DM0854_RI0954'].description;
      } else if (!!user.userComponents['SZ0025-SS0211_DM0854_RI0955'] && user.userComponents['SZ0025-SS0211_DM0854_RI0955'].value === 'selected') {
        tempUser.criterioApplicato = user.userComponents['SZ0025-SS0211_DM0854_RI0955'].description;
      } else if (!!user.userComponents['SZ0025-SS0211_DM0854_RI0956'] && user.userComponents['SZ0025-SS0211_DM0854_RI0956'].value === 'selected') {
        tempUser.criterioApplicato = user.userComponents['SZ0025-SS0211_DM0854_RI0956'].description;
      }
      (0, _keys2.default)(user.userComponents).forEach(function (key) {
        var currentComponents = user.userComponents[key];
        if (currentComponents.refDataTeJsObj && currentComponents.refDataTeJsObj === 'directPepDetail') {
          dpdKey = currentComponents.refDataTeJs;
          tempUser.directPepDetail[dpdKey] = currentComponents.value === 'selected' ? 'SI' : currentComponents.value;
        }
        if (currentComponents.refDataTeJsObj && currentComponents.refDataTeJsObj === 'indirectPepDetail') {
          dpdKey = currentComponents.refDataTeJs === 'tipolegame' ? 'tipoLegame' : currentComponents.refDataTeJs;
          tempUser.indirectPepDetail[dpdKey] = currentComponents.value === 'selected' ? 'SI' : currentComponents.value;
        }
        if (currentComponents.id.startsWith('RESIDENZA-') && currentComponents.name !== 'INDIRIZZO_TIPO') {
          dpdKey = currentComponents.name.toLowerCase();
          tempUser.residenza[dpdKey] = currentComponents.value ? currentComponents.value : '';
        }
        if (currentComponents.id.startsWith('DOCUMENTO-') && currentComponents.name !== 'DOCR_UPLOAD' && currentComponents.name !== 'DOCF_UPLOAD') {
          dpdKey = currentComponents.name;
          tempUser.documento[dpdKey.toLowerCase()] = currentComponents.value ? currentComponents.value : '';
        }
        if (currentComponents.name === 'DOCR_UPLOAD' || currentComponents.name === 'DOCF_UPLOAD') {
          tempUser.documento.doc_ref_id = currentComponents.docRefId;
        }
        if (currentComponents.id.startsWith('NOME_COGNOME-') || currentComponents.id.startsWith('CODICE_FISCALE-')) {
          dpdKey = currentComponents.name.toLowerCase();
          var rezKey = TYPES[dpdKey];
          tempUser.datiContatto[rezKey] = currentComponents.value ? currentComponents.value : '';
        }
      });
      toComponents[0].rawValue.titolare_effettivo.push(tempUser);
    });
    resComponents = toComponents;
  }

  return resComponents;
};

var updateSavePg = function updateSavePg(savePG, c) {
  var comId = c.id_;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(savePG.data.acolQuestionnaire.sections.section), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var s = _step2.value;

      if (comId.startsWith(s.sectionCode) && s.subSections) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(s.subSections.subSection), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var ss_ = _step3.value;

            if (comId.startsWith(ss_.id) && ss_.questions) {
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = (0, _getIterator3.default)(ss_.questions.question), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var q = _step4.value;

                  if (comId.startsWith(q.id) && q.answers) {
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                      for (var _iterator5 = (0, _getIterator3.default)(q.answers.answer), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var a = _step5.value;

                        if (comId === a.id) {
                          if (a.field.type === 'Radio' || a.field.type === 'CheckBox') {
                            a.field.selected = c.value === 'selected';
                          } else if (a.field.type === 'DropdownBox' || a.field.type === 'ListBox') {
                            a.field.value = c.value;
                            a.linkId = c.linkId;
                            a.field.linkValue = c.linkValue;
                          } else if (a.field.type === 'TextBox' || a.field.type.toUpperCase() === 'DATEPICKER' || a.field.type.toUpperCase() === 'TEXTAREA') {
                            a.field.value = c.value;
                          }
                          return;
                        }
                      }
                    } catch (err) {
                      _didIteratorError5 = true;
                      _iteratorError5 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                          _iterator5.return();
                        }
                      } finally {
                        if (_didIteratorError5) {
                          throw _iteratorError5;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
};

//Update the User to State
var addTitolareUserToObject = exports.addTitolareUserToObject = function addTitolareUserToObject(userDetails, count) {
  return function (dispatch, getState) {
    var _getState28 = getState(),
        components = _getState28.components,
        step = _getState28.step;

    var titolareList = step.titolareList || [];
    if (titolareList.length < 5) {
      userDetails.open = false;
      (0, _keys2.default)(userDetails.userComponents).forEach(function (k) {
        userDetails.userComponents[k].validations = !!components[k].validations && components[k].validations;
      });
      if (!!userDetails.userWidgets["TITOLARE_EFFETTIVO"] && !!userDetails.userWidgets["TITOLARE_EFFETTIVO"].status && userDetails.userWidgets["TITOLARE_EFFETTIVO"].status[0] === 'ignoreValidation' && !!userDetails.userComponents && !!userDetails.userComponents['SZ0025-SS0052_DM0097_RI0022'] && !!userDetails.userComponents['SZ0025-SS0052_DM0097_RI0023'] && !!userDetails.userComponents['SZ0025-SS0163_DM0503_RI0568'] && !!userDetails.userComponents['SZ0025-SS0163_DM0503_RI0569'] && !!userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_SI'] && !!userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_NO'] && !!userDetails.userComponents['TITOLARE_OWNER-LABEL'] && !!userDetails.userComponents['SZ0025-SS0163'] && !!userDetails.userComponents['SZ0025-SS0052']) {
        userDetails.userComponents['SZ0025-SS0052_DM0097_RI0022'].status[0] = '';
        userDetails.userComponents['SZ0025-SS0052_DM0097_RI0023'].status[0] = '';
        userDetails.userComponents['SZ0025-SS0163_DM0503_RI0568'].status[0] = '';
        userDetails.userComponents['SZ0025-SS0163_DM0503_RI0569'].status[0] = '';
        userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_NO'].status[0] = '';
        userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_NO'].value = 'selected';
        userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_SI'].status[0] = '';
        userDetails.userComponents['TITOLARE_OWNER-EFFETTIVO_SI'].value = '';
        userDetails.userComponents['TITOLARE_OWNER-LABEL'].status[0] = '';
        userDetails.userComponents['SZ0025-SS0163'].status[0] = '';
        userDetails.userComponents['SZ0025-SS0052'].status[0] = '';
      }
      titolareList.push(userDetails);
      dispatch({ type: USER_COUNTER, userCounter: count });
      dispatch({
        type: SET_TITOLARE_LIST,
        titolareList: titolareList
      });
    }
  };
};

var getPrevTitolareUser = exports.getPrevTitolareUser = function getPrevTitolareUser(user, titoValue) {
  return function (dispatch, getState) {
    var _getState29 = getState(),
        step = _getState29.step;

    var dpdKey = null;
    var TYPES = {
      cf: 'codiceFiscale',
      nome: 'nome',
      cognome: 'cognome',
      datadinascita: 'dataDiNascita',
      sesso: 'sesso',
      luogodinascita: 'luogoDiNascita',
      provinciadinascita: 'provinciaDiNascita',
      meseAnno: 'meseAnno'
    };
    var titolareList = step.titolareList;

    //titolareList.map(user => {
    //const titoValue = userArray[user.id]

    (0, _keys2.default)(user.userComponents).forEach(function (k) {
      var comp = user.userComponents[k];
      if (comp.id.startsWith('RESIDENZA-')) {
        dpdKey = comp.name === 'residenzaFiscale' ? 'residenzafiscale' : comp.name.toLowerCase();
        comp.value = !!titoValue.residenza && !!titoValue.residenza[dpdKey] ? titoValue.residenza[dpdKey] : '';
      }
      if (comp.id.startsWith('DOCUMENTO-') && comp.name !== 'DOCR_UPLOAD' && comp.name !== 'DOCF_UPLOAD') {
        comp.value = !!titoValue.documento && !!titoValue.documento[comp.name.toLowerCase()] ? titoValue.documento[comp.name.toLowerCase()] : '';
      }

      if (comp.id.startsWith('NOME_COGNOME-') || comp.id.startsWith('CODICE_FISCALE-')) {
        var _dpdKey = comp.name === 'meseAnno' ? 'meseAnno' : comp.name.toLowerCase();
        var rezKey = TYPES[_dpdKey];
        comp.value = !!titoValue.datiContatto && !!titoValue.datiContatto[rezKey] ? titoValue.datiContatto[rezKey] : '';
      }
      if (comp.refDataTeJsObj && comp.refDataTeJsObj === 'indirectPepDetail') {
        dpdKey = comp.refDataTeJs === 'tipolegame' ? 'tipoLegame' : comp.refDataTeJs;
        comp.value = !!titoValue.indirectPepDetail && !!titoValue.indirectPepDetail[dpdKey] ? titoValue.indirectPepDetail[dpdKey] : '';
      }
      if (comp.refDataTeJsObj && comp.refDataTeJsObj === 'directPepDetail') {
        dpdKey = comp.refDataTeJs;
        comp.value = !!titoValue.directPepDetail && !!titoValue.directPepDetail[dpdKey] ? titoValue.directPepDetail[dpdKey] : '';
      }
    });

    if (user.userComponents['TITOLARE_DATA-EFFETTIVO_SI']) {
      user.userComponents['TITOLARE_DATA-EFFETTIVO_SI'].value = titoValue.legale_repre === 'SI' ? 'selected' : '';
      user.userComponents['TITOLARE_DATA-EFFETTIVO_NO'].value = titoValue.legale_repre === 'SI' ? '' : 'selected';
      /* user.open = false */
    }

    user.userComponents['SZ0025-SS0052_DM0097_RI0022'].value = titoValue.directPep === 'SI' ? 'selected' : '';
    user.userComponents['SZ0025-SS0052_DM0097_RI0023'].value = titoValue.directPep === 'SI' ? '' : 'selected';

    user.userComponents['SZ0025-SS0163_DM0503_RI0568'].value = titoValue.indirectPep === 'SI' ? 'selected' : '';
    user.userComponents['SZ0025-SS0163_DM0503_RI0569'].value = titoValue.indirectPep === 'SI' ? '' : 'selected';

    if (!!titoValue.directPepDetail && titoValue.directPepDetail.inCorso) {
      user.userComponents['SZ0025-SS0162_DM0501_RI0565'].value = titoValue.directPepDetail.inCorso === 'SI' ? 'selected' : '';
      user.userComponents['SZ0025-SS0162_DM0501_RI0566'].value = titoValue.directPepDetail.inCorso === 'SI' ? '' : 'selected';
    }
    if (!!titoValue.indirectPepDetail && titoValue.indirectPepDetail.inCorso) {
      user.userComponents['SZ0025-SS0163_DM0507_RI0573'].value = titoValue.indirectPepDetail.inCorso === 'SI' ? 'selected' : '';
      user.userComponents['SZ0025-SS0163_DM0507_RI0574'].value = titoValue.indirectPepDetail.inCorso === 'SI' ? '' : 'selected';
    }
    //})

    // dispatch({
    //   type: SET_TITOLARE_LIST,
    //   titolareList: titolareList
    // })
  };
};
//Add titolare User
var addTitolareUser = exports.addTitolareUser = function addTitolareUser() {
  return function (dispatch, getState) {
    var _getState30 = getState(),
        step = _getState30.step;
    // const widgets_ = step && step.widgets_ ? step.widgets_ : []
    // const TITOLARE_WIDGETS = ['FLOW_BAR', 'TITOLARE_EFFETTIVO']
    // let acwidgets = TITOLARE_WIDGETS.map(k => widgets_.find(w => w.name === k))
    // const staticWidgets = TitolareStatic.getTitolareEffettivoComponent()
    // if (staticWidgets.widgets && acwidgets) {
    //   acwidgets = [...acwidgets, ...staticWidgets.widgets]
    // }
    // acwidgets.find(w => {
    //   if (w && w.name === 'TITOLARE_DATA') {
    //     acwidgets.splice(acwidgets.indexOf(w), 1)
    //   }
    // })

    // const { entities } = normalize(acwidgets, widgetListSchema)
    // const widgets = extendModel(entities.widgets)
    // const components = extendModel(entities.components, null, {
    //   dispatch,
    //   widgets: entities.widgets
    // })

    dispatch(validateStep());
    if (!(0, _keys2.default)(getState().components).find(function (k) {
      return (0, _utils.isEntityInvalid)(k, getState().components);
    })) {
      step.userCounter = step.userCounter + 1;
      var userDetails = {
        id: step.userCounter,
        userWidgets: JSON.parse((0, _stringify2.default)(step.titoWidgets)),
        userComponents: JSON.parse((0, _stringify2.default)(step.titoComponents)),
        type: "add"
      };
      dispatch(addTitolareUserToObject(userDetails, step.userCounter));
      window.scrollTo(0, 0);
    }
  };
};

//Update Titolare User
//export const updateTitolareUser = id => (dispatch, getState) => {
// const { widgets, components, step } = getState()
// const titolareList = step.titolareList
// const prev = titolareList.find(user => user.open)
// const current = titolareList.find(user => user.id === parseInt(id))
// if (current) {
//   current.open = true
// }
// if (prev && prev.open) {
//   prev.userWidgets = JSON.parse(JSON.stringify(widgets))
//   prev.userComponents = JSON.parse(JSON.stringify(components))
//   prev.open = false

//   if (prev.id !== 0 && prev.userWidgets.TITOLARE_DATA) {
//     prev.userWidgets.TITOLARE_DATA.active = false
//     prev.userWidgets.TITOLARE_DATA.status = ['hidden']
//   }
//   titolareList[prev.id] = prev
// }
// // if (step.userCounter !== 0) {
// //   current.userWidgets.TITOLARE_DATA.active = false
// //   current.userWidgets.TITOLARE_DATA.status = ['hidden']
// // }
// dispatch({
//   type: SET_TITOLARE_LIST,
//   titolareList: titolareList
// })
//}

//Update User Component
var updateUserComponent = exports.updateUserComponent = function updateUserComponent() {
  return function (dispatch, getState) {
    var _getState31 = getState(),
        widgets = _getState31.widgets,
        components = _getState31.components,
        step = _getState31.step;

    var titolareList = step.titolareList;
    var uc = titolareList.find(function (user) {
      return user.open;
    });
    if (uc) {
      uc.userWidgets = JSON.parse((0, _stringify2.default)(widgets));
      uc.userComponents = JSON.parse((0, _stringify2.default)(components));
      (0, _keys2.default)(uc.userComponents).forEach(function (k) {
        uc.userComponents[k].validations = components[k].validations;
        // if(k === 'DOCUMENTO-TIPO_DOCUMENTO'){
        //   uc.userComponents[k].values = uc.userComponents[k].values.length === 0 ? components[k].values : uc.userComponents[k].values
        // }
      });
      titolareList[uc.id] = uc;
    }
    dispatch({
      type: SET_TITOLARE_LIST,
      titolareList: titolareList
    });
  };
};

var digitalSignCheckCall = exports.digitalSignCheckCall = function digitalSignCheckCall() {
  return API.checkContract().then(function (_ref5) {
    var data = _ref5.data;
    return data;
  });
};

var getContractList = exports.getContractList = function getContractList() {
  return API.request({ endpoint: 'wgt/sign/contractlist' });
};

var downloadPdf = exports.downloadPdf = function downloadPdf(url) {
  window.pdfLoaderDispatch(showLoading());
  (0, _api.request)({
    endpoint: url,
    method: "GET",
    headers: { 'Content-Type': 'application/pdf' }
  }).then(function (res) {
    window.pdfLoaderDispatch(hideLoading());
  });
};

window.downloadPdf = downloadPdf;

var getPdfAnchorTag = exports.getPdfAnchorTag = function getPdfAnchorTag(text, contracts) {
  return '<a class="clickable" onclick="downloadPdf(\'wgt/utils/stampa/contract/' + contracts.stampeId + '/' + contracts.barCode + '.pdf\')">' + text + '</a>';
};

var updateDiFarmaComponent = exports.updateDiFarmaComponent = function updateDiFarmaComponent(loadedWidgets, json) {
  return function (dispatch, getState) {
    var _getState32 = getState(),
        step = _getState32.step,
        product = _getState32.product;

    dispatch(disableBtn(step));
    loadedWidgets = !!loadedWidgets && (0, _keys2.default)(loadedWidgets).length > 0 ? loadedWidgets : step.widgets_.filter(function (w) {
      return w.name === 'FLOW_BAR';
    });
    json.step.widgets = !!json && !!json.step && !!json.step.widgets && json.step.widgets.length > 0 ? json.step.widgets : step.widgets_;
    json.step.contactId = !!json && !!json.step && !!json.step.contactId ? json.step.contactId : step.contactId;
    json.step.number = !!json && !!json.step && !!json.step.number ? json.step.number : step.number;
    json.step.name = !!json && !!json.step && !!json.step.name ? json.step.name : step.name;
    json.step.guid = !!json && !!json.step && !!json.step.guid ? json.step.guid : step.guid;
    json.step.last = !!json && !!json.step && !!json.step.last ? json.step.last : step.last;

    //const staticWidgets = FirmeStatic.getFirmeComponent() 
    var widgetCode = json.step.widgets.filter(function (w) {
      return w.name.toUpperCase() === 'ATTIVA_REVOCA_FIRMA';
    }).map(function (w) {
      return w.code;
    });
    //staticWidgets.widgets[0].code = widgetCode[0] 
    var updateContractsComponents = [];
    var updateFirma = null;
    var posplanurl = 'OnboardRequestDetails/FetchPOSPlan';
    var posplanbody = {
      GUID: !!json.step.guid ? json.step.guid : step.guid
    };
    var posPlan = "";
    var promocodeFromAPI = "";
    (0, _api2.FetchPOSPlan)(posplanurl, posplanbody).then(function (posPlanJson) {
      dispatch(showLoading());
      var dbplan = posPlanJson && posPlanJson.payLoad && posPlanJson.payLoad.Plan && posPlanJson.payLoad.Plan.toUpperCase();
      var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
      posPlan = planMap[dbplan] || 'flat';
      promocodeFromAPI = !!posPlanJson.payLoad && !!posPlanJson.payLoad.ReferalCode && posPlanJson.payLoad.ReferalCode;
      digitalSignCheckCall().then(function (_ref6) {
        var digitalsign = _ref6.digitalsign;

        dispatch(showLoading());
        getContractList().then(function (response) {
          dispatch(hideLoading());
          dispatch(handleServerErrors(response));
          if (response.status === 'success') {
            var _response$data = response.data,
                contracts = _response$data.contracts,
                holderInfo = _response$data.holderInfo;

            var contractList = contracts.filter(function (_ref7) {
              var sign = _ref7.sign;
              return sign !== '' && sign.toLowerCase() !== 'never_uploaded';
            });
            var signedContractList = contractList.filter(function (_ref8) {
              var sign = _ref8.sign;
              return sign.toLowerCase() === 'true';
            });
            var contractFirmaActive = true;
            updateContractsComponents = contractList.map(function (contract, index) {
              var _FirmeStatic$getDiFar = FirmeStatic.getDiFarmaComponents(),
                  widgets = _FirmeStatic$getDiFar.widgets;

              widgets[0].name = 'DIFARMA_' + index;
              widgets[0].components[2].url = '';

              //Rewamp of whole digital contracts in last step (All flows)	
              var subUrl = '/wgt/utils/stampa/contract/';
              var subLabel = widgets[0].components.find(function (d) {
                return d.name === 'SUB_LABEL';
              }).value;

              var contrattoTitle = "";
              var contrattoDescription = "";
              var contracts = {};
              if (index === 0) {
                contracts = contractList.find(function (d) {
                  return d.tipo === 'POS_EN';
                });
                if (posPlan === "flex" || posPlan && posPlan.toUpperCase() === "FLEXCRS" || posPlan && posPlan.toUpperCase() === "FLEXMINI") {
                  contrattoTitle = '<b>Contratto di Vendita e Licenza d\u2019uso software</b>';
                  contrattoDescription = '<p>Nel  ' + (contracts ? getPdfAnchorTag("contratto di vendita e licenza d’uso software", contracts) : "contratto di vendita e licenza d’uso software") + ' accetti di:</p>\n                <ul class=\'btn-indent-txt\'>\n                  <li>Acquistare il POS Android a ' + (posPlan.toUpperCase() === 'FLEXMINI' ? '80€' : '99€') + ' + IVA</li>\n                  <li>Far addebitare il relativo costo sul conto corrente indicato</li>\n                  <li>Mantenere il contratto di acquiring collegato alla presente proposta attivo per ottenere assistenza sul tuo dispositivo</li>\n                ';
                } else {
                  contrattoTitle = '<b>Contratto di noleggio POS</b>';
                  contrattoDescription = '\n                  <p>\n                    Nel \n                    ' + (contracts ? getPdfAnchorTag("contratto di noleggio POS", contracts) : "contratto di noleggio POS") + '\n                    accetti di:\n                  </p>\n                  <ul class=\'btn-indent-txt\'>\n                    <li>Pagare un canone mensile di 17 o 22 euro per POS in base a quanto selezionato</li>\n                    <li>Ricevere in comodato d\'uso il/i terminale/i POS Android</li>\n                    <li>Far accreditare gli importi delle transazioni tramite POS sul conto corrente indicato</li>\n                  </ul>\n                ';
                }
              } else if (index === 1) {
                contracts = contractList.find(function (d) {
                  return d.tipo === 'POS_BS';
                });
                contrattoTitle = '<b>Contratto di acquiring</b>';
                if (posPlan === "flex" || posPlan && posPlan.toUpperCase() === "FLEXCRS" || posPlan && posPlan.toUpperCase() === "FLEXMINI") {
                  contrattoDescription = '\n                  <p>\n                    Nel\n                    ' + (contracts ? getPdfAnchorTag("contratto di acquiring", contracts) : "contratto di acquiring") + '\n                    accetti di:\n                  </p>\n                  <ul class=\'btn-indent-txt\'>\n                    <li>Pagare l\u2019 1% di commissioni per tutte le transazioni tramite POS per carte di debito, credito e PagoBancomat</li>\n                    <li>Pagamento del bollo di attivazione di 16 euro</li>\n                  </ul>\n                ';
                } else {
                  contrattoDescription = '\n                  <p>\n                    Nel\n                    ' + (contracts ? getPdfAnchorTag("contratto di acquiring", contracts) : "contratto di acquiring") + '\n                    accetti di:\n                  </p>\n                  <ul class=\'btn-indent-txt\'>\n                    <li>Non pagare commissioni per tutte le transazioni tramite POS per carte di debito, credito e PagoBancomat</li>\n                    <li>Pagamento del bollo di attivazione di 16 euro</li>\n                  </ul>\n                ';
                }
              } else if (index === 2) {
                contracts = contractList.find(function (d) {
                  return d.tipo === 'Questionario Antiriciclaggio';
                });
                contrattoTitle = '<b>Questionario antiriciclaggio</b>';
                contrattoDescription = '\n                Nel\n                ' + (contracts ? getPdfAnchorTag("questionario antiriciclaggio", contracts) : "questionario antiriciclaggio") + '\n                accetti quanto dichiarato in fase di richiesta in materia in antiriciclaggio per adempiere agli obblighi di ageduata verifica.\n              ';
              } else if (index === 3) {
                contracts = contractList.find(function (d) {
                  return d.tipo === 'Privacy';
                });
                contrattoTitle = '<b>Informativa trattamento dei dati personali</b>';
                contrattoDescription = '\n                Nell\'\n                ' + (contracts ? getPdfAnchorTag("informativa sul trattamento dei dati personali", contracts) : "informativa sul trattamento dei dati personali") + '\n                accetti le caratteristiche relative al trattamento dei tuoi dati personali da parte di Banca Sella S.p.A e tutte le societ\xE0 del gruppo, che hai selezionato in fase di richiesta.\n              ';
              }
              widgets[0].components[0].value = contrattoTitle;
              widgets[0].components.find(function (d) {
                return d.name === 'SUB_LABEL';
              }).value = contrattoDescription;
              window.pdfLoaderDispatch = dispatch;

              widgets[0].components[2].barcode = contract.barCode;
              widgets[0].components[2].tipo = contract.tipo;

              widgets[0].components[2].body = {
                barcode: contract.barCode,
                stampeId: contract.stampeId,
                smsContent: contract.tipo
              };
              widgets[0].components[2].value = contract.sign === 'false' ? widgets[0].components[2].value : 'Firmato';
              widgets[0].components[2].disabled = contract.sign === 'false' ? false : true;
              // if (index === 0) { 
              // widgets[0].components[2].disabled = false 
              // }

              if (holderInfo.digitalsign && contract.sign.toLowerCase() === 'true') {
                widgets[0].components[2].type = 'active';
                widgets[0].components[2].disabled = true;
                widgets[0].components[2].value = 'FIRMATO';
              }
              if (holderInfo.digitalsign && contract.sign.toLowerCase() === 'false' && contractFirmaActive) {
                updateFirma = {
                  id: widgets[0].name + '-' + contract.azioni,
                  update: {
                    disabled: false,
                    type: 'sella',
                    action: (0, _assign2.default)({}, widgets[0].components[2].action, {
                      value: 'Attivata',
                      type: 'inverse',
                      disabled: true,
                      barcode: contract.barCode,
                      fetch: {
                        attivata: {
                          url: 'wgt/sign/url',
                          body: {
                            docId: contract.barCode,
                            smsContent: contract.tipo
                          },
                          mappingEvent: 'DiFarmaIframeSrcSetter'
                        }
                      },
                      updateComponentId: widgets[0].name + '-IFRAME',
                      toggleVisibility: {
                        show: {
                          fields: [widgets[0].name + '-IFRAME']
                        }
                      }
                    })
                  }
                };
                contractFirmaActive = false;
              }
              return widgets[0];
            });
            if (contractList.length === signedContractList.length) {
              dispatch(enableBtn(step));
            }
          }
          var staticPosPlanWidgets = JSON.parse((0, _stringify2.default)((0, _posPlanStatic.getPosPlanComponent)()));
          staticPosPlanWidgets.widgets[0].components[0].fetchPosPlan = {
            url: 'OnboardRequestDetails/FetchPOSPlan', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
            body: {
              GUID: json.step.guid
            },
            mappingEvent: 'FetchPOSPlan'
          };

          var widgets = [].concat((0, _toConsumableArray3.default)(loadedWidgets), (0, _toConsumableArray3.default)(staticPosPlanWidgets.widgets), (0, _toConsumableArray3.default)(updateContractsComponents));

          // Coupon start
          //if(posPlan==="flat") {
          var promoCodeStaticComp = JSON.parse((0, _stringify2.default)((0, _promoCodeStatic.getPromoCodeComponent)()));
          promoCodeStaticComp.widgets[0].components[0].fetchPromoCode = {
            url: 'OnboardRequestDetails/FetchPromoCode', //'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/FetchPromoCode',//'https://172.17.4.63/magtek/OnboardRequestDetails/FetchPromoCode',
            body: {
              GUID: json.step.guid
            },
            mappingEvent: 'FetchPromoCode'
          };
          if (!!promocodeFromAPI) {
            promoCodeStaticComp.widgets[0].components[0].value = promocodeFromAPI;
          }
          promoCodeStaticComp.widgets[0].components[0].validations = {
            //skipLazy: true,
            //isRequired: true,
            default: [{
              validate: Model.VALIDATION_METHODS.filled,
              getErrorMessage: Model.VALIDATION_ERRORS.filled
            }],
            // overrides: [
            //   {
            //     validate: Model.VALIDATION_METHODS.filled,
            //     getErrorMessage: Model.VALIDATION_ERRORS.filled
            //   }
            // ],
            // url: 'PromoCodeManagement/ValidatePromoCode',//'https://sandbox.gestpay.net/PromocodesService/PromoCodeManagement/ValidatePromoCode',//'https://172.17.4.63/magtek/PromoCodeManagement/ValidatePromoCode'
            fields: ['PROMO-PromoCode']
          };
          widgets.push(promoCodeStaticComp.widgets[0]);
          //}
          // Coupon end

          var _normalize2 = (0, _normalizr.normalize)(widgets, _schema.widgetListSchema),
              entities = _normalize2.entities;

          dispatch((0, _widgetsActions.updateAllWidgets)((0, _utils.extendModel)(entities.widgets, null, {
            dispatch: dispatch,
            step: json.step.number,
            product: product.prodCode,
            name: json.step.name
          })));
          dispatch((0, _componentsActions.updateAllComponents)((0, _utils.extendModel)(entities.components, null, {
            dispatch: dispatch,
            widgets: entities.widgets,
            step: json.step.number,
            product: product.prodCode,
            name: json.step.name
          })));
          dispatch((0, _componentsActions.activateSign)(digitalsign));
          if (updateFirma !== null) {
            dispatch((0, _componentsActions.updateComponent)(updateFirma.id, updateFirma.update));
          }
        });
      });
    });
  };
};

//delete titolare user
var deleteTitolareUser = exports.deleteTitolareUser = function deleteTitolareUser(user) {
  return function (dispatch, getState) {
    var _getState33 = getState(),
        step = _getState33.step;

    var titolareList = step.titolareList;
    if (titolareList.length <= 5 && titolareList.length > 1) {
      titolareList.splice(user, 1);
      step.userCounter = step.userCounter - 1;

      titolareList.map(function (user) {
        if (user.id !== titolareList.indexOf(user)) {
          user.id = titolareList.indexOf(user);
        }
      });
      titolareList[titolareList.length - 1].open = true;
      var count = step.userCounter;
      dispatch({ type: USER_COUNTER, userCounter: count });
      dispatch({
        type: SET_TITOLARE_LIST,
        titolareList: titolareList
      });
    }
  };
};

var showWebcamModal = exports.showWebcamModal = function showWebcamModal(component) {
  return function (dispatch /*, getState*/) {
    dispatch({ type: SHOW_WEBCAM_MODAL, component: component });
  };
};

var hideAddressModal = exports.hideAddressModal = function hideAddressModal() {
  return function (dispatch /*, getState*/) {
    dispatch({ type: HIDE_ADDRESS_MODAL });
  };
};

var showAddressModal = exports.showAddressModal = function showAddressModal(component) {
  return function (dispatch /*, getState*/) {
    dispatch({ type: SHOW_ADDRESS_MODAL, component: component });
  };
};

var hideWebcamModal = exports.hideWebcamModal = function hideWebcamModal() {
  return function (dispatch /*, getState*/) {
    dispatch({ type: HIDE_WEBCAM_MODAL });
  };
};

var showLoading = exports.showLoading = function showLoading() {
  return function (dispatch /*, getState*/) {
    dispatch({ type: SHOW_LOADING });
  };
};
var hideLoading = exports.hideLoading = function hideLoading() {
  return function (dispatch /*, getState*/) {
    dispatch({ type: HIDE_LOADING });
  };
};
var enableBtn = exports.enableBtn = function enableBtn(step) {
  return function (dispatch /*, getState*/) {
    dispatch({
      type: ENABLE_BUTTON,
      step: step
    });
  };
};
var disableBtn = exports.disableBtn = function disableBtn(step) {
  return function (dispatch /*, getState*/) {
    dispatch({
      type: DISABLE_BUTTON,
      step: step
    });
  };
};
var showAPIAlertModel = exports.showAPIAlertModel = function showAPIAlertModel() {
  return function (dispatch /*, getState*/) {
    dispatch({ type: SHOW_API_ALERT_MODAL });
  };
};

var updateTitolareList = exports.updateTitolareList = function updateTitolareList(titolareList) {
  return function (dispatch) {
    dispatch({
      type: SET_TITOLARE_LIST,
      titolareList: titolareList
    });
  };
};

var hideAlert = exports.hideAlert = function hideAlert(component) {
  return function (dispatch) {
    dispatch((0, _componentsActions.updateComponent)(component.id, { status: ['hidden'] }));
  };
};
var showAlert = exports.showAlert = function showAlert(component) {
  return function (dispatch) {
    dispatch((0, _componentsActions.updateComponent)(component.id, {
      value: component.value,
      title: component.title,
      status: []
    }));
  };
};
var Patrimonio_CheckBoxes_RBG1 = exports.Patrimonio_CheckBoxes_RBG1 = ['SZ0010-SS0213_DM0856_RI0059', 'SZ0010-SS0213_DM0856_RI0060', 'SZ0010-SS0213_DM0856_RI0061', 'SZ0010-SS0213_DM0856_RI0062', 'SZ0010-SS0213_DM0856_RI0063', 'SZ0010-SS0213_DM0856_RI0064', 'SZ0010-SS0213_DM0856_RI0065'];
var Patrimonio_CheckBoxes_RBG2 = exports.Patrimonio_CheckBoxes_RBG2 = ['SZ0010-SS0214_DM0857_RI0059', 'SZ0010-SS0214_DM0857_RI0060', 'SZ0010-SS0214_DM0857_RI0061', 'SZ0010-SS0214_DM0857_RI0062', 'SZ0010-SS0214_DM0857_RI0063', 'SZ0010-SS0214_DM0857_RI0064', 'SZ0010-SS0214_DM0857_RI0065'];
var Patrimonio_CheckBoxes_RBG3 = exports.Patrimonio_CheckBoxes_RBG3 = ['SZ0010-SS0215_DM0858_RI0059', 'SZ0010-SS0215_DM0858_RI0060', 'SZ0010-SS0215_DM0858_RI0061', 'SZ0010-SS0215_DM0858_RI0062', 'SZ0010-SS0215_DM0858_RI0063', 'SZ0010-SS0215_DM0858_RI0064', 'SZ0010-SS0215_DM0858_RI0065'];
var Patrimonio_CheckBoxes_RBG4 = exports.Patrimonio_CheckBoxes_RBG4 = ['SZ0010-SS0216_DM0859_RI0059', 'SZ0010-SS0216_DM0859_RI0060', 'SZ0010-SS0216_DM0859_RI0061', 'SZ0010-SS0216_DM0859_RI0062', 'SZ0010-SS0216_DM0859_RI0063', 'SZ0010-SS0216_DM0859_RI0064', 'SZ0010-SS0216_DM0859_RI0065'];
var Patrimonio_CheckBoxes_RBG5 = exports.Patrimonio_CheckBoxes_RBG5 = ['SZ0010-SS0217_DM0860_RI0059', 'SZ0010-SS0217_DM0860_RI0060', 'SZ0010-SS0217_DM0860_RI0061', 'SZ0010-SS0217_DM0860_RI0062', 'SZ0010-SS0217_DM0860_RI0063', 'SZ0010-SS0217_DM0860_RI0064', 'SZ0010-SS0217_DM0860_RI0065'];
var Patrimonio_CheckBoxes_RBG6 = exports.Patrimonio_CheckBoxes_RBG6 = ['SZ0010-SS0218_DM0861_RI0059', 'SZ0010-SS0218_DM0861_RI0060', 'SZ0010-SS0218_DM0861_RI0061', 'SZ0010-SS0218_DM0861_RI0062', 'SZ0010-SS0218_DM0861_RI0063', 'SZ0010-SS0218_DM0861_RI0064', 'SZ0010-SS0218_DM0861_RI0065'];
var Patrimonio_CheckBoxes_RBG7 = exports.Patrimonio_CheckBoxes_RBG7 = ['SZ0010-SS0219_DM0862_RI0059', 'SZ0010-SS0219_DM0862_RI0060', 'SZ0010-SS0219_DM0862_RI0061', 'SZ0010-SS0219_DM0862_RI0062', 'SZ0010-SS0219_DM0862_RI0063', 'SZ0010-SS0219_DM0862_RI0064', 'SZ0010-SS0219_DM0862_RI0065'];
var Patrimonio_CheckBoxes_RBG8 = exports.Patrimonio_CheckBoxes_RBG8 = ['SZ0010-SS0220_DM0863_RI0059', 'SZ0010-SS0220_DM0863_RI0060', 'SZ0010-SS0220_DM0863_RI0061', 'SZ0010-SS0220_DM0863_RI0062', 'SZ0010-SS0220_DM0863_RI0063', 'SZ0010-SS0220_DM0863_RI0064', 'SZ0010-SS0220_DM0863_RI0065'];
var Patrimonio_CheckBoxes_RBG9 = exports.Patrimonio_CheckBoxes_RBG9 = ['SZ0010-SS0221_DM0864_RI0059', 'SZ0010-SS0221_DM0864_RI0060', 'SZ0010-SS0221_DM0864_RI0061', 'SZ0010-SS0221_DM0864_RI0062', 'SZ0010-SS0221_DM0864_RI0063', 'SZ0010-SS0221_DM0864_RI0064', 'SZ0010-SS0221_DM0864_RI0065'];
var Patrimonio_CheckBoxes_RBG10 = exports.Patrimonio_CheckBoxes_RBG10 = ['SZ0010-SS0222_DM0865_RI0059', 'SZ0010-SS0222_DM0865_RI0060', 'SZ0010-SS0222_DM0865_RI0061', 'SZ0010-SS0222_DM0865_RI0062', 'SZ0010-SS0222_DM0865_RI0063', 'SZ0010-SS0222_DM0865_RI0064', 'SZ0010-SS0222_DM0865_RI0065'];
var Patrimonio_RadioButtons = exports.Patrimonio_RadioButtons = ['SZ0010-SS0212_DM0855_RI0937', 'SZ0010-SS0212_DM0855_RI0938', 'SZ0010-SS0212_DM0855_RI0939', 'SZ0010-SS0212_DM0855_RI0940', 'SZ0010-SS0212_DM0855_RI0941', 'SZ0010-SS0212_DM0855_RI0942', 'SZ0010-SS0212_DM0855_RI0943', 'SZ0010-SS0212_DM0855_RI0944', 'SZ0010-SS0212_DM0855_RI0945'
//'SZ0010-SS0212_DM0855_RI0946'
];
var Patrimonio_CheckBoxes = exports.Patrimonio_CheckBoxes = ['SZ0010-SS0213_DM0856_RI0059', 'SZ0010-SS0213_DM0856_RI0060', 'SZ0010-SS0213_DM0856_RI0061', 'SZ0010-SS0213_DM0856_RI0062', 'SZ0010-SS0213_DM0856_RI0063', 'SZ0010-SS0213_DM0856_RI0064', 'SZ0010-SS0213_DM0856_RI0065', 'SZ0010-SS0214_DM0857_RI0059', 'SZ0010-SS0214_DM0857_RI0060', 'SZ0010-SS0214_DM0857_RI0061', 'SZ0010-SS0214_DM0857_RI0062', 'SZ0010-SS0214_DM0857_RI0063', 'SZ0010-SS0214_DM0857_RI0064', 'SZ0010-SS0214_DM0857_RI0065', 'SZ0010-SS0215_DM0858_RI0059', 'SZ0010-SS0215_DM0858_RI0060', 'SZ0010-SS0215_DM0858_RI0061', 'SZ0010-SS0215_DM0858_RI0062', 'SZ0010-SS0215_DM0858_RI0063', 'SZ0010-SS0215_DM0858_RI0064', 'SZ0010-SS0215_DM0858_RI0065', 'SZ0010-SS0216_DM0859_RI0059', 'SZ0010-SS0216_DM0859_RI0060', 'SZ0010-SS0216_DM0859_RI0061', 'SZ0010-SS0216_DM0859_RI0062', 'SZ0010-SS0216_DM0859_RI0063', 'SZ0010-SS0216_DM0859_RI0064', 'SZ0010-SS0216_DM0859_RI0065', 'SZ0010-SS0217_DM0860_RI0059', 'SZ0010-SS0217_DM0860_RI0060', 'SZ0010-SS0217_DM0860_RI0061', 'SZ0010-SS0217_DM0860_RI0062', 'SZ0010-SS0217_DM0860_RI0063', 'SZ0010-SS0217_DM0860_RI0064', 'SZ0010-SS0217_DM0860_RI0065', 'SZ0010-SS0218_DM0861_RI0059', 'SZ0010-SS0218_DM0861_RI0060', 'SZ0010-SS0218_DM0861_RI0061', 'SZ0010-SS0218_DM0861_RI0062', 'SZ0010-SS0218_DM0861_RI0063', 'SZ0010-SS0218_DM0861_RI0064', 'SZ0010-SS0218_DM0861_RI0065', 'SZ0010-SS0219_DM0862_RI0059', 'SZ0010-SS0219_DM0862_RI0060', 'SZ0010-SS0219_DM0862_RI0061', 'SZ0010-SS0219_DM0862_RI0062', 'SZ0010-SS0219_DM0862_RI0063', 'SZ0010-SS0219_DM0862_RI0064', 'SZ0010-SS0219_DM0862_RI0065', 'SZ0010-SS0220_DM0863_RI0059', 'SZ0010-SS0220_DM0863_RI0060', 'SZ0010-SS0220_DM0863_RI0061', 'SZ0010-SS0220_DM0863_RI0062', 'SZ0010-SS0220_DM0863_RI0063', 'SZ0010-SS0220_DM0863_RI0064', 'SZ0010-SS0220_DM0863_RI0065', 'SZ0010-SS0221_DM0864_RI0059', 'SZ0010-SS0221_DM0864_RI0060', 'SZ0010-SS0221_DM0864_RI0061', 'SZ0010-SS0221_DM0864_RI0062', 'SZ0010-SS0221_DM0864_RI0063', 'SZ0010-SS0221_DM0864_RI0064', 'SZ0010-SS0221_DM0864_RI0065', 'SZ0010-SS0222_DM0865_RI0059', 'SZ0010-SS0222_DM0865_RI0060', 'SZ0010-SS0222_DM0865_RI0061', 'SZ0010-SS0222_DM0865_RI0062', 'SZ0010-SS0222_DM0865_RI0063', 'SZ0010-SS0222_DM0865_RI0064', 'SZ0010-SS0222_DM0865_RI0065'];

var PatrimonioCheckBoxesIds = exports.PatrimonioCheckBoxesIds = ['SZ0010SS0213DM0856RI0059', 'SZ0010SS0213DM0856RI0060', 'SZ0010SS0213DM0856RI0061', 'SZ0010SS0213DM0856RI0062', 'SZ0010SS0213DM0856RI0063', 'SZ0010SS0213DM0856RI0064', 'SZ0010SS0213DM0856RI0065', 'SZ0010SS0214DM0857RI0059', 'SZ0010SS0214DM0857RI0060', 'SZ0010SS0214DM0857RI0061', 'SZ0010SS0214DM0857RI0062', 'SZ0010SS0214DM0857RI0063', 'SZ0010SS0214DM0857RI0064', 'SZ0010SS0214DM0857RI0065', 'SZ0010SS0215DM0858RI0059', 'SZ0010SS0215DM0858RI0060', 'SZ0010SS0215DM0858RI0061', 'SZ0010SS0215DM0858RI0062', 'SZ0010SS0215DM0858RI0063', 'SZ0010SS0215DM0858RI0064', 'SZ0010SS0215DM0858RI0065', 'SZ0010SS0216DM0859RI0059', 'SZ0010SS0216DM0859RI0060', 'SZ0010SS0216DM0859RI0061', 'SZ0010SS0216DM0859RI0062', 'SZ0010SS0216DM0859RI0063', 'SZ0010SS0216DM0859RI0064', 'SZ0010SS0216DM0859RI0065', 'SZ0010SS0217DM0860RI0059', 'SZ0010SS0217DM0860RI0060', 'SZ0010SS0217DM0860RI0061', 'SZ0010SS0217DM0860RI0062', 'SZ0010SS0217DM0860RI0063', 'SZ0010SS0217DM0860RI0064', 'SZ0010SS0217DM0860RI0065', 'SZ0010SS0218DM0861RI0059', 'SZ0010SS0218DM0861RI0060', 'SZ0010SS0218DM0861RI0061', 'SZ0010SS0218DM0861RI0062', 'SZ0010SS0218DM0861RI0063', 'SZ0010SS0218DM0861RI0064', 'SZ0010SS0218DM0861RI0065', 'SZ0010SS0219DM0862RI0059', 'SZ0010SS0219DM0862RI0060', 'SZ0010SS0219DM0862RI0061', 'SZ0010SS0219DM0862RI0062', 'SZ0010SS0219DM0862RI0063', 'SZ0010SS0219DM0862RI0064', 'SZ0010SS0219DM0862RI0065', 'SZ0010SS0220DM0863RI0059', 'SZ0010SS0220DM0863RI0060', 'SZ0010SS0220DM0863RI0061', 'SZ0010SS0220DM0863RI0062', 'SZ0010SS0220DM0863RI0063', 'SZ0010SS0220DM0863RI0064', 'SZ0010SS0220DM0863RI0065', 'SZ0010SS0221DM0864RI0059', 'SZ0010SS0221DM0864RI0060', 'SZ0010SS0221DM0864RI0061', 'SZ0010SS0221DM0864RI0062', 'SZ0010SS0221DM0864RI0063', 'SZ0010SS0221DM0864RI0064', 'SZ0010SS0221DM0864RI0065', 'SZ0010SS0222DM0865RI0059', 'SZ0010SS0222DM0865RI0060', 'SZ0010SS0222DM0865RI0061', 'SZ0010SS0222DM0865RI0062', 'SZ0010SS0222DM0865RI0063', 'SZ0010SS0222DM0865RI0064', 'SZ0010SS0222DM0865RI0065'];
var Metadata = exports.Metadata = function Metadata(body) {
  return API.Metadata(body).then(function (_ref9) {
    var data = _ref9.data;
    return data;
  });
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var unit = exports.unit = function unit(str) {
  return str.replace(/([\.\d]+)(.*)/, '$2');
};
var number = exports.number = function number(str) {
  return Number(str.replace(/([\.\d]+)(.*)/, '$1'));
};
var important = exports.important = function important(str) {
  return str + ' !important';
};

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = exports.UpdateReferalCode = exports.ValidateUser = exports.SendMailWithPromoCode = exports.updateOnboardingDetails = exports.FetchPOSOnboardDetails = exports.FetchPOSPlan = exports.ValidatePromoCode = exports.FetchPromoCode = exports.updatePromoCode = exports.insertGUID = exports.insertPromoCode = exports.fetchIPAddress = exports.getTimUserInfo = exports.uploadFile = exports.getFilePreview = exports.saveTitolare = exports.savePersonalizzaPOS = exports.savePg = exports.acknowledgePOSContract = exports.acknowledgeContract = exports.checkContract = exports.getAutofillValues = exports.getServerValidation = exports.fetchSelectOptions = exports.fetchAPIData = exports.getProductInfo = exports.getPrevStep = exports.getNextStep = exports.resumeContactProcess = exports.resumeProcess = exports.validateResumeOtp = exports.initThankYouPage = exports.initReuploadProcess = exports.requireResumeOtpSms = exports.sendResumeOtpSms = exports.completeReupload = exports.getContracts = exports.getUserRequests = exports.initRecoveryProcess = exports.initResumeProcess = exports.startOnboarding = exports.unauth = exports.auth = exports.downloadPdf = exports.base64ToArrayBuffer = exports.extractFileNameFromUrl = exports.request = undefined;

var _set = __webpack_require__(111);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(264);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _isomorphicFetch = __webpack_require__(121);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _qs = __webpack_require__(124);

var _qs2 = _interopRequireDefault(_qs);

var _uuid = __webpack_require__(170);

var _uuid2 = _interopRequireDefault(_uuid);

var _utils = __webpack_require__(12);

var _stateExtension = __webpack_require__(95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Cookies from 'universal-cookie';


/**
 * Functions used to connect to the API server
 * @module API
 */

/**
 * The API root
 * @private
 */
var API_ROOT = "https://www.sella.it/onboarding";
var PROMO_API_ROOT = "https://sandbox2.gestpay.net/PromocodesService";
var Onboard_API_ROOT = "https://sandbox2.gestpay.net/onboardingpos";

/**
 * The basic request
 * @private
 * @throws      NoGivenEndpointException
 * @param {Object} options              The options object
 * @param {string} options.endpoint     The endpoint to fetch
 * @param {string} options.method       The request method ['GET', ?POST', PUT', 'PATCH', 'DELETE'
 * @param {Object} options.body         The body to send in the request
 * @param {Object} options.headers      The request headers
 * @return {Promise}                    A fetch request
 */
var request = exports.request = function request() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endpoint = _ref.endpoint,
      method = _ref.method,
      body = _ref.body,
      headers = _ref.headers,
      apiRoot = _ref.apiRoot;

  if (!headers) headers = { 'Content-Type': 'application/json' };
  if (!method) method = 'POST';
  if (endpoint === '') throw 'You need to pass an endpoint to fetch';
  if (apiRoot === undefined || apiRoot === null) apiRoot = API_ROOT;

  //let uri=`${apiRoot}/${endpoint}`
  // @remarks uncomment to test mocked endpoints redescribing them in the stateExtension as full urls
  // uri = /:\/\//.test(endpoint) ? endpoint : `${API_ROOT}/${endpoint}`
  if (endpoint.indexOf('onboarding/upload') > -1) {
    headers = (0, _extends3.default)({}, headers, {
      Cookie: 'key=value;' + document.cookie
    });
  }

  var req = {
    credentials: 'include',
    method: method,
    headers: headers
  };
  if (endpoint.indexOf('PromoCodeManagement') > -1 || endpoint.indexOf('OnboardRequestDetails') > -1) //sandbox.gestpay.net
    {
      req.credentials = true;
      delete req['credentials'];
    }
  var uri = '';
  uri = endpoint.indexOf('PromoCodeManagement') > -1 || endpoint.indexOf('OnboardRequestDetails') > -1 ? PROMO_API_ROOT + '/' + endpoint : apiRoot + '/' + endpoint;
  var onboardingURI = Onboard_API_ROOT + '/onboarding/wgt';
  if (body) {
    if (method === 'GET' && body) {
      uri += '?' + _qs2.default.stringify(body);
    } else if (headers['Content-Type'] === 'application/json') {
      req.body = (0, _stringify2.default)(body);
    } else {
      req.body = body;
    }
  }

  var ApiReqbody = "";
  if (!req.body) {
    ApiReqbody = "";
  } else {
    ApiReqbody = req.body;
  }
  var apiRequestbody = {
    ApiUrl: uri,
    ApiHttpMethod: req.method,
    ApiContent: ApiReqbody,
    ApiHeader: (0, _stringify2.default)(headers)
  };

  var apiRequest = {
    credentials: 'include',
    body: (0, _stringify2.default)(apiRequestbody),
    method: 'POST',
    //headers:JSON.stringify(req.headers)
    headers: { 'Content-Type': 'application/json' }
  };

  if (endpoint.indexOf('OnboardRequestDetails') > -1 || endpoint.indexOf('PromoCodeManagement') > -1) {
    onboardingURI = uri;
    apiRequest = req;
  }

  if (endpoint.indexOf('wgt/document/upload') > -1 || endpoint.indexOf('wgt/genericfiledoc/upload') > -1 || endpoint.indexOf('wgt/contact/upload') > -1 || endpoint.indexOf('wgt/genericdocument/upload') > -1) {
    req.headers['ApiUrl'] = uri;
    onboardingURI = Onboard_API_ROOT + '/onboarding/upload';
    apiRequest = req;
  }

  return (0, _isomorphicFetch2.default)(onboardingURI, apiRequest)
  //return fetch(uri,req)
  .then(function (res) {
    if ((uri.endsWith('wgt/product/onboarding/next') || uri.endsWith('wgt/product/onboarding/back')) && res.status === 200) {
      window.scrollTo(0, 0);
    }
    if (headers['Content-Type'] === 'application/pdf') {
      res.text().then(function (text) {
        var fileName = extractFileNameFromUrl(endpoint);
        var fileContent = text.slice(1, -1);
        downloadPdf(fileName, fileContent);
        return true;
      });
    } else if (req.headers['Content-Type'] === 'application/image') {
      var _json = {
        status: 'success',
        message: 'ok',
        data: { url: uri }
      };

      if (res.status >= 400) {
        _json.status = 'error';
      }

      if (res.status === 404) {
        _json.status = 'not_found';
      }

      return _json;
    } else if (res.headers.get('Content-Type').indexOf('application/json') > -1 || res.headers.get('Content-Type').indexOf('text/plain') > -1 && headers['Content-Type'] === 'application/json') {
      // the second condition has been added to avoid misinterpretation of openAM response
      return res.json();
    } else {
      return res;
    }
  }).catch(function (res) {
    // @hack for IE (can't handle redirect on ajax requests)
    if (res.message === 'Network request failed' && res.name === 'TypeError') {
      return { status: 'redirect', message: '' };
    } else {
      return { status: 'error', message: 'unknown error' };
    }
  });
};

var extractFileNameFromUrl = exports.extractFileNameFromUrl = function extractFileNameFromUrl(url) {
  var fileName = "";
  if (url) {
    var urlArr = url.split("/");
    fileName = urlArr[urlArr.length - 1];
  }
  return fileName;
};

var base64ToArrayBuffer = exports.base64ToArrayBuffer = function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};

var downloadPdf = exports.downloadPdf = function downloadPdf(fileName, base64) {
  var byte = base64ToArrayBuffer(base64);
  var blob = new Blob([byte], { type: "application/pdf" });

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

/**
 * Encrypts a proof using the yoox encoder
 * @public
 * @param  {Object} proof   The plain third party data container
 * @return {Promise}        Promise
 */
/*#Removed4POS*/
/*export const encryptYooxProof = proof => {
  const body = { value: proof }

  const endpoint = 'api/rest/FREE/encrypt/yoox'

  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, body, apiRoot })
}*/

/**
 * Decrypts a proof using the yoox decoder
 * @public
 * @param  {Object} proof   The encrypted third party data container
 * @return {Promise}        Promise
 */
/*#Removed4POS*/
/*export const decryptYooxProof = proof => {
  const body = { value: proof.value }

  const endpoint = 'api/rest/FREE/decrypt/yoox'

  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, body, apiRoot })
}*/

/**
 * Logs the provided state to the server and traces an invitation's referrer
 * @public
 * @param  {Object} invitation  The session containing the dispatched actions and updated states
 * @return {Promise}            The server response.jswon
 */
/*#Removed4POS*/
/*export const acceptInvitation = invitation => {
  // @remarks re-enable once the service will be ready to accept LOG types and get only the last invitation to populate the fields on step1
  // invitation.type = !!invitation.promoCode || !!invitation.campaignUrl || !!invitation.encryptedReporterId ? 'INVITATION' : 'LOG'
  invitation.type = 'INVITATION'
  // @remarks commented to avoid bad responses from the signaler services until it will be synced to the latest contract
  const body = invitation

  // const body = {
  //   type: invitation.type,
  //   contactId: invitation.contactId,
  //   promoCode: invitation.promoCode,
  //   campaignUrl: invitation.campaignUrl,
  //   encryptedReporterId: invitation.encryptedReporterId,
  //   codiceFiscale: invitation.codiceFiscale
  // }

  const endpoint = 'api/rest/FREE/onboarding/invitations'

  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, body, apiRoot })
}*/

/**
 * Gets an invitation by contactId
 * @public
 * @param  {string} contactId   The contact's file id
 * @return {Promise}            The server response.json
 */
/*#Removed4POS*/
/*export const getInvitation = contactId => {
  const endpoint = `api/rest/FREE/onboarding/invitations?contactId=${contactId}&type=invitation&last=true`
  const method = 'GET'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, method, apiRoot }).then(json => {
    json.data = json.data[0]
    return json
  })
}*/

/**
 * Gets all the invitations by contactId
 * @public
 * @param  {string} contactId   The contact's file id
 * @return {Promise}            The server response.json
 */
/*#Removed4POS*/
/*export const getInvitations = contactId => {
  const endpoint = `api/rest/FREE/onboarding/invitations?contactId=${contactId}&type=invitation`
  const method = 'GET'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')

  return request({ endpoint, method, apiRoot })
}*/

/**
 * OpenAM Auth
 * @public
 * @param {Object} body                   The callbacks to rebounce (empty obj on first call)
 * @return {Promise}                      The server response.json
 */
var auth = exports.auth = function auth(body) {
  return request({ endpoint: 'auth/sso/json/authenticate', body: body }).then(function (json) {
    return !!json.tokenId ? request({ endpoint: 'wgt/auth', body: {} }).then(function () {
      return json;
    }).catch(function () {
      return json;
    }) : json;
  });
};

/**
 * OpenAM UnAuth
 * @public
 * @param {Object} body                   The callbacks to rebounce (empty obj on first call)
 * @return {Promise}                      The server response.json
 */
var unauth = exports.unauth = function unauth() {
  return request({ endpoint: 'wgt/unauth', body: {} }).then(function () {
    return json;
  }).catch(function () {
    return json;
  });
};

/**
 * Starts the onboarding process
 * @public
 * @param {string} partnership = 'HYPE'   The partnership code
 * @param {string} convention = 'ND'      The convention code
 * @param {Object} thirdPartyData         Third party init data
 * @return {Promise}                      The server response.json
 */
var startOnboarding = exports.startOnboarding = function startOnboarding() {
  var partnership = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'POS';
  var convention = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ND';
  var thirdPartyData = arguments[2];

  var p = partnership && partnership.toUpperCase();
  switch (p) {
    case 'POS_PERSONA_FISICA_EASYNOLO':
    case 'POS_DITTA_IND_EASYNOLO':
    case 'POS_AZIENDA_EASYNOLO':
    case 'POS_PERSONA_FISICA':
    case 'POS_DITTA_IND':
    case 'POS_AZIENDA':
      return request({
        endpoint: 'wgt/product/onboarding/start',
        body: { code: partnership, thirdPartyData: thirdPartyData }
      });
    default:
      return request({
        endpoint: 'wgt/' + partnership + '/' + convention + '/start',
        body: { data: thirdPartyData }
      });
  }
};

/**
 * Gets the form fields needed to resume the onboarding process
 * @public
 * @param {string} guid                   The guid of the session to recover
 * @return {Promise}                      The server response.json
 */
var initResumeProcess = exports.initResumeProcess = function initResumeProcess(guid) {
  var body = { guid: guid };
  return request({ endpoint: 'wgt/resume/start', body: body }).then(function (json) {
    if (json.status !== 'redirect' && json.status !== 'error') {
      return (0, _extends3.default)({}, json, {
        isOtpCallback: true,
        step: (0, _extends3.default)({}, json.data.step, { name: 'resume' }),
        data: undefined
      });
    } else {
      return json;
    }
  });
};

/**
 * Gets the form fields needed to get the contract list
 * @public
 * @param {string} guid                   The guid of the session to recover
 * @return {Promise}                      The server response.json
 */
var initRecoveryProcess = exports.initRecoveryProcess = function initRecoveryProcess() {
  var body = {};
  return request({ endpoint: 'wgt/contact/start', body: body }).then(function (json) {
    return (0, _extends3.default)({}, json, {
      step: json.data.step
    });
  });
};

/**
 * Gets the contracts list (only after initRecoveryProcess has been launched)
 * @public
 * @return {Promise}                      The server response.json
 */
var getUserRequests = exports.getUserRequests = function getUserRequests() {
  return request({ endpoint: 'wgt/contact/list' });
};

/**
 * Gets a pending contract
 * @public
 * @param {string} guid                   The guid of the contract to read
 * @return {Promise}                      The server response.json
 */
var getContracts = exports.getContracts = function getContracts(guid) {
  var body = { guid: guid };
  return request({ endpoint: 'wgt/contact/contract/list', body: body });
};

/**
 * Send the reuploaded document
 * @public
 * @param {string} guid                   The guid of the session to recover
 * @param {string} barCode1               The barcode of contarct document upload
 * @param {string} barCode2               The barcode of contarct document upload
 * @return {Promise}                      The server response.json
 */
var completeReupload = exports.completeReupload = function completeReupload(guid, barCode1, barCode2) {
  var body = { guid: guid, barCode1: barCode1, barCode2: barCode2 };
  return request({ endpoint: 'wgt/contact/sendpdf', body: body });
};

/**
 * Sends the OTP SMS needed to resume an onboarding contract
 * @public
 * @param {Boolean} forClosedContract     Specifies if the otp has to be sent for an open or closed contract
 * @return {Promise}                      The server response.json
 */
var sendResumeOtpSms = exports.sendResumeOtpSms = function sendResumeOtpSms(forClosedContract) {
  if (!forClosedContract) {
    return request({ endpoint: 'wgt/resume/send/cell' });
  } else {
    return request({ endpoint: 'wgt/contact/send/cell' });
  }
};

/**
 * Requires the OTP SMS needed to resume an onboarding contract
 * @public
 * @param {Object} body                   The body containing the tern to access the contracts list
 * @param {string} guid                   The session guid
 * @return {Promise}                      The server response.json
 */
var requireResumeOtpSms = exports.requireResumeOtpSms = function requireResumeOtpSms(body, guid) {
  return request({ endpoint: 'wgt/contact/next', body: body }).then(function (json) {
    var mock = (0, _stateExtension.getResumeByOtpMock)(body, guid);

    mock.isOtpCallback = true;
    mock.isContractClosed = true;

    if (!!json && json.status === 'success' && !json.step) {
      return mock;
    } else {
      return json;
    }
  });
};

/**
 * Requires the component to reupload the document and resume onboarding contract
 * @public
 * @param {string}        guid            The session guid
 * @param {string}        barCode         The document barCode
 * @param {string}        docType         The document type
 * @param  {Boolean}      showSelfie      Establishes if the selfie widget should be added to the mock
 * @return {Promise}                      The server response.json
 */
var initReuploadProcess = exports.initReuploadProcess = function initReuploadProcess(guid, barCode, docType, showSelfie) {
  var mock = (0, _stateExtension.getReuploadDocumentsMock)(docType, showSelfie);

  mock.step.widgets.forEach(function (w) {
    w.components.forEach(function (c) {
      c.guid = guid;
      c.barCode = barCode;
    });
  });

  return mock;
};

/**
 * Requires TYP mocked data
 * @public
 * @param  {string} contactId   The last session's contactId
 * @return {Object}             The step json
 */
var initThankYouPage = exports.initThankYouPage = function initThankYouPage(contactId, parentGuid) {
  return (0, _stateExtension.getThankYouPageMock)(contactId, parentGuid);
};

/**
 * Validates a resume OTP
 * @public
 * @param {string} otp                    The guid of the session to recover
 * @param {Boolean} forClosedContract     Specifies if the otp has to be sent for an open or closed contract
 * @return {Promise}                      The server response.json
 */
var validateResumeOtp = exports.validateResumeOtp = function validateResumeOtp(otp, forClosedContract) {
  var body = { code: otp };
  if (!forClosedContract) {
    return request({ endpoint: 'wgt/resume/validate/cell', body: body });
  } else {
    return request({ endpoint: 'wgt/contact/validate/cell', body: body });
  }
};

/**
 * Resumes an onboarding contract after a successful OTP validation
 * @public
 * @return {Promise}                      The server response.json
 */
var resumeProcess = exports.resumeProcess = function resumeProcess() {
  return request({ endpoint: 'wgt/resume' }).then(function (json) {
    return (0, _extends3.default)({}, json, {
      step: json.data && json.data.step,
      data: undefined
    });
  });
};

/**
 * Resumes an onboarding contract from the dossier list
 * @public
 * @param  {string}     guid              The session guid
 * @return {Promise}                      The server response.json
 */
var resumeContactProcess = exports.resumeContactProcess = function resumeContactProcess(guid) {
  var body = { guid: guid };

  return request({ endpoint: 'wgt/contact/resume', body: body }).then(function (json) {
    return (0, _extends3.default)({}, json, {
      step: json.data.step,
      data: undefined
    });
  });
};

/**
 * Gets the next step in the onboarding process
 * @public
 * @param {Object} widgets      The current widgets
 * @param {Object} components   The current components
 * @param {Number} stepNumber   The current onboarding step
 * @return {Promise}            The server response.json
 */
var getNextStep = exports.getNextStep = function getNextStep(widgets, components, stepNumber) {
  var body = null;
  if (widgets) {
    body = {
      step: {
        number: stepNumber,
        widgets: (0, _utils.compressWidgets)(widgets, components)
      }
    };
  }
  return request({ endpoint: 'wgt/product/onboarding/next', body: body });
};

/**
 * Gets the previous step in the onboarding process
 * @public
 * @return {Promise}      The server response.json
 */
var getPrevStep = exports.getPrevStep = function getPrevStep() {
  return request({ endpoint: 'wgt/product/onboarding/back', method: 'GET' });
};

/**
 * Gets the product info
 * @public
 * @return {Promise}      The server response.json
 */
var getProductInfo = exports.getProductInfo = function getProductInfo() {
  return request({ endpoint: 'wgt/product/info', method: 'GET' });
};

/**
 * Common API method to fetch data
 * @public
 * @param {string} url     The API endpoint to retrieve the options
 * @param {Object} body           Additional info to send with the request
 * @return {Promise}              The server response.json
 */
var fetchAPIData = exports.fetchAPIData = function fetchAPIData(url, body) {
  return request({ endpoint: url, body: body }); /*.then(json => json.data)*/
};

/**
 * Fills all the selects with their options
 * @public
 * @param {string} optionsURL     The API endpoint to retrieve the options
 * @param {Object} body           Additional info to send with the request
 * @return {Promise}              The server response.json
 */
var fetchSelectOptions = exports.fetchSelectOptions = function fetchSelectOptions(optionsURL, body) {
  return request({ endpoint: optionsURL, body: body }).then(function (json) {
    return json.data;
  });
};

/**
 * Fills all the selects with their options
 * @public
 * @param {string} component          The component to validate
 * @param {Object} requiredValues     Values that the server needs to validate the component
 * @return {Promise}                  The new updated component with the server error messages
 */
var getServerValidation = exports.getServerValidation = function getServerValidation(component, requiredValues) {
  // if (component.name === 'INDIRIZZO') {
  //   requiredValues.indirizzo = requiredValues.indirizzo.replace(
  //     /(\s+(?:\d+|snc)).+/,
  //     '$1'
  //   )
  // }
  return request({
    endpoint: component.validations.url,
    body: requiredValues,
    method: component.validations.method
  }).then(function (json) {
    if (component.name === 'INDIRIZZO') {
      var addressJson = (0, _extends3.default)({}, json.data, {
        statusCode: json.data.status,
        status: json.status
      });

      if (!json.data.errorMessage && !json.data.failureMessage && !json.data.civicoFailureMessage) {
        addressJson.status = 'success';
        addressJson.statusCode = 'ok';
      }

      if (json.status === 'error') {
        var missingAddressChunk = component.value.split(/\s+(?=(?:\d+|snc))/).map(function (e, i) {
          return i !== 0 && e;
        }).filter(function (e) {
          return !!e;
        }).join('');

        if (!!json.data.listIndirizzi && json.data.listIndirizzi.length > 0) {
          addressJson.values = [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(json.data.listIndirizzi.map(function (e) {
            if (/.+\s+(?:\d+|snc)/.test(e.indirizzo)) {
              return e.indirizzo;
            } else {
              return e.indirizzo + ' ' + missingAddressChunk;
            }
          })), [component.value])))).map(function (s) {
            return {
              label: s.toUpperCase(),
              value: s.toUpperCase()
            };
          });
        }
        addressJson.description = addressJson.message = json.data.errorMessage || json.data.civicoFailureMessage || json.data.warningMessage || json.data.civicoWaringMessage || component.cleanName + ' non validi';
      } else {
        json.description = addressJson.message = undefined;
      }

      json = addressJson;
    }
    var _json2 = json,
        status = _json2.status,
        message = _json2.message,
        values = _json2.values;

    var result = {
      status: [status]
    };

    if (json.hasOwnProperty('statusCode')) {
      result.status = [].concat((0, _toConsumableArray3.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(result.status), [function () {
        return json.statusCode.toLowerCase() !== 'ko' && json.statusCode.toLowerCase() !== '0001' ? 'success' : 'error';
      }()]))));
      result.errorMessage = json.statusCode.toLowerCase() !== 'ko' && json.statusCode.toLowerCase() !== '0001' ? '' : json.description;
      if (result.errorMessage.toLowerCase().indexOf('invalid otp') > -1) {
        result.errorMessage = ['OTP non valido'];
      } else {
        result.errorMessage = [result.errorMessage];
      }
    }

    // @hack for CF to trigger login modal
    if (json.data && json.data.hasOwnProperty('login')) {
      result.loginRequired = json.data.login;
    }

    // @hack for promoCode to trigger redirect on correct flow
    if (json.data && json.data.hasOwnProperty('redirect')) {
      result.redirectRequired = json.data.redirect;
    }
    // if (component.name === "PromoCode") {
    //   console.log(json)
    // }
    if (status === 'error') {
      if (component.name === "PromoCode") {
        result.errorMessage = !!json.error && !!json.error.description ? [json.error.description] : "";
        result.salesManId = "";
      } else {
        result.errorMessage = [message.replace('è invalido', 'non è valido')];
      }
    } else if (status === 'success') {
      result.errorMessage = '';
      if (component.name === "PromoCode") {
        result.salesManId = json.payLoad.SalesManId;
      }
    }

    if (!!values) {
      result.values = values;
    }

    return result;
  });
};

/**
 * Fetches component values needed to autofill other components
 * @public
 * @param  {string} endpoint      The API endpoint that returns values
 * @param  {type} body            The information needed to get the required data
 * @param  {Guid} requestId       The requestId
 * @return {Promise}              The server response.json
 */
var getAutofillValues = exports.getAutofillValues = function getAutofillValues(endpoint, body, requestId) {
  return request({ endpoint: endpoint, body: body }).then(function (json) {
    return (0, _extends3.default)({}, json, { requestId: requestId });
  });
};

var checkContract = exports.checkContract = function checkContract() {
  return request({ endpoint: 'wgt/sign/check', body: {} });
};

/**
 * Acknowledges the contract
 * @public
 * @param  {Object} component     The component
 * @return {Promise}              ?
 */
var acknowledgeContract = exports.acknowledgeContract = function acknowledgeContract(component) {
  var body = {
    stampeId: component.link.stampeId,
    barCode: component.link.barCode
  };
  return request({ endpoint: component.acknowledgement.url, body: body });
};

var acknowledgePOSContract = exports.acknowledgePOSContract = function acknowledgePOSContract(state) {
  var url = 'wgt/product/onboarding/next';
  var body = {
    step: {
      number: state.step.number,
      widgets: [{
        code: state.widgets.DIFARMA_0.code,
        components: [{
          name: 'check-attf',
          value: ''
        }]
      }]
    }
  };
  return request({ endpoint: url, body: body });
};

var savePg = exports.savePg = function savePg(pgRequest, stepNumber) {
  var body = null;
  var url = stepNumber === 3 ? 'wgt/acol/save' : 'wgt/acol/save/pg';
  body = {
    acolQuestionnaire: pgRequest.data.acolQuestionnaire
  };
  return request({ endpoint: url, body: body });
};

var savePersonalizzaPOS = exports.savePersonalizzaPOS = function savePersonalizzaPOS(widgets, stepNumber) {
  var body = null;
  var url = 'wgt/product/onboarding/next';
  body = {
    step: {
      number: stepNumber + '',
      widgets: widgets
    }
  };
  return request({ endpoint: url, body: body });
};

var saveTitolare = exports.saveTitolare = function saveTitolare(components, stepNumber, widgets) {
  var titoWidget = widgets['TITOLARE_EFFETTIVO'];
  var body = null;
  var url = 'wgt/product/onboarding/next';
  body = {
    step: {
      number: stepNumber,
      widgets: [{
        code: titoWidget.code,
        components: components
      }]
    }
  };
  return request({ endpoint: url, body: body });
};

/**
 * Gets the file preview for the provided uploader
 * @public
 * @param  {Object} component The component
 * @param  {Object} extraBody The formdata
 * @return {Promise}           [description]
 */
var getFilePreview = exports.getFilePreview = function getFilePreview(component, extraBody) {
  var url = '';
  if (!!extraBody && !!extraBody.widgetId) {
    url = 'genericfiledoc/previewGet/' + extraBody.type + '_' + extraBody.widgetId + '_' + extraBody.docRefId + '?r=' + Math.random();
  } else {
    url = 'wgt/document/preview/' + component.uploadType + '?v=' + (0, _uuid2.default)();
    //url= `wgt/document/v2/preview/${component.uploadType}?r=`+Math.random() -- New one
  }
  var opt = {
    endpoint: url,
    method: 'GET',
    headers: { 'Content-Type': 'application/image' }
  };
  return request(opt).then(function (json) {
    if (json.status === 'success') {
      return json.data.url;
    } else {
      return '';
    }
  });
};

/**
 * Uploads a file
 * @public
 * @param {string} base64URL     The base64 encoded string
 * @param {Enum} type            One of FRONT_DOC_1, BACK_DOC_1, FRONT_DOC_2, BACK_DOC_2, SELFIE
 * @param  {string} guid         The session guid
 * @param  {string} barCode      The document barCode
 * @return {Promise}             The server response.json
 */
var uploadFile = exports.uploadFile = function uploadFile(file, base64URL, type, guid, barCode, extraBody) {
  var endpoint = null;
  var base64chunks = base64URL.split(';');
  var base64 = base64chunks[1].replace('base64,', '');
  var contentType = !!file.type ? file.type : base64chunks[0].replace('data:', '');
  var body = new FormData();

  if (extraBody && extraBody.docRefId) {
    body.append('type', extraBody.type);
  } else {
    body.append('type', type);
  }

  if (!!file.name) {
    body.append('file', (0, _utils.b64toBlob)(base64, contentType), file.name);
  } else {
    body.append('file', (0, _utils.b64toBlob)(base64, contentType), 'blob');
  }

  endpoint = 'wgt/document/upload';

  if (extraBody && extraBody.docRefId) {
    body.append('docRefId', extraBody.docRefId);
    body.append('widgetId', extraBody.widgetId);
    body.append('docType', extraBody.docType);
    endpoint = 'wgt/genericfiledoc/upload';
  }

  if (!!guid && !!barCode) {
    endpoint = 'wgt/contact/upload';
    body.append('guid', guid);
    body.append('barCode', barCode);
  }
  //Changes for loading new widget 
  if (type == 'FRONT_DOC_') {
    body.append('widgetId', extraBody.widgetId);
    endpoint = 'wgt/genericdocument/upload';
  }
  return request({ endpoint: endpoint, body: body, headers: {} });
};

/**
 * Gets tim user info
 * @public
 * @param  {string} proof   Tim authorization code
 * @return {Promise}        userObject promise
 */
var getTimUserInfo = exports.getTimUserInfo = function getTimUserInfo(proof) {
  var env = (0, _utils.getEnv)();

  var domain = {
    third: 'api',
    second: 'platfr',
    first: 'io'
  };

  switch (env) {
    case 'tst':
      domain.first = 'tst';
      break;
    case 'pre':
      domain.third = 'sandbox';
      domain.first = 'io';
      break;
    case 'pro':
      break;
    default:
      domain.first = 'tst';
  }

  var body = {
    code: proof.code,
    state: proof.state
  };

  var endpoint = 'api/public/auth/v1/saminifo-tim';
  var method = 'GET';
  var apiRoot = 'https://' + domain.third + '.' + domain.second + '.' + domain.first;
  return request({ endpoint: endpoint, method: method, body: body, apiRoot: apiRoot });
};

/**
 * Sends an OTP to the provided recipient trough the provided channel
 * @public
 * @param  {string} channel      The message channel
 * @param  {string} recipient    The message recipient
 * @return {Promise}             otp delivery promise
 * @fulfil {Object}              Success response
 * @reject {Error}               Error response
 */
/*#Removed4POS*/
/*export const sendOtp = (channel, recipient) => {
  const endpoint = 'api/rest/FREE/otp/send'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')
  const body = {
    type: channel,
    typeValue: recipient,
    templateId: 'ONBOARDING OTP' // this template isn't valid anymore, infer it using the EXTRA value located in stateExtension.js
  }

  return request({
    endpoint,
    body,
    apiRoot
  })
}*/

/**
 * Notifies the onboarding completion to the specified tenant
 * @param  {string} contactId  contactId
 * @param  {string} name   step name
 * @return {Promise}           promise
 */
/*#Removed4POS*/
/*export const track = ({ contactId, name }) => {
  const endpoint = 'api/rest/FREE/onboarding/tracking'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')
  const body = {
    idPratica: contactId,
    state: name.toUpperCase()
  }

  return request({
    endpoint,
    apiRoot,
    body
  })
}*/

/**
 * Notifies the onboarding completion to the specified tenant
 * @param  {string} idPratica  contactId
 * @param  {string} phone      phone number
 * @param  {string} email      email
 * @param  {string} tenant     tenant
 * @return {Promise}           promise
 */
/*#Removed4POS*/
/*export const notifyCompletion = ({ idPratica, phone, email, tenant }) => {
  const endpoint = 'api/rest/FREE/onboarding/endup'
  const apiRoot = API_ROOT.replace(/\/onboarding/, '')
  const body = {
    idPratica,
    phone: phone.replace(/(?:\+\d\d)?(\d+)/, '$1'),
    email,
    tenant
  }

  return request({
    endpoint,
    apiRoot,
    body
  })
}*/
var fetchIPAddress = exports.fetchIPAddress = function fetchIPAddress() {
  return (0, _isomorphicFetch2.default)("https://api.ipify.org?format=json").then(function (response) {
    return response.json();
  });
};

var insertPromoCode = exports.insertPromoCode = function insertPromoCode(promoCodeComp) {
  var body = null;
  if (promoCodeComp) {
    body = {
      Guid: promoCodeComp.Guid,
      ContactId: promoCodeComp.ContactId,
      MerchantName: promoCodeComp.MerchantName,
      PromoCode: promoCodeComp.PromoCode,
      CreationDate: promoCodeComp.CreationDate,
      ModifiedDate: promoCodeComp.ModifiedDate,
      CodiceFiscale: promoCodeComp.CodiceFiscale,
      VatNumber: promoCodeComp.VatNumber,
      SalesManId: promoCodeComp.SalesManID,
      FirstName: promoCodeComp.Nome,
      RagioneSociale: promoCodeComp.RagioneSociale,
      Email: promoCodeComp.Email,
      plan: promoCodeComp.PLAN,
      clientip: promoCodeComp.ClientIP,
      PRIVACYFK: promoCodeComp.PRIVACYFK
    };
  }

  return request({ endpoint: 'OnboardRequestDetails/InsertOnboardingDetails', body: body });
};
var insertGUID = exports.insertGUID = function insertGUID(requestBody) {
  var body = null;
  if (requestBody) {
    body = {
      Guid: requestBody.Guid,
      plan: requestBody.plan === 'flex' ? 'flex' : requestBody.plan === 'flexCRS' ? 'flexCRS' : requestBody.plan === 'flatCRS' ? 'flatCRS' : requestBody.plan === 'flexmini' ? 'flexmini' : 'flat'
    };
  }

  return request({ endpoint: 'OnboardRequestDetails/InsertOnboardingDetails', body: body });
};
//'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/InsertOnboardingDetails'
//https://172.17.4.63/magtek/OnboardRequestDetails/InsertOnboardingDetails
var updatePromoCode = exports.updatePromoCode = function updatePromoCode(promoCodeComp) {
  var body = null;
  if (promoCodeComp) {
    body = {
      ContactId: promoCodeComp.ContactId,
      Guid: promoCodeComp.Guid,
      PromoCode: promoCodeComp.PromoCode
    };
  }

  return request({ endpoint: 'OnboardRequestDetails/UpdateOnboardingDetails', body: body });
};
//'https://sandbox.gestpay.net/PromocodesService/OnboardRequestDetails/UpdateOnboardingDetails'
//https://172.17.4.63/magtek/OnboardRequestDetails/UpdateOnboardingDetails
var FetchPromoCode = exports.FetchPromoCode = function FetchPromoCode(endpoint, body) {
  return request({ endpoint: endpoint, method: "GET", body: body });
};
var ValidatePromoCode = exports.ValidatePromoCode = function ValidatePromoCode(endpoint, body) {
  return request({ endpoint: endpoint, method: "POST", body: body });
};
var FetchPOSPlan = exports.FetchPOSPlan = function FetchPOSPlan(endpoint, body) {
  return request({ endpoint: endpoint, method: "GET", body: body });
};
var FetchPOSOnboardDetails = exports.FetchPOSOnboardDetails = function FetchPOSOnboardDetails(endpoint, body) {
  return request({ endpoint: endpoint, method: "GET", body: body });
};

/**
 * Update the Company address to the database
 * @param {Object} onBoardDetails        The current widgets
 * @return {Promise}              The server response.json
 */
var updateOnboardingDetails = exports.updateOnboardingDetails = function updateOnboardingDetails(onBoardDetails) {
  var body = null;
  if (onBoardDetails) {
    // body = {
    //   Guid: components.Guid,
    //   INSEGNA: components.INSEGNA,
    //   RAGIONESOCIALE: components.RAGIONESOCIALE,
    //   INDIRIZZO: components.INDIRIZZO,
    //   CITTA: components.CITTA,
    //   PROVINCIA: components.PROVINCIA
    // }
    body = onBoardDetails;
  }

  return request({ endpoint: 'OnboardRequestDetails/UpdateOnboardingDetails', body: body });
};
var SendMailWithPromoCode = exports.SendMailWithPromoCode = function SendMailWithPromoCode(onBoardDetails) {
  var body = null;
  if (onBoardDetails) {
    body = onBoardDetails;
  }

  return request({ endpoint: 'OnboardRequestDetails/SendEmail', body: body });
};
var ValidateUser = exports.ValidateUser = function ValidateUser(endpoint, body) {
  return request({ endpoint: endpoint, body: body });
};
var UpdateReferalCode = exports.UpdateReferalCode = function UpdateReferalCode(onBoardDetails) {
  var body = null;
  if (onBoardDetails) {
    body = onBoardDetails;
  }
  return request({ endpoint: 'OnboardRequestDetails/UpdateReferalCode', body: body });
};
//Meta Data API wgt/product/onboarding/metadata
var Metadata = exports.Metadata = function Metadata(body) {
  return request({ endpoint: 'wgt/product/onboarding/metadata', body: body });
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1140);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(532);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  return _react2.default.createElement(
    'button',
    (0, _extends3.default)({
      id: props.id,
      value: props.value,
      onClick: function onClick(e) {
        return props.action(e.target.value);
      },
      disabled: !!props.disabled
    }, (0, _withStyles.css)(props.styles.button, props.styles['button--' + props.type], props.styles['button--pull-' + props.pullTo], props.styles['button--display-' + props.display], props.id === 'DIFARMA_0-FIRMA' || props.id === 'DIFARMA_1-FIRMA' || props.id === 'DIFARMA_2-FIRMA' || props.id === 'DIFARMA_3-FIRMA' || props.id === 'DIFARMA_4-FIRMA' || props.id === 'DIFARMA_5-FIRMA' ? props.styles['button--firma'] : '')),
    props.value === 'Firmato' || props.value === 'Attivata' ? _react2.default.createElement(
      'b',
      null,
      '\u2714 Firmato'
    ) : props.text
  );
};

Button.propTypes = {
  id: _propTypes.PropTypes.string,
  text: _propTypes.PropTypes.string.isRequired,
  type: _propTypes.PropTypes.oneOf(['primary', 'inverse', 'primary-inverse', 'sella', 'active', 'secondry', 'delete']),
  disabled: _propTypes.PropTypes.bool,
  pullTo: _propTypes.PropTypes.oneOf(['left', 'right']),
  action: _propTypes.PropTypes.func.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Button);

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1123);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Clearfix = function Clearfix(props) {
  return _react2.default.createElement('div', (0, _withStyles.css)(props.styles.clearfix));
};

Clearfix.propTypes = {
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Clearfix);

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(171);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savePG = exports.getReuploadDocumentsMock = exports.getThankYouPageMock = exports.getResumeByOtpMock = exports.LinkIdMap = exports.RefIdMap = exports.getAddressStateComponents = exports.COMPONENTS = exports.WIDGETS = exports.VALIDATION_ERRORS = exports.Titolare_Effectivo_EmptyJSONResponse = exports.MultiSelectComponents = exports.VALIDATION_METHODS = exports.VALIDATION_PATTERNS = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _componentsActions = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The input fields validation patterns
 * @private
 * @type {Object}
 */
/**
 * Extends the widgets data model with custom properties
 * @module stateExtension
 */
var VALIDATION_PATTERNS = exports.VALIDATION_PATTERNS = {
  mobilePrefix: /^[+-]?[0-9]+$/,
  mobileNumber: /^[0-9]{9,10}$/,
  number: /^[0-9]+$/,
  alphabetic: /^[a-zA-Z \']+$/,
  alphanumeric: /^[a-zA-Z0-9 \']+$/,
  address: /^([a-zA-Z0-9\',\.\/\\\-]+\s){2,}(\d+|snc)[a-zA-Z0-9\',\.\/\\\-\s]*$/,
  date: /^(3[01]|[12][0-9]|0[1-9])\/(1[0-2]|0[1-9])\/[0-9]{4}$/,
  cf: /^[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\w{3}[A-Za-z]$/,
  cap: /^[0-9]{5}$/,
  otp: /^[a-zA-Z0-9 \']{6}$/,
  otpEmail: /^[a-zA-Z0-9 \']{8}$/,
  city: /^[a-zA-Z\u0080-\u024F\s'\.\-]+$/,
  email: /^[-a-z0-9~!$%^&*_=}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9][-a-z0-9]*(\.[-a-z0-9]+)*\.(aero|arpa|biz|com|coop|edu|email|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
  bool: /^selected$/,
  filled: /^.+/,
  decimal: /^\d*\.?\d*$/
};
var VALIDATION_METHODS = exports.VALIDATION_METHODS = {
  mobilePrefix: function mobilePrefix(c) {
    return VALIDATION_PATTERNS.mobilePrefix.test(c.value);
  },
  mobileNumber: function mobileNumber(c) {
    return VALIDATION_PATTERNS.mobileNumber.test(c.value);
  },
  alphabetic: function alphabetic(c) {
    return VALIDATION_PATTERNS.alphabetic.test(c.value);
  },
  alphanumeric: function alphanumeric(c) {
    return VALIDATION_PATTERNS.alphanumeric.test(c.value);
  },
  address: function address(c) {
    return VALIDATION_PATTERNS.address.test(c.value) && c.value.length <= LENGTH_CONSTRAINTS.address;
  },
  date: function date(c) {
    return VALIDATION_PATTERNS.date.test(c.value);
  },
  cf: function cf(c) {
    return VALIDATION_PATTERNS.cf.test(c.value);
  },
  cfUnderage: function cfUnderage(c) {
    return c.errorMessage.indexOf("Questo prodotto puo' essere richiesto solo da maggiorenni o minorenni tra 12 e 18 anni") < 0;
  },
  cap: function cap(c) {
    return VALIDATION_PATTERNS.cap.test(c.value);
  },
  otp: function otp(c) {
    return VALIDATION_PATTERNS.otp.test(c.value);
  },
  otpEmail: function otpEmail(c) {
    return VALIDATION_PATTERNS.otpEmail.test(c.value);
  },
  city: function city(c) {
    return VALIDATION_PATTERNS.city.test(c.value);
  },
  email: function email(c) {
    return VALIDATION_PATTERNS.email.test(c.value);
  },
  bool: function bool(c) {
    return VALIDATION_PATTERNS.bool.test(c.value);
  },
  filled: function filled(c) {
    return VALIDATION_PATTERNS.filled.test(c.value);
  },
  number: function number(c) {
    return VALIDATION_PATTERNS.number.test(c.value);
  },
  decimal: function decimal(c) {
    return VALIDATION_PATTERNS.decimal.test(c.value);
  },
  underageContactConflict: function underageContactConflict(c) {
    return !(c.errorMessage.find(function (e) {
      return e === 'Campo non valido';
    }) && !!c.validations && !!c.validations.default && c.validations.default.reduce(function (res, rule) {
      return res && rule.validate(c);
    }, true));
  }
};

var TITOLARE_EFFETTIVO_WIDGETS = ['TITOLARE_ESERCITA', 'TITOLARE_ESERCITA-LABEL', 'TITOLARE_ESERCITA-ESERCITA_SI', 'TITOLARE_ESERCITA-ESERCITA_NO', 'RESIDENZA', 'RESIDENZA-FISCALE', 'RESIDENZA-NAZIONE', 'RESIDENZA-CAP', 'RESIDENZA-PROVINCIA', 'RESIDENZA-CITTA', 'RESIDENZA-INDIRIZZO', 'DOCUMENTO', 'DOCUMENTO-DATA_RILASCIO', 'DOCUMENTO-DATA_SCADENZA', 'DOCUMENTO-DOCF_UPLOAD', 'DOCUMENTO-DOCR_UPLOAD', 'DOCUMENTO-ENTE_RILASCIO', 'DOCUMENTO-LUOGO_RILASCIO', 'DOCUMENTO-NUMERO_DOCUMENTO', 'DOCUMENTO-TIPO_DOCUMENTO', 'NOME_COGNOME', 'NOME_COGNOME-COGNOME', 'NOME_COGNOME-NOME', 'CODICE_FISCALE', 'CODICE_FISCALE-CF', 'SZ0025'];
var TITOLARE_EFFETTIVO_QUESTIONS = ['SZ0025-SS0052_DM0097', 'SZ0025-SS0052_DM0097_RI0022', 'SZ0025-SS0052_DM0097_RI0023', 'SZ0025-SS0163_DM0503', 'SZ0025-SS0163_DM0503_RI0568', 'SZ0025-SS0163_DM0503_RI0569', 'TITOLARE_OWNER-LABEL', 'TITOLARE_OWNER-EFFETTIVO_NO', 'TITOLARE_OWNER-EFFETTIVO_SI'];
var MultiSelectComponents = exports.MultiSelectComponents = ['SZ0023-SS0027_DM1071_RI1062', 'SZ0023-SS0027_DM1072_RI1063', 'SZ0023-SS0027_DM1073_RI1064', 'SZ0023-SS0027_DM1074_RI1065', 'SZ0023-SS0027_DM1077_RI1057', 'SZ0016-SS0092_DM1076_RI0120', 'SZ0016-SS0092_DM0054_RI0120'];
var Titolare_Effectivo_EmptyJSONResponse = exports.Titolare_Effectivo_EmptyJSONResponse = [{
  "name": "TITOLARE_EFFETTIVO_DATA",
  "rawValue": {
    "titolare_effettivo": [{
      "id": 1,
      "datiContatto": {
        "nome": "",
        "cognome": "",
        "codiceFiscale": "",
        "luogoDiNascita": "",
        "sesso": "",
        "provinciaDiNascita": "",
        "dataDiNascita": ""
      },
      "residenza": {
        "cap": "",
        "provincia": "",
        "citta": "",
        "nazione": "ITALIA",
        "indirizzo": "",
        "residenzaFiscale": "ITALIA"
      },
      "documento": {
        "tipo_documento": "-",
        "ente_rilascio": "Comune",
        "luogo_rilascio": "",
        "numero_documento": "",
        "data_rilascio": "",
        "data_scadenza": ""
      },
      "domicilio": {},
      "directPepDetail": {},
      "indirectPepDetail": {}
    }]
  }
}];

var LENGTH_CONSTRAINTS = {
  address: 40
};

var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = {
  filled: function filled(c) {
    if (c.value.trim().length < 1 && c.validations && c.validations.isRequired) {
      return c.cleanName && c.cleanName + " \xE8 obbligatorio" || '';
    } else {
      return c.cleanName && c.cleanName + " non \xE8 valido" || '';
    }
  },
  address: function address(c) {
    var errorMessage = void 0;
    if (c.value.trim().length < 1 && c.validations && c.validations.isRequired) {
      errorMessage = c.cleanName + " sono obbligatori";
    } else if (c.value.trim().length > LENGTH_CONSTRAINTS.address) {
      errorMessage = c.cleanName + " superano i " + LENGTH_CONSTRAINTS.address + " caratteri consentiti";
    } else {
      // errorMessage = `${c.cleanName} non sono completi`
      errorMessage = 'Attenzione, indirizzo incompleto. Ricordati di indicare il qualificatore (Via, Piazza, C.so, etc.), il nome della via e il numero civico (se non è presente il civico, inserisci SNC)';
      if (/[^a-zA-Z0-9\',\.\/\\\-\s]+/.test(c.value.trim())) {
        errorMessage = c.cleanName + " non sono validi";
      }
    }
    return errorMessage;
  },
  underageContactConflict: function underageContactConflict(c) {
    var isEmail = c.name === 'EMAIL';
    return "Quest" + (isEmail ? 'a' : 'o') + " \xE8 " + (isEmail ? 'la' : 'il') + " tu" + (isEmail ? 'a' : 'o') + " " + c.cleanName + ", inserisci quell" + (isEmail ? 'a' : 'o') + " del genitore";
  },
  cfUnderage: function cfUnderage() {
    return (/*c*/'Puoi richiedere il prodotto solo se hai compiuto almeno 12 anni'
    );
  }

  /**
   * The input fields hints
   * @private
   * @type {Object}
   */
};var HINTS = {
  address: 'Inserisci anche il C/O (presso) se sulla cassetta delle lettere non è presente il tuo cognome'

  /**
   * Exports the extended widget model
   * @public
   * @see {@link https://github.com/hype-app/hype-onboarding-react/tree/master/app/state/stateExtension.js stateExtension.js}
   */
};var WIDGETS = exports.WIDGETS = {
  FLOW_BAR: {
    group: 'FLOW_BAR',
    groupTitle: 'Progresso'
  },
  ADESIONE_CONSULENZA: {
    group: 'ADESIONE_CONSULENZA',
    groupTitle: 'Adesione consulenza'
  },
  ANTIRICICLAGGIO: {
    group: 'ANTIRICICLAGGIO',
    groupTitle: ''
  },
  ATTIVA_REVOCA_FIRMA: {
    group: 'ATTIVA_REVOCA_FIRMA',
    groupTitle: 'Attiva o revoca la firma digitale',
    status: []
  },
  BONIFICO: {
    group: 'MOD_IDENTIFICAZIONE',
    groupTitle: 'Fatti riconoscere'
  },
  BUNDLE: {
    group: 'BUNDLE',
    groupTitle: 'Bundle prodotti'
  },
  CAT_IDENTIFICAZIONE: {
    group: 'CAT_IDENTIFICAZIONE',
    groupTitle: 'Categoria identificazione'
  },
  CELLULARE: {
    group: 'CONTATTI',
    groupTitle: 'Contatti'
  },
  CHI_CONSIGLIA: {
    group: 'CHI_CONSIGLIA',
    groupTitle: 'Consigliano Hype'
  },
  CITTADINANZA: {
    group: 'CITTADINANZA',
    groupTitle: 'Cittadinanza'
  },
  DENOMINAZIONE_AZIENDA: {
    group: 'DENOMINAZIONE_AZIENDA',
    groupTitle: 'Ragione Sociale'
  },
  AZIENDA_TYPE: {
    group: 'AZIENDA_TYPE',
    groupTitle: 'Forma Giuridica'
  },
  AZIENDA_SUBTYPE: {
    group: 'AZIENDA_TYPE',
    groupTitle: 'Forma Giuridica'
  },
  CODICE_FISCALE: {
    group: 'IDENTITA',
    groupTitle: 'Identità',
    quiet: true
  },
  CODICE_PROMOZIONALE: {
    group: 'CODICE_PROMOZIONALE',
    groupTitle: 'Hai un codice promo?'
  },
  CONTO_ADDEBITO: {
    group: 'INFO_CONTO',
    groupTitle: 'Informazioni conto'
  },
  CONTO_RIFERIMENTO: {
    group: 'INFO_CONTO',
    groupTitle: 'Informazioni conto'
  },
  CRONISTORIA: {
    group: 'CRONISTORIA',
    groupTitle: 'Cronistoria'
    //status: ['hidden']
  },
  DATI_SENSIBILI: {
    group: 'DATI_SENSIBILI',
    groupTitle: 'Privacy'
  },
  DOCUMENTAZIONE: {
    group: 'DOCUMENTAZIONE',
    groupTitle: 'Documentazione',
    status: ['hidden']
  },
  DOCUMENTO: {
    group: 'DOCUMENTO',
    groupTitle: 'Documento di identificazione del richiedente o del legale rappresentante'
    // quiet: true
  },
  DOCUMENTO_2: {
    group: 'DOCUMENTO_2',
    groupTitle: 'Documento intestato al richiedente o al legale rappresentante per verifica della residenza'
    // quiet: true
  },
  //Changes for loading new widget
  DOCUMENTO_GENERICO: {
    group: 'DOCUMENTO_GENERICO',
    groupTitle: 'CERTIFICATO DI ATTRIBUZIONE PARTITA IVA'
  },
  DOMICILIO: {
    group: 'DOMICILIO',
    groupTitle: 'Domicilio'
  },
  DIFARMA_0: {
    group: 'DIFARMA_0'
  },
  DIFARMA_1: {
    group: 'DIFARMA_1'
  },
  DIFARMA_2: {
    group: 'DIFARMA_2'
  },
  DIFARMA_3: {
    group: 'DIFARMA_3'
  },
  DIFARMA_4: {
    group: 'DIFARMA_4'
  },
  EMAIL: {
    group: 'CONTATTI',
    groupTitle: 'Contatti'
  },
  /* FIRMA: {
    group: 'FIRMA',
    groupTitle: 'Firma'
  }, */
  INTERESSI_CC: {
    group: 'CONTO',
    groupTitle: 'Conto'
  },
  INTESTATARI_FISSI: {},
  INVITO_INTESTATARI: {
    group: 'INVITO_INTESTATARI',
    groupTitle: 'Genitore o tutore',
    quiet: true
  },
  LABEL: {},
  MOD_IDENTIFICAZIONE: {
    group: 'MOD_IDENTIFICAZIONE',
    groupTitle: 'Fatti riconoscere',
    status: ['hidden']
  },
  NOME_COGNOME: {
    group: 'IDENTITA',
    groupTitle: 'Identità'
  },
  NUMERO_INTESTATARI: {
    group: 'NUMERO_INTESTATARI',
    groupTitle: 'Numero di intestatari'
  },
  PRIVACY: {
    group: 'PRIVACY',
    groupTitle: 'Privacy'
  },
  PROFESSIONE_ATTIVITA: {
    group: 'ATTIVITA',
    groupTitle: 'Attività'
  },
  PROFILAZIONE: {
    group: 'PROFILAZIONE',
    groupTitle: 'Profilazione'
    //status: ['hidden']
  },
  PROMOZIONE: {
    group: 'PROMOZIONE',
    groupTitle: 'Promozioni'
    //status: []
  },
  PROMOZIONE_TERZI: {
    group: 'PROMOZIONE_TERZI',
    groupTitle: 'Promozione Terzi'
    //status: ['hidden']
  },
  RESIDENZA: {
    group: 'RESIDENZA',
    groupTitle: 'Residenza'
  },
  RESIDENZA_FISCALE: {
    group: 'RESIDENZA_FISCALE',
    groupTitle: 'Residenza Fiscale'
  },
  RESUME_BY_CELL: {
    group: 'RESUME_BY_CELL',
    groupTitle: 'Riprendi usando il numero di cellulare'
  },
  RIF_POSTALE: {
    group: 'RIF_POSTALE',
    groupTitle: 'Riferimento postale'
  },
  RIF_SPEDIZIONE_CARTA: {
    group: 'RIF_SPEDIZIONE_CARTA',
    groupTitle: 'Dove vuoi ricevere la tua carta?'
  },
  SELFIE: {
    group: 'MOD_IDENTIFICAZIONE',
    groupTitle: 'Fatti riconoscere'
  },
  SUCCURSALE: {
    group: 'SUCCURSALE',
    groupTitle: 'Succursale'
  },
  SUCCURSALE_IDENTIFICAZIONE: {
    group: 'SUCCURSALE_IDENTIFICAZIONE',
    groupTitle: 'Identificazione succursale'
  },
  /*  TERMINA_PROCEDURA: {
     group: 'TERMINA_PROCEDURA',
     groupTitle: 'Concludi la registrazione'
   }, */
  TIPOLOGIA_CARTA: {
    group: 'TIPOLOGIA_CARTA',
    groupTitle: 'Scegli il tipo di carta'
  },
  VERIFICA_DATI_DA_CF: {
    group: 'VERIFICA_DATI_DA_CF',
    groupTitle: 'Verifica dati',
    quiet: true
  },
  WIDGET_HTML: {
    group: 'WIDGET_HTML',
    groupTitle: 'Widget HTML'
  },
  JOLLY: {
    group: 'JOLLY',
    groupTitle: 'Autorizzazione a procedere'
  },
  LOGIN_SE_CLIENTE: {
    group: 'LOGIN_SE_CLIENTE',
    groupTitle: ''
  },
  ATTESA: {},
  VISIONE_CONTRATTI: {},
  SIGNALER: {
    bundleCode: null,
    bundleLink: null,
    code: '999',
    components: [],
    errorMessage: [],
    group: 'SIGNALER',
    groupTitle: 'Hai un codice promo?',
    name: 'SIGNALER',
    position: 9,
    status: [],
    extra: true
  },
  WHAT_YOU_NEED: {
    bundleCode: null,
    bundleLink: null,
    code: '998',
    components: [],
    errorMessage: [],
    group: 'WHAT_YOU_NEED',
    groupTitle: 'Cosa ti serve sapere',
    name: 'WHAT_YOU_NEED',
    position: 0,
    status: [],
    extra: true
  },
  VERIFICA_EMAIL_EXTRA: {
    bundleCode: null,
    bundleLink: null,
    code: '998',
    components: [],
    errorMessage: [],
    group: 'VERIFICA_EMAIL_EXTRA',
    groupTitle: 'Verifica email',
    name: 'VERIFICA_EMAIL_EXTRA',
    position: 0,
    status: ['hidden'],
    extra: true
  },
  PARTITA_IVA: {
    group: 'RIFERIMENTI_FISCALI',
    groupTitle: 'Riferimenti Fiscali'
  },
  CF_AZIENDA: {
    group: 'RIFERIMENTI_FISCALI',
    groupTitle: 'Riferimenti Fiscali'
  },
  AZIENDA_ROLES: {
    group: 'AZIENDA_ROLES',
    groupTitle: 'Indica la carica o il ruolo che rivesti in azienda'
  },
  CLASSIFICAZIONE_AZIENDA: {
    group: 'CLASSIFICAZIONE_AZIENDA',
    groupTitle: 'INFORMAZIONI PER LA CLASSIFICAZIONE DELLA AZIENDA'
  },
  PEC: {
    group: 'INFO_AZIENDA',
    groupTitle: 'INFO AZIENDA'
  },
  TELEFONO_FISSO: {
    group: 'INFO_AZIENDA',
    groupTitle: 'INFO AZIENDA'
  },
  SEDE_LEGALE: {
    group: 'SEDE_LEGALE',
    groupTitle: 'SEDE LEGALE'
  },
  SEDE_AMMINISTRATIVA: {
    group: 'SEDE_AMMINISTRATIVA',
    groupTitle: 'SEDE AMMINISTRATIVA'
  },
  //step 4:
  SETTORE_ATTIVITA_AZIENDA: {
    group: 'SETTORE_ATTIVITA_AZIENDA',
    groupTitle: 'SETTORE E ATTIVITÀ ECONOMICA'
  },
  AZIENDA_ANTIRICICLAGGIO: {
    group: 'AZIENDA_ANTIRICICLAGGIO',
    groupTitle: ''
  },
  //step 5:
  TITOLARE_DATA: {
    group: 'TITOLARE_DATA',
    groupTitle: 'TITOLARE EFFETTIVO'
  },
  TITOLARE_OWNER: {
    group: 'TITOLARE_OWNER',
    groupTitle: ''
  },
  TITOLARE_ESERCITA: {
    group: 'TITOLARE_ESERCITA',
    groupTitle: ''
  },
  //step 6:
  PRODUCT_PLUGIN: {
    group: 'PRODUCT_PLUGIN',
    groupTitle: 'PUNTO VENDITA',
    status: ['hidden']
  },

  TITOLARE_EFFETTIVO: {
    group: 'TITOLARE EFFETTIVO',
    groupTitle: 'TITOLARE EFFETTIVO',
    status: ['hidden']
  },

  FORMA_GIURIDIA: {
    code: '27232',
    name: 'FORMA_GIURIDIA',
    bundleCode: null,
    bundleLink: null,
    errorMessage: [],
    group: 'AZIENDA_TYPE',
    status: [],
    extra: true

  },

  SETTORE_ATTIVITA_AZIENDA_COMP: {
    code: '27232',
    name: 'SETTORE_ATTIVITA_AZIENDA_COMP',
    bundleCode: null,
    bundleLink: null,
    components: [{
      name: 'SETTORE_ATTIVITA_AZIENDA_COMP_DESC',
      value: "per <b>attivit\xE0 finanziarie</b> si intendono attivit\xE0 di assicurazione, concessione di finanziamenti, crediti e microcrediti, crediti a consumo ed ipotecari, l\u2019emissione o gestione di carte di credito, di debito o di altri mezzi di pagamento, etc",
      rawValue: null,
      status: [],
      position: 1,
      errorMessage: [],
      validations: [],
      values: [],
      type: 'label',
      isSmall: true,
      active: true
    }],
    errorMessage: [],
    status: [],
    extra: true
  }

  /**
   * Exports the extended components model
   * @public
   * @see {@link https://github.com/hype-app/hype-onboarding-react/tree/master/app/state/stateExtension.js stateExtension.js}
   */
};var COMPONENTS = exports.COMPONENTS = {
  'FLOW_BAR-STEP_1': {
    name: 'STEP_1',
    type: null,
    cleanName: 'Inizio'
    /*,
          value: 'La carta che gestisci e controlli con l\'app!'*/
  },
  'FLOW_BAR-STEP_2': {
    name: 'STEP_2',
    type: null,
    cleanName: 'Secondo step'
  },
  'FLOW_BAR-STEP_3': {
    name: 'STEP_3',
    type: null,
    cleanName: 'Terzo step'
  },
  'FLOW_BAR-STEP_4': {
    name: 'STEP_4',
    type: null,
    cleanName: 'Quarto step'
  },
  'FLOW_BAR-STEP_5': {
    name: 'STEP_5',
    type: null,
    cleanName: 'Quinto step'
  },
  'ADESIONE_CONSULENZA-ADESIONE_SI': {
    name: 'ADESIONE_SI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Adesione SÌ'
  },
  'ADESIONE_CONSULENZA-ADESIONE_NO': {
    name: 'ADESIONE_SI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Adesione NO'
  },
  'ANTIRICICLAGGIO-QUESTIONARIO': {
    name: 'QUESTIONARIO',
    cleanName: 'Questionario'
  },
  'ATTIVA_REVOCA_FIRMA-LINK_ISTRUZIONI': {
    id: 'ATTIVA_REVOCA_FIRMA-LINK_ISTRUZIONI',
    name: 'LINK_ISTRUZIONI',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: 'Istruzioni operative',
      url: 'http://www.trusttechnologies.it/document_loader.aspx?idDocument=150',
      target: '_blank'
    },
    value: 'e delle §link§',
    extra: true,
    position: 3,
    element: 'span'
  },
  'ATTIVA_REVOCA_FIRMA-LINK_ADDENDUM': {
    id: 'ATTIVA_REVOCA_FIRMA-LINK_ADDENDUM',
    name: 'LINK_ADDENDUM',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: "dell'Addendum al manuale operativo",
      url: 'http://www.trusttechnologies.it/document_loader.aspx?idDocument=58',
      target: '_blank'
    },
    value: '§link§',
    extra: true,
    position: 2,
    element: 'span'
  },
  'ATTIVA_REVOCA_FIRMA-LINK_MANUALE': {
    id: 'ATTIVA_REVOCA_FIRMA-LINK_MANUALE',
    name: 'LINK_MANUALE',
    type: 'labelWithLink',
    status: [],
    link: {
      placeholder: '§link§',
      text: "Manuale operativo.",
      url: 'https://www.sella.it/SSRDocumentDisplayer?dtdPG=IS_OP_SELLADIGIT_PIN_SMS&dtdPE=1',
      target: '_blank'
    },
    value: "La firma digitale \xE8 un servizio gratuito che ti consente di firmare i documenti comodamente online, senza stampare.Per Proseguire nell' attivazione prendi visione del \xA7link\xA7",
    extra: true,
    position: 1,
    element: 'span'
  },
  'ATTIVA_REVOCA_FIRMA-FIRMA': {
    name: 'FIRMA',
    cleanName: 'ATTIVA',
    type: 'sella',
    pullTo: 'right',
    position: 4,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/sign/active',
          body: {},
          mappingEvent: 'IframeSrcSetter'
        }
      },
      updateComponentId: 'ATTIVA_REVOCA_FIRMA-IFRAME',
      toggleVisibility: {
        show: {
          fields: ['ATTIVA_REVOCA_FIRMA-IFRAME']
        }
      }
    }
  },
  'ATTIVA_REVOCA_FIRMA-IFRAME': {
    name: 'IFRAME',
    cleanName: 'iFrame',
    value: '',
    otpMessage: true
  },
  'ATTIVA_REVOCA_FIRMA-MODAL': {
    name: 'Modal',
    value: '',
    title: 'Messaggio'
  },
  'ATTIVA_REVOCA_FIRMA-VISIONE': {
    name: 'VISIONE',
    cleanName: 'Presa visione',
    active: true,
    value: '',
    status: [],
    type: 'checkbox',
    position: 4,
    pullTo: 'left',
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/sign/active',
          body: {},
          mappingEvent: 'IframeSrcSetter'
        }
      },
      updateComponentId: 'ATTIVA_REVOCA_FIRMA-IFRAME',
      toggleVisibility: {
        show: {
          fields: ['ATTIVA_REVOCA_FIRMA-IFRAME']
        }
      }
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    description: 'Ho Preso visione',
    toggleVisibility: {
      // show: {
      //   fields: ['ATTIVA_REVOCA_FIRMA-FIRMA']//,'ATTIVA_REVOCA_FIRMA-LABEL']
      // },
      hide: {
        fields: ['ATTIVA_REVOCA_FIRMA-IFRAME']
      }
    }
  },

  'ATTIVA_REVOCA_FIRMA-LABEL': {
    name: 'LABEL',
    cleanName: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
    active: false,
    value: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
    status: ['hidden'],
    type: 'label',
    position: 5,
    validations: {
      isRequired: false,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    description: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare'
  },

  'DIFARMA_0-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_0-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  'DIFARMA_0-FIRMA': {
    name: 'Firma',
    cleanName: 'Firma',
    pullTo: 'right',
    position: 3,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_0-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_1-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_1-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  'DIFARMA_1-FIRMA': {
    name: 'Firma',
    cleanName: 'Firma',
    pullTo: 'right',
    position: 3,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          // mappingEvent: 'IframeSrcSetter'
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_1-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_2-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_2-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },

  'DIFARMA_2-FIRMA': {
    name: 'Firma',
    cleanName: 'Firma',
    pullTo: 'right',
    position: 3,
    status: [],
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          // mappingEvent: 'IframeSrcSetter'
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_2-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_3-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_3-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  'DIFARMA_3-FIRMA': {
    name: 'Firma',
    cleanName: 'Firma',
    pullTo: 'right',
    status: [],
    position: 3,
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          // mappingEvent: 'IframeSrcSetter'
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },

  'DIFARMA_3-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  'DIFARMA_4-LABEL': {
    name: 'LABEL',
    cleanName: 'LABEL'
  },
  'DIFARMA_4-SUB_LABEL': {
    name: 'SUB_LABEL',
    cleanName: 'SUB_LABEL'
  },
  'DIFARMA_4-FIRMA': {
    name: 'ATTIVA',
    cleanName: 'ATTIVA',
    pullTo: 'right',
    status: [],
    position: 3,
    action: {
      value: 'Attivata',
      type: 'inverse',
      disabled: true,
      fetch: {
        attivata: {
          url: 'wgt/utils/presavisione',
          // mappingEvent: 'IframeSrcSetter'
          mappingEvent: 'DigiSignature'
        }
      }
    }
  },
  'DIFARMA_4-IFRAME': {
    name: 'IFRAME',
    cleanName: 'IFRAME'
  },
  /* 'ATTIVA_REVOCA_FIRMA-CONTENT1': {
    name: 'CONTENT1'
    // cleanName: 'iFrame',
  },
  'ATTIVA_REVOCA_FIRMA-CONTENT2': {
    name: 'CONTENT2'
    // cleanName: 'iFrame',
  },
  'ATTIVA_REVOCA_FIRMA-ATTIVATA': {
    name: 'ATTIVATA'
    // cleanName: 'iFrame',
    // type: 'button'
  }, */
  'BONIFICO-SPACER': {
    id: 'BONIFICO-SPACER',
    name: 'SELFIE_UPLOAD_SPACER',
    type: 'spacer',
    position: 1,
    value: '',
    status: [],
    extra: true
  },
  'BONIFICO-LABEL': {
    id: 'BONIFICO-LABEL',
    name: 'LABEL',
    type: 'label',
    position: 2,
    isPadded: true,
    isCentered: true,
    cleanName: 'Fatti riconoscere con un bonifico',
    value: "Invia un <b>bonifico</b> da un <b>tuo conto</b> al nostro <b>IBAN di verifica</b> inserendo <b>la causale indicata</b>. Dopo l'attivazione l'importo verrà trasferito sul tuo nuovo IBAN.",
    validations: {},
    status: [],
    extra: true
  },
  'BONIFICO-IBAN': {
    name: 'IBAN',
    type: 'text',
    position: 3,
    isDisabled: true,
    cleanName: 'IBAN temporaneo di verifica',
    validations: {}
  },
  'BONIFICO-CAUSALE': {
    name: 'CAUSALE',
    type: 'text',
    position: 4,
    isDisabled: true,
    cleanName: 'Causale',
    validations: {}
  },
  /*  'BUNDLE-VISIONE': {
     name: 'VISIONE',
     type: 'checkbox',
     validations: {
       isRequired: true,
       default: [
         {
           validate: VALIDATION_METHODS.bool,
           getErrorMessage: VALIDATION_ERRORS.filled
         }
       ]
     },
     cleanName: 'Presa visione',
     description:
       'Dichiaro di aver letto la documentazione informativa, di averne compreso e salvato il contenuto.'
   }, */
  'BUNDLE-NOME_PRODOTTO': {
    name: 'NOME_PRODOTTO',
    cleanName: 'Nome prodotto'
  },
  'BUNDLE-DESCRIZIONE': {
    name: 'DESCRIZIONE',
    cleanName: 'Descrizione prodotto'
  },
  'BUNDLE-IMMAGINE_PRODOTTO': {
    name: 'IMMAGINE_PRODOTTO',
    cleanName: 'Immagine prodotto'
  },
  'CAT_IDENTIFICAZIONE-IDENT_BONIFICO': {
    name: 'IDENT_BONIFICO',
    cleanName: 'Identificati tramite bonifico'
  },
  'CAT_IDENTIFICAZIONE-IDENT_WEBCAM': {
    name: 'IDENT_WEBCAM',
    cleanName: 'Identificati tramite webcam'
  },
  'CAT_IDENTIFICAZIONE-IDENT_PERSONA': {
    name: 'IDENT_PERSONA',
    cleanName: 'Identificati di persona'
  },
  'CELLULARE-CODICE_CELLULARE': {
    name: 'CODICE_CELLULARE',
    type: 'text',
    cleanName: 'Codice OTP ricevuto via SMS', //Codice cellulare',
    isDisabled: true,
    fullWidth: true,
    //validMessage:'Ti abbiamo inviato un sms con il codice di accesso',
    validations: {
      isRequired: true,
      skipLazy: true,
      default: [{
        validate: VALIDATION_METHODS.otp,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/confermacellulare',
      fields: {
        'CELLULARE-PREF_CELLULARE': {
          fieldName: 'prefisso'
        },
        'CELLULARE-NUM_CELLULARE': {
          fieldName: 'numero'
        },
        'CELLULARE-CODICE_CELLULARE': {
          fieldName: 'codice'
        }
      }
    }
  },
  'CELLULARE-CONFERMA_NUM_CELLULARE': {
    name: 'CONFERMA_NUM_CELLULARE',
    type: 'text',
    position: 4,
    cleanName: 'Conferma numero cellulare',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobileNumber,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'CELLULARE-CONFERMA_PREF_CELLULARE': {
    name: 'CONFERMA_PREF_CELLULARE',
    type: 'hidden',
    value: '+39',
    cleanName: 'Conferma prefisso cellulare',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobilePrefix,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'CELLULARE-NUM_CELLULARE': {
    name: 'NUM_CELLULARE',
    type: 'text',
    otpbtnDisabled: true,
    position: 2,
    cleanName: 'Numero cellulare',
    validations: {
      isRequired: true,
      skipLazy: true,
      default: [{
        validate: VALIDATION_METHODS.mobileNumber,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
      // url: 'wgt/validate/cellulare',
      // fields: {
      //   'CELLULARE-PREF_CELLULARE': {
      //     fieldName: 'prefisso'
      //   },
      //   'CELLULARE-NUM_CELLULARE': {
      //     fieldName: 'numero'
      //   }
      // },
      // params: [
      //   {
      //     type: 'WIDGET',
      //     entityName: 'CELLULARE',
      //     propName: 'code',
      //     name: 'widgetId'
      //   }
      // ]
    },
    fetch: {
      url: 'wgt/validate/cellulare',
      fields: [{
        'CELLULARE-PREF_CELLULARE': {
          fieldName: 'prefisso'
        },
        'CELLULARE-NUM_CELLULARE': {
          fieldName: 'numero'
        }
      }]
      //mappingEvent:'sendOTP'
    }
  },
  'CELLULARE-PREF_CELLULARE': {
    name: 'PREF_CELLULARE',
    position: 1,
    // type: 'hidden',
    // value: '+39',
    // cleanName: 'Prefisso cellulare',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.mobilePrefix,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
    type: 'selectbox',
    isDisabled: false,
    options: {
      url: 'wgt/utils/prefissi',
      mapping: { label: 'description', value: 'value' }
    },
    value: '+39',
    label: 'Italia (+39)',
    cleanName: 'Prefisso cellulare',
    validations: {
      isRequired: true
    },
    flag: 'static_1'
  },
  'CHI_CONSIGLIA-CHI_CONSIGLIA': {
    name: 'CHI_CONSIGLIA',
    cleanName: 'Chi consiglia'
  },
  'CITTADINANZA-CITTADINANZA': {
    name: 'CITTADINANZA',
    type: 'selectbox',
    initialValue: 'ITALIA',
    options: {
      url: 'wgt/utils/cittadinanze/VALID',
      mapping: { label: 'nazionalita', value: 'key' }
    },
    cleanName: 'Cittadinanza',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    flag: 'static_1'
  },
  'DENOMINAZIONE_AZIENDA-DENOMINAZIONE': {
    name: 'DENOMINAZIONE',
    type: 'text',
    cleanName: 'Ragione Sociale',
    /*options: {
      url: 'wgt/utils/cittadinanze/VALID',
      mapping: { label: 'nazionalita', value: 'key' }
    },*/
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    description: 'Come Da Iscrizione Alla Camera Di Commercio O Agli Albi Professionali'
  },
  'AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA': {
    name: 'TIPO_SOGGETTO_AZIENDA',
    type: 'selectbox',
    /*initialValue: 'Seleziona un  Tipo Soggetto',*/
    // values: [
    //   // {
    //   //   value: '-1',
    //   //   label: 'Seleziona un  Tipo Soggetto',
    //   //   description: 'Seleziona un  Tipo Soggetto'
    //   // },
    //   // {
    //   //   value: '1052',
    //   //   label: 'Ente privato',
    //   //   description: 'Ente privato'
    //   // },
    //   {
    //     value: '1051',
    //     label: 'Società cooperativa',
    //     description: 'Società Cooperative'
    //   },
    //   {
    //     value: '1050',
    //     label: 'Società di capitali',
    //     description: 'Società di Capitali'
    //   },
    //   {
    //     value: '1049',
    //     label: 'Società di persone',
    //     description: 'Società di Persone, studi associati'
    //   }
    // ],

    options: {
      mapping: { label: 'tipoSoggettoDesc', value: 'tipoSoggettoId' }
    },
    trigger: [{
      componentId: 'AZIENDA_SUBTYPE-AZIENDA_TIPO_SOCIETA',
      type: 'fetchOption'
    }],
    cleanName: 'Categoria società', //'Seleziona la categoria',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
      /*,
      notifyComponents: {
        validate: ['AZIENDA_SUBTYPE-AZIENDA_TIPO_SOCIETA']
      }*/
    } },
  'AZIENDA_SUBTYPE-AZIENDA_TIPO_SOCIETA': {
    name: 'AZIENDA_TIPO_SOCIETA',
    type: 'selectbox',
    /*initialValue: 'Seleziona un Tipo Societa',*/
    options: {
      url: 'wgt/utils/aziendaTipoSocieta',
      mapping: { label: 'description', value: 'value' },
      fields: [{
        'AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA': {
          fieldName: 'value'
        }
      }]
    },
    cleanName: 'Tipo società', //'Seleziona il tipo',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'CODICE_FISCALE-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    position: 1,
    validations: {
      skipLazy: true,
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cf,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      overrides: [{
        validate: VALIDATION_METHODS.cfUnderage,
        getErrorMessage: VALIDATION_ERRORS.cfUnderage
      }],
      url: 'wgt/validate/codicefiscale',
      fields: ['CODICE_FISCALE-CF', 'NOME_COGNOME-NOME', 'NOME_COGNOME-COGNOME']
    },
    fetch: {
      questionario: {
        url: 'wgt/utils/splitcf',
        fields: [{
          'CODICE_FISCALE-CF': {
            fieldName: 'cf'
          }
        }],
        mappingEvent: 'titolareEffettivo'
      }
    }
  },
  'CODICE_FISCALE-DATADINASCITA': {
    name: 'dataDiNascita',
    type: 'text',
    cleanName: 'Data di nascita*',
    value: '',
    active: false,
    status: ['hidden'],
    extra: true,
    position: 2
  },
  'CODICE_FISCALE-SESSO': {
    name: 'SESSO',
    type: 'label',
    active: false,
    cleanName: 'Sesso*',
    value: '',
    status: ['hidden'],
    extra: true
  },
  'CODICE_FISCALE-PROVINCIADINASCITA': {
    name: 'provinciaDiNascita',
    type: 'label',
    active: false,
    cleanName: 'Provincia',
    value: '',
    status: ['hidden'],
    extra: true
  },
  'CODICE_FISCALE-LUOGODINASCITA': {
    name: 'luogoDiNascita',
    type: 'text',
    active: false,
    cleanName: 'Luogo di nascita*',
    value: '',
    status: ['hidden'],
    extra: true,
    position: 3
  },
  'CODICE_PROMOZIONALE-CODICE_PROMOZIONALE': {
    name: 'CODICE_PROMOZIONALE',
    cleanName: 'Codice promo'
  },
  'CONTO_ADDEBITO-CONTO_ADDEBITO': {
    name: 'CONTO_ADDEBITO',
    cleanName: 'Conto di addebito'
  },
  'CONTO_RIFERIMENTO-CONTO_RIFERIMENTO': {
    name: 'CONTO_RIFERIMENTO',
    cleanName: 'Conto di riferimento'
  },
  'CRONISTORIA-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Presa visione',
    validations: {
      //isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    description:
    //'Per dar seguito alla richiesta è necessario il tuo consenso alla conservazione della cronistoria delle attività precontrattuali.'
    'Consensi facoltativi al trattamento dei dati personali.\nCon riferimento al Paragrafo 3 dell’informativa, mi esprimo in merito al trattamento dei miei dati da parte di Fabrick ai fini di seguito indicati, consapevole che tale azione è facoltativa e non vincolante alla stipula del contratto:conservazione della documentazione delle attività precontrattuali (es. preventivi, richiesta di prodotti poi non sottoscritti).'
  },
  'DATI_SENSIBILI-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Il consenso', //'Presa visione',
    description:
    //'Per dar seguito alla richiesta è necessario il tuo consenso al trattamento dei dati sensibili.\nIMPORTANTE: Non richiediamo e non trattiamo di nostra iniziativa i tuoi "dati sensibili" se non per dare esecuzione alla disposizione delle tue operazioni.\nCi teniamo a precisarti che NON UTILIZZEREMO QUESTI DATI IN ALTRO MODO.'
    'Consenso al trattamento dei dati particolari ai sensi dell’articolo 9 del Regolamento.\nFabrick non richiede e non tratta di propria iniziativa "dati particolari", se non per eseguire le operazioni richieste dal Cliente. Per questo motivo, come riportato nell’informativa che mi è stata consegnata e di cui ho preso visione in riferimento al Paragrafo 8:    mi esprimo in merito al trattamento dei dati particolari, consapevole che tale consenso è vincolante per dare seguito alle operazioni da me richieste.'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO': {
    name: 'DESCR_PRODOTTO',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO_2': {
    name: 'DESCR_PRODOTTO_2',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO_3': {
    name: 'DESCR_PRODOTTO_3',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-DESCR_PRODOTTO_4': {
    name: 'DESCR_PRODOTTO_4',
    type: 'label',
    cleanName: 'Descrizione prodotto'
  },
  'DOCUMENTAZIONE-LINK': {
    name: 'LINK',
    type: 'link',
    cleanName: 'Scarica'
  },
  'DOCUMENTAZIONE-LINK_2': {
    name: 'LINK_2',
    type: 'link',
    cleanName: 'Link'
  },
  'DOCUMENTAZIONE-LINK_3': {
    name: 'LINK_3',
    type: 'link',
    cleanName: 'Link'
  },
  'DOCUMENTAZIONE-LINK_4': {
    name: 'LINK_4',
    type: 'link',
    cleanName: 'Link'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO': {
    name: 'NOME_PRODOTTO',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO_2': {
    name: 'NOME_PRODOTTO_2',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO_3': {
    name: 'NOME_PRODOTTO_3',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-NOME_PRODOTTO_4': {
    name: 'NOME_PRODOTTO_4',
    type: 'label',
    cleanName: 'Nome prodotto'
  },
  'DOCUMENTAZIONE-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Presa visione',
    description: 'Dichiaro di aver letto la documentazione informativa, di averne compreso e salvato il contenuto.'
  },
  'DOCUMENTO-DATA_RILASCIO': {
    name: 'DATA_RILASCIO',
    type: 'date',
    cleanName: 'Data rilascio',
    position: 5,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.date,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO-DATA_SCADENZA': {
    name: 'DATA_SCADENZA',
    type: 'date',
    cleanName: 'Data scadenza',
    position: 6,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.date,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO-DOCF_UPLOAD': {
    name: 'DOCF_UPLOAD',
    type: 'file',
    uploadType: 'FRONT_DOC_1',
    position: 7,
    cleanName: 'Carica il fronte del documento',
    modalTitle: 'Carica o scatta il fronte del documento',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO-DOCR_UPLOAD': {
    name: 'DOCR_UPLOAD',
    uploadType: 'BACK_DOC_1',
    type: 'file',
    position: 8,
    cleanName: 'Carica il retro del documento',
    modalTitle: 'Carica o scatta il retro del documento',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO-ENTE_RILASCIO': {
    name: 'ENTE_RILASCIO',
    type: 'text',
    // type: 'selectbox',
    // options: {
    //   url: 'wgt/utils/documenti',
    //   mapping: { label: 'enteEmissione', value: 'enteEmissione' }
    // },
    isDisabled: true,
    position: 3,
    cleanName: 'Ente di rilascio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO-LUOGO_RILASCIO': {
    name: 'LUOGO_RILASCIO',
    type: 'text',
    position: 4,
    cleanName: 'Luogo di rilascio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  // 'DOCUMENTO-PROVINCIA_RILASCIO': {
  //   name: 'PROVINCIA_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Provincia di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },
  // 'DOCUMENTO-NAZIONE_RILASCIO': {
  //   name: 'NAZIONE_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Nazione di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },
  'DOCUMENTO-NUMERO_DOCUMENTO': {
    name: 'NUMERO_DOCUMENTO',
    type: 'text',
    position: 2,
    cleanName: 'Numero documento',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphanumeric,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO-TIPO_DOCUMENTO': {
    name: 'TIPO_DOCUMENTO',
    type: 'selectbox',
    position: 1,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO-DOCUMENTRULES2']
      },
      hide: {
        fields: ['DOCUMENTO-DOCUMENTRULES']
      }
    },
    options: {
      url: 'wgt/utils/documenti',
      mapping: { label: 'nome', value: 'nome', enteEmissione: 'enteEmissione' }
    },
    autofill: {
      mapping: [{
        key: 'value',
        resKey: 'enteEmissione',
        componentId: 'DOCUMENTO-ENTE_RILASCIO'
      }]
    },
    cleanName: 'Tipo di documento'
  },
  // 'DOCUMENTO_2-BOLLETTA': {
  //   name: 'BOLLETTA',
  //   cleanName: 'Bolletta',
  //   type: 'radio',
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   },
  //   position: 1,
  //   trigger: [
  //     {
  //       componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
  //       /*componentIds: [
  //         'DOCUMENTO_2-ENTE_RILASCIO',
  //         'DOCUMENTO_2-LUOGO_RILASCIO',
  //         'DOCUMENTO_2-NUMERO_DOCUMENTO',
  //         'DOCUMENTO_2-DATA_RILASCIO',
  //         'DOCUMENTO_2-DATA_SCADENZA',
  //         'DOCUMENTO_2-DOCR_UPLOAD'
  //       ],*/
  //       type: 'copy',
  //       value: ''
  //     }
  //   ],
  //   toggleVisibility: {
  //     show: {
  //       fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
  //     },
  //     hide: {
  //       fields: [
  //         'DOCUMENTO_2-ENTE_RILASCIO',
  //         'DOCUMENTO_2-LUOGO_RILASCIO',
  //         'DOCUMENTO_2-NUMERO_DOCUMENTO',
  //         'DOCUMENTO_2-DATA_RILASCIO',
  //         'DOCUMENTO_2-DATA_SCADENZA',
  //         'DOCUMENTO_2-DOCR_UPLOAD',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE2',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE3'
  //       ]
  //     }
  //   }
  // },
  'DOCUMENTO_2-BUSTA_PAGA': {
    name: 'BUSTA_PAGA',
    cleanName: 'Busta paga',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    position: 1,
    trigger: [{
      componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
      type: 'copy',
      value: ''
    }],
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      },
      hide: {
        fields: ['DOCUMENTO_2-ENTE_RILASCIO', 'DOCUMENTO_2-LUOGO_RILASCIO', 'DOCUMENTO_2-NUMERO_DOCUMENTO', 'DOCUMENTO_2-DATA_RILASCIO', 'DOCUMENTO_2-DATA_SCADENZA', 'DOCUMENTO_2-DOCR_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE2', 'DOCUMENTO_2-SECONDDOCUMENTRULE3']
      }
    }
  },
  // 'DOCUMENTO_2-ESTRATTO_CONTO': {
  //   name: 'ESTRATTO_CONTO',
  //   cleanName: 'Estratto conto',
  //   type: 'radio',
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   },
  //   position: 3,
  //   trigger: [
  //     {
  //       componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
  //       type: 'copy',
  //       value: ''
  //     }
  //   ],
  //   toggleVisibility: {
  //     show: {
  //       fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
  //     },
  //     hide: {
  //       fields: [
  //         'DOCUMENTO_2-ENTE_RILASCIO',
  //         'DOCUMENTO_2-LUOGO_RILASCIO',
  //         'DOCUMENTO_2-NUMERO_DOCUMENTO',
  //         'DOCUMENTO_2-DATA_RILASCIO',
  //         'DOCUMENTO_2-DATA_SCADENZA',
  //         'DOCUMENTO_2-DOCR_UPLOAD',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE2',
  //         'DOCUMENTO_2-SECONDDOCUMENTRULE3'
  //       ]
  //     }
  //   }
  // },
  'DOCUMENTO_2-CARTA_IDENTITA': {
    name: 'CARTA_IDENTITA',
    cleanName: 'Carta di Identità',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    trigger: [{
      componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
      type: 'copy',
      value: 'COMUNE'
    }],
    position: 2,
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO_2-ENTE_RILASCIO', 'DOCUMENTO_2-LUOGO_RILASCIO', 'DOCUMENTO_2-NUMERO_DOCUMENTO', 'DOCUMENTO_2-DATA_RILASCIO', 'DOCUMENTO_2-DATA_SCADENZA', 'DOCUMENTO_2-DOCR_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE3']
      },
      hide: {
        fields: ['DOCUMENTO_2-SECONDDOCUMENTRULE2', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      }
    }
  },
  'DOCUMENTO_2-PERMESSO_SOGGIORNO': {
    name: 'PERMESSO_SOGGIORNO',
    cleanName: 'Permesso di soggiorno'
  },
  'DOCUMENTO_2-PASSAPORTO': {
    name: 'PASSAPORTO',
    cleanName: 'Passaporto',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    trigger: [{
      componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
      type: 'copy',
      value: 'QUESTURA'
    }],
    position: 3,
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO_2-ENTE_RILASCIO', 'DOCUMENTO_2-LUOGO_RILASCIO', 'DOCUMENTO_2-NUMERO_DOCUMENTO', 'DOCUMENTO_2-DATA_RILASCIO', 'DOCUMENTO_2-DATA_SCADENZA', 'DOCUMENTO_2-DOCR_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE3']
      },
      hide: {
        fields: ['DOCUMENTO_2-SECONDDOCUMENTRULE2', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      }
    }
  },
  'DOCUMENTO_2-PATENTE': {
    name: 'PATENTE',
    cleanName: 'Patente',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    trigger: [{
      componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
      type: 'copy',
      value: 'UFFICIO PROVINCIALE MCTC'
    }],
    position: 4,
    toggleVisibility: {
      show: {
        fields: ['DOCUMENTO_2-ENTE_RILASCIO', 'DOCUMENTO_2-LUOGO_RILASCIO', 'DOCUMENTO_2-NUMERO_DOCUMENTO', 'DOCUMENTO_2-DATA_RILASCIO', 'DOCUMENTO_2-DATA_SCADENZA', 'DOCUMENTO_2-DOCR_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE3']
      },
      hide: {
        fields: ['DOCUMENTO_2-SECONDDOCUMENTRULE2', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      }
    }
  },
  'DOCUMENTO_2-TESSERA_SANITARIA': {
    name: 'TESSERA_SANITARIA',
    cleanName: 'Tessera sanitaria',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    trigger: [{
      componentId: 'DOCUMENTO_2-ENTE_RILASCIO',
      type: 'copy',
      value: 'MEF'
    }],
    position: 5,
    toggleVisibility: {
      // show: {
      //   fields: ['DOCUMENTO_2-DOCF_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE1']
      // },
      // hide: {
      //   fields: [
      //     'DOCUMENTO_2-ENTE_RILASCIO',
      //     'DOCUMENTO_2-LUOGO_RILASCIO',
      //     'DOCUMENTO_2-NUMERO_DOCUMENTO',
      //     'DOCUMENTO_2-DATA_RILASCIO',
      //     'DOCUMENTO_2-DATA_SCADENZA',
      //     'DOCUMENTO_2-DOCR_UPLOAD',
      //     'DOCUMENTO_2-SECONDDOCUMENTRULE2',
      //     'DOCUMENTO_2-SECONDDOCUMENTRULE3'
      //   ]
      // }
      show: {
        fields: ['DOCUMENTO_2-DOCR_UPLOAD', 'DOCUMENTO_2-SECONDDOCUMENTRULE3']
      },
      hide: {
        fields: ['DOCUMENTO_2-SECONDDOCUMENTRULE2', 'DOCUMENTO_2-SECONDDOCUMENTRULE1', 'DOCUMENTO_2-NUMERO_DOCUMENTO', 'DOCUMENTO_2-LUOGO_RILASCIO', 'DOCUMENTO_2-DATA_RILASCIO', 'DOCUMENTO_2-DATA_SCADENZA', 'DOCUMENTO_2-ENTE_RILASCIO']
      }
    }
  },
  'DOCUMENTO_2-NUMERO_DOCUMENTO': {
    name: 'NUMERO_DOCUMENTO',
    type: 'text',
    position: 6,
    cleanName: 'Numero documento',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphanumeric,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_2-LUOGO_RILASCIO': {
    name: 'LUOGO_RILASCIO',
    type: 'text',
    position: 7,
    cleanName: 'Luogo di rilascio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_2-DATA_RILASCIO': {
    name: 'DATA_RILASCIO',
    type: 'date',
    cleanName: 'Data rilascio',
    position: 8,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.date,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_2-DATA_SCADENZA': {
    name: 'DATA_SCADENZA',
    type: 'date',
    cleanName: 'Data scadenza',
    position: 9,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.date,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_2-DOCF_UPLOAD': {
    name: 'DOCF_UPLOAD',
    type: 'file',
    uploadType: 'FRONT_DOC_2',
    position: 10,
    cleanName: 'Carica il fronte del documento',
    modalTitle: 'Carica o scatta il fronte del documento',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_2-DOCR_UPLOAD': {
    name: 'DOCR_UPLOAD',
    uploadType: 'BACK_DOC_2',
    type: 'file',
    position: 11,
    cleanName: 'Carica il retro del documento',
    modalTitle: 'Carica o scatta il retro del documento',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_2-ENTE_RILASCIO': {
    name: 'ENTE_RILASCIO',
    type: 'text',
    // type: 'selectbox',
    // options: {
    //   url: 'wgt/utils/documenti',
    //   mapping: { label: 'enteEmissione', value: 'enteEmissione' }
    // },
    isDisabled: true,
    position: 13,
    cleanName: 'Ente di emissione',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  // 'DOCUMENTO_2-PROVINCIA_RILASCIO': {
  //   name: 'PROVINCIA_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Provincia di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },
  // 'DOCUMENTO_2-NAZIONE_RILASCIO': {
  //   name: 'NAZIONE_RILASCIO',
  //   type: 'text',
  //   position: 4,
  //   cleanName: 'Nazione di rilascio',
  //   validations: {
  //     isRequired: true,
  //     default: [{validate:V(v) => ALIDATION_PATTERNS.alphabetic.test(c.value)}]
  //   }
  // },

  'DOCUMENTO_2-TIPO_DOCUMENTO': {
    name: 'TIPO_DOCUMENTO',
    type: 'selectbox',
    position: 12,
    active: true,
    status: ['hidden'],
    options: {
      url: 'wgt/utils/documenti',
      mapping: { label: 'nome', value: 'nome', enteEmissione: 'enteEmissione' }
    },
    autofill: {
      mapping: [{
        key: 'value',
        resKey: 'enteEmissione',
        componentId: 'DOCUMENTO_2-ENTE_RILASCIO'
      }]
    },
    cleanName: 'Tipo di documento'
  },
  //Changes for loading new 'VAT IDENTIFICATION CERTIFICATE' widget 
  'DOCUMENTO_GENERICO-DOC_UPLOAD': {
    name: 'DOCUMENTO_GENERICO',
    uploadType: 'FRONT_DOC_',
    type: 'file',
    position: 3,
    cleanName: 'Certificato',
    modalTitle: 'DOCUMENTO_GENERICO',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOCUMENTO_GENERICO-SUB_LABEL': {
    id: 'DOCUMENTO_GENERICO-SUB_LABEL',
    name: 'SUB_LABEL',
    type: 'label',
    value: 'Solo nel caso in cui tu sia un libero professionista, allega qui il tuo certificato di attribuzione partita IVA',
    position: 1,
    status: [],
    extra: true

  },

  //Pos Changes for new widget label 
  'DOCUMENTO_GENERICO-NOTES': {
    id: 'DOCUMENTO_GENERICO-NOTES',
    name: 'NOTES',
    type: 'label',
    value: "<b>Il documento \xE8 necessario solo per liberi professionisti:</b>\n      <br>I formati accettati sono: PDF, JPEG, GIF, PNG, PJPEG, X-PNG. Il peso massimo consentito per documento \xE8 di 7MB. Per un documento PDF, il numero massimo di pagine consentite \xE8 4.",
    position: 4,
    status: [],
    isSmall: true,
    extra: true

  },

  'DOMICILIO-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    position: 2,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: 'DOMICILIO-CAP'
      },
      // {
      //   key: 'stato',
      //   componentId: 'DOMICILIO-NAZIONE'
      // },
      {
        key: 'provincia',
        componentId: 'DOMICILIO-PROVINCIA'
      }, {
        key: 'localita',
        componentId: 'DOMICILIO-CITTA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'DOMICILIO-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    //isDisabled: true,
    position: 4,
    // autofill: {
    //   url: 'wgt/utils/comunifromegon',
    //   errorMessage: 'la provincia non è valida',
    //   mapping: [
    //     {
    //       key: 'provincia',
    //       componentId: 'DOMICILIO-PROVINCIA'
    //     },
    //     {
    //       key: 'localita',
    //       componentId: 'DOMICILIO-CITTA',
    //       excludeFromPayload: true
    //     },
    //     {
    //       key: 'capCode',
    //       componentId: 'DOMICILIO-CAP',
    //       excludeFromPayload: true
    //     }
    //   ]
    // },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [{
        'DOMICILIO-NAZIONE': {
          fieldName: 'nome'
        }
      }]
    },
    notifyComponents: {
      validate: ['DOMICILIO-INDIRIZZO']
    },
    flag: 'static_1'
  },

  'DOMICILIO-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    position: 5,
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: [{
        'DOMICILIO-PROVINCIA': {
          fieldName: 'provincia'
        }
      }]
    },
    autofill: {
      mapping: [{
        key: 'localita',
        resKey: 'provincia',
        componentId: 'DOMICILIO-PROVINCIA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: ['DOMICILIO-INDIRIZZO']
    }
  },
  'DOMICILIO-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di domicilio",
    position: 6,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.address
      }]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'DOMICILIO-NAZIONE',
      //   'DOMICILIO-PROVINCIA',
      //   'DOMICILIO-CAP',
      //   'DOMICILIO-CITTA',
      //   'DOMICILIO-INDIRIZZO',
      //   'DOMICILIO-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'DOMICILIO-CAP': 'cap',
      //   'DOMICILIO-NAZIONE': 'nazione',
      //   'DOMICILIO-PROVINCIA': 'provincia',
      //   'DOMICILIO-CITTA': 'citta',
      //   'DOMICILIO-INDIRIZZO': 'indirizzo',
      //   'DOMICILIO-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    },
    hint: {
      value: HINTS.address,
      visible: false
    }
  },
  'DOMICILIO-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    cleanName: 'Nazione',
    value: 'ITALIA',
    //isDisabled:true,
    position: 7,
    //value:'ITALIA'
    // options: {
    //    url: 'wgt/utils/nazionifromegon',
    //   fields: [{}]
    // },
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.selected,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    flag: 'static_1'
  },
  'DOMICILIO-INDIRIZZO_TIPO': {
    id: 'DOMICILIO-INDIRIZZO_TIPO',
    name: 'INDIRIZZO_TIPO',
    type: 'hidden',
    value: 'IRE',
    status: [],
    extra: true
  },
  'DOMICILIO-ALTRO': {
    name: 'ALTRO',
    type: 'radio',
    cleanName: 'Altro',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    position: 2,
    toggleVisibility: {
      show: {
        fields: ['DOMICILIO-PROVINCIA', 'DOMICILIO-CITTA', 'DOMICILIO-CAP', 'DOMICILIO-INDIRIZZO', 'DOMICILIO-NAZIONE']
      }
    }
  },
  'DOMICILIO-RESIDENZA': {
    name: 'RESIDENZA',
    type: 'radio',
    value: 'selected',
    cleanName: 'Coincide con residenza',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    position: 1,
    toggleVisibility: {
      hide: {
        fields: ['DOMICILIO-PROVINCIA', 'DOMICILIO-CITTA', 'DOMICILIO-CAP', 'DOMICILIO-INDIRIZZO', 'DOMICILIO-NAZIONE']
      }
    }
  },
  'EMAIL-CODICE_EMAIL': {
    name: 'CODICE_EMAIL',
    type: 'hidden',
    cleanName: 'Codice email'
  },
  'EMAIL-EMAIL': {
    name: 'EMAIL',
    type: 'text',
    position: 1,
    fullWidth: true,
    cleanName: 'Email',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.email,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'EMAIL-CONFERMA_EMAIL': {
    name: 'CONFERMA_EMAIL',
    type: 'text',
    position: 2,
    cleanName: 'Conferma email',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.email,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'FIRMA-IFRAME': {
    name: 'IFRAME',
    cleanName: 'iFrame',
    type: '',
    pullTo: 'right',
    position: 2,
    action: function action() {}
  },
  'INTERESSI_CC-INTERESSI': {
    name: 'INTERESSI',
    cleanName: 'Interessi'
  },
  'INTESTATARI_FISSI-LABEL': {
    name: 'LABEL',
    type: 'label',
    value: '',
    cleanName: 'Label'
  },
  'INTESTATARI_FISSI-INTESTATARI_1': {
    name: 'INTESTATARI_1',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  'INVITO_INTESTATARI-LABEL': {
    id: 'INVITO_INTESTATARI-LABEL',
    name: 'LABEL',
    type: 'label',
    value: 'Hype può essere utilizzato dai minori autorizzati da un genitore o da un tutore, il quale riceverà una e-mail che gli permetterà di inserire i propri dati in totale riservatezza.',
    position: 0,
    status: [],
    extra: true
  },
  'INVITO_INTESTATARI-LABEL2': {
    id: 'INVITO_INTESTATARI-LABEL2',
    name: 'SPACER',
    type: 'label',
    value: 'Il genitore/tutore riceverà tramite e-mail documentazione periodica relativa alle operazioni effettuate.',
    position: 0,
    status: [],
    extra: true
  },
  'INVITO_INTESTATARI-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    position: 9,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cf,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/codicefiscale',
      fields: ['INVITO_INTESTATARI-CF', 'INVITO_INTESTATARI-NOME', 'INVITO_INTESTATARI-COGNOME']
    }
  },
  'INVITO_INTESTATARI-CF_1': {
    name: 'CF_1',
    type: 'hidden',
    cleanName: 'Codice Fiscale',
    position: 9,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cf,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/codicefiscale',
      fields: ['INVITO_INTESTATARI-CF_1', 'INVITO_INTESTATARI-NOME', 'INVITO_INTESTATARI-COGNOME']
    }
  },
  'INVITO_INTESTATARI-COGNOME': {
    name: 'COGNOME',
    type: 'text',
    cleanName: 'Cognome',
    position: 2,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: ['INVITO_INTESTATARI-CF']
    }
  },
  'INVITO_INTESTATARI-COGNOME_1': {
    name: 'COGNOME_1',
    type: 'hidden',
    cleanName: 'Cognome',
    position: 7,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'INVITO_INTESTATARI-EMAIL': {
    name: 'EMAIL',
    type: 'text',
    cleanName: 'Email',
    position: 3,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.email,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      overrides: [{
        validate: VALIDATION_METHODS.underageContactConflict,
        getErrorMessage: VALIDATION_ERRORS.underageContactConflict
      }]
    }
  },
  'INVITO_INTESTATARI-EMAIL_1': {
    name: 'EMAIL_1',
    type: 'hidden',
    cleanName: 'Conferma email',
    position: 4,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.email,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'INVITO_INTESTATARI-NOME': {
    name: 'NOME',
    type: 'text',
    cleanName: 'Nome',
    position: 1,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: ['INVITO_INTESTATARI-CF']
    }
  },
  'INVITO_INTESTATARI-NOME_1': {
    name: 'NOME_1',
    type: 'hidden',
    cleanName: 'Nome',
    position: 7,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'INVITO_INTESTATARI-NUM_CELLULARE': {
    name: 'NUM_CELLULARE',
    type: 'text',
    cleanName: 'Numero cellulare',
    position: 5,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobileNumber,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      overrides: [{
        validate: VALIDATION_METHODS.underageContactConflict,
        getErrorMessage: VALIDATION_ERRORS.underageContactConflict
      }]
    }
  },
  'INVITO_INTESTATARI-NUM_CELLULARE_1': {
    name: 'NUM_CELLULARE_1',
    type: 'hidden',
    position: 6,
    cleanName: 'Conferma numero cellulare',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobileNumber,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'INVITO_INTESTATARI-PREF_CELLULARE': {
    name: 'PREF_CELLULARE',
    type: 'hidden',
    value: '+39',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobilePrefix,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
      // type: 'selectbox',
      // isDisabled: true,
      // options: {
      //   url: 'wgt/utils/prefissi',
      //   mapping: { label: 'description', value: 'value' }
      // },
      // value: '+39',
      // cleanName: 'Prefisso cellulare',
      // validations: {
      //   isRequired: true
      // }
    } },
  'INVITO_INTESTATARI-PREF_CELLULARE_1': {
    name: 'PREF_CELLULARE_1',
    type: 'hidden',
    value: '+39',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobilePrefix,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
      // type: 'selectbox',
      // isDisabled: true,
      // options: {
      //   url: 'wgt/utils/prefissi',
      //   mapping: { label: 'description', value: 'value' }
      // },
      // value: '+39',
      // cleanName: 'Prefisso cellulare',
      // validations: {
      //   isRequired: true
      // }
    } },
  'LABEL-LABEL': {
    name: 'LABEL',
    type: 'label',
    cleanName: 'Label'
  },
  'LABEL-SUB_LABEL': {
    name: 'SUB_LABEL',
    type: 'label',
    cleanName: 'Sublabel',
    status: []
  },
  'MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO': {
    name: 'SELFIE_1_DOCUMENTO',
    type: 'hidden',
    position: 1,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Selfie con documento in mano',
    toggleVisibility: {
      show: { fields: ['SELFIE'] },
      hide: { fields: ['DOCUMENTO_2'] }
    }
  },
  'MOD_IDENTIFICAZIONE-BONIFICO_1_DOCUMENTO': {
    name: 'BONIFICO_1_DOCUMENTO',
    type: 'radio',
    position: 2,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Bonifico',
    description: 'Se hai un conto a te intestato, puoi utilizzare anche questo metodo per farti riconoscere',
    toggleVisibility: {
      show: { fields: ['BONIFICO'] },
      hide: { fields: ['SELFIE'] }
    }
  },
  'MOD_IDENTIFICAZIONE-SELFIE_BONIFICO_DOCUMENTO': {
    name: 'SELFIE_BONIFICO_DOCUMENTO',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Selfie bonifico e documento'
  },
  'MOD_IDENTIFICAZIONE-SELFIE_2_DOCUMENTI': {
    name: 'SELFIE_2_DOCUMENTI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Selfie con documento in mano',
    description: 'Volto e documento devono essere ben visibili per essere sicuri che sia davvero tu'
  },
  'MOD_IDENTIFICAZIONE-BONIFICO_2_DOCUMENTI': {
    name: 'BONIFICO_2_DOCUMENTI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Bonifico',
    description: 'Se hai un conto a te intestato, puoi utilizzare anche questo metodo per farti riconoscere'
  },
  'MOD_IDENTIFICAZIONE-PERSONA': {
    name: 'PERSONA',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Persona'
  },
  'MOD_IDENTIFICAZIONE-2_DOCUMENTI': {
    name: '2_DOCUMENTI',
    type: 'radio',
    //value: 'selected',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    toggleVisibility: {
      show: { fields: ['DOCUMENTO_2'] },
      hide: { fields: ['SELFIE'] }
    },
    cleanName: '2 Documenti'
  },
  'MOD_IDENTIFICAZIONE-VIDEO_2_DOCUMENTI': {
    name: 'VIDEO_2_DOCUMENTI',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Video 2 Documenti'
  },
  'NOME_COGNOME-COGNOME': {
    name: 'COGNOME',
    type: 'text',
    cleanName: 'Cognome',
    position: 2,
    notifyComponents: {
      validate: ['CODICE_FISCALE-CF']
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'NOME_COGNOME-NOME': {
    name: 'NOME',
    type: 'text',
    cleanName: 'Nome',
    position: 1,
    notifyComponents: {
      validate: ['CODICE_FISCALE-CF']
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'NUMERO_INTESTATARI-INTESTATARI_1': {
    name: 'INTESTATARI_1',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  'NUMERO_INTESTATARI-INTESTATARI_2': {
    name: 'INTESTATARI_2',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  'NUMERO_INTESTATARI-INTESTATARI_3': {
    name: 'INTESTATARI_3',
    type: 'hidden',
    cleanName: 'Intestatari'
  },
  // 'PRIVACY-PRIVACY': {
  //   id: 'PRIVACY-PRIVACY',
  //   name: 'PRIVACY',
  //   type: 'checkbox',
  //   value: '',
  //   pullTo: 'left',
  //   active: true,
  //   cleanName: 'Privacy',
  //   status: [],
  //   position: 1,
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   },
  //   description: '',
  //   descriptionWithLink: true,
  //   combineComponent: {
  //     id: 'PRIVACY-PRIVACY_TEXT',
  //     name: 'PRIVACY_TEXT',
  //     type: 'labelWithLink',
  //     pullTo: 'right',
  //     status: [],
  //     link: {
  //       placeholder: '§link§',
  //       text: "l'informativa in materia di privacy",
  //       url:
  //         //'https://www.hype.it/SSRDocumentDisplayer?dtdPG=INFORMATIVA_PRIVACY_HYPE&dtdPE=1',
  //         'https://www.axerve.com/site/privacy-policy/',
  //       target: '_blank'
  //     },
  //     value: 'Cliccando su continua dichiaro di aver letto §link§',
  //     extra: true,
  //     // position: 2,
  //     // style: {'margin-left'}
  //     element: 'span'
  //   }
  // },
  'PRIVACY-PRIVACY': {
    id: 'PRIVACY-PRIVACY',
    name: 'PRIVACY',
    type: 'checkbox',
    status: [],
    link: {
      placeholder: '§link§',
      text: "l'informativa sul trattamento dei dati personali",
      url: 'https://www.fabrick.com/transparency/FBK_PP_IT_IT_INFORMATIVAPRIVACY_CLIENTI_H20.pdf',
      target: '_blank'
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    value: 'Dichiaro di aver letto e compreso §link§ di Fabrick S.p.A.',
    description: 'Dichiaro di aver letto e compreso §link§ di Fabrick S.p.A.',
    additionalView: function additionalView(props) {
      return (props.plan === 'flat' || props.plan === 'flatCRS') && _react2.default.createElement(
        "div",
        { className: "grayed mt-5" },
        "Se sei gi\xE0 in possesso di un ",
        _react2.default.createElement(
          "b",
          null,
          "codice coupon"
        ),
        " puoi inserirlo all'ultimo step dopo la firma dei contratti, prima dell'invio della pratica."
      );
    },
    active: true,
    position: 2,
    element: 'span'
  },
  'PROFESSIONE_ATTIVITA-PROFESSIONE': {
    name: 'PROFESSIONE',
    type: 'selectbox',
    cleanName: 'Professione',
    position: 1,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    options: {
      url: 'wgt/utils/professioni',
      mapping: { label: 'description', value: 'value' },
      fields: [{}]
    },

    trigger: [{
      componentId: 'PROFESSIONE_ATTIVITA-SETTORE',
      type: 'fetchOption'
    }, {
      componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      type: 'fetchOption'
      //,
      // {
      //   componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      //   type: 'fetch'
      // }
    }],
    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionario', //'wgt/acol/get',
        body: {
          contesto: 'ACOLProspect_PF',
          viewMode: false
        },
        fields: [{
          'PROFESSIONE_ATTIVITA-PROFESSIONE': {
            fieldName: 'profession'
          }
        }, {
          'PROFESSIONE_ATTIVITA-ATTIVITA': {
            fieldName: 'attivita'
          }
        }, {
          'PROFESSIONE_ATTIVITA-ATTIVITA': {
            fieldName: 'attivitaEconomica'
          }
        }],
        mappingEvent: 'questionario'
      }
    }
  },
  'PROFESSIONE_ATTIVITA-SETTORE': {
    name: 'SETTORE',
    type: 'selectbox',
    cleanName: 'Settore',
    position: 2,
    options: {
      url: 'wgt/utils/settori',
      mapping: { label: 'description', value: 'value' },
      fields: [{
        'PROFESSIONE_ATTIVITA-PROFESSIONE': {
          fieldName: 'value'
        }
      }]
    },
    trigger: [{
      componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      type: 'fetchOption'
      // ,
      // {
      //   componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      //   type: 'fetch'
      // }
    }],
    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionario', //'wgt/acol/get',
        body: {
          contesto: 'ACOLProspect_PF',
          viewMode: false
        },
        fields: [{
          'PROFESSIONE_ATTIVITA-PROFESSIONE': {
            fieldName: 'profession'
          }
        }, {
          'PROFESSIONE_ATTIVITA-ATTIVITA': {
            fieldName: 'attivita'
          }
        }, {
          'PROFESSIONE_ATTIVITA-ATTIVITA': {
            fieldName: 'attivitaEconomica'
          }
        }],
        mappingEvent: 'questionario'
      }
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'PROFESSIONE_ATTIVITA-ATTIVITA': {
    name: 'ATTIVITA',
    type: 'selectbox',
    position: 3,
    cleanName: 'Attività economica',
    options: {
      url: 'wgt/utils/attivita',
      mapping: { label: 'description', value: 'value' },
      fields: [{
        'PROFESSIONE_ATTIVITA-PROFESSIONE': {
          fieldName: 'professione'
        }
      }]
    },
    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionario', //'wgt/acol/get',
        body: {
          contesto: 'ACOLProspect_PF',
          viewMode: false
        },
        fields: [{
          'PROFESSIONE_ATTIVITA-PROFESSIONE': {
            fieldName: 'profession'
          }
        }, {
          'PROFESSIONE_ATTIVITA-ATTIVITA': {
            fieldName: 'attivita'
          }
        }, {
          'PROFESSIONE_ATTIVITA-ATTIVITA': {
            fieldName: 'attivitaEconomica'
          }
        }],
        mappingEvent: 'questionario'
      }
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
      // trigger: [
      //   {
      //     componentId: 'PROFESSIONE_ATTIVITA-ATTIVITA',
      //     type: 'fetch'
      //   }
      // ]
    } },

  'PROFILAZIONE-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Profilazione visione',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.bool,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    description:
    //'Ti chiediamo il consenso per il trattamento dei tuoi dati per l\'offerta di prodotti finanziari del Gruppo Sella, per la gestione o/e il monitoraggio dei movimenti, anche ai fini antifrode, o per la realizzazione e l\'invio di promozioni ed offerte create "su misura" per te, sia direttamente che tramite società terze.'
    'Consenso facoltativo al trattamento dei dati personali per finalità di profilazione.\nCon riferimento al Paragrafo 9 dell’informativa, mi esprimo in merito al trattamento dei miei dati da parte di Fabrick ai fini di seguito indicati, consapevole che tale azione è facoltativa e non vincolante alla stipula del contratto:attività di profilazione per proporLe prodotti e servizi personalizzati che rispondono al meglio alle Sue esigenze.'
  },
  'PROMOZIONE-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Presa visione',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.bool,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    description:
    //'Ti chiediamo il consenso per il trattamento dei tuoi dati da parte di Axerve S.p.A., da parte di una Società del Gruppo Sella oppure da parte di società terze nominate responsabili esterne del trattamento per l\'offerta di prodotti finanziari del Gruppo Sella e prodotti e servizi di terzi, per la gestione o/e il monitoraggio dei movimenti, anche ai fini antifrode, o per la realizzazione e l\'invio di promozioni ed offerte create "su misura" per te, sia direttamente che tramite società terze.'
    'Rilevazione del grado di soddisfazione della Clientela sulla qualità dei servizi resi, elaborazione di studi e ricerche di mercato, attività di marketing di prodotti e servizi propri, di Società del Gruppo Banca Sella o di terzi, per migliorare continuamente il servizio fornito.'
  },
  'PROMOZIONE_TERZI-VISIONE': {
    name: 'VISIONE',
    type: 'checkbox',
    cleanName: 'Presa visione',
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.bool,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // },
    description:
    //'Per dar seguito alla richiesta è necessario il tuo consenso alla comunicazione dei dati a soggetti terzi che svolgono per conto della banca attività di promozione/vendita di prodotti/servizi, rilevazione del grado di soddisfazione della clientela, ricerche di mercato.'
    'Comunicazione dei dati a soggetti terzi che svolgono per conto di Fabrick attività di rilevazione del grado di soddisfazione della Clientela sulla qualità dei servizi resi, elaborazione di studi e ricerche di mercato, attività di marketing di prodotti e servizi propri, di Società del Gruppo Banca Sella o di terzi, per migliorare continuamente il servizio fornito ai Clienti.'
  },
  'RESIDENZA-NAZIONE': {
    name: 'NAZIONE',
    type: 'text',
    isDisabled: true,
    value: 'ITALIA',
    cleanName: 'Nazione'
    // type: 'selectbox',
    // cleanName: 'Nazione',
    // value: 'ITALIA',
    // isDisabled: true,
    // position: 1,
    // options: {
    //   url: 'wgt/utils/nazionifromegon',
    //   mapping: { label: 'nome', value: 'nome' }
    // }
  },
  'RESIDENZA-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    position: 1,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: 'RESIDENZA-CAP'
      },
      // {
      //   key: 'stato',
      //   componentId: 'RESIDENZA-NAZIONE'
      // },
      {
        key: 'provincia',
        componentId: 'RESIDENZA-PROVINCIA'
      }, {
        key: 'localita',
        componentId: 'RESIDENZA-CITTA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'RESIDENZA-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    //isDisabled: true,
    position: 2,
    // autofill: {
    //   url: 'wgt/utils/comunifromegon',
    //   errorMessage: 'la provincia non è valida',
    //   mapping: [
    //     {
    //       key: 'provincia',
    //       componentId: 'RESIDENZA-PROVINCIA'
    //     },
    //     {
    //       key: 'localita',
    //       componentId: 'RESIDENZA-CITTA',
    //       excludeFromPayload: true
    //     },
    //     {
    //       key: 'capCode',
    //       componentId: 'RESIDENZA-CAP',
    //       excludeFromPayload: true
    //     }
    //   ]
    // },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [{
        'RESIDENZA-NAZIONE': {
          fieldName: 'nome'
        }
      }]
    },
    notifyComponents: {
      validate: ['RESIDENZA-INDIRIZZO']
    },
    flag: 'static_1'
  },
  'RESIDENZA-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    position: 3,
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: [{
        'RESIDENZA-PROVINCIA': {
          fieldName: 'provincia'
        }
      }]
    },
    autofill: {
      mapping: [{
        key: 'localita',
        resKey: 'provincia',
        componentId: 'RESIDENZA-PROVINCIA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: ['RESIDENZA-INDIRIZZO']
    }
  },
  'RESIDENZA-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di residenza",
    position: 4,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.address
      }]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'RESIDENZA-NAZIONE',
      //   'RESIDENZA-PROVINCIA',
      //   'RESIDENZA-CAP',
      //   'RESIDENZA-CITTA',
      //   'RESIDENZA-INDIRIZZO',
      //   'RESIDENZA-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'RESIDENZA-CAP': 'cap',
      //   'RESIDENZA-NAZIONE': 'nazione',
      //   'RESIDENZA-PROVINCIA': 'provincia',
      //   'RESIDENZA-CITTA': 'citta',
      //   'RESIDENZA-INDIRIZZO': 'indirizzo',
      //   'RESIDENZA-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    },
    hint: {
      value: HINTS.address,
      visible: false
    }
  },
  'RESIDENZA-INDIRIZZO_TIPO': {
    id: 'RESIDENZA-INDIRIZZO_TIPO',
    name: 'INDIRIZZO_TIPO',
    type: 'hidden',
    value: 'IRE',
    status: [],
    extra: true
  },
  'RESIDENZA_FISCALE-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    value: 'ITALIA',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RESIDENZA_FISCALE-NAZIONE_2': {
    name: 'NAZIONE_2',
    type: 'selectbox',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RESIDENZA_FISCALE-NAZIONE_3': {
    name: 'NAZIONE_3',
    type: 'selectbox',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RESIDENZA_FISCALE-NO_ALTRE_RESIDENZE': {
    name: 'NO_ALTRE_RESIDENZE',
    cleanName: 'Nessuna altra residenza'
  },
  'RESIDENZA_FISCALE-CF_3': {
    name: 'CF_3',
    type: 'text',
    cleanName: 'Codice Fiscale',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cf,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/codicefiscale',
      fields: ['RESIDENZA_FISCALE-CF_3', 'RESIDENZA_FISCALE-NOME', 'RESIDENZA_FISCALE-COGNOME']
    }
  },
  'RESIDENZA_FISCALE-CF_2': {
    name: 'CF_2',
    type: 'text',
    cleanName: 'Codice Fiscale',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cf,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/codicefiscale',
      fields: ['RESIDENZA_FISCALE-CF_2', 'RESIDENZA_FISCALE-NOME', 'RESIDENZA_FISCALE-COGNOME']
    }
  },
  'RESIDENZA_FISCALE-STESSA_NAZIONE': {
    name: 'STESSA_NAZIONE',
    cleanName: 'Stessa nazione'
  },
  'RESIDENZA_FISCALE-ALTRE_RESIDENZE': {
    name: 'ALTRE_RESIDENZE',
    cleanName: 'Altre residenze'
  },
  'RESIDENZA_FISCALE-ALTRA_NAZIONE': {
    name: 'ALTRA_NAZIONE',
    cleanName: 'Altra nazione'
  },
  'RESIDENZA_FISCALE-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cf,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/codicefiscale',
      fields: ['RESIDENZA_FISCALE-CF', 'RESIDENZA_FISCALE-NOME', 'RESIDENZA_FISCALE-COGNOME']
    }
  },
  'RESUME_BY_CELL-PREF_CELLULARE': {
    name: 'PREF_CELLULARE',
    type: 'hidden',
    value: '+39',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobilePrefix,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
      // type: 'selectbox',
      // isDisabled: true,
      // options: {
      //   url: 'wgt/utils/prefissi',
      //   mapping: { label: 'description', value: 'value' }
      // },
      // value: '+39',
      // cleanName: 'Prefisso cellulare',
      // validations: {
      //   isRequired: true
      // }
    } },
  'RESUME_BY_CELL-NUM_CELLULARE': {
    name: 'NUM_CELLULARE',
    type: 'text',
    cleanName: 'Numero cellulare',
    isDisabled: true,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobileNumber,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'RESUME_BY_CELL-CODICE_CELLULARE': {
    name: 'CODICE_CELLULARE',
    type: 'text',
    // status: ['hidden'],
    cleanName: 'Codice OTP',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.otp,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'RESUME_BY_CELL-GUID_PROCESSO': {
    name: 'GUID_PROCESSO',
    type: 'hidden',
    cleanName: 'GUID del processo'
  },
  'RIF_POSTALE-ALTRO': {
    name: 'ALTRO',
    cleanName: 'Altro'
  },
  'RIF_POSTALE-RESIDENZA': {
    name: 'RESIDENZA',
    type: 'text',
    cleanName: 'Residenza'
  },
  'RIF_POSTALE-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [{
        'RIF_POSTALE-NAZIONE': {
          fieldName: 'nome'
        }
      }]
    }
  },
  'RIF_POSTALE-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    cleanName: 'Nazione',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'RIF_POSTALE-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di spedizione",
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.address
      }]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'RIF_POSTALE-NAZIONE',
      //   'RIF_POSTALE-PROVINCIA',
      //   'RIF_POSTALE-CAP',
      //   'RIF_POSTALE-CITTA',
      //   'RIF_POSTALE-INDIRIZZO',
      //   'RIF_POSTALE-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'RIF_POSTALE-CAP': 'cap',
      //   'RIF_POSTALE-NAZIONE': 'nazione',
      //   'RIF_POSTALE-PROVINCIA': 'provincia',
      //   'RIF_POSTALE-CITTA': 'citta',
      //   'RIF_POSTALE-INDIRIZZO': 'indirizzo',
      //   'RIF_POSTALE-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    }
  },
  'RIF_POSTALE-DOMICILIO': {
    name: 'DOMICILIO',
    type: 'text',
    cleanName: 'Domicilio'
  },
  'RIF_POSTALE-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'RIF_POSTALE-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: 'RIF_POSTALE-CAP'
      },
      // {
      //   key: 'stato',
      //   componentId: 'RIF_POSTALE-NAZIONE'
      // },
      {
        key: 'provincia',
        componentId: 'RIF_POSTALE-PROVINCIA'
      }, {
        key: 'localita',
        componentId: 'RIF_POSTALE-CITTA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'RIF_SPEDIZIONE_CARTA-ALTRO': {
    name: 'ALTRO',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Presso un altro indirizzo',
    position: 3,
    toggleVisibility: {
      show: {
        fields: ['RIF_SPEDIZIONE_CARTA-NAZIONE', 'RIF_SPEDIZIONE_CARTA-PROVINCIA', 'RIF_SPEDIZIONE_CARTA-CITTA', 'RIF_SPEDIZIONE_CARTA-CAP', 'RIF_SPEDIZIONE_CARTA-INDIRIZZO']
      }
    }
  },
  'RIF_SPEDIZIONE_CARTA-RADIO_SPACER': {
    id: 'RIF_SPEDIZIONE_CARTA-RADIO_SPACER',
    name: 'RADIO_SPACER',
    type: 'spacer',
    position: 4,
    value: '',
    status: [],
    extra: true
  },
  'RIF_SPEDIZIONE_CARTA-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    position: 5,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: 'RIF_SPEDIZIONE_CARTA-CAP'
      },
      // {
      //   key: 'stato',
      //   componentId: 'RIF_SPEDIZIONE_CARTA-NAZIONE'
      // },
      {
        key: 'provincia',
        componentId: 'RIF_SPEDIZIONE_CARTA-PROVINCIA'
      }, {
        key: 'localita',
        componentId: 'RIF_SPEDIZIONE_CARTA-CITTA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'RIF_SPEDIZIONE_CARTA-CITTA': {
    name: 'CITTA',
    type: 'selectbox',
    isDisabled: true,
    cleanName: 'Città',
    position: 7,
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: [{
        'RIF_SPEDIZIONE_CARTA-PROVINCIA': {
          fieldName: 'provincia'
        }
      }]
    },
    autofill: {
      mapping: [{
        key: 'localita',
        resKey: 'provincia',
        componentId: 'RIF_SPEDIZIONE_CARTA-PROVINCIA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: ['RIF_SPEDIZIONE_CARTA-INDIRIZZO']
    }
  },
  'RIF_SPEDIZIONE_CARTA-DOMICILIO': {
    name: 'DOMICILIO',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Presso il mio domicilio',
    position: 2,
    toggleVisibility: {
      hide: {
        fields: ['RIF_SPEDIZIONE_CARTA-NAZIONE', 'RIF_SPEDIZIONE_CARTA-PROVINCIA', 'RIF_SPEDIZIONE_CARTA-CITTA', 'RIF_SPEDIZIONE_CARTA-CAP', 'RIF_SPEDIZIONE_CARTA-INDIRIZZO']
      }
    }
  },
  'RIF_SPEDIZIONE_CARTA-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di spedizione",
    position: 8,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.address
      }]
      // url: 'wgt/validate/indirizzo',
      // lazy: true,
      // fields: [
      //   'RIF_SPEDIZIONE_CARTA-NAZIONE',
      //   'RIF_SPEDIZIONE_CARTA-PROVINCIA',
      //   'RIF_SPEDIZIONE_CARTA-CAP',
      //   'RIF_SPEDIZIONE_CARTA-CITTA',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO'
      // ],
      // mapping: {
      //   'RIF_SPEDIZIONE_CARTA-CAP': 'cap',
      //   'RIF_SPEDIZIONE_CARTA-NAZIONE': 'nazione',
      //   'RIF_SPEDIZIONE_CARTA-PROVINCIA': 'provincia',
      //   'RIF_SPEDIZIONE_CARTA-CITTA': 'citta',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO': 'indirizzo',
      //   'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO': 'tipoIndirizzo'
      // }
    },
    hint: {
      value: HINTS.address,
      visible: false
    }
  },
  'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO': {
    id: 'RIF_SPEDIZIONE_CARTA-INDIRIZZO_TIPO',
    name: 'INDIRIZZO_TIPO',
    type: 'hidden',
    value: 'IRE',
    status: [],
    extra: true
  },
  'RIF_SPEDIZIONE_CARTA-NAZIONE': {
    name: 'NAZIONE',
    type: 'hidden',
    value: 'ITALIA'
    // type: 'selectbox',
    // value: 'ITALIA',
    // cleanName: 'Nazione',
    // position: 3,
    // isDisabled: true,
    // options: {
    //   url: 'wgt/utils/nazionifromegon',
    //   mapping: { label: 'nome', value: 'nome' }
    // }
  },
  'RIF_SPEDIZIONE_CARTA-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    isDisabled: true,
    position: 6,
    // autofill: {
    //   url: 'wgt/utils/comunifromegon',
    //   errorMessage: 'la provincia non è valida',
    //   mapping: [
    //     {
    //       key: 'provincia',
    //       componentId: 'RIF_SPEDIZIONE_CARTA-PROVINCIA'
    //     },
    //     {
    //       key: 'localita',
    //       componentId: 'RIF_SPEDIZIONE_CARTA-CITTA',
    //       excludeFromPayload: true
    //     },
    //     {
    //       key: 'capCode',
    //       componentId: 'RIF_SPEDIZIONE_CARTA-CAP',
    //       excludeFromPayload: true
    //     }
    //   ]
    // },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [{
        'RIF_SPEDIZIONE_CARTA-NAZIONE': {
          fieldName: 'nome'
        }
      }]
    },
    notifyComponents: {
      validate: ['RIF_SPEDIZIONE_CARTA-INDIRIZZO']
    }
  },
  'RIF_SPEDIZIONE_CARTA-RESIDENZA': {
    name: 'RESIDENZA',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Presso la mia residenza',
    position: 1,
    toggleVisibility: {
      hide: {
        fields: ['RIF_SPEDIZIONE_CARTA-NAZIONE', 'RIF_SPEDIZIONE_CARTA-PROVINCIA', 'RIF_SPEDIZIONE_CARTA-CITTA', 'RIF_SPEDIZIONE_CARTA-CAP', 'RIF_SPEDIZIONE_CARTA-INDIRIZZO']
      }
    }
  },
  'SELFIE-SELFIE_UPLOAD': {
    name: 'SELFIE_UPLOAD',
    type: 'file',
    position: 3,
    uploadType: 'SELFIE',
    cleanName: 'Scatta un selfie con documento in mano',
    modalTitle: 'Scatta il tuo selfie con documento in mano',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SELFIE-SELFIE_UPLOAD_LABEL': {
    id: 'SELFIE-SELFIE_UPLOAD_LABEL',
    name: 'SELFIE_UPLOAD_LABEL',
    type: 'label',
    isPadded: true,
    isCentered: true,
    position: 2,
    value: 'Scatta un <b>selfie</b> con un <b>tuo documento</b> in mano.<br>Assicurati che sia il tuo <b>viso</b> che il <b>documento</b> siano <b>ben riconoscibili</b> nella foto.',
    status: [],
    extra: true
  },
  'SELFIE-SELFIE_UPLOAD_SPACER': {
    id: 'SELFIE-SELFIE_UPLOAD_SPACER',
    name: 'SELFIE_UPLOAD_SPACER',
    type: 'spacer',
    position: 1,
    value: '',
    status: [],
    extra: true
  },
  'SUCCURSALE-SUCCURSALE': {
    name: 'SUCCURSALE',
    cleanName: 'Succursale'
  },
  'SUCCURSALE_IDENTIFICAZIONE-TIPO_DOCUMENTO': {
    name: 'TIPO_DOCUMENTO',
    type: 'selectbox',
    options: {
      url: 'wgt/utils/documenti',
      mapping: { label: 'nome', value: 'nome' }
    },
    cleanName: 'Tipo di documento'
  },
  'SUCCURSALE_IDENTIFICAZIONE-LUOGO_RILASCIO': {
    name: 'LUOGO_RILASCIO',
    type: 'text',
    cleanName: 'Luogo di rilascio'
  },
  'SUCCURSALE_IDENTIFICAZIONE-NUMERO_DOCUMENTO': {
    name: 'NUMERO_DOCUMENTO',
    type: 'text',
    cleanName: 'Numero documento'
  },
  'SUCCURSALE_IDENTIFICAZIONE-SUCCURSALE': {
    name: 'SUCCURSALE',
    cleanName: 'Succursale'
  },
  'SUCCURSALE_IDENTIFICAZIONE-DATA_SCADENZA': {
    name: 'DATA_SCADENZA',
    type: 'text',
    cleanName: 'Data scadenza',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.date,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SUCCURSALE_IDENTIFICAZIONE-DATA_RILASCIO': {
    name: 'DATA_RILASCIO',
    type: 'text',
    cleanName: 'Data rilascio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.date,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SUCCURSALE_IDENTIFICAZIONE-ENTE_RILASCIO': {
    name: 'ENTE_RILASCIO',
    type: 'text',
    cleanName: 'Ente di rilascio'
  },
  /*  'TERMINA_PROCEDURA-LABEL': {
     name: 'LABEL',
     type: 'label',
     cleanName: 'Label',
     value: 'Per completare la tua richiesta manca pochissimo!'
   },
   'TERMINA_PROCEDURA-RESUME_INTEST_2': {
     name: 'RESUME_INTEST_2',
     type: null,
     cleanName: 'Riprendi in test'
   },
   'TERMINA_PROCEDURA-RESUME_INTEST_3': {
     name: 'RESUME_INTEST_3',
     type: null,
     cleanName: 'Riprendi in test'
   }, */
  'TIPOLOGIA_CARTA-CARTA_FISICA': {
    name: 'CARTA_FISICA',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Voglio ricevere GRATIS anche la carta fisica',
    description: 'Per acquistare online, nei negozi e prelevare contanti in tutto il mondo senza commissioni.',
    // value: '',
    position: 1,
    toggleVisibility: {
      show: {
        fields: ['RIF_SPEDIZIONE_CARTA' /*,
                                        'RIF_SPEDIZIONE_CARTA-RESIDENZA',
                                        'RIF_SPEDIZIONE_CARTA-DOMICILIO',
                                        'RIF_SPEDIZIONE_CARTA-ALTRO'*/
        ]
      }
    }
  },
  'TIPOLOGIA_CARTA-CARTA_VIRTUALE': {
    name: 'CARTA_VIRTUALE',
    type: 'radio',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    cleanName: 'Voglio solo la carta virtuale',
    description: 'Permette di effettuare soltanto acquisti online e non consente prelievi di denaro.',
    position: 2,
    toggleVisibility: {
      hide: {
        fields: ['RIF_SPEDIZIONE_CARTA' /*,
                                        'RIF_SPEDIZIONE_CARTA-RESIDENZA',
                                        'RIF_SPEDIZIONE_CARTA-DOMICILIO',
                                        'RIF_SPEDIZIONE_CARTA-ALTRO'*/
        ]
      }
    }
  },
  'VERIFICA_DATI_DA_CF-CF': {
    name: 'CF',
    type: 'text',
    cleanName: 'Codice Fiscale',
    isDisabled: true,
    position: 7
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.cf,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ],
    //   url: 'wgt/validate/codicefiscale',
    //   fields: [
    //     'VERIFICA_DATI_DA_CF-CF',
    //     'VERIFICA_DATI_DA_CF-NOME',
    //     'VERIFICA_DATI_DA_CF-COGNOME'
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-CITTA': {
    name: 'CITTA',
    type: 'text',
    cleanName: 'Città',
    isDisabled: true,
    position: 5
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.city,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-COGNOME': {
    name: 'COGNOME',
    type: 'text',
    cleanName: 'Cognome',
    isDisabled: true,
    position: 2
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.alphabetic,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-DATA': {
    name: 'DATAb',
    type: 'text',
    cleanName: 'Data',
    isDisabled: true,
    position: 3
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.date,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-NOME': {
    name: 'NOME',
    type: 'text',
    cleanName: 'Nome',
    isDisabled: true,
    position: 1
    // validations: {
    //   isRequired: true,
    //   default: [
    //     {
    //       validate: VALIDATION_METHODS.alphabetic,
    //       getErrorMessage: VALIDATION_ERRORS.filled
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'text',
    cleanName: 'Provincia',
    isDisabled: true,
    position: 6
    // options: {
    //   url: 'wgt/utils/provincefromegon',
    //   mapping: { label: 'sigla', value: 'sigla' },
    //   fields: [
    //     {
    //       'VERIFICA_DATI_DA_CF-NAZIONE': {
    //         fieldName: 'nome'
    //       }
    //     }
    //   ]
    // }
  },
  'VERIFICA_DATI_DA_CF-SESSO': {
    name: 'SESSO',
    type: 'text',
    cleanName: 'Sesso',
    isDisabled: true,
    position: 4
    // values: ['M', 'F']
  },
  'WIDGET_HTML-HTML': {
    name: 'HTML',
    cleanName: 'Html'
  },
  /* 'TERMINA_PROCEDURA-CONTRATTO': {
    id: 'TERMINA_PROCEDURA-CONTRATTO',
    name: 'CONTRATTO',
    type: 'labelWithLink',
    status: [],
    // validations: {
    //   isRequired: true,
    //   default: [{validate:V(v) => ALIDATION_PATTERNS.bool.test(c.value)}]
    // },
    link: {
      placeholder: '§link§',
      text: 'contratto',
      dataSourceUrl: 'wgt/sign/contractlist'
    },
    acknowledgement: {
      url: 'wgt/utils/presavisione',
      fields: ''
    },
    cleanName: 'Presa visione',
    value:
      'Proseguendo dichiaro di aver letto e accettato il §link§ ed attesto di essere fiscalmente residente esclusivamente in Italia (*)',
    extra: true
  },
  'TERMINA_PROCEDURA-MODULO': {
    id: 'TERMINA_PROCEDURA-MODULO',
    name: 'MODULO',
    type: 'labelWithLink',
    status: [],
    // validations: {
    //   isRequired: true,
    //   default: [{validate:V(v) => ALIDATION_PATTERNS.bool.test(c.value)}]
    // },
    link: {
      placeholder: '§link§',
      text: 'modulo standard',
      url:
        'https://www.hype.it/SSRDocumentDisplayer?dtdPG=INFO_DEPOSITANTI_BSE&dtdPE=1'
    },
    cleanName: 'Presa visione',
    value:
      'Dichiaro di aver inoltre ricevuto, prima della conclusione del contratto, il §link§ per le informazioni da fornire ai depositanti',
    extra: true
  },
  'TERMINA_PROCEDURA-RESIDENZA_ITA': {
    id: 'TERMINA_PROCEDURA-RESIDENZA_ITA',
    name: 'RESIDENZA_ITA',
    type: 'labelWithLink',
    status: [],
    // validations: {
    //   isRequired: true,
    //   default: [{validate:V(v) => ALIDATION_PATTERNS.bool.test(c.value)}]
    // },
    links: [
      {
        placeholder: '§link§',
        text: 'cliccando qui',
        url: '#'
      }
      // ,
      // {
      //   placeholder: '§phone§',
      //   text: '0152434667',
      //   url: 'phone:0152434667'
      // }
    ],
    cleanName: 'Presa visione',
    value:
      'Nel caso tu abbia altre residenze fiscali oltre a quella italiana scrivici §link§', //contattaci telefonicamente allo §phone§ oppure
    extra: true
  },
  'TERMINA_PROCEDURA-RESIDENZA_ITA_SPEC': {
    id: 'TERMINA_PROCEDURA-RESIDENZA_ITA_SPEC',
    name: 'RESIDENZA_ITA_SPEC',
    type: 'label',
    status: [],
    cleanName: 'Presa visione',
    isSmall: true,
    value:
      '(*)"Attestazione di residenza fiscale resa ai sensi dell\'art. 5 della Legge 95/2015 e del DPCM 28/12/2015 (G.U. n° 303 del 31/12/2015) art. 2 comma 1 e Allegato A sezione III A"',
    extra: true
  },*/
  'JOLLY-LABEL': {
    id: 'JOLLY-LABEL',
    name: 'LABEL',
    type: 'hidden'
  },
  'JOLLY-SUB_LABEL': {
    id: 'JOLLY-SUB_LABEL',
    name: 'SUB_LABEL',
    type: 'label',
    value: "A seguito della richiesta che ho ricevuto tramite e-mail, autorizzo e richiedo l'attivazione del servizio Hype intestato al soggetto minorenne richiedente, del quale dichiaro di essere:",
    position: 1
  },
  'JOLLY-JOLLY_INPUT': {
    id: 'JOLLY-JOLLY_INPUT',
    name: 'JOLLY_INPUT',
    type: 'hidden'
  },
  'JOLLY-JOLLY_SPACER': {
    id: 'JOLLY-JOLLY_SPACER',
    name: 'JOLLY_SPACER',
    type: 'spacer',
    position: 2,
    value: '',
    status: [],
    extra: true
  },
  'JOLLY-JOLLY_RADIO_GENITORE': {
    id: 'JOLLY-JOLLY_RADIO_GENITORE',
    name: 'JOLLY_RADIO_GENITORE',
    type: 'radio',
    position: 3,
    cleanName: 'Genitore',
    value: '',
    values: [{ value: 'GENITORE', selected: 'selected' }, { value: 'TUTORE', selected: '' }, { value: 'selected', selected: '', rif: 'selected' }, { value: 'selected', selected: '', rif: '' }],
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    autofill: {
      mapping: [{
        componentId: 'JOLLY-JOLLY_INPUT',
        key: 'selected'
      }, {
        componentId: 'RIF_SPEDIZIONE_CARTA-RESIDENZA',
        key: 'rif'
      }]
    },
    status: [],
    extra: true
  },
  'JOLLY-JOLLY_RADIO_TUTORE': {
    id: 'JOLLY-JOLLY_RADIO_TUTORE',
    name: 'JOLLY_RADIO_TUTORE',
    type: 'radio',
    position: 4,
    cleanName: 'Tutore',
    value: '',
    values: [{ value: 'GENITORE', selected: '' }, { value: 'TUTORE', selected: 'selected' }, { value: 'selected', selected: '', rif: 'selected' }, { value: 'selected', selected: '', rif: '' }],
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    autofill: {
      mapping: [{
        componentId: 'JOLLY-JOLLY_INPUT',
        key: 'selected'
      }, {
        componentId: 'RIF_SPEDIZIONE_CARTA-RESIDENZA',
        key: 'rif'
      }]
    },
    status: [],
    extra: true
  },
  'JOLLY-JOLLY_LABEL2': {
    id: 'JOLLY-JOLLY_LABEL2',
    name: 'JOLLY_LABEL2',
    type: 'label',
    position: 5,
    value: 'Come genitore/tutore del minorenne riceverai tramite e-mail documentazione periodica delle operazioni effettuate.',
    status: [],
    extra: true
  },
  'WHAT_YOU_NEED-DOCUMENTS': {
    id: 'WHAT_YOU_NEED-DOCUMENTS',
    name: 'DOCUMENTS',
    type: 'image',
    cleanName: 'lorem ipsum',
    position: 1,
    value: 'Tieni a portata di mano un §tuo documento§ di identità',
    values: ['wyn', 'wyn--docs'],
    status: [],
    errorMessage: [],
    extra: true
  },
  'WHAT_YOU_NEED-PHONE': {
    id: 'WHAT_YOU_NEED-PHONE',
    name: 'PHONE',
    type: 'image',
    cleanName: 'lorem ipsum',
    position: 2,
    value: 'Registrati dal tuo smartphone o da pc se hai una §webcam§',
    values: ['wyn', 'wyn--phone'],
    status: [],
    errorMessage: [],
    extra: true
  },
  'WHAT_YOU_NEED-SECURE': {
    id: 'WHAT_YOU_NEED-SECURE',
    name: 'SECURE',
    type: 'image',
    cleanName: 'lorem ipsum',
    position: 3,
    value: 'La registrazione è §rapida e sicura§, sei in buone mani!',
    values: ['wyn', 'wyn--secure'],
    status: [],
    errorMessage: [],
    extra: true
  },
  'WHAT_YOU_NEED-SPACER': {
    id: 'WHAT_YOU_NEED-SPACER',
    name: 'SPACER',
    type: 'spacer',
    position: 4,
    value: '',
    status: [],
    extra: true
  },
  'SIGNALER-HAS_PROMO_CODE_YES': {
    id: 'SIGNALER-HAS_PROMO_CODE_YES',
    name: 'HAS_PROMO_CODE_YES',
    type: 'radio',
    cleanName: 'Ho un codice promo',
    position: 2,
    value: '',
    status: [],
    errorMessage: [],
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    toggleVisibility: {
      show: { fields: ['SIGNALER-PROMO_CODE'] }
    },
    extra: true
  },
  'SIGNALER-HAS_PROMO_CODE_NO': {
    id: 'SIGNALER-HAS_PROMO_CODE_NO',
    name: 'HAS_PROMO_CODE_NO',
    type: 'radio',
    cleanName: 'Non ho un codice promo',
    position: 1,
    value: '',
    status: ['selected'],
    errorMessage: [],
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    toggleVisibility: {
      hide: { fields: ['SIGNALER-PROMO_CODE'] }
    },
    extra: true
  },
  'SIGNALER-PROMO_CODE': {
    id: 'SIGNALER-PROMO_CODE',
    name: 'PROMO_CODE',
    type: 'text',
    cleanName: 'Codice promo',
    position: 3,
    value: '',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: '../api/rest/FREE/promocode/check',
      method: 'GET',
      fields: ['SIGNALER-PROMO_CODE'],
      mapping: {
        'SIGNALER-PROMO_CODE': 'promocode'
      }
    },
    status: ['hidden'],
    errorMessage: [],
    extra: true
  },
  'SIGNALER-REFERRER': {
    id: 'SIGNALER-REFERRER',
    name: 'REFERRER',
    type: 'hidden',
    position: 2,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'SIGNALER-CAMPAIGN_URL': {
    id: 'SIGNALER-CAMPAIGN_URL',
    name: 'CAMPAIGN_URL',
    type: 'hidden',
    position: 3,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-TYPE_VALUE': {
    id: 'VERIFICA_EMAIL_EXTRA-TYPE_VALUE',
    name: 'EMAIL',
    type: 'text',
    cleanName: 'Email',
    position: 1,
    value: '',
    status: [],
    isDisabled: true,
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-OTP_VALUE': {
    id: 'VERIFICA_EMAIL_EXTRA-OTP_VALUE',
    name: 'OTP',
    cleanName: 'Codice di verifica',
    type: 'text',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.otpEmail,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: '../api/rest/FREE/otp/validate',
      fields: ['VERIFICA_EMAIL_EXTRA-REQUEST_ID', 'VERIFICA_EMAIL_EXTRA-TYPE', 'VERIFICA_EMAIL_EXTRA-TYPE_VALUE', 'VERIFICA_EMAIL_EXTRA-OTP_VALUE'],
      mapping: {
        'VERIFICA_EMAIL_EXTRA-REQUEST_ID': 'requestId',
        'VERIFICA_EMAIL_EXTRA-TYPE': 'type',
        'VERIFICA_EMAIL_EXTRA-TYPE_VALUE': 'typeValue',
        'VERIFICA_EMAIL_EXTRA-OTP_VALUE': 'otpValue'
      }
    },
    position: 2,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-LABEL': {
    id: 'VERIFICA_EMAIL_EXTRA-LABEL',
    name: 'LABEL',
    type: 'labelWithLink',
    position: 3,
    link: {
      placeholder: '§link§',
      text: 'Reinvia Otp',
      url: '../api/rest/FREE/otp/send',
      method: 'POST',
      fired: false,
      requestIdComponentId: 'VERIFICA_EMAIL_EXTRA-REQUEST_ID',
      mapping: [{
        key: 'templateId',
        componentId: 'VERIFICA_EMAIL_EXTRA-TEMPLATE_ID'
      }, {
        key: 'type',
        componentId: 'VERIFICA_EMAIL_EXTRA-TYPE'
      }, {
        key: 'typeValue',
        componentId: 'VERIFICA_EMAIL_EXTRA-TYPE_VALUE'
      }]
    },
    value: "Il CODICE DI VERIFICA \xE8 stato inviato\n            automaticamente al tuo indirizzo email, se non dovessi\n            riceverlo entro un minuto puoi richiederne uno nuovo cliccando\n            sul link \xA7link\xA7 o ricaricando la pagina.",
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-TYPE': {
    id: 'VERIFICA_EMAIL_EXTRA-TYPE',
    name: 'OTP_TYPE',
    type: 'hidden',
    position: 3,
    value: 'EMAIL',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-TEMPLATE_ID': {
    id: 'VERIFICA_EMAIL_EXTRA-TEMPLATE_ID',
    name: 'OTP_TEMPLATE',
    type: 'hidden',
    position: 4,
    value: 'TIM_ONBOARD_EMAIL_OTP',
    status: [],
    errorMessage: [],
    extra: true
  },
  'VERIFICA_EMAIL_EXTRA-REQUEST_ID': {
    id: 'VERIFICA_EMAIL_EXTRA-REQUEST_ID',
    name: 'OTP_REQUEST_ID',
    type: 'hidden',
    position: 5,
    value: '',
    status: [],
    errorMessage: [],
    extra: true
  },
  'PARTITA_IVA-NUM_PARTITA_IVA': {
    name: 'NUM_PARTITA_IVA',
    type: 'text',
    cleanName: 'Numero Partita IVA',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphanumeric,
        getErrorMessage: VALIDATION_ERRORS.filled
      }],
      url: 'wgt/validate/piva',
      fields: ['PARTITA_IVA-NUM_PARTITA_IVA'],
      mapping: {
        'PARTITA_IVA-NUM_PARTITA_IVA': 'piva'
      }
    },
    trigger: [{
      componentId: 'CF_AZIENDA-NUM_CF_AZIENDA',
      type: 'copy'
    }],
    status: [],
    errorMessage: []
  },
  'CF_AZIENDA-NUM_CF_AZIENDA': {
    name: 'NUM_CF_AZIENDA',
    type: 'text',
    cleanName: 'Codice Fiscale Società'
  },
  'AZIENDA_ROLES-TIPO_ROLES_LINK_AZIENDA': {
    name: 'TIPO_ROLES_LINK_AZIENDA',
    type: 'selectbox',
    cleanName: 'Scegli tra le cariche disponibili per il tipo di azienda indicato',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    values: []
  },
  //step 3:

  'PEC-CODICE_EMAIL': {
    name: 'CODICE_EMAIL',
    type: 'text'
  },
  'PEC-CONFERMA_EMAIL': {
    name: 'CONFERMA_EMAIL',
    type: 'text'
  },
  'PEC-EMAIL': {
    name: 'EMAIL',
    type: 'text',
    cleanName: 'Indirizzo PEC (Posta Elettronica Certificata)',
    position: 1,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.email,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'PEC-ADDRESS': {
    name: 'ADDRESS',
    type: 'label',
    position: 2,
    value: 'L’indirizzo PEC è importante per la ricezione della comunicazione periodica'
  },
  'TELEFONO_FISSO-PREFISSO': {
    name: 'PREFISSO',
    type: 'hidden',
    value: '39',
    active: true,
    position: 1,
    status: ['readonly']
  },
  'TELEFONO_FISSO-NUMERO': {
    name: 'NUMERO',
    type: 'text',
    position: 3,
    cleanName: 'Numero di telefono aziendale',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.mobileNumber,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_LEGALE-CAP': {
    name: 'CAP',
    type: 'text',
    position: 1,
    cleanName: 'CAP',
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: 'SEDE_LEGALE-CAP'
      },
      /*{
        key: 'stato',
        componentId: 'SEDE_LEGALE-NAZIONE'
      },*/
      {
        key: 'provincia',
        componentId: 'SEDE_LEGALE-PROVINCIA'
      }, {
        key: 'localita',
        componentId: 'SEDE_LEGALE-CITTA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_LEGALE-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    position: 2,
    cleanName: 'Provincia',
    isDisabled: false,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [{
        'SEDE_LEGALE-NAZIONE': {
          fieldName: 'value'
        }
      }]
    },
    notifyComponents: {
      validate: ['SEDE_LEGALE-INDIRIZZO']
    },
    flag: 'static_1'
  },
  'SEDE_LEGALE-CITTA': {
    name: 'CITTA',
    type: 'text',
    cleanName: 'Città',
    position: 3,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_LEGALE-NAZIONE': {
    name: 'NAZIONE',
    type: 'text',
    position: 4,
    cleanName: 'Nazione',
    value: 'ITALIA',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_LEGALE-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    position: 5,
    cleanName: 'Indirizzo e numero civico',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_AMMINISTRATIVA-ALTRO': {
    name: 'ALTRO',
    type: 'radio',
    position: 1,
    cleanName: 'La sede amministrativa NON COINCIDE con la sede legale',
    toggleVisibility: {
      show: {
        fields: ['SEDE_AMMINISTRATIVA-CAP', 'SEDE_AMMINISTRATIVA-CITTA', 'SEDE_AMMINISTRATIVA-INDIRIZZO', 'SEDE_AMMINISTRATIVA-NAZIONE', 'SEDE_AMMINISTRATIVA-PROVINCIA']
      }
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_AMMINISTRATIVA-SEDE_LEGALE': {
    name: 'SEDE_LEGALE',
    type: 'radio',
    position: 1,
    value: 'selected',
    cleanName: 'La sede amministrativa COINCIDE con la sede legale',
    toggleVisibility: {
      hide: {
        fields: ['SEDE_AMMINISTRATIVA-CAP', 'SEDE_AMMINISTRATIVA-CITTA', 'SEDE_AMMINISTRATIVA-INDIRIZZO', 'SEDE_AMMINISTRATIVA-NAZIONE', 'SEDE_AMMINISTRATIVA-PROVINCIA']
      }
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_AMMINISTRATIVA-CAP': {
    name: 'CAP',
    type: 'text',
    cleanName: 'Cap',
    position: 2,
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: 'SEDE_AMMINISTRATIVA-CAP'
      },
      // {
      //   key: 'stato',
      //   componentId: 'RESIDENZA-NAZIONE'
      // },
      {
        key: 'provincia',
        componentId: 'SEDE_AMMINISTRATIVA-PROVINCIA'
      }, {
        key: 'localita',
        componentId: 'SEDE_AMMINISTRATIVA-CITTA'
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_AMMINISTRATIVA-CITTA': {
    name: 'CITTA',
    type: 'text',
    position: 4,
    cleanName: 'Città',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_AMMINISTRATIVA-INDIRIZZO': {
    name: 'INDIRIZZO',
    type: 'text',
    position: 5,
    cleanName: 'Indirizzo',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SEDE_AMMINISTRATIVA-NAZIONE': {
    name: 'NAZIONE',
    type: 'selectbox',
    position: 4,
    cleanName: 'Nazione',
    value: 'ITALIA',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    flag: 'static_1'
  },
  'SEDE_AMMINISTRATIVA-PROVINCIA': {
    name: 'PROVINCIA',
    type: 'selectbox',
    position: 3,
    cleanName: 'Provincia',
    options: {
      url: 'wgt/utils/provincefromegon',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: [{
        'SEDE_AMMINISTRATIVA-NAZIONE': {
          fieldName: 'value'
        }
      }]
    },
    validations: {
      isRequired: true
    },
    flag: 'static_1'
  },
  'CLASSIFICAZIONE_AZIENDA-FATTURATO_ANNUO': {
    name: 'FATTURATO_ANNUO',
    type: 'text',
    numFormat: 'Europian',
    displayType: 'input',
    cleanName: 'Fatturato annuo (in Euro)',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'CLASSIFICAZIONE_AZIENDA-NUMERO_ADDETTI': {
    name: 'NUMERO_ADDETTI',
    type: 'text',
    cleanName: 'N.Addetti',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.number,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO': {
    name: 'RISULTATO_ECONOMICO',
    type: 'text',
    numFormat: 'Europian',
    displayType: 'input',
    cleanName: 'Risultato Economico(perdita/utile)in Euro',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'CLASSIFICAZIONE_AZIENDA-TOT_BILANCIO_ANNUO': {
    name: 'TOT_BILANCIO_ANNUO',
    type: 'text',
    cleanName: 'Totale Bilancio',
    numFormat: 'Europian',
    displayType: 'input',
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  //step 4:
  'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
    name: 'TIPO_SOCIETA',
    type: 'selectbox',
    cleanName: 'Tipo Attività',
    fullWidth: true,
    isDisabled: false,
    position: 1,
    options: {
      url: 'wgt/utils/tiposocieta',
      mapping: { label: 'description', value: 'value' },
      fields: [{
        'SETTORE_ATTIVITA_AZIENDA-TIPO_ID_SOGGETTO': {
          fieldName: 'value'
        }
      }]
    },
    trigger: [{
      componentId: 'SETTORE_ATTIVITA_AZIENDA-SETTORE',
      type: 'fetchOption'
    }],
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
    name: 'SETTORE',
    type: 'selectbox',
    cleanName: 'Settore',
    fullWidth: true,
    position: 2,
    options: {
      url: 'wgt/utils/settoriaziende',
      mapping: { label: 'description', value: 'value' },
      fields: [{
        'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
          fieldName: 'idSocieta'
        },
        'SETTORE_ATTIVITA_AZIENDA-TIPO_ID_SOGGETTO': {
          fieldName: 'idSoggetto'
        }
      }]
    },

    fetch: {
      questionario: {
        url: 'wgt/ar/getQuestionarioPG', //'wgt/acol/get/pg',
        body: {
          contesto: 'ACOLProspect_PG',
          requestType: 'azienda',
          viewMode: false
        },
        fields: [{
          'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
            fieldName: 'tipoSocieta'
          }
        }, {
          'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
            fieldName: 'sae'
          }
        }],
        mappingEvent: 'questionario'
      }
    },
    trigger: [{
      componentId: 'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA',
      type: 'fetchOption'
      /*,{
        componentId: 'AZIENDA_ANTIRICICLAGGIO-QUESTIONARIO',
        type: 'fetch',
        api: 'questionario'
      }*/
    }],
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA': {
    name: 'DETTAGLIO_ATTIVITA_ECONOMICA',
    type: 'selectbox',
    position: 3,
    fullWidth: true,
    /* isDisabled: true, */
    staticDescription: 'Il dato è necessario per finalizzare la compilazione del questionario antiriciclaggio. \nPuoi trovare il codice ATECO della tua attività sulla visura camerale o sul certificato di attribuzione della Partita IVA.',
    cleanName: "Codice ATECO",
    options: {
      init: true, //acolQuestionnaire widget issue - begin - end
      //init: false,
      /* isDisabled: false, */
      url: 'wgt/utils/dettaglioattivitaaziendepersettore', //dettaglioattivitaaziende',
      mapping: { label: 'description', value: 'value' },
      fields: [{
        'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
          fieldName: 'value'
        }
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.filled,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
  },
  'SETTORE_ATTIVITA_AZIENDA-TIPO_ID_SOGGETTO': {
    name: 'TIPO_ID_SOGGETTO',
    type: 'hidden',
    cleanName: ''
  },
  'AZIENDA_ANTIRICICLAGGIO-QUESTIONARIO': {
    name: 'QUESTIONARIO',
    type: 'hidden',
    cleanName: 'Questionario',
    showLoading: true
    /*    fetch: {
      questionario: {
        url: 'wgt/acol/get/pg',
        body: {
          requestType: 'azienda',
          viewMode: false
        },
        fields: [
          {
            'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA': {
              fieldName: 'tipoSocieta'
            }
          },
          {
            'SETTORE_ATTIVITA_AZIENDA-SETTORE': {
              fieldName: 'sae'
            }
          }
        ],
        mappingEvent: 'questionario'
      }
    }*/
  },
  //step 5:

  'TITOLARE_DATA-LABEL': {
    name: 'TITOLARE_DATA-LABEL',
    type: 'label',
    value: 'OLTRE AD ESSERE LEGALE RAPPRESENTANTE, RISULTO ESSERE ANCHE TITOLARE EFFETTIVO DELLA SOCIETÀ<br/>IL TITOLARE EFFETTIVO POSSIEDE ALMENO IL 25% DELLE QUOTE DELLA SOCIETÀ',
    position: 1
  },
  'TITOLARE_DATA-EFFETTIVO_SI': {
    name: 'EFFETTIVO_SI',
    type: 'radio',
    value: '',
    cleanName: 'SI',
    position: 2,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    toggleVisibility: {
      hide: {
        fields: TITOLARE_EFFETTIVO_WIDGETS
      }
    }
  },
  'TITOLARE_DATA-EFFETTIVO_NO': {
    name: 'EFFETTIVO_NO',
    type: 'radio',
    cleanName: 'NO',
    value: '',
    position: 2,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    toggleVisibility: {
      show: {
        fields: TITOLARE_EFFETTIVO_WIDGETS
      }
    }
  },
  'TITOLARE_OWNER-LABEL': {
    name: 'TITOLARE_OWNER-LABEL',
    type: 'label',
    value: 'Ci sono altre persone che possiedono almeno il 25% delle quote della società?',
    position: 1
  },
  'TITOLARE_OWNER-EFFETTIVO_SI': {
    name: 'EFFETTIVO_SI',
    type: 'radio',
    value: 'selected',
    cleanName: 'SI',
    position: 2,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
    // toggleVisibility: {
    //   hide: {
    //     fields: TITOLARE_EFFETTIVO_WIDGETS
    //   }
    // }
  },
  'TITOLARE_OWNER-EFFETTIVO_NO': {
    name: 'EFFETTIVO_NO',
    type: 'radio',
    cleanName: 'NO',
    value: '',
    position: 2,
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.bool,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    }
    // toggleVisibility: {
    //   show: {
    //     fields: TITOLARE_EFFETTIVO_WIDGETS
    //   }
    // }
  },
  // 'TITOLARE_ESERCITA-LABEL': {
  //   name: 'TITOLARE_DATA-LABEL',
  //   type: 'label',
  //   value:
  //     'ESERCITA O HA ESERCITATO UNA IMPORTANTE FUNZIONE PUBBLICA / POLITICA OPPURE INTRATTIENE LEGAMI (DI PARENTELA O DI AFFARI) CON SOGGETTI CHE ESERCITANO O HANNO ESERCITATO UNA IMPORTANTE FUNZIONE PUBBLICA / POLITICA*'
  // },
  // 'TITOLARE_ESERCITA-ESERCITA_SI': {
  //   name: 'ESERCITA_SI',
  //   type: 'radio',
  //   value: 'selected',
  //   cleanName: 'SI',
  //   position: 2,
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   }
  // },
  // 'TITOLARE_ESERCITA-ESERCITA_NO': {
  //   name: 'ESERCITA_NO',
  //   type: 'radio',
  //   cleanName: 'NO',
  //   position: 2,
  //   validations: {
  //     isRequired: true,
  //     default: [
  //       {
  //         validate: VALIDATION_METHODS.bool,
  //         getErrorMessage: VALIDATION_ERRORS.filled
  //       }
  //     ]
  //   }
  // },
  'RESIDENZA-FISCALE': {
    name: 'residenzaFiscale',
    type: 'selectbox',
    active: false,
    value: 'ITALIA',
    cleanName: 'Residenza Fiscale',
    options: {
      url: 'wgt/utils/nazionifromegon',
      mapping: { label: 'nome', value: 'nome' }
    }
  },
  'PRODUCT_PLUGIN-PLUGIN_TEMPLATE': {
    name: 'PLUGIN_TEMPLATE',
    text: 'PUNTO VENDITA',
    type: 'hidden',
    active: false,
    status: ['hidden'],
    trigger: [{
      type: 'call',
      fn: _componentsActions.parsePersonalizzaWidgets,
      params: [{
        type: 'COMPONENT_PROP',
        name: 'rawValue'
      }]
    }]
  },
  'PRODUCT_PLUGIN-PLUGIN_VALIDATION_ERROR': {
    name: 'PLUGIN_VALIDATION_ERROR',
    text: 'PLUGIN_VALIDATION_ERROR',
    type: 'hidden',
    active: false,
    status: ['hidden']
  },

  'AZIENDA_SUBTYPE-FORMA_GIURIDIA': {
    name: 'FORMA_GIURIDIA',
    type: 'label',
    value: "<small><p>Societ\xE0 <b>finanziarie:</b> svolgono attivit\xE0 di concessione di crediti e microcrediti, concessione di finanziamenti, credito al consumo e credito ipotecario, l\u2019emissione o gestione di carte di credito, di debito o di altri mezzi di pagamento etc\u2026\n      </p>\n      <p>Societ\xE0 <b>non finanziarie:</b>  tutte le societ\xE0 di capitali, le societ\xE0 cooperative e le societ\xE0 di persone, le societ\xE0 semplici e le imprese individuali con oltre 5 dipendenti.\n      </p></small>",

    rawValue: null,
    errorMessage: [],
    validations: [],
    status: [],
    extra: true,
    values: [],
    isSmall: true,
    active: true
  },
  'AZIENDA_SUBTYPE-ENTE_PRIVATO': {
    name: 'ENTE_PRIVATO',
    type: 'label',
    value: "\n      <small>\n      <p>IMPORTANTE:</p>\n      <p>POS Easy \xE8 richiedibile per le sole associazioni con codice SAE 500/501\n      </p>\n      <p>Per associazioni con pi\xF9 di 5 titolari effettivi o societ\xE0 con legali rappresentanti con poteri di firma congiunta, le richieste non sono sottoscrivibili tramite canale online. Verifica nella live chat i passaggi da seguire.\n      </p></small>",

    rawValue: null,
    errorMessage: [],
    validations: [],
    status: ['hidden'],
    extra: true,
    values: [],
    isSmall: true,
    active: true
  },
  'AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA': {
    name: 'SOCIETA_COOPERATIVA',
    type: 'label',
    value: "\n      <small>\n      <p>IMPORTANTE:</p>\n      <p>Per societ\xE0 con pi\xF9 di 5 titolari effettivi o con legali rappresentanti con poteri di firma congiunta, le richieste non sono sottoscrivibili tramite canale online. Verifica nella live chat i passaggi da seguire.\n      </p></small>",

    rawValue: null,
    errorMessage: [],
    validations: [],
    status: ['hidden'],
    extra: true,
    values: [],
    isSmall: true,
    active: true
  },
  'AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE': {
    name: 'SOCIETA_DI_PERSONE_CAPITALE',
    type: 'label',
    value: "\n      <small>\n      <p>IMPORTANTE:</p>\n      <p>Per societ\xE0 con pi\xF9 di 5 titolari effettivi o con legali rappresentanti con poteri di firma congiunta, le richieste non sono sottoscrivibili tramite canale online. Verifica nella live chat i passaggi da seguire.\n      </p></small>",

    rawValue: null,
    errorMessage: [],
    validations: [],
    status: ['hidden'],
    extra: true,
    values: [],
    isSmall: true,
    active: true
  },
  'TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA': {
    name: 'TITOLARE_EFFETTIVO_DATA',
    value: '',
    active: false,
    status: [],
    errorMessage: [],
    validations: []
  }
};

var getAddressStateComponents = exports.getAddressStateComponents = function getAddressStateComponents() {
  var widgetName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'RESIDENZA';
  var addressId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var components = {};
  var NAZIONE = widgetName + "-NAZIONE";
  var CAP = widgetName + "-CAP";
  var PROVINCIA = widgetName + "-PROVINCIA";
  var CITTA = widgetName + "-CITTA";
  var INDIRIZZO = widgetName + "-INDIRIZZO";
  components[NAZIONE] = {
    name: 'NAZIONE',
    type: 'text',
    isDisabled: true,
    value: 'ITALIA',
    cleanName: 'Nazione',
    addressId: addressId
    // type: 'selectbox',
    // cleanName: 'Nazione',
    // isDisabled: true,
    // position: 1,
    // options: {
    //   url: 'wgt/utils/nazionifromegon',
    //   mapping: { label: 'nome', value: 'nome' }
    // }
  };
  components[CAP] = {
    name: 'CAP',
    type: 'text',
    cleanName: 'CAP',
    autofill: {
      url: 'wgt/utils/dettaglicapfromegon',
      errorMessage: 'il CAP non è valido',
      mapping: [{
        key: 'capCode',
        componentId: CAP
      }, {
        key: 'provincia',
        componentId: PROVINCIA
      }, {
        key: 'localita',
        componentId: CITTA
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.cap,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    addressId: addressId
  };
  components[PROVINCIA] = {
    name: 'PROVINCIA',
    type: 'selectbox',
    cleanName: 'Provincia',
    isDisabled: true,
    options: {
      url: 'wgt/utils/province/VALID',
      mapping: { label: 'sigla', value: 'sigla' },
      fields: []
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.alphabetic,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: [INDIRIZZO]
    },
    addressId: addressId
  };
  var field = {};
  field[NAZIONE] = {
    fieldName: 'nome'
  };
  components[PROVINCIA].options.fields.push(field);

  components[CITTA] = {
    name: 'CITTA',
    type: 'text',
    isDisabled: true,
    cleanName: 'Città',
    options: {
      // url: 'wgt/utils/comunifromegon',
      mapping: { label: 'localita', value: 'localita' },
      fields: []
    },
    autofill: {
      mapping: [{
        key: 'localita',
        resKey: 'provincia',
        componentId: PROVINCIA
      }]
    },
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.city,
        getErrorMessage: VALIDATION_ERRORS.filled
      }]
    },
    notifyComponents: {
      validate: [INDIRIZZO]
    },
    addressId: addressId
  };
  field = {};
  field[PROVINCIA] = {
    fieldName: 'provincia'
  };
  components[CITTA].options.fields.push(field);

  components[INDIRIZZO] = {
    name: 'INDIRIZZO',
    type: 'text',
    cleanName: 'Indirizzo e numero civico',
    modalTitle: "Verifica l'indirizzo di residenza",
    validations: {
      isRequired: true,
      default: [{
        validate: VALIDATION_METHODS.address,
        getErrorMessage: VALIDATION_ERRORS.address
      }]
    },
    hint: {
      value: HINTS.address,
      visible: false
    },
    addressId: addressId
  };
  return components;
};

var RefIdMap = exports.RefIdMap = {};
var LinkIdMap = exports.LinkIdMap = {};

var getResumeByOtpMock = exports.getResumeByOtpMock = function getResumeByOtpMock(body, guid) {
  return {
    status: 'success',
    message: 'The request is successfully served.',
    step: {
      number: null,
      last: false,
      contactId: null,
      name: 'resume-otp',
      widgets: [{
        code: '-223',
        name: 'LABEL',
        bundleLink: null,
        bundleCode: null,
        position: null,
        components: [{
          name: 'LABEL',
          value: 'ACCEDI ALLA TUA RICHIESTA',
          active: true,
          status: [],
          errorMessage: [],
          validations: [],
          values: [],
          type: null
        }, {
          name: 'SUB_LABEL',
          value: "Richiedi l'invio del codice che ricevi via SMS per accedere e visualizzare la richiesta.",
          active: true,
          status: [],
          errorMessage: [],
          validations: [],
          values: [],
          type: null
        }],
        status: [],
        errorMessage: []
      }, {
        code: '-224',
        name: 'RESUME_BY_CELL',
        bundleLink: null,
        bundleCode: null,
        position: null,
        components: [{
          name: 'PREF_CELLULARE',
          value: '+39',
          active: true,
          status: ['readonly'],
          errorMessage: [],
          validations: ['number'],
          values: [],
          type: null
        }, {
          name: 'NUM_CELLULARE',
          value: body.numCell,
          active: true,
          status: ['readonly'],
          errorMessage: [],
          validations: ['number'],
          values: [],
          type: null
        }, {
          name: 'CODICE_CELLULARE',
          value: '',
          active: true,
          status: [],
          errorMessage: [],
          validations: ['alphanumeric'],
          values: [],
          type: null
        }, {
          name: 'GUID_PROCESSO',
          value: guid,
          active: true,
          status: ['readonly'],
          errorMessage: [],
          validations: [],
          values: [],
          type: null
        }],
        status: [],
        errorMessage: []
      }]
    }
  };
};

var getThankYouPageMock = exports.getThankYouPageMock = function getThankYouPageMock(contactId, parentGuid) {
  return {
    status: 'success',
    message: 'The request is successfully served.',
    step: {
      number: 6,
      last: true,
      name: 'thanks',
      contactId: contactId,
      widgets: [{
        code: '1337',
        name: 'THANKS',
        bundleLink: null,
        bundleCode: null,
        position: null,
        components: [{
          name: 'LABEL',
          value: 'Thanks',
          active: true,
          status: [],
          errorMessage: [],
          validations: [],
          values: [],
          type: 'hidden'
        }, !!parentGuid && {
          name: 'RESUME_INTEST_2',
          value: parentGuid,
          active: true,
          status: [],
          errorMessage: [],
          validations: [],
          values: [],
          type: 'hidden'
        }],
        status: [],
        errorMessage: []
      }]
    }
  };
};

var getReuploadDocumentsMock = exports.getReuploadDocumentsMock = function getReuploadDocumentsMock(docType, showSelfie) {
  var mock = {
    status: 'success',
    message: 'Next step successfully retreived',
    step: {
      number: null,
      last: false,
      contactId: 'null',
      name: 'reupload',
      widgets: [{
        code: '1934',
        name: 'DOCUMENTO',
        bundleLink: null,
        bundleCode: null,
        position: 2,
        components: [{
          name: 'TIPO_DOCUMENTO',
          value: docType,
          active: true,
          status: ['hidden'],
          errorMessage: [],
          validations: ['required'],
          values: [],
          type: 'selectbox'
        }, {
          name: 'DOCF_UPLOAD',
          value: '',
          active: true,
          status: [],
          errorMessage: [],
          validations: ['required'],
          values: [],
          type: null
        }, {
          name: 'DOCR_UPLOAD',
          value: '',
          active: true,
          status: [],
          errorMessage: [],
          validations: ['required'],
          values: [],
          type: null
        }],
        status: [],
        errorMessage: []
      }, {
        code: '1937',
        name: 'ATTESA',
        bundleLink: null,
        bundleCode: null,
        position: 5,
        components: [],
        status: ['hidden'],
        errorMessage: []
      }]
    }
  };

  if (showSelfie) {
    var selfieWidget = {
      code: '1370',
      name: 'SELFIE',
      bundleLink: null,
      bundleCode: null,
      position: 1,
      components: [{
        name: 'SELFIE_UPLOAD',
        value: '',
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: null
      }],
      status: [],
      errorMessage: []
    };

    mock.step.widgets.unshift(selfieWidget);
  }

  return mock;
};
//export const TITOLARE_LIST = []
var savePG = exports.savePG = {};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.5';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(305)(module)))

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1070), __esModule: true };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = function Page(props) {
  return _react2.default.createElement(
    'div',
    (0, _withStyles.css)(props.styles.page),
    props.children
  );
};

Page.propTypes = {
  children: _propTypes.PropTypes.node,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Page);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1121);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
  return _react2.default.createElement(
    "header",
    (0, _withStyles.css)(props.styles.header, !!props.centeredLogo && props.styles["header--centered"], !!props.whiteLabel && props.styles["header--whitelabel"]),
    _react2.default.createElement(
      "div",
      (0, _withStyles.css)(props.styles.logo, !!props.centeredLogo && props.styles["logo--centered"], !!props.whiteLabel && props.styles["logo--whitelabel"]),
      _react2.default.createElement("div", (0, _withStyles.css)(props.styles["logo-img"]))
    ),
    _react2.default.createElement(
      "div",
      (0, _withStyles.css)(props.styles.children, !!props.whiteLabel && props.styles["children--whitelabel"]),
      props.children
    )
  );
};

Header.propTypes = {
  children: _propTypes.PropTypes.node,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Header);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1122);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function Wrapper(props) {
  return _react2.default.createElement(
    'div',
    (0, _withStyles.css)(props.styles.wrapper
    //,(!!props.children && !! !!props.children[0].props.widgets && !!props.children[0].props.widgets["ATTIVA_REVOCA_FIRMA"])? '':''
    ),
    props.children
  );
};

Wrapper.propTypes = {
  children: _propTypes.PropTypes.node,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Wrapper);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1124);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderRequestNumber = function renderRequestNumber(contactId, styles) {
  if (contactId) {
    return _react2.default.createElement(
      'p',
      (0, _withStyles.css)(styles['contact-id']),
      'Richiesta numero ' + contactId
    );
  }
};

var renderSubtitle = function renderSubtitle(subtitle, styles) {
  if (subtitle) {
    return _react2.default.createElement(
      'h2',
      (0, _withStyles.css)(styles.subtitle),
      subtitle
    );
  }
};

var Title = function Title(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h1',
      (0, _withStyles.css)(props.styles.title),
      props.isLastStep ? 'Accetta i contratti' : props.title,
      renderRequestNumber(props.contactId, props.styles)
    ),
    renderSubtitle(props.subtitle, props.styles)
  );
};

Title.propTypes = {
  title: _propTypes.PropTypes.string.isRequired,
  contactId: _propTypes.PropTypes.string,
  subtitle: _propTypes.PropTypes.string,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Title);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _stepActions = __webpack_require__(28);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1174);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer(props) {
    (0, _classCallCheck3.default)(this, Footer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).call(this, props));

    _this.onButtonClick = function () {
      // using Java Script method to get PDF file
      fetch("../../assets/files/2025_Accessibility.pdf").then(function (response) {
        response.blob().then(function (blob) {

          // Creating new object of PDF file
          var fileURL = window.URL.createObjectURL(blob);

          // Setting various property values
          var alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "2025_Accessibility.pdf";
          alink.click();
        });
      });
    };

    return _this;
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          styles = _props.styles,
          StepNumber = _props.StepNumber,
          plan = _props.plan,
          dispatch = _props.dispatch;

      return _react2.default.createElement(
        'footer',
        (0, _extends3.default)({ id: 'footer' }, (0, _withStyles.css)(styles.footer)),
        _react2.default.createElement(
          'div',
          (0, _withStyles.css)(styles.MainContainer),
          _react2.default.createElement(
            'div',
            (0, _withStyles.css)(styles.leftAlign),
            _react2.default.createElement(
              'div',
              (0, _withStyles.css)(styles.centerAlign),
              _react2.default.createElement(
                'div',
                (0, _withStyles.css)(styles.links),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(styles.textualLinks),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'a',
                      (0, _extends3.default)({}, (0, _withStyles.css)(styles.privacyPolicy), { href: 'https://www.fabrick.com/it-it/privacy/privacy-policy-clienti/', target: '_blank' }),
                      'PrivacyPolicy'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'a',
                      (0, _extends3.default)({}, (0, _withStyles.css)(styles.privacyPolicy), { href: 'https://www.axerve.com/cookie-policy', target: '_blank' }),
                      'Privacy e Cookie Policy'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'a',
                      (0, _extends3.default)({}, (0, _withStyles.css)(styles.privacyPolicy), { onClick: this.onButtonClick }),
                      'Dichiarazione di accessibilit\xE0'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            '\xA9 2017 - 2025 Fabrick S.p.A. - Piazza Gaudenzio Sella 1, 13900 Biella - Appartenente al Gruppo IVA Maurizio Sella S.a.a. - Partita IVA 02675650028 - Codice Fiscale 02654890025'
          )
        )
      );
    }
  }]);
  return Footer;
}(_react.Component);
/* import { getLinkFoglioInformativo } from '../../utils' */
/* import { open as openChatbot } from '../../state/actions/chatbotActions' */
/* import Link from '../link' */


Footer.propTypes = {
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  var routing = state.routing;

  return { routing: routing };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Footer));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var colors = _ref.colors,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes;

  var styles = {
    globals: {
      // inputs
      '*input': {
        fontSize: fontSizes.big,

        cursor: 'auto',

        color: colors.input.text.default,
        backgroundColor: colors.input.bg.default,

        appearence: 'textfield',
        // Default placeholder color
        '::placeholder': {
          color: colors.input.placeholder.default
        }
      },

      '*select': {
        lineHeight: '1.5rem',

        padding: '1.5rem .625rem .625rem',

        backgroundClip: 'padding-box',

        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        appearance: 'none',

        '::-ms-expand': {
          display: 'none'
        }
      },
      // links
      '*a': {
        display: 'inline-block',

        transition: 'all 100ms',
        textDecoration: 'none',

        color: colors.link.text.default,

        ':hover': {
          color: colors.link.text.hover
        },
        ':focus': {
          color: colors.link.text.hover
        }
      },
      // pages
      // Metro mode compatibility.
      '*@-ms-viewport': {
        width: 'device-width'
      },

      '**': {
        boxSizing: 'border-box'
      },

      '*html': {
        fontSize: '100%',

        color: colors.common.html.text.default,
        backgroundColor: colors.common.html.bg.default
      },

      '*body': {
        fontFamily: fontFamilies.default,
        fontWeight: fontWeights.body.default,
        margin: '0',
        padding: '0',

        backgroundColor: colors.common.body.bg.default,

        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '-webkit-tap-highlight-color': colors.common.tap.default
      },

      '*::selection': {
        color: colors.common.selection.text.default,
        backgroundColor: colors.common.selection.bg.default,
        'text-shadow': 'none'
      },
      '*::-moz-selection': {
        color: colors.common.selection.text.default,
        backgroundColor: colors.common.selection.bg.default,
        'text-shadow': 'none'
      },
      // separator
      '*hr': {
        display: 'block',

        width: '100%',
        height: '1px',

        border: '0',
        backgroundColor: colors.common.separator
      },
      // typography
      '*h1': {
        textAlign: 'center',

        fontSize: '1.5rem',

        marginBottom: '10px',

        color: colors.common.headings.h1
      },

      '*h2': {
        textAlign: 'center',

        fontSize: '1rem',
        'font-style': 'normal',

        color: colors.common.headings.h2
      },

      '*h3': {
        textAlign: 'center',

        fontSize: '1.2rem'
      },

      '*h4': {
        textAlign: 'center',
        fontSize: '1rem',
        marginTop: '3rem',
        marginBottom: 'auto'
      },

      '*h5': {
        textAlign: 'center',

        fontSize: '2vmax'
      },

      '*h6': {
        textAlign: 'center',

        fontSize: '1.6vmax'
      },

      '*p': {
        fontSize: '1rem',
        lineHeight: '1.5rem',

        color: colors.common.paragraph.default
      },

      '*b': {
        fontWeight: fontWeights.b.default
      }
    }
  };

  return styles;
};

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(66);
var call = __webpack_require__(512);
var isArrayIter = __webpack_require__(513);
var anObject = __webpack_require__(61);
var toLength = __webpack_require__(162);
var getIterFn = __webpack_require__(258);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateWidget = exports.updateAllWidgets = exports.UPDATE_ALL_WIDGETS = exports.SIDE_UPDATE_WIDGET = exports.UPDATE_WIDGET = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Actions you can make on widgets
 * @module  {Actions} widgetActions
 */
var UPDATE_WIDGET = exports.UPDATE_WIDGET = '@@widgets/UPDATE';
var SIDE_UPDATE_WIDGET = exports.SIDE_UPDATE_WIDGET = '@@widgets/SIDE_UPDATE';
var UPDATE_ALL_WIDGETS = exports.UPDATE_ALL_WIDGETS = '@@widgets/UPDATE_ALL';

/**
 * Updates all the widgets
 *
 * @param {Object} widgets      The updated widgets
 * @return {Function}           Dispatches an UPDATE_ALL_WIDGETS action
 */
var updateAllWidgets = exports.updateAllWidgets = function updateAllWidgets(widgets) {
  return {
    type: UPDATE_ALL_WIDGETS,
    widgets: widgets
  };
};

/**
 * Modifies the widgets with the updated values
 *
 * @param {string} widgetName     The name of the widget to update
 * @param {Object} updateBody     An object containing the properties and values to assign to the widget
 * @param {Object} options        Update options
 * @param {Boolean} collateral    Collateral update flag
 * @return {Function}             Dispatches an update widget action
 */
var updateWidget = exports.updateWidget = function updateWidget(widgetName, updateBody) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      collateral = _ref.collateral;

  return function (dispatch, getState) {
    var _getState = getState(),
        widgets = _getState.widgets;

    return dispatch({
      type: !collateral ? UPDATE_WIDGET : SIDE_UPDATE_WIDGET,
      widget: (0, _extends3.default)({}, widgets[widgetName], updateBody)
    });
  };
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1154);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(props) {
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      id: 'spinner'
    }, (0, _withStyles.css)(props.styles.spinner, props.styles['spinner--' + props.type])),
    _react2.default.createElement('div', (0, _withStyles.css)(props.styles['spinner-dots']
    /*props.type === 'local' && props.styles['spinner-dots--local']*/
    ))
  );
};

Spinner.propTypes = {
  type: _propTypes.PropTypes.oneOf(['global', 'step', 'local']).isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Spinner);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1176);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTitle = function getTitle(title, type) {
  if (!!title) {
    return title;
  } else {
    switch (type) {
      case 'error':
        return 'Accidenti';
      case 'warning':
        return 'Attenzione';
      case 'success':
        return 'Benissimo';
      case 'info':
        return 'Info';
    }
  }
};

var Result = function Result(props) {
  return _react2.default.createElement(
    'div',
    (0, _withStyles.css)(props.styles.result, props.styles['result--' + props.type]),
    _react2.default.createElement(
      'span',
      (0, _withStyles.css)(props.styles.title),
      getTitle(props.title, props.type)
    ),
    _react2.default.createElement(
      'div',
      (0, _withStyles.css)(props.styles.message),
      props.children
    )
  );
};

Result.propTypes = {
  type: _propTypes.PropTypes.string.isRequired,
  title: _propTypes.PropTypes.string,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Result);

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1079), __esModule: true };

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = __webpack_require__(96);

var _utils = __webpack_require__(12);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _checkbox = __webpack_require__(1125);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _textbox = __webpack_require__(266);

var _textbox2 = _interopRequireDefault(_textbox);

var _label = __webpack_require__(1130);

var _label2 = _interopRequireDefault(_label);

var _labelWithLink = __webpack_require__(531);

var _labelWithLink2 = _interopRequireDefault(_labelWithLink);

var _link = __webpack_require__(265);

var _link2 = _interopRequireDefault(_link);

var _image = __webpack_require__(1132);

var _image2 = _interopRequireDefault(_image);

var _select = __webpack_require__(1134);

var _select2 = _interopRequireDefault(_select);

var _countryCode = __webpack_require__(1136);

var _countryCode2 = _interopRequireDefault(_countryCode);

var _tariffe = __webpack_require__(1141);

var _tariffe2 = _interopRequireDefault(_tariffe);

var _selectsearch = __webpack_require__(1143);

var _selectsearch2 = _interopRequireDefault(_selectsearch);

var _multiselect = __webpack_require__(1147);

var _multiselect2 = _interopRequireDefault(_multiselect);

var _radio = __webpack_require__(1151);

var _radio2 = _interopRequireDefault(_radio);

var _file = __webpack_require__(1153);

var _file2 = _interopRequireDefault(_file);

var _datepicker = __webpack_require__(1156);

var _datepicker2 = _interopRequireDefault(_datepicker);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _textArea = __webpack_require__(1160);

var _textArea2 = _interopRequireDefault(_textArea);

var _iframe = __webpack_require__(1162);

var _iframe2 = _interopRequireDefault(_iframe);

var _attivaButton = __webpack_require__(1164);

var _attivaButton2 = _interopRequireDefault(_attivaButton);

var _alertModal = __webpack_require__(1165);

var _alertModal2 = _interopRequireDefault(_alertModal);

var _mobileWithOTPButton = __webpack_require__(1167);

var _mobileWithOTPButton2 = _interopRequireDefault(_mobileWithOTPButton);

var _api = __webpack_require__(45);

var _privacyfabrick = __webpack_require__(1169);

var _privacyfabrick2 = _interopRequireDefault(_privacyfabrick);

var _stateExtension = __webpack_require__(95);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1173);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Button from '../button'
var Widgets = function (_Component) {
  (0, _inherits3.default)(Widgets, _Component);

  function Widgets(props) {
    (0, _classCallCheck3.default)(this, Widgets);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Widgets.__proto__ || (0, _getPrototypeOf2.default)(Widgets)).call(this, props));

    _this.state = {
      plan: ''
    };
    return _this;
  }

  (0, _createClass3.default)(Widgets, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch,
          guid = _props.guid;

      var url = 'OnboardRequestDetails/FetchPOSPlan';
      var body = { GUID: guid };
      (0, _api.FetchPOSPlan)(url, body).then(function (json) {
        var dbplan = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toUpperCase();
        var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
        var plan = planMap[dbplan] || 'flat';
        _this2.setState({ plan: plan });
      });
    }
  }, {
    key: 'makeStatusAsHidden',
    value: function makeStatusAsHidden(component) {
      if (component && component.status) {
        component.status.splice(0, component.status.length);
        component.status.push('hidden');
      }
    }
  }, {
    key: 'renderComponents',
    value: function renderComponents(widget, allComponents) {
      var _this3 = this;

      // When Cittadinanza != Italy in step 1, remove the radio buttons of PERMESSO_SOGGIORNO in step 2
      var permessoSoggiorno = allComponents['DOCUMENTO_2-PERMESSO_SOGGIORNO'];
      if (permessoSoggiorno && permessoSoggiorno.status && permessoSoggiorno.status.indexOf('hidden') < 0) {
        this.makeStatusAsHidden(allComponents['DOCUMENTO_2-BUSTA_PAGA']);
        this.makeStatusAsHidden(allComponents['DOCUMENTO_2-PASSAPORTO']);
        this.makeStatusAsHidden(allComponents['DOCUMENTO_2-TESSERA_SANITARIA']);
        this.makeStatusAsHidden(allComponents['DOCUMENTO_2-PATENTE']);
        this.makeStatusAsHidden(allComponents['DOCUMENTO_2-CARTA_IDENTITA']);
      }

      var widgetComponents = widget.components.map(function (id) {
        return allComponents[id];
      });

      return (0, _lodash.orderBy)(widgetComponents, 'position').map(function (c) {
        if (!!c && c.type !== null && !(!c.status || !(c.status.indexOf('hidden') < 0))) {
          switch (c.type) {
            case 'text':
              return c.id === 'CELLULARE-NUM_CELLULARE' ? _react2.default.createElement(_mobileWithOTPButton2.default, { key: c.name, widget: widget, component: c }) : _react2.default.createElement(_textbox2.default, { key: c.name, widget: widget, component: c });
            case 'TextArea':
              return _react2.default.createElement(_textArea2.default, { key: c.name, widget: widget, component: c });
            case 'label':
              return c.value ? _react2.default.createElement(_label2.default, { key: c.name, widget: widget, component: c }) : c.id === 'S1-S1S4D7' ? _react2.default.createElement(_label2.default, { key: c.name, widget: widget, component: c }) : '';
            /* case 'primary':
            case 'inverse':
            case 'primary-inverse':
            case 'success': {
              return <Button key={c.name} widget={widget} text={c.value} {...c} />
            } */
            case 'inverse':
            case 'sella':
            case 'active':
              {
                return _react2.default.createElement(_attivaButton2.default, { key: c.name, widget: widget, component: c });
              }
            case 'labelWithLink':
              return c.value ? _react2.default.createElement(_labelWithLink2.default, { key: c.name, widget: widget, component: c, plan: _this3.props.plan }) : '';

            case 'link':
              return c.value ? _react2.default.createElement(_link2.default, { key: c.name, widget: widget, component: c }) : '';

            case 'image':
              return _react2.default.createElement(_image2.default, { key: c.name, widget: widget, component: c });

            case 'checkbox':
              return _react2.default.createElement(_checkbox2.default, { key: c.name, widget: widget, component: c });

            case 'selectbox':
              if (c.fieldId === 'S1S6D2' || c.id === 'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA') {
                return _react2.default.createElement(_selectsearch2.default, { key: c.name, widget: widget, component: c });
              } else if (_stateExtension.MultiSelectComponents.indexOf(c.id) > -1) {
                var componentValues = [];
                componentValues = !!c.value && c.value !== '' ? c.value : [];
                return _react2.default.createElement(_multiselect2.default, { key: c.name, widget: widget, component: c, setSelectedOptions: componentValues });
              } else if (c.id === 'CELLULARE-PREF_CELLULARE' || c.id === 'S2-S2S7D10') {
                return _react2.default.createElement(_countryCode2.default, { key: c.name, widget: widget, component: c });
              } else if (c.id === 'S16-S16S1D1') {
                return _react2.default.createElement(_tariffe2.default, { key: c.name, widget: widget, component: c });
              } else {
                return _react2.default.createElement(_select2.default, { key: c.name, widget: widget, component: c });
              }

            case 'DropDownSearch':
              return _react2.default.createElement(_selectsearch2.default, { key: c.name, widget: widget, component: c });

            case 'radio':
              if (c.id === 'DOCUMENTO_2-TESSERA_SANITARIA') {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(_radio2.default, { key: c.name, widget: widget, component: c }),
                  _react2.default.createElement('br', null)
                );
              } else return _react2.default.createElement(_radio2.default, { key: c.name, widget: widget, component: c });

            case 'file':
              return _react2.default.createElement(_file2.default, {
                key: c.name,
                widget: widget,
                component: c,
                components: _this3.props.components
              });

            case 'date':
              return _react2.default.createElement(_datepicker2.default, { key: c.name, widget: widget, component: c });
            case 'spacer':
              return _react2.default.createElement('div', { key: c.name });
            case 'iframe':
              return _react2.default.createElement(_iframe2.default, { key: c.id, name: c.name, widget: widget, component: c });
            case 'alert':
              return _react2.default.createElement(_alertModal2.default, { title: c.title, content: c.value, component: c });
            case 'privacyfabrick':
              return _react2.default.createElement(_privacyfabrick2.default, { widget: widget, component: c });
          }
        }
      });
    }
  }, {
    key: 'renderWidgets',
    value: function renderWidgets() {
      var _this4 = this;

      var plan = this.state.plan;


      var groupedWidgets = (0, _lodash.groupBy)((0, _utils.filterObject)(this.props.widgets, function (w) {
        return w.status.indexOf('hidden') < 0 && w.status.indexOf('ignoreValidation') < 0 && (Number(w.code) > 0 || _stateExtension.VALIDATION_PATTERNS.alphanumeric.test(w.code) || _this4.props.renderNegatives);
      }), 'group');

      /**
       * The grouped widgets index
       * @type {Array}
       * @hack needed to place on top the signaler widget
       */
      var groupKeys = (0, _keys2.default)(groupedWidgets);
      var wynIndex = groupKeys.indexOf('WHAT_YOU_NEED');
      if (wynIndex > -1) {
        groupKeys.splice(wynIndex, 1);
        groupKeys.splice(0, 0, 'WHAT_YOU_NEED');
      }
      var signalerIndex = groupKeys.indexOf('SIGNALER');
      if (signalerIndex > -1) {
        groupKeys.splice(signalerIndex, 1);
        groupKeys.splice(groupKeys.length - 1, 0, 'SIGNALER');
      }

      return groupKeys.map(function (group /*, index*/) {
        // @hack I know that the second condition is awful but i couldn't do any better, YOLO
        if (group === 'undefined' || group === 'RIF_SPEDIZIONE_CARTA' && !!_this4.props.widgets.RIF_SPEDIZIONE_CARTA && !!_this4.props.widgets.JOLLY && _this4.props.widgets.JOLLY.status.indexOf('hidden') < 0) return;
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ key: group }, (0, _withStyles.css)(_this4.props.styles['widget-group'], group === 'SZ0025' || group === 'PRIVACY' && _this4.props.styles['widget-group__margin-min-bottom'])),
          group === "DATI_SENSIBILI" && groupedWidgets[group][0].groupTitle === 'Privacy' && _react2.default.createElement(
            'h4',
            (0, _extends3.default)({
              key: group + '-title'
            }, (0, _withStyles.css)(_this4.props.styles['widget-group__maintitle'])),
            'Privacy del contratto acquirer Banca Sella'
          ),
          (groupedWidgets[group][0].groupTitle !== 'CONVENZIONE' || plan === 'flat' || plan === 'flatCRS') && _react2.default.createElement(
            'h4',
            (0, _extends3.default)({
              key: group + '-title'
            }, (0, _withStyles.css)(_this4.props.styles['widget-group__title'])),
            groupedWidgets[group][0].groupTitle === "PRIVACY CONTRATTO AXERVE PER NOLEGGIO POS" ? "PRIVACY CONTRATTO DI ACQUIRING BANCA SELLA" : groupedWidgets[group][0].groupTitle
          ),
          _react2.default.createElement(
            'div',
            (0, _extends3.default)({
              key: group + '-inputs'
            }, (0, _withStyles.css)(_this4.props.styles['widget-group__inputs'], groupedWidgets[group].filter(function (w) {
              return w.status.indexOf('error') > -1 && !w.quiet;
            }).length > 0 ? _this4.props.styles['widget-group__inputs--invalid'] : null)),
            groupedWidgets[group].map(function (w) {
              return _this4.renderComponents(w, _this4.props.components);
            })
          ),
          _react2.default.createElement(_clearfix2.default, { key: group + '-clearfix' }),
          _react2.default.createElement(
            'small',
            (0, _extends3.default)({
              key: group + '-errors'
            }, (0, _withStyles.css)(_this4.props.styles['widget-group__error-msg'])),
            groupedWidgets[group].map(function (w) {
              return !w.quiet ? w.errorMessage : '';
            })
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderWidgets()
      );
    }
  }]);
  return Widgets;
}(_react.Component);

Widgets.propTypes = {
  components: _propTypes.PropTypes.object.isRequired,
  widgets: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  var components = state.components;

  return { components: components };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Widgets));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _stepActions = __webpack_require__(28);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1175);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function Modal(props) {
  var handleClick = function handleClick() /*e*/{
    var dispatch = props.dispatch;

    dispatch((0, _stepActions.hideModal)());
  };

  return _react2.default.createElement(
    'div',
    (0, _withStyles.css)(props.styles.modal, !!props.hidden && props.styles['modal--hidden']),
    _react2.default.createElement('div', (0, _withStyles.css)(props.styles.bg)),
    _react2.default.createElement('div', (0, _extends3.default)({}, (0, _withStyles.css)(props.styles.closeBtn), {
      onClick: function onClick(event) {
        return handleClick(event);
      }
    })),
    _react2.default.createElement(
      'div',
      (0, _withStyles.css)(props.styles.wrapper),
      _react2.default.createElement(
        'div',
        (0, _withStyles.css)(props.styles.content),
        props.children
      )
    )
  );
};

Modal.propTypes = {
  children: _propTypes.PropTypes.node,
  content: _propTypes.PropTypes.string,
  hidden: _propTypes.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state) {
  var step = state.step;

  return { step: step };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Modal));

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(128);
var TAG = __webpack_require__(34)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(256);
var ITERATOR = __webpack_require__(34)('iterator');
var Iterators = __webpack_require__(130);
module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(126);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(72);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1068), __esModule: true };

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1082), __esModule: true };

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1091), __esModule: true };

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1126);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(props) {
  var newStyles = (0, _extends3.default)({
    parent: props.parentStyles || {}
  }, props.styles);

  return _react2.default.createElement(
    'a',
    (0, _extends3.default)({}, (0, _withStyles.css)(newStyles.link, newStyles.parent), {
      href: props.href,
      onClick: props.onClick,
      target: props.target,
      title: props.title
    }),
    props.children
  );
};

Link.propTypes = {
  href: _propTypes.PropTypes.string,
  onClick: _propTypes.PropTypes.func,
  target: _propTypes.PropTypes.string,
  title: _propTypes.PropTypes.string,
  styles: _propTypes.PropTypes.object.isRequired,
  parentStyles: _propTypes.PropTypes.object
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Link);

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _api = __webpack_require__(45);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1129);

var _styles2 = _interopRequireDefault(_styles);

var _reactNumberFormat = __webpack_require__(474);

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Textbox = function (_Component) {
  (0, _inherits3.default)(Textbox, _Component);

  function Textbox(props) {
    (0, _classCallCheck3.default)(this, Textbox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Textbox.__proto__ || (0, _getPrototypeOf2.default)(Textbox)).call(this, props));

    _moment2.default.locale('it');

    _this.state = {
      value: props.component.value || ''
    };
    return _this;
  }

  (0, _createClass3.default)(Textbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!!this.props.component.value && this.props.component.hasOwnProperty('validations') && this.props.component.validations.hasOwnProperty('url')) {
        var _props = this.props,
            component = _props.component,
            dispatch = _props.dispatch;

        dispatch((0, _componentsActions.updateComponent)(component.id, { value: component.value }));
      }
      if (this.props.component.name === "PromoCode") {
        var _props2 = this.props,
            _component = _props2.component,
            _dispatch = _props2.dispatch;

        var body = _component.fetchPromoCode.body;
        var url = _component.fetchPromoCode.url;
        (0, _api.FetchPromoCode)(url, body).then(function (json) {
          _component.value = !!json.payLoad && json.payLoad.PromoCode ? json.payLoad.PromoCode : ""; //"PRMDOO2"
          //(!!component.value)?dispatch(updateComponent(component.id, { value: component.value,isDisabled:true})):
          // if(!!component.value)
          // {
          //   dispatch(updateComponent(component.id, { value: component.value,isDisabled:true}))
          // }
          // else
          // {
          _dispatch((0, _componentsActions.updateComponent)(_component.id, { value: _component.value }));
          //}
        });
      }
      if (this.props.component.id === "S1-S1S1D1" && this.props.component.cleanName === "Insegna") {
        var _props3 = this.props,
            _component2 = _props3.component,
            _dispatch2 = _props3.dispatch;

        if (!!_component2.value) {
          //let companyname="SLR";
          var companyname = _component2.value.replace(/[^a-zA-Z ]/g, "");
          _dispatch2((0, _componentsActions.updateComponent)(_component2.id, { value: companyname }));
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.component && nextProps.component.value !== this.state.value) {
        this.setState({
          value: nextProps.component.value
        });
      }
    }
  }, {
    key: 'urlParam',
    value: function urlParam(name) {
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var queryPlanParam = this.urlParam('plan');
      if (this.props.component.id === "S1-S1S1D1" && this.props.component.cleanName === "Insegna") {
        e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, "");
      } else if (!!queryPlanParam && queryPlanParam.toLowerCase() === 'flexmini' && this.props.component.id === 'S2-S2S1D1' && this.props.component.cleanName === 'Numero Terminali POS da Installare' && !(/^\d$/.test(e.target.value) && parseInt(e.target.value) <= 5)) {
        e.target.value = '';
      }
      var val = e.target.value;
      var _props4 = this.props,
          component = _props4.component,
          dispatch = _props4.dispatch;


      if (this.props.type === 'date') {
        dispatch((0, _componentsActions.updateComponent)(component.id, {
          value: (0, _moment2.default)(val).format('DD/MM/YYYY')
        }));
        e.preventDefault();
      } else {

        // this.setState({value:val});
        this.setState({ value: val }, function () {
          dispatch((0, _componentsActions.updateComponent)(component.id, { value: val }));
        });
      }
    }
  }, {
    key: 'validateRequired',
    value: function validateRequired() {
      var component = this.props.component;

      if (component.validations && component.validations.isRequired && !component.isDisabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      var _props5 = this.props,
          dispatch = _props5.dispatch,
          component = _props5.component;

      if (e.target.type === 'text') {
        var inputs = Array.prototype.slice.call(document.querySelectorAll('[name="' + component.id + '"]'));
        var dateInput = inputs.find(function (t) {
          return t.type === 'date';
        });
        if (!!dateInput) {
          dispatch((0, _componentsActions.updateComponent)(component.id, { isPickerVisible: true }));
          setTimeout(function () {
            dateInput.focus();
            dateInput.click();
          }, 100);
        } else {
          if (!!component.hint) {
            dispatch((0, _componentsActions.updateComponent)(component.id, {
              hint: (0, _extends3.default)({}, component.hint, { visible: true }),
              errorMessage: '',
              status: []
            }, { avoidValidation: true }));
          }
        }
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var _props6 = this.props,
          dispatch = _props6.dispatch,
          component = _props6.component;

      var delta = {};
      if (e.target.type === 'date' && e.target.value === '') {
        delta.isPickerVisible = false;
      } else if (e.target.type === 'text') {
        //const cleanValue = cleanupString(e.target.value)
        delta.value = (0, _utils.cleanupString)(e.target.value);
        // if (cleanValue !== component.value) {
        //   delta.value = cleanupString(component.value)
        // }

        if (!!component.hint) {
          delta.hint = (0, _extends3.default)({}, component.hint, { visible: false });
        }
      }
      if ((0, _keys2.default)(delta).length > 0) {
        component.value = delta.value;
        dispatch((0, _componentsActions.updateComponent)(component.id, delta));
      }
    }
    //   toggle_visibility(id) {
    //     var divElemIBANText =document.getElementById(id);
    //     var label = document.getElementById("divIBANQuestion");

    //     if(divElemIBANText.style.display == 'none' || divElemIBANText.style.display == '')
    //      {
    //        label.innerHTML = label.innerHTML.replace("[+]","[-]");
    //        divElemIBANText.style.display = 'block';
    //      }
    //     else
    //     {
    //        label.innerHTML = label.innerHTML.replace("[-]","[+]");
    //        divElemIBANText.style.display = 'none';

    //     }
    //  }

  }, {
    key: 'getProperErrorMessage',
    value: function getProperErrorMessage() {
      var component = this.props.component;


      if (!!component.validations.overrides) {
        var validationResult = (0, _utils.getValidationsResult)({
          component: component,
          type: 'overrides'
        });
        if (!validationResult.result) {
          return validationResult.errorMessage;
        }
      }
      return component.errorMessage && component.errorMessage[0];
    }
  }, {
    key: 'renderStaticTextPhoneNum',
    value: function renderStaticTextPhoneNum() {
      return 'Cliccando su ‘Invia il codice di verifica’ riceverai un SMS con il codice OTP'; //'Inserisci il tuo numero di cellulare per ricevere via SMS il codice di sicurezza OTP'
    }
  }, {
    key: 'renderStaticTextUnderOTP',
    value: function renderStaticTextUnderOTP() {

      return 'Inserisci il codice di verifica OTP ricevuto sul tuo numero di cellulare';
    }
  }, {
    key: 'renderStaticTextDenominazione',
    value: function renderStaticTextDenominazione() {
      return 'Attenzione: nel caso in cui tu sia un libero professionista ti chiediamo di indicare come ragione sociale solamente il tuo nome e il tuo cognome.';
    }
  }, {
    key: 'renderStaticTextPuntoVendita',
    value: function renderStaticTextPuntoVendita() {
      return 'Per visualizzare correttamente il nome della tua insegna sullo scontrino ti suggeriamo di non utilizzare i caratteri speciali (inclusi accenti e apostrofi). Ti consigliamo di sostituirli con caratteri normali.';
    }
  }, {
    key: 'renderStaticTextPuntoVendita1',
    value: function renderStaticTextPuntoVendita1() {
      return '\xABQuesto nome comparir\xE0 sulla copia della transazione che stamper\xE0 il tuo POS Easy. Il numero massimo di caratteri che puoi inserire \xE8 di XX. Puoi inserire solo lettere o numeri, non puoi utilizzare segni di punteggiatura o caratteri speciali\xBB';
    }
  }, {
    key: 'renderStaticTextPuntoVendita2',
    value: function renderStaticTextPuntoVendita2() {
      return 'In caso di inserimento caratteri non consentiti, controllo immediato e deve comparire la scritta.';
    }
  }, {
    key: 'renderStaticTextPuntoVendita3',
    value: function renderStaticTextPuntoVendita3() {
      return '\xABTesto non valido, ricordati di inserire solo lettere o numeri!\xBB in rosso';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          widget = _props7.widget,
          component = _props7.component;

      var md = new _mobileDetect2.default(window.navigator.userAgent);
      var queryPlanParam = this.urlParam('plan');
      if (component.id === "S2-S2S1D1" && !!queryPlanParam && queryPlanParam.toLowerCase() === 'flexmini') {
        component.maxLength = '1';
      }
      // component.cleanName = (component.id === "S1-S1S1D1" && component.cleanName === "Insegna") ? "Nome attività" : component.cleanName
      return _react2.default.createElement(
        'div',
        (0, _withStyles.css)(this.props.styles.component, component.fullWidth && this.props.styles.singleField, (this.props.type === 'date' && !component.isPickerVisible || this.props.type === 'text' && !!component.isPickerVisible) && this.props.styles['component--hidden'], component.id === 'CELLULARE-NUM_CELLULARE' && this.props.styles.divAlignPhoneNum, component.id === 'CELLULARE-CODICE_CELLULARE' && !md.mobile() && this.props.styles.otpWidth, component.id == 'S1-S1S1D1' && this.props.styles.fullFieldWidth, component.id === 'PROMO-PromoCode' && this.props.styles.grayed),
        component.componentTitle && _react2.default.createElement(
          'b',
          (0, _withStyles.css)(this.props.styles.componentTitle),
          component.componentTitle
        ),
        !!component.numFormat && component.numFormat === 'Europian' ? _react2.default.createElement(_reactNumberFormat2.default, (0, _extends3.default)({
          allowNegative: component.id === "CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO",
          displayType: this.props.component.displayType,
          thousandSeparator: '.',
          decimalSeparator: ',',
          prefix: '€ ',
          fixedDecimalScale: false, decimalScale: 2,
          placeholder: component.cleanName,
          value: this.state.value,
          onFocus: this.onFocus.bind(this),
          onBlur: this.onBlur.bind(this),
          onChange: this.handleChange.bind(this)
        }, (0, _withStyles.css)(this.props.styles.input,
        // component.status.indexOf('error') <= -1 && component.value!=='' &&
        // this.props.styles['input--valid'],
        component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink']), {
          name: component.id
        })) : _react2.default.createElement('input', (0, _extends3.default)({
          type: this.props.type,
          placeholder: component.cleanName,
          value: this.props.type === 'date' && !!this.state.value ? (0, _moment2.default)(this.state.value, 'DD/MM/YYYY').format('YYYY-MM-DD') : this.state.value,
          onFocus: this.onFocus.bind(this),
          onBlur: this.onBlur.bind(this),
          onChange: this.handleChange.bind(this)
        }, (0, _withStyles.css)(this.props.styles.input,
        // component.status.indexOf('error') <= -1 && component.value!=='' &&
        // this.props.styles['input--valid'],
        component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink'], component.id === 'PROMO-PromoCode' && this.props.styles.grayedText), {
          disabled: !!component.isDisabled || component.status.indexOf('readonly') > -1 || widget.status.indexOf('readonly') > -1,
          readOnly: component.type === 'date' && this.props.type === 'text',
          name: component.id,
          maxLength: component.maxLength
        })),
        _react2.default.createElement(
          'span',
          null,
          component.id === 'CELLULARE-CODICE_CELLULARE' ? this.renderStaticTextUnderOTP() : ''
        ),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(
              'b',
              null,
              component.id === 'S1-S1S1D1' ? this.renderStaticTextPuntoVendita() : ''
            )
          )
        ),
        _react2.default.createElement(
          'span',
          null,
          component.id === 'DENOMINAZIONE_AZIENDA-DENOMINAZIONE' && !!component.staticDescFlag && component.staticDescFlag === true ? this.renderStaticTextDenominazione() : ''
        ),
        component.id !== 'PROMO-PromoCode' && _react2.default.createElement(
          'span',
          (0, _withStyles.css)(this.props.styles.label, this.state.value !== '' && this.props.styles['label--active']),
          component.cleanName
        ),
        _react2.default.createElement(
          'small',
          (0, _withStyles.css)(this.props.styles['error-msg']),
          (0, _utils.camelize)(this.getProperErrorMessage(), true, true)
        ),
        !!component.hint && !!component.hint.visible ? _react2.default.createElement(
          'span',
          (0, _withStyles.css)(this.props.styles.hint),
          this.props.component.hint.value
        ) : ''
      );
    }
  }]);
  return Textbox;
}(_react.Component);

Textbox.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  type: _propTypes.PropTypes.oneOf(['text', 'date']),
  styles: _propTypes.PropTypes.object.isRequired
};

Textbox.defaultProps = {
  type: 'text'
};

Textbox.defaultProps = {
  type: 'text'
};

var mapStateToProps = function mapStateToProps() /*state, ownProps*/{
  /*const { components } = state
  return { component: components[ownProps.component.id] }*/
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Textbox));

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parsers = __webpack_require__(40);

exports.default = function (_ref) {
  var colSpan = _ref.colSpan,
      _ref$columns = _ref.columns,
      columns = _ref$columns === undefined ? 12 : _ref$columns,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === undefined ? '10px' : _ref$gutter,
      _ref$align = _ref.align,
      align = _ref$align === undefined ? 'left' : _ref$align,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$gridUseGutters = _ref.gridUseGutters,
      gridUseGutters = _ref$gridUseGutters === undefined ? false : _ref$gridUseGutters;

  var styles = {};

  if (!isNaN(colSpan) && Math.ceil(colSpan) === colSpan) {
    // Check if $col-span is a valid integer number then process the parameters passed to the grid() mixin.
    styles.boxSizing = 'border-box';
    var initColWidth = colSpan * 100 / columns;
    var newOffset = offset * 100 / columns;
    var newGutter = void 0;

    if (align === 'left') {
      // Check if align is set to left (default) and make element floating to the left
      styles.float = 'left';

      if (!gridUseGutters) {
        // If gridUseGutters is set to false (true by default) set the element width based on the initColWidth process result.
        styles.width = initColWidth + '%';
      }

      if (offset !== 0 && gutter === 0) {
        // Check if not 0 offset is passed as argument and then if gutter is 0 set the left (based on direction) margin as offset.
        styles.marginLeft = newOffset + '%';
      } else if (offset !== 0 && gutter !== 0) {
        // If offset && gutter aren't 0 set the left offset by adding the gutter
        styles.margin = '0 ' + gutter + ' 0 calc(' + newOffset + '% + ' + gutter + ')';
      }
    } else if (align === 'right') {
      // Check if align is set to right && make element floating to the right
      styles.float = 'right';

      if (!gridUseGutters) {
        // If gridUseGutters is set to false (true by default) set the element width based on the initColWidth process result.
        styles.width = initColWidth + '%';
      }

      if (offset !== 0 && gutter === 0) {
        // Check if not 0 offset is passed as argument && then if gutter is 0 set the right (based on direction) margin as offset.
        styles.marginRight = newOffset + '%';
      } else if (offset !== 0 && gutter !== 0) {
        // If offset && gutter aren't set to 0 put the right offset by adding the gutter
        styles.margin = '0 calc(' + newOffset + '% + ' + gutter + ') 0 gutter';
      }
    } else if (align === 'center') {
      // Check if align is set to center && make element st&&ing to the center of is parent
      styles.margin = '0 auto';

      if (!gridUseGutters) {
        // If gridUseGutters is false calculate the width based on columns argument
        styles.width = initColWidth + '%';
      }
    } else {
      // If no additional argument is passed set the default grid style
      styles.float = left;

      if (!gridUseGutters) {
        // If gridUseGutters is false calculate the width based on columns argument
        styles.width = initColWidth + '%';
      }
    }

    if (!!gridUseGutters) {
      // If gridUseGutters is true then calculate the default new width && leftMargin based on columns && colSpan
      newGutter = (0, _parsers.number)(gutter) / (columns / colSpan);

      if (!isNaN(gutter) && (0, _parsers.unit)(gutter) === '%') {
        // if the gutter has a % unit
        styles.width = initColWidth - (0, _parsers.number)(gutter) - newGutter + '%';

        if (offset === 0) {
          styles.margin = '0 0 0 ' + gutter;
        }
      } else {
        //If the gutter doesn't have a % unit
        styles.width = 'calc( ' + initColWidth + '%  ' + gutter + '  ' + newGutter + (0, _parsers.unit)(gutter) + ' )';

        if (offset === 0) {
          styles.margin = '0 0 0 ' + gutter;
        }
      }
    }
  } else if (colSpan === 'none') {
    // If the first argument ($colSpan) is set to 'none' remove all grid style && floatings
    styles.float = 'none';
    styles.width = 'auto';
    styles.margin = 'auto';
  }

  return styles;
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _contentSelfie;

  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images;

  var keyframes = {
    opac: {
      '0%': {
        opacity: '0'
      },

      '100%': {
        opacity: '1'
      }
    }
  };

  var styles = {
    modal: {
      position: 'fixed',
      zIndex: '100',

      width: '100%',
      height: '100%',

      '::before': {
        display: 'inline-block',

        height: '100%',

        content: '\'\'',
        verticalAlign: 'middle'
      }
    },

    'modal--hidden': {
      display: 'none',

      animation: keyframes.opac + ' .5s'
    },

    closeBtn: {
      position: 'fixed',
      zIndex: '150',
      top: '0',
      right: '0',

      width: spacings.x4,
      height: spacings.x4,
      marginTop: spacings.x4,
      marginRight: spacings.x4,

      cursor: 'pointer',

      borderRadius: '100%',
      backgroundColor: colors.modal.closeButton,
      backgroundImage: images.closeIcon,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },

    title: {
      margin: '0',

      color: colors.modal.title
    },

    subtitle: {},

    bg: {
      position: 'fixed',
      zIndex: '100',
      top: '0',
      left: '0',

      width: '100%',
      height: '100%',

      opacity: '.97',
      backgroundColor: colors.modal.overlay
    },

    wrapper: {
      display: 'inline-block',

      width: '100%',

      verticalAlign: 'middle'
    },

    content: (0, _defineProperty3.default)({
      position: 'relative',
      zIndex: '110',
      right: '0',
      left: '0',

      width: '90vw',
      marginRight: 'auto',
      marginLeft: 'auto',

      borderRadius: '4px',
      backgroundColor: 'transparent'

    }, (0, _breakTo2.default)('small'), {
      width: '50vw',
      padding: '0 ' + spacings.x4
    }),

    'content--selfie': (_contentSelfie = {}, (0, _defineProperty3.default)(_contentSelfie, (0, _breakTo2.default)('small'), {
      width: 'auto',

      textAlign: 'center'
    }), (0, _defineProperty3.default)(_contentSelfie, 'width', 'auto'), (0, _defineProperty3.default)(_contentSelfie, 'textAlign', 'center'), _contentSelfie),

    buttons: {
      paddingTop: spacings.x4,
      paddingBottom: spacings.x4,

      textAlign: 'center',

      '> button': {
        marginTop: '0',
        marginBottom: '0'
      }
    }
  };

  return styles;
};

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Actions you can make on product
 * @module  {Actions} productActions
 */
var UPDATE_PRODUCT = exports.UPDATE_PRODUCT = '@@product/UPDATE';

/**
 * Updates the product info
 *
 * @param {Object} product      The updated product
 * @return {Function}           Dispatches an UPDATE_PRODUCT action
 */
var updateProduct = exports.updateProduct = function updateProduct(product) {
  return function (dispatch, getState) {
    var _getState = getState(),
        routing = _getState.routing;

    return dispatch({
      type: UPDATE_PRODUCT,
      product: product,
      flow: routing.flow
    });
  };
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1062), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(61);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(130);
var ITERATOR = __webpack_require__(34)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(61);
var aFunction = __webpack_require__(126);
var SPECIES = __webpack_require__(34)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(66);
var invoke = __webpack_require__(1064);
var html = __webpack_require__(461);
var cel = __webpack_require__(228);
var global = __webpack_require__(33);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(128)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(61);
var isObject = __webpack_require__(54);
var newPromiseCapability = __webpack_require__(259);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(33);
var core = __webpack_require__(20);
var dP = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(62);
var SPECIES = __webpack_require__(34)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(34)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(53).f;
var create = __webpack_require__(165);
var redefineAll = __webpack_require__(260);
var ctx = __webpack_require__(66);
var anInstance = __webpack_require__(257);
var forOf = __webpack_require__(135);
var $iterDefine = __webpack_require__(237);
var step = __webpack_require__(463);
var setSpecies = __webpack_require__(518);
var DESCRIPTORS = __webpack_require__(62);
var fastKey = __webpack_require__(239).fastKey;
var validate = __webpack_require__(262);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(33);
var $export = __webpack_require__(26);
var meta = __webpack_require__(239);
var fails = __webpack_require__(90);
var hide = __webpack_require__(72);
var redefineAll = __webpack_require__(260);
var forOf = __webpack_require__(135);
var anInstance = __webpack_require__(257);
var isObject = __webpack_require__(54);
var setToStringTag = __webpack_require__(131);
var dP = __webpack_require__(53).f;
var each = __webpack_require__(1072)(0);
var DESCRIPTORS = __webpack_require__(62);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(256);
var from = __webpack_require__(1076);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(26);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(26);
var aFunction = __webpack_require__(126);
var ctx = __webpack_require__(66);
var forOf = __webpack_require__(135);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAddressComponents = exports.getAddressComponents = function getAddressComponents() {
  return {
    code: '15865',
    name: 'RESIDENZA',
    bundleLink: null,
    bundleCode: null,
    components: [{
      name: 'CAP',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['cap', 'required'],
      values: [],
      type: null
    }, {
      name: 'CITTA',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['required', 'city'],
      values: [],
      type: null
    }, {
      name: 'INDIRIZZO',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['required'],
      values: [],
      type: null
    }, {
      name: 'NAZIONE',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['word', 'required'],
      values: [],
      type: null
    }, {
      name: 'PROVINCIA',
      value: '',
      rawValue: null,
      active: true,
      status: [],
      errorMessage: [],
      validations: ['word', 'required'],
      values: [],
      type: null
    }],
    status: [],
    errorMessage: []
  };
};
var getPECAddressComponent = exports.getPECAddressComponent = function getPECAddressComponent() {
  return {
    widgets: [{
      code: "19356",
      name: 'PEC',
      bundleLink: null,
      bundleCode: null,
      components: [{
        name: 'ADDRESS',
        value: 'L’indirizzo PEC è importante per la ricezione della comunicazione periodica',
        rawValue: null,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        active: true
      }]
    }]

  };
};
var getDocumentoRulesComponent = exports.getDocumentoRulesComponent = function getDocumentoRulesComponent() {
  return {
    widgets: [{
      code: "15773",
      name: 'DOCUMENTO',
      bundleLink: null,
      bundleCode: null,
      components: [{
        name: 'DOCUMENTRULES',
        value: 'I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
        rawValue: null,
        status: [],
        //position:7,
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        isSmall: true,
        active: true
      }, {
        name: 'DOCUMENTRULES2',
        value: '<b>Il documento non deve avere scadenza nei prossimi 3 mesi</b>.<br/>I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
        rawValue: null,
        status: [],
        //position:7,
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        isSmall: true,
        active: false
      }]
    }, {
      code: "15774",
      name: 'DOCUMENTO_2',
      bundleLink: null,
      bundleCode: null,
      components: [{
        name: 'SECONDDOCUMENTRULE1',
        value: '<b>Il documento deve essere intestato al richiedente e non più vecchio di 3 mesi</b>.<br/>I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
        rawValue: null,
        status: [],
        position: 13,
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        isSmall: true,
        active: false
      }, {
        name: 'SECONDDOCUMENTRULE2',
        value: 'I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
        rawValue: null,
        status: [],
        position: 14,
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        isSmall: true,
        active: true
      }, {
        name: 'SECONDDOCUMENTRULE3',
        value: '<b>Il documento non deve avere scadenza nei prossimi 3 mesi</b>.<br/>I formati accettati sono:PDF, JPEG, GIF, PNG, PJPEG, X-PNG.Il peso massimo consentito per documento è di 7MB. Per un documento PDF, il numero massimo di pagine consentito è 5.',
        rawValue: null,
        status: [],
        position: 15,
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        isSmall: true,
        active: false
      }]
    }]

  };
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getPromoCodeComponent = exports.getPromoCodeComponent = function getPromoCodeComponent() {
  return {
    widgets: [{
      code: '19357',
      name: 'PROMO',
      bundleLink: null,
      bundleCode: null,
      group: 'PROMO',
      groupTitle: '',
      errorMessage: [],
      components: [{
        name: 'PromoCode',
        value: '',
        status: [],
        errorMessage: [],
        //validations: {
        // isRequired: true,
        //default: [
        //   {
        //     validate: VALIDATION_METHODS.filled,
        //     getErrorMessage:VALIDATION_ERRORS.filled
        //   }
        //]
        //},
        type: 'text',
        componentTitle: 'Inserisci il codice coupon in tuo possesso',
        cleanName: 'Codice coupon', //'PromoCode',
        active: true,
        isDisabled: false
      }],
      active: true,
      status: []

    }]

  };
};

var getPromotionalComponent = exports.getPromotionalComponent = function getPromotionalComponent() {
  return {
    code: '19358',
    description: '',
    events: {},
    id: 'S16S1D2',
    title: '',
    type: 'LABEL',
    typeValues: [],
    value: ['Se hai utilizzato un coupon promozionale, seleziona la fascia di prezzo che pagherai una volta terminata la promozione.']
  };
};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTitolareEffettivoComponent = exports.getTitolareEffettivoComponent = function getTitolareEffettivoComponent() {
  var titolareEffettivo = {
    widgets: [
    // {
    //   code: '16727',
    //   name: 'TITOLARE_OWNER',
    //   bundleLink: null,
    //   bundleCode: null,
    //   position: 1,
    //   components: [
    //     {
    //       name: 'LABEL',
    //       value: '',
    //       rawValue: null,
    //       active: true,
    //       status: [],
    //       errorMessage: [],
    //       validations: ['required'],
    //       values: [],
    //       type: 'label'
    //     },
    //     {
    //       name: 'EFFETTIVO_SI',
    //       value: '',
    //       rawValue: null,
    //       active: true,
    //       status: [],
    //       errorMessage: [],
    //       validations: ['required'],
    //       values: ['selected'],
    //       type: 'radio'
    //     },
    //     {
    //       name: 'EFFETTIVO_NO',
    //       value: '',
    //       rawValue: null,
    //       active: true,
    //       status: [],
    //       errorMessage: [],
    //       validations: ['required'],
    //       values: [],
    //       type: 'radio'
    //     }
    //   ],
    //   status: [],
    //   errorMessage: []
    // },
    {
      code: '16726',
      name: 'TITOLARE_DATA',
      bundleLink: null,
      bundleCode: null,
      position: 1,
      components: [{
        name: 'LABEL',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: 'label'
      }, {
        name: 'EFFETTIVO_SI',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: ['selected'],
        type: 'radio'
      }, {
        name: 'EFFETTIVO_NO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: 'radio'
      }],
      status: [],
      errorMessage: []
    }, {
      code: '16728',
      name: 'NOME_COGNOME',
      bundleLink: null,
      bundleCode: null,
      position: 2,
      components: [{
        name: 'COGNOME',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [''],
        values: [],
        type: null
      }, {
        name: 'NOME',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [''],
        values: [],
        type: null
      }],
      status: [],
      errorMessage: []
    }, {
      code: '16729',
      name: 'CODICE_FISCALE',
      bundleLink: null,
      bundleCode: null,
      position: 3,
      components: [{
        name: 'CF',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [''],
        values: [],
        type: null
      }, {
        name: 'DATADINASCITA',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [''],
        values: [],
        type: 'label'
      }, {
        name: 'SESSO',
        value: '',
        rawValue: null,
        active: false,
        status: ['hidden'],
        errorMessage: [],
        validations: [''],
        values: [],
        type: 'label'
      }, {
        name: 'PROVINCIADINASCITA',
        value: '',
        rawValue: null,
        active: false,
        status: ['hidden'],
        errorMessage: [],
        validations: [''],
        values: [],
        type: 'label'
      }, {
        name: 'LUOGODINASCITA',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [''],
        values: [],
        type: 'label'
      }],
      status: [],
      errorMessage: []
    }, {
      code: '15865',
      name: 'RESIDENZA',
      bundleLink: null,
      bundleCode: null,
      position: 4,
      components: [{
        name: 'CAP',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['cap', 'required'],
        values: [],
        type: null
      }, {
        name: 'CITTA',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required', 'city'],
        values: [],
        type: null
      }, {
        name: 'INDIRIZZO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: null
      }, {
        name: 'NAZIONE',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['word', 'required'],
        values: [{
          value: 'ABU DHABI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AFGHANISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AJMAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ALAND ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ALBANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ALGERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANDORRA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANGOLA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANGUILLA (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANTARTIDE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANTIGUA E BARBUDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARABIA SAUDITA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARGENTINA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARMENIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARUBA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ASCENSION',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AUSTRALIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AUSTRIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AZERBAIGIAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AZZORRE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BAHAMAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BAHREIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BANGLADESH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BARBADOS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BELGIO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BELIZE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BENIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BERMUDA (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BHUTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BIELORUSSIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOLIVIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BONAIRE SAINT EUSTATIUS AND SABA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOSNIA ED ERZEGOVINA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOTSWANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOUVET ISOLA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BRASILE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BRUNEI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BULGARIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BURKINA FASO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BURUNDI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAMBOGIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAMERUN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CANADA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CANARIE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAPO VERDE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAROLINE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAYMAN (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CENTRAFRICANA REPUBBLICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CEUTA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CHAFARINAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CHAGOS ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CHRISTMAS (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CIAD',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CILE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CINA REPUBBLICA POPOLARE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CIPRO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CITTA DEL VATICANO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CLIPPERTON',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COCOS (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COLOMBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COMORE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CONGO REPUBBLICA DEMOCRATICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CONGO REPUBBLICA POPOLARE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COOK (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COREA DEL NORD',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COREA DEL SUD',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COSTA DAVORIO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COSTA RICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CROAZIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CUBA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CURACAO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'DANIMARCA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'DOMINICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'DUBAI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ECUADOR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'EGITTO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'EL SALVADOR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ERITREA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ESTONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ETIOPIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FAER OER (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FIGI=VITI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FILIPPINE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FINLANDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FRANCIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FUIJAYRAH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GABON',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GAMBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GEORGIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GERMANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GHANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIAMAICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIAPPONE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIBILTERRA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIBUTI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIORDANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GOUGH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GRECIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GRENADA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GROENLANDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUADALUPA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUAM (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUATEMALA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUAYANA=GUIANA FRANCESE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUERNSEY ISOLE DEL CANALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUINEA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUINEA BISSAU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUINEA EQUATORIALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUYANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HAITI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HEARD E MCDONALD ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HONDURAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HONG KONG',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'INDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'INDONESIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'IRAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'IRAQ',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'IRLANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ISLANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ISOLE AMERICANE DEL PACIFICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ISRAELE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ITALIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'JERSEY ISOLE DEL CANALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KAZAKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KENYA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KIRGHIZISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KIRIBATI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KOSOVO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KUWAIT',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LA REUNION (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LAOS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LESOTHO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LETTONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIBANO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIBERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIECHTENSTEIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LITUANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LUSSEMBURGO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MACAO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MACEDONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MADAGASCAR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MADEIRA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALAWI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALAYSIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALDIVE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALTA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALVINE=FALKLAND (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAN (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MARIANNE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAROCCO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MARSHALL',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MARTINICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAURITANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAURIZIO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAYOTTE (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MELILLA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MESSICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MICRONESIA STATI FEDERATI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MIDWAY (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MOLDAVIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONACO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONGOLIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONTENEGRO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONTSERRAT',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MOZAMBICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MYANMAR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NAMIBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NAURU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NEPAL',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NICARAGUA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NIGER',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NIGERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NIUE=SAVAGE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NORVEGIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NUOVA CALEDONIA (ISOLE E DIPENDENZE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NUOVA ZELANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'OMAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PAESI BASSI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PAKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PALAU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PANAMA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PAPUA NUOVA GUINEA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PARAGUAY',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PENON DE ALHUCEMAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PENON DE VELEZ DE LA GOMERA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PERU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PITCAIRN (E DIPENDENZE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'POLINESIA FRANCESE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'POLONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PORTOGALLO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PUERTO RICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'QATAR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'RAS AL KHAIMAH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REGNO UNITO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REPUBBLICA CECA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REPUBBLICA DELLA CINA NAZIONALE=TAIWAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REPUBBLICA DOMINICANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ROMANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'RUANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'RUSSIA=FEDERAZIONE RUSSA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAHARA OCCIDENTALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT BARTHELEMY',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT LUCIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT MARTIN SETTENTRIONALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT PIERRE ET MIQUELON (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT VINCENT E GRENADINE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SALOMONE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAMOA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAMOA AMERICANE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAN MARINO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SANTELENA (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAO TOME E PRINCIPE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SEICELLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SENEGAL',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SERBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SHARJAH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SIERRA LEONE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SINGAPORE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SINT MAARTEN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SIRIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SLOVACCHIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SLOVENIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SOMALIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SPAGNA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SRI LANKA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'STATI UNITI DAMERICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUD GEORGIA E SUD SANDWICH ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUD SUDAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUDAFRICANA REPUBBLICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUDAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SURINAME',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SVALBARD E JAN MAYEN ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SVEZIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SVIZZERA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SWAZILAND',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TAGIKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TANZANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TERRITORI PALESTINESI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TERRITORIO ANTARTICO FRANCESE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TERRITORIO BRITANNICO OCEANO INDIANO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'THAILANDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TIMOR ORIENTALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TOGO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TOKELAU=ISOLE DELL UNIONE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TONGA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TRINIDAD E TOBAGO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TRISTAN DA CUNHA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TUNISIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TURCHIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TURKMENISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TURKS E CAICOS (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TUVALU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UCRAINA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UGANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UMM AL QAIWAIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UNGHERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'URUGUAY',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UZBEKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VANUATU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VENEZUELA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VERGINI AMERICANE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VERGINI BRITANNICHE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VIETNAM',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'WAKE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'WALLIS E FUTUNA (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'YEMEN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ZAMBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ZIMBABWE',
          jsonString: null,
          description: 'NAZIONE'
        }],
        type: null
      }, {
        name: 'PROVINCIA',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['word', 'required'],
        values: [{
          value: '',
          jsonString: null,
          description: ''
        }, {
          value: 'AG',
          jsonString: null,
          description: 'AGRIGENTO'
        }, {
          value: 'AL',
          jsonString: null,
          description: 'ALESSANDRIA'
        }, {
          value: 'AN',
          jsonString: null,
          description: 'ANCONA'
        }, {
          value: 'AO',
          jsonString: null,
          description: 'AOSTA'
        }, {
          value: 'AP',
          jsonString: null,
          description: 'ASCOLI PICENO'
        }, {
          value: 'AQ',
          jsonString: null,
          description: 'L AQUILA'
        }, {
          value: 'AR',
          jsonString: null,
          description: 'AREZZO'
        }, {
          value: 'AT',
          jsonString: null,
          description: 'ASTI'
        }, {
          value: 'AV',
          jsonString: null,
          description: 'AVELLINO'
        }, {
          value: 'BA',
          jsonString: null,
          description: 'BARI'
        }, {
          value: 'BG',
          jsonString: null,
          description: 'BERGAMO'
        }, {
          value: 'BI',
          jsonString: null,
          description: 'BIELLA'
        }, {
          value: 'BL',
          jsonString: null,
          description: 'BELLUNO'
        }, {
          value: 'BN',
          jsonString: null,
          description: 'BENEVENTO'
        }, {
          value: 'BO',
          jsonString: null,
          description: 'BOLOGNA'
        }, {
          value: 'BR',
          jsonString: null,
          description: 'BRINDISI'
        }, {
          value: 'BS',
          jsonString: null,
          description: 'BRESCIA'
        }, {
          value: 'BT',
          jsonString: null,
          description: 'BARLETTA ANDRIA TRANI'
        }, {
          value: 'BZ',
          jsonString: null,
          description: 'BOLZANO'
        }, {
          value: 'CA',
          jsonString: null,
          description: 'CAGLIARI'
        }, {
          value: 'CB',
          jsonString: null,
          description: 'CAMPOBASSO'
        }, {
          value: 'CE',
          jsonString: null,
          description: 'CASERTA'
        }, {
          value: 'CH',
          jsonString: null,
          description: 'CHIETI'
        }, {
          value: 'CL',
          jsonString: null,
          description: 'CALTANISSETTA'
        }, {
          value: 'CN',
          jsonString: null,
          description: 'CUNEO'
        }, {
          value: 'CO',
          jsonString: null,
          description: 'COMO'
        }, {
          value: 'CR',
          jsonString: null,
          description: 'CREMONA'
        }, {
          value: 'CS',
          jsonString: null,
          description: 'COSENZA'
        }, {
          value: 'CT',
          jsonString: null,
          description: 'CATANIA'
        }, {
          value: 'CZ',
          jsonString: null,
          description: 'CATANZARO'
        }, {
          value: 'EN',
          jsonString: null,
          description: 'ENNA'
        }, {
          value: 'FC',
          jsonString: null,
          description: 'FORLI CESENA'
        }, {
          value: 'FE',
          jsonString: null,
          description: 'FERRARA'
        }, {
          value: 'FG',
          jsonString: null,
          description: 'FOGGIA'
        }, {
          value: 'FI',
          jsonString: null,
          description: 'FIRENZE'
        }, {
          value: 'FM',
          jsonString: null,
          description: 'FERMO'
        }, {
          value: 'FR',
          jsonString: null,
          description: 'FROSINONE'
        }, {
          value: 'GE',
          jsonString: null,
          description: 'GENOVA'
        }, {
          value: 'GO',
          jsonString: null,
          description: 'GORIZIA'
        }, {
          value: 'GR',
          jsonString: null,
          description: 'GROSSETO'
        }, {
          value: 'IM',
          jsonString: null,
          description: 'IMPERIA'
        }, {
          value: 'IS',
          jsonString: null,
          description: 'ISERNIA'
        }, {
          value: 'KR',
          jsonString: null,
          description: 'CROTONE'
        }, {
          value: 'LC',
          jsonString: null,
          description: 'LECCO'
        }, {
          value: 'LE',
          jsonString: null,
          description: 'LECCE'
        }, {
          value: 'LI',
          jsonString: null,
          description: 'LIVORNO'
        }, {
          value: 'LO',
          jsonString: null,
          description: 'LODI'
        }, {
          value: 'LT',
          jsonString: null,
          description: 'LATINA'
        }, {
          value: 'LU',
          jsonString: null,
          description: 'LUCCA'
        }, {
          value: 'MB',
          jsonString: null,
          description: 'MONZA E DELLA BRIANZA'
        }, {
          value: 'MC',
          jsonString: null,
          description: 'MACERATA'
        }, {
          value: 'ME',
          jsonString: null,
          description: 'MESSINA'
        }, {
          value: 'MI',
          jsonString: null,
          description: 'MILANO'
        }, {
          value: 'MN',
          jsonString: null,
          description: 'MANTOVA'
        }, {
          value: 'MO',
          jsonString: null,
          description: 'MODENA'
        }, {
          value: 'MS',
          jsonString: null,
          description: 'MASSA CARRARA'
        }, {
          value: 'MT',
          jsonString: null,
          description: 'MATERA'
        }, {
          value: 'NA',
          jsonString: null,
          description: 'NAPOLI'
        }, {
          value: 'NO',
          jsonString: null,
          description: 'NOVARA'
        }, {
          value: 'NU',
          jsonString: null,
          description: 'NUORO'
        }, {
          value: 'OR',
          jsonString: null,
          description: 'ORISTANO'
        }, {
          value: 'PA',
          jsonString: null,
          description: 'PALERMO'
        }, {
          value: 'PC',
          jsonString: null,
          description: 'PIACENZA'
        }, {
          value: 'PD',
          jsonString: null,
          description: 'PADOVA'
        }, {
          value: 'PE',
          jsonString: null,
          description: 'PESCARA'
        }, {
          value: 'PG',
          jsonString: null,
          description: 'PERUGIA'
        }, {
          value: 'PI',
          jsonString: null,
          description: 'PISA'
        }, {
          value: 'PN',
          jsonString: null,
          description: 'PORDENONE'
        }, {
          value: 'PO',
          jsonString: null,
          description: 'PRATO'
        }, {
          value: 'PR',
          jsonString: null,
          description: 'PARMA'
        }, {
          value: 'PT',
          jsonString: null,
          description: 'PISTOIA'
        }, {
          value: 'PU',
          jsonString: null,
          description: 'PESARO URBINO'
        }, {
          value: 'PV',
          jsonString: null,
          description: 'PAVIA'
        }, {
          value: 'PZ',
          jsonString: null,
          description: 'POTENZA'
        }, {
          value: 'RA',
          jsonString: null,
          description: 'RAVENNA'
        }, {
          value: 'RC',
          jsonString: null,
          description: 'REGGIO CALABRIA'
        }, {
          value: 'RE',
          jsonString: null,
          description: 'REGGIO EMILIA'
        }, {
          value: 'RG',
          jsonString: null,
          description: 'RAGUSA'
        }, {
          value: 'RI',
          jsonString: null,
          description: 'RIETI'
        }, {
          value: 'RM',
          jsonString: null,
          description: 'ROMA'
        }, {
          value: 'RN',
          jsonString: null,
          description: 'RIMINI'
        }, {
          value: 'RO',
          jsonString: null,
          description: 'ROVIGO'
        }, {
          value: 'SA',
          jsonString: null,
          description: 'SALERNO'
        }, {
          value: 'SI',
          jsonString: null,
          description: 'SIENA'
        }, {
          value: 'SO',
          jsonString: null,
          description: 'SONDRIO'
        }, {
          value: 'SP',
          jsonString: null,
          description: 'LA SPEZIA'
        }, {
          value: 'SR',
          jsonString: null,
          description: 'SIRACUSA'
        }, {
          value: 'SS',
          jsonString: null,
          description: 'SASSARI'
        }, {
          value: 'SU',
          jsonString: null,
          description: 'SUD SARDEGNA'
        }, {
          value: 'SV',
          jsonString: null,
          description: 'SAVONA'
        }, {
          value: 'TA',
          jsonString: null,
          description: 'TARANTO'
        }, {
          value: 'TE',
          jsonString: null,
          description: 'TERAMO'
        }, {
          value: 'TN',
          jsonString: null,
          description: 'TRENTO'
        }, {
          value: 'TO',
          jsonString: null,
          description: 'TORINO'
        }, {
          value: 'TP',
          jsonString: null,
          description: 'TRAPANI'
        }, {
          value: 'TR',
          jsonString: null,
          description: 'TERNI'
        }, {
          value: 'TS',
          jsonString: null,
          description: 'TRIESTE'
        }, {
          value: 'TV',
          jsonString: null,
          description: 'TREVISO'
        }, {
          value: 'UD',
          jsonString: null,
          description: 'UDINE'
        }, {
          value: 'VA',
          jsonString: null,
          description: 'VARESE'
        }, {
          value: 'VB',
          jsonString: null,
          description: 'VERBANO CUSIO OSSOLA'
        }, {
          value: 'VC',
          jsonString: null,
          description: 'VERCELLI'
        }, {
          value: 'VE',
          jsonString: null,
          description: 'VENEZIA'
        }, {
          value: 'VI',
          jsonString: null,
          description: 'VICENZA'
        }, {
          value: 'VR',
          jsonString: null,
          description: 'VERONA'
        }, {
          value: 'VT',
          jsonString: null,
          description: 'VITERBO'
        }, {
          value: 'VV',
          jsonString: null,
          description: 'VIBO VALENTIA'
        }],
        type: null
      }, {
        name: 'FISCALE',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['word', 'required'],
        flag: 'static_1',
        values: [{
          value: 'ABU DHABI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AFGHANISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AJMAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ALAND ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ALBANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ALGERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANDORRA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANGOLA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANGUILLA (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANTARTIDE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ANTIGUA E BARBUDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARABIA SAUDITA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARGENTINA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARMENIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ARUBA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ASCENSION',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AUSTRALIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AUSTRIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AZERBAIGIAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'AZZORRE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BAHAMAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BAHREIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BANGLADESH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BARBADOS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BELGIO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BELIZE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BENIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BERMUDA (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BHUTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BIELORUSSIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOLIVIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BONAIRE SAINT EUSTATIUS AND SABA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOSNIA ED ERZEGOVINA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOTSWANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BOUVET ISOLA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BRASILE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BRUNEI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BULGARIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BURKINA FASO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'BURUNDI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAMBOGIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAMERUN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CANADA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CANARIE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAPO VERDE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAROLINE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CAYMAN (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CENTRAFRICANA REPUBBLICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CEUTA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CHAFARINAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CHAGOS ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CHRISTMAS (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CIAD',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CILE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CINA REPUBBLICA POPOLARE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CIPRO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CITTA DEL VATICANO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CLIPPERTON',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COCOS (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COLOMBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COMORE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CONGO REPUBBLICA DEMOCRATICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CONGO REPUBBLICA POPOLARE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COOK (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COREA DEL NORD',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COREA DEL SUD',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COSTA DAVORIO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'COSTA RICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CROAZIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CUBA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'CURACAO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'DANIMARCA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'DOMINICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'DUBAI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ECUADOR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'EGITTO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'EL SALVADOR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ERITREA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ESTONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ETIOPIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FAER OER (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FIGI=VITI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FILIPPINE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FINLANDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FRANCIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'FUIJAYRAH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GABON',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GAMBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GEORGIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GERMANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GHANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIAMAICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIAPPONE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIBILTERRA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIBUTI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GIORDANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GOUGH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GRECIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GRENADA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GROENLANDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUADALUPA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUAM (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUATEMALA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUAYANA=GUIANA FRANCESE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUERNSEY ISOLE DEL CANALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUINEA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUINEA BISSAU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUINEA EQUATORIALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'GUYANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HAITI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HEARD E MCDONALD ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HONDURAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'HONG KONG',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'INDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'INDONESIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'IRAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'IRAQ',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'IRLANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ISLANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ISOLE AMERICANE DEL PACIFICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ISRAELE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ITALIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'JERSEY ISOLE DEL CANALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KAZAKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KENYA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KIRGHIZISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KIRIBATI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KOSOVO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'KUWAIT',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LA REUNION (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LAOS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LESOTHO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LETTONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIBANO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIBERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LIECHTENSTEIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LITUANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'LUSSEMBURGO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MACAO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MACEDONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MADAGASCAR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MADEIRA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALAWI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALAYSIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALDIVE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALTA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MALVINE=FALKLAND (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAN (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MARIANNE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAROCCO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MARSHALL',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MARTINICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAURITANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAURIZIO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MAYOTTE (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MELILLA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MESSICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MICRONESIA STATI FEDERATI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MIDWAY (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MOLDAVIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONACO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONGOLIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONTENEGRO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MONTSERRAT',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MOZAMBICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'MYANMAR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NAMIBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NAURU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NEPAL',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NICARAGUA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NIGER',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NIGERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NIUE=SAVAGE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NORVEGIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NUOVA CALEDONIA (ISOLE E DIPENDENZE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'NUOVA ZELANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'OMAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PAESI BASSI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PAKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PALAU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PANAMA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PAPUA NUOVA GUINEA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PARAGUAY',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PENON DE ALHUCEMAS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PENON DE VELEZ DE LA GOMERA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PERU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PITCAIRN (E DIPENDENZE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'POLINESIA FRANCESE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'POLONIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PORTOGALLO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'PUERTO RICO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'QATAR',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'RAS AL KHAIMAH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REGNO UNITO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REPUBBLICA CECA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REPUBBLICA DELLA CINA NAZIONALE=TAIWAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'REPUBBLICA DOMINICANA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ROMANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'RUANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'RUSSIA=FEDERAZIONE RUSSA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAHARA OCCIDENTALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT BARTHELEMY',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT KITTS E NEVIS=SAINT CHRISTOPHER E NEVIS',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT LUCIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT MARTIN SETTENTRIONALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT PIERRE ET MIQUELON (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAINT VINCENT E GRENADINE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SALOMONE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAMOA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAMOA AMERICANE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAN MARINO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SANTELENA (ISOLA)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SAO TOME E PRINCIPE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SEICELLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SENEGAL',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SERBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SHARJAH',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SIERRA LEONE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SINGAPORE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SINT MAARTEN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SIRIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SLOVACCHIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SLOVENIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SOMALIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SPAGNA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SRI LANKA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'STATI UNITI DAMERICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUD GEORGIA E SUD SANDWICH ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUD SUDAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUDAFRICANA REPUBBLICA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SUDAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SURINAME',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SVALBARD E JAN MAYEN ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SVEZIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SVIZZERA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'SWAZILAND',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TAGIKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TANZANIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TERRITORI PALESTINESI',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TERRITORIO ANTARTICO FRANCESE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TERRITORIO BRITANNICO OCEANO INDIANO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'THAILANDIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TIMOR ORIENTALE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TOGO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TOKELAU=ISOLE DELL UNIONE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TONGA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TRINIDAD E TOBAGO',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TRISTAN DA CUNHA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TUNISIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TURCHIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TURKMENISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TURKS E CAICOS (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'TUVALU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UCRAINA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UGANDA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UMM AL QAIWAIN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UNGHERIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'URUGUAY',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'UZBEKISTAN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VANUATU',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VENEZUELA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VERGINI AMERICANE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VERGINI BRITANNICHE (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'VIETNAM',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'WAKE ISOLE',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'WALLIS E FUTUNA (ISOLE)',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'YEMEN',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ZAMBIA',
          jsonString: null,
          description: 'NAZIONE'
        }, {
          value: 'ZIMBABWE',
          jsonString: null,
          description: 'NAZIONE'
        }],
        type: null
      }],
      status: [],
      errorMessage: []
    }, {
      code: '15773',
      name: 'DOCUMENTO',
      bundleLink: null,
      bundleCode: null,
      position: 5,
      components: [{
        name: 'DATA_RILASCIO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['date.before.today', 'date', 'required'],
        values: [],
        type: null
      }, {
        name: 'DATA_SCADENZA',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['date.after.today', 'date', 'required'],
        values: [],
        type: null
      }, {
        name: 'DOCF_UPLOAD',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: null
      }, {
        name: 'DOCR_UPLOAD',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: null
      }, {
        name: 'ENTE_RILASCIO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['word', 'required'],
        values: [],
        type: null
      }, {
        name: 'LUOGO_RILASCIO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required', 'city'],
        values: [],
        type: null
      }, {
        name: 'NUMERO_DOCUMENTO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['alphanumeric', 'required'],
        values: [],
        type: null
      }, {
        name: 'TIPO_DOCUMENTO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['word', 'required'],
        values: [],
        type: null
      }],
      status: [],
      errorMessage: []
      // },
      // {
      //   code: '16727',
      //   name: 'TITOLARE_ESERCITA',
      //   bundleLink: null,
      //   bundleCode: null,
      //   position: 6,
      //   components: [
      //     {
      //       name: 'LABEL',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: [],
      //       values: [],
      //       type: 'label'
      //     },
      //     {
      //       name: 'ESERCITA_SI',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: [],
      //       type: 'radio'
      //     },
      //     {
      //       name: 'ESERCITA_NO',
      //       value: '',
      //       rawValue: null,
      //       active: true,
      //       status: [],
      //       errorMessage: [],
      //       validations: ['required'],
      //       values: [],
      //       type: 'radio'
      //     }
      //     // },
      //     // {
      //     //   name: 'ADD',
      //     //   id: 'bt-add',
      //     //   text: 'AGGIUNGI ALTRO TITOLARE',
      //     //   action: null,
      //     //   type: 'button',
      //     //   pullTo: 'left',
      //     //   active: true,
      //     //   status: [],
      //     //   errorMessage: [],
      //     //   validations: [],
      //     //   values: []
      //     // }
      //   ],
      //   status: [],
      //   errorMessage: []
      // }
    }]
  };
  return titolareEffettivo;
};

var getTitolareStaticComponent = exports.getTitolareStaticComponent = function getTitolareStaticComponent() {
  var TitolareStaticComponent = {
    widgets: [{
      code: '16727',
      name: 'TITOLARE_OWNER',
      bundleLink: null,
      bundleCode: null,
      position: 1,
      components: [{
        name: 'LABEL',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: 'label'
      }, {
        name: 'EFFETTIVO_SI',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: ['selected'],
        type: 'radio'
      }, {
        name: 'EFFETTIVO_NO',
        value: '',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: ['required'],
        values: [],
        type: 'radio'
      }],
      status: [],
      errorMessage: []
    }]
  };

  return TitolareStaticComponent;
};

var getTipDocValues = exports.getTipDocValues = function getTipDocValues() {

  return {
    Values: [{ classe: 'A', descrizione: "Carta d'identità", enteEmissione: 'COMUNE', idBanca: '1', label: "Carta d'identita", nome: "Carta d'identita", rifDate: '2012-09-30T00:00:00.000+02:00', tipo: 'ID', valid: 'Y', value: "Carta d'identita" }, { classe: 'A', descrizione: 'Passaporto', enteEmissione: 'QUESTURA', idBanca: '1', label: 'Passaporto', nome: 'Passaporto', rifDate: '2012-09-30T00:00:00.000+02:00', tipo: 'ID', valid: 'Y', value: 'Passaporto' }, { classe: 'A', descrizione: 'Patente di guida', enteEmissione: 'UFFICIO PROVINCIALE MCTC', idBanca: '1', label: 'Patente di guida', nome: 'Patente di guida', rifDate: '2012-09-30T00:00:00.000+02:00', tipo: 'ID', valid: 'Y', value: 'Patente di guida' }]
  };
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Actions you can make on chatbot
 * @module  {Actions} chatbotActions
 */
var OPEN = exports.OPEN = '@@chatbot/OPEN';
var CLOSE = exports.CLOSE = '@@chatbot/CLOSE';

/**
 * Opens the chatbot
 *
 * @return {Object}           open action payload
 */
var open = exports.open = function open() {
  return {
    type: OPEN
  };
};

/**
 * Closes the chatbot
 *
 * @return {Object}           close action payload
 */
var close = exports.close = function close() {
  return {
    type: CLOSE
  };
};

/**
 * Toggle the chatbot
 *
 * @return {Object}           toggle action payload
 */
var toggle = exports.toggle = function toggle() {
  return function (dispatch, getState) {
    var _getState = getState(),
        isOpen = _getState.chatbot.open;

    if (!!isOpen) {
      return dispatch(close());
    } else {
      return dispatch(open());
    }
  };
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(133);

var _routes = __webpack_require__(1103);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(1213);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1215);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Chatbot from '@hype/chatbot'

// import i18n from '../i18n'
// import ru from './../../lang/ru.json'
// import en from './../../lang/en.json'

// const localeData = {
//   en,
//   ru,
// }

// const DEFAULT_LOCALE = 'en'

/*import { getHelpdeskMail } from '../../utils'
import {
  open as openChatbot,
  close as closeChatbot
} from '../../state/actions/chatbotActions'*/
var handleChange = function handleChange(_ref, _ref2) {
  var partnership = _ref.partnership;
  var nextPartnership = _ref2.partnership;

  if (!partnership || !nextPartnership) {
    window.scrollTo(0, 0);
  }
};

var Root = function (_Component) {
  (0, _inherits3.default)(Root, _Component);

  function Root(props) {
    (0, _classCallCheck3.default)(this, Root);
    return (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).call(this, props));
  }

  // getLocation() {
  //   return this.props.store.getState().getIn(['routing', 'locationBeforeTransitions']).toJS()
  // }

  // setLanguage(lang) {
  //   const location = this.getLocation()

  //   if (localeData[lang]) {
  //     this.props.history.push({...location, query: {...location.query, lang } })
  //     window.location.reload()
  //   }
  // }

  (0, _createClass3.default)(Root, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          history = _props.history,
          routing = _props.routing,
          product = _props.product,
          children = _props.children;
      // const lang = localeData[this.getLocation().query.lang] ? this.getLocation().query.lang || DEFAULT_LOCALE : DEFAULT_LOCALE
      // const i18nTools = new i18n.Tools({ localeData: localeData[lang], locale: lang })

      /*const chatbotProps = {
        open: chatbot.open,
        afterOpenCallback: () => {
          dispatch(openChatbot())
        },
        afterCloseCallback: () => {
          dispatch(closeChatbot())
        },
        theme: {
          color: this.props.styles.chatbot._definition.backgroundColor,
          height: '420px',
          width: '340px',
          padding: '50px',
          fontFamily: 'Muli, sans-serif',
          buttonSize: '64px'
        },
          contactId: step.contactId,
        chatbotName: 'Hypebot',
        emailAddress: getHelpdeskMail(routing),
          endpoint:
          'https://westus.api.cognitive.microsoft.com/qnamaker/v2.0/knowledgebases/57858072-d02e-4dd6-bd72-73da2d55eb5b/generateAnswer',
        subKey: '35f376e3f5294748886e1cd937a75f3e',
        operatorChatURL: `${process.env.API_ROOT.replace(
          /\/onboarding/,
          ''
        )}/Chat/`,
        __hypeCheck: `${process.env.API_ROOT.replace(
          /\/onboarding/,
          ''
        )}/api/rest/FREE/services`
      }*/

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(
          'div',
          { className: 'pos-onboarding-root-wrapper' },
          _react2.default.createElement(_reactRouter.Router, {
            history: history,
            routes: _routes2.default,
            onUpdate: function onUpdate() {
              return handleChange(routing, product);
            }
          }),
          children
        )
      );
    }
  }]);
  return Root;
}(_react.Component);

Root.propTypes = {
  children: _propTypes.PropTypes.node,
  history: _propTypes.PropTypes.object,
  store: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  return state;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Root));

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    '::after': {
      display: 'block',
      visibility: 'hidden',
      clear: 'both',

      height: '0',

      content: '\'\''
    }
  };
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _chatbotActions = __webpack_require__(528);

var _reactRedux = __webpack_require__(14);

var _link = __webpack_require__(265);

var _link2 = _interopRequireDefault(_link);

var _api = __webpack_require__(45);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1128);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelWithLink = function (_Component) {
  (0, _inherits3.default)(LabelWithLink, _Component);

  function LabelWithLink(props) {
    (0, _classCallCheck3.default)(this, LabelWithLink);
    return (0, _possibleConstructorReturn3.default)(this, (LabelWithLink.__proto__ || (0, _getPrototypeOf2.default)(LabelWithLink)).call(this, props));
  }

  (0, _createClass3.default)(LabelWithLink, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var dispatch = nextProps.dispatch,
          component = nextProps.component,
          components = nextProps.components;

      if (!!component && !!component.link && component.link.hasOwnProperty('fired') && !component.link.fired && component.link.method === 'POST') {
        this.sendOtp(dispatch, component, components);
      }
    }
  }, {
    key: 'sendOtp',
    value: function sendOtp(dispatch, component, components) {
      var body = component.link.mapping.reduce(function (res, m) {
        return (0, _extends4.default)({}, res, (0, _defineProperty3.default)({}, m.key, components[m.componentId].value));
      }, {});

      if (!!(0, _keys2.default)(body).reduce(function (res, k) {
        return res && !!body[k];
      }, true)) {
        dispatch((0, _componentsActions.updateComponent)(component.id, {
          link: (0, _extends4.default)({}, component.link, {
            fired: true
          })
        }));
        (0, _api.request)({
          endpoint: component.link.url,
          method: component.method,
          body: body /*, apiRoot*/
        }).then(function (json) {
          dispatch((0, _componentsActions.updateComponent)(component.link.requestIdComponentId, {
            value: json.requestId
          }));
        });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch;


      if (!this.input.disabled) {
        if (component.status.indexOf('checkonly') > -1) {
          if (component.value !== 'selected') {
            dispatch((0, _componentsActions.updateComponent)(component.id, {
              value: 'selected'
            }));
            if (!!component.action) {
              dispatch((0, _componentsActions.updateComponent)(component.id, component.action));
            }
          }
        } else {
          dispatch((0, _componentsActions.updateComponent)(component.id, {
            value: this.input.checked ? 'selected' : ''
          }));
        }
      }
    }
  }, {
    key: 'handleOpenChatbot',
    value: function handleOpenChatbot(e) {
      e.preventDefault();
      var dispatch = this.props.dispatch;

      dispatch((0, _chatbotActions.open)());
    }
  }, {
    key: 'handleSendOtpClick',
    value: function handleSendOtpClick(e) {
      e.preventDefault();
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          component = _props2.component,
          components = _props2.components;

      this.sendOtp(dispatch, component, components);
    }
  }, {
    key: 'render',
    value: function render() {
      var component = this.props.component;

      var chunks = component.id === "SZ0023-SS0048_DM0089_RI1056" || component.id === "PRIVACY-PRIVACY" ? component.description.split(/\s(?=\s§\w*§)|(§\w*§)/g) : component.value.split(/\s(?=\s§\w*§)|(§\w*§)/g);

      var conditionalProps = void 0;
      if (component.link && component.link.method !== 'POST') {
        conditionalProps = {
          href: component.link.url,
          target: component.link.target
        };
      } else {
        conditionalProps = {
          href: '#',
          onClick: this.handleSendOtpClick.bind(this)
        };
      }

      if (component.id === 'TERMINA_PROCEDURA-RESIDENZA_ITA') {
        conditionalProps.onClick = this.handleOpenChatbot.bind(this);
      }
      var Element = component.element ? component.element : component.id === "SZ0023-SS0048_DM0089_RI1056" ? 'span' : 'p';

      return _react2.default.createElement(
        Element,
        (0, _withStyles.css)(this.props.styles.component && this.props.component.id !== "SZ0023-SS0048_DM0089_RI1056", this.props.styles['component--block'], this.props.styles.label),
        chunks.map(function (chunk, index) {
          if (component.link) {
            return chunk === component.link.placeholder ? _react2.default.createElement(
              _link2.default,
              (0, _extends4.default)({ key: index }, conditionalProps),
              component.link.text
            ) : chunk;
          }
          if (component.links) {
            var link = component.links.find(function (l) {
              return l.placeholder === chunk;
            });

            if (!!link) {
              return _react2.default.createElement(
                _link2.default,
                (0, _extends4.default)({
                  key: index,
                  href: link.url,
                  target: link.target
                }, conditionalProps),
                link.text
              );
            } else {
              return chunk;
            }
          }
        }),
        component.additionalView && component.additionalView(this.props)
      );
    }
  }]);
  return LabelWithLink;
}(_react.Component);

LabelWithLink.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components;

  return { component: components[ownProps.component.id], components: components };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(LabelWithLink));

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _button;

  var colors = _ref.colors,
      layouts = _ref.layouts;
  return {
    button: (_button = {
      fontSize: '.8rem',

      display: 'inline-block',
      width: 'auto !important',
      margin: '30px 0',
      padding: '1rem 1.5rem',

      //letterSpacing: '2px',
      //textTransform: 'uppercase',
      fontWeight: 'bold'
    }, (0, _defineProperty3.default)(_button, 'fontSize', '1rem'), (0, _defineProperty3.default)(_button, 'fontFamily', 'Muli'), (0, _defineProperty3.default)(_button, 'color', colors.button.text.default), (0, _defineProperty3.default)(_button, 'border', '2px solid ' + colors.button.border.default), (0, _defineProperty3.default)(_button, 'borderRadius', layouts.button.borderRadius), (0, _defineProperty3.default)(_button, 'outline', 'none'), (0, _defineProperty3.default)(_button, 'background', colors.button.bg.default), (0, _defineProperty3.default)(_button, (0, _breakTo2.default)('smaller'), {
      padding: '1rem 2rem'
    }), (0, _defineProperty3.default)(_button, ':disabled', {
      color: colors.button.text.disabled,
      border: '2px solid ' + colors.button.border.disabled,
      cursor: 'not-allowed !important'
    }), _button),

    // 'button--primary': {
    //   color: colors.button.text.primary,
    //   background: colors.button.bg.primary,
    //   border: colors.button.border.primary
    // },
    'button--primary': {
      color: colors.button.border.disabled,
      background: colors.button.bg.default,
      border: '2px solid ' + colors.button.border.disabled
    },
    'button--primaryEnabled': {
      color: colors.button.text.primary,
      background: colors.button.bg.primary,
      border: '2px solid ' + colors.button.border.primary
    },
    'button--secondry': {
      color: colors.button.text.default,
      background: colors.button.bg.default,
      border: '2px solid ' + colors.button.border.default,
      marginLeft: '12%',
      ':disabled': {
        color: colors.button.text.disabled,
        border: '2px solid ' + colors.button.border.disabled,
        cursor: 'not-allowed !important'
      }
    },
    'button--secondryEnabled': {
      color: colors.button.text.primary,
      background: colors.button.bg.primary,
      border: '2px solid ' + colors.button.border.primary,
      marginLeft: '12%'
    },
    'button--delete': {
      color: colors.button.text.primary,
      background: colors.button.bg.delete,
      border: colors.button.border.primary,
      marginLeft: '22%'
    },

    'button--inverse': {
      color: colors.button.bg.default,
      border: '2px solid ' + colors.button.text.primary,
      background: 'transparent'
    },

    'button--primary-inverse': {
      color: colors.button.bg.primary,
      border: '2px solid ' + colors.button.text.primary,
      background: colors.button.text.primary
    },

    'button--firma': {
      color: colors.button.text.default,
      border: '2px solid ' + colors.button.border.default,
      background: colors.button.bg.default
    },

    'button--sella': {
      color: colors.button.text.sella,
      border: '2px solid ' + colors.button.bg.sella,
      background: colors.button.bg.sella
    },
    'button--active': {
      color: colors.button.text.active,
      border: '2px solid ' + colors.button.bg.active,
      background: colors.button.bg.active,
      cursor: 'default !important'
    },

    'button--pull-left': {
      float: 'left'
    },

    'button--pull-right': {
      float: 'right'
    },
    'button--display-none': {
      display: 'none'
    }
  };
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _stepActions = __webpack_require__(28);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _result = __webpack_require__(138);

var _result2 = _interopRequireDefault(_result);

var _authLocale = __webpack_require__(1177);

var Locale = _interopRequireWildcard(_authLocale);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1178);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthModal = function (_Component) {
  (0, _inherits3.default)(AuthModal, _Component);

  function AuthModal(props) {
    (0, _classCallCheck3.default)(this, AuthModal);
    return (0, _possibleConstructorReturn3.default)(this, (AuthModal.__proto__ || (0, _getPrototypeOf2.default)(AuthModal)).call(this, props));
  }

  (0, _createClass3.default)(AuthModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _stepActions.authStep)({}));
    }
  }, {
    key: 'getResource',
    value: function getResource(key, property) {
      /**
       * @remarks locale forced to it
       * @todo internationalization
       */
      return Locale.getResource(key, 'it', property);
    }
  }, {
    key: 'getInputType',
    value: function getInputType(callbackType) {
      var res = '';
      switch (callbackType) {
        case 'PasswordCallback':
          res = 'password';
          break;
        default:
          res = 'text';
          break;
      }
      return res;
    }
  }, {
    key: 'onValueChange',
    value: function onValueChange(e) {
      var _props = this.props,
          auth = _props.auth,
          dispatch = _props.dispatch;


      auth.callbacks.find(function (c) {
        return !!c.input && c.input[0].name === e.target.name;
      }).input[0].value = e.target.value;

      dispatch((0, _stepActions.updateAuthStep)(auth));
    }
  }, {
    key: 'handleClick',
    value: function handleClick() /*e*/{
      var dispatch = this.props.dispatch;

      dispatch((0, _stepActions.toggleLoginForm)(false));
    }
  }, {
    key: 'getOutputType',
    value: function getOutputType(val) {
      var map = { '0': 'info', '1': 'warning', '2': 'error' };
      return map[val];
    }
  }, {
    key: 'printOutputCallbacks',
    value: function printOutputCallbacks() {
      var _this2 = this;

      var _props2 = this.props,
          auth = _props2.auth,
          styles = _props2.styles;


      if (!!auth.callbacks) {
        return auth.callbacks.filter(function (callback) {
          return callback.type === 'TextOutputCallback';
        }).map(function (callback, index) {
          return _react2.default.createElement(
            _result2.default,
            {
              key: index,
              title: _this2.getResource('MESSAGE_TYPE_' + callback.output[1].value),
              type: _this2.getOutputType(callback.output[1].value)
            },
            _react2.default.createElement(
              'div',
              null,
              _this2.getResource(callback.output[0].value)
            ),
            callback.output[0].value === 'USER_CODE' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                (0, _withStyles.css)(styles.title),
                'Sei gi\xE0 cliente Sella.it'
              ),
              _react2.default.createElement(
                'div',
                (0, _withStyles.css)(styles.subtitle),
                _react2.default.createElement(
                  'div',
                  null,
                  'Diventare cliente \xE8 ancora pi\xF9 semplice!'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  'Effettua l\'accesso per continuare con la registrazione semplificata.'
                )
              )
            ) : '',
            callback.output[0].value === 'ERROR_PASSWORD_EXPIRED' ? _react2.default.createElement(
              'div',
              null,
              '\xC8 possibile richiedere lo sblocco seguendo la procedura dal portale',
              ' ',
              _react2.default.createElement(
                'a',
                { rel: 'nofollow', href: 'https://www.sella.it', target: '_blank' },
                'sella.it'
              )
            ) : '',
            callback.output[0].value.indexOf('WARN_PASSWORD_REMINDER:') > -1 ? _react2.default.createElement(
              'div',
              null,
              '\xC8 possibile aggiornare ora la password seguendo la procedura dal portale',
              ' ',
              _react2.default.createElement(
                'a',
                { rel: 'nofollow', href: 'https://www.sella.it', target: '_blank' },
                'sella.it'
              )
            ) : '',
            callback.output[0].value === 'ERROR_PIN_EXPIRED' ? _react2.default.createElement(
              'div',
              null,
              '\xC8 possibile richiedere lo sblocco seguendo la procedura dal portale',
              ' ',
              _react2.default.createElement(
                'a',
                { rel: 'nofollow', href: 'https://www.sella.it', target: '_blank' },
                'sella.it'
              )
            ) : '',
            callback.output[0].value.indexOf('WARN_PIN_REMINDER:') > -1 ? _react2.default.createElement(
              'div',
              null,
              '\xC8 possibile aggiornare ora il PIN seguendo la procedura dal portale',
              ' ',
              _react2.default.createElement(
                'a',
                { rel: 'nofollow', href: 'https://www.sella.it', target: '_blank' },
                'sella.it'
              )
            ) : ''
          );
        });
      }
    }
  }, {
    key: 'printInputCallbacks',
    value: function printInputCallbacks() {
      var _this3 = this;

      var _props3 = this.props,
          auth = _props3.auth,
          styles = _props3.styles;


      if (!!auth.callbacks) {
        return auth.callbacks.filter(function (callback) {
          return callback.type !== 'TextOutputCallback';
        }).map(function (callback, index) {
          return _react2.default.createElement(
            'div',
            (0, _extends3.default)({
              key: index
            }, (0, _withStyles.css)(styles.component, styles['component--block'])),
            callback.input.map(function (input, iindex) {
              return _react2.default.createElement('input', (0, _extends3.default)({
                key: iindex,
                name: input.name,
                type: _this3.getInputType(callback.type),
                value: input.value
              }, (0, _withStyles.css)(styles.input), {
                placeholder: _this3.getResource(callback.output[iindex].value, 'placeholder'),
                onChange: function onChange(event) {
                  _this3.onValueChange(event);
                }
              }));
            }),
            callback.output.filter(function (output) {
              return output.name === 'prompt';
            }).map(function (output, oindex) {
              return _react2.default.createElement('span', (0, _extends3.default)({
                key: oindex
              }, (0, _withStyles.css)(styles.label, styles['label--auth'], callback.input[oindex].value !== '' && styles['label--active']), {
                dangerouslySetInnerHTML: {
                  __html: _this3.getResource(output.value, 'label')
                }
              }));
            })
          );
        });
      }
    }
  }, {
    key: 'printTitle',
    value: function printTitle() {
      var _props4 = this.props,
          auth = _props4.auth,
          styles = _props4.styles;


      if (!!auth.callbacks) {
        return auth.callbacks.filter(function (callback) {
          return callback.type !== 'TextOutputCallback';
        }).map(function (callback, index) {
          if (callback.output[0].value === 'USER_CODE') {
            return _react2.default.createElement(
              'div',
              { key: index },
              _react2.default.createElement(
                'h1',
                (0, _withStyles.css)(styles.title),
                'Sei gi\xE0 cliente Sella.it'
              ),
              _react2.default.createElement(
                'div',
                (0, _withStyles.css)(styles.subtitle),
                _react2.default.createElement(
                  'div',
                  null,
                  'Diventare cliente \xE8 ancora pi\xF9 semplice!'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  'Effettua l\'accesso per continuare con la registrazione semplificata.'
                )
              )
            );
          } else if (callback.output[0].value === 'INSERT_RSA_OTP') {
            return _react2.default.createElement(
              'div',
              { key: index },
              _react2.default.createElement(
                'h1',
                (0, _withStyles.css)(styles.title),
                'Inserisci il codice del token'
              ),
              _react2.default.createElement('div', (0, _withStyles.css)(styles.token))
            );
          }
        });
      }
    }
  }, {
    key: 'getProperErrorMessage',
    value: function getProperErrorMessage(errorMessage) {
      switch (errorMessage) {
        case 'Dear colleague,<BR/>We got a system error during Authentication process!!':
          return 'Errore durante il processo di autenticazione, si prega di riprovare.';
        case 'Invalid two password chars entered.':
          return 'I caratteri di controllo immessi non sono validi';
        default:
          return errorMessage;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props5 = this.props,
          dispatch = _props5.dispatch,
          auth = _props5.auth,
          isCloseButtonHidden = _props5.isCloseButtonHidden,
          styles = _props5.styles;

      return _react2.default.createElement(
        'div',
        (0, _withStyles.css)(styles.modal),
        _react2.default.createElement('div', (0, _withStyles.css)(styles.bg)),
        !isCloseButtonHidden ? _react2.default.createElement('div', (0, _extends3.default)({}, (0, _withStyles.css)(styles.closeBtn), {
          onClick: function onClick(event) {
            return _this4.handleClick(event);
          }
        })) : '',
        _react2.default.createElement(
          'div',
          (0, _withStyles.css)(styles.wrapper),
          _react2.default.createElement(
            'div',
            (0, _withStyles.css)(styles.content),
            !!auth.errorMessage ? _react2.default.createElement(
              _result2.default,
              { title: this.getResource('MESSAGE_TYPE_1'), type: 'error' },
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: this.getProperErrorMessage(auth.errorMessage)
                }
              })
            ) : '',
            this.printTitle(),
            this.printOutputCallbacks(),
            this.printInputCallbacks(),
            _react2.default.createElement(
              'div',
              (0, _withStyles.css)(styles.buttons),
              !auth.errorMessage ? _react2.default.createElement(_button2.default, {
                type: 'sella',
                action: function action() {
                  return dispatch((0, _stepActions.authStep)(auth));
                },
                text: 'Login'
              }) : _react2.default.createElement(_button2.default, {
                type: 'sella',
                action: function action() {
                  return dispatch((0, _stepActions.authStep)({}));
                },
                text: 'Riprova'
              })
            )
          )
        )
      );
    }
  }]);
  return AuthModal;
}(_react.Component);

AuthModal.propTypes = {
  auth: _propTypes.PropTypes.object,
  isCloseButtonHidden: _propTypes.PropTypes.bool,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var auth = state.step.auth;

  return (0, _extends3.default)({}, state, { auth: auth || {} });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(AuthModal));

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _webcamjs = __webpack_require__(509);

var _webcamjs2 = _interopRequireDefault(_webcamjs);

__webpack_require__(1179);

var _reactRedux = __webpack_require__(14);

var _stepActions = __webpack_require__(28);

var _componentsActions = __webpack_require__(19);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1180);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebcamModal = function (_Component) {
  (0, _inherits3.default)(WebcamModal, _Component);

  function WebcamModal(props) {
    (0, _classCallCheck3.default)(this, WebcamModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WebcamModal.__proto__ || (0, _getPrototypeOf2.default)(WebcamModal)).call(this, props));

    _this.state = {
      value: props.component.value,
      showWebcam: false
    };

    _webcamjs2.default.set({
      // 'force_flash': true,
      swfURL: _utils.CONTEXT_ROOT + '/assets/webcam.swf'
    });
    return _this;
  }

  (0, _createClass3.default)(WebcamModal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.component.value && this.props.component.uploadType === 'SELFIE') {
        this.showWebcam();
      }
    }
  }, {
    key: 'screenshot',
    value: function screenshot() {
      var that = this;
      _webcamjs2.default.snap(function (dataUri) {
        that.setState({ value: dataUri });
        if (!!document.getElementById('my_camera') && document.getElementById('my_camera').childNodes[1].tagName === 'VIDEO') {
          _webcamjs2.default.reset();
        }
      });
    }
  }, {
    key: 'showWebcam',
    value: function showWebcam() {
      this.setState({ showWebcam: true });
      setTimeout(function () {
        return _webcamjs2.default.attach('#my_camera');
      }, 100);
    }
  }, {
    key: 'showUploader',
    value: function showUploader() {
      var _props = this.props,
          dispatch = _props.dispatch,
          component = _props.component;

      dispatch((0, _stepActions.hideWebcamModal)());
      document.getElementById(component.id + '--out').click();
    }
  }, {
    key: 'closePopup',
    value: function closePopup() /*e*/{
      var dispatch = this.props.dispatch;

      if (!!document.getElementById('my_camera') && document.getElementById('my_camera').childNodes[1].tagName === 'VIDEO') {
        _webcamjs2.default.reset();
      }
      dispatch((0, _stepActions.hideWebcamModal)());
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      this.setState({
        value: null
      });
      this.showWebcam();
    }
  }, {
    key: 'onAccept',
    value: function onAccept() {
      var _props2 = this.props,
          component = _props2.component,
          dispatch = _props2.dispatch;


      if (!!this.state.value) {
        if (this.state.value !== component.value) {
          (0, _utils.resizeImage)(this.state.value, _utils.MAX_IMAGE_UPLOAD_SIZE).then(function (dataUri) {
            var time = new Date().getTime();
            dispatch((0, _componentsActions.uploadFile)((0, _extends3.default)({}, component, { value: dataUri }), { name: 'captured_' + time + '.jpg' }));
          });
        }

        dispatch((0, _stepActions.hideWebcamModal)());
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        (0, _withStyles.css)(this.props.styles.modal, this.props.component.status.indexOf('hidden') > -1 && this.props.styles['modal--hidden']),
        _react2.default.createElement('div', (0, _withStyles.css)(this.props.styles.bg)),
        _react2.default.createElement('div', (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.closeBtn), {
          onClick: this.closePopup.bind(this)
        })),
        _react2.default.createElement(
          'div',
          (0, _withStyles.css)(this.props.styles.wrapper),
          _react2.default.createElement(
            'div',
            (0, _withStyles.css)(this.props.styles.content, this.props.styles['content--selfie']),
            _react2.default.createElement(
              'h1',
              (0, _withStyles.css)(this.props.styles.title),
              this.props.component.modalTitle
            ),
            !this.state.value && this.state.showWebcam ? _react2.default.createElement('div', {
              id: 'my_camera',
              style: {
                height: Math.ceil(window.innerHeight / 2),
                width: Math.ceil(4 * window.innerHeight / 2 / 3),
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '1rem'
              }
            }) : null,
            this.state.value ? _react2.default.createElement('img', (0, _extends3.default)({
              ref: 'screenshot'
            }, (0, _withStyles.css)(this.props.styles.screenshot), {
              src: this.state.value
            })) : null,
            _react2.default.createElement(
              'div',
              (0, _withStyles.css)(this.props.styles['selfie-buttons']),
              !!this.state.showWebcam && !this.state.value ? _react2.default.createElement(_button2.default, {
                type: 'primary-inverse',
                action: this.screenshot.bind(this),
                text: 'Scatta'
              }) : null,
              this.state.value ? _react2.default.createElement(_button2.default, {
                type: 'inverse',
                action: this.onCancel.bind(this),
                text: this.state.showWebcam ? 'Riprova' : 'Webcam'
              }) : null,
              this.state.value ? _react2.default.createElement(_button2.default, {
                type: 'primary-inverse',
                action: this.onAccept.bind(this),
                text: 'Conferma'
              }) : null,
              !this.state.showWebcam && this.props.component.uploadType !== 'SELFIE' ? _react2.default.createElement(_button2.default, {
                type: 'inverse',
                action: this.showUploader.bind(this),
                text: 'Sfoglia'
              }) : null,
              !this.state.showWebcam && !this.state.value && this.props.component.uploadType !== 'SELFIE' ? _react2.default.createElement(_button2.default, {
                type: 'primary-inverse',
                action: this.showWebcam.bind(this),
                text: 'Webcam'
              }) : null
            )
          )
        )
      );
    }
  }]);
  return WebcamModal;
}(_react.Component);

WebcamModal.propTypes = {
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components;

  return {
    component: components[ownProps.component.id],
    components: components
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(WebcamModal));

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1182);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./index.css", function() {
		var newContent = require("!!../../css-loader/index.js!./index.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
module.exports = __webpack_require__(1053);


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(174);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(65);

var _reactRouter = __webpack_require__(133);

var _reactRouterRedux = __webpack_require__(252);

var _reactHotLoader = __webpack_require__(1054);

var _configureStore = __webpack_require__(1059);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _root = __webpack_require__(529);

var _root2 = _interopRequireDefault(_root);

__webpack_require__(1216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)();
// import injectTapEventPlugin from 'react-tap-event-plugin'


var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, {
  selectLocationState: function selectLocationState(state) {
    return state.routing;
  }
});

//---App initialization

/**
 * we require next line to support onTouchTap event
 * which will solve a lot of "click" problems for mobile devices
 */
// injectTapEventPlugin()

(0, _reactDom.render)(_react2.default.createElement(
  _reactHotLoader.AppContainer,
  null,
  _react2.default.createElement(_root2.default, { history: history, store: store })
), document.getElementById('root'));

//---Hot Module Replacement
if (false) {
  module.hot.accept('./containers/root', function () {
    var NextApp = require('./containers/root').default;

    (0, _reactDom.render)(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(NextApp, { history: history, store: store })
    ), document.getElementById('root'));
  });
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1055)


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(1056);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(1057);

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(1058);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(2);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _eventsMap;

exports.default = configureStore;

var _redux = __webpack_require__(167);

var _reduxThunk = __webpack_require__(505);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _rootReducer = __webpack_require__(1060);

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _stepActions = __webpack_require__(28);

var _reduxBeacon = __webpack_require__(503);

var _googleTagManager = __webpack_require__(1101);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Define an event

var stepUpdate = function stepUpdate(action, state) {
  return {
    hitType: 'dispatch',
    contactId: state.step.contactId || '',
    partnership: state.routing.partnership,
    floodLightGroup: (0, _utils.getFloodLightGroup)(state.step),
    floodLightActivity: (0, _utils.getFloodLightActivity)(state.step),
    floodLightQuantity: state.step.number === 6 ? '1' : '0',
    convention: state.routing.convention,
    actorSlug: (0, _utils.getActorSlug)(state.step),
    stepSlug: (0, _utils.getStepSlug)(state.step, state.product, state),
    productCode: (0, _utils.getProductCode)(state.step, state.product, state),
    stepError: state.step.hasServerErrors ? state.step.serverErrorMessage : '',
    isUnderage: !!state.step.isUnderage ? 'yes' : 'no',
    isParent: !!state.step.isParent ? 'yes' : 'no'
  };
};

var loginFormUpdate = function loginFormUpdate(action, state) {
  return {
    hitType: 'dispatch',
    actorSlug: (0, _utils.getActorSlug)(state.step),
    stepSlug: !!action.loginFormVisible ? 'auth' : ''
  };
};

// Map the event to a Redux action
var eventsMap = (_eventsMap = {}, (0, _defineProperty3.default)(_eventsMap, _stepActions.PUSH_ANALYTICS, stepUpdate), (0, _defineProperty3.default)(_eventsMap, _stepActions.TOGGLE_LOGIN_FORM, loginFormUpdate), _eventsMap);

var middlewares = [_reduxThunk2.default, (0, _reduxBeacon.createMiddleware)(eventsMap, (0, _googleTagManager.GoogleTagManager)())];

if (false) {
  var _require = require('redux-logger'),
      createLogger = _require.createLogger;

  var logger = createLogger({
    collapsed: true
  });
  middlewares.push(logger);
}

function configureStore(state) {
  var store = (0, _redux.createStore)(_rootReducer2.default, state, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares)));

  return store;
}

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(167);

var _productReducer = __webpack_require__(1061);

var _productReducer2 = _interopRequireDefault(_productReducer);

var _stepReducer = __webpack_require__(1096);

var _stepReducer2 = _interopRequireDefault(_stepReducer);

var _componentsReducer = __webpack_require__(1097);

var _componentsReducer2 = _interopRequireDefault(_componentsReducer);

var _widgetsReducer = __webpack_require__(1098);

var _widgetsReducer2 = _interopRequireDefault(_widgetsReducer);

var _routingReducer = __webpack_require__(1099);

var _routingReducer2 = _interopRequireDefault(_routingReducer);

var _chatbotReducer = __webpack_require__(1100);

var _chatbotReducer2 = _interopRequireDefault(_chatbotReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  product: _productReducer2.default,
  step: _stepReducer2.default,
  components: _componentsReducer2.default,
  widgets: _widgetsReducer2.default,
  routing: _routingReducer2.default,
  chatbot: _chatbotReducer2.default
});

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _productActions = __webpack_require__(510);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Product reducer
 * @module  {Reducer} productReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _productActions.UPDATE_PRODUCT:
      var pAndC = (0, _utils.getPartnershipAndConventionFromRawValue)(action.flow);
      return (0, _extends3.default)({}, state, action.product, pAndC, {
        flow: (0, _utils.getFlowRawValue)(action.product.properties[action.product.prodCode].partnership || pAndC.partnership, action.product.properties[action.product.prodCode].convenzione || pAndC.convention)
      }, action.product.properties[action.product.prodCode], {
        properties: undefined
      });
    default:
      return state;
  }
};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166);
__webpack_require__(106);
__webpack_require__(132);
__webpack_require__(1063);
__webpack_require__(1066);
__webpack_require__(1067);
module.exports = __webpack_require__(20).Promise;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(164);
var global = __webpack_require__(33);
var ctx = __webpack_require__(66);
var classof = __webpack_require__(256);
var $export = __webpack_require__(26);
var isObject = __webpack_require__(54);
var aFunction = __webpack_require__(126);
var anInstance = __webpack_require__(257);
var forOf = __webpack_require__(135);
var speciesConstructor = __webpack_require__(514);
var task = __webpack_require__(515).set;
var microtask = __webpack_require__(1065)();
var newPromiseCapabilityModule = __webpack_require__(259);
var perform = __webpack_require__(516);
var promiseResolve = __webpack_require__(517);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(34)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(260)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(131)($Promise, PROMISE);
__webpack_require__(518)(PROMISE);
Wrapper = __webpack_require__(20)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(519)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(33);
var macrotask = __webpack_require__(515).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(128)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(26);
var core = __webpack_require__(20);
var global = __webpack_require__(33);
var speciesConstructor = __webpack_require__(514);
var promiseResolve = __webpack_require__(517);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(26);
var newPromiseCapability = __webpack_require__(259);
var perform = __webpack_require__(516);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
__webpack_require__(106);
module.exports = __webpack_require__(1069);


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(61);
var get = __webpack_require__(258);
module.exports = __webpack_require__(20).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166);
__webpack_require__(106);
__webpack_require__(132);
__webpack_require__(1071);
__webpack_require__(1075);
__webpack_require__(1077);
__webpack_require__(1078);
module.exports = __webpack_require__(20).Set;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(520);
var validate = __webpack_require__(262);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(521)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(66);
var IObject = __webpack_require__(230);
var toObject = __webpack_require__(105);
var toLength = __webpack_require__(162);
var asc = __webpack_require__(1073);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1074);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
var isArray = __webpack_require__(464);
var SPECIES = __webpack_require__(34)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(26);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(522)('Set') });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(135);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(523)('Set');


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(524)('Set');


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(1080);
module.exports = __webpack_require__(20).Array.from;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(66);
var $export = __webpack_require__(26);
var toObject = __webpack_require__(105);
var call = __webpack_require__(512);
var isArrayIter = __webpack_require__(513);
var toLength = __webpack_require__(162);
var createProperty = __webpack_require__(1081);
var getIterFn = __webpack_require__(258);

$export($export.S + $export.F * !__webpack_require__(519)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(53);
var createDesc = __webpack_require__(127);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1083);
module.exports = __webpack_require__(20).Object.values;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(26);
var $values = __webpack_require__(1084)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(104);
var toIObject = __webpack_require__(92);
var isEnum = __webpack_require__(129).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1086), __esModule: true };

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166);
__webpack_require__(106);
__webpack_require__(132);
__webpack_require__(1087);
__webpack_require__(1088);
__webpack_require__(1089);
__webpack_require__(1090);
module.exports = __webpack_require__(20).Map;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(520);
var validate = __webpack_require__(262);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(521)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(26);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(522)('Map') });


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(523)('Map');


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(524)('Map');


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetListSchema = undefined;

var _normalizr = __webpack_require__(224);

var _stateExtension = __webpack_require__(95);

var componentSchema = new _normalizr.schema.Entity('components', {}, {
  processStrategy: function processStrategy(entity, parent) {
    entity.id = parent.name + '-' + entity.name;
    return entity;
  }
});

var widgetSchema = new _normalizr.schema.Entity('widgets', {
  components: [componentSchema]
}, {
  idAttribute: function idAttribute(entity) {
    return entity.name;
  },
  mergeStrategy: function mergeStrategy(entity) {
    // adds the widget code as suffix for JOLLY widgets to avoid ambiiguity
    // (even if the name property is reassigned, only the id changes)
    if (entity.name === 'JOLLY') {
      return entity.name + '_' + entity.code;
    } else {
      return entity.name;
    }
  },
  processStrategy: function processStrategy(entity) {
    // merges the widget properties from the stateExtension
    if (_stateExtension.WIDGETS[entity.name]) {
      for (var key in _stateExtension.WIDGETS[entity.name]) {
        if (key === 'status' && entity.name === 'TITOLARE_EFFETTIVO' && !!entity[key] && entity[key][0] === 'ignoreValidation') entity[key] = entity[key];else if (key !== 'components') entity[key] = _stateExtension.WIDGETS[entity.name][key];
      }
    }

    return entity;
  }
});

var widgetListSchema = exports.widgetListSchema = [widgetSchema];

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getPosPlanComponent = exports.getPosPlanComponent = function getPosPlanComponent() {
  return {
    widgets: [{
      code: '19500',
      name: 'POSPLAN',
      bundleLink: null,
      bundleCode: null,
      group: 'POSPLAN',
      groupTitle: '',
      errorMessage: [],
      components: [{
        id: 'idPOSPlan',
        name: 'PLAN',
        value: '',
        status: [''],
        errorMessage: [],
        //validations: {
        // isRequired: true,
        //default: [
        //   {
        //     validate: VALIDATION_METHODS.filled,
        //     getErrorMessage:VALIDATION_ERRORS.filled
        //   }
        //]
        //},
        //type: 'label',
        type: 'InfoTool',
        cleanName: 'PLAN', //'PromoCode',
        active: true,
        isDisabled: false
      }],
      active: true,
      status: []

    }]

  };
};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getprivacyfabrick = undefined;

var _stateExtension = __webpack_require__(95);

var getprivacyfabrick = exports.getprivacyfabrick = function getprivacyfabrick() {
    return {
        widgets: [{
            code: '19503',
            name: 'PRIVACY_FABRICK',
            bundleLink: null,
            bundleCode: null,
            group: 'PRIVACY_FABRICK',
            groupTitle: '',
            components: [{
                id: 'PRIVACY_FABRICK',
                name: 'FABCHECKBOX',
                active: true,
                type: 'privacyfabrick',
                position: '3',
                value: '',
                cleanName: '',
                // validations: {
                //   isRequired: true,
                //   default: [
                //     {
                //       validate: VALIDATION_METHODS.bool,
                //       getErrorMessage: VALIDATION_ERRORS.filled
                //     }
                //   ]
                // },
                status: [],
                errorMessage: []
            }],
            active: true,
            status: [],
            errorMessage: []
        }]
    };
};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getFirmeComponent = exports.getFirmeComponent = function getFirmeComponent() {
  return {
    widgets: [{
      code: '15793',
      name: 'ATTIVA_REVOCA_FIRMA',
      bundleLink: null,
      bundleCode: null,
      position: 1,
      components: [{
        name: 'FIRMA',
        value: 'ATTIVA',
        rawValue: null,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: 'sella',
        pullTo: 'right'
        // position: 3
      }, {
        name: 'LABEL',
        value: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
        rawValue: null,
        status: [],
        errorMessage: [],
        validations: []
      }, {
        name: 'IFRAME',
        value: '',
        rawValue: null,
        active: true,
        status: ['hidden'],
        errorMessage: [],
        validations: [],
        values: [],
        type: 'iframe',
        position: 5
      }, {
        name: 'LINK_ADDENDUM',
        value: 'http://www.trusttechnologies.it/document_loader.aspx?idDocument=58',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: null
      }, {
        name: 'LINK_ISTRUZIONI',
        value: 'http://www.trusttechnologies.it/document_loader.aspx?idDocument=150',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: null
      }, {
        name: 'LINK_MANUALE',
        value: 'https://www.sella.it/SSRDocumentDisplayer?dtdPG=IS_OP_SELLADIGIT_PIN_SMS&dtdPE=1',
        rawValue: null,
        active: true,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: null
      }, {
        name: 'VISIONE',
        value: '',
        rawValue: null,
        active: true,
        status: ['checkonly'],
        errorMessage: [],
        validations: [],
        values: [],
        type: null
      }, {
        name: 'MODAL',
        value: '',
        title: 'Messaggio',
        active: true,
        status: ['hidden'],
        type: 'alert'
      }],
      status: [],
      errorMessage: []
      /*  {
         code: '15794',
         name: 'FIRMA',
         bundleLink: null,
         bundleCode: null,
         position: 2,
         components: [
           {
             name: 'IFRAME',
             value: '',
             rawValue: null,
             active: true,
             status: [],
             errorMessage: [],
             validations: [],
             values: [],
             type: null
           }
         ],
         status: [],
         errorMessage: []
       } */
    }]
  };
};

var getDiFarmaComponents = exports.getDiFarmaComponents = function getDiFarmaComponents() {
  return {
    widgets: [{
      code: '15865',
      name: 'DIFARMA',
      bundleLink: null,
      bundleCode: null,
      position: 3,
      components: [{
        name: 'LABEL',
        value: 'Firma il contratto',
        active: true,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        position: 1
      }, {
        name: 'SUB_LABEL',
        value: 'Ho letto il contratto ed accetto termini e condizioni',
        // 'Ti verr&agrave; inviato un codice alfanumerico via SMS che dovrai utilizzare per firmare il contratto assieme al PIN di firma.',          
        active: true,
        status: [],
        errorMessage: [],
        validations: [],
        values: [],
        type: 'label',
        position: 2
      }, {
        name: 'FIRMA',
        value: 'Accetta',
        rawValue: null,
        active: true,
        disabled: true,
        status: [],
        url: '',
        errorMessage: [],
        validations: [],
        values: [],
        type: 'inverse',
        pullTo: 'right',
        position: 3
        /* action: {
          value: 'Attivata',
          type: 'inverse',
          disabled: true,
          fetch: {
            attivata: {
              url: 'wgt/sign/url',
              body: {},
              mappingEvent: 'IframeSrcSetter'
            }
          },
          updateComponentId: '',
          toggleVisibility: {
            show: {
              fields: ['DIFARMA_0-IFRAME']
            }
          }
        } */
      }, {
        name: 'IFRAME',
        value: '',
        rawValue: null,
        active: true,
        status: ['hidden'],
        errorMessage: [],
        validations: [],
        values: [],
        type: 'iframe',
        position: 4
      }],
      status: [],
      errorMessage: []
    }]
  };
};

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _stepActions = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isStepLoading: false,
  isLoading: true,
  isParent: null,
  isUnderage: null,
  contactId: null,
  guid: null,
  widgets_: [],
  pendingActions: [],
  last: false,
  name: '',
  number: null,
  hasServerErrors: false,
  serverErrorMessage: '',
  serverErrorStatus: '',
  userCounter: 0,
  titolareList: [],
  config: {},
  titoWidgets: [],
  titoComponents: [],
  isAPIResError: false

  /**
   * Step reducer
   * @module  {Reducer} stepReducer
   *
   * @param {Object} state      The current state
   * @param {Object} action     The action
   * @return {Object}           The new state
   */
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _stepActions.HANDLE_SERVER_ERRORS:
      return (0, _extends3.default)({}, state, {
        hasServerErrors: action.hasServerErrors,
        serverErrorMessage: action.serverErrorMessage,
        serverErrorStatus: action.serverErrorStatus,
        isStepLoading: state.isStepLoading && !action.hasServerErrors,
        isLoading: state.isLoading && !action.hasServerErrors,
        pendingActions: !action.hasServerErrors ? state.pendingActions : []
      });

    case _stepActions.TOGGLE_LOGIN_FORM:
      var auth = state.auth;

      if (!action.loginFormVisible) {
        auth = !!state.auth.tokenId ? state.auth : null;
      }

      return (0, _extends3.default)({}, state, {
        loginFormVisible: action.loginFormVisible,
        auth: auth
      });

    case _stepActions.UPDATE_AUTH_STEP:
      return (0, _extends3.default)({}, state, {
        auth: action.auth
      });

    case _stepActions.DEAL_ACTION_TOKEN:
      var pendingActions = state.pendingActions || [];
      if (!!action.token) {
        if (!action.token.dispose) {
          pendingActions = pendingActions.concat(action.token);
        } else {
          var idxToRemove = pendingActions.findIndex(function (a) {
            return a.id === action.token.id;
          });
          if (idxToRemove > -1) {
            pendingActions.splice(idxToRemove, 1);
          }
        }
      } else {
        pendingActions = state.pendingActions;
      }

      var blockingActions = pendingActions.filter(function (a) {
        return !!a.blocking;
      });

      return (0, _extends3.default)({}, state, {
        isStepLoading: blockingActions.length > 0,
        isLoading: blockingActions.length > 0 && action.isLoading,
        pendingActions: pendingActions
      });

    case _stepActions.UPDATE_STEP:
      return (0, _extends3.default)({}, state, {
        number: action.step.number,
        name: action.step.name,
        last: action.step.last,
        widgets_: action.step.widgets_,
        contactId: action.step.contactId,
        guid: action.step.guid,
        titoWidgets: action.step.titoWidgets,
        titoComponents: action.step.titoComponents,
        isLoading: action.isLoading !== undefined ? action.isLoading : state.isLoading,
        isParent: action.step.name === 'resume' ? null : state.isParent,
        isUnderage: action.step.name === 'resume' ? null : state.isUnderage,
        auth: action.step.auth || null,
        config: action.step.config || {},
        isStepLoading: false,
        isAPIResError: false
      });

    case _stepActions.SHOW_WEBCAM_MODAL:
      return (0, _extends3.default)({}, state, {
        webcamComponent: action.component
      });

    case _stepActions.HIDE_WEBCAM_MODAL:
      return (0, _extends3.default)({}, state, {
        webcamComponent: null
      });

    case _stepActions.SHOW_ADDRESS_MODAL:
      return (0, _extends3.default)({}, state, {
        addressComponent: action.component
      });

    case _stepActions.HIDE_ADDRESS_MODAL:
      return (0, _extends3.default)({}, state, {
        addressComponent: null
      });

    case _stepActions.SET_IS_UNDERAGE:
      return (0, _extends3.default)({}, state, {
        isUnderage: action.isUnderage
      });

    case _stepActions.SET_IS_PARENT:
      return (0, _extends3.default)({}, state, {
        isParent: action.isParent
      });

    case _stepActions.SET_CONTACT_INFO:
      return (0, _extends3.default)({}, state, action.contact);

    case _stepActions.SET_REQUEST_LIST:
      return (0, _extends3.default)({}, state, {
        requestList: action.requestList
      });
    case _stepActions.SET_TITOLARE_LIST:
      return (0, _extends3.default)({}, state, {
        titolareList: action.titolareList
      });

    case _stepActions.SET_CONTRACT_LIST:
      return (0, _extends3.default)({}, state, {
        contractList: action.contractList,
        userCounter: state.userCounter
      });
    case _stepActions.SHOW_LOADING:
      return (0, _extends3.default)({}, state, {
        isStepLoading: true
      });
    case _stepActions.HIDE_LOADING:
      return (0, _extends3.default)({}, state, {
        isStepLoading: false
      });
    case _stepActions.USER_COUNTER:
      return (0, _extends3.default)({}, state, {
        userCounter: action.userCounter
      });
    case _stepActions.ENABLE_BUTTON:
      return (0, _extends3.default)({}, state, {
        disableButton: false
      });
    case _stepActions.DISABLE_BUTTON:
      return (0, _extends3.default)({}, state, {
        disableButton: true
      });
    case _stepActions.SHOW_API_ALERT_MODAL:
      return (0, _extends3.default)({}, state, {
        isAPIResError: true,
        isStepLoading: false
      });
    default:
      return state;
  }
};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _componentsActions = __webpack_require__(19);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Components Reducer
 * @module  {Reducer} componentReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _componentsActions.UPDATE_ALL_COMPONENTS:
      if ((0, _utils.arraysEqual)((0, _keys2.default)(state), (0, _keys2.default)(action.components || {}))) {
        // this loop avoids to refetch the select options if the flow returns validation errors on step
        (0, _keys2.default)(action.components).forEach(function (k) {
          return action.components[k].values = state[k].values;
        });

        return (0, _extends4.default)({}, action.components);
      } else {
        return (0, _keys2.default)(action.components).reduce(function (newState, k) {
          newState[k] = (0, _extends4.default)({}, state[k], action.components[k]);
          return newState;
        }, {});
      }
    case _componentsActions.UPDATE_COMPONENT:
    case _componentsActions.SIDE_UPDATE_COMPONENT:
    case _componentsActions.VALIDATE_COMPONENT_SUCCESS:
    case _componentsActions.VALIDATE_COMPONENT_FAILED:
    case _componentsActions.SIDE_VALIDATE_COMPONENT_SUCCESS:
    case _componentsActions.SIDE_VALIDATE_COMPONENT_FAILED:
    case _componentsActions.SERVER_VALIDATE_COMPONENT_SUCCESS:
    case _componentsActions.SERVER_VALIDATE_COMPONENT_FAILED:
    case _componentsActions.AUTOFILL_COMPONENT_START:
    case _componentsActions.AUTOFILL_COMPONENT_DONE:
    case _componentsActions.AUTOFILL_COMPONENT_FAILED:
      var newState = (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.component.id, (0, _extends4.default)({}, state[action.component.id], action.component)));
      return newState;
    case _componentsActions.QUESTIONARIO_COMPONENT:
      /* */
      return newState;
    default:
      return state;
  }
};

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(4);

var _extends4 = _interopRequireDefault(_extends3);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _widgetsActions = __webpack_require__(136);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Widget reducer
 * @module  {Reducer} widgetsReducer
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _widgetsActions.UPDATE_ALL_WIDGETS:
      if ((0, _utils.arraysEqual)((0, _keys2.default)(state), (0, _keys2.default)(action.widgets || {}))) {
        return (0, _extends4.default)({}, action.widgets);
      } else {
        return (0, _keys2.default)(action.widgets).reduce(function (newState, k) {
          newState[k] = (0, _extends4.default)({}, state[k], action.widgets[k]);
          return newState;
        }, {});
      }
    case _widgetsActions.UPDATE_WIDGET:
    case _widgetsActions.SIDE_UPDATE_WIDGET:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.widget.name, (0, _extends4.default)({}, state[action.widget.name], action.widget)));
    default:
      return state;
  }
};

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRouterRedux = __webpack_require__(252);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  locationBeforeTransitions: null
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
    var pAndC = (0, _utils.getPartnershipAndConventionFromUrl)(action.payload);

    if (pAndC.partnership === 'HYPE4TIM') {
      /* TODO: */
      document.title = 'Attivazione Carta TIMpersonal';
    } else {
      document.title = 'Richiesta POS';
    }

    return (0, _extends3.default)({}, state, {
      locationBeforeTransitions: action.payload,
      flow: (0, _utils.getFlowRawValue)(pAndC.partnership, pAndC.convention)
    }, pAndC, {
      container: action.payload.pathname.replace(/\/([^\/]+)\/.*/, '$1'),
      argument: action.payload.pathname.replace(/\/[^\/]+\/[^\/]+\/([^\/]+).*/, '$1')
    });
  }

  return state;
};

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _chatbotActions = __webpack_require__(528);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Components Reducer
 * @module  {Reducer} chatbotReduced
 *
 * @param {Object} state      The current state
 * @param {Object} action     The action
 * @return {Object}           The new state
 */
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { open: false };
  var action = arguments[1];

  switch (action.type) {
    case _chatbotActions.OPEN:
      return (0, _extends3.default)({}, state, { open: true });
    case _chatbotActions.CLOSE:
      return (0, _extends3.default)({}, state, { open: false });
    default:
      return state;
  }
};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1102);

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GoogleTagManager = function GoogleTagManager() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$dataLayerName = _ref.dataLayerName,
      dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName;

  return function (events) {
    if (typeof window === 'undefined') {
      return;
    }
    if (!window[dataLayerName] || typeof window[dataLayerName].push !== 'function') {
      throw new Error('redux-beacon error: window.' + dataLayerName + ' is not defined. Have you forgotten to include Google Tag Manager and dataLayer?');
    }
    events.forEach(function (event) {
      var eventToPush = function () {
        if (event.event === undefined && event.hitType !== undefined) {
          return Object.assign({}, event, { event: event.hitType });
        }
        return event;
      }();
      window[dataLayerName].push(eventToPush);
    });
  };
};

module.exports = { GoogleTagManager: GoogleTagManager };

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(133);

var _qs = __webpack_require__(124);

var _qs2 = _interopRequireDefault(_qs);

var _utils = __webpack_require__(12);

var _root = __webpack_require__(529);

var _root2 = _interopRequireDefault(_root);

var _app = __webpack_require__(1104);

var _app2 = _interopRequireDefault(_app);

var _resume = __webpack_require__(1197);

var _resume2 = _interopRequireDefault(_resume);

var _list = __webpack_require__(1203);

var _list2 = _interopRequireDefault(_list);

var _reupload = __webpack_require__(1207);

var _reupload2 = _interopRequireDefault(_reupload);

var _endOfTheRide = __webpack_require__(1209);

var _endOfTheRide2 = _interopRequireDefault(_endOfTheRide);

var _notFound = __webpack_require__(1211);

var _notFound2 = _interopRequireDefault(_notFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = _react2.default.createElement(
  _reactRouter.Route,
  { path: _utils.CONTEXT_ROOT + '/', component: _root2.default },
  _react2.default.createElement(_reactRouter.IndexRedirect, { to: _utils.CONTEXT_ROOT + '/request/pos_azienda_easynolo' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: _utils.CONTEXT_ROOT + '/request', component: _root2.default },
    _react2.default.createElement(_reactRouter.IndexRedirect, { to: _utils.CONTEXT_ROOT + '/request/pos_azienda_easynolo' })
  ),
  _react2.default.createElement(_reactRouter.Route, {
    path: _utils.CONTEXT_ROOT + '/oauth-request/:flow/:target',
    onEnter: function onEnter(route, replace) {
      var query = route.location.query;

      var newQuery = (0, _extends3.default)({}, query, {
        embedded: route.params.target === 'embedded' ? '1' : undefined
      });
      replace(_utils.CONTEXT_ROOT + '/request/' + route.params.flow + _qs2.default.stringify(newQuery, { addQueryPrefix: true }));
    }
  }),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/request/:flow', component: _app2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/request/:flow/:stepSlug', component: _app2.default }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: _utils.CONTEXT_ROOT + '/resume', component: _resume2.default },
    _react2.default.createElement(_reactRouter.IndexRedirect, { to: _utils.CONTEXT_ROOT + '/resume/pos_azienda_easynolo' })
  ),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/resume/:flow', component: _resume2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/resume/:flow/:guid', component: _resume2.default }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: _utils.CONTEXT_ROOT + '/status', component: _list2.default },
    _react2.default.createElement(_reactRouter.IndexRedirect, { to: _utils.CONTEXT_ROOT + '/status/pos_azienda_easynolo' })
  ),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/status/:flow', component: _list2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/reupload/:flow/:guid', component: _reupload2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/thanks/:flow', component: _endOfTheRide2.default }),
  _react2.default.createElement(_reactRouter.Route, {
    path: _utils.CONTEXT_ROOT + '/thanks/:flow/:guid',
    component: _endOfTheRide2.default
  }),
  _react2.default.createElement(_reactRouter.Route, { path: _utils.CONTEXT_ROOT + '/pending/:flow', component: _endOfTheRide2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '*', component: _notFound2.default })
);

exports.default = routes;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getOwnPropertyNames = __webpack_require__(1105);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _stepActions = __webpack_require__(28);

var _utils = __webpack_require__(12);

var _page = __webpack_require__(112);

var _page2 = _interopRequireDefault(_page);

var _flowbar = __webpack_require__(1118);

var _flowbar2 = _interopRequireDefault(_flowbar);

var _header = __webpack_require__(113);

var _header2 = _interopRequireDefault(_header);

var _wrapper = __webpack_require__(114);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _title = __webpack_require__(115);

var _title2 = _interopRequireDefault(_title);

var _widgets = __webpack_require__(172);

var _widgets2 = _interopRequireDefault(_widgets);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _footer = __webpack_require__(116);

var _footer2 = _interopRequireDefault(_footer);

var _spinner = __webpack_require__(137);

var _spinner2 = _interopRequireDefault(_spinner);

var _modal = __webpack_require__(173);

var _modal2 = _interopRequireDefault(_modal);

var _authmodal = __webpack_require__(533);

var _authmodal2 = _interopRequireDefault(_authmodal);

var _webcammodal = __webpack_require__(534);

var _webcammodal2 = _interopRequireDefault(_webcammodal);

var _result = __webpack_require__(138);

var _result2 = _interopRequireDefault(_result);

var _titolareEffictivo = __webpack_require__(1181);

var _titolareEffictivo2 = _interopRequireDefault(_titolareEffictivo);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1184);

var _styles2 = _interopRequireDefault(_styles);

var _progressBar = __webpack_require__(1185);

var _selectPlan = __webpack_require__(1188);

var _planToolbar = __webpack_require__(1191);

var _planAlertPopup = __webpack_require__(1194);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import AddressModal from '../../components/addressmodal'
var App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));

    _this.fetchPOSPlan = function (guid) {
      var url = 'OnboardRequestDetails/FetchPOSPlan';
      var body = { GUID: guid };
      _this.setState({ posplanInDB: '' });
      (0, _api.FetchPOSPlan)(url, body).then(function (json) {
        var posplanInDB = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toLowerCase();
        _this.setState({ posplanInDB: posplanInDB });
      });
    };

    _this.state = {
      posplanInDB: ''
    };
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'urlParam',
    value: function urlParam(name) {
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results == null) {
        return null;
      } else {
        return decodeURI(results[1]) || 0;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
      //const {step,widgets,components}=getState()
      //const urlParams = new URLSearchParams(window.location.search);
      //const queryParam = urlParams.get('plan');

      var queryParam = this.urlParam('plan');
      if ((0, _keys2.default)(this.props.components).length === 0) {
        if (queryParam !== null || queryParam !== '') {
          dispatch((0, _stepActions.startProcess)({
            partnership: this.props.partnership,
            convention: this.props.convention,
            proof: this.props.proof,
            location: this.props.location
          }));
        }
      }
    }
  }, {
    key: 'enableNextButtonColor',
    value: function enableNextButtonColor(nextProps) {
      var _this2 = this;

      var step = nextProps.step,
          components = nextProps.components;

      var isStepFilled = true;
      if (!!components && (0, _getOwnPropertyNames2.default)(components).length > 0) {
        delete step.isFormFilled;
        (0, _keys2.default)(components).filter(function (c) {
          return components[c].validations && components[c].validations.isRequired;
        }).forEach(function (k) {
          if ((components[k].type === 'text' || components[k].type === 'radio' && (k === 'SZ0022-SS0209_DM0850_RI0950' || k === 'SZ0022-SS0209_DM0850_RI0951' || k === 'SZ0011-SS0231_DM0887_RI0992' || k === 'SZ0011-SS0231_DM0887_RI0993') || components[k].type === 'date' || components[k].type === 'selectbox' || components[k].type === 'checkbox' || components[k].type === 'TextArea' || components[k].type === 'file' && k !== 'SELFIE-SELFIE_UPLOAD') && components[k].status.indexOf('hidden') < 0 && !components[k].isDisabled) {
            var Titolare_Effettivo_CheckBoxes = ['SZ0024-SS0049_DM0094_RI0500', 'SZ0024-SS0049_DM0094_RI0501', 'SZ0024-SS0049_DM0534_RI0502', 'SZ0024-SS0049_DM0534_RI0503', 'SZ0024-SS0049_DM0525_RI0576', 'SZ0024-SS0049_DM0525_RI0577'];
            var Ulteriori_info_CheckBoxes = ['SZ0022-SS0208_DM0849_RI0947', 'SZ0022-SS0208_DM0849_RI0948', 'SZ0022-SS0208_DM0849_RI0949'];
            var Ulteriori_info_RadioButtons = ['SZ0022-SS0209_DM0850_RI0950', 'SZ0022-SS0209_DM0850_RI0951'];
            var Altre_informazioni_Checkboxes = ['SZ0011-SS0230_DM0886_RI0989', 'SZ0011-SS0230_DM0886_RI0990', 'SZ0011-SS0230_DM0886_RI0991'];
            var Altre_informazioni_RadioButtons = ['SZ0011-SS0231_DM0887_RI0992', 'SZ0011-SS0231_DM0887_RI0993'];
            if (k === "TELEFONO_FISSO-NUMERO" && step.number === 3) isStepFilled = isStepFilled && !components[k].errorMessage[0];else if (step.number === 4 && (k.includes("SZ0024-SS0049_DM0094_RI0504") || k.includes("SZ0024-SS0049_DM0094_RI0505") || k.includes("SZ0023-SS0048_DM0089_RI0"))) {
              if (!!components["SZ0024-SS0049_DM0094_RI0504"] && !!components["SZ0024-SS0049_DM0094_RI0505"]) {
                var holdersCheckbox = (!!components["SZ0023-SS0048_DM0089_RI0121"] && components["SZ0023-SS0048_DM0089_RI0121"].value || !!components["SZ0023-SS0048_DM0089_RI1058"] && components["SZ0023-SS0048_DM0089_RI1058"].value || //Add validations for Questions begin - end
                !!components["SZ0023-SS0048_DM0089_RI1059"] && components["SZ0023-SS0048_DM0089_RI1059"].value || !!components["SZ0023-SS0048_DM0089_RI1060"] && components["SZ0023-SS0048_DM0089_RI1060"].value || !!components["SZ0023-SS0048_DM0089_RI1061"] && components["SZ0023-SS0048_DM0089_RI1061"].value || !!components["SZ0023-SS0048_DM0089_RI1056"] && components["SZ0023-SS0048_DM0089_RI1056"].value || !!components["SZ0023-SS0048_DM0089_RI0126"] && components["SZ0023-SS0048_DM0089_RI0126"].value || !!components["SZ0023-SS0048_DM0089_RI0381"] && components["SZ0023-SS0048_DM0089_RI0381"].value) && (!!components["SZ0024-SS0049_DM0094_RI0504"] && components["SZ0024-SS0049_DM0094_RI0504"].value || !!components["SZ0024-SS0049_DM0094_RI0505"] && components["SZ0024-SS0049_DM0094_RI0505"].value);
                isStepFilled = isStepFilled && !components[k].errorMessage[0] && holdersCheckbox;
              } else {
                var holdersCheckbox1 = !!components["SZ0023-SS0048_DM0089_RI0121"] && components["SZ0023-SS0048_DM0089_RI0121"].value || !!components["SZ0023-SS0048_DM0089_RI1058"] && components["SZ0023-SS0048_DM0089_RI1058"].value || //Add validations for Questions begin - end
                !!components["SZ0023-SS0048_DM0089_RI1059"] && components["SZ0023-SS0048_DM0089_RI1059"].value || !!components["SZ0023-SS0048_DM0089_RI1060"] && components["SZ0023-SS0048_DM0089_RI1060"].value || !!components["SZ0023-SS0048_DM0089_RI1061"] && components["SZ0023-SS0048_DM0089_RI1061"].value || !!components["SZ0023-SS0048_DM0089_RI1056"] && components["SZ0023-SS0048_DM0089_RI1056"].value || !!components["SZ0023-SS0048_DM0089_RI0126"] && components["SZ0023-SS0048_DM0089_RI0126"].value || !!components["SZ0023-SS0048_DM0089_RI0381"] && components["SZ0023-SS0048_DM0089_RI0381"].value;
                isStepFilled = isStepFilled && !components[k].errorMessage[0] && holdersCheckbox1;
              }
            } else if (step.number === 4 && Titolare_Effettivo_CheckBoxes.indexOf(k) > -1) {
              var isCheckBoxesGR1filled = components["SZ0024-SS0049_DM0094_RI0500"].value || components["SZ0024-SS0049_DM0094_RI0501"].value;
              var isCheckBoxesGR2filled = components["SZ0024-SS0049_DM0534_RI0502"].value || components["SZ0024-SS0049_DM0534_RI0503"].value;
              var isCheckBoxesGR3filled = components["SZ0024-SS0049_DM0525_RI0576"].value || components["SZ0024-SS0049_DM0525_RI0577"].value;
              isStepFilled = isStepFilled && !components[k].errorMessage[0] && isCheckBoxesGR1filled && isCheckBoxesGR2filled && isCheckBoxesGR3filled;
            } else if (step.number === 4 && Ulteriori_info_CheckBoxes.indexOf(k) > -1) {
              var ulteriinfoCheckbox = components["SZ0022-SS0208_DM0849_RI0947"].value || components["SZ0022-SS0208_DM0849_RI0948"].value || components["SZ0022-SS0208_DM0849_RI0949"].value;
              isStepFilled = isStepFilled && !components[k].errorMessage[0] && ulteriinfoCheckbox;
            } else if (step.number === 4 && Ulteriori_info_RadioButtons.indexOf(k) > -1) {
              var ulteriinfoRadios = components["SZ0022-SS0209_DM0850_RI0950"].value || components["SZ0022-SS0209_DM0850_RI0951"].value;
              isStepFilled = isStepFilled && !components[k].errorMessage[0] && ulteriinfoRadios;
            } else if (step.number === 3 && Altre_informazioni_Checkboxes.indexOf(k) > -1) {
              var altreinfoCheckbox = components["SZ0011-SS0230_DM0886_RI0989"].value || components["SZ0011-SS0230_DM0886_RI0990"].value || components["SZ0011-SS0230_DM0886_RI0991"].value;
              isStepFilled = isStepFilled && !components[k].errorMessage[0] && altreinfoCheckbox;
            } else if (step.number === 3 && Altre_informazioni_RadioButtons.indexOf(k) > -1) {
              var altreinfoRadios = components["SZ0011-SS0231_DM0887_RI0992"].value || components["SZ0011-SS0231_DM0887_RI0993"].value;
              isStepFilled = isStepFilled && !components[k].errorMessage[0] && altreinfoRadios;
            } else if (step.number === 3 && _stepActions.Patrimonio_CheckBoxes.indexOf(k) > -1) {
              var patrimonioCheckBoxes = false;
              _stepActions.Patrimonio_RadioButtons.forEach(function (radiobtn) {
                if (components[radiobtn].value === 'selected') {
                  if (radiobtn === 'SZ0010-SS0212_DM0855_RI0937') {
                    _stepActions.Patrimonio_CheckBoxes_RBG1.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0938') {
                    _stepActions.Patrimonio_CheckBoxes_RBG2.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0939') {
                    _stepActions.Patrimonio_CheckBoxes_RBG3.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0940') {
                    _stepActions.Patrimonio_CheckBoxes_RBG4.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0941') {
                    _stepActions.Patrimonio_CheckBoxes_RBG5.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0942') {
                    _stepActions.Patrimonio_CheckBoxes_RBG6.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0943') {
                    _stepActions.Patrimonio_CheckBoxes_RBG7.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0944') {
                    _stepActions.Patrimonio_CheckBoxes_RBG8.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  } else if (radiobtn === 'SZ0010-SS0212_DM0855_RI0945') {
                    _stepActions.Patrimonio_CheckBoxes_RBG9.forEach(function (chbox) {
                      patrimonioCheckBoxes = patrimonioCheckBoxes || !!components[chbox].active && components[chbox].active && components[chbox].value === 'selected';
                    });
                  }
                  // else if(radiobtn==='SZ0010-SS0212_DM0855_RI0946')
                  // {
                  //   Patrimonio_CheckBoxes_RBG10.forEach(chbox => {
                  //     patrimonioCheckBoxes=patrimonioCheckBoxes ||  (!!components[chbox].active && components[chbox].active && components[chbox].value === 'selected')
                  //   })
                  //  }
                }
              });
              isStepFilled = !components[k].errorMessage[0] && patrimonioCheckBoxes;
            } else isStepFilled = isStepFilled && !!components[k].value && !components[k].errorMessage[0];

            if (step.number === 3 && _this2.props.product.prodCode === _utils.posProducts.prodPersonaFisica && !!components["PROFESSIONE_ATTIVITA-PROFESSIONE"] && components["PROFESSIONE_ATTIVITA-PROFESSIONE"].value !== '' && (k === "PROFESSIONE_ATTIVITA-ATTIVITA" || k === "PROFESSIONE_ATTIVITA-SETTORE")) {
              if (components[k].value === '') {
                isStepFilled = isStepFilled && components["PROFESSIONE_ATTIVITA-ATTIVITA"].values.length === 0 || components["PROFESSIONE_ATTIVITA-SETTORE"].values.length === 0;
              }
            }
          }
        });
        if (isStepFilled) {
          step.isFormFilled = true;
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var dispatch = this.props.dispatch;
      var number = this.props.step.number;
      var step = nextProps.step,
          components = nextProps.components;


      this.enableNextButtonColor(nextProps);

      if (number === 1 && !!step.auth && !!step.auth.tokenId && !!step.loginFormVisible) {
        dispatch((0, _stepActions.getNextStep)(this.props.proof));
        dispatch((0, _stepActions.authenticated)());
      }

      if (number === 1 && !!step.auth && !!step.auth.tokenId && step.hasServerErrors && step.serverErrorStatus === 'unauthorized') {
        dispatch((0, _stepActions.unauthenticated)());
        dispatch((0, _stepActions.toggleLoginForm)(true));
      }

      var oldStep = this.props.step;

      var _ref = oldStep || {},
          oldGuid = _ref.guid;

      var newGuid = step.guid;

      if (oldGuid !== newGuid) {
        this.fetchPOSPlan(newGuid);
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      var dispatch = this.props.dispatch;

      dispatch((0, _stepActions.getPrevStep)(this.props.proof));
      // window.scrollTo(0, 0)
    }
  }, {
    key: 'goForward',
    value: function goForward() {
      var _props = this.props,
          dispatch = _props.dispatch,
          components = _props.components;
      var last = this.props.step.last;


      if (!!last) {
        dispatch((0, _stepActions.acknowledgeContract)(this.props.components['TERMINA_PROCEDURA-CONTRATTO']));
      } else {

        //@hack for CF login
        // if (
        //   number === 1 &&
        //   !!this.props.components['CODICE_FISCALE-CF'] &&
        //   !!this.props.components['CODICE_FISCALE-CF'].loginRequired
        // ) {
        //   let isStepFilled = true

        //   Object.keys(components)
        //     .filter(c => c.validations && c.validations.isRequired)
        //     .forEach(k => {
        //       if (
        //         components[k].type === 'text' &&
        //         components[k].status.indexOf('hidden') < 0
        //       ) {
        //         isStepFilled = isStepFilled && !!components[k].value
        //       }
        //     })

        //   if (isStepFilled && (!auth || !auth.tokenId)) {
        //     dispatch(toggleLoginForm(true))
        //   } else {
        //     dispatch(getNextStep(this.props.proof))
        //   }
        // } else {
        dispatch((0, _stepActions.getNextStep)(this.props.proof));
        //}

      }
      //window.scrollTo(0, 0)
      (0, _utils.scrollToFirstInvalidComponent)(components);
    }
  }, {
    key: 'addTitolare',
    value: function addTitolare() {
      var dispatch = this.props.dispatch;

      dispatch((0, _stepActions.addTitolareUser)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      //const urlParams = new URLSearchParams(window.location.search);
      //const queryParam = urlParams.get('plan');
      var queryPlanParam = this.urlParam('plan');
      var queryRefParam = this.urlParam('ref');
      if ((queryPlanParam === null || queryPlanParam === "" || queryPlanParam === 0) && this.props.step.number === 1 && (this.props.step.contactId === '' || this.props.step.contactId === null)) {
        return _react2.default.createElement(
          _page2.default,
          null,
          _react2.default.createElement(
            _header2.default,
            null,
            _react2.default.createElement(_progressBar.ProgressBar, { StepNumber: 0, NoOfSteps: 0 })
          ),
          _react2.default.createElement(_selectPlan.SelectPlan, {
            richiestaNumero: '00000000', queryPlanParam: queryPlanParam, queryRefParam: queryRefParam, pathName: this.props.location.pathname, flatSearch: 'plan=flat',
            flexSearch: 'plan=flex' }),
          _react2.default.createElement(_footer2.default, { StepNumber: '0' })
        );
      } else {
        var IOS11Rules = (0, _utils.ios11Instructions)();
        if (!this.globalStylesOverrides) {
          this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
        }

        if (this.props.step.isLoading || !(!!this.props.components && (0, _keys2.default)(this.props.components).length > 0) && !this.props.step.hasServerErrors) {
          return _react2.default.createElement(_spinner2.default, { type: 'global' });
        }

        if (this.props.step.hasServerErrors && this.props.step.serverErrorStatus !== 'unauthorized') {
          return _react2.default.createElement(
            _modal2.default,
            null,
            _react2.default.createElement(
              _result2.default,
              { type: 'error' },
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: this.props.step.serverErrorMessage
                }
              }),
              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: IOS11Rules } })
            )
          );
        }
        var newTitle = void 0;
        if (this.props.product.prodCode === _utils.posProducts.prodAzienda && this.props.step.number === 1) {
          newTitle = 'Stai iniziando la richiesta per la categoria TUTTE LE SOCIETÁ (ad esempio: sas, ss, snc, srl, spa o sapa)';
        } else if (this.props.product.prodCode === _utils.posProducts.prodDittaInd && this.props.step.number === 1) {
          newTitle = 'Stai iniziando la richiesta per la categoria LIBERO PROFESSIONISTA O DITTA INDIVIDUALE';
        } else if (this.props.product.prodCode === _utils.posProducts.prodPersonaFisica && this.props.step.number === 1) {
          newTitle = 'Stai iniziando la richiesta per la categoria BED AND BREAKFAST';
        }
        return _react2.default.createElement(
          _page2.default,
          null,
          this.props.step.loginFormVisible ? _react2.default.createElement(_authmodal2.default, null) : null,
          this.props.step.isStepLoading ? _react2.default.createElement(_spinner2.default, { type: 'step' }) : null,
          this.props.step.webcamComponent ? _react2.default.createElement(_webcammodal2.default, {
            key: this.props.step.webcamComponent.name,
            component: this.props.step.webcamComponent
          }) : null,
          _react2.default.createElement(
            _header2.default,
            {
              whiteLabel: !!this.props.routing.locationBeforeTransitions.query.embedded
              //plan={queryParam}
            },
            (this.props.components["POSPLAN-PLAN"] || queryPlanParam) && _react2.default.createElement(_planToolbar.PlanToolbar, { component: this.props.components["POSPLAN-PLAN"], posplanInDB: this.state.posplanInDB, queryRefParam: queryRefParam, queryParam: queryPlanParam, dispatch: this.props.dispatch }),
            this.props.widgets.FLOW_BAR ?
            //<Flowbar widget={this.props.widgets.FLOW_BAR} />
            _react2.default.createElement(_progressBar.ProgressBar, { StepNumber: !!this.props.step && this.props.step.number, NoOfSteps: !!this.props.widgets.FLOW_BAR.components && this.props.widgets.FLOW_BAR.components.length }) : null
          ),
          !!this.props.components['FLOW_BAR-STEP_' + this.props.step.number] ? this.props.step.number === 1 ? _react2.default.createElement(_title2.default, {
            title: newTitle,
            contactId: this.props.step.contactId
          }) : _react2.default.createElement(_title2.default, {
            title: this.props.components['FLOW_BAR-STEP_' + this.props.step.number].value,
            contactId: this.props.step.contactId,
            isLastStep: this.props.step.last
          }) : this.props.step.last === true ? _react2.default.createElement(_title2.default, {
            title: 'Accetta i contratti',
            contactId: this.props.step.contactId,
            isLastStep: this.props.step.last
          }) : null,
          (this.state.posplanInDB && queryPlanParam && queryPlanParam.toLowerCase() !== this.state.posplanInDB || this.props.components["POSPLAN-PLAN"] && this.props.components["POSPLAN-PLAN"].value && queryPlanParam && queryPlanParam.toLowerCase() !== this.props.components["POSPLAN-PLAN"].value.toLowerCase()) && _react2.default.createElement(_planAlertPopup.PlanAlertPopup, { plan: this.state.posplanInDB || this.props.components["POSPLAN-PLAN"].value, location: this.props.location, queryRefParam: queryRefParam }),
          this.props.step.name === "I titolari dell'azienda" ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_titolareEffictivo2.default, {
              titolareList: this.props.step.titolareList,
              widgets: this.props.widgets,
              components: this.props.components
            }),
            _react2.default.createElement(
              _wrapper2.default,
              null,
              _react2.default.createElement(_button2.default, {
                id: 'bt-prev',
                text: 'Indietro',
                action: function action() {
                  _this3.goBack();
                },
                disabled: this.props.step.number === 1 || !!this.props.step.last
              }),
              _react2.default.createElement(_button2.default, (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.listColumn), {
                id: 'bt-add',
                text: 'Aggiungi titolare',
                action: function action() {
                  _this3.addTitolare();
                }
                //type="secondry"
                , type: !!this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'] && this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'].value == "selected" ? "secondryEnabled" : "secondry",
                disabled: this.props.step.titolareList.length === 5
              })),
              _react2.default.createElement(_button2.default, {
                id: 'bt-next',
                text: 'Continua',
                action: function action() {
                  _this3.goForward();
                }
                //type={!!this.props.step.isFormFilled && this.props.step.isFormFilled?'primaryEnabled':'primary'}
                , type: !!this.props.step.isFormFilled && this.props.step.isFormFilled && !!this.props.components['TITOLARE_OWNER-EFFETTIVO_NO'] && this.props.components['TITOLARE_OWNER-EFFETTIVO_NO'].value === 'selected' || !!this.props.components["TITOLARE_DATA-EFFETTIVO_SI"] && this.props.components["TITOLARE_DATA-EFFETTIVO_SI"].value === '' && !!this.props.components["TITOLARE_DATA-EFFETTIVO_NO"] && this.props.components["TITOLARE_DATA-EFFETTIVO_NO"].value === '' ? 'primaryEnabled' : 'primary',
                disabled: !!this.props.widgets["TITOLARE_EFFETTIVO"] && !!this.props.widgets["TITOLARE_EFFETTIVO"].status && this.props.widgets["TITOLARE_EFFETTIVO"].status[0] === 'ignoreValidation' ? !(!!this.props.components["TITOLARE_DATA-EFFETTIVO_SI"] && this.props.components["TITOLARE_DATA-EFFETTIVO_SI"].value === '' && !!this.props.components["TITOLARE_DATA-EFFETTIVO_NO"] && this.props.components["TITOLARE_DATA-EFFETTIVO_NO"].value === '') && !!this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'] && this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'].value === 'selected' : !!this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'] && this.props.components['TITOLARE_OWNER-EFFETTIVO_SI'].value === 'selected',
                pullTo: 'right'
              })
            )
          ) : _react2.default.createElement(
            _wrapper2.default,
            null,
            _react2.default.createElement(_widgets2.default, {
              widgets: this.props.widgets,
              components: this.props.components,
              guid: this.props.step.guid,
              plan: queryPlanParam
            }),
            _react2.default.createElement(_button2.default, {
              id: 'bt-prev',
              text: 'Indietro',
              action: function action() {
                _this3.goBack();
              },
              disabled: this.props.step.number === 1 || !!this.props.step.last,
              display: !!this.props.step.last && 'none'
            }),
            _react2.default.createElement(_button2.default, {
              id: 'bt-next',
              text: 'Continua',
              action: function action() {
                _this3.goForward();
              },
              type: !!this.props.step.last && !!this.props.step.disableButton ? 'inverse' : !!this.props.step.isFormFilled && this.props.step.isFormFilled ? 'primaryEnabled' : 'primary',
              pullTo: 'right',
              disabled: !!this.props.step.last && !!this.props.step.disableButton
            }),
            _react2.default.createElement(_clearfix2.default, null)
          ),
          _react2.default.createElement(_footer2.default, { plan: queryPlanParam })
        );
      }
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  step: _propTypes.PropTypes.object.isRequired,
  widgets: _propTypes.PropTypes.object.isRequired,
  components: _propTypes.PropTypes.object.isRequired,
  dispatch: _propTypes.PropTypes.func.isRequired,
  partnership: _propTypes.PropTypes.string,
  convention: _propTypes.PropTypes.string,
  proof: _propTypes.PropTypes.object
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var deltaProps = (0, _extends3.default)({}, state, (0, _utils.getPartnershipAndConventionFromRawValue)(ownProps.params.flow), {
    proof: {
      value: ownProps.location.query.proof,
      type: ownProps.location.query.proofType
    }
  });

  return deltaProps;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(App));

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1106), __esModule: true };

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1107);
var $Object = __webpack_require__(20).Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(241)('getOwnPropertyNames', function () {
  return __webpack_require__(465).f;
});


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noImportant = __webpack_require__(1109);

var aphrodite = _interopRequireWildcard(_noImportant);

var _aphroditeInterfaceFactory = __webpack_require__(499);

var _aphroditeInterfaceFactory2 = _interopRequireDefault(_aphroditeInterfaceFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var globalSelectorHandler = function globalSelectorHandler(selector, _, generateSubtreeStyles) {
  if (selector[0] !== '*') {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};

var globalExtension = { selectorHandler: globalSelectorHandler };

var myAphrodite = aphrodite.StyleSheet.extend([globalExtension]);

exports.default = (0, _aphroditeInterfaceFactory2.default)(myAphrodite);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1110);


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Module with the same interface as the core aphrodite module,
// except that styles injected do not automatically have !important
// appended to them.


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _generate = __webpack_require__(222);

var _exports2 = __webpack_require__(455);

var _exports3 = _interopRequireDefault(_exports2);

var useImportant = false; // Don't add !important to style definitions
exports['default'] = (0, _exports3['default'])(useImportant, _generate.defaultSelectorHandlers);
module.exports = exports['default'];

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _colors = __webpack_require__(1112);

var _colors2 = _interopRequireDefault(_colors);

var _fontfaces = __webpack_require__(1113);

var _fontfaces2 = _interopRequireDefault(_fontfaces);

var _fontweights = __webpack_require__(1114);

var _fontweights2 = _interopRequireDefault(_fontweights);

var _fontsizes = __webpack_require__(1115);

var _fontsizes2 = _interopRequireDefault(_fontsizes);

var _colorMapper = __webpack_require__(1116);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assetsPath = _utils.CONTEXT_ROOT + '/assets';

exports.default = {
  colors: {
    common: {
      html: {
        text: {
          default: _colors2.default.purple.default
        },
        bg: {
          default: _colors2.default.blue.default
        }
      },
      body: {
        text: {
          default: _colors2.default.purple.default
        },
        bg: {
          default: _colors2.default.neutro.light
        }
      },
      tap: {
        default: (0, _colorMapper.hexToRgba)(_colors2.default.blue.default, '.1')
      },
      selection: {
        text: { default: _colors2.default.purple.lighter },
        bg: { default: _colors2.default.blue.lightest }
      },
      separator: {
        default: _colors2.default.purple.lightest
      },
      headings: {
        h1: _colors2.default.purple.default,
        h2: _colors2.default.purple.lighter
      },
      paragraph: {
        default: _colors2.default.purple.default
      },
      utility: {
        error: {
          default: _colors2.default.utility.red.default,
          lightest: _colors2.default.utility.red.lightest
        },
        warning: {
          default: _colors2.default.utility.yellow.default,
          lightest: _colors2.default.utility.yellow.lightest
        },
        info: {
          default: _colors2.default.utility.blue.default,
          lightest: _colors2.default.utility.blue.lightest
        },
        success: {
          default: _colors2.default.utility.green.default,
          lightest: _colors2.default.utility.green.lightest
        }
      },
      text: _colors2.default.purple.default
    },
    label: {
      default: _colors2.default.blue.default,
      disabled: _colors2.default.purple.lighter,
      sellaAuth: _colors2.default.sella.light
    },
    input: {
      bg: {
        default: _colors2.default.neutro.light
      },
      border: {
        default: _colors2.default.purple.lightest,
        active: _colors2.default.blue.default,
        blink: _colors2.default.purple.lighter,
        sella: _colors2.default.sella.light
      },
      option: {
        active: _colors2.default.blue.lighter,
        hover: _colors2.default.blue.lightest
      },
      text: {
        default: _colors2.default.purple.default,
        disabled: _colors2.default.purple.default
      },
      placeholder: {
        default: _colors2.default.purple.lighter
      }
    },
    spinner: {
      dots: {
        transparent: (0, _colorMapper.hexToRgba)(_colors2.default.blue.lightest, '.2'),
        opaque: (0, _colorMapper.hexToRgba)(_colors2.default.blue.lightest, '1')
      },
      circle: {
        default: _colors2.default.blue.default
      },
      bg: {
        transparent: (0, _colorMapper.hexToRgba)(_colors2.default.blue.darker, '.8'),
        opaque: _colors2.default.blue.default
      }
    },
    header: {
      bg: _colors2.default.gray.default,
      children: {
        bg: _colors2.default.gray.default
      }
    },
    flowbar: {
      bullet: {
        default: _colors2.default.blue.lightest,
        done: _colors2.default.blue.default
      },
      line: {
        default: _colors2.default.blue.lightest,
        done: _colors2.default.blue.default
      },
      item: {
        default: _colors2.default.gray.light,
        done: _colors2.default.gray.default
      }
    },
    title: _colors2.default.purple.darker,
    subtitle: _colors2.default.purple.default,
    footer: {
      bg: _colors2.default.purple.darkest,
      text: (0, _colorMapper.hexToRgba)(_colors2.default.floral.default, '.8'),
      copyright: (0, _colorMapper.hexToRgba)(_colors2.default.floral.default, '.2'),
      label: _colors2.default.floral.default,
      link: _colors2.default.floral.default,
      linkHover: _colors2.default.floral.darker,
      linkAlt: _colors2.default.blue.default,
      linkAltHover: _colors2.default.blue.dark
    },
    flag: {
      default: _colors2.default.purple.lightest,
      disabled: _colors2.default.purple.lighter,
      checked: _colors2.default.blue.default,
      bg: _colors2.default.neutro.light
    },
    button: {
      text: {
        default: _colors2.default.blue.default,
        primary: _colors2.default.utility.white.default,
        disabled: _colors2.default.blue.default,
        sella: _colors2.default.sella.dark,
        active: _colors2.default.utility.white.default
      },
      bg: {
        default: _colors2.default.neutro.light,
        primary: _colors2.default.utility.green.dark,
        sella: _colors2.default.sella.light,
        active: _colors2.default.utility.green.lightest,
        delete: _colors2.default.utility.red.default
      },
      border: {
        primary: _colors2.default.utility.green.dark,
        default: _colors2.default.blue.default,
        disabled: _colors2.default.gray.light,
        active: _colors2.default.utility.green.lightest
      }
    },
    link: {
      text: {
        default: _colors2.default.blue.dark,
        hover: _colors2.default.blue.default
      }
    },
    widget: {
      groupTitle: {
        default: _colors2.default.purple.darker
      }
    },
    fileUpload: {
      border: {
        default: _colors2.default.purple.lightest,
        focus: _colors2.default.blue.light,
        error: _colors2.default.utility.red.default
      },
      bg: _colors2.default.neutro.light,
      text: _colors2.default.purple.default
    },
    datepicker: {
      header: {
        text: _colors2.default.floral.default,
        bg: _colors2.default.blue.default
      },
      day: {
        text: {
          default: _colors2.default.purple.default,
          hover: _colors2.default.neutro.light,
          keyboard: _colors2.default.neutro.light,
          selected: _colors2.default.neutro.light
        },
        bg: {
          hover: _colors2.default.floral.dark,
          keyboard: _colors2.default.blue.light,
          selected: _colors2.default.blue.default
        }
      },
      arrow: _colors2.default.blue.lightest
    },
    modal: {
      title: _colors2.default.floral.default,
      overlay: _colors2.default.blue.darker,
      bg: _colors2.default.neutro.light,
      closeButton: _colors2.default.blue.lightest,
      selfie: {
        contentBg: _colors2.default.neutro.light
      }
    },
    auth: {
      sella: {
        bg: _colors2.default.sella.dark,
        title: _colors2.default.sella.light,
        label: _colors2.default.sella.light,
        inputBorder: '#f1f2ef',
        off: _colors2.default.neutro.light,
        link: {
          default: _colors2.default.utility.red.default,
          hover: _colors2.default.utility.red.dark
        }
      }
    },
    requestList: {
      header: {
        text: _colors2.default.floral.default,
        bg: _colors2.default.blue.default,
        border: _colors2.default.blue.default
      },
      content: {
        text: _colors2.default.purple.default,
        bg: _colors2.default.neutro.light
      }
    },
    chatbot: {
      default: _colors2.default.blue.default
    }
  },
  spacings: {
    default: 0.5 + 'rem',
    x2: 0.5 * 2 + 'rem',
    x3: 0.5 * 3 + 'rem',
    x4: 0.5 * 4 + 'rem',
    x5: 0.5 * 5 + 'rem',
    x6: 0.5 * 6 + 'rem',
    x7: 0.5 * 7 + 'rem',
    header: {
      height: {
        default: '116px',
        /* medium: '75px',  */
        noFlowbar: '75px',
        noHeader: '75px'
      },
      children: {
        height: {
          medium: '75px'
        },
        paddingTop: { default: 0 },
        marginTop: {
          default: 0,
          noHeader: 0,
          img: 'unset'
        }
      },
      logo: {
        maxWidth: 'auto',
        width: '169px',
        height: '32px',
        /* width: '135px',
        height: '24px', */
        margin: {
          default: '1rem auto 0',
          /* medium: '1.4rem 2rem', */
          /* medium: '2rem 2rem', */
          centered: '1rem auto',
          img: 'unset'
        },
        /* position: 'absolute', */
        backgroundSize: 'contain',
        backgroundPosition: 'center center'
      }
    },
    flowbar: {
      paddingTop: {
        default: '8px'
      }
    },
    input: {
      padding: {
        top: {
          default: '.3rem'
        }
      },
      selectboxHeight: '37px'
    },
    radioImage: {
      selfie: {
        default: '54%',
        small: '54%'
      },
      virtualCard: {
        default: '51%',
        small: '51%'
      }
    },
    thankYouImg: {
      backgroundPosition: {
        default: 'center',
        smaller: 'center'
      }
    }
  },
  images: {
    logoSella: 'url(\'' + assetsPath + '/images/logosella.svg\')',
    notfound: 'url(\'' + assetsPath + '/images/404.png\')',
    welcome: 'url(\'' + assetsPath + '/images/thank_you.svg\')',
    header: 'url(\'' + assetsPath + '/images/hype_logo_header.svg\')',
    //header: `url('${assetsPath}/images/hype_logo_header.png')`,
    footer: 'url(\'' + assetsPath + '/images/hype_logo_footer.svg\')',
    selectTriangle: 'url(\'' + assetsPath + '/images/select_triangle.svg\') 99% 56% no-repeat ' + _colors2.default.neutro.light,
    closeIcon: 'url(\'' + assetsPath + '/images/close_icon.svg\')',
    closeIconSella: 'url(\'' + assetsPath + '/images/close_icon_sella.svg\')',
    rsaToken: 'url(\'' + assetsPath + '/images/token.svg\')',
    sellaItLogo: 'url(\'' + assetsPath + '/images/sella_it_logo.svg\')',
    phisicalCard: 'url(\'' + assetsPath + '/images/card_physical.svg\')',
    phisicalCardSelected: 'url(\'' + assetsPath + '/images/card_physical_selected.svg\')',
    virtualCard: 'url(\'' + assetsPath + '/images/card_virtual.svg\')',
    virtualCardSelected: 'url(\'' + assetsPath + '/images/card_virtual_selected.svg\')',
    selfie: 'url(\'' + assetsPath + '/images/selfie.svg\')',
    selfieSelected: 'url(\'' + assetsPath + '/images/selfie_selected.svg\')',
    bonifico: 'url(\'' + assetsPath + '/images/bonifico.svg\')',
    bonificoSelected: 'url(\'' + assetsPath + '/images/bonifico_selected.svg\')',
    checkboxTick: 'url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSI5cHgiIHZpZXdCb3g9IjAgMCAxMiA5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0MC4zICgzMzgzOSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Y2hlY2tib3hfbWFyazwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJTdGVwLTMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJTdGVwLS0tMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQzNS4wMDAwMDAsIC03MjQuMDAwMDAwKSIgZmlsbD0iI0ZFRkFGMiI+CiAgICAgICAgICAgIDxnIGlkPSJDb250ZW50IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MzEuMDAwMDAwLCAxMzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iRGF0aS1TZW5zaWJpbGkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA1ODguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTQiPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNy40MTUzMzk0OSwxMy42NzQ1Njg2IEM3LjgwMjc2MTQyLDE0LjA5ODU0MjYgOC40NjY4NzQ4NSwxNC4xMDk4MSA4Ljg2ODQ1NTk4LDEzLjY5OTIyMjMgTDE1LjcxNDkwNDQsNi42OTkyMjIyNSBDMTYuMTAxMDc0MSw2LjMwNDM5MTQ4IDE2LjA5NDA1Myw1LjY3MTI2NTQzIDE1LjY5OTIyMjMsNS4yODUwOTU2NCBDMTUuMzA0MzkxNSw0Ljg5ODkyNTg2IDE0LjY3MTI2NTQsNC45MDU5NDY5NyAxNC4yODUwOTU2LDUuMzAwNzc3NzUgTDcuNDM4NjQ3MjcsMTIuMzAwNzc3NyBMOC44OTE3NjM3NiwxMi4zMjU0MzE0IEw1LjczODIxMjEzLDguODc0MzUxNzYgQzUuMzY1NjU4MTYsOC40NjY2NDg0NSA0LjczMzEzNDY2LDguNDM4MTU0MjkgNC4zMjU0MzEzNiw4LjgxMDcwODI2IEMzLjkxNzcyODA2LDkuMTgzMjYyMjMgMy44ODkyMzM5LDkuODE1Nzg1NzMgNC4yNjE3ODc4NywxMC4yMjM0ODkgTDcuNDE1MzM5NDksMTMuNjc0NTY4NiBaIiBpZD0iY2hlY2tib3hfbWFyayI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+)',
    documents: {
      tris: 'url(\'' + assetsPath + '/images/tris_documenti.svg\')',
      patenteFronte: 'url(\'' + assetsPath + '/images/patente_fronte.svg\')',
      patenteRetro: 'url(\'' + assetsPath + '/images/patente_retro.svg\')',
      cartaIdentitaFronte: 'url(\'' + assetsPath + '/images/carta_identita_fronte.svg\')',
      cartaIdentitaRetro: 'url(\'' + assetsPath + '/images/carta_identita_retro.svg\')',
      passaportoFronte: 'url(\'' + assetsPath + '/images/passaporto_fronte.svg\')',
      passaportoRetro: 'url(\'' + assetsPath + '/images/passaporto_retro.svg\')',
      selfieSelected: 'url(\'' + assetsPath + '/images/selfie_selected.svg\')',
      uploaderLoading: 'url(\'' + assetsPath + '/images/spinner.png\')'
    },
    whatYouNeed: {
      documents: 'url(\'' + assetsPath + '/images/wyn_documents.svg\')',
      phone: 'url(\'' + assetsPath + '/images/wyn_phone.svg\')',
      secure: 'url(\'' + assetsPath + '/images/wyn_secure.svg\')'
    }
  },
  layouts: {
    header: {
      width: '118px',
      height: '44px'
    },
    button: {
      borderRadius: '4px'
    }
  },
  fontFamilies: {
    default: [_fontfaces2.default.muli.light, _fontfaces2.default.muli.normal, _fontfaces2.default.muli.semibold, _fontfaces2.default.muli.bold, 'sans-serif'],
    alternate: [_fontfaces2.default.muli.light, _fontfaces2.default.muli.normal, _fontfaces2.default.muli.semibold, _fontfaces2.default.muli.bold, 'sans-serif']
  },
  fontWeights: {
    body: {
      default: _fontweights2.default.normal
    },
    b: {
      default: _fontweights2.default.semibold
    },
    flowbar: {
      default: _fontweights2.default.semibold
    },
    datepicker: {
      default: _fontweights2.default.normal
    },
    image: {
      default: _fontweights2.default.light
    },
    radio: {
      title: _fontweights2.default.semibold,
      subtitle: _fontweights2.default.normal
    },
    requestList: {
      header: _fontweights2.default.semibold
    },
    result: {
      title: _fontweights2.default.bold
    },
    title: {
      default: _fontweights2.default.normal
    },
    subtitle: {
      default: _fontweights2.default.normal,
      sella: _fontweights2.default.normal
    },
    widget: {
      group: _fontweights2.default.semibold
    },
    label: {
      default: _fontweights2.default.bold
    },
    input: {
      default: _fontweights2.default.semibold,
      error: _fontweights2.default.normal
    }
  },
  fontSizes: (0, _extends3.default)({}, _fontsizes2.default, {
    flowbar: {
      //default: '0.875rem'
      default: '0.6875rem'
    },
    input: {
      default: _fontsizes2.default.normal,
      textIndent: '0',
      lineHeight: '1.5rem'
    }
  }),
  textTransforms: {
    input: {
      placeholder: 'none'
    }
  },
  textDecorations: {
    link: {
      default: 'none',
      hover: 'none'
    }
  }
};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  utility: {
    green: {
      default: '#61cc71',
      lightest: '#aeffbe',
      dark: '#54d326'
    },
    white: {
      default: '#ffffff'
    },
    blue: {
      default: '#2eb5ff',
      lightest: '#7bffff'
    },
    yellow: {
      default: '#ffcd67',
      lightest: '#ffffb4'
    },
    red: {
      default: '#c94646',
      lightest: '#ecbcbc'
    }
  },
  purple: {
    default: '#201849',
    light: '#453f6b',
    lighter: '#736d91',
    lightest: '#bab7cc',
    darker: '#01476f',
    darkest: '#00466E'
  },
  blue: {
    darkest: '#003c5d',
    darker: '#016aa3',
    dark: '#0087d6',
    default: '#00B7FF', //'#00a5ff',
    light: '#2eb5ff',
    lighter: '#5cc5ff',
    lightest: '#b9e6ff'
  },
  orange: {
    default: '#fca664',
    light: '#ffb077',
    lighter: '#ffc296',
    lightest: '#ffddba'
  },
  floral: {
    darker: '#e9e3d7',
    dark: '#f2eee6',
    default: '#fefaf2'
  },
  neutro: {
    dark: '#000',
    light: '#fff'
  },
  sella: {
    dark: '#072030',
    light: '#f7e53b'
  },
  yooxYellow: {
    dark: '#fe7b10',
    default: '#fae32f',
    lightest: 'rgba(254, 123, 16, 0.7)'
  },
  yooxBlack: {
    darker: '#333333',
    dark: '#333333',
    default: '#333333',
    light: '#848484',
    lighter: '#cbcbcb',
    lightest: '#f3f3f3'
  },
  timRed: {
    darker: '#960028',
    dark: '#c80028',
    default: '#eb0028',
    light: '#ff825a'
  },
  timBlue: {
    dark: '#003264',
    default: '#376ea5',
    light: '#004691',
    lighter: '#1680C3',
    lightest: '#82b9e6'
  },
  timGray: {
    default: '#d8d8d8'
  },
  gray: {
    default: '#f8f9fa',
    light: '#cecece'
  }
};

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(12);

var assetsPath = _utils.CONTEXT_ROOT + '/assets';

exports.default = {
  muli: {
    light: {
      fontFamily: 'Muli',
      src: 'local(\'Muli Light\'), local(\'Muli-Light\'), url(https://fonts.gstatic.com/s/muli/v10/T-qN9Yh40TTJeenUALkjgg.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Muli-Light.ttf\') format(\'truetype\')',
      fontWeight: '300',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'Muli',
      src: 'local(\'Muli Regular\'), local(\'Muli-Regular\'), url(https://fonts.gstatic.com/s/muli/v10/z6c3Zzm51I2zB_Gi7146Bg.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Muli-Regular.ttf\') format(\'truetype\')',
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'Muli',
      src: 'local(\'Muli Bold\'), local(\'Muli-Bold\'), url(https://fonts.gstatic.com/s/muli/v10/WQIsflEaABH2ETkzZKPChw.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Muli-Bold.ttf\') format(\'truetype\')',
      fontWeight: '700',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Muli',
      src: 'local(\'Muli ExtraBold\'), local(\'Muli-ExtraBold\'), url(https://fonts.gstatic.com/s/muli/v10/uLHeTmQh-SODolEfROCiNQ.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Muli-ExtraBold.ttf\') format(\'truetype\')',
      fontWeight: '800',
      fontStyle: 'normal'
    }
  },
  montserrat: {
    light: {
      fontFamily: 'Montserrat',
      src: 'local(\'Montserrat Regular\'), local(\'Montserrat-Regular\'), url(https://fonts.gstatic.com/s/montserrat/v10/zhcz-_WihjSQC0oHJ9TCYPk_vArhqVIZ0nv9q090hN8.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Montserrat-Regular.ttf\') format(\'truetype\')',
      fontWeight: '400',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'Montserrat',
      src: 'local(\'Montserrat Regular\'), local(\'Montserrat-Regular\'), url(https://fonts.gstatic.com/s/montserrat/v10/zhcz-_WihjSQC0oHJ9TCYPk_vArhqVIZ0nv9q090hN8.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Montserrat-Regular.ttf\') format(\'truetype\')',
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'Montserrat',
      src: 'local(\'Montserrat SemiBold\'), local(\'Montserrat-SemiBold\'), url(https://fonts.gstatic.com/s/montserrat/v10/q2OIMsAtXEkOulLQVdSl06VlZKEoJGujTpfWnQT9bUY.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Montserrat-SemiBold.ttf\') format(\'truetype\')',
      fontWeight: '600',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Montserrat',
      src: 'local(\'Montserrat SemiBold\'), local(\'Montserrat-SemiBold\'), url(https://fonts.gstatic.com/s/montserrat/v10/q2OIMsAtXEkOulLQVdSl06VlZKEoJGujTpfWnQT9bUY.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/Montserrat-SemiBold.ttf\') format(\'truetype\')',
      fontWeight: '600',
      fontStyle: 'normal'
    }
  },
  sourceSans: {
    light: {
      fontFamily: 'Source Sans Pro',
      src: 'local(\'Source Sans Pro\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/ODelI1aHBYDBqgeIAH2zlNV_2ngZ8dMf8fLgjYEouxg.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/SourceSansPro-Regular.ttf\') format(\'truetype\')',
      fontWeight: '400',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'Source Sans Pro',
      src: 'local(\'Source Sans Pro\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/ODelI1aHBYDBqgeIAH2zlNV_2ngZ8dMf8fLgjYEouxg.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/SourceSansPro-Regular.ttf\') format(\'truetype\')',
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'Source Sans Pro',
      src: 'local(\'Source Sans Pro Semibold\'), local(\'SourceSansPro-Semibold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/toadOcfmlt9b38dHJxOBGCOFnW3Jk0f09zW_Yln67Ac.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/SourceSansPro-Semibold.ttf\') format(\'truetype\')',
      fontWeight: '600',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'Source Sans Pro',
      src: 'local(\'Source Sans Pro Semibold\'), local(\'SourceSansPro-Semibold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v9/toadOcfmlt9b38dHJxOBGCOFnW3Jk0f09zW_Yln67Ac.woff2) format(\'woff2\'), url(\'' + assetsPath + '/fonts/SourceSansPro-Semibold.ttf\') format(\'truetype\')',
      fontWeight: '600',
      fontStyle: 'normal'
    }
  },
  timSans: {
    light: {
      fontFamily: 'TIM Sans',
      src: 'local(\'timsans-light\'), local(\'timsans-light\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-light.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-light.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-light.eot?#iefix) format(\'embedded-opentype\'), url(\'' + assetsPath + '/fonts/timsans-light.woff\') format(\'woff\'), url(\'' + assetsPath + '/fonts/timsans-light.ttf\') format(\'truetype\'), url(\'' + assetsPath + '/fonts/timsans-light.eot?#iefix\') format(\'embedded-opentype\')',
      fontWeight: '300',
      fontStyle: 'normal'
    },
    normal: {
      fontFamily: 'TIM Sans',
      src: 'local(\'timsans-regular\'), local(\'timsans-regular\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-regular.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-regular.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-regular.eot?#iefix) format(\'embedded-opentype\'), url(\'' + assetsPath + '/fonts/timsans-regular.woff\') format(\'woff\'), url(\'' + assetsPath + '/fonts/timsans-regular.ttf\') format(\'truetype\'), url(\'' + assetsPath + '/fonts/timsans-regular.eot?#iefix\') format(\'embedded-opentype\')',
      fontWeight: '400',
      fontStyle: 'normal'
    },
    semibold: {
      fontFamily: 'TIM Sans',
      src: 'local(\'timsans-bold\'), local(\'timsans-bold\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-bold.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-bold.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-bold.eot?#iefix) format(\'embedded-opentype\'), url(\'' + assetsPath + '/fonts/timsans-bold.woff\') format(\'woff\'), url(\'' + assetsPath + '/fonts/timsans-bold.ttf\') format(\'truetype\'), url(\'' + assetsPath + '/fonts/timsans-bold.eot?#iefix\') format(\'embedded-opentype\')',
      fontWeight: '700',
      fontStyle: 'normal'
    },
    bold: {
      fontFamily: 'TIM Sans',
      src: 'local(\'timsans-heavy\'), local(\'timsans-heavy\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-heavy.woff) format(\'woff\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-heavy.ttf) format(\'truetype\'), url(https://cdn.rawgit.com/hype-app/fonts/ced548a8/timsans-heavy.eot?#iefix) format(\'embedded-opentype\'), url(\'' + assetsPath + '/fonts/timsans-heavy.woff\') format(\'woff\'), url(\'' + assetsPath + '/fonts/timsans-heavy.ttf\') format(\'truetype\'), url(\'' + assetsPath + '/fonts/timsans-heavy.eot?#iefix\') format(\'embedded-opentype\')',
      fontWeight: '800',
      fontStyle: 'normal'
    }
  }
};

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  light: '300',
  normal: '400',
  semibold: '600',
  bold: '800'
};

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  smaller: '0.5625rem',
  small: '0.75rem',
  normal: '1rem',
  big: '1.125rem',
  bigger: '1.325rem' //'1.625rem'
};

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Converts an hex color string to rgb object
 * @param  {string} hex The hex color
 * @return {Object}     The rgb color
 */
var hexToRgb = exports.hexToRgb = function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

/**
 * Converts an hex color string to rgba string
 * @param  {string} hex     The hex color
 * @param  {string} alpha   The desired alpha
 * @return {string}         The rgba string
 */
var hexToRgba = exports.hexToRgba = function hexToRgba(hex, alpha) {
  var rgbObj = hexToRgb(hex);
  return "rgba(" + rgbObj.r + ", " + rgbObj.g + ", " + rgbObj.b + ", " + alpha + ")";
};

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    page: {
      display: 'flex',
      flexDirection: 'column',

      minHeight: '100vh'
    }
  };
};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1119);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flowbar = function (_Component) {
  (0, _inherits3.default)(Flowbar, _Component);

  function Flowbar(props) {
    (0, _classCallCheck3.default)(this, Flowbar);
    return (0, _possibleConstructorReturn3.default)(this, (Flowbar.__proto__ || (0, _getPrototypeOf2.default)(Flowbar)).call(this, props));
  }

  (0, _createClass3.default)(Flowbar, [{
    key: 'isItemActive',
    value: function isItemActive(component) {
      return component.status.indexOf('active') > -1;
    }
  }, {
    key: 'isItemDone',
    value: function isItemDone(component) {
      return component.status.indexOf('passed') > -1;
    }
  }, {
    key: 'getFlowbarItemModifierClass',
    value: function getFlowbarItemModifierClass(id) {
      if (this.isItemActive(this.props.components[id])) {
        return this.props.styles['item--active'];
      }

      if (this.isItemDone(this.props.components[id])) {
        return this.props.styles['item--done'];
      }

      return;
    }
  }, {
    key: 'renderComponents',
    value: function renderComponents() {
      var _this2 = this;

      return this.props.widget.components.filter(function (k) {
        return k.indexOf(_this2.props.widget.name) > -1 && _this2.props.components[k];
      }).map(function (id) {
        if (id === 'FLOW_BAR-STEP_1' || id === 'FLOW_BAR-STEP_2' || _this2.props.components[id].status[0] === 'last') {
          return _react2.default.createElement(
            'li',
            (0, _extends3.default)({
              key: _this2.props.components[id].name
            }, (0, _withStyles.css)(_this2.props.styles.item, _this2.getFlowbarItemModifierClass(id))),
            _react2.default.createElement(
              'span',
              null,
              _this2.props.components[id].value,
              ' '
            )
          );
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'ul',
        (0, _withStyles.css)(this.props.styles.flowbar),
        this.renderComponents()
      );
    }
  }]);
  return Flowbar;
}(_react.Component);

Flowbar.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  components: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  var components = state.components;

  return { components: components };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Flowbar));

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _item, _itemActive, _itemDone;

  var colors = _ref.colors,
      spacings = _ref.spacings,
      fontSizes = _ref.fontSizes,
      fontWeights = _ref.fontWeights;
  return {
    flowbar: (0, _defineProperty3.default)({
      width: 'auto',
      padding: '0',

      listStyle: 'none',

      textAlign: 'center',

      // height: '8px',

      paddingTop: spacings.flowbar.paddingTop.default
    }, (0, _breakTo2.default)('medium'), {
      paddingTop: '0'
    }),

    item: (_item = {
      fontWeight: fontWeights.flowbar.default,

      position: 'relative',
      display: 'inline-block',
      width: '8%',
      height: '8px',
      margin: '0',
      textAlign: 'center',
      whiteSpace: 'nowrap',

      color: 'transparent'

    }, (0, _defineProperty3.default)(_item, (0, _breakTo2.default)('medium'), {
      fontSize: fontSizes.flowbar.default,

      width: '120px',
      margin: '0 1rem',
      //color: '#cecece'
      color: '#cecece' //colors.flowbar.item.default
    }), (0, _defineProperty3.default)(_item, '::before', (0, _defineProperty3.default)({
      position: 'absolute',
      zIndex: '99',
      top: '0',
      left: '46%',

      display: 'block',

      width: '8px',
      height: '8px',

      content: "''",
      verticalAlign: 'middle',

      borderRadius: '8px',
      backgroundColor: colors.flowbar.bullet.default

    }, (0, _breakTo2.default)('medium'), {
      top: '27px'
    })), (0, _defineProperty3.default)(_item, '::after', (0, _defineProperty3.default)({
      position: 'absolute',
      top: '3px',
      left: '50%',

      display: 'block',

      width: '100%',
      height: '2px',

      content: "''",
      verticalAlign: 'middle',

      borderRadius: '2px',
      backgroundColor: colors.flowbar.line.default

    }, (0, _breakTo2.default)('medium'), {
      width: '155px',
      top: '30px'
    })), (0, _defineProperty3.default)(_item, ':last-child', {
      '::after': {
        width: '0'
      }
    }), _item),

    'item--active': (_itemActive = {
      fontWeight: fontWeights.flowbar.default,
      /* color: colors.flowbar.line.default, */
      color: 'transparent'

    }, (0, _defineProperty3.default)(_itemActive, (0, _breakTo2.default)('medium'), {
      color: colors.flowbar.bullet.done
    }), (0, _defineProperty3.default)(_itemActive, '::before', {
      backgroundColor: colors.flowbar.bullet.done
    }), (0, _defineProperty3.default)(_itemActive, '::after', {
      backgroundColor: colors.flowbar.line.default
    }), _itemActive),

    'item--done': (_itemDone = {
      fontWeight: fontWeights.flowbar.default,
      color: 'transparent'

    }, (0, _defineProperty3.default)(_itemDone, (0, _breakTo2.default)('medium'), {
      color: '#cecece' //colors.flowbar.item.default
      //color:'#cecece'
    }), (0, _defineProperty3.default)(_itemDone, '::before', {
      backgroundColor: colors.flowbar.bullet.done
    }), (0, _defineProperty3.default)(_itemDone, '::after', {
      backgroundColor: colors.flowbar.line.done
    }), _itemDone)
  };
};

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  extraSmall: "30em", // 480px
  smaller: "40em", // 640px
  small: "48em", // 768px
  medium: "60em", // 960px
  large: "80em", // 1280px
  extraLarge: "100em" // 1600px
};
var maxWidthBreakpoint = exports.maxWidthBreakpoint = {
  small: "767px",
  medium: "1024px"
};

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _parsers = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _logo;

  var colors = _ref.colors,
      images = _ref.images,
      spacings = _ref.spacings;
  return {
    header: (0, _defineProperty3.default)({
      overflow: "hidden",
      width: "100%",
      height: spacings.header.height.default,
      marginBottom: "1.5rem",
      backgroundColor: colors.header.bg
    }, (0, _breakTo2.default)("medium"), {
      height: spacings.header.height.medium
    }),

    "header--whitelabel": {
      height: (0, _parsers.important)(spacings.header.height.noHeader)
    },

    "header--centered": {
      height: (0, _parsers.important)(spacings.header.height.noFlowbar)
    },

    logo: (_logo = {
      width: spacings.header.logo.width,
      height: spacings.header.logo.height,
      float: "left",
      marginTop: "1.5rem",
      position: "absolute",
      left: "15%"
    }, (0, _defineProperty3.default)(_logo, (0, _breakTo.maxWidth)("small"), {
      left: "5%"
    }), (0, _defineProperty3.default)(_logo, (0, _breakTo.maxWidth)("medium"), {
      left: "10%"
    }), _logo),

    "logo--whitelabel": {
      display: "none"
    },

    "logo--centered": (0, _defineProperty3.default)({
      right: "0"
    }, (0, _breakTo2.default)("medium"), {
      right: "0"
      // margin: spacings.header.logo.margin.centered
    }),

    "logo-link": {
      display: "block",

      width: "100%",

      textAlign: "center"
    },

    "logo-img": (0, _defineProperty3.default)({
      maxWidth: spacings.header.logo.maxWidth,
      width: spacings.header.logo.width,
      height: spacings.header.logo.height,

      margin: spacings.header.logo.margin.img,

      backgroundImage: images.header,
      backgroundRepeat: "no-repeat",
      backgroundSize: spacings.header.logo.backgroundSize,
      backgroundPosition: spacings.header.logo.backgroundPosition
    }, (0, _breakTo.maxWidth)("small"), {
      width: "7.5rem"
    }),

    children: (0, _defineProperty3.default)({
      backgroundColor: colors.header.children.bg,
      paddingTop: spacings.header.children.paddingTop.default,
      marginTop: "75px",
      //marginTop: spacings.header.children.marginTop.default,
      paddingBottom: "2rem"
    }, (0, _breakTo2.default)("medium"), {
      padding: ".2rem 0",
      height: spacings.header.children.height.medium
    }),
    "children--whitelabel": {
      marginTop: (0, _parsers.important)(spacings.header.children.marginTop.noHeader)
    }
  };
};

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    wrapper: (0, _defineProperty3.default)({
      width: '90%',
      maxWidth: '43rem',
      margin: '0 auto',

      flex: '1 0 auto',
      alignItems: 'flex-start'

    }, (0, _breakTo2.default)('small'), {
      minWidth: '43rem'
    }),
    wrapperDigiMaxWidth: {
      maxWidth: '49rem!important'
    }

  };
};

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _clearfix = __webpack_require__(530);

var _clearfix2 = _interopRequireDefault(_clearfix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return {
    clearfix: (0, _extends3.default)({}, (0, _clearfix2.default)())
  };
};

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var colors = _ref.colors,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes;
  return {
    title: {
      margin: '2rem auto',

      fontSize: fontSizes.bigger,

      color: colors.title
    },

    subtitle: {
      color: colors.subtitle,
      fontSize: fontSizes.normal,
      fontWeight: fontWeights.light
    },

    'contact-id': {
      fontSize: fontSizes.normal,
      fontFamily: fontFamilies.alternate,
      fontWeight: fontWeights.title.default,
      lineHeight: '1.5rem',

      margin: '0',

      color: colors.subtitle
    }
  };
};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _link = __webpack_require__(265);

var _link2 = _interopRequireDefault(_link);

var _styles = __webpack_require__(1127);

var _styles2 = _interopRequireDefault(_styles);

var _labelWithLink = __webpack_require__(531);

var _labelWithLink2 = _interopRequireDefault(_labelWithLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox(props) {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call(this, props));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch;

      var value = 'selected';
      if (component.value === 'selected' || component.status.indexOf('selected') > -1) {
        this.input.checked = true;
        value = 'selected';
      } else {
        this.input.checked = false;
        value = '';
      }
      dispatch((0, _componentsActions.updateComponent)(component.id, { value: value, status: component.status.filter(function (s) {
          return s !== 'selected';
        }) }, { bypassValidation: component.status.indexOf('error') < 0 }));
      if (component.id === 'SZ0023-SS0048_DM0089_RI0381' && this.input.checked) {
        var isSelected = this.input.checked;
        var csInfoArr = ['SZ0023-SS0048_DM0089_RI0121',
        //'SZ0023-SS0048_DM0089_RI0122', //Remove component RI0122 begin - end
        'SZ0023-SS0048_DM0089_RI1058', 'SZ0023-SS0048_DM0089_RI1059', 'SZ0023-SS0048_DM0089_RI1060', 'SZ0023-SS0048_DM0089_RI1061', 'SZ0023-SS0048_DM0089_RI1056', 'SZ0023-SS0048_DM0089_RI0126'];
        var csInfoArrBody = {
          //validations : {isRequired: true}, //{isRequired: !isSelected},
          value: '',
          isDisabled: isSelected
        };

        csInfoArr.forEach(function (cid) {
          dispatch((0, _componentsActions.updateComponent)(cid, csInfoArrBody, { bypassValidation: true }));
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          component = _props2.component,
          dispatch = _props2.dispatch;


      if (nextProps.component && nextProps.component.status.indexOf('selected') > -1 && nextProps.component.value === '' && component.value === 'selected') {
        this.input.checked = true;
        dispatch((0, _componentsActions.updateComponent)(component.id, { value: 'selected' }));
      }
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      var _props3 = this.props,
          component = _props3.component,
          dispatch = _props3.dispatch;


      if (!this.input.disabled) {
        if (component.status.indexOf('checkonly') > -1) {
          if (component.value !== 'selected') {
            dispatch((0, _componentsActions.updateComponent)(component.id, {
              value: 'selected'
            }));
            if (!!component.action) {
              dispatch((0, _componentsActions.updateComponent)(component.id, component.action));
            }
          }
        } else {
          dispatch((0, _componentsActions.updateComponent)(component.id, {
            value: this.input.checked ? 'selected' : ''
          }));
        }
      }

      /*@Hack for Info Legali Step*/
      if (component.id === 'SZ0023-SS0048_DM0089_RI0381') {
        var isSelected = this.input.checked;
        var csInfoArr = ['SZ0023-SS0048_DM0089_RI0121',
        //'SZ0023-SS0048_DM0089_RI0122', //Remove component RI0122 begin - end
        'SZ0023-SS0048_DM0089_RI1058', 'SZ0023-SS0048_DM0089_RI1059', 'SZ0023-SS0048_DM0089_RI1060', 'SZ0023-SS0048_DM0089_RI1061', 'SZ0023-SS0048_DM0089_RI1056', 'SZ0023-SS0048_DM0089_RI0126'];
        var csInfoArrBody = {
          //validations : {isRequired: true}, //{isRequired: !isSelected},
          value: '',
          isDisabled: isSelected
        };

        csInfoArr.forEach(function (cid) {
          dispatch((0, _componentsActions.updateComponent)(cid, csInfoArrBody, { bypassValidation: true }));
        });
      }
    }
  }, {
    key: 'getProperErrorMessage',
    value: function getProperErrorMessage() {
      var component = this.props.component;


      if (!!component.validations.overrides) {
        var validationResult = (0, _utils.getValidationsResult)({
          component: component,
          type: 'overrides'
        });
        if (!validationResult.result) {
          return validationResult.errorMessage;
        }
      }
      return component.errorMessage && component.errorMessage[0];
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var component = this.props.component;


      if (component.description && component.description.split('\n').length > 1) {
        var description = component.description.split('\n');
        return description.map(function (s, index) {
          return _react2.default.createElement(
            'span',
            { key: index },
            s,
            _react2.default.createElement('br', null)
          );
        });
      } else return component.description;
    }
  }, {
    key: 'renderLabelWithLink',
    value: function renderLabelWithLink() {
      var component = this.props.component;

      var chunks = component.combineComponent.value.split(/\s(?=\s§\w*§)|(§\w*§)/g);
      var conditionalProps = void 0;
      if (component.combineComponent.link && component.combineComponent.link.method !== 'POST') {
        conditionalProps = {
          href: component.combineComponent.link.url,
          target: component.combineComponent.link.target
        };
      }
      return _react2.default.createElement(
        'span',
        null,
        chunks.map(function (chunk, index) {
          if (component.combineComponent.link) {
            return chunk === component.combineComponent.link.placeholder ? _react2.default.createElement(
              _link2.default,
              (0, _extends3.default)({ key: index }, conditionalProps),
              component.combineComponent.link.text
            ) : chunk;
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          widget = _props4.widget,
          component = _props4.component;

      return _react2.default.createElement(
        'div',
        (0, _withStyles.css)(this.props.styles.component, this.props.styles.checkbox, this.props.styles['component--block'], this.props.styles['component--pull-' + component.pullTo],
        /* ['S8-S8S2D2F3', 'S8-S8S2D1F4'].includes(component.id) && */
        this.props.styles.checkboxContainer),
        _react2.default.createElement('input', (0, _extends3.default)({
          ref: function ref(input) {
            _this2.input = input;
          },
          type: 'checkbox',
          id: component.id
        }, (0, _withStyles.css)(this.props.styles.input), {
          checked: component.value === 'selected',
          onChange: function onChange() {
            return _this2.onChange();
          },
          name: component.id,
          disabled: !!component.isDisabled || component.status.indexOf('readonly') > -1 || widget.status.indexOf('readonly') > -1
        })),
        !!component.description && component.description.indexOf("§link§") === -1 && _react2.default.createElement(
          'label',
          (0, _extends3.default)({
            htmlFor: component.id
          }, (0, _withStyles.css)(this.props.styles.label, component.status.indexOf('error') > -1 && this.props.styles['label--invalid'])),
          this.renderLabel()
        ),
        !!component.description && component.description.indexOf("§link§") > -1 && _react2.default.createElement(
          'label',
          (0, _extends3.default)({
            htmlFor: component.id
          }, (0, _withStyles.css)(this.props.styles.label, component.status.indexOf('error') > -1 && this.props.styles['label--invalid'])),
          _react2.default.createElement(_labelWithLink2.default, { key: component.name, widget: widget, component: component })
        ),
        _react2.default.createElement(
          'p',
          null,
          component.id === 'S8-S8S2D1F4' ? 'Servizio sottoposto a valutazione del gruppo Sella' : ''
        ),
        component.descriptionWithLink && !!component.combineComponent.value && _react2.default.createElement(
          'label',
          { htmlFor: component.id },
          this.renderLabelWithLink()
        ),
        _react2.default.createElement(
          'small',
          (0, _withStyles.css)(this.props.styles['error-msg']),
          (0, _utils.camelize)(this.getProperErrorMessage(), true, true)
        )
      );
    }
  }]);
  return Checkbox;
}(_react.Component);

Checkbox.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components;

  return { component: components[ownProps.component.id] };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Checkbox));

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var colors = _ref.colors,
      textDecorations = _ref.textDecorations;
  return {
    link: {
      marginBottom: '0',
      color: colors.link.text.default,
      textDecoration: textDecorations.link.default,
      ':hover': {
        color: colors.link.text.hover,
        textDecoration: textDecorations.link.hover
      }
    }
  };
};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _parsers = __webpack_require__(40);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    checkbox: {},
    checkboxContainer: (0, _defineProperty3.default)({}, (0, _breakTo2.default)('small'), {
      width: '100%',
      marginRight: '0'
    }),
    input: {
      position: 'absolute',
      left: '-9999px',

      ':enabled + label': {
        fontSize: '0.875rem',

        position: 'relative',
        display: 'inline-block',

        paddingLeft: spacings.x5,

        cursor: 'pointer',

        color: colors.common.text,
        // checkbox appearance
        '::before': {
          position: 'absolute',
          top: '0',
          left: '0',

          width: '20px',
          height: '20px',

          content: "''",

          border: '2px solid ' + colors.flag.default,
          borderRadius: '2px',
          background: colors.flag.bg
        },
        // checked mark appearance
        '::after': {
          fontSize: spacings.x4,
          lineHeight: '20px',

          position: 'absolute',
          top: '-5px',
          left: '6px',

          width: '9px',
          height: '12px',

          content: images.checkboxTick,
          transition: 'all .2s',
          textAlign: 'center',

          border: 0,
          borderRadius: '2px'
        }
      },

      ':disabled + label': {
        color: colors.flag.default
      },

      ':not(:checked) + label::after': {
        fontSize: 0,

        opacity: 0
      },

      ':not(:checked):disabled + label::before': {
        boxShadow: 'none'
      },

      ':checked + label::before': {
        border: '2px solid ' + colors.flag.checked,
        background: colors.flag.checked
      },

      ':checked + label::after': {
        transform: 'scale(1)',

        opacity: '1'
      },

      ':disabled + label::before': {
        boxShadow: 'none'
      },

      ':disabled + label::after': {
        border: '1px solid ' + colors.flag.disabled
      }
    },

    // 'input--invalid': {

    //   ':enabled + label:before': {
    //     borderColor: important(colors.common.utility.error.default),
    //   }
    // },

    label: {
      fontFamily: fontFamilies.alternate
    },

    'label--invalid': {
      color: (0, _parsers.important)(colors.common.utility.error.default)
    },
    'component--pull-left': {
      float: 'left'
    },
    'component--pull-right': {
      float: 'right'
    },
    'component--block': {
      display: 'block'
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _parsers = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    label: {
      fontFamily: fontFamilies.alternate,
      marginBottom: '0',
      ':not(:first-child)': {
        marginTop: '0'
      }
    },

    'label--small': {
      fontSize: '13px'
    },

    'label--padded': {
      marginTop: (0, _parsers.important)('2rem')
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var colors = _ref.colors,
        spacings = _ref.spacings,
        images = _ref.images,
        fontFamilies = _ref.fontFamilies,
        fontWeights = _ref.fontWeights,
        fontSizes = _ref.fontSizes,
        textTransforms = _ref.textTransforms;

    var component = (0, _component2.default)({
        colors: colors,
        spacings: spacings,
        images: images,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        fontSizes: fontSizes,
        textTransforms: textTransforms
    });
    var styles = {
        divAlignPhoneNum: {
            verticalAlign: 'middle!important',
            paddingTop: '49px!important'
        },
        checkmark: {
            display: 'inline-block',
            width: '10px',
            height: '22px',
            msTransform: 'rotate(45deg)', /* IE 9 */
            webkitTransform: 'rotate(45deg)', /* Chrome, Safari, Opera */
            transform: 'rotate(45deg)',
            position: 'absolute',
            marginLeft: '-23px'
        },

        checkmarkStem: {
            position: 'absolute',
            width: '3px',
            height: '11px', //'9px',
            backgroundColor: '#fff',
            left: '11px',
            top: '5px'
        },
        checkmarkKick: {
            position: 'absolute',
            width: '3px',
            height: '3px',
            backgroundColor: '#fff',
            // left:'8px',
            // top:'12px'
            top: '13px',
            left: '8px'
        },
        checkmarkCircle: {
            position: 'absolute',
            width: '22px',
            height: '22px',
            backgroundColor: 'green',
            borderRadius: '11px',
            left: '0',
            top: '0'
        },
        otpWidth: {
            width: '32rem!important'
        },
        fullFieldWidth: {
            width: '100%!important'
        },
        grayed: {
            padding: "1rem 1rem 2rem 1rem",
            borderRadius: "6px",
            backgroundColor: "#eee"
        },
        grayedText: {
            backgroundColor: "#eee !important"
        },
        componentTitle: {
            display: "block",
            marginBottom: "1rem",
            color: "#201849"
            // gap :
            // {
            //     display:"none"
            // },
            // ibantextfont :
            // {
            //     fontSize: "0.875rem"   
            // }
        } };
    return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _api = __webpack_require__(45);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1131);

var _styles2 = _interopRequireDefault(_styles);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function (_Component) {
  (0, _inherits3.default)(Label, _Component);

  function Label(props) {
    (0, _classCallCheck3.default)(this, Label);
    return (0, _possibleConstructorReturn3.default)(this, (Label.__proto__ || (0, _getPrototypeOf2.default)(Label)).call(this, props));
  }

  (0, _createClass3.default)(Label, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.component.name === "S16S1D2") {
        var _props = this.props,
            component = _props.component,
            dispatch = _props.dispatch;

        var body = component.fetchPromoCode.body;
        var url = component.fetchPromoCode.url;
        (0, _api.FetchPromoCode)(url, body).then(function (json) {
          if (!!json.payLoad && json.payLoad.PromoCode === 'TRYBLACK') {
            dispatch((0, _componentsActions.updateComponent)(component.id, { status: [] }));
          } else {
            dispatch((0, _componentsActions.updateComponent)(component.id, { status: ['hidden'] }));
          }
        });
      }
      if (this.props.component.id === "POSPLAN-PLAN") {
        var _props2 = this.props,
            _component = _props2.component,
            _dispatch = _props2.dispatch;

        var _body = _component.fetchPosPlan.body;
        var _url = _component.fetchPosPlan.url;
        (0, _api.FetchPOSPlan)(_url, _body).then(function (json) {
          if (json && json.payLoad && json.payLoad.Plan) {
            _dispatch((0, _componentsActions.updateComponent)(_component.id, { value: json.payLoad.Plan }));
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          widget = _props3.widget,
          component = _props3.component;

      var md = new _mobileDetect2.default(window.navigator.userAgent);

      return this.props.component.id === 'S1-S1S4D7' ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('h4', (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles['widget-group__title']), {
          dangerouslySetInnerHTML: { __html: 'Contatti utente amministratore Dashboard' } })),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('small', { dangerouslySetInnerHTML: { __html: 'Indicare i dati dell’utente amministratore Dashboard che gestisce le associazioni degli utenti ai terminali POS tramite la Fabrick Dashboard.' } })
        )
      ) : _react2.default.createElement('p', (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.component, this.props.styles['component--block'], this.props.styles.label, component.status[0] === 'hidden' ? this.props.styles['component--hidden'] : '', !!this.props.component.isSmall && this.props.styles['label--small'], !!this.props.component.isPadded && this.props.styles['label--padded'], !!this.props.component.isCentered && this.props.styles['label--centered'], !!this.props.component.isBold && this.props.styles['label--bold'], !md.mobile() && !!this.props.component.id && this.props.component.id === 'PEC-ADDRESS' ? this.props.styles['label--align'] : ''), {
        dangerouslySetInnerHTML: { __html: component.value }
      }));
    }
  }]);
  return Label;
}(_react.Component);

Label.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps() {
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Label));

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _parsers = __webpack_require__(40);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    label: {
      fontFamily: fontFamilies.alternate,
      marginBottom: '0',
      ':not(:first-child)': {
        marginTop: '0'
      }
    },

    'label--small': {
      fontSize: '13px'
    },

    'label--padded': {
      marginTop: (0, _parsers.important)('2rem')
    },

    'label--bold': {
      fontWeight: fontWeights.label.default
    },

    'label--centered': {
      textAlign: 'center'
    },
    'label--align': {
      verticalAlign: 'middle',
      width: '50%!important'
    },
    'widget-group__title': (0, _defineProperty3.default)({
      color: colors.widget.groupTitle.default
    }, (0, _breakTo2.default)('medium'), {
      position: 'absolute',
      marginLeft: '-16vw',
      fontWeight: fontWeights.widget.group,
      marginTop: '2.5vw',
      width: '14vw',
      textAlign: 'right'
    })
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1133);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(props) {
  return _react2.default.createElement(
    'div',
    (0, _withStyles.css)(props.styles.component, props.styles.img),
    _react2.default.createElement(
      'div',
      (0, _withStyles.css)(props.styles.pic),
      _react2.default.createElement('div', _withStyles.css.apply(undefined, (0, _toConsumableArray3.default)(props.component.values.map(function (c) {
        return props.styles[c];
      }))))
    ),
    _react2.default.createElement(
      'div',
      (0, _withStyles.css)(props.styles.text),
      props.component.value.replace(/([^§]*)§([^§]*)§([^§]*)/g, '$1'),
      _react2.default.createElement(
        'b',
        null,
        props.component.value.replace(/([^§]*)§([^§]*)§([^§]*)/g, '$2')
      ),
      props.component.value.replace(/([^§]*)§([^§]*)§([^§]*)/g, '$3')
    )
  );
};

Image.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Image);

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _parsers = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    img: (0, _defineProperty3.default)({
      display: 'block',

      maxWidth: '550px',
      height: '170px',
      marginRight: (0, _parsers.important)('auto'),
      marginBottom: '0',
      marginLeft: (0, _parsers.important)('auto'),

      textAlign: 'center'

    }, (0, _breakTo2.default)('small'), {
      display: 'inline-block',

      width: '14rem',
      maxWidth: '100%',
      marginRight: '0',
      marginLeft: '0',
      'padding-right': '0',
      paddingLeft: '0',

      textAlign: 'inherit'
    }),

    pic: (0, _defineProperty3.default)({
      display: 'table-cell',

      width: '7rem'

    }, (0, _breakTo2.default)('small'), {
      display: 'block',

      width: '100%'
    }),

    text: (0, _defineProperty3.default)({
      top: '140px',
      fontWeight: fontWeights.image.default,
      fontFamily: fontFamilies.alternate,
      display: 'table-cell',

      textAlign: 'left',
      verticalAlign: 'middle'

    }, (0, _breakTo2.default)('small'), {
      display: 'block',

      width: 'inherit',

      paddingLeft: '.2rem',
      paddingRight: '.2rem',

      textAlign: 'center',
      verticalAlign: 'inherit'
    }),

    wyn: {
      display: 'block',

      width: '95px',
      height: '110px',
      marginRight: 'auto',
      marginLeft: 'auto',

      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'
    },

    'wyn--docs': {
      backgroundImage: images.whatYouNeed.documents
    },

    'wyn--phone': {
      backgroundImage: images.whatYouNeed.phone
    },

    'wyn--secure': {
      backgroundImage: images.whatYouNeed.secure
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _set = __webpack_require__(111);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(171);

var _from2 = _interopRequireDefault(_from);

var _typeof2 = __webpack_require__(93);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _lodash = __webpack_require__(96);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1135);

var _styles2 = _interopRequireDefault(_styles);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_Component) {
  (0, _inherits3.default)(Select, _Component);

  function Select(props) {
    (0, _classCallCheck3.default)(this, Select);
    return (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call(this, props));
  }

  (0, _createClass3.default)(Select, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
        var dispatch = this.props.dispatch;

        this.props.component.fetchInProgress = true;
        dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
      //const componentId = this.props.component.id
      // if (
      //   this.props.component.hasOwnProperty('fetch') &&
      //   !componentId.startsWith('PROFESSIONE_ATTIVITA-') &&
      //   step.name.toLowerCase() === 'info legali'
      // ) {
      //setTimeout(dispatch(fetchData(this.props.component.id, null, true)), 3000)

      dispatch((0, _componentsActions.fetchData)(this.props.component.id, null, true));
      this.aziendaSubType(this.props.component.id, this.props.component.value);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var dispatch = this.props.dispatch;

      if (nextProps.component && this.props.component.values.length === 0 && nextProps.component.values.length >= 0 || nextProps.component && this.props.component.values.length > 0 && nextProps.component.values.length === 0) {
        if (!this.props.component.value && !!this.props.component.initialValue) {
          this.props.component.value = this.props.component.initialValue;
        }

        if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
          this.props.component.fetchInProgress = true;
          dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
        }
      }
    }
  }, {
    key: 'onValueChange',
    value: function onValueChange(e) {
      var _props = this.props,
          dispatch = _props.dispatch,
          component = _props.component;

      this.aziendaSubType(component.id, e.target.value);
      dispatch((0, _componentsActions.updateComponent)(component.id, { value: e.target.value }));
      e.preventDefault();
    }
  }, {
    key: 'renderOptions',
    value: function renderOptions() {
      var _this2 = this;

      var component = this.props.component;

      if (component.id === 'AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA' && component.values.length === 0) {
        this.props.component.rawValue.map(function (v) {
          var item = {};
          item.value = v.tipoSoggettoId, item.description = v.tipoSoggettoDesc;
          component.values.push(item);
        });
      }
      var values = component.values;
      var isObjectArray = false;
      if (values && values.constructor.toString().indexOf('Array') > -1 && (0, _typeof3.default)(values[0]) === 'object') {
        values = values.filter(function (v) {
          return !!v.value && v.value !== '-1';
        });
        isObjectArray = true;
        values = (0, _lodash.uniqBy)(values, 'value');
      } else {
        values = (0, _from2.default)(new _set2.default(values));
      }
      return values.map(function (v) {
        if (!isObjectArray) {
          v = {
            value: v,
            label: v
          };
        }
        if (!v.label && !!v.description) {
          v.label = component.flag === 'static_1' && (v.description === 'NAZIONE' ||
          //  || v.description === 'PROVINCIA' || v.description==='RESIDENZA-PROVINCIA' || v.description==='DOMICILIO-PROVINCIA'
          //|| v.description==='SEDE_LEGALE-PROVINCIA' || v.description==='SEDE_AMMINISTRATIVA-PROVINCIA' ||
          component.name === 'PROVINCIA' || component.name === 'CITTADINANZA') ? v.value : v.description;
        }
        // if (!v.label && !!v.value) {
        //   v.label = v.value
        // }
        return _react2.default.createElement(
          'option',
          (0, _extends3.default)({}, (0, _withStyles.css)(_this2.props.styles.option), {
            value: v.value,
            key: v.value
          }),
          v.label
        );
      });
    }
  }, {
    key: 'validateRequired',
    value: function validateRequired() {
      var component = this.props.component;

      if (component.validations && component.validations.isRequired && !component.isDisabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'aziendaSubType',
    value: function aziendaSubType(componentid, componentvalue) {
      var dispatch = this.props.dispatch;

      if (componentid === 'AZIENDA_TYPE-TIPO_SOGGETTO_AZIENDA') {
        if (componentvalue === '1054') {
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-ENTE_PRIVATO', { status: [''] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-FORMA_GIURIDIA', { status: ['hidden'] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE', { status: ['hidden'] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA', { status: ['hidden'] }));
        } else if (componentvalue === '1050' || componentvalue === '1049') {
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-ENTE_PRIVATO', { status: ['hidden'] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE', { status: [''] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-FORMA_GIURIDIA', { status: [''] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA', { status: ['hidden'] }));
        } else if (componentvalue === '1051') {
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-ENTE_PRIVATO', { status: ['hidden'] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-SOCIETA_DI_PERSONE_CAPITALE', { status: ['hidden'] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-FORMA_GIURIDIA', { status: ['hidden'] }));
          dispatch((0, _componentsActions.updateComponent)('AZIENDA_SUBTYPE-SOCIETA_COOPERATIVA', { status: [''] }));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          widget = _props2.widget,
          component = _props2.component;

      var md = new _mobileDetect2.default(window.navigator.userAgent);
      return _react2.default.createElement(
        'div',
        (0, _withStyles.css)(this.props.styles.component, component.fullWidth && this.props.styles.singleField, component.id === 'CELLULARE-PREF_CELLULARE' && !md.mobile() && this.props.styles.divPrefix),
        _react2.default.createElement(
          'select',
          (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.input, this.props.styles['input--select'], component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink'], !component.value && this.props.styles['input--unset']), {
            onChange: function onChange(event) {
              _this3.onValueChange(event);
            },
            value: component.value || 'Seleziona',
            disabled: !!component.isDisabled || component.status.indexOf('readonly') > -1 || widget.status.indexOf('readonly') > -1,
            name: component.id
          }),
          _react2.default.createElement(
            'option',
            {
              value: 'Seleziona',
              disabled: !component.isGrouped && component.isGrouped !== true
            },
            component.cleanName
          ),
          this.renderOptions()
        ),
        _react2.default.createElement(
          'span',
          (0, _withStyles.css)(this.props.styles.label, component.value !== '' && this.props.styles['label--active'], this.props.isInModal && this.props.styles['label--neutral']),
          component.cleanName
        ),
        _react2.default.createElement(
          'small',
          (0, _withStyles.css)(this.props.styles['error-msg']),
          (0, _utils.camelize)(component.errorMessage[0], true, true)
        )
      );
    }
  }]);
  return Select;
}(_react.Component);

Select.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired,
  isInModal: _propTypes.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  var step = state.step;
  /*return { component: components[ownProps.component.id] }*/

  return { step: step };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Select));

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _set = __webpack_require__(111);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(171);

var _from2 = _interopRequireDefault(_from);

var _typeof2 = __webpack_require__(93);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _lodash = __webpack_require__(96);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1137);

var _styles2 = _interopRequireDefault(_styles);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

__webpack_require__(1138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountryCode = function (_Component) {
    (0, _inherits3.default)(CountryCode, _Component);

    function CountryCode(props) {
        (0, _classCallCheck3.default)(this, CountryCode);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CountryCode.__proto__ || (0, _getPrototypeOf2.default)(CountryCode)).call(this, props));

        _this.toggleList = function () {
            var _this$props = _this.props,
                dispatch = _this$props.dispatch,
                component = _this$props.component;

            dispatch((0, _componentsActions.updateComponent)(component.id, { listOpen: !component.listOpen }));
        };

        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CountryCode, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                var dispatch = this.props.dispatch;

                this.props.component.fetchInProgress = true;
                dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('mousedown', this.handleClickOutside);
            var dispatch = this.props.dispatch;

            dispatch((0, _componentsActions.fetchData)(this.props.component.id, null, true));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }, {
        key: 'handleClickOutside',
        value: function handleClickOutside(event) {
            if (this.node.contains(event.target)) {
                return;
            }
            var _props = this.props,
                dispatch = _props.dispatch,
                component = _props.component;

            dispatch((0, _componentsActions.updateComponent)(component.id, { listOpen: false }));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatch = this.props.dispatch;

            if (nextProps.component && this.props.component.values.length === 0 && nextProps.component.values.length >= 0 || nextProps.component && this.props.component.values.length > 0 && nextProps.component.values.length === 0) {
                if (!this.props.component.value && !!this.props.component.initialValue) {
                    this.props.component.value = this.props.component.initialValue;
                }

                if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                    this.props.component.fetchInProgress = true;
                    dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
                }
            }
        }
    }, {
        key: 'onValueChange',
        value: function onValueChange(countryCode) {
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                component = _props2.component;

            dispatch((0, _componentsActions.updateComponent)(component.id, {
                value: countryCode.value,
                label: countryCode.label,
                listOpen: false
            }));
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var _this2 = this;

            var component = this.props.component;

            var values = component.values;
            var isObjectArray = false;
            var assetsPath = _utils.CONTEXT_ROOT + '/assets/flags/';

            if (values && values.constructor.toString().indexOf('Array') > -1 && (0, _typeof3.default)(values[0]) === 'object') {
                values = values.filter(function (v) {
                    return !!v.value && v.value !== '-1';
                });
                isObjectArray = true;
                values = (0, _lodash.uniqBy)(values, 'value');
            } else {
                values = (0, _from2.default)(new _set2.default(values));
            }

            return component.values.map(function (item) {
                return _react2.default.createElement(
                    'li',
                    { className: 'dd-list-item',
                        key: item.value,
                        onClick: function onClick() {
                            return _this2.onValueChange(item);
                        } },
                    _react2.default.createElement('img', (0, _extends3.default)({ src: assetsPath + item.value.substr(1) + '.svg'
                    }, (0, _withStyles.css)(_this2.props.styles.image))),
                    ' ' + item.label
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                widget = _props3.widget,
                component = _props3.component;

            var md = new _mobileDetect2.default(window.navigator.userAgent);
            var assetsPath = _utils.CONTEXT_ROOT + '/assets/flags/';
            var isResumePage = window.location.pathname.indexOf('/resume') >= 0 ? true : false;

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.component, component.fullWidth && this.props.styles.singleField, component.id === 'CELLULARE-PREF_CELLULARE' && !md.mobile() && !isResumePage && this.props.styles.divPrefix, this.props.styles.countryCodeComponent), {
                    ref: function ref(node) {
                        _this3.node = node;
                    } }),
                _react2.default.createElement(
                    'div',
                    (0, _extends3.default)({ className: 'dd-header', onClick: this.toggleList
                    }, (0, _withStyles.css)(this.props.styles.input, this.props.styles.flagInput, this.props.styles['input--select'], component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink'], !component.value && this.props.styles['input--unset'])),
                    _react2.default.createElement('img', (0, _extends3.default)({ src: assetsPath + component.value.substr(1) + '.svg'
                    }, (0, _withStyles.css)(this.props.styles.image))),
                    !!component.label ? ' ' + component.label : ''
                ),
                component.listOpen && _react2.default.createElement(
                    'ul',
                    { className: 'dd-list' },
                    this.renderOptions()
                ),
                _react2.default.createElement(
                    'span',
                    (0, _withStyles.css)(this.props.styles.label, component.value !== '' && this.props.styles['label--active'], this.props.isInModal && this.props.styles['label-neutral']),
                    component.cleanName
                ),
                _react2.default.createElement(
                    'small',
                    (0, _withStyles.css)(this.props.styles['error-msg']),
                    (0, _utils.camelize)(component.errorMessage[0], true, true)
                )
            );
        }
    }]);
    return CountryCode;
}(_react.Component);

CountryCode.propTypes = {
    widget: _propTypes.PropTypes.object.isRequired,
    component: _propTypes.PropTypes.object.isRequired,
    styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    var step = state.step;

    return { step: step };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(CountryCode));

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var colors = _ref.colors,
        spacings = _ref.spacings,
        images = _ref.images,
        fontFamilies = _ref.fontFamilies,
        fontWeights = _ref.fontWeights,
        fontSizes = _ref.fontSizes,
        textTransforms = _ref.textTransforms;


    var component = (0, _component2.default)({
        colors: colors,
        spacings: spacings,
        images: images,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        fontSizes: fontSizes,
        textTransforms: textTransforms
    });

    var styles = {
        image: {
            width: '1.3rem',
            height: '1rem',
            margin: '-0.2rem auto',
            backgroundColor: '#cecece',
            padding: '0.06rem'
        },
        flagInput: {
            cursor: 'default',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingRight: '0.6rem'
        },
        countryCodeComponent: {
            float: 'left'
        }
    };

    return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1139);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, "*{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-box-sizing:border-box;box-sizing:border-box;text-rendering:optimizeLegibility}:focus{outline:none}li,ul{list-style:none}li,p,ul{margin:0;padding:0}.dd-wrapper{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative}.dd-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;cursor:default;position:relative;background-color:#fff}.dd-header span{margin-right:20px}.dd-header-title{font-weight:300;margin:2px 10px}.angle-down{color:#000;margin-right:20px}.dd-list{z-index:10;position:absolute;border:1px solid #dfdfdf;border-top:none;border-bottom-right-radius:3px;border-bottom-left-radius:3px;background-color:#fff;-webkit-box-shadow:0 2px 5px -1px #e8e8e8;box-shadow:0 2px 5px -1px #e8e8e8;max-height:225px;overflow-y:scroll;-webkit-overflow-scrolling:touch}.dd-list-item{width:100%;padding:2px 5px 1px;line-height:1.6rem;cursor:default;display:block;white-space:nowrap;text-overflow:ellipsis}.dd-list-item.selected,.dd-list-item:hover{color:#fff;background-color:#1e90ff}.dd-wrapper-single{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;width:265px}.dd-wrapper-single .dd-header{border:1px solid #ccc}.dd-wrapper-single .dd-header .dd-header-name{font-weight:400}.dd-wrapper-single .dd-list{border:1px solid #ccc;border-top:none}", ""]);

// exports


/***/ }),
/* 1140 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _api = __webpack_require__(45);

var _lodash = __webpack_require__(96);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1142);

var _styles2 = _interopRequireDefault(_styles);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tariffe = function (_Component) {
    (0, _inherits3.default)(Tariffe, _Component);

    function Tariffe(props) {
        (0, _classCallCheck3.default)(this, Tariffe);
        return (0, _possibleConstructorReturn3.default)(this, (Tariffe.__proto__ || (0, _getPrototypeOf2.default)(Tariffe)).call(this, props));
    }

    (0, _createClass3.default)(Tariffe, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                var dispatch = this.props.dispatch;

                this.props.component.fetchInProgress = true;
                dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                component = _props.component,
                dispatch = _props.dispatch,
                guid = _props.guid;

            var url = 'OnboardRequestDetails/FetchPOSPlan';
            var body = { GUID: guid };
            (0, _api.FetchPOSPlan)(url, body).then(function (json) {
                var dbplan = json && json.payLoad && json.payLoad.Plan && json.payLoad.Plan.toUpperCase();
                var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
                var plan = planMap[dbplan] || 'flat';
                dispatch((0, _componentsActions.updateComponent)(component.id, { plan: plan }));
            });
        }
    }, {
        key: 'ChangePOSPlan',
        value: function ChangePOSPlan() {
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                component = _props2.component;
            var plan = component.plan;

            var newplan = plan === 'flex' || plan === 'flexmini' ? 'flat' : 'flex';
            dispatch((0, _componentsActions.updateComponent)(component.id, { plan: newplan }));

            // {() => {
            //     const plan = this.component.plan=== 'flex' ? 'flat' : 'flex';
            //     dispatch(updateComponent(component.id, {plan:plan}));
            // }}
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatch = this.props.dispatch;

            if (nextProps.component && this.props.component.values.length === 0 && nextProps.component.values.length >= 0 || nextProps.component && this.props.component.values.length > 0 && nextProps.component.values.length === 0) {
                if (!this.props.component.value && !!this.props.component.initialValue) {
                    this.props.component.value = this.props.component.initialValue;
                }

                if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                    this.props.component.fetchInProgress = true;
                    dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
                }
            }
            var component = nextProps.component;

            if (component && component.plan && (component.plan === 'flex' || component.plan && component.plan.toUpperCase() === 'FLEXCRS' || component.plan && component.plan.toUpperCase() === 'FLEXMINI') && this.props.component && component.plan !== this.props.component.plan) {
                this.onValueChange(component.plan.toUpperCase() === 'FLEXMINI' ? '207' : '203', component.plan);
            }
        }
    }, {
        key: 'onValueChange',
        value: function onValueChange(selectedValue, plan) {
            var _props3 = this.props,
                dispatch = _props3.dispatch,
                component = _props3.component;

            if (selectedValue === '203') {
                if (plan === 'flex' || plan && plan.toUpperCase() === 'FLEXCRS') {
                    dispatch((0, _componentsActions.updateComponent)('S2-S2S1D6', { status: ['readonly'], active: true }));
                    dispatch((0, _componentsActions.updateComponent)('S2-S2S1D2', { status: ['hidden'] }));
                } else {
                    dispatch((0, _componentsActions.updateComponent)('S2-S2S1D2', { status: ['readonly'] }));
                    dispatch((0, _componentsActions.updateComponent)('S2-S2S1D3', { status: ['hidden'], active: false }));
                }
            } else if (selectedValue === '207') {
                dispatch((0, _componentsActions.updateComponent)('S2-S2S1D3', { status: ['readonly'], active: true }));
                dispatch((0, _componentsActions.updateComponent)('S2-S2S1D2', { status: ['hidden'] }));
            }
            dispatch((0, _componentsActions.updateComponent)(component.id, { value: selectedValue }));
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var _this2 = this;

            var component = this.props.component;
            var values = component.values,
                plan = component.plan;


            var filteredPlans = values.filter(function (v) {
                return (plan === 'flat' || plan && plan.toUpperCase() === 'FLATCRS') && (v.value === '193' || v.value === '194' || v.value === '204' || v.value === '205') || (plan === 'flex' || plan && plan.toUpperCase() === 'FLEXCRS') && v.value === '203' || (plan === 'flexmini' || plan && plan.toUpperCase() === 'FLEXMINI') && v.value === '207';
            });

            return filteredPlans.map(function (v) {
                return _react2.default.createElement(
                    'div',
                    (0, _withStyles.css)(_this2.props.styles.component, (v.value === '203' || v.value === '207') && _this2.props.styles['tariffe-hide'] /*, this.props.styles['tariffe-component']*/),
                    _react2.default.createElement(
                        'div',
                        (0, _withStyles.css)(_this2.props.styles.tariffe, component.status.indexOf('error') > -1 && _this2.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && _this2.props.styles['input--blink'], !component.value && _this2.props.styles['input--unset']),
                        _react2.default.createElement(
                            'div',
                            (0, _extends3.default)({}, (0, _withStyles.css)(_this2.props.styles['tariffe-block'], v.value === component.value ? _this2.props.styles['tariffe-block-selected'] : _this2.props.styles['tariffe-block-disabled']), {
                                onClick: function onClick() {
                                    return _this2.onValueChange(v.value, plan);
                                } }),
                            _react2.default.createElement('span', (0, _withStyles.css)(v.value === component.value ? _this2.props.styles['tariffe-selected-img'] : '')),
                            _react2.default.createElement(
                                'div',
                                (0, _withStyles.css)(_this2.props.styles['tariffe-currency-vat']),
                                _react2.default.createElement(
                                    'div',
                                    (0, _withStyles.css)(_this2.props.styles['tariffe-currency'], v.value === component.value ? _this2.props.styles['tariffe-selected'] : _this2.props.styles['tariffe-disabled']),
                                    v.currency
                                ),
                                _react2.default.createElement(
                                    'div',
                                    (0, _withStyles.css)(_this2.props.styles['tariffe-vat']),
                                    v.vat
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                (0, _withStyles.css)(_this2.props.styles['tariffe-per-month']),
                                v.perMonth
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            (0, _withStyles.css)(_this2.props.styles['tariffe-desc']),
                            v.desc
                        )
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                dispatch = _props4.dispatch,
                component = _props4.component;
            var plan = component.plan;

            var md = new _mobileDetect2.default(window.navigator.userAgent);

            return _react2.default.createElement(
                'div',
                null,
                this.renderOptions(),
                _react2.default.createElement(
                    'span',
                    (0, _withStyles.css)(this.props.styles.label, component.value !== '' && this.props.styles['label--active'], this.props.isInModal && this.props.styles['label--neutral']),
                    component.cleanName
                ),
                _react2.default.createElement(
                    'small',
                    (0, _withStyles.css)(this.props.styles['error-msg']),
                    (0, _utils.camelize)(component.errorMessage[0], true, true)
                ),
                (plan === 'flat' || plan === 'flatCRS') && _react2.default.createElement(
                    'div',
                    { className: 'grayed mt-4' },
                    'Se sei gi\xE0 in possesso di un ',
                    _react2.default.createElement(
                        'b',
                        null,
                        'codice coupon'
                    ),
                    ' puoi inserirlo all\'ultimo step dopo la firma dei contratti, prima dell\'invio della pratica.'
                )
            );
        }
    }]);
    return Tariffe;
}(_react.Component);

Tariffe.propTypes = {
    widget: _propTypes.PropTypes.object.isRequired,
    component: _propTypes.PropTypes.object.isRequired,
    styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    var step = state.step;

    return step;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Tariffe));

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assetsPath = _utils.CONTEXT_ROOT + '/assets';

exports.default = function (_ref) {
    var colors = _ref.colors,
        spacings = _ref.spacings,
        images = _ref.images,
        fontFamilies = _ref.fontFamilies,
        fontWeights = _ref.fontWeights,
        fontSizes = _ref.fontSizes,
        textTransforms = _ref.textTransforms;


    var component = (0, _component2.default)({
        colors: colors,
        spacings: spacings,
        images: images,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        fontSizes: fontSizes,
        textTransforms: textTransforms
    });

    var styles = {
        // 'tariffe-component':{
        //     width: '14rem!important'
        // },
        'tariffe': {
            width: '20rem', //13rem',
            position: 'relative'
        },
        'tariffe-block': {
            // textAlign: 'center',
            border: '2px solid',
            padding: '2rem 5rem', //'1.5rem 2rem',
            borderRadius: '5px',
            cursor: 'pointer'
        },
        'tariffe-block-selected': {
            borderColor: colors.input.border.active
        },
        'tariffe-selected': {
            color: colors.label.default
        },
        'tariffe-selected-img': {
            // backgroundImage: 'url(/assets/images/sella_it_logo.svg)',
            backgroundImage: 'url(\'' + assetsPath + '/images/select_tick.svg\')',
            position: 'absolute',
            width: '2rem',
            height: '2rem',
            backgroundRepeat: 'no-repeat',
            top: '-0.7rem',
            right: '-0.85rem'
        },
        'tariffe-block-disabled': {
            // borderColor: colors.input.border.default
            borderColor: '#cecece'
        },
        'tariffe-disabled': {
            // color: colors.label.disabled
            color: '#cecece'
        },
        'tariffe-currency-vat': {},
        'tariffe-currency': {
            display: 'inline-block',
            fontSize: '4rem',
            fontWeight: '900'
        },
        'tariffe-vat': {
            display: 'inline-block',
            position: 'absolute',
            marginTop: '2rem',
            fontSize: '0.8rem',
            fontWeight: '900',
            marginLeft: '0.5rem'
        },
        'tariffe-per-month': {
            textAlign: 'center'
        },
        'tariffe-desc': {
            marginTop: '0.5rem'
            //fontSize: '0.9rem'
        },
        "tariffe-link": {
            textDecoration: "underline",
            color: "#4285f4",
            fontWeight: "600",
            cursor: "pointer"
        },
        "tariffe-hide": {
            display: 'none'
        }

    };

    return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DropDownSearch = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(65);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _reactSelect = __webpack_require__(253);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(1144);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1146);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import 'react-select/dist/react-select.css'
var DropDownSearch = exports.DropDownSearch = function (_Component) {
    (0, _inherits3.default)(DropDownSearch, _Component);

    function DropDownSearch(props) {
        (0, _classCallCheck3.default)(this, DropDownSearch);
        return (0, _possibleConstructorReturn3.default)(this, (DropDownSearch.__proto__ || (0, _getPrototypeOf2.default)(DropDownSearch)).call(this, props));
    }

    (0, _createClass3.default)(DropDownSearch, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                var dispatch = this.props.dispatch;

                this.props.component.fetchInProgress = true;
                dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dispatch = this.props.dispatch;

            dispatch((0, _componentsActions.fetchData)(this.props.component.id, null, true));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatch = this.props.dispatch;

            if (nextProps.component && this.props.component.values.length === 0 && nextProps.component.values.length >= 0 || nextProps.component && this.props.component.values.length > 0 && nextProps.component.values.length === 0) {
                if (!this.props.component.value && !!this.props.component.initialValue) {
                    this.props.component.value = this.props.component.initialValue;
                }

                if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                    this.props.component.fetchInProgress = true;
                    dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
                }
            }
        }
    }, {
        key: 'onValueChange',
        value: function onValueChange(e) {
            var _props = this.props,
                dispatch = _props.dispatch,
                component = _props.component;

            dispatch((0, _componentsActions.updateComponent)(component.id, { value: !!e.value ? e.value : '' }));
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var _this2 = this;

            var _props2 = this.props,
                widget = _props2.widget,
                component = _props2.component;

            if (component.id === 'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA' && !!component.values) {
                component.values.forEach(function (item) {
                    item.label = item.value.replace('##', '  ');
                });
            }
            return _react2.default.createElement(
                'div',
                (0, _withStyles.css)(this.props.styles.component, component.fullWidth && this.props.styles.singleField),
                _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.try, this.props.styles['input--select'], component.status.indexOf('error') > -1 && this.props.styles['input--invalid']), {
                    name: component.id,
                    value: component.value,
                    onChange: function onChange(event) {
                        _this2.onValueChange(event);
                    },
                    options: component.values, placeholder: component.cleanName
                }))
            );
        }
    }, {
        key: 'validateRequired',
        value: function validateRequired() {
            var component = this.props.component;

            if (component.validations && component.validations.isRequired && !component.isDisabled) {
                return true;
            }
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var component = this.props.component;

            return _react2.default.createElement(
                'div',
                (0, _withStyles.css)(this.props.styles.divmain, this.props.styles.component, component.fullWidth && this.props.styles.singleField),
                _react2.default.createElement(
                    'span',
                    (0, _withStyles.css)(this.props.styles.label, component.value !== '' && this.props.styles.labelActive),
                    component.cleanName
                ),
                this.renderOptions(),
                _react2.default.createElement(
                    'p',
                    null,
                    !!component.staticDescription && component.staticDescription
                ),
                _react2.default.createElement(
                    'small',
                    (0, _withStyles.css)(this.props.styles['error-msg']),
                    (0, _utils.camelize)(component.errorMessage[0], true, true)
                )
            );
        }
    }]);
    return DropDownSearch;
}(_react.Component);

DropDownSearch.propTypes = {
    widget: _propTypes.PropTypes.object.isRequired,
    component: _propTypes.PropTypes.object.isRequired,
    styles: _propTypes.PropTypes.object.isRequired,
    isInModal: _propTypes.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
    var step = state.step;
    /*return { component: components[ownProps.component.id] }*/

    return { step: step };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(DropDownSearch));

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1145);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:#fff;background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333;font-weight:600}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:none;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{font-size:0;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#00b7ff transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{color:#736d91;border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#000;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:#1e90ff;color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var colors = _ref.colors,
        spacings = _ref.spacings,
        images = _ref.images,
        fontFamilies = _ref.fontFamilies,
        fontWeights = _ref.fontWeights,
        fontSizes = _ref.fontSizes,
        textTransforms = _ref.textTransforms;

    var component = (0, _component2.default)({
        colors: colors,
        spacings: spacings,
        images: images,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        fontSizes: fontSizes,
        textTransforms: textTransforms
    });
    var styles = {

        try: {
            border: 'none',
            borderBottom: '2px solid #bab7cc',
            borderBottomStyle: 'solid',
            borderRadius: '0px'
        },
        labelActive: {
            fontWeight: '800',
            position: 'relative',
            color: '#00B7FF', //'#00a5ff',
            fontSize: '.75rem',
            top: '0',
            display: 'block',
            visibility: 'visible'
        },
        divmain: {
            paddingTop: '10px'
        }
    };
    return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultiSelect = undefined;

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _set = __webpack_require__(111);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(171);

var _from2 = _interopRequireDefault(_from);

var _typeof2 = __webpack_require__(93);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(65);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _reactSelect = __webpack_require__(253);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(1148);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1150);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import 'react-select/dist/react-select.css';
var MultiSelect = exports.MultiSelect = function (_Component) {
    (0, _inherits3.default)(MultiSelect, _Component);

    function MultiSelect(props) {
        (0, _classCallCheck3.default)(this, MultiSelect);
        return (0, _possibleConstructorReturn3.default)(this, (MultiSelect.__proto__ || (0, _getPrototypeOf2.default)(MultiSelect)).call(this, props));
    }

    (0, _createClass3.default)(MultiSelect, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                var dispatch = this.props.dispatch;

                this.props.component.fetchInProgress = true;
                dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dispatch = this.props.dispatch;

            dispatch((0, _componentsActions.fetchData)(this.props.component.id, null, true));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatch = this.props.dispatch;

            if (nextProps.component && this.props.component.values.length === 0 && nextProps.component.values.length >= 0 || nextProps.component && this.props.component.values.length > 0 && nextProps.component.values.length === 0) {
                if (!this.props.component.value && !!this.props.component.initialValue) {
                    this.props.component.value = this.props.component.initialValue;
                }

                if (this.props.component.hasOwnProperty('options') && (this.props.component.values || []).length === 0 && !this.props.component.fetchInProgress) {
                    this.props.component.fetchInProgress = true;
                    dispatch((0, _componentsActions.getSelectOptions)(this.props.component));
                }
            }
        }
    }, {
        key: 'onValueChange',
        value: function onValueChange(selectedOption) {
            var _props = this.props,
                dispatch = _props.dispatch,
                component = _props.component;
            //this.props.setSelectedOptions.push(selectedOption)

            dispatch((0, _componentsActions.updateComponent)(component.id, { value: selectedOption }));
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var _this2 = this;

            var _props2 = this.props,
                widget = _props2.widget,
                component = _props2.component;

            var values = component.values;
            var componentValues = [];
            var isObjectArray = false;
            if (values && values.constructor.toString().indexOf('Array') > -1 && (0, _typeof3.default)(values[0]) === 'object') {
                values = values.filter(function (v) {
                    return !!v.value && v.value !== '-1';
                });
                isObjectArray = true;
                values = uniqBy(values, 'value');
            } else {
                values = (0, _from2.default)(new _set2.default(values));
            }
            values.map(function (v) {
                if (!isObjectArray) {
                    var item = {};
                    item.value = v, item.label = v;
                    componentValues.push(item);
                }
            });
            return (
                // <div {...css(this.props.styles.component,  component.fullWidth && this.props.styles.singleField)}>
                _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, (0, _withStyles.css)(this.props.styles.try, this.props.styles['input--select'], component.status.indexOf('error') > -1 && this.props.styles['input--invalid']), {
                    name: component.id,
                    value: this.props.setSelectedOptions,
                    onChange: function onChange(event) {
                        _this2.onValueChange(event);
                    },
                    options: componentValues, placeholder: component.cleanName,
                    multi: true,
                    removeSelected: false,
                    joinValues: true,
                    simpleValue: true,
                    delimiter: '||'
                }))

                //</div>

            );
        }
    }, {
        key: 'validateRequired',
        value: function validateRequired() {
            var component = this.props.component;

            if (component.validations && component.validations.isRequired && !component.isDisabled) {
                return true;
            }
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var component = this.props.component;

            return _react2.default.createElement(
                'div',
                (0, _withStyles.css)(this.props.styles.divmain, this.props.styles.component, component.fullWidth && this.props.styles.singleField),
                _react2.default.createElement(
                    'span',
                    (0, _withStyles.css)(this.props.styles.label, component.value !== '' && this.props.styles.labelActive),
                    component.cleanName
                ),
                this.renderOptions(),
                _react2.default.createElement(
                    'p',
                    null,
                    !!component.staticDescription && component.staticDescription
                ),
                _react2.default.createElement(
                    'small',
                    (0, _withStyles.css)(this.props.styles['error-msg']),
                    (0, _utils.camelize)(component.errorMessage[0], true, true)
                )
            );
        }
    }]);
    return MultiSelect;
}(_react.Component);

MultiSelect.propTypes = {
    widget: _propTypes.PropTypes.object.isRequired,
    component: _propTypes.PropTypes.object.isRequired,
    styles: _propTypes.PropTypes.object.isRequired,
    setSelectedOptions: _propTypes.object.array
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
    var step = state.step;
    /*return { component: components[ownProps.component.id] }*/

    return { step: step };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(MultiSelect));

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1149);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var colors = _ref.colors,
        spacings = _ref.spacings,
        images = _ref.images,
        fontFamilies = _ref.fontFamilies,
        fontWeights = _ref.fontWeights,
        fontSizes = _ref.fontSizes,
        textTransforms = _ref.textTransforms;

    var component = (0, _component2.default)({
        colors: colors,
        spacings: spacings,
        images: images,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        fontSizes: fontSizes,
        textTransforms: textTransforms
    });
    var styles = {

        try: {
            border: 'none',
            borderBottom: '2px solid #bab7cc',
            borderBottomStyle: 'solid',
            borderRadius: '0px'
        },
        labelActive: {
            fontWeight: '800',
            position: 'relative',
            color: '#00B7FF', //'#00a5ff',
            fontSize: '.75rem',
            top: '0',
            display: 'block',
            visibility: 'visible'
        },
        divmain: {
            paddingTop: '10px'
        }
    };
    return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1152);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Radio = function (_Component) {
  (0, _inherits3.default)(Radio, _Component);

  function Radio(props) {
    (0, _classCallCheck3.default)(this, Radio);
    return (0, _possibleConstructorReturn3.default)(this, (Radio.__proto__ || (0, _getPrototypeOf2.default)(Radio)).call(this, props));
  }

  (0, _createClass3.default)(Radio, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch;

      var value = 'selected';
      if (component.value === 'selected' || component.status.indexOf('selected') > -1) {
        this.input.checked = true;
        value = 'selected';
      } else {
        this.input.checked = false;
        value = '';
      }
      dispatch((0, _componentsActions.updateComponent)(component.id, { value: value, status: component.status.filter(function (s) {
          return s !== 'selected';
        }) }, { bypassValidation: component.status.indexOf('error') < 0 }));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          component = _props2.component,
          dispatch = _props2.dispatch;

      if (nextProps.component && nextProps.component.status.indexOf('selected') > -1 && nextProps.component.value === '' && component.value === 'selected') {
        dispatch((0, _componentsActions.updateComponent)(component.id, { value: 'selected' }));
      }
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _props3 = this.props,
          component = _props3.component,
          widget = _props3.widget,
          components = _props3.components,
          dispatch = _props3.dispatch;

      if (!this.input.disabled && this.input.checked) {
        dispatch((0, _componentsActions.updateComponent)(component.id, { value: 'selected' }));
        var radioGroup = null;
        if (widget.radioGroup) {
          var parentId = widget.radioGroup[component.id_];
          radioGroup = (0, _keys2.default)(widget.radioGroup).filter(function (k) {
            return widget.radioGroup[k] === parentId;
          });
        }
        var relatedRadioKeys = (0, _keys2.default)(components).filter(function (k) {
          return k !== component.id && components[k].type === 'radio' && (radioGroup ? radioGroup.some(function (id_) {
            return id_ === components[k].id_;
          }) : k.startsWith(widget.name + '-'));
        });
        relatedRadioKeys.forEach(function (k) {
          dispatch((0, _componentsActions.updateComponent)(k, { value: '' }, { bypassValidation: true }));
        });
      }
    }
  }, {
    key: 'onImageClick',
    value: function onImageClick(e) {
      var _this2 = this;

      if ((0, _keys2.default)(this.imageModifiers).some(function (k) {
        return !!_this2.imageModifiers[k];
      })) {
        var radio = Array.prototype.slice.call(e.target.childNodes).find(function (n) {
          return n.type === 'radio';
        });
        if (!!radio) {
          radio.click();
        }
      }
    }

    /**
     * Checks if none of the related radios are selected
     *
     * @return {Boolean}             The result
     */

  }, {
    key: 'hasAnyRelatedRadioError',
    value: function hasAnyRelatedRadioError() {
      var _props4 = this.props,
          components = _props4.components,
          widget = _props4.widget,
          component = _props4.component;

      var radioGroup = null;
      if (widget && widget.radioGroup) {
        var parentId = widget.radioGroup[component.id_];
        radioGroup = (0, _keys2.default)(widget.radioGroup).filter(function (k) {
          return widget.radioGroup[k] === parentId;
        });
      }
      var keys = (0, _keys2.default)(components).filter(function (k) {
        return components[k].type === 'radio';
      });
      if (widget && radioGroup) {
        keys = keys.filter(function (k) {
          return radioGroup.some(function (id_) {
            return id_ === components[k].id_;
          });
        });
      } else {
        keys = keys.filter(function (k) {
          return k.indexOf(component.id.split('-')[0]) > -1;
        });
      }

      /*const keys = Object.keys(components).filter(
        k =>
          k.indexOf(component.id.split('-')[0]) > -1 &&
          components[k].type === 'radio'
      ) */

      var noneHasError = keys.reduce(function (res, k) {
        return res && components[k].status.indexOf('error') < 0;
      }, true);

      return !noneHasError;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          widgets = _props5.widgets,
          component = _props5.component;

      var widget = widgets[component.id.split('-')[0]];

      this.imageModifiers = [component.id.indexOf('CARTA_FISICA') > -1 && !component.value && this.props.styles['radio--phisical-card'], component.id.indexOf('CARTA_FISICA') > -1 && !!component.value && this.props.styles['radio--phisical-card-selected'], component.id.indexOf('CARTA_VIRTUALE') > -1 && !component.value && this.props.styles['radio--virtual-card'], component.id.indexOf('CARTA_VIRTUALE') > -1 && !!component.value && this.props.styles['radio--virtual-card-selected'], component.id.indexOf('BONIFICO') > -1 && !component.value && this.props.styles['radio--bonifico'], component.id.indexOf('BONIFICO') > -1 && !!component.value && this.props.styles['radio--bonifico-selected']].filter(function (e) {
        return !!e;
      });

      if (!widget) return null;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, _withStyles.css.apply(undefined, [this.props.styles.component, this.props.styles.radio, this.imageModifiers.length > 0 && this.props.styles['radio--image']].concat((0, _toConsumableArray3.default)(this.imageModifiers), [component.id.indexOf('RIF_SPEDIZIONE_CARTA-') > -1 && this.props.styles['component--third'], component.status.indexOf('readonly') > -1 && component.status.indexOf('reallyreadonly') > -1 && this.props.styles['radio--readonly'], component.id === 'SEDE_AMMINISTRATIVA-ALTRO' || component.id === 'SEDE_AMMINISTRATIVA-SEDE_LEGALE' ? this.props.styles['radio--input-height'] : ''])), {
          onClick: this.onImageClick.bind(this)
        }),
        _react2.default.createElement('input', (0, _extends3.default)({
          ref: function ref(input) {
            _this3.input = input;
          },
          type: 'radio',
          name: widget.radioGroup ? widget.radioGroup[component.id_] : widget.group,
          disabled: component.status.indexOf('readonly') > -1,
          id: component.id
        }, (0, _withStyles.css)(this.props.styles.input, this.imageModifiers.length > 0 && this.props.styles['input--image']), {
          value: component.value,
          onClick: this.onClick.bind(this)
        })),
        _react2.default.createElement(
          'label',
          (0, _extends3.default)({
            htmlFor: component.id
          }, (0, _withStyles.css)(this.props.styles.label, this.imageModifiers.length > 0 && this.props.styles['label--image'], this.hasAnyRelatedRadioError() && this.props.styles['label--invalid'])),
          component.cleanName,
          !!component.description ? _react2.default.createElement(
            'div',
            (0, _withStyles.css)(this.props.styles.sublabel, component.status.indexOf('readonly') > -1 && component.status.indexOf('reallyreadonly') > -1 && this.props.styles['sublabel--readonly']),
            component.description
          ) : ''
        )
      );
    }
  }]);
  return Radio;
}(_react.Component);

Radio.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components,
      widgets = state.widgets;

  return { component: components[ownProps.component.id], widgets: widgets, components: components };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Radio));

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _parsers = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    radio: { width: '50% !important' },

    'radio--image': {
      cursor: 'pointer',
      paddingTop: (0, _parsers.important)('6.6rem'),

      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center'
    },

    'radio--readonly': {
      cursor: 'default'
    },

    label: {
      fontFamily: fontFamilies.alternate
    },

    'label--image': {
      fontWeight: fontWeights.radio.title,

      position: (0, _parsers.important)('static'),

      display: (0, _parsers.important)('block'),

      width: (0, _parsers.important)('100%'),
      marginRight: 'auto',
      marginLeft: 'auto',
      paddingTop: '2.5rem',
      paddingLeft: (0, _parsers.important)('0'),

      textAlign: 'center',

      '::before': {
        top: (0, _parsers.important)('7rem'),
        left: (0, _parsers.important)('50%'),

        marginLeft: '-10px'
      },

      '::after': {
        top: (0, _parsers.important)('7.4rem'),
        left: (0, _parsers.important)('50%'),

        marginLeft: '-4px'
      }
    },

    'radio--phisical-card': {
      backgroundImage: images.phisicalCard
    },

    'radio--phisical-card-selected': {
      backgroundImage: images.phisicalCardSelected
    },

    'radio--virtual-card': (0, _defineProperty3.default)({
      backgroundImage: images.virtualCard

    }, (0, _breakTo2.default)('small'), {
      backgroundPositionX: spacings.radioImage.virtualCard.small
    }),

    'radio--virtual-card-selected': (0, _defineProperty3.default)({
      backgroundImage: images.virtualCardSelected

    }, (0, _breakTo2.default)('small'), {
      backgroundPositionX: spacings.radioImage.virtualCard.small
    }),

    'radio--selfie': (0, _defineProperty3.default)({
      backgroundImage: images.selfie,
      backgroundPositionX: spacings.radioImage.selfie.default,

      backgroundSize: 100

    }, (0, _breakTo2.default)('small'), {
      backgroundPositionX: spacings.radioImage.selfie.small
    }),

    'radio--selfie-selected': (0, _defineProperty3.default)({
      backgroundImage: images.selfieSelected,
      backgroundPositionX: spacings.radioImage.selfie.default,

      backgroundSize: 100

    }, (0, _breakTo2.default)('small'), {
      backgroundPositionX: spacings.radioImage.selfie.small
    }),

    'radio--bonifico': {
      backgroundImage: images.bonifico
    },

    'radio--bonifico-selected': {
      backgroundImage: images.bonificoSelected
    },

    input: {
      position: 'absolute',
      left: '-9999px',

      ':enabled + label': {
        fontSize: '0.875rem',
        lineHeight: '1.8',

        position: 'absolute',

        display: 'inline-block',

        paddingLeft: spacings.x5,

        cursor: 'pointer',

        color: colors.common.text,
        // checkbox appearence
        '::before': {
          position: 'absolute',
          top: '0',
          left: '0',

          width: '20px',
          height: '20px',

          content: "''",

          border: '2px solid ' + colors.flag.default,
          borderRadius: '50%',
          background: colors.flag.bg
        },
        // checked mark appearence
        '::after': {
          fontSize: spacings.x4,
          lineHeight: '15px',

          position: 'absolute',
          top: '6px',
          left: '6px',

          width: '10px',
          height: '10px',

          content: "''",
          transition: 'all .2s',
          textAlign: 'center',

          border: '1px solid ' + colors.flag.checked,
          borderRadius: '50%',
          backgroundColor: colors.flag.checked
        }
      },

      ':disabled + label': {
        color: colors.flag.default
      },

      ':not(:checked) + label::after': {
        fontSize: 0,

        opacity: 0
      },

      ':not(:checked):disabled + label::before': {
        boxShadow: 'none'
      },

      ':checked + label::before': {
        border: '2px solid ' + colors.flag.checked
      },

      ':checked + label::after': {
        transform: 'scale(1)',

        opacity: '1'
      },

      ':disabled + label::before': {
        boxShadow: 'none'
      },

      ':disabled + label::after': {
        border: '1px solid ' + colors.flag.disabled
      }
    },

    'input--image': {
      ':not(:checked) + label': {
        color: colors.flag.default
      }
    },

    'label--invalid': {
      color: colors.common.utility.error.default
    },

    sublabel: {
      fontSize: '13px',
      fontWeight: fontWeights.radio.subtitle,
      lineHeight: '1rem'
    },
    'sublabel--readonly': {
      color: colors.common.text,
      cursor: 'text'
    },
    'radio--input-height': {
      'min-height': '7rem'
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(94);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _stepActions = __webpack_require__(28);

var _componentsActions = __webpack_require__(19);

var _spinner = __webpack_require__(137);

var _spinner2 = _interopRequireDefault(_spinner);

var _reactRedux = __webpack_require__(14);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1155);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = new _mobileDetect2.default(window.navigator.userAgent);

var File = function (_Component) {
  (0, _inherits3.default)(File, _Component);

  function File(props) {
    (0, _classCallCheck3.default)(this, File);

    var _this = (0, _possibleConstructorReturn3.default)(this, (File.__proto__ || (0, _getPrototypeOf2.default)(File)).call(this, props));

    _this.state = {
      focused: false
    };
    return _this;
  }

  (0, _createClass3.default)(File, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch;


      if (!component.value) {
        dispatch((0, _componentsActions.updateFilePreview)(component));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.component) {
        nextProps.component.styleObj = {};
        if (!!nextProps.component.value) {
          nextProps.component.styleObj = {
            backgroundImage: 'url(' + nextProps.component.value + ')'
          };
        }
      }
    }
  }, {
    key: 'onUploaderClick',
    value: function onUploaderClick(e) {
      if (!md.mobile()) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            component = _props2.component;

        if (e.currentTarget.id.indexOf('--out') < 0) {
          e.preventDefault();
          dispatch((0, _stepActions.showWebcamModal)(component));
        }
      }
    }
  }, {
    key: 'onFileUpload',
    value: function onFileUpload(e) {
      e.preventDefault();
      var _props3 = this.props,
          component = _props3.component,
          dispatch = _props3.dispatch;

      var reader = new FileReader();
      var file = e.target.files[0];
      if (!!file) {
        if (_utils.fileTypes.some(function (f) {
          return f.toUpperCase() === file.type.toUpperCase();
        })) {
          if (file.type === 'application/pdf') {
            reader.addEventListener("load", function () {
              dispatch((0, _componentsActions.uploadFile)((0, _extends3.default)({}, component, { value: reader.result }), file));
            }, false);
            reader.readAsDataURL(file);
          } else {
            reader.onloadend = function () {
              (0, _utils.resizeImage)(reader.result, _utils.MAX_IMAGE_UPLOAD_SIZE).then(function (dataUri) {
                dispatch((0, _componentsActions.uploadFile)((0, _extends3.default)({}, component, { value: dataUri }), file));
              });
            };
            reader.readAsDataURL(file);
            e.target.value = '';
          }
        } else {
          return dispatch((0, _componentsActions.updateComponent)(component.id, {
            value: '',
            errorMessage: "InValid File Format",
            isLoading: false
          }, { avoidValidation: true }));
        }
      }
    }
  }, {
    key: 'getProperErrorMessage',
    value: function getProperErrorMessage() {
      var component = this.props.component;


      if (!!component.validations.overrides) {
        var validationResult = (0, _utils.getValidationsResult)({
          component: component,
          type: 'overrides'
        });
        if (!validationResult.result) {
          return validationResult.errorMessage;
        }
      }
      return component.errorMessage; //&& component.errorMessage[0]
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.setState({ focused: true });
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.setState({ focused: false });
    }
  }, {
    key: 'dragOver',
    value: function dragOver(e) {
      if (e.target.name !== 'SELFIE-SELFIE_UPLOAD') {
        this.focus();
      }
    }
  }, {
    key: 'drop',
    value: function drop(e) {
      if (e.target.name === 'SELFIE-SELFIE_UPLOAD') {
        e.preventDefault();
      }
      this.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          component = _props4.component,
          components = _props4.components;


      var documentTypeComponent = components['DOCUMENTO-TIPO_DOCUMENTO'];

      var modifiers = [!!md.mobile() && this.props.styles['uploader--mobile'], component.name.indexOf('DOCF') > -1 && !!documentTypeComponent && documentTypeComponent.value === 'Carta d\'identita' && this.props.styles['uploader--idcard-front'], component.name.indexOf('DOCR') > -1 && !!documentTypeComponent && documentTypeComponent.value === 'Carta d\'identita' && this.props.styles['uploader--idcard-back'], component.name.indexOf('DOCF') > -1 && !!documentTypeComponent && documentTypeComponent.value === 'Patente di guida' && this.props.styles['uploader--license-front'], component.name.indexOf('DOCR') > -1 && !!documentTypeComponent && documentTypeComponent.value === 'Patente di guida' && this.props.styles['uploader--license-back'], component.name.indexOf('DOCF') > -1 && !!documentTypeComponent && documentTypeComponent.value === 'Passaporto' && this.props.styles['uploader--passport-front'], component.name.indexOf('DOCR') > -1 && !!documentTypeComponent && documentTypeComponent.value === 'Passaporto' && this.props.styles['uploader--passport-back'], component.name.indexOf('SELFIE') > -1 && this.props.styles['uploader--selfie'], component.name.indexOf('IDENT_WEBCAM') >= 0 && this.props.styles['uploader--identwebcam'], !!component.value && this.props.styles['uploader--filled'], !component.value && component.status.indexOf('error') > -1 && this.props.styles[!!md.mobile() || component.name.indexOf('SELFIE') > -1 ? 'uploader--error-mobile' : 'uploader--error'], !!component.isLoading && this.props.styles['uploader--loading'], !!this.state.focused && this.props.styles[!!md.mobile() || component.name.indexOf('SELFIE') > -1 ? 'uploader--focus-mobile' : 'uploader--focus']].filter(function (e) {
        return !!e;
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, _withStyles.css.apply(undefined, [this.props.styles.component, component.fullWidth && this.props.styles.singleField, this.props.styles.uploader].concat((0, _toConsumableArray3.default)(modifiers))), {
          style: component.styleObj
        }),
        !!this.props.component.isLoading ? _react2.default.createElement(_spinner2.default, { type: 'local' }) : '',
        _react2.default.createElement('input', (0, _extends3.default)({
          type: 'file',
          id: component.id + '--out'
        }, (0, _withStyles.css)(this.props.styles['input-file'], this.props.styles['input-file--out']), {
          // value={component.value}
          onChange: function onChange(event) {
            return _this2.onFileUpload(event);
          },
          onClick: this.onUploaderClick.bind(this),
          name: component.id
        })),
        ' ',
        _react2.default.createElement('input', (0, _extends3.default)({
          type: 'file',
          id: component.id
        }, (0, _withStyles.css)(this.props.styles['input-file']), {
          // value={component.value}
          onFocus: this.focus.bind(this),
          onDragOver: this.dragOver.bind(this),
          onDragEnd: this.blur.bind(this),
          onDragLeave: this.blur.bind(this),
          onDrop: this.drop.bind(this),
          onBlur: this.blur.bind(this),
          onChange: function onChange(event) {
            return _this2.onFileUpload(event);
          },
          onClick: this.onUploaderClick.bind(this),
          name: component.id
          //accept="image/*"
          , accept: '.pdf,.jpeg,.gif,.png,.pjpeg,.x-png'
        }, component.name.indexOf('SELFIE') > -1 ? {
          id: 'capture',
          capture: 'camera'
        } : {})),
        _react2.default.createElement(
          'label',
          (0, _extends3.default)({
            htmlFor: component.id
          }, (0, _withStyles.css)(this.props.styles['input-file__label'], component.name.indexOf('SELFIE') > -1 && this.props.styles['input-file__label--selfie'], !!component.value && this.props.styles['input-file__label--filled'])),
          ' ',
          component.cleanName,
          ' '
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'small',
          (0, _withStyles.css)(this.props.styles['error-msg']),
          (0, _utils.camelize)(this.getProperErrorMessage(), true, true)
        )
      );
    }
  }]);
  return File;
}(_react.Component);

File.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  components: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  var step = state.step;

  return { step: step
    //return {}
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(File));

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var colors = _ref.colors;

  var keyframes = {
    firstDot: {
      '0%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '25%': {
        backgroundColor: colors.spinner.dots.opaque
      },

      '50%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '75%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '100%': {
        backgroundColor: colors.spinner.dots.transparent
      }
    },

    middleDot: {
      '0%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '25%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '50%': {
        backgroundColor: colors.spinner.dots.opaque
      },

      '75%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '100%': {
        backgroundColor: colors.spinner.dots.transparent
      }
    },

    lastDot: {
      '0%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '25%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '50%': {
        backgroundColor: colors.spinner.dots.transparent
      },

      '75%': {
        backgroundColor: colors.spinner.dots.opaque
      },

      '100%': {
        backgroundColor: colors.spinner.dots.transparent
      }
    }
  };

  var styles = {
    spinner: {
      position: 'fixed',
      zIndex: '120',
      top: '0',

      display: 'block',

      width: '100%',
      height: '100%',

      textAlign: 'center'
    },

    'spinner--global': {
      backgroundColor: colors.spinner.bg.opaque
    },

    'spinner--step': {
      background: colors.spinner.bg.transparent
    },

    'spinner--local': {
      background: 'transparent',
      position: 'absolute'
    },

    'spinner-dots': {
      position: 'absolute',
      top: '50%',
      left: '50%',

      width: '12px',
      height: '12px',
      margin: '-6px 0 0 -6px',

      animationName: keyframes.middleDot,
      animationDuration: '2s',
      animationTimingFunction: 'ease-in-out',
      animationIterationCount: 'infinite',

      borderRadius: '50%',

      '::before': {
        position: 'absolute',
        top: '0',
        left: '-25px',

        width: '12px',
        height: '12px',

        content: '\'\'',

        animationName: keyframes.firstDot,
        animationDuration: '2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',

        borderRadius: '50%'
      },

      '::after': {
        position: 'absolute',
        top: '0',
        left: '25px',

        width: '12px',
        height: '12px',

        content: '\'\'',
        animationName: keyframes.lastDot,
        animationDuration: '2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',

        borderRadius: '50%'
      }
      // 'spinner-dots--local': {
      //   animationName: keyframes.middleDotLocal,
      //   '::before': {
      //     animationName: keyframes.firstDotLocal
      //   },
      //   '::after': {
      //     animationName: keyframes.lastDotLocal
      //   }
      // }
    } };

  return styles;
};

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _parsers = __webpack_require__(40);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  // const keyframes = {
  //   spinner: {
  //     to: {
  //       transform: 'rotate(360deg)'
  //     }
  //   }
  // }

  var styles = {
    uploader: {
      height: '15rem',
      margin: '1rem 0 2rem',

      color: colors.fileUpload.bg,
      border: '2px dashed ' + colors.fileUpload.border.default,
      borderRadius: '4px',
      backgroundColor: colors.fileUpload.bg,
      backgroundImage: images.documents.tris,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 35%',
      backgroundSize: '10rem'

      // [breakTo('smaller')]: {
      //   float: 'left',

      //   width: '41%',
      //   margin: '0 .5rem',
      // }
    },
    'uploader--license-front': {
      backgroundImage: images.documents.patenteFronte
    },
    'uploader--license-back': {
      backgroundImage: images.documents.patenteRetro
    },
    'uploader--idcard-front': {
      backgroundImage: images.documents.cartaIdentitaFronte
    },
    'uploader--idcard-back': {
      backgroundImage: images.documents.cartaIdentitaRetro
    },
    'uploader--passport-front': {
      backgroundImage: images.documents.passaportoFronte
    },
    'uploader--passport-back': {
      backgroundImage: images.documents.passaportoRetro
    },
    'uploader--selfie': (0, _defineProperty3.default)({
      border: '2px solid ' + colors.fileUpload.border.default,
      backgroundImage: images.documents.selfieSelected,
      backgroundPosition: '56% 35%'
    }, (0, _breakTo2.default)('smaller'), {
      backgroundPosition: '52% 35%'
    }),
    'uploader--filled': {
      color: 'inherit',
      backgroundColor: colors.fileUpload.bg,
      backgroundSize: 'auto 90%',
      backgroundPosition: '50% 50%'
    },
    'uploader--loading': {
      // ':before': {
      //   content: '\'\'',
      //   boxSizing: 'border-box',
      //   position: 'absolute',
      //   top: '50%',
      //   left: '50%',
      //   width: '70px',
      //   height: '70px',
      //   marginTop: '-35px',
      //   marginLeft: '-35px',
      //   backgroundImage: images.documents.uploaderLoading,
      //   backgroundRepeat: 'no-repeat',
      //   backgroundPosition: 'center',
      //   animationName: keyframes.spinner,
      //   animationDuration: '.6s',
      //   animationTimingFunction: 'linear',
      //   animationIterationCount: 'infinite'
      // },
      position: 'relative',
      backgroundImage: (0, _parsers.important)('none')
    },
    'input-file__label--filled': {
      color: 'transparent'
    },

    'uploader--error': {
      color: 'inherit',
      border: '2px dashed ' + colors.fileUpload.border.error
    },
    'uploader--mobile': {
      color: 'inherit',
      border: '2px solid ' + colors.fileUpload.border.default
    },
    'uploader--error-mobile': {
      color: 'inherit',
      border: '2px solid ' + colors.fileUpload.border.error
    },
    'uploader--focus': {
      color: 'inherit',
      border: '2px dashed ' + colors.fileUpload.border.focus
    },
    'uploader--focus-mobile': {
      color: 'inherit',
      border: '2px solid ' + colors.fileUpload.border.focus
    },

    'input-file': {
      // lineHeight: '23rem',

      position: 'absolute',

      display: 'block',

      width: '100%',
      height: '100%',
      marginTop: '-1rem',
      marginLeft: '-.5rem',

      opacity: '0',

      cursor: 'pointer'
    },

    'input-file--out': {
      left: '-9999px',

      width: '10px',
      height: '10px',
      margin: '0',
      padding: '0'
    },

    'input-file__label': {
      fontSize: '1rem',
      lineHeight: '1.5rem',

      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',

      paddingBottom: '1rem',

      width: '100%',
      height: '100%',

      color: colors.fileUpload.text
    },

    'input-file__label--selfie': {
      maxWidth: '23.6rem',
      marginRight: 'auto',
      marginLeft: 'auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center',
      textAlign: 'center'
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactDatepicker = __webpack_require__(472);

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _utils = __webpack_require__(12);

var _textbox = __webpack_require__(266);

var _textbox2 = _interopRequireDefault(_textbox);

__webpack_require__(1157);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1159);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Datepicker = function (_Component) {
  (0, _inherits3.default)(Datepicker, _Component);

  function Datepicker(props) {
    (0, _classCallCheck3.default)(this, Datepicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Datepicker.__proto__ || (0, _getPrototypeOf2.default)(Datepicker)).call(this, props));

    _moment2.default.locale('it');
    _this.state = props.component.value ? {
      date: (0, _moment2.default)(props.component.value, props.component.field && !!props.component.field.format ? props.component.field.format.toUpperCase() : 'DD/MM/YYYY')
    } : {};
    return _this;
  }

  // handleClick(e) {
  //   if (e.target.type === 'text') {
  //     const root = document.getElementById('root').childNodes[0]
  //     const datePicker = document.querySelectorAll(
  //       '[class^="react-datepicker__tether-element"]'
  //     )[0]
  //     if (!!datePicker) {
  //       root.appendChild(datePicker)
  //       datePicker.style.display = 'block'
  //     }
  //   }
  // }

  (0, _createClass3.default)(Datepicker, [{
    key: 'handleChange',
    value: function handleChange(date) {
      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch;

      dispatch((0, _componentsActions.updateComponent)(component.id, {
        value: date.format(component.field && !!component.field.format ? component.field.format.toUpperCase() : 'DD/MM/YYYY')
      }));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.component) {
        this.setState({
          date: !!nextProps.component.value ? (0, _moment2.default)(nextProps.component.value, nextProps.component.field && !!nextProps.component.field.format ? nextProps.component.field.format.toUpperCase() : 'DD/MM/YYYY') : undefined
        });
      }
    }
  }, {
    key: 'validateRequired',
    value: function validateRequired() {
      var component = this.props.component;

      if (component.validations && component.validations.isRequired && !component.isDisabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          component = _props2.component,
          widget = _props2.widget;

      var md = new _mobileDetect2.default(window.navigator.userAgent);

      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      if (!!md.mobile()) {
        return _react2.default.createElement(
          'div',
          (0, _withStyles.css)(this.props.styles.component, this.props.styles['component--bare']),
          _react2.default.createElement(_textbox2.default, {
            key: component.name + '-text',
            widget: widget,
            component: component,
            type: 'text'
          }),
          _react2.default.createElement(_textbox2.default, {
            key: component.name + '-date',
            widget: widget,
            component: component,
            type: 'date'
          })
        );
      } else {
        return _react2.default.createElement(
          'div',
          (0, _withStyles.css)(this.props.styles.component, this.props.component.statusStyle === 'hidden' ? this.props.styles['hide-datepicker'] : ''),
          _react2.default.createElement(_reactDatepicker2.default, (0, _extends3.default)({
            dateFormat: component.field && !!component.field.format ? component.field.format.toUpperCase() : 'DD/MM/YYYY',
            key: component.name + '-date'
          }, (0, _withStyles.css)(this.props.styles.input, component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink']), {
            selected: this.state.date,
            disabled: !!component.isDisabled || component.status.indexOf('readonly') > -1 || widget.status.indexOf('readonly') > -1,
            onChange: function onChange(date) {
              return _this2.handleChange(date);
            },
            showYearDropdown: true,
            showMonthDropdown: true,
            scrollableYearDropdown: true,
            placeholderText: component.cleanName,
            name: component.id
          })),
          _react2.default.createElement(
            'span',
            (0, _withStyles.css)(this.props.styles.label, this.state.value !== '' && this.props.styles['label--active']),
            component.cleanName,
            this.validateRequired() ? _react2.default.createElement(
              'span',
              (0, _withStyles.css)(this.props.styles['label--required']),
              '\xA0*'
            ) : ''
          ),
          !component.isDisabled ? _react2.default.createElement(
            'small',
            (0, _withStyles.css)(this.props.styles['error-msg']),
            (0, _utils.camelize)(component.errorMessage[0], true, true)
          ) : ''
        );
      }
    }
  }]);
  return Datepicker;
}(_react.Component);

Datepicker.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  type: _propTypes.PropTypes.oneOf(['text', 'date']),
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components;

  return { component: components[ownProps.component.id] };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Datepicker));

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1158);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./react-datepicker.css", function() {
		var newContent = require("!!../../css-loader/index.js!./react-datepicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker__navigation{background:none;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.45rem solid transparent;z-index:1}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:30px;width:100%}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;display:inline-block;height:0;outline:0;padding:0;vertical-align:middle}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:7px;text-align:center;top:50%}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);

// exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _parsers = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _globals;

  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    globals: (_globals = {
      '*.react-datepicker': {
        fontFamily: fontFamilies.default,
        fontWeight: fontWeights.datepicker.default
      },
      '*.react-datepicker__triangle': {
        borderBottomColor: (0, _parsers.important)(colors.datepicker.header.bg),
        '::before': {
          borderBottomColor: (0, _parsers.important)(colors.datepicker.header.bg)
        }
      },
      '*.react-datepicker__month-container': {
        borderRadius: '4px',
        backgroundColor: (0, _parsers.important)(colors.datepicker.header.bg)
      },
      '*.react-datepicker__year-read-view--selected-year': {
        color: (0, _parsers.important)(colors.datepicker.header.text)
      },
      '*.react-datepicker__day-name': {
        color: (0, _parsers.important)(colors.datepicker.header.text)
      },
      '*.react-datepicker__month': {
        margin: '0',
        padding: '.4rem',

        backgroundColor: (0, _parsers.important)(colors.datepicker.header.text)
      },
      '*.react-datepicker__current-month': {
        textTransform: 'capitalize',

        color: (0, _parsers.important)(colors.datepicker.header.text)
      },
      '*.react-datepicker__navigation--next': {
        borderLeftColor: (0, _parsers.important)(colors.datepicker.header.text),
        ':hover': {
          borderLeftColor: (0, _parsers.important)(colors.datepicker.arrow)
        }
      },
      '*.react-datepicker__navigation--previous': {
        borderRightColor: (0, _parsers.important)(colors.datepicker.header.text),
        ':hover': {
          borderRightColor: (0, _parsers.important)(colors.datepicker.arrow)
        }
      },
      '*.react-datepicker__year-read-view--down-arrow': {
        borderWidth: '.2rem',
        borderTopColor: (0, _parsers.important)(colors.datepicker.header.text),
        ':hover': {
          borderTopColor: (0, _parsers.important)(colors.datepicker.arrow)
        },
        '::before': {
          borderWidth: '.2rem',
          borderTopColor: (0, _parsers.important)(colors.datepicker.header.text),
          ':hover': {
            borderTopColor: (0, _parsers.important)(colors.datepicker.arrow)
          }
        }
      }
    }, (0, _defineProperty3.default)(_globals, '*.react-datepicker__year-read-view--down-arrow', {
      marginLeft: '35px'
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__year-read-view--selected-year', {
      marginRight: '15px'
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__month-read-view--down-arrow', {
      marginLeft: '35px'
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__month-read-view--selected-month', {
      marginRight: '20px'
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__header', {
      borderBottom: '1px solid ' + (0, _parsers.important)(colors.datepicker.header.bg),
      backgroundColor: (0, _parsers.important)(colors.datepicker.header.bg)
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker-wrapper', {
      width: '100%'
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__input-container', {
      width: '100%'
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__day', {
      color: (0, _parsers.important)(colors.datepicker.day.text.default),
      ':hover': {
        borderRadius: '100%',
        color: (0, _parsers.important)(colors.datepicker.day.text.default),
        backgroundColor: (0, _parsers.important)(colors.datepicker.day.bg.hover)
      }
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__day--selected', {
      backgroundColor: (0, _parsers.important)(colors.datepicker.day.bg.selected),
      color: (0, _parsers.important)(colors.datepicker.day.text.selected),
      borderRadius: '100%',
      ':hover': {
        color: (0, _parsers.important)(colors.datepicker.day.text.hover),
        borderRadius: '100%',
        backgroundColor: (0, _parsers.important)(colors.datepicker.day.bg.hover)
      }
    }), (0, _defineProperty3.default)(_globals, '*.react-datepicker__day--keyboard-selected', {
      backgroundColor: (0, _parsers.important)(colors.datepicker.day.bg.keyboard),
      color: (0, _parsers.important)(colors.datepicker.day.text.keyboard),
      borderRadius: '100%',
      ':hover': {
        color: (0, _parsers.important)(colors.datepicker.day.text.hover)
      }
    }), _globals),
    'hide-datepicker': {
      opacity: '0'
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1161);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function (_Component) {
  (0, _inherits3.default)(TextArea, _Component);

  function TextArea(props) {
    (0, _classCallCheck3.default)(this, TextArea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextArea.__proto__ || (0, _getPrototypeOf2.default)(TextArea)).call(this, props));

    _moment2.default.locale('it');
    _this.state = {
      value: props.component.value || ''
    };
    return _this;
  }

  (0, _createClass3.default)(TextArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!!this.props.component.value && this.props.component.hasOwnProperty('validations') && this.props.component.validations.hasOwnProperty('url')) {
        var _props = this.props,
            component = _props.component,
            dispatch = _props.dispatch;

        dispatch((0, _componentsActions.updateComponent)(component.id, { value: component.value }));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.component && nextProps.component.value !== this.state.value) {
        this.setState({
          value: nextProps.component.value
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      var val = e.target.value;
      var _props2 = this.props,
          component = _props2.component,
          dispatch = _props2.dispatch;

      this.setState({ value: val }, function () {
        dispatch((0, _componentsActions.updateComponent)(component.id, { value: val }));
      });
    }
  }, {
    key: 'validateRequired',
    value: function validateRequired() {
      var component = this.props.component;

      if (component.validations && component.validations.isRequired && !component.isDisabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'getProperErrorMessage',
    value: function getProperErrorMessage() {
      var component = this.props.component;


      if (!!component.validations.overrides) {
        var validationResult = (0, _utils.getValidationsResult)({
          component: component,
          type: 'overrides'
        });
        if (!validationResult.result) {
          return validationResult.errorMessage;
        }
      }
      return component.errorMessage[0];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          widget = _props3.widget,
          component = _props3.component;

      return _react2.default.createElement(
        'div',
        (0, _withStyles.css)(this.props.styles.component),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          placeholder: component.cleanName,
          value: this.state.value,
          onChange: this.handleChange.bind(this)
        }, (0, _withStyles.css)(this.props.styles.input, component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink']), {
          disabled: !!component.isDisabled || component.status.indexOf('readonly') > -1 || widget.status.indexOf('readonly') > -1,
          rows: component.rows,
          cols: component.cols,
          maxLength: component.maxLength,
          name: component.id
        })),
        _react2.default.createElement(
          'span',
          (0, _withStyles.css)(this.props.styles.label, this.state.value !== '' && this.props.styles['label--active']),
          component.cleanName
        ),
        _react2.default.createElement(
          'small',
          (0, _withStyles.css)(this.props.styles['error-msg']),
          (0, _utils.camelize)(this.getProperErrorMessage(), true, true)
        ),
        !!component.hint && !!component.hint.visible ? _react2.default.createElement(
          'span',
          (0, _withStyles.css)(this.props.styles.hint),
          this.props.component.hint.value
        ) : ''
      );
    }
  }]);
  return TextArea;
}(_react.Component);

TextArea.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components;

  return { component: components[ownProps.component.id] };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(TextArea));

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _component2.default;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1163);

var _styles2 = _interopRequireDefault(_styles);

var _withStyles = __webpack_require__(5);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _reactDeviceDetect = __webpack_require__(473);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { PropTypes } from 'prop-types'
// import { updateComponent } from '../../state/actions/componentsActions'
var Iframe = function (_Component) {
  (0, _inherits3.default)(Iframe, _Component);

  function Iframe(props) {
    (0, _classCallCheck3.default)(this, Iframe);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Iframe.__proto__ || (0, _getPrototypeOf2.default)(Iframe)).call(this, props));

    _this.renderOtpMessage = function (component) {

      return !!component.otpMessage ? _react2.default.createElement(
        'p',
        (0, _withStyles.css)(_this.props.styles.otpMessage),
        'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare'
      ) : "";
    };

    return _this;
  }

  (0, _createClass3.default)(Iframe, [{
    key: 'render',
    value: function render() {
      var component = this.props.component;

      var md = new _mobileDetect2.default(window.navigator.userAgent);
      //if (!!md.mobile() && md.tablet()) {
      if (_reactDeviceDetect.isMobileOnly && !_reactDeviceDetect.isTablet) {
        return _react2.default.createElement('iframe', (0, _extends3.default)({
          name: this.props.name,
          src: component.value
          // width="700px"
          //height="500px"
          //max-width="51rem"
        }, (0, _withStyles.css)(this.props.styles.iframeMobile), {
          hidden: this.props.component.status.indexOf('hidden') > -1
        }));
      } else {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', (0, _withStyles.css)(this.props.styles.outeroverlay)),
          _react2.default.createElement(
            'div',
            (0, _withStyles.css)(_reactDeviceDetect.isTablet && this.props.styles.overlayTablet, !_reactDeviceDetect.isTablet && this.props.styles.overlay),
            this.renderOtpMessage(component),
            _react2.default.createElement('iframe', (0, _extends3.default)({}, (0, _withStyles.css)(_reactDeviceDetect.isTablet && this.props.styles.iframeTablet, !_reactDeviceDetect.isTablet && this.props.styles.iframe), {
              name: this.props.name,
              src: component.value,
              hidden: this.props.component.status.indexOf('hidden') > -1
            }))
          )
        );
      }
    }
  }]);
  return Iframe;
}(_react.Component);

exports.default = (0, _withStyles.withStyles)(_styles2.default)(Iframe);

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      fontSizes = _ref.fontSizes,
      fontWeights = _ref.fontWeights;
  return {
    iframeMobile: {
      position: 'relative',
      width: "100%",
      height: "500px",
      maxWidth: "51rem!important"
    },
    iframeTablet: {
      position: 'relative',
      width: '100%',
      height: '380px',
      top: '21%',
      marginRight: 'auto',
      marginLeft: 'auto',
      border: 'none'
    },
    overlayTablet: {
      width: '75%',
      height: 'auto',
      position: 'fixed',
      top: '15%',
      right: '11%',
      left: '11%',
      background: 'white',
      zIndex: '102'
    },
    overlay: {
      // width: '782px', //782
      // height: 'auto',
      // position: 'fixed',
      // top: '15%',
      // left: '20%',
      // background: 'white',
      // zIndex: '102'
      //overflowY: '-webkit-paged-x'
      width: '60%',
      height: 'auto',
      position: 'fixed',
      top: '20%',
      left: '20%',
      background: 'white',
      zIndex: '102',
      right: '20%'
    },
    iframe: {
      position: 'relative',
      width: '100%', //'782px'
      height: '380px',
      top: '21%',
      marginRight: 'auto',
      marginLeft: 'auto',
      border: 'none'
    },
    outeroverlay: {
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: '0',
      left: '0',
      background: 'black',
      zIndex: '100',
      opacity: '0.5'
    },
    otpMessage: {
      paddingLeft: '45px',
      paddingRight: '21px'
    }
  };
};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _componentsActions = __webpack_require__(19);

var _reactRedux = __webpack_require__(14);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { withStyles } from '../../styles/withStyles'
// import Styles from './styles'

var AttivaButton = function (_Component) {
  (0, _inherits3.default)(AttivaButton, _Component);

  function AttivaButton(props) {
    (0, _classCallCheck3.default)(this, AttivaButton);
    return (0, _possibleConstructorReturn3.default)(this, (AttivaButton.__proto__ || (0, _getPrototypeOf2.default)(AttivaButton)).call(this, props));
  }

  (0, _createClass3.default)(AttivaButton, [{
    key: 'onClick',
    value: function onClick(e) {
      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch;

      if (component.action !== {}) dispatch((0, _componentsActions.updateComponent)(component.id, component.action));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var component = this.props.component;

      if (component.id === "ATTIVA_REVOCA_FIRMA-VISIONE" && (component.value === "Attivata" || component.value === "Firmato")) //Rewamp of whole digital contracts in last step (All flows)	
        {
          component.display = "none";
        }
      return _react2.default.createElement(_button2.default, (0, _extends3.default)({
        key: component.id,
        text: component.value
      }, component, {
        action: function action(e) {
          return _this2.onClick(e);
        }
      }));
    }
  }]);
  return AttivaButton;
}(_react.Component);

AttivaButton.propTypes = {
  widget: _propTypes.PropTypes.object.isRequired,
  component: _propTypes.PropTypes.object.isRequired
  // styles: PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var components = state.components;

  return { component: components[ownProps.component.id] };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AttivaButton);

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _stepActions = __webpack_require__(28);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1166);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertModal = function AlertModal(props) {
  var handleClick = function handleClick() /*e*/{
    var dispatch = props.dispatch,
        component = props.component;

    dispatch((0, _stepActions.hideAlert)(component));
  };
  var renderLabel = function renderLabel() {
    if (props.content && props.content.split('<br><br>').length > 1) {
      var description = props.content.split('<br><br>');
      return description.map(function (s, index) {
        return _react2.default.createElement(
          'span',
          { key: index },
          s,
          _react2.default.createElement('br', null)
        );
      });
    } else return props.content;
  };
  return _react2.default.createElement(
    'div',
    (0, _withStyles.css)(props.styles.modal, !!props.hidden && props.styles['modal--hidden']),
    _react2.default.createElement(
      'div',
      (0, _withStyles.css)(props.styles.header),
      _react2.default.createElement(
        'div',
        (0, _withStyles.css)(props.styles.title),
        _react2.default.createElement(
          'span',
          null,
          ' ',
          props.title
        )
      ),
      _react2.default.createElement('div', (0, _extends3.default)({}, (0, _withStyles.css)(props.styles.closeBtn), {
        onClick: function onClick(event) {
          return handleClick(event);
        }
      }))
    ),
    _react2.default.createElement(
      'div',
      (0, _withStyles.css)(props.styles.wrapper),
      _react2.default.createElement(
        'div',
        (0, _withStyles.css)(props.styles.content),
        renderLabel()
      )
    )
  );
};

AlertModal.propTypes = {
  // children: PropTypes.node,
  title: _propTypes.PropTypes.string,
  content: _propTypes.PropTypes.string
  // hidden: PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state) {
  var step = state.step;

  return { step: step };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(AlertModal));

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var spacings = _ref.spacings,
      images = _ref.images;

  var styles = {
    modal: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      height: 'auto',
      maxHeight: '350px',
      position: 'fixed',
      top: '35%',
      left: '25%',
      right: '25%',
      background: 'white',
      border: '1px #00B7FF solid', //#00a5ff,
      borderRadius: '5px',
      zIndex: '110',
      boxShadow: '1px 1px rgba(0,165,255,0.5)'
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      background: 'rgba(0,165,255,1)'
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      color: 'white',
      padding: '2px 10px',
      verticalAlign: 'middle'
    },
    closeBtn: {
      width: spacings.x4,
      height: spacings.x2,
      margin: spacings.x2,
      cursor: 'pointer',
      borderRadius: '100%',
      backgroundImage: images.closeIconSella,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '40%'
    },
    'modal--display-none': {
      display: 'none'
    },
    wrapper: {
      display: 'inline-block',
      width: '100%'
    },
    content: {
      padding: '25px 10px',
      marginRight: 'auto',
      marginLeft: 'auto'
    }
  };
  return styles;
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _componentsActions = __webpack_require__(19);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1168);

var _styles2 = _interopRequireDefault(_styles);

var _textbox = __webpack_require__(266);

var _textbox2 = _interopRequireDefault(_textbox);

var _utils = __webpack_require__(12);

var _mobileDetect = __webpack_require__(52);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECAPTCHA_SITEKEY = "6Lc_4GgpAAAAAFTIpWi4mRDFGjnfQLzIc1FyUmE5";

var MobileWithOTPButton = function (_Component) {
    (0, _inherits3.default)(MobileWithOTPButton, _Component);

    function MobileWithOTPButton(props) {
        (0, _classCallCheck3.default)(this, MobileWithOTPButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MobileWithOTPButton.__proto__ || (0, _getPrototypeOf2.default)(MobileWithOTPButton)).call(this, props));

        _this.state = {
            value: props.component.value || ''
        };
        window.handleRecaptcha = _this.handleRecaptcha.bind(_this);
        _this.sendOTP = _this.sendOTP.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(MobileWithOTPButton, [{
        key: 'handleChange',
        value: function handleChange(e) {
            var val = e.target.value;
            this.setState({ value: val });
            var _props = this.props,
                dispatch = _props.dispatch,
                component = _props.component;

            var delta = {};
            if (e.target.type === 'text') {
                delta.value = (0, _utils.cleanupString)(e.target.value);
                if (!!component.hint) {
                    delta.hint = (0, _extends3.default)({}, component.hint, { visible: false });
                }
            }
            if ((0, _keys2.default)(delta).length > 0) {
                component.value = delta.value;
                dispatch((0, _componentsActions.updateComponent)(component.id, delta));
            }
            dispatch((0, _componentsActions.updateComponent)('CELLULARE-CODICE_CELLULARE', {
                value: ''
            }, { avoidValidation: true }));
        }
    }, {
        key: 'onBlur',
        value: function onBlur(e) {
            var _props2 = this.props,
                dispatch = _props2.dispatch,
                component = _props2.component;

            var delta = {};
            if (e.target.type === 'text') {
                delta.value = (0, _utils.cleanupString)(e.target.value);
                if (!!component.hint) {
                    delta.hint = (0, _extends3.default)({}, component.hint, { visible: false });
                }
            }
            if ((0, _keys2.default)(delta).length > 0) {
                component.value = delta.value;
                dispatch((0, _componentsActions.updateComponent)(component.id, delta));
            }
        }
    }, {
        key: 'sendOTP',
        value: function sendOTP() {
            var _props3 = this.props,
                dispatch = _props3.dispatch,
                component = _props3.component,
                components = _props3.components;

            var body = {};
            if (component.fetch.hasOwnProperty('fields')) {
                component.fetch.fields.forEach(function (field) {
                    return (0, _keys2.default)(field).forEach(function (key) {
                        return body[field[key].fieldName] = components[key].value;
                    });
                });
            }
            dispatch((0, _componentsActions.sendOTP)(component.fetch.url, body));
        }
    }, {
        key: 'handleRecaptcha',
        value: function handleRecaptcha() {
            var _props4 = this.props,
                dispatch = _props4.dispatch,
                component = _props4.component,
                components = _props4.components;

            var body = {};
            if (component.fetch.hasOwnProperty('fields')) {
                component.fetch.fields.forEach(function (field) {
                    return (0, _keys2.default)(field).forEach(function (key) {
                        return body[field[key].fieldName] = components[key].value;
                    });
                });
            }
            dispatch((0, _componentsActions.sendOTP)(component.fetch.url, body));
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            grecaptcha.execute();
        }
    }, {
        key: 'AddLibrary',
        value: function AddLibrary(urlOfTheLibrary) {
            var script = document.createElement("script");
            script.src = urlOfTheLibrary;
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }
    }, {
        key: 'getProperErrorMessage',
        value: function getProperErrorMessage() {
            var component = this.props.component;


            if (!!component.validations.overrides) {
                var validationResult = (0, _utils.getValidationsResult)({
                    component: component,
                    type: 'overrides'
                });
                if (!validationResult.result) {
                    return validationResult.errorMessage;
                }
            }
            return component.errorMessage && component.errorMessage[0];
        }
    }, {
        key: 'render',
        value: function render() {
            var _props5 = this.props,
                widget = _props5.widget,
                component = _props5.component;

            var md = new _mobileDetect2.default(window.navigator.userAgent);
            var isResumePage = window.location.pathname.indexOf('/resume') >= 0 ? true : false;
            return _react2.default.createElement(
                'div',
                (0, _withStyles.css)(this.props.styles.component, !md.mobile() && !isResumePage && this.props.styles.divmain, isResumePage && this.props.styles.divResume),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        (0, _withStyles.css)(!md.mobile() && !isResumePage && this.props.styles.divMobileNum),
                        _react2.default.createElement('input', (0, _extends3.default)({ type: 'text'
                        }, (0, _withStyles.css)(this.props.styles.input, component.status.indexOf('error') > -1 && this.props.styles['input--invalid'], component.status.indexOf('loading') > -1 && this.props.styles['input--blink']), {
                            onChange: this.handleChange.bind(this),
                            onBlur: this.onBlur.bind(this),
                            name: component.id,
                            placeholder: component.cleanName, value: component.value })),
                        _react2.default.createElement(
                            'span',
                            (0, _withStyles.css)(this.props.styles.label, this.state.value !== '' && this.props.styles['label--active']),
                            component.cleanName
                        ),
                        _react2.default.createElement(
                            'span',
                            (0, _withStyles.css)(component.otpbtnDisabled ? this.props.styles.otpMsgvisible : this.props.styles.otpMsghidden, isResumePage && this.props.styles.otpMsgvisible),
                            'Cliccando su \u2018Invia il codice di verifica\u2019 riceverai un SMS con il codice OTP'
                        ),
                        _react2.default.createElement(
                            'small',
                            (0, _withStyles.css)(this.props.styles['error-msg']),
                            (0, _utils.camelize)(this.getProperErrorMessage(), true, true)
                        ),
                        !!component.hint && !!component.hint.visible ? _react2.default.createElement(
                            'span',
                            (0, _withStyles.css)(this.props.styles.hint),
                            this.props.component.hint.value
                        ) : ''
                    ),
                    _react2.default.createElement(
                        'div',
                        (0, _withStyles.css)(!md.mobile() && this.props.styles.divOTPAlign, isResumePage && this.props.styles.otpMsgvisible),
                        _react2.default.createElement(
                            'button',
                            (0, _extends3.default)({ onClick: this.onSubmit.bind(this), disabled: component.otpbtnDisabled }, (0, _withStyles.css)(this.props.styles.button, md.mobile() && this.props.styles.mobile_otpButtonAlign, this.props.styles.otpButtonColor, !component.otpbtnDisabled && this.props.styles.buttonOTPEnabled)),
                            'Invia il codice di verifica'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        this.AddLibrary("https://www.google.com/recaptcha/api.js"),
                        _react2.default.createElement('div', { 'class': 'g-recaptcha',
                            'data-sitekey': RECAPTCHA_SITEKEY,
                            'data-callback': 'handleRecaptcha',
                            'data-size': 'invisible' })
                    )
                )
            );
        }
    }]);
    return MobileWithOTPButton;
}(_react.Component);

MobileWithOTPButton.propTypes = {
    widget: _propTypes.PropTypes.object.isRequired,
    component: _propTypes.PropTypes.object.isRequired,
    type: _propTypes.PropTypes.oneOf(['text']),
    styles: _propTypes.PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
    var components = state.components;

    return { components: components
        //return {}
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(MobileWithOTPButton));

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _styles = __webpack_require__(532);

var _styles2 = _interopRequireDefault(_styles);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var colors = _ref.colors,
        spacings = _ref.spacings,
        images = _ref.images,
        fontFamilies = _ref.fontFamilies,
        fontWeights = _ref.fontWeights,
        fontSizes = _ref.fontSizes,
        textTransforms = _ref.textTransforms,
        layouts = _ref.layouts;

    var component = (0, _component2.default)({
        colors: colors,
        spacings: spacings,
        images: images,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        fontSizes: fontSizes,
        textTransforms: textTransforms
    });
    var styles = {
        'divmain': {
            width: '80%!important',
            marginTop: '58px'
        },
        'divResume': {
            width: '21rem!important'
        },
        'divMobileNum': {
            width: '14rem!important',
            float: 'left'
            //marginTop: '42px'
        },
        'divOTPAlign': {
            //width: '15rem!important',
            float: 'right',
            marginTop: '-40px!important'

        },
        'otpButtonColor': {
            color: '#cecece!important'
            //margin:'0'
        },
        'mobile_otpButtonAlign': {

            marginTop: '4rem!important'
        },
        'buttonOTPEnabled': {
            color: 'white',
            background: '#00B7FF', //'#00a5ff',
            border: colors.button.border.primary
        },
        'otpMsgvisible': {
            display: 'none'
        },
        'otpMsghidden': {
            display: 'block',
            position: 'absolute'
            //marginTop: '44px'
        }

    };

    var buttonStyles = (0, _styles2.default)({ colors: colors, layouts: layouts });
    return (0, _extends3.default)({}, component, buttonStyles, styles);
};

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1170);

var _styles2 = _interopRequireDefault(_styles);

__webpack_require__(1171);

var _componentsActions = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivacyFabrick = function (_Component) {
    (0, _inherits3.default)(PrivacyFabrick, _Component);

    function PrivacyFabrick(props) {
        (0, _classCallCheck3.default)(this, PrivacyFabrick);
        return (0, _possibleConstructorReturn3.default)(this, (PrivacyFabrick.__proto__ || (0, _getPrototypeOf2.default)(PrivacyFabrick)).call(this, props));
    }

    (0, _createClass3.default)(PrivacyFabrick, [{
        key: 'onChange',
        value: function onChange() {
            var _props = this.props,
                component = _props.component,
                dispatch = _props.dispatch;


            if (!this.input.disabled) {
                if (component.status.indexOf('checkonly') > -1) {
                    if (component.value !== 'selected') {
                        dispatch((0, _componentsActions.updateComponent)(component.id, {
                            value: 'selected'
                        }));
                        if (!!component.action) {
                            dispatch((0, _componentsActions.updateComponent)(component.id, component.action));
                        }
                    }
                } else {
                    dispatch((0, _componentsActions.updateComponent)(component.id, {
                        value: this.input.checked ? 'selected' : ''
                    }));
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                widget = _props2.widget,
                component = _props2.component;

            return _react2.default.createElement(
                'div',
                null,
                !!component && _react2.default.createElement(
                    'div',
                    (0, _withStyles.css)(this.props.styles.component, this.props.styles.checkbox, this.props.styles['component--block'], this.props.styles['component--pull-' + component.pullTo], this.props.styles.checkboxContainer),
                    _react2.default.createElement(
                        'div',
                        null,
                        '     ',
                        _react2.default.createElement('input', (0, _extends3.default)({
                            ref: function ref(input) {
                                _this2.input = input;
                            },
                            type: 'checkbox',
                            id: component.id
                        }, (0, _withStyles.css)(this.props.styles.input), {
                            checked: component.value === 'selected',
                            onChange: function onChange() {
                                return _this2.onChange();
                            },
                            name: component.id
                        })),
                        _react2.default.createElement(
                            'label',
                            (0, _extends3.default)({
                                htmlFor: component.id
                            }, (0, _withStyles.css)(this.props.styles.label, component.status.indexOf('error') > -1 && this.props.styles['label--invalid'])),
                            'Presto il consenso al trattamento dei miei dati personali da parte di Fabrick S.p.A. per svolgere le seguenti attivit\xE0 di marketing: rilevazione del grado di soddisfazione della clientela sulla qualit\xE0 dei servizi resi; compimento di studi e ricerche di mercato; sviluppo e vendita di servizi propri e/o di societ\xE0 del Gruppo Sella e/o di terzi, con modalit\xE0, tra le quali, l\u2019invio di comunicazioni a carattere informativo, promozionale e commerciale (le attivit\xE0 potranno essere svolte attraverso e-mail, SMS, notifiche push, posta cartacea, telefono con operatore e social network). (cfr. par. 4, lett. c)'
                        )
                    )
                )
            );
        }
    }]);
    return PrivacyFabrick;
}(_react.Component);

PrivacyFabrick.propTypes = {
    widget: _propTypes.PropTypes.object.isRequired,
    component: _propTypes.PropTypes.object.isRequired
    //styles: PropTypes.object.isRequired
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
    var components = state.components;

    return { component: components[ownProps.component.id] };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(PrivacyFabrick));

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _parsers = __webpack_require__(40);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });

  var styles = {
    checkbox: {},
    checkboxContainer: (0, _defineProperty3.default)({}, (0, _breakTo2.default)('small'), {
      width: '100%',
      marginRight: '0'
    }),
    input: {
      position: 'absolute',
      left: '-9999px',
      ':focus + label::before': {
        outline: '2px solid #4A90E2', /* Change the color and width as needed */
        boxShadow: '0 0 5px rgba(74, 144, 226, 0.5)' /* Optional: Add a shadow for better visibility */
      },
      ':enabled + label': {
        fontSize: '0.875rem',

        position: 'relative',
        display: 'inline-block',

        paddingLeft: spacings.x5,

        cursor: 'pointer',

        //color: colors.common.text,

        //color: '#747474',
        // checkbox appearance
        '::before': {
          position: 'absolute',
          top: '0',
          left: '0',

          width: '20px',
          height: '20px',

          content: "''",

          border: '2px solid ' + colors.flag.default,
          //borderRadius: '6px',
          background: colors.flag.bg
        },
        // checked mark appearance
        '::after': {
          fontSize: spacings.x4,
          lineHeight: '20px',

          position: 'absolute',
          top: '-5px',
          left: '6px',

          width: '9px',
          height: '12px',

          content: images.checkboxTick,
          transition: 'all .2s',
          textAlign: 'center',

          border: 0,
          borderRadius: '2px'
        }
      },

      ':disabled + label': {
        color: colors.flag.default
      },

      ':not(:checked) + label::after': {
        fontSize: 0,

        opacity: 0
      },

      ':not(:checked):disabled + label::before': {
        boxShadow: 'none'
      },

      ':checked + label::before': {
        border: '2px solid ' + colors.flag.checked,
        background: colors.flag.checked,
        boxShadow: 'none',
        outline: 'none'
      },
      ':checked +label': {
        color: '#000'
      },
      ':checked + label::after': {
        transform: 'scale(1)',

        opacity: '1'
      },

      ':disabled + label::before': {
        boxShadow: 'none'
      },

      ':disabled + label::after': {
        border: '1px solid ' + colors.flag.disabled
      }
    },

    // 'input--invalid': {

    //   ':enabled + label:before': {
    //     borderColor: important(colors.common.utility.error.default),
    //   }
    // },

    label: {
      fontFamily: fontFamilies.alternate
    },

    'label--invalid': {
      color: (0, _parsers.important)(colors.common.utility.error.default)
    },
    'component--pull-left': {
      float: 'left'
    },
    'component--pull-right': {
      float: 'right'
    },
    'component--block': {
      display: 'block'
    }
  };

  return (0, _extends3.default)({}, component, styles);
};

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1172);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      fontWeights = _ref.fontWeights;
  return {
    'widget-group': (0, _defineProperty3.default)({}, (0, _breakTo2.default)('medium'), {
      // overflow: 'hidden',

      marginBottom: '3rem'
    }),

    'widget-group__title': (0, _defineProperty3.default)({
      color: colors.widget.groupTitle.default
    }, (0, _breakTo2.default)('medium'), {
      position: 'absolute',
      marginLeft: '-16vw',
      fontWeight: fontWeights.widget.group,
      marginTop: '2.5vw',
      width: '14vw',
      textAlign: 'right'
    }),
    'widget-group__maintitle': (0, _defineProperty3.default)({
      color: colors.widget.groupTitle.default
    }, (0, _breakTo2.default)('medium'), {
      position: 'absolute',
      marginLeft: '-6.5vw',
      fontWeight: fontWeights.widget.group,
      marginTop: '-1.5vw',
      textAlign: 'right'
    }),

    'widget-group__inputs': (0, _defineProperty3.default)({}, (0, _breakTo2.default)('medium'), {
      float: 'left',

      width: '100%'
    }),

    'widget-group__inputs--invalid': {
      maxWidth: '43rem',

      borderBottom: '2px solid ' + colors.common.utility.error.default
    },

    'widget-group__error-msg': {
      display: 'block',

      marginTop: '.5rem',

      textAlign: 'center',

      color: colors.common.utility.error.default
    },
    'widget-group__margin-min-bottom': {
      marginBottom: '-1rem !important'
    }
  };
};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = __webpack_require__(4);

var _extends7 = _interopRequireDefault(_extends6);

var _clearfix = __webpack_require__(530);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _grid = __webpack_require__(267);

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      images = _ref.images,
      spacings = _ref.spacings,
      fontWeights = _ref.fontWeights;
  return {
    footer: (0, _extends7.default)({}, (0, _clearfix2.default)(), {

      position: 'relative',

      marginTop: spacings.x4,

      backgroundColor: colors.footer.bg
    }),

    link: {
      fontWeight: fontWeights.semibold,
      color: colors.footer.link,

      ':hover': {
        color: colors.footer.linkHover
      },
      ':visited': {
        color: colors.footer.link
      },
      ':active': {
        color: colors.footer.link
      },
      ':focus': {
        color: colors.footer.link
      }
    },
    links: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px', //var(--structure-header-blocks-gap-v, 16px);
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      alignSelf: 'stretch',
      flexShrink: '0',
      position: 'relative'
    },
    textualLinks: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px', //var(--structure-header-blocks-gap-h, 16px);
      rowGap: '24px',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      alignContent: 'center',
      flex: '1',
      position: 'relative',
      padding: '16px 0px 16px 0px'
    },
    privacyPolicy: {
      color: '#0087d6', //var(--surfaces-footer-pre-login-light-bg-content-primary,rgba(0, 0, 0, 0.6));
      textAlign: 'left',
      fontFamily: 'Rethink Sans', //var(--typography-font-family-secondary,"RethinkSans-Medium",sans-serif);
      fontSize: '11px', //var(--titles-and-paragraphs-font-sizes-paragraphs-default, 14px);
      fontWeight: '500',
      textDecorationLine: 'underline',
      position: 'relative',
      padding: '4px',
      cursor: 'pointer'

    },

    // This container should contain everything inside the footer.
    // Also provide a centered position.
    container: (0, _extends7.default)({}, (0, _clearfix2.default)()),

    // The footer columns.
    section: {
      display: 'block',

      paddingLeft: spacings.default
    },

    'section--gutter': (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 12, columns: 12 }), (0, _defineProperty3.default)({}, (0, _breakTo2.default)('small'), (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 3, columns: 12 })))),

    'section--left': (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 12, columns: 12 }), (0, _defineProperty3.default)({

      padding: '0 2rem'

    }, (0, _breakTo2.default)('small'), (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 5, columns: 12 }), {
      padding: '0'
    }))),

    'section--center': (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 0, columns: 12 }), (0, _defineProperty3.default)({}, (0, _breakTo2.default)('small'), (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 1, columns: 12 })))),

    'section--right': (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 12, columns: 12 }), (0, _defineProperty3.default)({

      padding: '0 2rem'

    }, (0, _breakTo2.default)('small'), (0, _extends7.default)({}, (0, _grid2.default)({ colSpan: 2, columns: 12 }), {
      marginTop: '0',
      padding: '0',
      whiteSpace: 'nowrap'
    }))),

    label: {
      fontSize: '1.125rem',
      fontWeight: fontWeights.semibold,
      lineHeight: '1.2',

      display: 'block',

      width: '100%',
      marginTop: '2.4rem',
      marginRight: '1.5rem',

      color: colors.footer.label
    },
    copyright: {
      fontSize: '.65rem',
      paddingBottom: '2.5rem',
      paddingTop: '3.5rem',
      textAlign: 'justify',
      color: '#7FA2B6', //colors.footer.copyright,
      maxWidth: '70rem',
      float: 'left',
      width: '80%',
      paddingLeft: '9%'
    },
    sellalogo: {
      float: 'right',
      paddingRight: '10%',
      paddingTop: '3.5rem',
      backgroundImage: images.logoSella,
      backgroundRepeat: 'no-repeat',
      marginTop: '3.5rem'
    },
    MainContainer: {
      color: '#00466E',
      height: '100%',
      width: '90%',
      fontSize: '0'
    },
    leftAlign: {
      display: 'inline-block',
      color: '#7FA2B6',
      width: '95%',
      textAlign: 'justify',
      verticalAlign: 'middle',
      fontSize: '10px',
      // padding: '65px 65px 65px 80px'
      padding: '5% 0% 5% 20%'
    },
    centerAlign: {
      display: 'inline-block',
      color: '#7FA2B6',
      width: '80%',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontSize: '10px',
      // padding: '65px 65px 65px 80px'
      padding: '0% 0% 5% 20%'
    },
    planTextAlign: {
      display: 'inline-block',
      color: '#7FA2B6',
      width: '85%',
      textAlign: 'justify',
      verticalAlign: 'middle',
      fontSize: '9px',
      // padding: '65px 65px 65px 80px'
      padding: '5% 0% 0% 20%'
    },
    rightAlign: {
      display: 'inline-block',
      width: '20%',
      backgroundImage: images.logoSella,
      backgroundPosition: 'right',
      backgroundRepeat: 'no-repeat',
      verticalAlign: 'middle',
      padding: '15px'
    },

    disclaimer: {
      fontSize: '.8125rem',
      fontWeight: fontWeights.normal,
      lineHeight: '1.6',

      letterSpacing: '1.2',

      color: colors.footer.text,

      '> a': {
        color: colors.footer.linkAlt,

        ':hover': {
          color: colors.footer.linkAltHover
        }
      }
    },

    // This footer element shows a logo image.
    logo: (0, _defineProperty3.default)({
      display: 'block',

      width: '76px',
      maxWidth: '6rem',
      height: '62px',
      margin: spacings.default + ' auto ' + spacings.x4,
      marginTop: '2rem',
      marginBottom: '0',
      paddingRight: spacings.x3,

      userSelect: 'none',
      // opacity: .1,

      backgroundImage: images.footer,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'

    }, (0, _breakTo2.default)('small'), {
      marginTop: '5.4rem'
    }),

    text: {
      fontSize: '1rem',
      fontWeight: fontWeights.normal,

      display: 'block',

      paddingBottom: spacings.default,

      color: colors.footer.text,

      ':nth-child(n+3)': {
        paddingTop: spacings.default
      }
    },

    strongText: {
      lineHeight: '1.3125rem',

      display: 'inline-block',

      margin: '.5rem 0'
    },

    socialIcon: {
      display: 'inline-block',

      userSelect: 'none',
      transition: 'all 300ms',

      fill: colors.footer.link,

      ':hover': {
        fill: colors.footer.linkHover
      },

      ':nth-child(n+2)': {
        marginLeft: spacings.x2
      }
    }
  };
};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__(268);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _modal2.default;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      fontWeights = _ref.fontWeights;
  return {
    result: {
      textAlign: 'center',
      marginTop: spacings.x2,
      marginBottom: spacings.x2,
      padding: spacings.default + ' ' + spacings.x2
    },

    'result--error': {
      borderLeft: '.25rem solid ' + colors.common.utility.error.default,
      backgroundColor: colors.common.utility.error.lightest
    },

    'result--success': {
      borderLeft: '.25rem solid ' + colors.common.utility.success.default,
      backgroundColor: colors.common.utility.success.lightest
    },

    'result--info': {
      borderLeft: '.25rem solid ' + colors.common.utility.info.default,
      backgroundColor: colors.common.utility.info.lightest
    },

    'result--warning': {
      borderLeft: '.25rem solid ' + colors.common.utility.warning.default,
      backgroundColor: colors.common.utility.warning.lightest
    },

    title: {
      fontWeight: fontWeights.result.title,

      display: 'block'
    },

    message: {
      margin: '0'
    }
  };
};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESOURCES = {
  USER_CODE: {
    it: {
      label: 'Inserisci il tuo codice sella.it',
      placeholder: 'Codice sella.it'
    },
    en: {
      label: 'Insert your sella.it code',
      placeholder: 'Sella.it code'
    }
  },
  USER_PIN: {
    it: {
      label: 'Inserisci il tuo pin',
      placeholder: 'Pin'
    },
    en: {
      label: 'Insert your pin',
      placeholder: 'Pin'
    }
  },
  DATE_OF_BIRTH: {
    it: {
      label: 'Inserisci la tua data di nascita',
      placeholder: 'dd/MM/yyyy'
    },
    en: {
      label: 'Insert yout birth date',
      placeholder: 'dd/MM/yyyy'
    }
  },
  INSERT_TWO_PWD_CHARS: {
    it: {
      value: 'Inserisci i due caratteri della password richiesti'
    },
    en: {
      value: 'Enter the requested two password chars'
    }
  },
  PWD_CHARS: {
    it: {
      label: '%d&deg; e %d&deg; carattere',
      placeholder: '%d° e %d° carattere'
    },
    en: {
      label: 'chars n.%d and n.%d',
      placeholder: 'chars n.%d and n.%d'
    }
  },
  INSERT_RSA_OTP: {
    it: {
      label: 'Inserici il codice RSA OTP',
      placeholder: 'RSA OTP'
    },
    en: {
      label: 'Enter RSA OTP Code',
      placeholder: 'RSA OTP'
    }
  },
  INSERT_NEXT_RSA_OTP: {
    it: {
      label: 'Inserici il codice RSA OTP successivo',
      placeholder: 'RSA OTP'
    },
    en: {
      label: 'Enter the next RSA OTP Code',
      placeholder: 'RSA OTP'
    }
  },
  REINSERT_RSA_OTP: {
    it: {
      label: 'Reinserici il codice RSA OTP',
      placeholder: 'RSA OTP'
    },
    en: {
      label: 'Re-enter RSA OTP Code',
      placeholder: 'RSA OTP'
    }
  },
  WARN_REINSERT_CREDENTIALS: {
    it: {
      value: 'Reinserisci le tue credenziali'
    },
    en: {
      value: 'Reinsert your credentials'
    }
  },
  INFO_CORRECT_OTP_REINSERT_NEXT_OTP: {
    it: {
      value: 'OTP corretto, a causa di errori precedenti ti chiediamo di inserire anche il codice RSA OTP successivo'
    },
    en: {
      value: 'Correct OTP, due to previous OTP errors, please enter Next RSA OTP Code'
    }
  },
  WRONG_OTP: {
    it: {
      value: 'OTP errato!'
    },
    en: {
      value: 'Wrong OTP!'
    }
  },
  ERROR_PASSWORD_EXPIRED: {
    it: {
      value: 'Password scaduta.'
    },
    en: {
      value: 'Password expired'
    }
  },
  ERROR_PIN_EXPIRED: {
    it: {
      value: 'PIN scaduto.'
    },
    en: {
      value: 'PIN expired'
    }
  },
  WARN_PASSWORD_REMINDER: {
    it: {
      value: 'La tua password scadrà tra %d %g.'
    },
    en: {
      value: 'Your password is about to expire in %d %g.'
    }
  },
  WARN_PIN_REMINDER: {
    it: {
      value: 'Il tuo PIN scadrà tra %d %g.'
    },
    en: {
      value: 'Your PIN is about to expire in %d %g.'
    }
  },
  G: {
    it: {
      value: 'giorno'
    },
    en: {
      value: 'day'
    }
  },
  GG: {
    it: {
      value: 'giorni'
    },
    en: {
      value: 'days'
    }
  },
  MESSAGE_TYPE_0: {
    it: {
      value: 'Info'
    },
    en: {
      value: 'Info'
    }
  },
  MESSAGE_TYPE_1: {
    it: {
      value: 'Attenzione'
    },
    en: {
      value: 'Warning'
    }
  },
  MESSAGE_TYPE_2: {
    it: {
      value: 'Errore'
    },
    en: {
      value: 'Error'
    }
  }

  //@todo add the translation for `Dear colleague,<BR/>We got a system error during Authentication process!!` and other generic error messages not bound to a code

};var getResource = exports.getResource = function getResource(key, lang, property) {
  try {
    if (!property) {
      property = 'value';
    }

    if (key.indexOf('PWD_CHARS:') > -1) {
      var tmp = key.split(':');
      var newKey = tmp[0];
      var values = tmp[1].split(',');

      var res = RESOURCES[newKey][lang][property];

      return res.replace(/%d/, values[0]).replace(/%d/, values[1]);
    } else if (key.indexOf('WARN_PASSWORD_REMINDER:') > -1) {
      var s = key.split(':');
      var k = s[0];
      var numd = s[1];
      var days = '';
      if (numd >= 1) {
        var _rgg = 'GG';
        days = RESOURCES[_rgg][lang][property];
      } else {
        var _rg = 'G';
        days = RESOURCES[_rg][lang][property];
      }

      var r = RESOURCES[k][lang][property];

      return r.replace(/%d/, numd).replace(/%g/, days);
    } else if (key.indexOf('WARN_PIN_REMINDER:') > -1) {
      var s1 = key.split(':');
      var k1 = s1[0];
      var numd1 = s1[1];
      var days1 = '';
      if (numd1 >= 1) {
        var _rgg1 = 'GG';
        days1 = RESOURCES[_rgg1][lang][property];
      } else {
        var _rg1 = 'G';
        days1 = RESOURCES[_rg1][lang][property];
      }

      var r1 = RESOURCES[k1][lang][property];

      return r1.replace(/%d/, numd1).replace(/%g/, days1);
    } else {
      return RESOURCES[key][lang][property];
    }
  } catch (ex) {
    // @log missing resource for key: ' + key + ', lang: ' + lang
    return key;
  }
};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _component = __webpack_require__(27);

var _component2 = _interopRequireDefault(_component);

var _modal = __webpack_require__(268);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes,
      textTransforms = _ref.textTransforms;

  var component = (0, _component2.default)({
    colors: colors,
    spacings: spacings,
    images: images,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    textTransforms: textTransforms
  });
  var modal = (0, _modal2.default)({ colors: colors, spacings: spacings, images: images, fontWeights: fontWeights });

  var styles = {
    token: {
      width: '10.6rem',
      height: '4.9rem',
      marginTop: spacings.x4,
      marginRight: 'auto',
      marginLeft: 'auto',

      backgroundImage: images.rsaToken,
      backgroundRepeat: 'no-repeat'
    },
    closeBtn: {
      position: 'fixed',
      zIndex: '100',
      top: '0',
      right: '0',

      width: spacings.x4,
      height: spacings.x4,
      marginTop: spacings.x4,
      marginRight: spacings.x4,

      cursor: 'pointer',

      borderRadius: '100%',
      backgroundColor: colors.button.bg.sella,
      backgroundImage: images.closeIconSella,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },
    bg: {
      backgroundColor: colors.auth.sella.bg,
      zIndex: 100,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0.97
    },
    content: (0, _extends3.default)({}, modal.content, {

      backgroundColor: 'transparent',
      maxWidth: '400px',
      textAlign: 'center',

      '.o-component': {
        marginBottom: '0'
      }
    }),
    title: {
      margin: '0',

      textAlign: 'center',

      display: 'inline-block',

      marginLeft: '-' + spacings.x3,
      paddingLeft: spacings.x6,
      paddingBottom: spacings.x2,
      paddingTop: spacings.x2,

      whiteSpace: 'nowrap',

      color: colors.auth.sella.title,
      backgroundImage: images.sellaItLogo,
      backgroundPositionY: 'center',
      backgroundRepeat: 'no-repeat'
    },
    subtitle: {
      fontSize: '1.1rem',
      fontWeight: fontWeights.subtitle.sella,

      marginTop: spacings.x4,

      color: colors.auth.sella.title
    },
    message: {
      margin: '0',

      textAlign: 'center'
    },
    form: {
      width: 'auto',
      marginRight: 'auto',
      marginLeft: 'auto'
    },
    field: {
      marginBottom: spacings.default
    },

    'label--auth': {
      color: colors.label.sellaAuth,
      marginTop: '-' + spacings.default
    },

    'label--required': {
      color: colors.common.utility.error.default
    },
    input: (0, _extends3.default)({}, component.input, {

      border: '1px solid ' + colors.input.border.sella,
      borderRadius: '4px',

      ':active': {
        borderBottom: '1px solid ' + colors.input.border.sella,
        outline: 'none'
      },

      ':focus': {
        borderBottom: '1px solid ' + colors.input.border.sella,
        outline: 'none'
      }
    }),
    off: {
      color: colors.auth.sella.off
    },
    link: {
      textDecoration: 'none',

      color: colors.auth.sella.link.default,
      ':hover': {
        color: colors.auth.sella.link.hover
      }
    },
    'recover--success': {
      display: 'block',

      margin: '0 auto',
      paddingBottom: '85px'
    },
    links: {
      fontSize: '12px',

      display: 'inline-block',

      marginTop: '1rem'
    }
  };

  return (0, _extends3.default)({}, component, modal, styles);
};

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/webcam.swf";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _modal = __webpack_require__(268);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontWeights = _ref.fontWeights;

  var modal = (0, _modal2.default)({ colors: colors, spacings: spacings, images: images, fontWeights: fontWeights });

  var styles = {
    'selfie-content': {
      position: 'fixed',
      zIndex: '110',
      top: '50%',
      left: '50%',

      width: '704px',
      height: '704px',
      marginTop: '-352px',
      marginLeft: '-352px',
      padding: '2rem',

      borderRadius: '4px',
      backgroundColor: colors.modal.selfie.bg
    },

    'selfie-content--novideo': {
      height: '200px',
      marginTop: '-100px'
    },

    screenshot: {
      display: 'block',
      marginTop: '2rem',
      maxWidth: '500px',
      maxHeight: '500px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },

    'selfie-buttons': {
      textAlign: 'center',

      ':not(.foo) button:not(:first-child)': {
        marginLeft: '50px'
      }
    }
  };

  return (0, _extends3.default)({}, modal, styles);
};

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _stepActions = __webpack_require__(28);

var _rcCollapse = __webpack_require__(226);

var _rcCollapse2 = _interopRequireDefault(_rcCollapse);

__webpack_require__(535);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1183);

var _styles2 = _interopRequireDefault(_styles);

var _widgets = __webpack_require__(172);

var _widgets2 = _interopRequireDefault(_widgets);

var _widgetsActions = __webpack_require__(136);

var _componentsActions = __webpack_require__(19);

var _titolareStatic = __webpack_require__(527);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import Title from '../../components/title'

//import { pushRoute } from '../../utils'
var TitolareEffictivo = function (_Component) {
  (0, _inherits3.default)(TitolareEffictivo, _Component);

  function TitolareEffictivo(props) {
    (0, _classCallCheck3.default)(this, TitolareEffictivo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TitolareEffictivo.__proto__ || (0, _getPrototypeOf2.default)(TitolareEffictivo)).call(this, props));

    _this.state = { accordion: true, activeKey: '0' };
    _this.onChange = _this.onChange.bind(_this);

    return _this;
  }

  (0, _createClass3.default)(TitolareEffictivo, [{
    key: 'onChange',
    value: function onChange(activeKey) {
      var dispatch = this.props.dispatch;

      if (activeKey) {
        var titolareList = this.props.titolareList;

        titolareList.map(function (o) {
          o.isUpdated = false;
          if (!!o.type) {
            delete o.type;
          }
          o.open = parseInt(activeKey) === o.id;
          if (o.userComponents["DOCUMENTO-TIPO_DOCUMENTO"].values.length === 0) {
            o.userComponents["DOCUMENTO-TIPO_DOCUMENTO"].values = (0, _titolareStatic.getTipDocValues)().Values;
          }
        });
      }

      this.setState({ activeKey: activeKey });
    }
  }, {
    key: 'deleteTitolare',
    value: function deleteTitolare(index) {
      var dispatch = this.props.dispatch;

      dispatch((0, _stepActions.deleteTitolareUser)(index));
      this.setState({ activeKey: (index - 1).toString() });
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var titolareList = this.props.titolareList;

      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }
      var ownerNome = "";
      var ownerCogNome = "";
      if (!!titolareList) {
        if (!titolareList.some(function (o) {
          return o.open;
        })) {
          titolareList.map(function (o) {
            if (o.id === 0) {
              o.open = true;
            }
          });
        }
        return titolareList.map(function (user) {
          var _React$createElement;

          if (user.open && !user.isUpdated) {
            if (user.userWidgets && user.userComponents && (0, _keys2.default)(user.userComponents).length) {
              var dispatch = _this2.props.dispatch;

              dispatch((0, _widgetsActions.updateAllWidgets)(user.userWidgets));
              dispatch((0, _componentsActions.updateAllComponents)(user.userComponents));
              user.isUpdated = true;
            }
          }
          if (!user.open || !!user.userWidgets["TITOLARE_EFFETTIVO"] && !!user.userWidgets["TITOLARE_EFFETTIVO"].status && user.userWidgets["TITOLARE_EFFETTIVO"].status[0] === 'ignoreValidation' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value === '' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"].value === '') {
            user.userWidgets['SZ0025'].status = ['hidden'];
            user.userWidgets['TITOLARE_OWNER'].status = ['hidden'];
          } else {
            user.userWidgets['SZ0025'].status = [''];
            user.userWidgets['TITOLARE_OWNER'].status = [''];
          }
          if (!!user.userWidgets["TITOLARE_EFFETTIVO"] && !!user.userWidgets["TITOLARE_EFFETTIVO"].status && user.userWidgets["TITOLARE_EFFETTIVO"].status[0] !== 'ignoreValidation' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value === '' && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_NO"].value === '') {
            user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value = 'selected';
          }
          if (user.id === 0 && !!user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"] && user.userComponents["TITOLARE_DATA-EFFETTIVO_SI"].value === "selected") {
            ownerNome = titolareList[user.id].NOME;
            ownerCogNome = titolareList[user.id].COGNOME;
          }
          return _react2.default.createElement(
            _rcCollapse.Panel,
            (0, _extends3.default)({}, (0, _withStyles.css)(_this2.props.styles.detail), {
              showArrow: true,
              header: ownerNome !== "" && ownerCogNome !== "" && user.id === 0 ? 'Titolare Effettivo' + ' : ' + ownerNome + ' ' + ownerCogNome : 'Titolare Effettivo' + ' : ' + user.userComponents['NOME_COGNOME-NOME'].value + ' ' + user.userComponents['NOME_COGNOME-COGNOME'].value,
              key: user.id
            }),
            _react2.default.createElement(_widgets2.default, {
              widgets: user.userWidgets,
              components: user.userComponents
            }),
            user.id === 0 ? null : _react2.default.createElement(_button2.default, (_React$createElement = {
              text: 'Elimina titolare',
              type: 'primary',
              value: 'Elimina titolare'
            }, (0, _defineProperty3.default)(_React$createElement, 'type', 'delete'), (0, _defineProperty3.default)(_React$createElement, 'action', _this2.deleteTitolare.bind(_this2, titolareList.indexOf(user))), _React$createElement)),
            _react2.default.createElement(_clearfix2.default, null)
          );
        });
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var accordion = this.state.accordion;
      var activeKey = this.state.activeKey;
      var _props = this.props,
          titolareList = _props.titolareList,
          dispatch = _props.dispatch;

      var comp = titolareList.find(function (o) {
        return o.type === "add";
      });
      if (!!comp) {
        activeKey = comp.id.toString();
        this.onChange(activeKey);
      }
      return _react2.default.createElement(
        _rcCollapse2.default,
        {
          accordion: accordion,
          onChange: this.onChange,
          activeKey: activeKey
        },
        this.getItems()
      );
    }
  }]);
  return TitolareEffictivo;
}(_react.Component);

TitolareEffictivo.propTypes = {
  titolareList: _propTypes.PropTypes.array.isRequired,
  widgets: _propTypes.PropTypes.object.isRequired,
  components: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return (0, _extends3.default)({}, state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(TitolareEffictivo));

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".rc-collapse{background-color:#f7f7f7;border-radius:3px;border:1px solid #d9d9d9}.rc-collapse-anim-active{transition:height .2s ease-out}.rc-collapse>.rc-collapse-item{border-top:1px solid #d9d9d9}.rc-collapse>.rc-collapse-item:first-child{border-top:none}.rc-collapse>.rc-collapse-item>.rc-collapse-header{height:38px;line-height:38px;text-indent:16px;color:#666;cursor:pointer}.rc-collapse>.rc-collapse-item>.rc-collapse-header .arrow{display:inline-block;content:\" \";width:0;height:0;font-size:0;line-height:0;border-top:3px solid transparent;border-bottom:3px solid transparent;border-left:4px solid #666;vertical-align:middle;margin-right:8px}.rc-collapse>.rc-collapse-item-disabled>.rc-collapse-header{cursor:not-allowed;color:#999;background-color:#f3f3f3}.rc-collapse-content{overflow:hidden;color:#666;padding:0 16px;background-color:#fff}.rc-collapse-content>.rc-collapse-content-box{margin-top:16px;margin-bottom:16px}.rc-collapse-content-inactive{display:none}.rc-collapse-item:last-child>.rc-collapse-content{border-radius:0 0 3px 3px}.rc-collapse>.rc-collapse-item-active>.rc-collapse-header .arrow{border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid #666;margin-right:6px}", ""]);

// exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _parsers = __webpack_require__(40);

var _grid = __webpack_require__(267);

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights;
  return {
    globals: {
      '*.rc-collapse': {
        'min-height': '21rem',
        // marginBottom: '1rem',
        width: '90%',
        margin: '0 auto',
        // float: important('left'),
        // marginLeft: important('150px'),
        border: '0',
        backgroundColor: colors.requestList.content.bg
      },

      '*.rc-collapse-header': {
        fontFamily: fontFamilies.default,
        fontWeight: fontWeights.requestList.header,
        lineHeight: (0, _parsers.important)('2.7rem'),

        color: (0, _parsers.important)(colors.requestList.header.text)
      },

      '*.rc-collapse-item .arrow': {
        float: (0, _parsers.important)('right'),

        marginTop: (0, _parsers.important)('16px'),
        marginRight: (0, _parsers.important)('16px'),

        borderTop: (0, _parsers.important)('4px solid transparent'),
        borderBottom: (0, _parsers.important)('4px solid transparent'),
        borderLeft: (0, _parsers.important)('6px solid ' + colors.requestList.header.text)
      },

      '*.rc-collapse-item-active .arrow': {
        float: (0, _parsers.important)('right'),

        marginTop: (0, _parsers.important)('18px'),
        marginRight: (0, _parsers.important)('16px'),

        borderTop: (0, _parsers.important)('6px solid ' + colors.requestList.header.text),
        borderBottom: (0, _parsers.important)('4px solid transparent'),
        borderLeft: (0, _parsers.important)('4px solid transparent')
      },
      '*.rc-collapse-content-box': {
        position: 'relative',
        // marginLeft: important('13.75rem')
        // marginLeft: important('18rem')
        margin: (0, _parsers.important)('0 auto'),
        width: '100%',
        maxWidth: '43rem'
      }
    },

    detail: {
      border: '1px solid ' + colors.requestList.header.border,
      borderRadius: '4px',
      backgroundColor: colors.requestList.header.bg
    },

    accord: {
      width: '80%',
      float: (0, _parsers.important)('left'),
      marginLeft: (0, _parsers.important)('150px')
    },

    label: {
      fontSize: '1rem',
      fontWeight: 'bold',
      lineHeight: '1.5',
      color: colors.label.default
    },

    value: {
      display: 'inline',
      fontSize: '1rem',
      lineHeight: '1.5',
      color: colors.common.body.text.default
    },

    listColumn: (0, _extends3.default)({}, (0, _grid2.default)({ colSpan: 6, columns: 12 })),
    listColumnButtons: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      position: 'absolute',
      height: '100%',
      right: '0'
    }
  };
};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = __webpack_require__(117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styles2.default;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = undefined;

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(65);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _styles = __webpack_require__(1186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = exports.ProgressBar = function (_React$Component) {
  (0, _inherits3.default)(ProgressBar, _React$Component);

  function ProgressBar(props) {
    (0, _classCallCheck3.default)(this, ProgressBar);
    return (0, _possibleConstructorReturn3.default)(this, (ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).call(this, props));
  }

  (0, _createClass3.default)(ProgressBar, [{
    key: 'render',
    value: function render() {
      var progressStyle = {};
      var stepNumber = this.props.StepNumber;
      var noOfSteps = this.props.NoOfSteps;
      if (stepNumber === 0) {
        progressStyle.width = '0%';
      } else {
        progressStyle.width = Math.round(stepNumber * 100 / noOfSteps) + '%';
      }

      return _react2.default.createElement(
        'div',
        { className: 'meter' },
        _react2.default.createElement('span', { id: 'progressbar', style: progressStyle }),
        'Percentuale di completamento ',
        progressStyle.width
      );
    }
  }]);
  return ProgressBar;
}(_react2.default.Component);

ProgressBar.propTypes = {
  //widget: PropTypes.object.isRequired,
  //components: PropTypes.object.isRequired,
  styles: _propTypes.PropTypes.object,
  //step: PropTypes.object.isRequired,
  StepNumber: _propTypes.PropTypes.object,
  NoOfSteps: _propTypes.PropTypes.object
};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1187);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes move{0%{background-position:0 0}to{background-position:50px 50px}}.meter{width:70%;text-align:center;height:8px;font-size:14px;margin:2px 15% 0;background:#ccecff;-moz-border-radius:25px;-webkit-border-radius:25px;border-radius:25px;padding:0 0 10px;-webkit-box-shadow:inset 0 -1px 1px hsla(0,0%,100%,.3);-moz-box-shadow:inset 0 -1px 1px hsla(0,0%,100%,.3);box-shadow:inset 0 -1px 1px hsla(0,0%,100%,.3)}@media (max-width:767px){.meter{width:90%;margin:2px 5% 0}}@media (max-width:1024px){.meter{width:80%;margin:2px 10% 0}}.meter>span{display:block;height:8px;text-align:center;background-color:#00b7ff;-webkit-background-size:50px 50px;-moz-background-size:50px 50px;-webkit-border-top-right-radius:8px;-webkit-border-bottom-right-radius:8px;-moz-border-radius-topright:8px;-moz-border-radius-bottomright:8px;border-top-right-radius:20px;border-bottom-right-radius:20px;-webkit-border-top-left-radius:20px;-webkit-border-bottom-left-radius:20px;-moz-border-radius-topleft:20px;-moz-border-radius-bottomleft:20px;border-top-left-radius:20px;border-bottom-left-radius:20px;position:relative;overflow:hidden}", ""]);

// exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPlan = undefined;

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1189);

var _styles2 = _interopRequireDefault(_styles);

var _utils = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectPlan = exports.SelectPlan = function (_Component) {
  (0, _inherits3.default)(SelectPlan, _Component);

  function SelectPlan() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SelectPlan);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectPlan.__proto__ || (0, _getPrototypeOf2.default)(SelectPlan)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SelectPlan, [{
    key: "OnFlatProceed",
    value: function OnFlatProceed() {
      var _props = this.props,
          pathName = _props.pathName,
          flatSearch = _props.flatSearch,
          queryRefParam = _props.queryRefParam;

      var queryparam = !!queryRefParam ? "?ref=" + queryRefParam + "&" + flatSearch : "?" + flatSearch;
      window.location.replace(("" + _utils.CONTEXT_ROOT) / pathName + queryparam);
    }
  }, {
    key: "OnFlexProceed",
    value: function OnFlexProceed() {
      var _props2 = this.props,
          pathName = _props2.pathName,
          flexSearch = _props2.flexSearch,
          queryRefParam = _props2.queryRefParam;

      var queryparam = !!queryRefParam ? "?ref=" + queryRefParam + "&" + flexSearch : "?" + flexSearch;
      window.location.replace(("" + _utils.CONTEXT_ROOT) / pathName + queryparam);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props3 = this.props,
          queryPlanParam = _props3.queryPlanParam,
          queryRefParam = _props3.queryRefParam;

      if (queryPlanParam === 0) {
        var refresh = !!queryRefParam ? window.location.protocol + "//" + window.location.host + window.location.pathname + "?ref=" + queryRefParam : window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.pushState({ path: refresh }, '', refresh);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var richiestaNumero = this.props.richiestaNumero;

      var assetsPath = _utils.CONTEXT_ROOT + "/assets/images/";

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(
          "div",
          { className: "title" },
          "Scegli la tua offerta"
        ),
        _react2.default.createElement(
          "div",
          { className: "wrapper" },
          _react2.default.createElement(
            "div",
            { className: "plan" },
            _react2.default.createElement(
              "div",
              { className: "section" },
              _react2.default.createElement(
                "div",
                { className: "title" },
                "POS Easy a commissioni"
              ),
              _react2.default.createElement(
                "div",
                { className: "img-container flex" },
                _react2.default.createElement("img", { src: assetsPath + "easyflex.png", alt: "Easy Flex" })
              ),
              _react2.default.createElement(
                "div",
                { className: "description" },
                "Zero canone,1% di commissioni."
              ),
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "POS in vendita:"
                  ),
                  _react2.default.createElement("br", null),
                  "  99 \u20AC + IVA"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Commissioni:"
                  ),
                  " 1%"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Attivazione:"
                  ),
                  " 16 \u20AC di bollo"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Canone mensile:"
                  ),
                  " 0 \u20AC"
                )
              )
            ),
            _react2.default.createElement(
              "button",
              { onClick: function onClick() {
                  return _this2.OnFlexProceed();
                } },
              "Prosegui"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "plan" },
            _react2.default.createElement(
              "div",
              { className: "section" },
              _react2.default.createElement(
                "div",
                { className: "title" },
                "POS Easy a canone"
              ),
              _react2.default.createElement(
                "div",
                { className: "img-container flat" },
                _react2.default.createElement("img", { src: assetsPath + "easyflat.png", alt: "Easy Flat" })
              ),
              _react2.default.createElement(
                "div",
                { className: "description" },
                "Un solo canone, zero commissioni."
              ),
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "POS in comodato d'uso:"
                  ),
                  _react2.default.createElement("br", null),
                  " incluso nel canone mensile"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Commissioni:"
                  ),
                  " 0 \u20AC"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Attivazione:"
                  ),
                  " 16 \u20AC di bollo"
                ),
                _react2.default.createElement(
                  "li",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Canone mensile:"
                  ),
                  _react2.default.createElement("br", null),
                  "17 \u20AC + IVA se transi meno di 10.000 \u20AC all'anno",
                  _react2.default.createElement("br", null),
                  "22 \u20AC + IVA se transi tra 10.000 \u20AC e 30.000 \u20AC all'anno"
                )
              )
            ),
            _react2.default.createElement(
              "button",
              { onClick: function onClick() {
                  return _this2.OnFlatProceed();
                } },
              "Prosegui"
            )
          )
        )
      );
    }
  }]);
  return SelectPlan;
}(_react.Component);

exports.default = SelectPlan;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1190);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;font-size:1rem}.container>.title{color:#00466e;text-align:center}.container .title{font-size:1.325rem;font-weight:700}@media (max-width:767px){.container .title{font-size:1rem}}.container .tagline{text-align:center;margin-top:.5rem}.container .wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:2.5rem 15%}@media (max-width:1024px){.container .wrapper{padding:2.5rem 10%}}@media (max-width:767px){.container .wrapper{padding:2rem 1rem}}.container .wrapper .plan{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:2.5rem;margin-right:2rem;border:1px solid #e0e0e0;border-radius:6px}@media (max-width:767px){.container .wrapper .plan{padding:1.25rem 1rem;margin-right:1rem}}.container .wrapper .plan:last-child{margin-right:0}@media (max-width:767px){.container .wrapper .plan .section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-ms-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.container .wrapper .plan .section .title{margin-top:1.5rem;text-align:center}}.container .wrapper .plan .section .img-container{margin-top:1.5rem;position:relative;width:100%;height:200px;border-radius:6px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (max-width:767px){.container .wrapper .plan .section .img-container{margin-top:0;border-radius:100%;width:100px;height:100px;padding:.65rem}}.container .wrapper .plan .section .img-container.flat,.container .wrapper .plan .section .img-container.flex{background-color:#97e5c7}.container .wrapper .plan .section .img-container img{height:100%}.container .wrapper .plan .section .description{margin-top:1.5rem}@media (max-width:767px){.container .wrapper .plan .section .description{display:none}}.container .wrapper .plan .section ul{margin-top:1.5rem}@media (max-width:767px){.container .wrapper .plan .section ul{display:none}}.container .wrapper .plan .section ul li{list-style:none;margin-left:1.5rem;margin-bottom:.75rem}.container .wrapper .plan .section ul li:before{content:\" \";position:absolute;width:1rem;height:1rem;margin-top:3px;margin-left:-1.5rem;background:url(\"/onboardingpos/assets/images/ICON.svg\")}.container .wrapper .plan .section ul li:last-child{margin-bottom:0}.container .wrapper .plan button{margin-top:1.5rem;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;max-width:100%;padding:1.2rem 4rem;font-weight:600;border:0;border-radius:6px;color:#fff;background-color:#53cd27}.customizedText{background-color:#a0dc8b;border-radius:3px;padding:1px 3px;color:green}@media (max-width:767px){.container .wrapper .plan button{width:100%;font-size:.85rem;padding:.75rem}}.maindiv{display:flex;background-color:#e8fde0;border-radius:10px}.innerdiv1{width:20%;float:left;color:#53ae32;padding:3px}.innersubdivplan{display:flex;background-color:#c4f3b3;border-radius:5px;padding:1px 9px;margin-top:6px}.innerdiv2{width:80%;float:right;padding:5px 10px}.promocolor{color:#43a520}", ""]);

// exports


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanToolbar = exports.Plan = undefined;

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__(1192);

var _styles2 = _interopRequireDefault(_styles);

var _utils = __webpack_require__(12);

var _api = __webpack_require__(45);

var api = _interopRequireWildcard(_api);

var _componentsActions = __webpack_require__(19);

var _withStyles = __webpack_require__(5);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Plan = exports.Plan = {
  FLEX: "FLEX",
  FLAT: "FLAT",
  FLEXCRS: "FLEXCRS",
  FLATCRS: "FLATCRS",
  FLEXMINI: "FLEXMINI"
};

var PlanToolbar = exports.PlanToolbar = function (_Component) {
  (0, _inherits3.default)(PlanToolbar, _Component);

  function PlanToolbar(props) {
    (0, _classCallCheck3.default)(this, PlanToolbar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanToolbar.__proto__ || (0, _getPrototypeOf2.default)(PlanToolbar)).call(this, props));

    _this.state = {
      plan: "",
      showTooltip: false
    };
    return _this;
  }

  (0, _createClass3.default)(PlanToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          component = _props.component,
          dispatch = _props.dispatch,
          queryParam = _props.queryParam,
          queryRefParam = _props.queryRefParam;

      if (component && component.id === "POSPLAN-PLAN") {
        var body = component.fetchPosPlan.body;
        var url = component.fetchPosPlan.url;
        return api.FetchPOSPlan(url, body).then(function (json) {
          var plan = json && json.payLoad && json.payLoad.Plan;
          var refCode = json && json.payLoad && json.payLoad.ReferalCode;
          if (plan) {
            if (!queryParam || !queryRefParam && !!queryParam && queryParam === plan || !!queryRefParam && queryRefParam !== refCode) {
              var refresh = !!refCode ? window.location.protocol + "//" + window.location.host + window.location.pathname + "?ref=" + refCode + "&plan=" + plan : window.location.protocol + "//" + window.location.host + window.location.pathname + "?plan=" + plan;
              window.history.pushState({ path: refresh }, '', refresh);
            }
            dispatch((0, _componentsActions.updateComponent)(component.id, { value: plan }));
            _this2.setState({ plan: plan });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          queryParam = _props2.queryParam,
          posplanInDB = _props2.posplanInDB;
      var plan = this.state.plan;

      var queryPlanName = queryParam && queryParam.toUpperCase();
      var dbPlanName = posplanInDB && posplanInDB.toUpperCase() || plan && plan.toUpperCase();
      var planName = dbPlanName || queryPlanName;
      var assetsPath = _utils.CONTEXT_ROOT + "/assets/images/";

      return _react2.default.createElement(
        "div",
        {
          className: "align-toolbar",
          onMouseEnter: function onMouseEnter() {
            return !_this3.state.showTooltip && _this3.setState({ showTooltip: true });
          },
          onMouseLeave: function onMouseLeave() {
            return _this3.state.showTooltip && _this3.setState({ showTooltip: false });
          }
        },
        _react2.default.createElement(
          "div",
          { className: "toolbar" },
          _react2.default.createElement(
            "div",
            {
              className: "img-container " + (Plan.FLEX === planName || Plan.FLEXCRS === planName || Plan.FLEXMINI === planName ? "flex" : "flat")
            },
            _react2.default.createElement("img", {
              src: assetsPath + (Plan.FLEX === planName || Plan.FLEXCRS === planName ? "easyflexbadge.png" : Plan.FLEXMINI === planName ? "easyflexminibadge.png" : "easyflatbadge.png"),
              alt: planName
            })
          ),
          _react2.default.createElement(
            "span",
            null,
            _react2.default.createElement(
              "b",
              null,
              "POS EASY",
              Plan.FLEXMINI === planName ? " MINI" : ""
            ),
            _react2.default.createElement("br", null),
            Plan.FLEX === planName || Plan.FLEXCRS === planName || Plan.FLEXMINI === planName ? "A commissioni" : "A canone"
          ),
          _react2.default.createElement("img", { className: "info-icon", src: assetsPath + "info.svg", alt: "info" })
        ),
        this.state.showTooltip && _react2.default.createElement(
          "ul",
          { className: "tooltip" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "b",
              null,
              "POS  ",
              Plan.FLEX === planName || Plan.FLEXCRS === planName || Plan.FLEXMINI === planName ? "in vendita :" : " in Comodato d'uso"
            ),
            _react2.default.createElement("br", null),
            Plan.FLEX === planName || Plan.FLEXCRS === planName ? _react2.default.createElement(
              "span",
              null,
              "99 \u20AC + IVA"
            ) : Plan.FLEXMINI === planName ? _react2.default.createElement(
              "span",
              null,
              "80 \u20AC + IVA"
            ) : ""
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "b",
              null,
              "Commissioni:"
            ),
            " ",
            " ",
            Plan.FLEX === planName || Plan.FLEXCRS === planName || Plan.FLEXMINI === planName ? "1%" : "0 €"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "b",
              null,
              "Canone mensile:"
            ),
            " ",
            Plan.FLEX === planName || Plan.FLEXCRS === planName || Plan.FLEXMINI === planName ? "0 €" : _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement("br", null),
              "17 \u20AC + IVA se transi meno di 10.000 \u20AC",
              _react2.default.createElement("br", null),
              "22 \u20AC + IVA se transi tra 10.000 e 30.000 \u20AC"
            )
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement(
              "b",
              null,
              "Attivazione:"
            ),
            " 16 \u20AC di bollo",
            _react2.default.createElement("br", null)
          )
        )
      );
    }
  }]);
  return PlanToolbar;
}(_react.Component);

exports.default = PlanToolbar;
// PlanToolbar.propTypes = {
//   component: PropTypes.object.isRequired
// }

// const mapStateToProps = (state) => {
//   const { step } = state
//   return step
// }

// export default connect(mapStateToProps)(withStyles(Styles)(PlanToolbar))

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1193);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".align-toolbar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;position:absolute;top:.4rem;right:15%;z-index:1}@media (max-width:767px){.align-toolbar{top:.8rem;right:5%}}@media (max-width:1024px){.align-toolbar{right:10%}}.align-toolbar .toolbar{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;padding:.5rem .75rem;border:1px solid #e0e0e0;border-radius:6px;cursor:pointer;background-color:#fff}.align-toolbar .toolbar .img-container{position:relative;border-radius:100%;width:50px;height:50px;margin-right:1rem;overflow:hidden}@media (max-width:767px){.align-toolbar .toolbar .img-container{display:none}}.align-toolbar .toolbar .img-container.flex{background-color:#c4f3b3}.align-toolbar .toolbar .img-container.flat{background-color:#97e5c7}.align-toolbar .toolbar .img-container img{width:100%}.align-toolbar .toolbar span{font-size:14px;margin-right:2rem}@media (max-width:767px){.align-toolbar .toolbar span{margin-right:1rem}}.align-toolbar .toolbar span b{font-weight:800}.align-toolbar .toolbar .info-icon{width:1.25rem;height:1.25rem}.align-toolbar .tooltip{padding:1rem;font-size:14px;max-width:330px;border:1px solid #e0e0e0;border-radius:6px;margin-top:.25rem;background-color:#fff}.align-toolbar .tooltip li{list-style:none;padding:.5rem 0;border-bottom:1px solid #e0e0e0}.align-toolbar .tooltip li:first-child{padding-top:0}.align-toolbar .tooltip li:last-child{border:none;padding-bottom:0}.grayed{padding:.5rem;margin-top:.5rem;border-radius:6px;background-color:#eee}.mt-4{margin-top:2rem}.mt-5{margin-top:3rem}.strike{text-decoration:line-through;color:grey}.maindiv{display:flex;background-color:#e8fde0;border-radius:10px}.innerdiv1{width:20%;float:left;color:#53ae32;padding:3px}.innersubdiv{display:flex;background-color:#c4f3b3;border-radius:5px;padding:1px 4px;margin-top:6px}.innerdiv2{width:80%;float:right;padding:5px 10px}.promocolor{color:#43a520}", ""]);

// exports


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanAlertPopup = undefined;

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(12);

var _styles = __webpack_require__(1195);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanAlertPopup = exports.PlanAlertPopup = function (_Component) {
  (0, _inherits3.default)(PlanAlertPopup, _Component);

  function PlanAlertPopup(props) {
    (0, _classCallCheck3.default)(this, PlanAlertPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanAlertPopup.__proto__ || (0, _getPrototypeOf2.default)(PlanAlertPopup)).call(this, props));

    _this.state = {};

    _this.handleProceed = function () {
      var _this$props = _this.props,
          location = _this$props.location,
          plan = _this$props.plan,
          queryRefParam = _this$props.queryRefParam;

      var planMap = { FLEX: 'flex', FLEXCRS: 'flexCRS', FLATCRS: 'flatCRS', FLEXMINI: 'flexmini' };
      var planName = planMap[plan && plan.toUpperCase()] || 'flat';
      var pathname = location.pathname,
          search = location.search;

      var queryparam = !!queryRefParam ? "?ref=" + queryRefParam + "&plan=" + planName : "?plan=" + planName;
      window.location.replace("" + pathname + queryparam);
    };

    _this.handleSendEmail = function () {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.href = "mailto:informazionicommerciali@axerve.com";
      a.click();
      document.body.removeChild(a);
    };

    return _this;
  }

  (0, _createClass3.default)(PlanAlertPopup, [{
    key: "render",
    value: function render() {
      var plan = this.props.plan;

      var assetsPath = _utils.CONTEXT_ROOT + "/assets/images/";

      return _react2.default.createElement(
        "div",
        { className: "modal" },
        _react2.default.createElement(
          "div",
          { className: "scroll" },
          _react2.default.createElement(
            "div",
            { className: "alert-container" },
            _react2.default.createElement(
              "div",
              { className: "section" },
              _react2.default.createElement(
                "div",
                { className: "img-container" },
                _react2.default.createElement("img", {
                  src: assetsPath + (plan === "flex" || plan && plan.toUpperCase() === "FLEXCRS" || plan && plan.toUpperCase() === "FLEXMINI" ? "easyflexalert.png" : "easyflatalert.png")
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "info-container" },
                _react2.default.createElement(
                  "div",
                  { className: "description heading" },
                  "Hai gia una richiesta in corso per l'offerta",
                  plan === "flex" || plan && plan.toUpperCase() === "FLEXCRS" || plan && plan.toUpperCase() === "FLEXMINI" ? " POS Easy a commissioni" : " POS Easy a canone"
                ),
                _react2.default.createElement(
                  "button",
                  { onClick: this.handleProceed },
                  "Prosegui con l'offerta a",
                  plan === "flex" || plan && plan.toUpperCase() === "FLEXCRS" || plan && plan.toUpperCase() === "FLEXMINI" ? " commissioni" : " canone"
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "section" },
              _react2.default.createElement(
                "div",
                { className: "img-container" },
                _react2.default.createElement("img", {
                  src: assetsPath + (plan === "flex" || plan && plan.toUpperCase() === "FLEXCRS" || plan && plan.toUpperCase() === "FLEXMINI" ? "easyflatalert.png" : "easyflexalert.png")
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "info-container" },
                _react2.default.createElement(
                  "div",
                  { className: "description" },
                  "Per proseguire con la richiesta del",
                  _react2.default.createElement(
                    "b",
                    null,
                    " ",
                    plan === "flex" || plan && plan.toUpperCase() === "FLEXCRS" || plan && plan.toUpperCase() === "FLEXMINI" ? "POS Easy a canone" : "POS Easy a commissioni",
                    " "
                  ),
                  "contattaci per richiedere assistenza"
                ),
                _react2.default.createElement(
                  "button",
                  { onClick: this.handleSendEmail },
                  "Contattaci"
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PlanAlertPopup;
}(_react.Component);

exports.default = PlanAlertPopup;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1196);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".modal{position:fixed;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2}@media (max-width:767px){.modal .scroll{position:relative;overflow-y:scroll;height:100%}}.modal .alert-container{position:absolute;width:50%;min-width:550px;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0 1rem;border-radius:6px;background-color:#fff}@media (max-width:767px){.modal .alert-container{width:80%;min-width:280px;max-width:calc(100% - 2rem);top:1rem;-webkit-transform:translateX(-50%);transform:translateX(-50%)}}.modal .alert-container .section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;padding:1rem 0;border-bottom:1px solid #e0e0e0}@media (max-width:767px){.modal .alert-container .section{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.modal .alert-container .section .img-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:108px;height:108px;border-radius:6px;background-color:#97e5c7;margin-right:1rem}@media (max-width:767px){.modal .alert-container .section .img-container{margin-right:0;border-radius:100%;width:100px;height:100px}}.modal .alert-container .section .img-container img{height:100%;border-radius:6px}.modal .alert-container .section .info-container{width:100%}@media (max-width:767px){.modal .alert-container .section .info-container{width:100%;padding-top:.5rem;text-align:center}}.modal .alert-container .section .info-container .heading{font-size:1.2rem;font-weight:700;color:#084c73}.modal .alert-container .section .info-container .description{padding-bottom:.5rem}@media (max-width:767px){.modal .alert-container .section .info-container .description{text-align:center}}.modal .alert-container .section .info-container button{max-width:100%;font-size:.9rem;font-weight:600;padding:1rem 2rem;border:0;border-radius:6px;color:#fff;background-color:#53cd27}", ""]);

// exports


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _stepActions = __webpack_require__(28);

var _page = __webpack_require__(112);

var _page2 = _interopRequireDefault(_page);

var _header = __webpack_require__(113);

var _header2 = _interopRequireDefault(_header);

var _wrapper = __webpack_require__(114);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _title = __webpack_require__(115);

var _title2 = _interopRequireDefault(_title);

var _widgets = __webpack_require__(172);

var _widgets2 = _interopRequireDefault(_widgets);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _footer = __webpack_require__(116);

var _footer2 = _interopRequireDefault(_footer);

var _spinner = __webpack_require__(137);

var _spinner2 = _interopRequireDefault(_spinner);

var _modal = __webpack_require__(173);

var _modal2 = _interopRequireDefault(_modal);

var _authmodal = __webpack_require__(533);

var _authmodal2 = _interopRequireDefault(_authmodal);

var _result = __webpack_require__(138);

var _result2 = _interopRequireDefault(_result);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1198);

var _styles2 = _interopRequireDefault(_styles);

var _apiAlertPopup = __webpack_require__(1199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resume = function (_Component) {
  (0, _inherits3.default)(Resume, _Component);

  function Resume(props) {
    (0, _classCallCheck3.default)(this, Resume);
    return (0, _possibleConstructorReturn3.default)(this, (Resume.__proto__ || (0, _getPrototypeOf2.default)(Resume)).call(this, props));
  }

  (0, _createClass3.default)(Resume, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          guid = _props.guid,
          dispatch = _props.dispatch,
          routing = _props.routing;

      dispatch((0, _stepActions.initResumeProcess)(guid, routing.flow));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          components = _props2.components,
          dispatch = _props2.dispatch;
      var auth = nextProps.step.auth;

      if (!!auth && !!auth.tokenId && !!nextProps.step.loginFormVisible) {
        dispatch((0, _stepActions.authenticated)());
      }

      if (!!components && !!components['CODICE_FISCALE-CF'] && components['CODICE_FISCALE-CF'].validations && components['CODICE_FISCALE-CF'].validations.url) {
        delete components['CODICE_FISCALE-CF'].validations.url;
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          guid = _props3.guid,
          routing = _props3.routing;

      dispatch((0, _stepActions.initResumeProcess)(guid, routing.flow));
      window.scrollTo(0, 0);
    }
  }, {
    key: 'goForward',
    value: function goForward() {
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          components = _props4.components,
          guid = _props4.guid,
          routing = _props4.routing;


      if (!!components['RESUME_BY_CELL-CODICE_CELLULARE']) {
        dispatch((0, _stepActions.validateResumeOtp)(components['RESUME_BY_CELL-CODICE_CELLULARE'], routing.flow));
      } else {
        dispatch((0, _stepActions.requireResumeOtpSms)(guid));
      }

      window.scrollTo(0, 0);
    }
  }, {
    key: 'sendOtpSms',
    value: function sendOtpSms() {
      var _props5 = this.props,
          dispatch = _props5.dispatch,
          components = _props5.components;


      dispatch((0, _stepActions.sendResumeOtpSms)(!components['RESUME_BY_CELL-GUID_PROCESSO'].value));

      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var IOS11Rules = (0, _utils.ios11Instructions)();
      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      if (this.props.step.isLoading) {
        return _react2.default.createElement(_spinner2.default, { type: 'global' });
      }

      if (this.props.step.hasServerErrors) {
        return _react2.default.createElement(
          _modal2.default,
          null,
          _react2.default.createElement(
            _result2.default,
            { type: 'error' },
            _react2.default.createElement('div', {
              dangerouslySetInnerHTML: {
                __html: this.props.step.serverErrorMessage
              }
            }),
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: IOS11Rules } })
          )
        );
      }

      return _react2.default.createElement(
        _page2.default,
        null,
        !!this.props.widgets.LOGIN_SE_CLIENTE && this.props.widgets.LOGIN_SE_CLIENTE.status.indexOf('hidden') < 0 ? _react2.default.createElement(_authmodal2.default, { isCloseButtonHidden: true }) : '',
        this.props.step.isStepLoading ? _react2.default.createElement(_spinner2.default, { type: 'step' }) : '',
        _react2.default.createElement(_header2.default, {
          centeredLogo: true,
          whiteLabel: !!this.props.routing.locationBeforeTransitions.query.embedded
        }),
        this.props.step.isAPIResError == true ? _react2.default.createElement(_apiAlertPopup.APIAlertPopup, null) : '',
        _react2.default.createElement(
          _wrapper2.default,
          null,
          _react2.default.createElement(_title2.default, {
            title: !!this.props.guid ? 'Accedi alla tua richiesta' : 'Accedi alle tue richieste',
            subtitle: !!this.props.guid ? 'Inserisci il codice ricevuto tramite SMS sul tuo numero di cellulare' : 'Inserisci i dati per accedere alla tua lista richieste.'
          }),
          _react2.default.createElement(_widgets2.default, {
            widgets: this.props.widgets,
            components: this.props.components,
            renderNegatives: true,
            guid: this.props.guid
          }),
          !!this.props.components['RESUME_BY_CELL-CODICE_CELLULARE'] ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { style: { textAlign: 'center' } },
              'Il codice OTP (One Time Password) ti \xE8 stato inviato automaticamente sul tuo numero di cellulare, se non dovessi riceverlo entro un minuto puoi richiederne uno nuovo cliccando sul tasto "Reinvia OTP".'
            )
          ) : '',
          !!this.props.components['RESUME_BY_CELL-CODICE_CELLULARE'] ? _react2.default.createElement(_button2.default, {
            text: 'Reinvia OTP',
            action: function action() {
              _this2.sendOtpSms();
            },
            pullTo: 'left'
          }) : '',
          !!this.props.components && (0, _keys2.default)(this.props.components).length > 0 ? _react2.default.createElement(_button2.default, {
            text: 'Continua',
            action: function action() {
              _this2.goForward();
            },
            type: 'primaryEnabled',
            pullTo: 'right'
          }) : '',
          _react2.default.createElement(_clearfix2.default, null)
        ),
        _react2.default.createElement(_footer2.default, null)
      );
    }
  }]);
  return Resume;
}(_react.Component);

Resume.propTypes = {
  guid: _propTypes.PropTypes.string,
  step: _propTypes.PropTypes.object.isRequired,
  widgets: _propTypes.PropTypes.object.isRequired,
  components: _propTypes.PropTypes.object.isRequired,
  dispatch: _propTypes.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return (0, _extends3.default)({}, state, {
    guid: ownProps.params.guid
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Resume));

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = __webpack_require__(117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styles2.default;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APIAlertPopup = undefined;

var _objectDestructuringEmpty2 = __webpack_require__(1200);

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(12);

var _styles = __webpack_require__(1201);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APIAlertPopup = exports.APIAlertPopup = function (_Component) {
  (0, _inherits3.default)(APIAlertPopup, _Component);

  function APIAlertPopup(props) {
    (0, _classCallCheck3.default)(this, APIAlertPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (APIAlertPopup.__proto__ || (0, _getPrototypeOf2.default)(APIAlertPopup)).call(this, props));

    _this.state = {};

    _this.handleProceed = function () {
      window.location.replace(window.location.href);
    };

    return _this;
  }

  (0, _createClass3.default)(APIAlertPopup, [{
    key: "render",
    value: function render() {
      (0, _objectDestructuringEmpty3.default)(this.props);

      var assetsPath = _utils.CONTEXT_ROOT + "/assets/images/";

      return _react2.default.createElement(
        "div",
        { className: "modal" },
        _react2.default.createElement(
          "div",
          { className: "scroll" },
          _react2.default.createElement(
            "div",
            { className: "alert-container" },
            _react2.default.createElement(
              "div",
              { className: "section" },
              _react2.default.createElement(
                "div",
                { className: "info-container" },
                _react2.default.createElement(
                  "div",
                  { className: "description heading" },
                  "Non sono presenti pratiche associate ai dati inseriti"
                ),
                _react2.default.createElement(
                  "div",
                  { className: "description textsize" },
                  "Assicurati che i dati inseriti corrispondino a quelli utilizzati in fase di richiesta."
                ),
                _react2.default.createElement(
                  "div",
                  { className: "btnPosition" },
                  _react2.default.createElement(
                    "button",
                    { onClick: this.handleProceed },
                    "Riprova"
                  )
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "section" },
              _react2.default.createElement(
                "div",
                { className: "info-container" },
                _react2.default.createElement(
                  "div",
                  { className: "description textsize" },
                  "In alternativa ricomincia la tua richiesta : ",
                  _react2.default.createElement(
                    "a",
                    { href: "https://axerve.com/punto-vendita" },
                    "Inizia la richiesta"
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return APIAlertPopup;
}(_react.Component);

exports.default = APIAlertPopup;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1202);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, ".modal{position:fixed;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2}@media (max-width:767px){.modal .scroll{position:relative;overflow-y:scroll;height:100%}}.modal .alert-container{position:absolute;width:40%;min-width:550px;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0 1rem;border-radius:6px;background-color:#fff}@media (max-width:767px){.modal .alert-container{width:80%;min-width:280px;max-width:calc(100% - 2rem);top:35%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}}.modal .alert-container .section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row;flex-flow:row;padding:1rem 0;border-bottom:1px solid #e0e0e0;text-align:center}@media (max-width:767px){.modal .alert-container .section{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.modal .alert-container .section .img-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:108px;height:108px;border-radius:6px;background-color:#97e5c7;margin-right:1rem}@media (max-width:767px){.modal .alert-container .section .img-container{margin-right:0;border-radius:100%;width:100px;height:100px}}.modal .alert-container .section .img-container img{height:100%;border-radius:6px}.modal .alert-container .section .info-container{width:100%}@media (max-width:767px){.modal .alert-container .section .info-container{width:100%;padding-top:.5rem;text-align:center}}.modal .alert-container .section .info-container .heading{font-size:1.2rem;font-weight:700;color:#084c73}.modal .alert-container .section .info-container .description{padding-bottom:.5rem}.modal .alert-container .section .info-container .textsize{font-size:.8rem}@media (max-width:767px){.modal .alert-container .section .info-container .description{text-align:center;font-size:.6rem}}.modal .alert-container .section .info-container button{max-width:100%;font-size:.9rem;font-weight:600;padding:1rem 2rem;border:0;border-radius:6px;color:#fff;background-color:#00b7ff}@media (max-width:767px){.modal .alert-container .section .info-container button{max-width:100%;font-size:.6rem;font-weight:600;padding:.5rem 1rem;border:0;border-radius:6px;color:#fff;background-color:#00b7ff}}.btnPosition{text-align:center}", ""]);

// exports


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _stepActions = __webpack_require__(28);

var _utils = __webpack_require__(12);

var _page = __webpack_require__(112);

var _page2 = _interopRequireDefault(_page);

var _header = __webpack_require__(113);

var _header2 = _interopRequireDefault(_header);

var _wrapper = __webpack_require__(114);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _title = __webpack_require__(115);

var _title2 = _interopRequireDefault(_title);

var _footer = __webpack_require__(116);

var _footer2 = _interopRequireDefault(_footer);

var _spinner = __webpack_require__(137);

var _spinner2 = _interopRequireDefault(_spinner);

var _modal = __webpack_require__(173);

var _modal2 = _interopRequireDefault(_modal);

var _requests = __webpack_require__(1204);

var _requests2 = _interopRequireDefault(_requests);

var _result = __webpack_require__(138);

var _result2 = _interopRequireDefault(_result);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1206);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_Component) {
  (0, _inherits3.default)(List, _Component);

  function List(props) {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).call(this, props));
  }

  (0, _createClass3.default)(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          routing = _props.routing;

      dispatch((0, _stepActions.getUserRequests)()).then(function (json) {
        if (json.status !== 'success') {
          dispatch((0, _stepActions.hideModal)());
          (0, _utils.pushRoute)('/resume/' + routing.flow);
        } else {
          dispatch((0, _stepActions.getContracts)(json.data.map(function (req) {
            return req.guid;
          })));
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var IOS11Rules = (0, _utils.ios11Instructions)();
      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      if (this.props.step.isLoading) {
        return _react2.default.createElement(_spinner2.default, { type: 'global' });
      }

      if (this.props.step.hasServerErrors) {
        return _react2.default.createElement(
          _modal2.default,
          null,
          _react2.default.createElement(
            _result2.default,
            { type: 'error' },
            _react2.default.createElement('div', {
              dangerouslySetInnerHTML: {
                __html: this.props.step.serverErrorMessage
              }
            }),
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: IOS11Rules } })
          )
        );
      }

      return _react2.default.createElement(
        _page2.default,
        null,
        this.props.step.isStepLoading ? _react2.default.createElement(_spinner2.default, { type: 'step' }) : '',
        _react2.default.createElement(_header2.default, {
          centeredLogo: true,
          whiteLabel: !!this.props.routing.locationBeforeTransitions.query.embedded
        }),
        _react2.default.createElement(
          _wrapper2.default,
          null,
          _react2.default.createElement(_title2.default, {
            title: 'Richieste in corso',
            subtitle: 'Qui di seguito sono elencate le tue richieste in corso:'
          }),
          _react2.default.createElement(_requests2.default, {
            requestList: this.props.step.requestList,
            contractList: this.props.step.contractList
          }),
          _react2.default.createElement(_clearfix2.default, null)
        ),
        _react2.default.createElement(_footer2.default, null)
      );
    }
  }]);
  return List;
}(_react.Component);

List.propTypes = {
  guid: _propTypes.PropTypes.string,
  step: _propTypes.PropTypes.object.isRequired,
  dispatch: _propTypes.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  return (0, _extends3.default)({}, state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(List));

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _utils = __webpack_require__(12);

var _stepActions = __webpack_require__(28);

var _rcCollapse = __webpack_require__(226);

var _rcCollapse2 = _interopRequireDefault(_rcCollapse);

__webpack_require__(535);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _reactRedux = __webpack_require__(14);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1205);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Requests = function (_Component) {
  (0, _inherits3.default)(Requests, _Component);

  function Requests(props) {
    (0, _classCallCheck3.default)(this, Requests);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Requests.__proto__ || (0, _getPrototypeOf2.default)(Requests)).call(this, props));

    _this.state = { accordion: true, activeKey: [] };
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Requests, [{
    key: 'onChange',
    value: function onChange(activeKey) {
      this.setState({ activeKey: activeKey });
    }
  }, {
    key: 'openReuploadView',
    value: function openReuploadView(guid) {
      var routing = this.props.routing;

      (0, _utils.pushRoute)('/reupload/' + routing.flow + '/' + guid);
    }
  }, {
    key: 'resumeRequest',
    value: function resumeRequest(productName, guid) {
      var _props = this.props,
          dispatch = _props.dispatch,
          routing = _props.routing;

      if (!!productName) {
        routing.flow = productName;
      }
      dispatch((0, _stepActions.resumeContactProcess)(guid));
    }
  }, {
    key: 'getStatus',
    value: function getStatus(product) {
      var cleanStatuses = {
        K: 'Documento respinto', // rejected document
        T: 'In attesa di apertura', // unknown document status
        A: 'Da completare',
        F: 'Da completare'
      };

      return !!cleanStatuses[product.statusCode] ? cleanStatuses[product.statusCode] : product.status;
    }
  }, {
    key: 'getDocumentStatus',
    value: function getDocumentStatus(contract) {
      if (!!contract && contract.sign === 'true') {
        return 'Doc. accettato';
      } else if (!!contract && contract.sign === 'false') {
        return 'Doc. respinto';
      } else {
        return 'Doc. da verificare';
      }
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var _props2 = this.props,
          requestList = _props2.requestList,
          contractList = _props2.contractList;


      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      if (!!requestList && !!contractList) {
        return requestList.map(function (product, index) {
          var contract = contractList.find(function (c) {
            return c.guid === product.guid && c.azioni === 'UPLOAD';
          });
          return _react2.default.createElement(
            _rcCollapse.Panel,
            (0, _extends3.default)({}, (0, _withStyles.css)(_this2.props.styles.detail), {
              showArrow: true,
              header: product.contactId + ' - ' + _this2.getStatus(product),
              key: index
            }),
            _react2.default.createElement(
              'div',
              (0, _withStyles.css)(_this2.props.styles.listColumn),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' Prodotto '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  product.prodotto
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' Intestatario '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  ' ',
                  product.nome,
                  ' ',
                  product.cognome,
                  ' '
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' Richiesta numero '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  ' ',
                  product.contactId,
                  ' '
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' Ultima modifica '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  ' ',
                  product.lastEdit,
                  ' '
                )
              ),
              product.statusCode === 'A' || product.statusCode === 'F' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' ',
                  'Ti sei fermato allo step',
                  ' '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  ' ',
                  product.lastStep,
                  ' '
                )
              ) : '',
              !!product.docType ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' Tipo documento '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  ' ',
                  product.docType,
                  ' '
                )
              ) : '',
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.label),
                  ' Esito documento '
                ),
                _react2.default.createElement(
                  'div',
                  (0, _withStyles.css)(_this2.props.styles.value),
                  _this2.getDocumentStatus(contract)
                )
              )
            ),
            _react2.default.createElement(
              'div',
              (0, _withStyles.css)(_this2.props.styles.listColumn, _this2.props.styles.listColumnButtons),
              product.statusCode === 'K' ? _react2.default.createElement(_button2.default, {
                text: 'Reinvia',
                type: 'primaryEnabled',
                value: product.guid,
                pullTo: 'right',
                action: _this2.openReuploadView.bind(_this2)
              }) : '',
              product.statusCode === 'A' || product.statusCode === 'F' ? _react2.default.createElement(_button2.default, {
                text: 'Riprendi',
                type: 'primaryEnabled',
                value: product.guid,
                pullTo: 'right',
                action: _this2.resumeRequest.bind(_this2, product.prodotto)
              }) : ''
            ),
            _react2.default.createElement(_clearfix2.default, null)
          );
        });
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var accordion = this.state.accordion;
      var activeKey = this.state.activeKey;
      return _react2.default.createElement(
        _rcCollapse2.default,
        {
          accordion: accordion,
          onChange: this.onChange,
          activeKey: activeKey
        },
        this.getItems()
      );
    }
  }]);
  return Requests;
}(_react.Component);

Requests.propTypes = {
  requestList: _propTypes.PropTypes.array,
  contractList: _propTypes.PropTypes.array
};

var mapStateToProps = function mapStateToProps(state) {
  return (0, _extends3.default)({}, state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Requests));

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _parsers = __webpack_require__(40);

var _grid = __webpack_require__(267);

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights;
  return {
    globals: {
      '*.rc-collapse': {
        'min-height': '21rem',
        marginBottom: '1rem',

        border: '0',
        backgroundColor: colors.requestList.content.bg
      },

      '*.rc-collapse-header': {
        fontFamily: fontFamilies.default,
        fontWeight: fontWeights.requestList.header,
        lineHeight: (0, _parsers.important)('2.7rem'),

        color: (0, _parsers.important)(colors.requestList.header.text)
      },

      '*.rc-collapse-item .arrow': {
        float: (0, _parsers.important)('right'),

        marginTop: (0, _parsers.important)('16px'),
        marginRight: (0, _parsers.important)('16px'),

        borderTop: (0, _parsers.important)('4px solid transparent'),
        borderBottom: (0, _parsers.important)('4px solid transparent'),
        borderLeft: (0, _parsers.important)('6px solid ' + colors.requestList.header.text)
      },

      '*.rc-collapse-item-active .arrow': {
        float: (0, _parsers.important)('right'),

        marginTop: (0, _parsers.important)('18px'),
        marginRight: (0, _parsers.important)('16px'),

        borderTop: (0, _parsers.important)('6px solid ' + colors.requestList.header.text),
        borderBottom: (0, _parsers.important)('4px solid transparent'),
        borderLeft: (0, _parsers.important)('4px solid transparent')
      },
      '*.rc-collapse-content-box': {
        position: 'relative'
      }
    },

    detail: {
      border: '1px solid ' + colors.requestList.header.border,
      borderRadius: '4px',
      backgroundColor: colors.requestList.header.bg
    },

    label: {
      fontSize: '1rem',
      fontWeight: 'bold',
      lineHeight: '1.5',
      color: colors.label.default
    },

    value: {
      display: 'inline',
      fontSize: '1rem',
      lineHeight: '1.5',
      color: colors.common.body.text.default
    },

    listColumn: (0, _extends3.default)({}, (0, _grid2.default)({ colSpan: 6, columns: 12 })),
    listColumnButtons: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      position: 'absolute',
      height: '100%',
      right: '0'
    }
  };
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = __webpack_require__(117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styles2.default;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _utils = __webpack_require__(12);

var _stepActions = __webpack_require__(28);

var _page = __webpack_require__(112);

var _page2 = _interopRequireDefault(_page);

var _header = __webpack_require__(113);

var _header2 = _interopRequireDefault(_header);

var _wrapper = __webpack_require__(114);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _title = __webpack_require__(115);

var _title2 = _interopRequireDefault(_title);

var _widgets = __webpack_require__(172);

var _widgets2 = _interopRequireDefault(_widgets);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _footer = __webpack_require__(116);

var _footer2 = _interopRequireDefault(_footer);

var _spinner = __webpack_require__(137);

var _spinner2 = _interopRequireDefault(_spinner);

var _modal = __webpack_require__(173);

var _modal2 = _interopRequireDefault(_modal);

var _webcammodal = __webpack_require__(534);

var _webcammodal2 = _interopRequireDefault(_webcammodal);

var _result = __webpack_require__(138);

var _result2 = _interopRequireDefault(_result);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1208);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reupload = function (_Component) {
  (0, _inherits3.default)(Reupload, _Component);

  function Reupload(props) {
    (0, _classCallCheck3.default)(this, Reupload);
    return (0, _possibleConstructorReturn3.default)(this, (Reupload.__proto__ || (0, _getPrototypeOf2.default)(Reupload)).call(this, props));
  }

  (0, _createClass3.default)(Reupload, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          guid = _props.guid,
          step = _props.step,
          widgets = _props.widgets,
          dispatch = _props.dispatch,
          routing = _props.routing;


      if (!step.requestList || !step.contractList) {
        dispatch((0, _stepActions.initRecoveryProcess)(guid, routing.flow));
      } else if (!!step.requestList && !!step.contractList && (0, _keys2.default)(widgets).length === 0) {
        var contract = this.props.step.contractList.find(function (c) {
          return c.azioni === 'UPLOAD';
        });
        var request = this.props.step.requestList.find(function (c) {
          return c.guid === guid;
        });
        dispatch((0, _stepActions.initReuploadProcess)(guid, contract.barCode, request.docType, request.selfie));
      }
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      var _this2 = this;

      if (!!this.props.step.requestList) {
        var contract = this.props.step.requestList.find(function (r) {
          return r.guid === _this2.props.guid;
        });
        return contract.prodotto + ' - ' + contract.contactId + ' - ' + contract.docType;
      } else {
        return '';
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      var routing = this.props.routing;


      (0, _utils.pushRoute)('/status/' + !!routing.flow);
    }
  }, {
    key: 'goForward',
    value: function goForward() {
      var _props2 = this.props,
          guid = _props2.guid,
          step = _props2.step,
          dispatch = _props2.dispatch;

      var contract = step.contractList.find(function (c) {
        return c.azioni === 'UPLOAD';
      });
      dispatch((0, _stepActions.completeReupload)(guid, contract.barCode));
    }
  }, {
    key: 'render',
    value: function render() {
      var IOS11Rules = (0, _utils.ios11Instructions)();
      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      if (this.props.step.isLoading) {
        return _react2.default.createElement(_spinner2.default, { type: 'global' });
      }

      if (this.props.step.hasServerErrors) {
        return _react2.default.createElement(
          _modal2.default,
          null,
          _react2.default.createElement(
            _result2.default,
            { type: 'error' },
            _react2.default.createElement('div', {
              dangerouslySetInnerHTML: {
                __html: this.props.step.serverErrorMessage
              }
            }),
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: IOS11Rules } })
          )
        );
      }

      return _react2.default.createElement(
        _page2.default,
        null,
        !!this.props.step.webcamComponent ? _react2.default.createElement(_webcammodal2.default, {
          key: this.props.step.webcamComponent.name,
          component: this.props.step.webcamComponent
        }) : '',
        this.props.step.isStepLoading ? _react2.default.createElement(_spinner2.default, { type: 'step' }) : '',
        _react2.default.createElement(_header2.default, {
          centeredLogo: true,
          whiteLabel: !!this.props.routing.locationBeforeTransitions.query.embedded
        }),
        _react2.default.createElement(
          _wrapper2.default,
          null,
          _react2.default.createElement(_title2.default, { title: 'Reinvia il documento', subtitle: this.getSubtitle() }),
          _react2.default.createElement(_widgets2.default, {
            widgets: this.props.widgets,
            components: this.props.components,
            renderNegatives: true,
            guid: this.props.guid
          }),
          _react2.default.createElement(_button2.default, { text: 'Indietro', action: this.goBack.bind(this) }),
          _react2.default.createElement(_button2.default, {
            text: 'Continua',
            action: this.goForward.bind(this),
            type: 'primary',
            pullTo: 'right'
          }),
          _react2.default.createElement(_clearfix2.default, null)
        ),
        _react2.default.createElement(_footer2.default, null)
      );
    }
  }]);
  return Reupload;
}(_react.Component);

Reupload.propTypes = {
  guid: _propTypes.PropTypes.string,
  step: _propTypes.PropTypes.object.isRequired,
  widgets: _propTypes.PropTypes.object.isRequired,
  components: _propTypes.PropTypes.object.isRequired,
  dispatch: _propTypes.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return (0, _extends3.default)({}, state, {
    guid: ownProps.params.guid
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(Reupload));

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = __webpack_require__(117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styles2.default;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _page = __webpack_require__(112);

var _page2 = _interopRequireDefault(_page);

var _header = __webpack_require__(113);

var _header2 = _interopRequireDefault(_header);

var _wrapper = __webpack_require__(114);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _clearfix = __webpack_require__(76);

var _clearfix2 = _interopRequireDefault(_clearfix);

var _title = __webpack_require__(115);

var _title2 = _interopRequireDefault(_title);

var _footer = __webpack_require__(116);

var _footer2 = _interopRequireDefault(_footer);

var _button = __webpack_require__(68);

var _button2 = _interopRequireDefault(_button);

var _stepActions = __webpack_require__(28);

var _utils = __webpack_require__(12);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1210);

var _styles2 = _interopRequireDefault(_styles);

var _api = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EndOfTheRide = function (_Component) {
  (0, _inherits3.default)(EndOfTheRide, _Component);

  function EndOfTheRide(props) {
    (0, _classCallCheck3.default)(this, EndOfTheRide);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EndOfTheRide.__proto__ || (0, _getPrototypeOf2.default)(EndOfTheRide)).call(this, props));

    _this.state = {
      Nome: ''
    };
    return _this;
  }

  (0, _createClass3.default)(EndOfTheRide, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          step = _props.step;

      var body = {
        GUID: this.props.step.guid
      };
      (0, _api.FetchPOSOnboardDetails)('OnboardRequestDetails/FetchPOSOnboardingDetails', body).then(function (json) {
        _this2.setState({
          Nome: !!json.payLoad && json.payLoad.FirstName ? json.payLoad.FirstName : ""
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          step = _props2.step;

      if (!step || !step.number) {
        dispatch((0, _stepActions.thanks)(this.props.guid));
      }
      // let body={
      //   GUID:this.props.step.guid
      // }
      // FetchPOSOnboardDetails('OnboardRequestDetails/FetchPOSOnboardingDetails', body).then(json => {
      // this.setState({
      //   Nome: (!!json.payLoad && json.payLoad.FirstName)? json.payLoad.FirstName:""
      // })
      // });
    }
  }, {
    key: 'getTitleText',
    value: function getTitleText() {
      var _props$routing = this.props.routing,
          partnership = _props$routing.partnership,
          convention = _props$routing.convention;


      if (partnership === 'HYPE' && convention === 'YOOX') return 'Grazie, ci sei quasi!';

      if (partnership === 'HYPE4TIM') return 'Grazie' + (!this.props.isParent ? ' per aver scelto la carta TIMpersonal!' : '!');

      return 'Grazie ' + (!this.props.isParent ? ' ' + this.state.Nome + ', per aver inoltrato la tua richiesta' : '!');
    }
  }, {
    key: 'getSubtitleText',
    value: function getSubtitleText() {
      var partnership = this.props.routing.partnership;
      var _props3 = this.props,
          isParent = _props3.isParent,
          guid = _props3.guid;


      if (!isParent) {
        if (!!guid) {
          if (partnership === 'HYPE4TIM') return "Tieni sott'occhio la tua email, ti invieremo a breve le istruzioni per proseguire.";

          return 'Hai completato la tua richiesta di registrazione!';
        } else {
          if (partnership === 'HYPE4TIM') return 'La tua richiesta è completa, adesso tocca a noi.';

          return "Tieni d'occhio la tua email, riceverai presto informazioni sullo stato della tua richiesta"; //'Hai completato la tua richiesta di registrazione. La stiamo già processando!'
        }
      }

      if (partnership === 'HYPE4TIM') return 'Hai completato la richiesta della carta TIMpersonal del minorenne.';

      return "Tieni d'occhio la tua email, riceverai presto informazioni sullo stato della tua richiesta"; //'Hai completato la richiesta di registrazione del minorenne. La stiamo già processando!'
    }
  }, {
    key: 'getInstructionsText',
    value: function getInstructionsText() {
      var partnership = this.props.routing.partnership;
      var _props4 = this.props,
          isParent = _props4.isParent,
          guid = _props4.guid;


      if (partnership === 'HYPE4TIM') {
        if (!isParent) {
          if (!guid) {
            return "Tieni sott'occhio la tua email, ti invieremo a breve le istruzioni per proseguire.";
          } else {
            return '';
          }
        } else {
          return 'La tua richiesta è completa, adesso tocca a noi. Presto invieremo al minorenne le istruzioni per proseguire.';
        }
      }

      return !isParent ? 'Iscriviti alla newsletter per non perdere nessuna opportunità di gestire in modo easy il tuo business' //"Tieni sott'occhio la tua email, ti invieremo a breve le istruzioni per proseguire."
      : 'Presto invieremo al minorenne le istruzioni per proseguire.';
    }
  }, {
    key: 'backToSite',
    value: function backToSite() {
      window.open('https://www.axerve.com', '_self');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var routing = this.props.routing;


      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      return _react2.default.createElement(
        _page2.default,
        null,
        _react2.default.createElement(_header2.default, {
          centeredLogo: true,
          whiteLabel: !!routing.locationBeforeTransitions.query.embedded
        }),
        _react2.default.createElement(
          _wrapper2.default,
          null,
          _react2.default.createElement(_title2.default, {
            title: this.getTitleText(),
            subtitle: this.getSubtitleText()
          }),
          _react2.default.createElement(
            'div',
            (0, _withStyles.css)(this.props.styles.container),
            _react2.default.createElement(
              'div',
              (0, _withStyles.css)(this.props.styles['thank-you']),
              _react2.default.createElement('div', (0, _withStyles.css)(this.props.styles['thank-you__img'])),
              _react2.default.createElement(
                'div',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(_button2.default, {
                  id: 'bt-prev',
                  text: 'TORNA AL SITO',
                  action: function action() {
                    return _this3.backToSite();
                  }
                })
              ),
              _react2.default.createElement(
                'div',
                (0, _withStyles.css)(this.props.styles['thank-you__parent'], !this.props.guid && this.props.styles['thank-you__parent--hidden']),
                _react2.default.createElement(_title2.default, {
                  title: 'Sei con il tuo genitore?',
                  subtitle: 'Clicca su continua e chiedigli di confermare la tua richiesta'
                }),
                _react2.default.createElement(
                  'div',
                  { style: { textAlign: 'center' } },
                  _react2.default.createElement(_button2.default, {
                    text: 'Continua',
                    action: function action() {
                      return (0, _utils.pushRoute)('/resume/' + routing.flow + '/' + _this3.props.guid);
                    },
                    type: 'primary'
                  })
                )
              )
            )
          ),
          _react2.default.createElement(_clearfix2.default, null)
        ),
        _react2.default.createElement(_footer2.default, null)
      );
    }
  }]);
  return EndOfTheRide;
}(_react.Component);

EndOfTheRide.propTypes = {
  guid: _propTypes.PropTypes.string,
  dispatch: _propTypes.PropTypes.func.isRequired,
  isParent: _propTypes.PropTypes.bool.isRequired,
  styles: _propTypes.PropTypes.object
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return (0, _extends3.default)({}, state, {
    guid: ownProps.params.guid,
    isParent: !!ownProps.location.query.p
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(EndOfTheRide));

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _styles = __webpack_require__(117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      spacings = _ref.spacings,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes;

  var generics = (0, _styles2.default)({
    colors: colors,
    spacings: spacings,
    fontFamilies: fontFamilies,
    fontWeights: fontWeights,
    fontSizes: fontSizes
  });

  var styles = {
    container: (0, _defineProperty3.default)({}, (0, _breakTo2.default)('smaller'), {
      display: 'block'
    }),

    'thank-you': {
      width: '100%',
      marginRight: 'auto',
      marginLeft: 'auto'
    },

    'thank-you__img': (0, _defineProperty3.default)({
      maxWidth: '30rem',
      height: '20rem',
      marginRight: 'auto',
      marginLeft: 'auto',

      backgroundImage: images.welcome,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: spacings.thankYouImg.backgroundPosition.default,
      backgroundSize: 'contain'

    }, (0, _breakTo2.default)('smaller'), {
      height: '28rem',
      backgroundPosition: spacings.thankYouImg.backgroundPosition.smaller
    }),

    'thank-you__text': {
      textAlign: 'center'
    },

    'thank-you__parent': {
      marginTop: '2rem'
    },

    'thank-you__parent--hidden': {
      display: 'none'
    }
  };

  return (0, _extends3.default)({}, generics, styles);
};

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(10);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _reactRedux = __webpack_require__(14);

var _page = __webpack_require__(112);

var _page2 = _interopRequireDefault(_page);

var _header = __webpack_require__(113);

var _header2 = _interopRequireDefault(_header);

var _wrapper = __webpack_require__(114);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _title = __webpack_require__(115);

var _title2 = _interopRequireDefault(_title);

var _footer = __webpack_require__(116);

var _footer2 = _interopRequireDefault(_footer);

var _withStyles = __webpack_require__(5);

var _styles = __webpack_require__(1212);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound(props) {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).call(this, props));
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'render',
    value: function render() {
      if (!this.globalStylesOverrides) {
        this.globalStylesOverrides = (0, _withStyles.css)(this.props.styles.globals);
      }

      return _react2.default.createElement(
        _page2.default,
        null,
        _react2.default.createElement(_header2.default, {
          centeredLogo: true,
          whiteLabel: !!this.props.routing.locationBeforeTransitions.query.embedded
        }),
        _react2.default.createElement(
          _wrapper2.default,
          null,
          _react2.default.createElement(_title2.default, {
            title: 'Pagina non trovata',
            subtitle: 'Ci dispiace, ma la pagina che stavi cercando di visualizzare non esiste.'
          }),
          _react2.default.createElement('div', (0, _withStyles.css)(this.props.styles.img))
        ),
        _react2.default.createElement(_footer2.default, null)
      );
    }
  }]);
  return NotFound;
}(_react.Component);

NotFound.propTypes = {
  styles: _propTypes.PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state /*, ownProps*/) {
  return state;
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withStyles.withStyles)(_styles2.default)(NotFound));

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(4);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(18);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _breakTo = __webpack_require__(25);

var _breakTo2 = _interopRequireDefault(_breakTo);

var _styles = __webpack_require__(117);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var colors = _ref.colors,
      images = _ref.images,
      fontFamilies = _ref.fontFamilies,
      fontWeights = _ref.fontWeights,
      fontSizes = _ref.fontSizes;

  var generics = (0, _styles2.default)({ colors: colors, fontFamilies: fontFamilies, fontWeights: fontWeights, fontSizes: fontSizes });

  var styles = {
    img: (0, _defineProperty3.default)({
      width: '20rem',
      height: '15rem',
      margin: '2rem auto',

      backgroundImage: images.notfound,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center'

    }, (0, _breakTo2.default)('small'), {
      width: '35rem',
      height: '25rem'
    })
  };

  return (0, _extends3.default)({}, generics, styles);
};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1214);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(47)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!./reset.css", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!./reset.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(46)(false);
// imports


// module
exports.push([module.i, "html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{font:inherit;margin:0;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{cursor:pointer;-webkit-appearance:button}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{margin:0 2px;padding:.35em .625em .75em;border:1px solid silver}legend{padding:0;border:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}li,ul{list-style-type:circle}ul.btn-indent-txt{margin:0 20px!important}ul.btn-indent-txt li{list-style-type:disc}", ""]);

// exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var colors = _ref.colors;
  return {
    chatbot: {
      backgroundColor: colors.chatbot.default,
      position: 'fixed',
      right: 0,
      bottom: 0,
      zIndex: 110
    }
  };
};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "web.config";

/***/ })
],[1052]);


// WEBPACK FOOTER //
// app.80be43febfd4df755961.js